webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1049)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(606),
  /* template */
  __webpack_require__(2177),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CLOSE_SUCCESS_ALERT; });
/* unused harmony export CREATE_INSTITUTION_ACCOUNT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DISABLE_SUBMIT_DETAIL_TRANSACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return DISABLE_SUBMIT_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ENABLE_SUBMIT_DETAIL_TRANSACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return ENABLE_SUBMIT_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return GET_NOTES_LIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return GET_NOTES_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return GET_NOTES_LIST_SUCCESS; });
/* unused harmony export GET_TRANSACTION_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return GET_TRANSACTION_LIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return GET_TRANSACTION_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return GET_TRANSACTION_LIST_SUCCESS; });
/* unused harmony export GET_TRANSACTION_REQUEST */
/* unused harmony export GET_TRANSACTION_SUCCESS */
/* unused harmony export GET_UPCOMING_TRANSACTIONS_REQUEST */
/* unused harmony export GET_UPCOMING_TRANSACTIONS_RESPONDED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return HIDE_ACCOUNT_CREATION_MODAL; });
/* unused harmony export HIDE_CANCEL_BUTTON */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return HIDE_CHECK_WIRE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return HIDE_ERRORS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HIDE_INFORMATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HIDE_QUESTION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return HIDE_SUCCESS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return HIDE_TRANSACTION_MODAL; });
/* unused harmony export IMPACT_PREFERENCES_UPDATED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return PURCHASE_NOTE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return PURCHASE_NOTE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return PURCHASE_NOTE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ACCOUNT_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_ACTIVE_ACCOUNT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_CHANGE_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_CREATION_SUCCEEDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SET_DEFAULT_FUNDING_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SET_DOCUMENTATION_REASON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_ERRORS_MODAL_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SET_IDLE_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_IDLE_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return SET_IR_ADMIN_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SET_NEEDS_DOCUMENTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SET_NEW_USER_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SET_REDIRECT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return SET_STATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return SET_CANADA_STATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return SET_COUNTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return SET_STATIC_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return SET_MAINTENANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_SUGGESTED_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_SUGGESTED_ADDRESS_MODAL_VISIBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_SUGGESTED_ADDRESS_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_SUGGESTED_ADDRESS_YES_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return SET_SUGGESTED_ADDRESS_YES_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SET_TRANSACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_USER_BY_ADMIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return SET_USER_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SHOW_ACCOUNT_CREATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SHOW_CHECK_WIRE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SHOW_ERRORS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHOW_INFORMATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SHOW_QUESTION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SHOW_SUCCESS_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SHOW_SUCCESS_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SHOW_TRANSACTION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return START_DOCUMENT_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return START_LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return START_REGISTRATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return STOP_DOCUMENT_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return STOP_LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return STOP_REGISTRATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return STOP_SET_DEFAULT_FUNDING_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return UPDATE_UPCOMING_TRANSACTION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return UPDATE_UPCOMING_TRANSACTION_RESPONDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SET_SEARCH_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SET_CURRENTLY_SEARCHING_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SET_NOTIFICATION_STATUS; });
/* unused harmony export SET_COMMUNICATION_PREFERENCES_NOTIFICATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_LOADING_REDIRECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return SET_CURRENT_DWOLLA_CUSTOMER_ID; });
var CLOSE_SUCCESS_ALERT = 'CLOSE_SUCCESS_ALERT';
var CREATE_INSTITUTION_ACCOUNT = 'CREATE_INSTITUTION_ACCOUNT';
var DISABLE_SUBMIT_DETAIL_TRANSACTION = 'DISABLE_SUBMIT_DETAIL_TRANSACTION';
var DISABLE_SUBMIT_SEARCH = 'DISABLE_SUBMIT_SEARCH';
var ENABLE_SUBMIT_DETAIL_TRANSACTION = 'ENABLE_SUBMIT_DETAIL_TRANSACTION';
var ENABLE_SUBMIT_SEARCH = 'ENABLE_SUBMIT_SEARCH';
var GET_NOTES_LIST_FAILURE = 'GET_NOTES_LIST_FAILURE';
var GET_NOTES_LIST_REQUEST = 'GET_NOTES_LIST_REQUEST';
var GET_NOTES_LIST_SUCCESS = 'GET_NOTES_LIST_SUCCESS';
var GET_TRANSACTION_FAILURE = 'GET_TRANSACTION_FAILURE';
var GET_TRANSACTION_LIST_FAILURE = 'GET_TRANSACTION_LIST_FAILURE';
var GET_TRANSACTION_LIST_REQUEST = 'GET_TRANSACTION_LIST_REQUEST';
var GET_TRANSACTION_LIST_SUCCESS = 'GET_TRANSACTION_LIST_SUCCESS';
var GET_TRANSACTION_REQUEST = 'GET_TRANSACTION_REQUEST';
var GET_TRANSACTION_SUCCESS = 'GET_TRANSACTION_SUCCESS';
var GET_UPCOMING_TRANSACTIONS_REQUEST = 'GET_UPCOMING_TRANSACTIONS_REQUEST';
var GET_UPCOMING_TRANSACTIONS_RESPONDED = 'GET_UPCOMING_TRANSACTIONS_RESPONDED';
var HIDE_ACCOUNT_CREATION_MODAL = 'HIDE_ACCOUNT_CREATION_MODAL';
var HIDE_CANCEL_BUTTON = 'HIDE_CANCEL_BUTTON';
var HIDE_CHECK_WIRE_MODAL = 'HIDE_CHECK_WIRE_MODAL';
var HIDE_ERRORS_MODAL = 'HIDE_ERRORS_MODAL';
var HIDE_INFORMATION_MODAL = 'HIDE_INFORMATION_MODAL';
var HIDE_QUESTION_MODAL = 'HIDE_QUESTION_MODAL';
var HIDE_SUCCESS_MODAL = 'HIDE_SUCCESS_MODAL';
var HIDE_TRANSACTION_MODAL = 'HIDE_TRANSACTION_MODAL';
var IMPACT_PREFERENCES_UPDATED = 'IMPACT_PREFERENCES_UPDATED';
var PURCHASE_NOTE_FAILURE = 'PURCHASE_NOTE_FAILURE';
var PURCHASE_NOTE_REQUEST = 'PURCHASE_NOTE_REQUEST';
var PURCHASE_NOTE_SUCCESS = 'PURCHASE_NOTE_SUCCESS';
var SET_ACCOUNT_STATUS = 'SET_ACCOUNT_STATUS';
var SET_ACTIVE_ACCOUNT_ID = 'SET_ACTIVE_ACCOUNT_ID';
var SET_CHANGE_ADDRESS = 'SET_CHANGE_ADDRESS';
var SET_CREATION_SUCCEEDED = 'SET_CREATION_SUCCEEDED';
var SET_DEFAULT_FUNDING_SOURCE = 'SET_DEFAULT_FUNDING_SOURCE';
var SET_DOCUMENTATION_REASON = 'SET_DOCUMENTATION_REASON';
var SET_ERRORS_MODAL_INFO = 'SET_ERRORS_MODAL_INFO';
var SET_IDLE_OFF = 'SET_IDLE_OFF';
var SET_IDLE_ON = 'SET_IDLE_ON';
var SET_IR_ADMIN_ROLE = 'SET_IR_ADMIN_ROLE';
var SET_NEEDS_DOCUMENTATION = 'SET_NEEDS_DOCUMENTATION';
var SET_NEW_USER_EMAIL = 'SET_NEW_USER_EMAIL';
var SET_REDIRECT_URL = 'SET_REDIRECT_URL';
var SET_STATES = 'SET_STATES';
var SET_CANADA_STATES = 'SET_CANADA_STATES';
var SET_COUNTRIES = 'SET_COUNTRIES';
var SET_STATIC_INFORMATION = 'SET_STATIC_INFORMATION';
var SET_MAINTENANCE = 'SET_MAINTENANCE';
var SET_SUGGESTED_ADDRESS = 'SET_SUGGESTED_ADDRESS';
var SET_SUGGESTED_ADDRESS_MODAL_VISIBLE = 'SET_SUGGESTED_ADDRESS_MODAL_VISIBLE';
var SET_SUGGESTED_ADDRESS_TYPE = 'SET_SUGGESTED_ADDRESS_TYPE';
var SET_SUGGESTED_ADDRESS_YES_METHOD = 'SET_SUGGESTED_ADDRESS_YES_METHOD';
var SET_SUGGESTED_ADDRESS_YES_CALL = 'SET_SUGGESTED_ADDRESS_YES_CALL';
var SET_TRANSACTION = 'SET_TRANSACTION';
var SET_USER = 'SET_USER';
var SET_USER_BY_ADMIN = 'SET_USER_BY_ADMIN';
var SET_USER_STATUS = 'SET_USER_STATUS';
var SHOW_ACCOUNT_CREATION_MODAL = 'SHOW_ACCOUNT_CREATION_MODAL';
var SHOW_CHECK_WIRE_MODAL = 'SHOW_CHECK_WIRE_MODAL';
var SHOW_ERRORS_MODAL = 'SHOW_ERRORS_MODAL';
var SHOW_INFORMATION_MODAL = 'SHOW_INFORMATION_MODAL';
var SHOW_QUESTION_MODAL = 'SHOW_QUESTION_MODAL';
var SHOW_SUCCESS_ALERT = 'SHOW_SUCCESS_ALERT';
var SHOW_SUCCESS_MODAL = 'SHOW_SUCCESS_MODAL';
var SHOW_TRANSACTION_MODAL = 'SHOW_TRANSACTION_MODAL';
var START_DOCUMENT_UPLOAD = 'START_DOCUMENT_UPLOAD';
var START_LOGIN_REQUEST = 'START_LOGIN_REQUEST';
var START_REGISTRATION_REQUEST = 'START_REGISTRATION_REQUEST';
var STOP_DOCUMENT_UPLOAD = 'STOP_DOCUMENT_UPLOAD';
var STOP_LOGIN_REQUEST = 'STOP_LOGIN_REQUEST';
var STOP_REGISTRATION_REQUEST = 'STOP_REGISTRATION_REQUEST';
var STOP_SET_DEFAULT_FUNDING_SOURCE = 'STOP_SET_DEFAULT_FUNDING_SOURCE';
var UPDATE_UPCOMING_TRANSACTION_REQUEST = 'UPDATE_UPCOMING_TRANSACTION_REQUEST';
var UPDATE_UPCOMING_TRANSACTION_RESPONDED = 'UPDATE_UPCOMING_TRANSACTION_RESPONDED';
var SET_SEARCH_STRING = 'SET_SEARCH_STRING';
var SET_CURRENTLY_SEARCHING_BY = 'SET_CURRENTLY_SEARCHING_BY';
var SET_NOTIFICATION_STATUS = 'SET_NOTIFICATION_STATUS';
var SET_COMMUNICATION_PREFERENCES_NOTIFICATION = 'SET_COMMUNICATION_PREFERENCES_NOTIFICATION';
var SET_LOADING_REDIRECTION = 'SET_LOADING_REDIRECTION';
var SET_CURRENT_DWOLLA_CUSTOMER_ID = 'SET_CURRENT_DWOLLA_CUSTOMER_ID';

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return zipRegex; });
/* harmony export (immutable) */ __webpack_exports__["H"] = camelToSnakeCase;
/* unused harmony export timeZone */
/* harmony export (immutable) */ __webpack_exports__["b"] = formatDate;
/* harmony export (immutable) */ __webpack_exports__["q"] = formatDecimal;
/* harmony export (immutable) */ __webpack_exports__["E"] = formatBaseAmount;
/* harmony export (immutable) */ __webpack_exports__["c"] = formatAmount;
/* harmony export (immutable) */ __webpack_exports__["r"] = formatNegativeAmount;
/* harmony export (immutable) */ __webpack_exports__["s"] = formatRate;
/* harmony export (immutable) */ __webpack_exports__["e"] = formatStatus;
/* harmony export (immutable) */ __webpack_exports__["o"] = formatTerm;
/* harmony export (immutable) */ __webpack_exports__["d"] = formatType;
/* harmony export (immutable) */ __webpack_exports__["u"] = formatPaymentPreference;
/* harmony export (immutable) */ __webpack_exports__["C"] = convertErrorStringsToArrayStrings;
/* harmony export (immutable) */ __webpack_exports__["v"] = findAccount;
/* harmony export (immutable) */ __webpack_exports__["f"] = isStateRestricted;
/* harmony export (immutable) */ __webpack_exports__["g"] = isFailTransaction;
/* harmony export (immutable) */ __webpack_exports__["h"] = isCancelTransaction;
/* harmony export (immutable) */ __webpack_exports__["i"] = isPurchaseFailedTransaction;
/* harmony export (immutable) */ __webpack_exports__["j"] = isPurchaseFailedTransactionWithSelectedErrorsCode;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return logglyTags; });
/* harmony export (immutable) */ __webpack_exports__["m"] = logAction;
/* harmony export (immutable) */ __webpack_exports__["L"] = addressAreEqual;
/* harmony export (immutable) */ __webpack_exports__["y"] = findRates;
/* harmony export (immutable) */ __webpack_exports__["n"] = getAccounTypeProperties;
/* harmony export (immutable) */ __webpack_exports__["w"] = getUserTypeLabel;
/* harmony export (immutable) */ __webpack_exports__["F"] = isStringValid;
/* harmony export (immutable) */ __webpack_exports__["G"] = isAddressValid;
/* harmony export (immutable) */ __webpack_exports__["J"] = capitalize;
/* harmony export (immutable) */ __webpack_exports__["I"] = downloadPDF;
/* harmony export (immutable) */ __webpack_exports__["l"] = openUrl;
/* harmony export (immutable) */ __webpack_exports__["N"] = downloadCSVBlob;
/* harmony export (immutable) */ __webpack_exports__["O"] = downloadBlob;
/* unused harmony export downloadCSV */
/* harmony export (immutable) */ __webpack_exports__["M"] = postMessageSuccessEmbedLogin;
/* harmony export (immutable) */ __webpack_exports__["t"] = orderTransactions;
/* harmony export (immutable) */ __webpack_exports__["D"] = selectRateAndTermToDisplay;
/* harmony export (immutable) */ __webpack_exports__["z"] = setActionTakenUpcomingTransactionHelper;
/* harmony export (immutable) */ __webpack_exports__["A"] = setFundingSourceUpcomingTransactionHelper;
/* harmony export (immutable) */ __webpack_exports__["B"] = orderUpcomingTransactions;
/* harmony export (immutable) */ __webpack_exports__["K"] = formatFileExtensions;
/* harmony export (immutable) */ __webpack_exports__["k"] = normalizeRichTextLinks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_timezone__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_static_accountTypes__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_static_upcomingTransactionActions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_config__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_static_userTypes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_static_restrictedStates__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__idle__ = __webpack_require__(604);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__idle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers__ = __webpack_require__(603);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_15__helpers__["a"]; });




















var zipRegex = /^\d{5}$|^\d{5}-\d{4}$|^[A-Z]\d[A-Z] \d[A-Z]\d$/;

function camelToSnakeCase(input) {
  return input.replace(/[\w]([A-Z])/g, function (m) {
    return m[0] + '_' + m[1];
  }).toLowerCase();
}

function timeZone() {
  return __WEBPACK_IMPORTED_MODULE_10__config_config__["b" /* timeZone */].value;
}
function formatDate(date) {
  if (!date) {
    return '----------';
  }
  if (timeZone() === 'local') {
    return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('MM/DD/YYYY');
  }
  return __WEBPACK_IMPORTED_MODULE_6_moment_timezone___default()(date).tz(timeZone()).format('MM/DD/YYYY');
}

function formatDecimal(number) {
  var factor = Math.pow(10, 2); // eslint-disable-line no-restricted-properties
  return Math.round(number * factor) / factor;
}

function formatBaseAmount(amount) {
  if (amount === 0) {
    return ' 0.00';
  }

  var _amount$toFixed$split = amount.toFixed(2).split('.'),
      _amount$toFixed$split2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_amount$toFixed$split, 2),
      whole = _amount$toFixed$split2[0],
      decimal = _amount$toFixed$split2[1];

  var _$exec = /(\d{1,3})((?:\d{3})*)$/.exec(whole),
      _$exec2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_$exec, 3),
      n1 = _$exec2[1],
      n2 = _$exec2[2];

  var result = n2.match(/\d\d\d/g) || [];
  result.unshift(n1);
  return result.join(',') + '.' + decimal;
}

function formatAmount(amount) {
  if (!amount) {
    return '$ 0.00';
  }
  var result = formatBaseAmount(amount);
  var sign = amount < 0 ? '-' : '';
  return '$' + sign + result;
}

function formatNegativeAmount(amount) {
  if (amount !== 0 && !amount) {
    return '';
  }
  var result = formatBaseAmount(amount);
  var sign = amount < 0 ? '(' : '';
  var postSign = amount < 0 ? ')' : '';
  return sign + '$' + result + postSign;
}

function formatRate(rate) {
  if (!rate && rate !== 0) {
    return '';
  }
  var rateFixed = rate.toFixed(2).toString();
  return rateFixed + '%';
}

function formatStatus(status) {
  return '' + status[0] + status.slice(1).toLowerCase();
}

function formatTerm(term) {
  var amountYears = term / 12;
  var yearLabel = amountYears === 1 ? 'Year' : 'Years';
  return amountYears + ' ' + yearLabel;
}

function formatType(type, userRole, fundingSourceId) {
  switch (type) {
    case 'ACCRINT':
      return 'Interest accrued';
    case 'FEE-SERV':
      return 'Service fee';
    case 'INT-DONATE':
      return 'Interest donated';
    case 'INT-PAID':
      return userRole === 'admin' ? 'INT-PAID' : 'Interest paid';
    case 'INT-REINVEST':
      return 'Interest reinvested in new Note';
    case 'PURCH-CANCEL':
      return 'Purchase cancelled';
    case 'PURCH-INT-REINVEST':
      return 'Note opened, interest reinvestment';
    case 'PURCH-NEW':
      return 'Note opened';
    case 'PURCH-REINVEST':
      return 'Note opened, principal reinvestment';
    case 'SELL-DONATE':
      return fundingSourceId === __WEBPACK_IMPORTED_MODULE_9__data_static_upcomingTransactionActions__["a" /* default */].donate.name ? 'Amount donated at redemption' : 'Note donated at maturity';
    case 'SELL-MATURE':
      return userRole === 'admin' ? 'SELL-MATURE' : 'Note repaid';
    case 'SELL-REDEEM-FULL':
      return userRole === 'admin' ? 'SELL-REDEEM-FULL' : 'Full redemption';
    case 'SELL-REDEEM-PARTIAL':
      return userRole === 'admin' ? 'SELL-REDEEM-PARTIAL' : 'Partial redemption';
    case 'SELL-REINVEST':
      return 'Note reinvested in new Note at maturity';
    case 'SETTLEMENT':
      return 'Note opened, combined reinvestment';
    case 'REPAID-ACCT-FULL':
      return 'Redeemed / Note closed';
    case 'REPAID-ACCT-PARTIAL':
      return 'Partial redemption';
    case 'ADDITIONAL-DEPOSIT':
      return 'Additional deposit';
    case 'REPAID-ACCT':
      return 'Note repaid at maturity';
    case 'PURCH-RENEWAL':
      return 'Principal renewal';
    case 'PURCH-INT-CAP':
      return 'Interest capitalized';
    case 'PAID-INT':
      return 'Interest paid';
    case 'check':
      return 'Check';
    case 'wire/ach':
      return 'Wire/ACH';
    case 'bank':
      return 'Bank';
    case 'ACCT-TRANSFER':
      return 'Account transfer';
    case 'ADDITIONAL_DEPOSIT_AT_REINVESTMENT':
      return 'Additional deposit at reinvestment';
    default:
      return type;
  }
}

function formatPaymentPreference(paymentPreference) {
  switch (paymentPreference) {
    case 'reinvest':
      return 'Reinvest';
    case 'payout':
      return 'Repay To Bank Account';
    case 'donate':
      return 'Donate';
    default:
      return paymentPreference;
  }
}

function convertErrorStringsToArrayStrings(errors) {
  return errors.split(',');
}

function findAccount(accounts, accountId) {
  return accounts.find(function (account) {
    return account.id === +accountId;
  });
}

function isStateRestricted(state) {
  var restrictedStateFound = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_13__data_static_restrictedStates__["a" /* default */], function (st) {
    return st.name === state;
  });
  return restrictedStateFound !== undefined;
}

function isFailTransaction(transaction) {
  return transaction.status === 'FAILED' && transaction.type !== __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].PURCHASE_NOTE && transaction.type !== __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].FUNDING;
}

function isCancelTransaction(transaction) {
  return transaction.status === 'CANCELLED' && transaction.type !== __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].PURCHASE_NOTE && transaction.type !== __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].FUNDING;
}

function isPurchaseFailedTransaction(transaction) {
  return (transaction.failureReason && transaction.failureReason.includes('R03') !== true && transaction.failureReason.includes('R01') !== true || transaction.failureReason === null) && (transaction.status === 'FAILED' || transaction.status === 'CANCELLED') && (transaction.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].PURCHASE_NOTE || transaction.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].FUNDING);
}

function isPurchaseFailedTransactionWithSelectedErrorsCode(transaction) {
  return transaction.failureReason && (transaction.failureReason.includes('R03') || transaction.failureReason.includes('R01')) && (transaction.status === 'FAILED' || transaction.status === 'CANCELLED') && (transaction.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].PURCHASE_NOTE || transaction.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].FUNDING);
}

var logglyTags = {
  auth0: 'auth0',
  dwolla: 'dwolla'
};

function validateLogArgs(options) {
  var errors = [];
  if (options.level === 'error') {
    if (!options.stack) {
      errors.push('Parameter "stack" is missing.');
    }
  } else {
    var requiredOption = ['level', 'action', 'message'];
    requiredOption.forEach(function (option) {
      if (!options[option]) {
        errors.push('Parameter "' + option + '" is missing.');
      }
    });
  }

  if (errors.length > 0) {
    throw errors;
  }
}

function logAction(options) {
  var level = options.level,
      user = options.user,
      action = options.action,
      message = options.message,
      tags = options.tags,
      stack = options.stack;

  validateLogArgs(options);
  var newLogger = new window.LogglyTracker();
  newLogger.push({
    logglyKey: __WEBPACK_IMPORTED_MODULE_10__config_config__["a" /* loggly */].logglyKey,
    tag: tags ? tags.join() : ''
  });
  var data = {
    level: level,
    message: message,
    timestampUTC: __WEBPACK_IMPORTED_MODULE_6_moment_timezone___default()().utc().toString(),
    timestampET: __WEBPACK_IMPORTED_MODULE_6_moment_timezone___default()().tz(timeZone()).toString(),
    action: action || 'N/A',
    originSystem: __WEBPACK_IMPORTED_MODULE_10__config_config__["a" /* loggly */].originSystem
  };

  if (stack) {
    data.stack = stack;
  }
  if (user) {
    data.user = user;
  }
  newLogger.push(data);
}
function addressAreEqual(adr1, adr2) {
  return adr1.city === adr2.city && adr1.state === adr2.state && adr1.streetAddress1 === adr2.streetAddress1 && adr1.streetAddress2 === adr2.streetAddress2 && adr1.zipCode === adr2.zipCode;
}

function findRates(interestYearRates, term, rate) {
  var isAdmin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var activeYearRates = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(interestYearRates)).sort(function (a, b) {
    return a.precedence - b.precedence;
  });
  var zeroRate = activeYearRates.find(function (val) {
    return val.rate === 0;
  });
  if (rate === 0 && zeroRate) {
    if (isAdmin) {
      return { term: term, rate: rate };
    }
    return zeroRate;
  }
  var found = activeYearRates.reduce(function (accum, curr) {
    var dif1 = Math.abs(curr.term - term);
    var dif2 = Math.abs(accum.term - term);
    var validation = dif1 <= dif2;
    if (dif1 === dif2) {
      validation = Math.abs(curr.rate - rate) <= Math.abs(accum.rate - rate);
    }
    return validation ? curr : accum;
  }, { term: Infinity, rate: Infinity });
  return found;
}

function getAccounTypeProperties(type) {
  var key = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8__data_static_accountTypes__["a" /* AccountTypes */]).find(function (currentKey) {
    return __WEBPACK_IMPORTED_MODULE_8__data_static_accountTypes__["a" /* AccountTypes */][currentKey].name === type;
  });
  return __WEBPACK_IMPORTED_MODULE_8__data_static_accountTypes__["a" /* AccountTypes */][key];
}

function getUserTypeLabel(type) {
  var key = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_12__data_static_userTypes__["a" /* UserTypes */]).find(function (currentKey) {
    return __WEBPACK_IMPORTED_MODULE_12__data_static_userTypes__["a" /* UserTypes */][currentKey].name === type;
  });
  return __WEBPACK_IMPORTED_MODULE_12__data_static_userTypes__["a" /* UserTypes */][key].label;
}

function isStringValid(value) {
  if (typeof value === 'string') {
    return value.trim() !== '';
  }
  return false;
}

function isAddressValid(_ref) {
  var city = _ref.city,
      state = _ref.state,
      streetAddress1 = _ref.streetAddress1,
      zipCode = _ref.zipCode;

  return isStringValid(city) && isStringValid(state) && isStringValid(streetAddress1) && isStringValid(zipCode);
}

function capitalize(string) {
  var newString = string.toLowerCase();
  return newString.replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
}

function downloadPDF(fileName, buffer) {
  var blob = new Blob([new Uint8Array(buffer)], { type: 'application/pdf' });
  var dataUrl = URL.createObjectURL(blob);
  var link = document.createElement('a');
  link.href = dataUrl;
  link.target = '_blank';
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
}

function openUrl(url) {
  var link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  link.remove();
}

function downloadCSVBlob(fileName, blob) {
  var url = window.URL.createObjectURL(blob);
  var link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function downloadBlob(fileName, blob) {
  var url = window.URL.createObjectURL(blob);
  var link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function downloadCSV(fileName, buffer) {
  downloadCSVBlob(fileName, new Blob([buffer], { type: 'text/csv;charset=utf-8;' }));
}

function postMessageSuccessEmbedLogin(redirectUrl) {
  parent.postMessage({
    type: 'EMBED_LOGIN',
    redirectUrl: redirectUrl
  }, '*');
}

function orderTransactions(noteTransactions) {
  return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(noteTransactions, ['transactionId'], ['desc']);
}

function selectRateAndTermToDisplay(note, rateAndTermList) {
  var transaction = note.transaction,
      termFromNote = note.term;
  var rate = transaction.rate,
      term = transaction.term,
      actionTaken = transaction.actionTaken;

  var isCustomRateAndTerm = rateAndTermList.some(function (rt) {
    return rt.rate === rate && rt.term === term;
  }) === false && !!actionTaken;
  if (!isCustomRateAndTerm) {
    var rateAndTerm = rateAndTermList.find(function (rt) {
      if (!actionTaken) {
        return rt.term === termFromNote;
      }
      return rt.term === termFromNote && rt.rate === rate;
    });
    return {
      isCustom: isCustomRateAndTerm,
      selected: rateAndTerm
    };
  }
  return {
    isCustom: isCustomRateAndTerm,
    selected: {
      rate: rate,
      term: term,
      label: formatRate(rate) + ', ' + formatTerm(term),
      id: rateAndTermList.length + 1,
      precedence: rateAndTermList.length + 1
    }
  };
}

function setActionTakenUpcomingTransactionHelper(actionTaken, transactionType) {
  var action = find(__WEBPACK_IMPORTED_MODULE_9__data_static_upcomingTransactionActions__["a" /* default */], function (a) {
    return a.name === actionTaken;
  });

  if (action) {
    return action;
  }

  switch (transactionType) {
    case __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].INT_PAID:
    case __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].SELL_MATURE:
      return __WEBPACK_IMPORTED_MODULE_9__data_static_upcomingTransactionActions__["a" /* default */].cashout;
    case __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].INT_REINVEST:
    case __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].SELL_REINVEST:
      return __WEBPACK_IMPORTED_MODULE_9__data_static_upcomingTransactionActions__["a" /* default */].reinvest;
    case __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].INT_DONATE:
    case __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].SELL_DONATE:
      return __WEBPACK_IMPORTED_MODULE_9__data_static_upcomingTransactionActions__["a" /* default */].donate;
    default:
      return null;
  }
}

function setFundingSourceUpcomingTransactionHelper(action, fundingSourceId, defaultFundingSourceId, fundingSources) {
  if (action && action.name === __WEBPACK_IMPORTED_MODULE_9__data_static_upcomingTransactionActions__["a" /* default */].cashout.name) {
    var targetId = fundingSourceId !== undefined ? fundingSourceId : defaultFundingSourceId;
    return fundingSources.find(function (fs) {
      return fs.id.toString() === targetId.toString();
    });
  }
  return null;
}

function orderUpcomingTransactions(transactions) {
  return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(transactions, ['transaction.noteId', 'transaction.type'], ['desc', 'desc']);
}

function formatFileExtensions(extensions) {
  var uniqueExtensions = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(extensions)));

  uniqueExtensions.sort();

  // Join all but the last item with commas, and the last item with 'or'
  if (uniqueExtensions.length > 1) {
    var lastExtension = uniqueExtensions.pop();
    return uniqueExtensions.join(', ') + ' or ' + lastExtension;
  }
  return uniqueExtensions[0];
}

function normalizeRichTextLinks(html) {
  if (!html) {
    return '';
  }
  var parsedHtml = new DOMParser().parseFromString(html, 'text/html');
  var anchors = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(parsedHtml.body.querySelectorAll('a[href]'));

  anchors.forEach(function (anchor) {
    var href = anchor.getAttribute('href').trim();
    // A href without a scheme (e.g. "www.calvertimpactcapital.org") is resolved
    // by the browser against the portal origin, so it navigates inside the app
    // instead of going to the external site.
    var hasScheme = /^[a-z][a-z0-9+.-]*:/i.test(href);
    var isInternalReference = href.startsWith('#') || href.startsWith('/');

    if (href && !hasScheme && !isInternalReference) {
      anchor.setAttribute('href', 'https://' + href);
    }
    anchor.setAttribute('target', '_blank');
    anchor.setAttribute('rel', 'noopener noreferrer');
  });

  return parsedHtml.body.innerHTML;
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(975)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(720),
  /* template */
  __webpack_require__(2101),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08834547",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1052)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(710),
  /* template */
  __webpack_require__(2180),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79fb2902",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Constants; });
/* eslint-disable import/prefer-default-export */
var Constants = {
  registration: {
    successMessage: 'Please check your email. We’ve sent a verification email to the address you provided.'
  },
  home: {
    successMessage: 'Your personal information was saved successfully.',
    startMessage: 'Thank you for registering with Calvert Impact Capital. We invite you to learn about our work, and when ready, open an investment account or claim an existing account.'
  },
  purchaseNote: {
    dwollaTermsUrl: 'https://www.dwolla.com/legal/tos/',
    fundingSourceError: 'You must select a bank account',
    interestYearRateError: 'You must select a rate',
    modalQuestion: 'Do you wish to proceed and invest?',
    modalTitle: 'Confirm investment',
    modalYesButtonMethod: 'Purchase Note',
    modalYesButtonText: 'Confirm',
    investmentRequiredError: 'You must provide an investment amount',
    propectusAndDwollaTermsError: 'Please accept the Dwolla Terms & Conditions and Prospectus before proceeding',
    prospectusTermUrl: 'http://www.calvertfoundation.org/storage/documents/CF-Community-Investment-Note-Prospectus.pdf',
    legacyFundingSourceMessageFirstLine: 'Check and wire/ACH transfer may only be used for receiving payments.',
    legacyFundingSourceMessageSecondLine: 'If you need to purchase a Note funded by a check or wire/ACH transfer, please contact Calvert Impact Capital.'
  },
  failedTransactiondetail: {
    markAsLostMessage: 'Are you sure you want to mark this transaction as lost?',
    markAsUnlostMessage: 'Are you sure you want to mark this transaction as unlost?',
    flaggedAsLostSuccessMessage: 'The transaction was succesfully flagged as lost.',
    flaggedAsUnlostSuccessMessage: 'The transaction was succesfully flagged as unlost.'
  },
  microDeposits: {
    modalYesButtonText: 'Confirm Micro-Deposits'
  },
  redeem: {
    modalYesButtonText: 'Confirm',
    modalQuestion: 'Are you sure you want to cancel this redemption request?',
    modalTitle: 'Cancel redemption'
  },
  accountDetail: {
    modalYesButtonText: 'Confirm',
    modalTitle: 'Account preference'
  },
  fundingSource: {
    modalTitle: 'Notice',
    modalEditProfileButtonText: 'Edit Profile',
    modalYesButtonText: 'Confirm',
    hyperLinkText: 'Terms of Service.',
    hyperLinkUrl: 'https://www.dwolla.com/legal/tos/?whitelabel',
    hyperLinkText2: 'Privacy Policy.',
    hyperLinkUrl2: 'https://www.dwolla.com/legal/privacy?whitelabel',
    retrySelfRegisterDisclaimer: 'Your identity could not be verified. Please check your profile and make any necessary corrections, then try again. If you need assistance, please contact Calvert Impact Capital.',
    retryDisclamer: 'Your identity could not be verified by our payment partner. Please check your profile and make any necessary corrections, then try again.',
    legacyDisclamer: 'Thank you for deciding to use a bank account as part of your Calvert Impact Capital account. We have partnered with Dwolla to securely send payments to, and allow you to invest from, your bank account(s). By proceeding, you agree that you have read and accept Dwolla’s',
    legacyDisclamerAppend: ' Please contact Calvert Impact Capital if you have any questions.',
    legacyDisclamerRetry: ' If you need assistance, please contact Calvert Impact Capital',
    defaultFundingSourceModalTitle: 'New default bank account',
    deleteFundingSourceModalTitle: 'Delete bank account'
  },
  companyInformation: {
    name: 'Calvert Impact Capital'
  },
  userDetail: {
    modalYesButtonText: 'Confirm',
    modalTitle: 'Personal information',
    modalQuestion: 'Are you sure about these changes?',
    modalQuestionPOBox: 'We identified you are entering a PO Box address. Are you sure about these changes?',
    ModalUserConfirmation: 'Are you sure this is the correct information?'
  },
  investorPreferences: {
    modalTitle: 'Investment Preferences',
    modalYesButtonText: 'Save',
    modalQuestion: 'Are you sure you want to submit your impact preferences?',
    successMessage: 'Your impact preferences were saved successfully.'
  },
  adminPreferences: {
    modalTitle: 'Investment preferences',
    modalYesButtonText: 'Save',
    modalQuestion: 'Are you sure you want to update these preferences?',
    successMessage: 'The preferences were submitted successfully.'
  },
  additionalEmail: {
    modalTitle: 'Additional email',
    modalYesButtonText: 'Confirm',
    modalQuestion: 'Are you sure you want to delete this email?',
    successMessageAfterAddition: 'The email was added successfully!',
    successMessageAfterDeletion: 'The email was deleted successfully!'
  },
  updatePrimaryInvestorMessage: {
    institutionAccountMessage: 'Because this is an institution account, this will send transaction notifications to the primary investor but will not affect the bank accounts used for investing.',
    notInstitutionAccountMessage: 'This will send future transaction notifications to the primary investor and make the primary investor\'s bank accounts available for investing using this account.'
  },
  transfer: {
    modalYesButtonText: 'Confirm',
    modalQuestion: 'Are you sure you want to cancel this transfer request?',
    modalTitle: 'Cancel transfer'
  },
  purchaseInvestmentNote: {
    // Brokerage is only a valid funding source for account A842 (Cede & Co) in
    // production; lower environments use A1824 as the equivalent test account.
    brokerageEnabledAccountIds: {
      production: ['842'],
      default: ['1824']
    }
  },
  addFunds: {
    modalYesButtonText: 'Confirm',
    modalQuestion: 'Are you sure you want to cancel this add funds request?',
    modalTitle: 'Cancel Add Funds Request'
  },
  richtext: {
    customEditorToolbar: [[{ header: [false, 1, 2, 3, 4, 5, 6] }], ['bold', 'italic', 'underline', 'strike'], [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }], [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], [{ indent: '-1' }, { indent: '+1' }], [{ color: ['#000000', '#041722', '#050505', '#096633', '#0e1012', '#10171e', '#121517', '#14171a', '#141d26', '#15181c', '#15202b', '#17bf63', '#182430', '#192734', '#1b2836', '#1b95e0', '#1da1f2', '#1da1f2', '#202327', '#244052', '#253341', '#264a9d', '#2f3336', '#325d7d', '#38444d', '#3b4c5c', '#3d4145', '#3d5466', '#512892', '#657786', '#66d397', '#68e090', '#697987', '#6b7d8c', '#6e767d', '#6e767d', '#70c8ff', '#71c9f8', '#794bc4', '#79500b', '#8899a6', '#929ca6', '#929ca6', '#92a4b3', '#97e3ff', '#99350d', '#9f0c3a', '#a37ced', '#a5f2aa', '#aab8c2', '#b8cbd9', '#bea8e2', '#c7b4fa', '#ccd6dd', '#d9d9d9', '#e0245e', '#e6ecf0', '#eaf5fd', '#f098b3', '#f45d22', '#f5f8fa', '#f6809a', '#f89a75', '#ff8d57', '#ffad1f', '#ffb8c2', '#ffbe78', '#ffcb70', '#ffd03f', '#ffe76e', '#ffffff', '#ffffff', '#000000', '#0000ff', '#008000', '#add8e6', '#90ee90', '#ffffe0', '#0000cd', '#9370db', '#ffa500', '#800080', '#ff0000', '#657786', '#657786', '#657786', '#8899a6', '#8899a6', '#8899a6', '#121517', '#141d26', '#d9d9d9', '#d9d9d9', '#e6ecf0', '#ffffff', '#ffffff', '#ffffff', '#ffff00'] }, { background: ['#000000', '#041722', '#050505', '#096633', '#0e1012', '#10171e', '#121517', '#14171a', '#141d26', '#15181c', '#15202b', '#17bf63', '#182430', '#192734', '#1b2836', '#1b95e0', '#1da1f2', '#1da1f2', '#202327', '#244052', '#253341', '#264a9d', '#2f3336', '#325d7d', '#38444d', '#3b4c5c', '#3d4145', '#3d5466', '#512892', '#657786', '#66d397', '#68e090', '#697987', '#6b7d8c', '#6e767d', '#6e767d', '#70c8ff', '#71c9f8', '#794bc4', '#79500b', '#8899a6', '#929ca6', '#929ca6', '#92a4b3', '#97e3ff', '#99350d', '#9f0c3a', '#a37ced', '#a5f2aa', '#aab8c2', '#b8cbd9', '#bea8e2', '#c7b4fa', '#ccd6dd', '#d9d9d9', '#e0245e', '#e6ecf0', '#eaf5fd', '#f098b3', '#f45d22', '#f5f8fa', '#f6809a', '#f89a75', '#ff8d57', '#ffad1f', '#ffb8c2', '#ffbe78', '#ffcb70', '#ffd03f', '#ffe76e', '#ffffff', '#ffffff', '#000000', '#0000ff', '#008000', '#add8e6', '#90ee90', '#ffffe0', '#0000cd', '#9370db', '#ffa500', '#800080', '#ff0000', '#657786', '#657786', '#657786', '#8899a6', '#8899a6', '#8899a6', '#121517', '#141d26', '#d9d9d9', '#d9d9d9', '#e6ecf0', '#ffffff', '#ffffff', '#ffffff', '#ffff00'] }], // dropdown with defaults from theme
    ['link']] }
};

/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(982)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(714),
  /* template */
  __webpack_require__(2110),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-194c1c3d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_config__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_cognito__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_static_addressErrors__ = __webpack_require__(130);









var _this = this;







function toQuerySearchParams(params) {
  if (!params) return '';
  var querySearchParams = new URLSearchParams(params);
  return querySearchParams;
}

function toURL(_ref) {
  var url = _ref.url,
      _ref$params = _ref.params,
      params = _ref$params === undefined ? null : _ref$params,
      _ref$apiVersion = _ref.apiVersion,
      apiVersion = _ref$apiVersion === undefined ? 'v1' : _ref$apiVersion;

  var sanitizedUrl = url[0] === '/' ? url.substring(1) : url;
  var baseUrl = __WEBPACK_IMPORTED_MODULE_8__config_config__["f" /* api */].baseUrl,
      baseUrlV2 = __WEBPACK_IMPORTED_MODULE_8__config_config__["f" /* api */].baseUrlV2;

  var apiVersionPathMap = {
    v1: sanitizedUrl,
    v2: 'v2/' + sanitizedUrl
  };
  var apiVersionUrlMap = {
    v1: baseUrl,
    v2: baseUrlV2
  };
  var urlObj = new URL(apiVersionPathMap[apiVersion], apiVersionUrlMap[apiVersion]);
  var querySearchParams = toQuerySearchParams(params);
  if (!querySearchParams) return urlObj;
  urlObj.search = querySearchParams;
  return urlObj;
}

var makeRequest = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2(url) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        method = _ref3.method,
        _ref3$headers = _ref3.headers,
        headers = _ref3$headers === undefined ? {} : _ref3$headers,
        _ref3$body = _ref3.body,
        body = _ref3$body === undefined ? null : _ref3$body;

    var legacyToken = arguments[2];
    var token;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = legacyToken;

            if (_context2.t0) {
              _context2.next = 5;
              break;
            }

            _context2.next = 4;
            return __WEBPACK_IMPORTED_MODULE_9__services_cognito__["b" /* CognitoService */].getIdToken();

          case 4:
            _context2.t0 = _context2.sent;

          case 5:
            token = _context2.t0;

            // eslint-disable-next-line no-param-reassign
            headers.Authorization = 'Bearer ' + token;

            return _context2.abrupt('return', fetch(url, { method: method, headers: headers, body: body }).then(function () {
              var _ref4 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                var contentType, responseBody, _responseBody, addressType, suggestedAddress, isAdminCommercialOverride, error;

                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        contentType = response.headers.get('content-type');
                        responseBody = void 0;

                        if (!(contentType && contentType.includes('application/json'))) {
                          _context.next = 6;
                          break;
                        }

                        _context.next = 5;
                        return response.json();

                      case 5:
                        responseBody = _context.sent;

                      case 6:

                        if (responseBody && responseBody.suggestedAddress) {
                          _responseBody = responseBody, addressType = _responseBody.addressType, suggestedAddress = _responseBody.suggestedAddress;


                          if (suggestedAddress) {
                            __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].commit('accountCreation/SET_SUGGESTED_ADDRESS', suggestedAddress);
                            __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].commit('accountCreation/SET_SUGGESTED_ADDRESS_TYPE', addressType);
                            __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].commit('accountCreation/SET_SUGGESTED_ADDRESS_MODAL_VISIBLE', true);
                            __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].commit('accountCreation/SET_SUGGESTED_ADDRESS_YES_METHOD', function () {
                              __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].commit('accountCreation/SET_SUGGESTED_ADDRESS_YES_CALL', {
                                payload: JSON.parse(body),
                                suggestedAddress: suggestedAddress,
                                addressType: addressType
                              });
                            });
                          }
                        }

                        if (responseBody && responseBody.errorMessage) {
                          // Admins can override a commercial residential address. For them we let
                          // the calling screen show a dedicated override modal instead of the
                          // generic error modal. Everyone else (e.g. investors self-editing) still
                          // gets the plain "not allowed" message here.
                          isAdminCommercialOverride = responseBody.errorMessage === 'RESIDENTIAL_COMMERCIAL_ADDRESS_NOT_ALLOWED' && __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].state.app && __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].state.app.irAdmin;


                          if (!isAdminCommercialOverride) {
                            error = __WEBPACK_IMPORTED_MODULE_12__data_static_addressErrors__["a" /* AddressErrors */][responseBody.errorMessage] || responseBody.errorMessage;

                            __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].commit('errors/SET_ERRORS_MODAL_INFO', [error]);
                            __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */].commit('errors/SHOW_ERRORS_MODAL');
                          }
                        }

                        _context.t0 = response.status;
                        _context.next = _context.t0 === 401 ? 11 : _context.t0 === 403 ? 13 : _context.t0 === 204 ? 15 : 16;
                        break;

                      case 11:
                        __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].replace({ name: 'Login' });
                        return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.reject('UNAUTHORIZED'));

                      case 13:
                        __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].replace({ name: 'Home' });
                        return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.reject('FORBIDDEN'));

                      case 15:
                        return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.resolve());

                      case 16:
                        if (contentType) {
                          _context.next = 18;
                          break;
                        }

                        return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.resolve());

                      case 18:
                        if (!(contentType.includes('text/csv') || contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'))) {
                          _context.next = 20;
                          break;
                        }

                        return _context.abrupt('return', response.blob());

                      case 20:
                        if (response.ok) {
                          _context.next = 22;
                          break;
                        }

                        return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.reject(responseBody));

                      case 22:
                        return _context.abrupt('return', responseBody);

                      case 23:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function (_x3) {
                return _ref4.apply(this, arguments);
              };
            }()).catch(function (error) {
              return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.reject(error);
            }));

          case 8:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function makeRequest(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var doRequest = function doRequest(method, urlObj, data) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return makeRequest(urlObj.href, {
    method: method,
    headers: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
      'Content-Type': 'application/json'
    }, options.headers),
    body: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data)
  }, options.legacyToken);
};

var doDelete = function doDelete(urlObj, data) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return makeRequest(urlObj.href, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
    method: 'DELETE',
    headers: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, options.headers)
  }, data ? {
    headers: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, options.headers, {
      'Content-Type': 'application/json'
    }),
    body: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data)
  } : {}));
};

var doUploadFile = function doUploadFile(urlObj, file) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var body = new FormData();
  body.append('file', file);
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
    body.append(key, data[key]);
  });
  return makeRequest(urlObj.href, {
    method: 'POST',
    headers: options.headers,
    body: body
  });
};
var doUploadFiles = function doUploadFiles(urlObj, files) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var body = new FormData();
  files.forEach(function (file) {
    body.append('files', file);
  });
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
    body.append(key, data[key]);
  });
  return makeRequest(urlObj.href, {
    method: 'POST',
    headers: options.headers,
    body: body
  });
};

var doUploadFilesAndForm = function doUploadFilesAndForm(urlObj, data, files) {
  var body = new FormData();
  files.forEach(function (file) {
    body.append('file', file);
  });
  body.append('filesCount', files.length);
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
    if (key === 'emails') {
      body.append(key, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data[key]));
    } else {
      body.append(key, data[key]);
    }
  });
  return makeRequest(urlObj.href, {
    method: 'POST',
    body: body
  });
};

var HttpService = function () {
  function HttpService() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, HttpService);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(HttpService, null, [{
    key: 'post',
    value: function post(url, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var urlObj = toURL({ url: url });
      return doRequest('POST', urlObj, data, options);
    }
  }, {
    key: 'postV2',
    value: function postV2(url, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var urlObj = toURL({ url: url, apiVersion: 'v2' });
      return doRequest('POST', urlObj, data, options);
    }
  }, {
    key: 'put',
    value: function put(url, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var urlObj = toURL({ url: url });
      return doRequest('PUT', urlObj, data, options);
    }
  }, {
    key: 'putV2',
    value: function putV2(url, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var urlObj = toURL({ url: url, apiVersion: 'v2' });
      return doRequest('PUT', urlObj, data, options);
    }
  }, {
    key: 'patchV2',
    value: function patchV2(url, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var urlObj = toURL({ url: url, apiVersion: 'v2' });
      return doRequest('PATCH', urlObj, data, options);
    }
  }, {
    key: 'get',
    value: function get(url, params) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var urlObj = toURL({ url: url, params: params });
      return makeRequest(urlObj.href, {
        method: 'GET',
        headers: options.headers
      });
    }
  }, {
    key: 'getV2',
    value: function getV2(url, params) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var urlObj = toURL({ url: url, params: params, apiVersion: 'v2' });
      return makeRequest(urlObj.href, {
        method: 'GET',
        headers: options.headers
      });
    }
  }, {
    key: 'delete',
    value: function _delete(url, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var urlObj = toURL({ url: url });
      return doDelete(urlObj, data, options);
    }
  }, {
    key: 'deleteV2',
    value: function deleteV2(url, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var urlObj = toURL({ url: url, apiVersion: 'v2' });
      return doDelete(urlObj, data, options);
    }
  }, {
    key: 'uploadFile',
    value: function uploadFile(url, file) {
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      var urlObj = toURL({ url: url });
      return doUploadFile(urlObj, file, data, options);
    }
  }, {
    key: 'uploadFileV2',
    value: function uploadFileV2(url, file) {
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      var urlObj = toURL({ url: url, apiVersion: 'v2' });
      return doUploadFile(urlObj, file, data, options);
    }
  }, {
    key: 'uploadFilesV2',
    value: function uploadFilesV2(url, files) {
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      var urlObj = toURL({ url: url, apiVersion: 'v2' });
      return doUploadFiles(urlObj, files, data, options);
    }
  }, {
    key: 'uploadFilesAndForm',
    value: function uploadFilesAndForm(url, data, files) {
      var urlObj = toURL({ url: url });
      return doUploadFilesAndForm(urlObj, data, files);
    }
  }, {
    key: 'uploadFilesAndFormV2',
    value: function uploadFilesAndFormV2(url, data, files) {
      var urlObj = toURL({ url: url, apiVersion: 'v2' });
      return doUploadFilesAndForm(urlObj, data, files);
    }
  }, {
    key: 'getMfaOptions',
    value: function getMfaOptions(email) {
      var _this2 = this;

      var urlObj = toURL({ url: 'auth/mfa/options', params: { email: email }, apiVersion: 'v2' });
      return fetch(urlObj.href, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function () {
        var _ref5 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3(response) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (response.ok) {
                    _context3.next = 2;
                    break;
                  }

                  throw new Error('Failed to get MFA options');

                case 2:
                  return _context3.abrupt('return', response.json());

                case 3:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this2);
        }));

        return function (_x25) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }]);

  return HttpService;
}();

/* harmony default export */ __webpack_exports__["a"] = (HttpService);

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserTypes; });
var UserTypes = { // eslint-disable-line import/prefer-default-export
  INVESTOR: {
    label: 'Investor',
    name: 'INVESTOR'
  },
  FINANCIAL_ADVISOR: {
    label: 'Financial Advisor',
    name: 'ADVISOR'
  },
  MINOR: {
    label: 'Minor',
    name: 'MINOR'
  },
  ADMIN: {
    label: 'Admin',
    name: 'ADMIN'
  },
  INSTITUTIONAL_REPRESENTATIVE: {
    label: 'Institutional Representative',
    name: 'INSTITUTIONAL_REPRESENTATIVE'
  },
  READ_ONLY: {
    label: 'Read-only',
    name: 'READ_ONLY'
  }
};

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1060)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(630),
  /* template */
  __webpack_require__(2188),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-88458236",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return api; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return timeZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return logoutRedirectionURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loggly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return settingsApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return env; });
var api = {
  baseUrl: window.localStorage.getItem('OVERRIDE_URL') || 'https://invest-backend.calvertimpactcapital.org/',
  baseUrlV2: window.localStorage.getItem('OVERRIDE_URL_2') || 'https://invest-backend.calvertimpactcapital.org/'
};
var timeZone = {
  value: 'America/New_York'
};

var logoutRedirectionURL = 'https://calvertimpact.org/investing/community-investment-note';

var auth = {
  clientId: 'vVdng2zFtx83V9ZTLVcaGzP8BG3cq2EA',
  domain: 'invest-calvertimpactcapital.auth0.com',
  audience: 'https://invest-calvertimpactcapital.auth0.com/userinfo',
  recaptchaSitekey: '6Lcizk0UAAAAALLzBaZ-XPaKpj4WzAiqUSGyG_Gc',
  connection: 'Username-Password-Authentication',
  cognito: {
    userPoolId: 'us-east-1_DPJXnzpnZ',
    clientId: '1prk6u6ip2bf9no2s34g7rhh7g'
  }
};

var loggly = {
  logglyKey: 'c3ca76d0-c675-4744-b3d8-8b762881b4d7',
  originSystem: 'production-frontend'
};

var settingsApp = {
  hasBeenDisablledSignUp: 'OFF',
  showMaintenance: 'false'
};

var env = 'production';

/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Events; });
/* eslint-disable import/prefer-default-export */
var Events = {
  ADDITIONAL_EMAILS_ADDING_FAILED: 'additionalEmailsAddingFailed',
  ADDITIONAL_EMAILS_ADDING_STARTED: 'additionalEmailsAddingStarted',
  ADDITIONAL_EMAILS_ADDING_SUCCEED: 'additionalEmailsAddingSucceed',
  ADDITIONAL_EMAILS_DELETING_FAILED: 'additionalEmailsDeletingFailed',
  ADDITIONAL_EMAILS_DELETING_STARTED: 'additionalEmailsDeletingStarted',
  ADDITIONAL_EMAILS_DELETING_SUCCEED: 'additionalEmailsDeletingSucceed',
  FUNDING_SOURCES_LOADING_FAILED: 'fundingSourcesLoadingFailed',
  FUNDING_SOURCES_LOADING_STARTED: 'fundingSourcesLoadingStarted',
  FUNDING_SOURCES_LOADING_SUCCEED: 'fundingSourcesLoadingSucceed',
  DEFAULT_FUNDING_SOURCE_UPDATED: 'defaultFundingSourceUpdated',
  GO_TO_FUNDING_SOURCES_SEGMENT: 'goToFundingSourcesSegment',
  GO_TO_UPCOMING_TRANSACTIONS_SEGMENT: 'goToUpcomingTransactionsSegment',
  HIDE_ALERT_FOR_UPCOMING_TRANSACTIONS: 'hideAlertForUpcomingTransactions',
  HIDE_SUCCESS_ALERT: 'hideSuccessAlert',
  IMPACT_PREFERENCES_LOADING_FAILED: 'impactPreferencesLoadingFailed',
  IMPACT_PREFERENCES_LOADING_STARTED: 'impactPreferencesLoadingStarted',
  IMPACT_PREFERENCES_LOADING_SUCCEED: 'impactPreferencesLoadingSucceed',
  NOTES_LOADING_FAILED: 'notesLoadingFailed',
  NOTES_LOADING_STARTED: 'notesLoadingStarted',
  NOTES_LOADING_SUCCEED: 'notesLoadingSucceed',
  OPEN_MODAL_TO_ADD_NEW_FUNDING_SOURCE: 'openModalToAddNewFundingSource',
  RATE_AND_TERM_IS_INVALID: 'rateAndTermIsInvalid',
  RATE_AND_TERM_IS_VALID: 'rateAndTermIsValid',
  RATE_CHANGED: 'rateChanged',
  REDIRECT_TO_NOTE_DETAILS_VIEW: 'redirectToNoteDetailsView',
  REDIRECT_TO_PURCHASE_INVESTMENT_NOTE_VIEW: 'redirectToPurchaseInvestmentNoteView',
  REPRESENTATIVE_ADDED: 'representativeAdded',
  REPRESENTATIVES_UPDATED: 'representativesUpdated',
  RESTART: 'restart',
  SHOW_ALERT_FOR_UPCOMING_TRANSACTIONS_WITH_ACTION: 'showAlertForUpcomingTransactionsWithAction',
  SHOW_ALERT_FOR_UPCOMING_TRANSACTIONS_WITH_NO_ACTION: 'showAlertForUpcomingTransactionsWithNoAction',
  TERM_CHANGED: 'termChanged',
  REPRESENTATIVE_LOADING_FAILED: 'representativeLoadingFailed',
  REPRESENTATIVE_LOADING_STARTED: 'representativeLoadingStarted',
  REPRESENTATIVE_LOADING_SUCCEED: 'representativeLoadingSucceed',
  UPCOMING_TRANSACTIONS_LOADING_FAILED: 'upcomingTransactionsLoadingFailed',
  UPCOMING_TRANSACTIONS_LOADING_STARTED: 'upcomingTransactionsLoadingStarted',
  UPCOMING_TRANSACTIONS_LOADING_SUCCEED: 'upcomingTransactionsLoadingSucceed',
  UPDATE_IMPACT_PREFERENCES_FAILED: 'updateImpactPreferencesFailed',
  UPDATE_IMPACT_PREFERENCES_STARTED: 'updateImpactPreferencesStarted',
  UPDATE_IMPACT_PREFERENCES_SUCCEED: 'updateImpactPreferencesSucceed',
  BENEFICIARY_LOADING_FAILED: 'beneficiaryLoadingFailed',
  BENEFICIARY_LOADING_STARTED: 'beneficiaryLoadingStarted',
  BENEFICIARY_LOADING_SUCCEED: 'beneficiaryLoadingSucceed',
  BENEFICIARIES_UPDATED: 'beneficiariesUpdated',
  USER_MERGE_REQUESTED: 'userMergeRequested'
};

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Actions = {
  cashout: {
    id: 1,
    name: 'payout',
    text: 'Repay to bank account',
    order: 1
  },
  donate: {
    id: 2,
    name: 'donate',
    text: 'Donate to Calvert Impact Capital',
    order: 2
  },
  reinvest: {
    id: 3,
    name: 'reinvest',
    text: 'Reinvest in a new Note',
    order: 0
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Actions);

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1026)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(711),
  /* template */
  __webpack_require__(2155),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-593816b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1048)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(718),
  /* template */
  __webpack_require__(2176),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-77f1c1cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var logActions = {
  PASSWORD_RESET: { name: 'passwordReset', description: 'Investor requests a password reset' },
  LOGIN: { name: 'login', description: 'Investor logs in to the system' },
  LOGIN_FAILED: { name: 'loginFailed', description: 'Somebody attempts to login to the system but with invalid credentials' },
  ADD_FUNDING_SOURCE: { name: 'addFundingSource', description: 'Investor adds a new funding source' },
  VIEW_INVESTOR_IMPACT_PREFERENCES: { name: 'viewInvestorImpactPreferences', description: 'Investor view preferences he selected' },
  DOCUMENT_VIEW: { name: 'documentView', description: 'Investor selects a document for view' }
};

/* harmony default export */ __webpack_exports__["a"] = (logActions);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TransactionTypes = {
  PURCHASE_NOTE: 'PURCH-NEW',
  FUNDING: 'FUND-ACCT',
  SELL_REINVEST: 'SELL-REINVEST',
  SELL_DONATE: 'SELL-DONATE',
  SELL_MATURE: 'SELL-MATURE',
  SELL_REDEEM_FULL: 'SELL-REDEEM-FULL',
  SELL_REDEEM_PARTIAL: 'SELL-REDEEM-PARTIAL',
  ACCRINT: 'ACCRINT',
  PURCH_COMMISSION: 'PURCH-COMMISSION',
  REPAID_ACCT: 'REPAID-ACCT',
  PAID_INT: 'PAID-INT',
  SERV_FEE: 'SERV-FEE',
  FEE_SERV: 'FEE-SERV',
  REPAID_ACCT_FULL: 'REPAID-ACCT-FULL',
  REPAID_ACCT_PARTIAL: 'REPAID-ACCT-PARTIAL',
  INT_REINVEST: 'INT-REINVEST',
  INT_PAID: 'INT-PAID',
  INT_DONATE: 'INT-DONATE',
  ADDITIONAL_DEPOSIT: 'ADDITIONAL-DEPOSIT',
  PURCH_INT_REINVEST: 'PURCH-INT-REINVEST',
  PURCH_REINVEST: 'PURCH-REINVEST',
  PURCH_RENEWAL: 'PURCH-RENEWAL',
  PURCH_INT_CAP: 'PURCH-INT-CAP',
  ACCT_TRANSFER: 'ACCT-TRANSFER',
  SETTLEMENT: 'SETTLEMENT'
};

/* harmony default export */ __webpack_exports__["a"] = (TransactionTypes);

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1051)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(703),
  /* template */
  __webpack_require__(2179),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-78801dd1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1012)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(625),
  /* template */
  __webpack_require__(2141),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42309630",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1014)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(696),
  /* template */
  __webpack_require__(2143),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44c0b518",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1006)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(697),
  /* template */
  __webpack_require__(2136),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-33d98090",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */,
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TransactionStatuses = {
  PENDING: 'PENDING',
  PROCESSED: 'PROCESSED',
  PREPENDING: 'PRE-PENDING',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED'
};

/* harmony default export */ __webpack_exports__["a"] = (TransactionStatuses);

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(680),
  /* template */
  __webpack_require__(2135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1023)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(698),
  /* template */
  __webpack_require__(2152),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-559abd32",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchTypes; });
var SearchTypes = { // eslint-disable-line import/prefer-default-export
  NAME_EMAIL: {
    description: 'Search users and accounts that match',
    name: 'NAME_EMAIL',
    displayName: 'Name / Email'
  },
  ADVISOR_FIRM: {
    description: 'Search advisors by company name 1 or company name 2',
    name: 'ADVISOR_FIRM',
    displayName: 'Advisor firm'
  },
  ACCOUNT_NUMBER: {
    description: 'Search using the accountId property',
    name: 'ACCOUNT_NUMBER',
    displayName: 'Account number'
  },
  CUSIP: {
    description: 'Search using the cusip property',
    name: 'CUSIP',
    displayName: 'CUSIP'
  },
  NOTE_NUMBER: {
    description: 'Search using the noteId property',
    name: 'NOTE_NUMBER',
    displayName: 'Note number'
  }
};

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(976)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(666),
  /* template */
  __webpack_require__(2102),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(987)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(704),
  /* template */
  __webpack_require__(2115),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21ad9f9c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */,
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = resetState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_app__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_authentication__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_accountCreation__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_userCreationByAdmin__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_home__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_errors__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_fundingSource__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_documentUpload__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_microDepositsVerification__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_note__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_question__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_account__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_transaction__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_transactionModal__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_checkWireModal__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_information__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_success__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_user__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_successAlert__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_impactPreferences__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_documentViews__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modules_monthlyMaturities__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_idle__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modules_kba__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__modules_feedback__ = __webpack_require__(586);






























__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["e" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["e" /* default */].Store({
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_3__modules_app__["a" /* default */],
    authentication: __WEBPACK_IMPORTED_MODULE_4__modules_authentication__["a" /* default */],
    accountCreation: __WEBPACK_IMPORTED_MODULE_5__modules_accountCreation__["a" /* default */],
    userCreationByAdmin: __WEBPACK_IMPORTED_MODULE_6__modules_userCreationByAdmin__["a" /* default */],
    home: __WEBPACK_IMPORTED_MODULE_7__modules_home__["a" /* default */],
    errors: __WEBPACK_IMPORTED_MODULE_8__modules_errors__["a" /* default */],
    fundingSource: __WEBPACK_IMPORTED_MODULE_9__modules_fundingSource__["a" /* default */],
    documentUpload: __WEBPACK_IMPORTED_MODULE_10__modules_documentUpload__["a" /* default */],
    microDepositsVerification: __WEBPACK_IMPORTED_MODULE_11__modules_microDepositsVerification__["a" /* default */],
    note: __WEBPACK_IMPORTED_MODULE_12__modules_note__["a" /* default */],
    transaction: __WEBPACK_IMPORTED_MODULE_15__modules_transaction__["a" /* default */],
    transactionModal: __WEBPACK_IMPORTED_MODULE_16__modules_transactionModal__["a" /* default */],
    checkWireModal: __WEBPACK_IMPORTED_MODULE_17__modules_checkWireModal__["a" /* default */],
    question: __WEBPACK_IMPORTED_MODULE_13__modules_question__["a" /* default */],
    account: __WEBPACK_IMPORTED_MODULE_14__modules_account__["a" /* default */],
    information: __WEBPACK_IMPORTED_MODULE_18__modules_information__["a" /* default */],
    success: __WEBPACK_IMPORTED_MODULE_19__modules_success__["a" /* default */],
    successAlert: __WEBPACK_IMPORTED_MODULE_21__modules_successAlert__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_20__modules_user__["a" /* default */],
    impactPreferences: __WEBPACK_IMPORTED_MODULE_22__modules_impactPreferences__["a" /* default */],
    documentViews: __WEBPACK_IMPORTED_MODULE_23__modules_documentViews__["a" /* default */],
    monthlyMaturities: __WEBPACK_IMPORTED_MODULE_24__modules_monthlyMaturities__["a" /* default */],
    idle: __WEBPACK_IMPORTED_MODULE_25__modules_idle__["a" /* default */],
    kba: __WEBPACK_IMPORTED_MODULE_26__modules_kba__["a" /* default */],
    feedback: __WEBPACK_IMPORTED_MODULE_27__modules_feedback__["a" /* default */]
  }
});

var initialStateCopy = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(store.state));

function resetState() {
  store.replaceState(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(initialStateCopy)));
}

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddressErrors; });
var AddressErrors = { // eslint-disable-line import/prefer-default-export
  MAILING_DELIVERABLE_MISSING_SECONDARY: 'The mailing address appears to be incomplete. Make sure that you include your apartment or unit number',
  MAILING_INCORRECT_ADDRESS: 'There was a problem validating your mailing address. Please check the information provided and try again',
  MAILING_UNDELIVERABLE: 'The mailing address entered appears to be incorrect. Please check the information provided and try again.',
  MAILING_UNKNOWN: 'The mailing address entered appears to be incorrect. Please check the information provided and try again.',
  MAILING_UNVERIFIED_ADDRESS: 'Please accept one of the suggested mailing addresses provided earlier.',
  ORGANIZATION_DELIVERABLE_MISSING_SECONDARY: 'The business address appears to be incomplete. Please make sure you include the apartment or unit number.',
  ORGANIZATION_INCORRECT_ADDRESS: 'The address entered appears to be incorrect. Please check the information provided and try again.',
  ORGANIZATION_PO_BOX_NOT_ALLOWED: 'PO Box addresses are not allowed as Business addresses.',
  ORGANIZATION_UNDELIVERABLE: 'The address entered appears to be incorrect. Please check the information provided and try again.',
  ORGANIZATION_UNKNOWN: 'The address entered appears to be incorrect. Please check the information provided and try again.',
  RESIDENTIAL_COMMERCIAL_ADDRESS_NOT_ALLOWED: 'Commercial addresses are not allowed as an investor\'s residential addresses.',
  RESIDENTIAL_DELIVERABLE_MISSING_SECONDARY: 'The address appears to be incomplete. Make sure that you include your apartment or unit number',
  RESIDENTIAL_INCORRECT_ADDRESS: 'The residential address entered appears to be incorrect.',
  RESIDENTIAL_PO_BOX_NOT_ALLOWED: 'PO Box addresses are not allowed as residential addresses.',
  RESIDENTIAL_UNKNOWN: 'The residential address entered appears to be incorrect. Please check the information provided and try again.',
  RESIDENTIAL_UNVERIFIED_ADDRESS: 'Please accept one of the suggested addresses provided earlier.',
  RESIDENTIAL_UNDELIVERABLE: 'The address entered appears to be incorrect. Please check the information provided and try again.',
  USER_ALREADY_EXIST: 'Email is already registered.'
};

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var emailErrorsTypes = {
  CONFIRMATION_EMAIL: {
    description: 'Confirmation email link expired',
    name: 'Confirmation Email'
  },
  RESET_PASSWORD: {
    description: 'Reset password link expired',
    name: 'Reset Password'
  }
};

/* harmony default export */ __webpack_exports__["a"] = (emailErrorsTypes);

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1027)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(615),
  /* template */
  __webpack_require__(2156),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a980416",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1054)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(616),
  /* template */
  __webpack_require__(2182),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7bd33c76",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1000)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(617),
  /* template */
  __webpack_require__(2129),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-292eef6d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(981)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(618),
  /* template */
  __webpack_require__(2109),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-18cec56b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1061)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(626),
  /* template */
  __webpack_require__(2189),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-89d7fbf0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(992)
  __webpack_require__(993)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(633),
  /* template */
  __webpack_require__(2122),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2696f6ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1029)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(686),
  /* template */
  __webpack_require__(2158),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5e13001a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(978)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(699),
  /* template */
  __webpack_require__(2105),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-11de8725",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountTypes; });
var AccountTypes = { // eslint-disable-line import/prefer-default-export
  INDIVIDUAL: {
    component: 'EditIndividualAccount',
    name: 'INDIVIDUAL',
    icon: 'img-profile-default',
    text: 'Individual Investor'
  },
  JOINT_ACCOUNT: {
    component: 'EditJointAccount',
    name: 'JOINT',
    icon: 'img-profile-joint',
    text: 'Joint Account'
  },
  UTMA_UGMA_ACCOUNT: {
    component: 'EditJointAccount',
    name: 'UTMA / UGMA',
    icon: 'img-profile-UGMA',
    text: 'UTMA/UGMA Account'
  },
  ADVISOR: {
    component: 'AccountDetail',
    name: 'ADVISOR',
    icon: 'img-profile-advisor',
    text: 'Financial Advisor'
  },
  ADMIN: {
    component: 'AccountDetail',
    name: 'ADMIN',
    icon: 'img-profile-default-admin',
    text: 'Admin'
  },
  INSTITUTION: {
    component: 'EditInstitutionAccount',
    name: 'INSTITUTION',
    icon: 'img-profile-institution',
    text: 'Institution Account'
  },
  TRUST: {
    component: 'EditTrustAccount',
    name: 'TRUST',
    icon: 'img-profile-trust',
    text: 'Trust Account'
  }
};

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ProhibitedStates = ['CA', 'GA', 'KY', 'LA', 'OH', 'OR'];
/* harmony default export */ __webpack_exports__["a"] = (ProhibitedStates);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__address__ = __webpack_require__(572);



var userProfile = function userProfile() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, userProfile);

  this.firstName = '';
  this.lastName = '';
  this.email = '';
  this.secondaryEmail = '';
  this.socialSecurityNum = '';
  this.primaryPhoneNum = '';
  this.secondaryPhoneNum = '';
  this.dateOfBirth = null;
  this.residentialAddress = new __WEBPACK_IMPORTED_MODULE_1__address__["a" /* default */]();
  this.isResidentDefaultAddress = true;
  this.mailingAddress = new __WEBPACK_IMPORTED_MODULE_1__address__["a" /* default */]();
  this.accountType = 'INDIVIDUAL';
  this.accounts = [];
  this.roles = [];
  this.status = '';
  this.userType = 'INVESTOR';
  this.CRDnumber = '';
  this.organizationName = '';
  this.alternateCompanyName = '';
  this.updateCount = 0;
};

/* harmony default export */ __webpack_exports__["a"] = (userProfile);

/***/ }),
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/calvert-logo.5b96ce4.png";

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(994)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(2123),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-26db51f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1075)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(683),
  /* template */
  __webpack_require__(2202),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c64b14b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1081)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(715),
  /* template */
  __webpack_require__(2208),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e79bd708",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./img-profile-UGMA.svg": 487,
	"./img-profile-advisor.svg": 161,
	"./img-profile-default-admin.svg": 231,
	"./img-profile-default.svg": 123,
	"./img-profile-institution.svg": 488,
	"./img-profile-joint.svg": 489,
	"./img-profile-trust.svg": 490
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 235;

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(2214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Callback__ = __webpack_require__(2027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Callback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Callback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_irAdmin__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_investor__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_recentRecordsTracker__ = __webpack_require__(577);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__router_investor__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__router_irAdmin__["a" /* default */]), [{
    path: '/callback',
    name: 'Callback',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Callback___default.a
  }]),
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.afterEach(function (to) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__router_recentRecordsTracker__["a" /* default */])(to);
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CognitoService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_amazon_cognito_identity_js__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_config__ = __webpack_require__(45);









var CognitoAuth = function () {
  function CognitoAuth() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, CognitoAuth);

    this.cognitoUser = null;
    this.correlationCode = '';
    this.currentEmail = '';
    this.currentPassword = '';
    this.methodUsed = null;
    this.userPool = new __WEBPACK_IMPORTED_MODULE_5_amazon_cognito_identity_js__["a" /* CognitoUserPool */]({
      UserPoolId: __WEBPACK_IMPORTED_MODULE_6__config_config__["e" /* auth */].cognito.userPoolId,
      ClientId: __WEBPACK_IMPORTED_MODULE_6__config_config__["e" /* auth */].cognito.clientId
    });
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(CognitoAuth, [{
    key: 'getCurrentUser',
    value: function getCurrentUser() {
      return this.userPool.getCurrentUser();
    }
  }, {
    key: 'getUserData',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var cognitoUser;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cognitoUser = this.getCurrentUser();
                _context.next = 3;
                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  cognitoUser.getSession(function (err) {
                    if (err) {
                      reject(err);
                    }
                    resolve(true);
                  });
                });

              case 3:
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  cognitoUser.getUserData(function (err, res) {
                    if (err) {
                      reject(err);
                    }
                    var userAttrs = {};
                    res.UserAttributes.forEach(function (attr) {
                      userAttrs[attr.Name] = attr.Value;
                    });
                    resolve(userAttrs);
                  });
                }));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getUserData() {
        return _ref.apply(this, arguments);
      }

      return getUserData;
    }()
  }, {
    key: 'isAuthenticated',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var cognitoUser;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                cognitoUser = this.getCurrentUser();

                if (!cognitoUser) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  cognitoUser.getSession(function (err) {
                    if (err) {
                      return resolve(false);
                    }

                    return resolve(true);
                  });
                }));

              case 3:
                return _context2.abrupt('return', false);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function isAuthenticated() {
        return _ref2.apply(this, arguments);
      }

      return isAuthenticated;
    }()
  }, {
    key: 'login',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(email, password) {
        var _this = this;

        var mfaMethod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'EMAIL';
        var authDetails, setCode, setMethod;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Store credentials for potential resend
                this.currentEmail = email;
                this.currentPassword = password;
                this.methodUsed = mfaMethod;

                authDetails = new __WEBPACK_IMPORTED_MODULE_5_amazon_cognito_identity_js__["b" /* AuthenticationDetails */]({
                  Username: email,
                  Password: password,
                  ValidationData: {
                    mfaMethod: mfaMethod // This becomes clientMetadata in Lambda
                  }
                });


                this.cognitoUser = new __WEBPACK_IMPORTED_MODULE_5_amazon_cognito_identity_js__["c" /* CognitoUser */]({
                  Username: email,
                  Pool: this.userPool
                });

                this.cognitoUser.setAuthenticationFlowType('CUSTOM_AUTH');

                setCode = function setCode(code) {
                  _this.correlationCode = code;
                };

                setMethod = function setMethod(method) {
                  _this.methodUsed = method;
                };

                return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this.cognitoUser.authenticateUser(authDetails, {
                    customChallenge: function customChallenge(challengeParameters) {
                      setCode(challengeParameters.correlationCode);
                      var usedMethod = challengeParameters.method || mfaMethod;
                      setMethod(usedMethod);
                      resolve({
                        status: 'NEEDS_MFA',
                        correlationCode: challengeParameters.correlationCode,
                        methodUsed: usedMethod
                      });
                    },

                    onFailure: function onFailure(err) {
                      reject(err);
                    },
                    onSuccess: function onSuccess(result) {
                      resolve({
                        status: 'SUCCESS',
                        token: result.getIdToken().getJwtToken()
                      });
                    }
                  });
                }));

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function login(_x, _x2) {
        return _ref3.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: 'handleMfa',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(mfaCode) {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this2.cognitoUser.sendCustomChallengeAnswer(mfaCode, {
                    onFailure: function onFailure(err) {
                      reject(err);
                    },
                    onSuccess: function onSuccess(result) {
                      resolve(result.getIdToken().getJwtToken());
                    }
                  }, {
                    correlationCode: _this2.correlationCode
                  });
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleMfa(_x4) {
        return _ref4.apply(this, arguments);
      }

      return handleMfa;
    }()
  }, {
    key: 'resendCode',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(newMethod) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(!this.currentEmail || !this.currentPassword)) {
                  _context5.next = 2;
                  break;
                }

                throw new Error('No active login session to resend code');

              case 2:
                return _context5.abrupt('return', this.login(this.currentEmail, this.currentPassword, newMethod));

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function resendCode(_x5) {
        return _ref5.apply(this, arguments);
      }

      return resendCode;
    }()
  }, {
    key: 'logout',
    value: function logout() {
      var _this3 = this;

      // Clear stored credentials
      this.currentEmail = '';
      this.currentPassword = '';
      this.correlationCode = '';
      this.methodUsed = null;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        return _this3.getCurrentUser().signOut(resolve);
      });
    }
  }, {
    key: 'resetPassword',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(email) {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.cognitoUser = new __WEBPACK_IMPORTED_MODULE_5_amazon_cognito_identity_js__["c" /* CognitoUser */]({
                  Username: email,
                  Pool: this.userPool
                });

                return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this4.cognitoUser.forgotPassword({
                    onSuccess: function onSuccess(result) {
                      resolve(result);
                    },
                    onFailure: function onFailure(err) {
                      reject(err);
                    }
                  });
                }));

              case 2:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function resetPassword(_x6) {
        return _ref6.apply(this, arguments);
      }

      return resetPassword;
    }()
  }, {
    key: 'confirmResetPassword',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(email, verificationCode, newPassword) {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.cognitoUser = new __WEBPACK_IMPORTED_MODULE_5_amazon_cognito_identity_js__["c" /* CognitoUser */]({
                  Username: email,
                  Pool: this.userPool
                });

                return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this5.cognitoUser.confirmPassword(verificationCode, newPassword, {
                    onSuccess: function onSuccess(result) {
                      resolve(result);
                    },
                    onFailure: function onFailure(err) {
                      reject(err);
                    }
                  });
                }));

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function confirmResetPassword(_x7, _x8, _x9) {
        return _ref7.apply(this, arguments);
      }

      return confirmResetPassword;
    }()
  }, {
    key: 'resendConfirmationCode',
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(email) {
        var _this6 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.cognitoUser = new __WEBPACK_IMPORTED_MODULE_5_amazon_cognito_identity_js__["c" /* CognitoUser */]({
                  Username: email,
                  Pool: this.userPool
                });

                return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this6.cognitoUser.resendConfirmationCode(function (err, result) {
                    if (err) {
                      reject(err);
                      return;
                    }
                    resolve(result);
                  });
                }));

              case 2:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function resendConfirmationCode(_x10) {
        return _ref8.apply(this, arguments);
      }

      return resendConfirmationCode;
    }()
  }, {
    key: 'verifyEmail',
    value: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(email, verificationCode) {
        var _this7 = this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.cognitoUser = new __WEBPACK_IMPORTED_MODULE_5_amazon_cognito_identity_js__["c" /* CognitoUser */]({
                  Username: email,
                  Pool: this.userPool
                });

                return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  _this7.cognitoUser.confirmRegistration(verificationCode, true, function (err, result) {
                    if (err) {
                      if (err.name === 'ExpiredCodeException') {
                        resolve(err);
                        return;
                      }

                      reject(err);
                      return;
                    }
                    resolve(result);
                  });
                }));

              case 2:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function verifyEmail(_x11, _x12) {
        return _ref9.apply(this, arguments);
      }

      return verifyEmail;
    }()
  }, {
    key: 'getIdToken',
    value: function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var cognitoUser;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                cognitoUser = this.getCurrentUser();

                if (!(cognitoUser === null)) {
                  _context10.next = 3;
                  break;
                }

                return _context10.abrupt('return', null);

              case 3:
                return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  cognitoUser.getSession(function (err, session) {
                    if (err) return reject(err);

                    if (session.isValid()) {
                      return resolve(session.getIdToken().getJwtToken());
                    }

                    return reject(new Error('Session is invalid'));
                  });
                }));

              case 4:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getIdToken() {
        return _ref10.apply(this, arguments);
      }

      return getIdToken;
    }()
  }], [{
    key: 'install',
    value: function install(Vue) {
      // eslint-disable-next-line no-param-reassign,no-use-before-define
      Vue.prototype.$cognitoAuth = CognitoService;
    }
  }]);

  return CognitoAuth;
}();

/* harmony default export */ __webpack_exports__["a"] = (CognitoAuth);


var CognitoService = new CognitoAuth();

/***/ }),
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TrustTypes = {
  irrevocableTrust: {
    id: 1,
    name: 'irrevocableTrust',
    text: 'Irrevocable trust',
    key: 'IRREVOCABLE_TRUST'
  },
  revocableTrust: {
    id: 2,
    name: 'revocableTrust',
    text: 'Revocable trust',
    key: 'REVOCABLE_TRUST'
  },
  testamentaryTrust: {
    id: 3,
    name: 'testamentaryTrust',
    text: 'Testamentary trust',
    key: 'TESTAMENTARY_TRUST'
  },
  other: {
    id: 7,
    name: 'other',
    text: 'Other',
    key: 'OTHER'
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TrustTypes);

/***/ }),
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQ2IiBoZWlnaHQ9IjI0NiIgdmlld0JveD0iMCAwIDI0NiAyNDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNzguNzAzIDI5SDExMi4zNTJMMTA1LjIzNyAxMDkuMzI3TDExMi4zNTIgMTg5LjY1NEgxNzguNzAzVjI5WiIgZmlsbD0iI0UxRUJGMCIvPgo8cGF0aCBkPSJNNDYgMjlIMTEyLjM1MlYxODkuNjU0SDQ2VjI5WiIgZmlsbD0iI0VDRjBGMSIvPgo8cGF0aCBkPSJNMTg5LjM3NiAzOS42NzI4SDEyMy4wMjVMMTE1LjkxIDEyMEwxMjMuMDI1IDIwMC4zMjdIMTg5LjM3NlYzOS42NzI4WiIgZmlsbD0iI0I0RDJENyIvPgo8cGF0aCBkPSJNNTYuNjczMiAzOS42NzI4SDEyMy4wMjVWMjAwLjMyN0g1Ni42NzMyVjM5LjY3MjhaIiBmaWxsPSIjRTFFQkYwIi8+CjxwYXRoIGQ9Ik0yMDAuMDQ5IDUwLjM0NTdIMTMzLjY5OEwxMjYuNTgyIDEzMC42NzNMMTMzLjY5OCAyMTFIMjAwLjA0OVY1MC4zNDU3WiIgZmlsbD0iI0UxRUJGMCIvPgo8cGF0aCBkPSJNNjcuMzQ2MSA1MC4zNDU3SDEzMy42OThWMjExSDY3LjM0NjFWNTAuMzQ1N1oiIGZpbGw9IiNFQ0YwRjEiLz4KPHBhdGggZD0iTTE3MSAxMzUuNUMxNzEgMTM1LjQ5IDE3MC45OTkgMTM1LjQ4IDE3MC45OTggMTM1LjQ3QzE3MC45ODIgMTE0LjgxIDE1NC4zMzkgOTguMDg2NCAxMzMuNjUyIDk4LjAwMjlDMTMzLjYwMiA5OC4wMDI2IDEzMy41NTEgOTggMTMzLjUgOThIMTMzLjVDMTE2LjY5IDk4LjAwMDMgMTA2Ljk3MSAxMDguOTcyIDEwNi45NzEgMTA4Ljk3MkM5OS43MzI2IDExNi4yMiA5Ni4wMDgzIDEyNS43NzYgOTYuMDAxMyAxMzUuNDczQzk2LjAwMTMgMTM1LjQ4MiA5NiAxMzUuNDkxIDk2IDEzNS41Qzk1Ljk5OTcgMTU2LjE3OSAxMTIuNjg5IDE3MyAxMzMuNSAxNzNIMTMzLjVDMTMzLjUwMSAxNzMgMTMzLjUgMTczIDEzMy41MDEgMTczQzEzMy41NDQgMTczIDEzMy41ODggMTcyLjk5OCAxMzMuNjMxIDE3Mi45OTdDMTU0LjEwMSAxNzIuOTI2IDE3MSAxNTYuNDA4IDE3MSAxMzUuNVpNMTAwLjk0MyAxMzcuOTI3SDEwOS42NUMxMDkuODQ4IDE0Mi44OTggMTEwLjY1NSAxNDcuNjgzIDExMi4wMSAxNTIuMDU4QzExMC41MTYgMTUzLjEwMyAxMDkuMDgzIDE1NC4yNjkgMTA3LjcyMyAxNTUuNTU2QzEwMy43NjIgMTUwLjQ4MSAxMDEuNDIgMTQ0LjM2MSAxMDAuOTQzIDEzNy45MjdaTTEwNy43MiAxMTUuNDQyQzEwOS4wODEgMTE2LjczIDExMC41MTYgMTE3Ljg5NiAxMTIuMDEgMTE4Ljk0MkMxMTAuNjU0IDEyMy4zMTYgMTA5Ljg0OCAxMjguMTAxIDEwOS42NSAxMzMuMDczSDEwMC45NDNDMTAxLjQwNiAxMjYuODA1IDEwMy42NjUgMTIwLjY0NiAxMDcuNzIgMTE1LjQ0MlpNMTU2LjAyIDExMS44NDNDMTU1LjEyOCAxMTIuNjkzIDE1NC4xOTYgMTEzLjQ3NiAxNTMuMjM2IDExNC4yMDVDMTUyLjA3MSAxMTEuNTM2IDE1MC42NzcgMTA5LjAzNSAxNDguOTE5IDEwNi43MTNDMTUxLjQzMSAxMDguMDU3IDE1My43MDMgMTA5LjY1MSAxNTYuMDIgMTExLjg0M1pNMTU5LjI3NyAxNTUuNTU2QzE1Ny45MTYgMTU0LjI2OSAxNTYuNDgzIDE1My4xMDMgMTU0Ljk5IDE1Mi4wNThDMTU2LjM0NSAxNDcuNjg0IDE1Ny4xNTEgMTQyLjg5OSAxNTcuMzUgMTM3LjkyN0gxNjYuMDU3QzE2NS41NzcgMTQ0LjM5IDE2My4yMjEgMTUwLjUwMyAxNTkuMjc3IDE1NS41NTZaTTExOC4wOCAxMDYuNzEzQzExNi4zMTkgMTA5LjAzOSAxMTQuOTI2IDExMS41NDEgMTEzLjc2NCAxMTQuMjA1QzExMi44MDYgMTEzLjQ3NyAxMTEuODc1IDExMi42OTcgMTEwLjk4NSAxMTEuODQ5QzExMy4xMjUgMTA5LjgwOCAxMTUuMzczIDEwOC4xNjIgMTE4LjA4IDEwNi43MTNaTTEzMS4wNzMgMTAzLjEyNlYxMjAuNzM2QzEyNi41MTMgMTIwLjM5OSAxMjIuMDE0IDExOS4xMTIgMTE3Ljg5NiAxMTYuODc1QzEyMC4zNjUgMTEwLjkwNSAxMjQuNzkyIDEwNC41MyAxMzEuMDczIDEwMy4xMjZaTTE0OC45MiAxNjQuMjg3QzE1MC42NzggMTYxLjk2NSAxNTIuMDcxIDE1OS40NjQgMTUzLjIzNiAxNTYuNzk1QzE1NC4xOTYgMTU3LjUyNCAxNTUuMTI4IDE1OC4zMDcgMTU2LjAyIDE1OS4xNTdDMTUzLjY5MiAxNjEuMzU2IDE1MS40MTggMTYyLjk1IDE0OC45MiAxNjQuMjg3Wk0xMzUuOTI3IDE2Ny44NzRWMTUwLjI2NEMxNDAuNDg2IDE1MC42MDEgMTQ0Ljk4NSAxNTEuODg4IDE0OS4xMDQgMTU0LjEyNkMxNDYuNjM1IDE2MC4wOTYgMTQyLjIwNyAxNjYuNDcgMTM1LjkyNyAxNjcuODc0Wk0xMzUuOTI3IDE0NS4zOTVWMTM3LjkyN0gxNTIuNTI2QzE1Mi4zNSAxNDEuODg3IDE1MS43NDkgMTQ1LjgwNiAxNTAuNzEyIDE0OS40NzdDMTQ2LjA2OCAxNDcuMDgzIDE0MS4wMjUgMTQ1LjcyMyAxMzUuOTI3IDE0NS4zOTVaTTEzNS45MjcgMTMzLjA3M1YxMjUuNjA1QzE0MS4wMjUgMTI1LjI3NyAxNDYuMDY4IDEyMy45MTcgMTUwLjcxMiAxMjEuNTIzQzE1MS43NDkgMTI1LjE5NCAxNTIuMzUgMTI5LjExMyAxNTIuNTI2IDEzMy4wNzNIMTM1LjkyN1YxMzMuMDczWk0xMzUuOTI3IDEyMC43MzZWMTAzLjEyNkMxNDIuMjA1IDEwNC41MjkgMTQ2LjYzNCAxMTAuOTAxIDE0OS4xMDQgMTE2Ljg3NEMxNDQuOTg1IDExOS4xMTIgMTQwLjQ4NyAxMjAuMzk5IDEzNS45MjcgMTIwLjczNlpNMTMxLjA3MyAxMjUuNjA1VjEzMy4wNzNIMTE0LjQ3NEMxMTQuNjQ5IDEyOS4xMTMgMTE1LjI1IDEyNS4xOTQgMTE2LjI4NyAxMjEuNTIzQzEyMC45MzIgMTIzLjkxNyAxMjUuOTc1IDEyNS4yNzcgMTMxLjA3MyAxMjUuNjA1Wk0xMzEuMDczIDEzNy45MjdWMTQ1LjM5NUMxMjUuOTc1IDE0NS43MjMgMTIwLjkzMiAxNDcuMDg0IDExNi4yODggMTQ5LjQ3OEMxMTUuMjUxIDE0NS44MDYgMTE0LjY1IDE0MS44ODggMTE0LjQ3NCAxMzcuOTI3TDEzMS4wNzMgMTM3LjkyN1pNMTMxLjA3MyAxNTAuMjY0VjE2Ny44NzRDMTI0Ljc5NCAxNjYuNDcxIDEyMC4zNjYgMTYwLjA5OSAxMTcuODk2IDE1NC4xMjZDMTIyLjAxNCAxNTEuODg4IDEyNi41MTMgMTUwLjYwMSAxMzEuMDczIDE1MC4yNjRaTTExOC4wOCAxNjQuMjg3QzExNS41MTMgMTYyLjkxMyAxMTMuMjI1IDE2MS4yODYgMTEwLjk4NSAxNTkuMTUxQzExMS44NzUgMTU4LjMwMyAxMTIuODA1IDE1Ny41MjIgMTEzLjc2MyAxNTYuNzk1QzExNC45MjggMTU5LjQ2MyAxMTYuMzIyIDE2MS45NjUgMTE4LjA4IDE2NC4yODdaTTE1Ny4zNSAxMzMuMDczQzE1Ny4xNTEgMTI4LjEwMSAxNTYuMzQ1IDEyMy4zMTYgMTU0Ljk5IDExOC45NDFDMTU2LjQ4NCAxMTcuODk2IDE1Ny45MTggMTE2LjczIDE1OS4yNzkgMTE1LjQ0MkMxNjMuMzM0IDEyMC42NDYgMTY1LjU5NCAxMjYuODA1IDE2Ni4wNTYgMTMzLjA3M0gxNTcuMzVWMTMzLjA3M1oiIGZpbGw9IiMwMDc4OEQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tutorial_2.a544055.png";

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img-profile-institution.4da9cb4.svg";

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjQ2cHgiIGhlaWdodD0iMjQ2cHgiIHZpZXdCb3g9IjAgMCAyNDYgMjQ2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1Mi4zICg2NzI5NykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXAgNTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJBY2NvdW50LWF2YXRhcnMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJHcm91cC01IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMy4xNTYyNTAsIC0xLjAwMDAwMCkiPgogICAgICAgICAgICA8cG9seWdvbiBpZD0iUmVjdGFuZ2xlIiBmaWxsPSIjQ0VFNUU4IiBmaWxsLXJ1bGU9Im5vbnplcm8iIHBvaW50cz0iMy4yOTM1MDQ5IDEuNTMxODYyNzUgMjQ4LjM5MTU0NCAxLjUzMTg2Mjc1IDI0OC4zOTE1NDQgMjQ2LjYyOTkwMiAzLjI5MzUwNDkgMjQ2LjYyOTkwMiI+PC9wb2x5Z29uPgogICAgICAgICAgICA8cG9seWdvbiBpZD0iVCIgZmlsbD0iIzEzN0Q4RiIgcG9pbnRzPSIxNDkuMDM0MzE0IDIwNS4wMzk4MjggMTA3LjQ0NjA3OCAyMDUuMDM5ODI4IDEwNy40NDYwNzggMTAzLjk1MTU5MyA3MC41OTMxMzcyIDEwMy45NTE1OTMgNzAuNTkzMTM3MiA2Ny43MTYyOTkgMTg1LjY4MTM3MiA2Ny43MTYyOTkgMTg1LjY4MTM3MiAxMDMuOTUxNTkzIDE0OS4wMzQzMTQgMTAzLjk1MTU5MyI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1031)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(619),
  /* template */
  __webpack_require__(2160),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6334279b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(995)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(622),
  /* template */
  __webpack_require__(2124),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-27006fb9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(974)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(634),
  /* template */
  __webpack_require__(2100),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06fcf640",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1015)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(667),
  /* template */
  __webpack_require__(2144),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-475f14a4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(681),
  /* template */
  __webpack_require__(2112),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(984)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(682),
  /* template */
  __webpack_require__(2113),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-217c3820",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1067)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(707),
  /* template */
  __webpack_require__(2195),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b3985d1e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1036)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(708),
  /* template */
  __webpack_require__(2165),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-69a61822",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 499 */,
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(127);





/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(request) {
    var currentDwollaCustomerId, payload, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            currentDwollaCustomerId = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.fundingSource.currentDwollaCustomerId;
            payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request, { dwollaCustomerId: currentDwollaCustomerId });
            _context.next = 5;
            return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('fundingSource/getClientToken', payload);

          case 5:
            response = _context.sent;
            return _context.abrupt('return', response);

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](0);

            console.error('Error fetching Dwolla client token:', _context.t0);
            throw _context.t0;

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 9]]);
  }));

  function fetchClientToken(_x) {
    return _ref.apply(this, arguments);
  }

  return fetchClientToken;
})());

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constantToTitleCase;
function constantToTitleCase(value) {
  if (!value) return '';
  return value.toLowerCase().replace(/_(.)/g, function (_, c) {
    return ' ' + c.toLowerCase();
  }).replace(/^./, function (c) {
    return c.toUpperCase();
  });
}

/***/ }),
/* 502 */,
/* 503 */,
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1037)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(2166),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_auth0_js__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_auth0_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_auth0_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_config__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_static_logActions__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(127);




/* eslint class-methods-use-this: ["error",
{ "exceptMethods": ["isAuthenticated", "setSession"] }] */










var AuthService = function () {
  function AuthService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AuthService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AuthService, null, [{
    key: 'register',
    value: function register(registerForm) {
      return __WEBPACK_IMPORTED_MODULE_8__api_HttpService__["a" /* default */].postV2('users/register', registerForm);
    }
  }, {
    key: 'setSession',
    value: function setSession(authResult) {
      var expiresAt = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(authResult.expiresIn * 1000 + new Date().getTime());
      sessionStorage.setItem('access_token', authResult.accessToken);
      sessionStorage.setItem('id_token', authResult.idToken);
      sessionStorage.setItem('expires_at', expiresAt);
    }
  }, {
    key: 'checkMfaRequired',
    value: function checkMfaRequired(loginError) {
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(loginError, 'statusCode', false) === 403 && __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(loginError, 'code', false) === 'mfa_required';
    }
  }, {
    key: 'challengeMfa',
    value: function challengeMfa() {
      return __WEBPACK_IMPORTED_MODULE_8__api_HttpService__["a" /* default */].post('/mfa/challenge', {
        mfaToken: sessionStorage.getItem('mfa_token')
      }).then(function (response) {
        sessionStorage.setItem('oob_code', response.oob_code);
      });
    }
  }, {
    key: 'handleMfa',
    value: function handleMfa(_ref) {
      var _this = this;

      var mfaCode = _ref.mfaCode;

      return __WEBPACK_IMPORTED_MODULE_6_axios___default()({
        method: 'POST',
        url: 'https://' + __WEBPACK_IMPORTED_MODULE_7__config_config__["e" /* auth */].domain + '/oauth/token',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          grant_type: 'http://auth0.com/oauth/grant-type/mfa-oob',
          mfa_token: sessionStorage.getItem('mfa_token'),
          oob_code: sessionStorage.getItem('oob_code'),
          binding_code: mfaCode,
          client_id: __WEBPACK_IMPORTED_MODULE_7__config_config__["e" /* auth */].clientId
        }
      }).then(function (res) {
        var _res$data = res.data,
            access_token = _res$data.access_token,
            id_token = _res$data.id_token,
            expires_in = _res$data.expires_in;

        _this.setSession({
          expiresIn: expires_in,
          accessToken: access_token,
          idToken: id_token
        });
        sessionStorage.removeItem('mfa_token');
        sessionStorage.removeItem('oob_code');
      }).catch(function (e) {
        throw __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(e, ['response', 'data']);
      });
    }
  }, {
    key: 'logIn',
    value: function logIn(_ref2) {
      var _this2 = this;

      var email = _ref2.email,
          password = _ref2.password;

      var webAuth = new __WEBPACK_IMPORTED_MODULE_4_auth0_js___default.a.WebAuth({
        domain: __WEBPACK_IMPORTED_MODULE_7__config_config__["e" /* auth */].domain,
        clientID: __WEBPACK_IMPORTED_MODULE_7__config_config__["e" /* auth */].clientId,
        audience: __WEBPACK_IMPORTED_MODULE_7__config_config__["e" /* auth */].audience,
        responseType: 'token id_token'
      });
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        webAuth.client.login({
          username: email,
          password: password,
          realm: __WEBPACK_IMPORTED_MODULE_7__config_config__["e" /* auth */].connection,
          scope: 'openid email'
        }, function (err, authResult) {
          if (err) {
            if (_this2.checkMfaRequired(err)) {
              sessionStorage.setItem('mfa_token', __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(err, ['original', 'response', 'body', 'mfa_token']));
              _this2.challengeMfa().then(function () {
                resolve({ needsMfa: true });
              });
              return;
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["m" /* logAction */])({
              action: __WEBPACK_IMPORTED_MODULE_10__data_static_logActions__["a" /* default */].LOGIN_FAILED.name,
              tags: [__WEBPACK_IMPORTED_MODULE_9__util__["x" /* logglyTags */].auth0],
              message: 'User failed to log in as ' + email,
              level: 'info'
            });
            reject(err);
            return;
          }
          if (authResult && authResult.accessToken && authResult.idToken) {
            _this2.setSession(authResult);
            resolve(authResult);
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["m" /* logAction */])({
              action: __WEBPACK_IMPORTED_MODULE_10__data_static_logActions__["a" /* default */].LOGIN_FAILED.name,
              tags: [__WEBPACK_IMPORTED_MODULE_9__util__["x" /* logglyTags */].auth0],
              message: 'User failed to log in as ' + email,
              level: 'info'
            });
            reject(new Error('Missing token'));
          }
        });
      });
    }
  }, {
    key: 'logOut',
    value: function logOut() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store__["b" /* resetState */])();
      sessionStorage.removeItem('access_token');
      sessionStorage.removeItem('id_token');
      sessionStorage.removeItem('expires_at');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    }
  }, {
    key: 'resetPassword',
    value: function resetPassword(_ref3) {
      var email = _ref3.email;

      var webAuth = new __WEBPACK_IMPORTED_MODULE_4_auth0_js___default.a.WebAuth({
        domain: __WEBPACK_IMPORTED_MODULE_7__config_config__["e" /* auth */].domain,
        clientID: __WEBPACK_IMPORTED_MODULE_7__config_config__["e" /* auth */].clientId,
        audience: __WEBPACK_IMPORTED_MODULE_7__config_config__["e" /* auth */].audience,
        responseType: 'token id_token'
      });
      var connection = __WEBPACK_IMPORTED_MODULE_7__config_config__["e" /* auth */].connection;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        webAuth.changePassword({
          connection: connection,
          email: email
        }, function (err, resp) {
          if (err) {
            reject(err);
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["m" /* logAction */])({
              message: 'Password reset requested ' + email,
              action: __WEBPACK_IMPORTED_MODULE_10__data_static_logActions__["a" /* default */].PASSWORD_RESET.name,
              tags: [__WEBPACK_IMPORTED_MODULE_9__util__["x" /* logglyTags */].auth0],
              level: 'info'
            });
            resolve(resp);
          }
        });
      });
    }
  }]);

  return AuthService;
}();

/* harmony default export */ __webpack_exports__["a"] = (AuthService);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ScanNotReadable: 'The document was blurred, parts were cut off, or was not readable due to glare',
  ScanNotUploaded: 'A document was uploaded, but it was not an ID',
  ScanIdTypeNotSupported: 'An ID was uploaded, but it is not a form of ID we accept',
  ScanNameMismatch: 'The name on the ID does not match the name on the account',
  default: 'Please try again with a different document'
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var InstitutionTypes = {
  bank: {
    id: 1,
    name: 'bank',
    text: 'Bank',
    key: 'BANK'
  },
  nonBankFinancialInstitution: {
    id: 2,
    name: 'nonBankFinancialInstitution',
    text: 'Non-bank financial institution',
    key: 'NON_BANK_FINANCIAL_INSTITUTION'
  },
  business: {
    id: 3,
    name: 'business',
    text: 'Business',
    key: 'BUSINESS'
  },
  faithBased: {
    id: 4,
    name: 'faithBased',
    text: 'Faith-based',
    key: 'FAITH_BASED'
  },
  foundation: {
    id: 5,
    name: 'foundation',
    text: 'Foundation',
    key: 'FOUNDATION'
  },
  nonProfit: {
    id: 6,
    name: 'nonProfit',
    text: 'Non-profit',
    key: 'NON_PROFIT'
  },
  other: {
    id: 7,
    name: 'other',
    text: 'Other',
    key: 'OTHER'
  }
};

/* harmony default export */ __webpack_exports__["a"] = (InstitutionTypes);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var restrictedStates = {
  AR: {
    id: 0,
    name: 'AR'
  }
};

/* harmony default export */ __webpack_exports__["a"] = (restrictedStates);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var address = function address() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, address);

  this.streetAddress1 = '';
  this.streetAddress2 = '';
  this.zipCode = '';
  this.city = '';
  this.state = '';
  this.country = '';
};

/* harmony default export */ __webpack_exports__["a"] = (address);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var transactionDetail = function transactionDetail() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, transactionDetail);

  this.noteNumber = '';
  this.note = {
    interestRate: 0
  };
  this.user = {
    name: ''
  };
  this.amount = 0;
  this.createdAt = '';
  this.updatedAt = '';
  this.dwollaTransferId = '';
  this.status = '';
  this.failureReason = '';
};

/* harmony default export */ __webpack_exports__["a"] = (transactionDetail);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_primevue_resources_themes_saga_blue_theme_css__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_primevue_resources_themes_saga_blue_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_primevue_resources_themes_saga_blue_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_primevue_resources_primevue_min_css__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_primevue_resources_primevue_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_primevue_resources_primevue_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_polyfill__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_whatwg_fetch__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_loader__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_bootstrap_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_primevue_config__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_primevue_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_primevue_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_bootstrap_datetimepicker__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_v_money__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_dwolla__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_pc_bootstrap4_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_directive_tooltip__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_directive_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_directive_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_directive_tooltip_dist_vueDirectiveTooltip_css__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_directive_tooltip_dist_vueDirectiveTooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_directive_tooltip_dist_vueDirectiveTooltip_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__App__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__router__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__config_config__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__services_cognito__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_filters__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__theme_main_css__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__theme_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__theme_main_css__);



var _this = this;

var isLoggedInUserAnAdmin = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return isAuthenticated();

          case 2:
            if (!_context2.sent) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].state.app.irAdmin || __WEBPACK_IMPORTED_MODULE_23__api_HttpService__["a" /* default */].getV2('users/user').then(function (user) {
              var roles = user.roles;

              __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('app/SET_IR_ADMIN_ROLE', roles.includes('IR_ADMIN'));
              __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('app/SET_USER', user);
              return __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].state.app.irAdmin;
            }));

          case 4:
            __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].commit('app/SET_IR_ADMIN_ROLE', false);
            return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */].state.app.irAdmin);

          case 6:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function isLoggedInUserAnAdmin() {
    return _ref2.apply(this, arguments);
  };
}();

var isInvestorTryingToGetAdminRoute = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(route) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.t0 = routeRequiresAdminRole(route);

            if (!_context3.t0) {
              _context3.next = 5;
              break;
            }

            _context3.next = 4;
            return isLoggedInUserAnAdmin();

          case 4:
            _context3.t0 = !_context3.sent;

          case 5:
            return _context3.abrupt('return', _context3.t0);

          case 6:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function isInvestorTryingToGetAdminRoute(_x) {
    return _ref3.apply(this, arguments);
  };
}();

var isAdminTryingToGetInvestorRoute = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(route) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.t0 = !routeRequiresAdminRole(route);

            if (!_context4.t0) {
              _context4.next = 5;
              break;
            }

            _context4.next = 4;
            return isLoggedInUserAnAdmin();

          case 4:
            _context4.t0 = _context4.sent;

          case 5:
            return _context4.abrupt('return', _context4.t0);

          case 6:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function isAdminTryingToGetInvestorRoute(_x2) {
    return _ref4.apply(this, arguments);
  };
}();














 // eslint-disable-line import/no-extraneous-dependencies











window.fetchClientToken = __WEBPACK_IMPORTED_MODULE_14__services_dwolla__["a" /* default */];

var VueInputMask = __webpack_require__(513).default;

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon___default.a);

// Make HttpService available as this.$http in components
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_23__api_HttpService__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_22__services_cognito__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_bootstrap_datetimepicker___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(VueInputMask);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_v_money___default.a, { precision: 2 });
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_16_vue_directive_tooltip___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_primevue_config__);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('constantToTitleCase', __WEBPACK_IMPORTED_MODULE_24__util_filters__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_20__router__["a" /* default */].beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  next();
});

var isAuthenticated = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$cognitoAuth.isAuthenticated());

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function isAuthenticated() {
    return _ref.apply(this, arguments);
  };
}();

function routeRequiresAdminRole(route) {
  return route.meta.requiresIrAdminRole || false;
}

__WEBPACK_IMPORTED_MODULE_20__router__["a" /* default */].beforeResolve(function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(to, from, next) {
    var notProtectedRoutes;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            notProtectedRoutes = ['Login', 'Registration', 'ResetPassword', 'ErrorAuth', 'EmbedLogin', 'VerifyEmail', 'ChangePassword'];
            _context5.next = 3;
            return isInvestorTryingToGetAdminRoute(to);

          case 3:
            if (!_context5.sent) {
              _context5.next = 7;
              break;
            }

            next('/home');
            _context5.next = 23;
            break;

          case 7:
            _context5.next = 9;
            return isAdminTryingToGetInvestorRoute(to);

          case 9:
            if (!_context5.sent) {
              _context5.next = 13;
              break;
            }

            next('/users');
            _context5.next = 23;
            break;

          case 13:
            _context5.next = 15;
            return isAuthenticated();

          case 15:
            _context5.t0 = !_context5.sent;

            if (!_context5.t0) {
              _context5.next = 18;
              break;
            }

            _context5.t0 = !notProtectedRoutes.includes(to.name);

          case 18:
            if (!_context5.t0) {
              _context5.next = 22;
              break;
            }

            next('/login');
            _context5.next = 23;
            break;

          case 22:
            next();

          case 23:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function (_x3, _x4, _x5) {
    return _ref5.apply(this, arguments);
  };
}());

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_18__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_20__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_19__App___default.a);
  }
});

var _LTracker = global._LTracker = global._LTracker || []; // eslint-disable-line
_LTracker.push({ // eslint-disable-line
  logglyKey: __WEBPACK_IMPORTED_MODULE_21__config_config__["a" /* loggly */].logglyKey,
  sendConsoleErrors: true
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AccountCreation__ = __webpack_require__(2014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AccountCreation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AccountCreation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AccountSuspended__ = __webpack_require__(2020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AccountSuspended___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AccountSuspended__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UpcomingTransactionsForInvestor__ = __webpack_require__(2078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UpcomingTransactionsForInvestor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_UpcomingTransactionsForInvestor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EditUserProfile__ = __webpack_require__(2037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EditUserProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_EditUserProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_EditUserProfileByAdvisor__ = __webpack_require__(2038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_EditUserProfileByAdvisor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_EditUserProfileByAdvisor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_InvestorPreferences__ = __webpack_require__(2052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_InvestorPreferences___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_InvestorPreferences__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Registration__ = __webpack_require__(2065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Registration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Registration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Login__ = __webpack_require__(2054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Home__ = __webpack_require__(2046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ResetPassword__ = __webpack_require__(2066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ResetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_ResetPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ChangePassword__ = __webpack_require__(2028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ChangePassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ChangePassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_VerifyEmail__ = __webpack_require__(2083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_VerifyEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_VerifyEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AddFundingSource__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AddFundingSource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_AddFundingSource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_PurchaseNote__ = __webpack_require__(2062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_PurchaseNote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_PurchaseNote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_NotesList__ = __webpack_require__(2059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_NotesList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_NotesList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_MicroDepositsVerification__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_MicroDepositsVerification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_MicroDepositsVerification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_KbaVerification__ = __webpack_require__(2053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_KbaVerification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_KbaVerification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_AccountSummary__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_AccountSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_AccountSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_DocumentUpload__ = __webpack_require__(2031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_DocumentUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_DocumentUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_AccountDocuments__ = __webpack_require__(2018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_AccountDocuments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_AccountDocuments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_InvestorAccountDetails__ = __webpack_require__(2049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_InvestorAccountDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_InvestorAccountDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ErrorAuth__ = __webpack_require__(2040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ErrorAuth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_ErrorAuth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_InvestorCommunicationPreferences__ = __webpack_require__(2050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_InvestorCommunicationPreferences___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_InvestorCommunicationPreferences__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_InvestorPaymentPreferences__ = __webpack_require__(2051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_InvestorPaymentPreferences___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_InvestorPaymentPreferences__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_EmbedLogin__ = __webpack_require__(2039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_EmbedLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_EmbedLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_FeedbackSurvey__ = __webpack_require__(2045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_FeedbackSurvey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_FeedbackSurvey__);



























/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/embed-login',
  name: 'EmbedLogin',
  component: __WEBPACK_IMPORTED_MODULE_24__components_EmbedLogin___default.a
}, {
  path: '/',
  name: 'Registration',
  component: __WEBPACK_IMPORTED_MODULE_6__components_Registration___default.a
}, {
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_7__components_Login___default.a
}, {
  path: '/home',
  name: 'Home',
  component: __WEBPACK_IMPORTED_MODULE_8__components_Home___default.a
}, {
  path: '/reset-password',
  name: 'ResetPassword',
  component: __WEBPACK_IMPORTED_MODULE_9__components_ResetPassword___default.a
}, {
  path: '/change-password',
  name: 'ChangePassword',
  component: __WEBPACK_IMPORTED_MODULE_10__components_ChangePassword___default.a
}, {
  path: '/verify-email',
  name: 'VerifyEmail',
  component: __WEBPACK_IMPORTED_MODULE_11__components_VerifyEmail___default.a
}, {
  path: '/account-summary',
  name: 'AccountSummary',
  component: __WEBPACK_IMPORTED_MODULE_17__components_AccountSummary___default.a
}, {
  path: '/account-creation',
  name: 'AccountCreation',
  component: __WEBPACK_IMPORTED_MODULE_0__components_AccountCreation___default.a
}, {
  path: '/upcoming-transactions',
  name: 'UpcomingTransactionsForInvestor',
  component: __WEBPACK_IMPORTED_MODULE_2__components_UpcomingTransactionsForInvestor___default.a
}, {
  path: '/funding-sources',
  name: 'AddFundingSource',
  component: __WEBPACK_IMPORTED_MODULE_12__components_AddFundingSource___default.a
}, {
  path: '/funding-sources/:id/micro-deposits',
  name: 'MicroDepositsVerification',
  component: __WEBPACK_IMPORTED_MODULE_15__components_MicroDepositsVerification___default.a
}, {
  path: '/kba',
  name: 'KbaVerification',
  component: __WEBPACK_IMPORTED_MODULE_16__components_KbaVerification___default.a
}, {
  path: '/notes/purchase',
  name: 'PurchaseNote',
  component: __WEBPACK_IMPORTED_MODULE_13__components_PurchaseNote___default.a
}, {
  path: '/notes',
  name: 'Notes',
  component: __WEBPACK_IMPORTED_MODULE_14__components_NotesList___default.a
}, {
  path: '/investor-impact-preferences',
  name: 'InvestorPreferences',
  component: __WEBPACK_IMPORTED_MODULE_5__components_InvestorPreferences___default.a
}, {
  path: '/account-suspended',
  name: 'AccountSuspended',
  component: __WEBPACK_IMPORTED_MODULE_1__components_AccountSuspended___default.a
}, {
  path: '/edit-user-profile',
  name: 'EditUserProfile',
  component: __WEBPACK_IMPORTED_MODULE_3__components_EditUserProfile___default.a
}, {
  path: '/edit-user-profile-by-advisor',
  name: 'EditUserProfileByAdvisor',
  component: __WEBPACK_IMPORTED_MODULE_4__components_EditUserProfileByAdvisor___default.a
}, {
  path: '/documents',
  name: 'DocumentUpload',
  component: __WEBPACK_IMPORTED_MODULE_18__components_DocumentUpload___default.a
}, {
  path: '/account-documents',
  name: 'AccountDocuments',
  component: __WEBPACK_IMPORTED_MODULE_19__components_AccountDocuments___default.a
}, {
  path: '/accounts/:id/details',
  name: 'InvestorAccountDetails',
  component: __WEBPACK_IMPORTED_MODULE_20__components_InvestorAccountDetails___default.a
}, {
  path: '/error',
  name: 'ErrorAuth',
  component: __WEBPACK_IMPORTED_MODULE_21__components_ErrorAuth___default.a
}, {
  path: '/investor-communication-preferences',
  name: 'InvestorCommunicationPreferences',
  component: __WEBPACK_IMPORTED_MODULE_22__components_InvestorCommunicationPreferences___default.a
}, {
  path: '/investor-payment-preferences',
  name: 'InvestorPaymentPreferences',
  component: __WEBPACK_IMPORTED_MODULE_23__components_InvestorPaymentPreferences___default.a
}, {
  path: '/feedback',
  name: 'FeedbackSurvey',
  component: __WEBPACK_IMPORTED_MODULE_25__components_FeedbackSurvey___default.a
}]);

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AccountCreationAdmin__ = __webpack_require__(2015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AccountCreationAdmin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AccountCreationAdmin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AccountCreationOrganization__ = __webpack_require__(2016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AccountCreationOrganization___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AccountCreationOrganization__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AccountDetail__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AccountDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AccountDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_EditIndividualAccount__ = __webpack_require__(2033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_EditIndividualAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_EditIndividualAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_EditInstitutionAccount__ = __webpack_require__(2034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_EditInstitutionAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_EditInstitutionAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_EditTrustAccount__ = __webpack_require__(2036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_EditTrustAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_EditTrustAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_EditJointAccount__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_EditJointAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_EditJointAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FailedTransactionDetail__ = __webpack_require__(2042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FailedTransactionDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_FailedTransactionDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_FailedTransactionList__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_FailedTransactionList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_FailedTransactionList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AdminSettings__ = __webpack_require__(2024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AdminSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_AdminSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_IRAdmin__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_IRAdmin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_IRAdmin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_NoteDetail__ = __webpack_require__(2058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_NoteDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_NoteDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_PurchaseInvestmentNote__ = __webpack_require__(2061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_PurchaseInvestmentNote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_PurchaseInvestmentNote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Redeem__ = __webpack_require__(2064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Redeem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Redeem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_FailTransaction__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_FailTransaction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_FailTransaction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Transfer__ = __webpack_require__(2073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Transfer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Transfer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_AddFunds__ = __webpack_require__(2022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_AddFunds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_AddFunds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_UserCreationByAdmin__ = __webpack_require__(2079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_UserCreationByAdmin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_UserCreationByAdmin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_UserDetail__ = __webpack_require__(2080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_UserDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_UserDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_EditFinancialAdvisor__ = __webpack_require__(2032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_EditFinancialAdvisor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_EditFinancialAdvisor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Users__ = __webpack_require__(2082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_RetryPayment__ = __webpack_require__(2067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_RetryPayment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_RetryPayment__);
























var adminRoutes = [{
  path: '/transactions',
  name: 'FailedTransactionList',
  component: __WEBPACK_IMPORTED_MODULE_9__components_FailedTransactionList___default.a
}, {
  path: '/settings',
  name: 'AdminSettings',
  component: __WEBPACK_IMPORTED_MODULE_10__components_AdminSettings___default.a
}, {
  path: '/users',
  name: 'Users',
  component: __WEBPACK_IMPORTED_MODULE_21__components_Users___default.a
}, {
  path: '/admin',
  name: 'IRAdmin',
  component: __WEBPACK_IMPORTED_MODULE_11__components_IRAdmin___default.a
}, {
  path: '/user-creation-by-admin',
  name: 'UserCreationByAdmin',
  component: __WEBPACK_IMPORTED_MODULE_18__components_UserCreationByAdmin___default.a
}, {
  path: '/users/:name/user-detail/:userId/account-creation-admin/:accountType',
  name: 'AccountCreationAdmin',
  component: __WEBPACK_IMPORTED_MODULE_1__components_AccountCreationAdmin___default.a
}, {
  path: '/users/:name/user-detail/:userId',
  name: 'UserDetail',
  component: __WEBPACK_IMPORTED_MODULE_19__components_UserDetail___default.a
}, {
  path: '/users/:name/edit-financial-advisor/:userId',
  name: 'EditFinancialAdvisor',
  component: __WEBPACK_IMPORTED_MODULE_20__components_EditFinancialAdvisor___default.a
}, {
  path: '/users/:name/user-detail/:userId/account-detail/:accountId/purchase-investment-note',
  name: 'PurchaseInvestmentNote',
  component: __WEBPACK_IMPORTED_MODULE_13__components_PurchaseInvestmentNote___default.a
}, {
  path: '/users/:name/user-detail/:userId/account-detail/:accountId',
  name: 'AccountDetail',
  component: __WEBPACK_IMPORTED_MODULE_3__components_AccountDetail___default.a
}, {
  path: '/users/:name/user-detail/:userId/individual-account-detail/:accountId',
  name: 'EditIndividualAccount',
  component: __WEBPACK_IMPORTED_MODULE_4__components_EditIndividualAccount___default.a
}, {
  path: '/users/:name/user-detail/:userId/institution-account-detail/:accountId',
  name: 'EditInstitutionAccount',
  component: __WEBPACK_IMPORTED_MODULE_5__components_EditInstitutionAccount___default.a
}, {
  path: '/users/:name/user-detail/:userId/trust-account-detail/:accountId',
  name: 'EditTrustAccount',
  component: __WEBPACK_IMPORTED_MODULE_6__components_EditTrustAccount___default.a
}, {
  path: '/users/:name/user-detail/:userId/joint-account-detail/:accountId',
  name: 'EditJointAccount',
  component: __WEBPACK_IMPORTED_MODULE_7__components_EditJointAccount___default.a
}, {
  path: '/users/:name/user-detail/:userId/note-detail/:noteId',
  name: 'NoteDetail',
  component: __WEBPACK_IMPORTED_MODULE_12__components_NoteDetail___default.a
}, {
  path: '/users/:name/user-detail/:userId/accounts/:accountId/redeem/:noteId',
  name: 'Redeem',
  component: __WEBPACK_IMPORTED_MODULE_14__components_Redeem___default.a
}, {
  path: '/users/:name/user-detail/:userId/note-detail/:noteId/fail-transaction/:transactionId',
  name: 'FailTransaction',
  component: __WEBPACK_IMPORTED_MODULE_15__components_FailTransaction___default.a
}, {
  path: '/users/:name/user-detail/:userId/transfer/:noteId',
  name: 'Transfer',
  component: __WEBPACK_IMPORTED_MODULE_16__components_Transfer___default.a
}, {
  path: '/users/:name/user-detail/:userId/add-funds/:noteId',
  name: 'AddFunds',
  component: __WEBPACK_IMPORTED_MODULE_17__components_AddFunds___default.a
}, {
  path: '/users/:name/user-detail/:userId/account-creation-organization/:accountType',
  name: 'AccountCreationOrganization',
  component: __WEBPACK_IMPORTED_MODULE_2__components_AccountCreationOrganization___default.a
}, {
  path: '/transaction-detail/:id',
  name: 'FailedTransactionDetail',
  component: __WEBPACK_IMPORTED_MODULE_8__components_FailedTransactionDetail___default.a
}, {
  path: '/transaction/retry',
  name: 'RetryFailedTransaction',
  component: __WEBPACK_IMPORTED_MODULE_22__components_RetryPayment___default.a
}];

var adminRoutesMeta = {
  meta: {
    requiresIrAdminRole: true
  }
};

/* harmony default export */ __webpack_exports__["a"] = (adminRoutes.map(function (route) {
  var routeWithMetadata = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(route, adminRoutesMeta);
  return routeWithMetadata;
}));

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trackRecentRecord;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_HttpService__ = __webpack_require__(20);



var ROUTE_RECORD_MAP = {
  UserDetail: { type: 'user', param: 'userId' },
  EditFinancialAdvisor: { type: 'user', param: 'userId' },
  AccountDetail: { type: 'account', param: 'accountId' },
  EditIndividualAccount: { type: 'account', param: 'accountId' },
  EditInstitutionAccount: { type: 'account', param: 'accountId' },
  EditTrustAccount: { type: 'account', param: 'accountId' },
  EditJointAccount: { type: 'account', param: 'accountId' },
  NoteDetail: { type: 'note', param: 'noteId' }
};

function trackRecentRecord(to) {
  var mapping = ROUTE_RECORD_MAP[to.name];
  if (!mapping) return;

  var recordId = parseInt(to.params[mapping.param], 10);
  if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(recordId) || recordId <= 0) return;

  __WEBPACK_IMPORTED_MODULE_1__api_HttpService__["a" /* default */].postV2('recent-records', {
    recordType: mapping.type,
    recordId: recordId
  }).catch(function () {});
}

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutation_types__ = __webpack_require__(8);





var _mutations;






/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    settingDefaultFundingSource: false,
    notificationStatus: 'init'
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["O" /* SET_DEFAULT_FUNDING_SOURCE */], function (state) {
    state.settingDefaultFundingSource = true;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["P" /* STOP_SET_DEFAULT_FUNDING_SOURCE */], function (state) {
    state.settingDefaultFundingSource = false;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["M" /* ENABLE_SUBMIT_SEARCH */], function (state) {
    state.disableSubmitSearch = false;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["N" /* DISABLE_SUBMIT_SEARCH */], function (state) {
    state.disableSubmitSearch = true;
  }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["Q" /* SET_NOTIFICATION_STATUS */], function (state, value) {
    if (state.notificationStatus !== 'NONE' || value === 'init') {
      state.notificationStatus = value;
    }
  }), _mutations),
  actions: {
    setDefaultFundingSource: function setDefaultFundingSource(_ref, _ref2) {
      var commit = _ref.commit;
      var accountId = _ref2.accountId,
          fundingSourceId = _ref2.fundingSourceId;

      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["O" /* SET_DEFAULT_FUNDING_SOURCE */]);
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('accounts/' + accountId, {
        defaultFundingSourceId: fundingSourceId
      }).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["P" /* STOP_SET_DEFAULT_FUNDING_SOURCE */]);
        return response;
      }).catch(function (error) {
        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["P" /* STOP_SET_DEFAULT_FUNDING_SOURCE */]);
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    updateAccountPaymentPreference: function updateAccountPaymentPreference(_ref3, _ref4) {
      var commit = _ref3.commit;
      var accountId = _ref4.accountId,
          paymentPreference = _ref4.paymentPreference;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('/accounts/' + accountId, { paymentPreference: paymentPreference }).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getAccount: function getAccount(_ref5, accountId) {
      var commit = _ref5.commit;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getAccountUsers: function getAccountUsers(_ref6, accountId) {
      var commit = _ref6.commit;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId + '/users').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getAccountEmails: function getAccountEmails(_ref7, accountId) {
      var commit = _ref7.commit;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId + '/emails').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getAccountOrganizations: function getAccountOrganizations(_ref8, accountId) {
      var commit = _ref8.commit;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId + '/organizations').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getAccountNotes: function getAccountNotes(_ref9, accountId) {
      var commit = _ref9.commit;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId + '/notes').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getAccountNoteTransactions: function getAccountNoteTransactions(_ref10, _ref11) {
      var commit = _ref10.commit;
      var accountId = _ref11.accountId,
          noteId = _ref11.noteId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId + '/notes/' + noteId + '/transactions').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getAccountSummaryReport: function getAccountSummaryReport(_ref12, _ref13) {
      var commit = _ref12.commit;
      var accountId = _ref13.accountId,
          withAccruedInterest = _ref13.withAccruedInterest;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId + '/notes/summary-report?accrued=' + withAccruedInterest.toString()).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getDocumentFromS3: function getDocumentFromS3(_ref14, _ref15) {
      var _this = this;

      var commit = _ref14.commit;
      var presignedUrl = _ref15.presignedUrl;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(presignedUrl, {
                  responseType: 'arraybuffer'
                }).catch(function (err) {
                  throw err;
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getAccountImpactPreferences: function getAccountImpactPreferences(_ref16, accountId) {
      var commit = _ref16.commit;
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId + '/impact-preferences', params).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    deleteAccountUser: function deleteAccountUser(_ref17, _ref18) {
      var commit = _ref17.commit;
      var accountId = _ref18.accountId,
          userId = _ref18.userId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].deleteV2('/accounts/' + accountId + '/users/' + userId).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getAccountFundingSources: function getAccountFundingSources(_ref19, accountId) {
      var commit = _ref19.commit;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId + '/funding-sources').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    updateImpactPreferences: function updateImpactPreferences(_ref20, _ref21) {
      var commit = _ref20.commit;
      var accountId = _ref21.accountId,
          selectedPreferences = _ref21.selectedPreferences;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].put('accounts/' + accountId + '/impact-preferences', selectedPreferences).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    updatePreferences: function updatePreferences(_ref22, _ref23) {
      var commit = _ref22.commit;
      var accountId = _ref23.accountId,
          payload = _ref23.payload;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].put('accounts/' + accountId + '/preferences', payload).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    updateAccount: function updateAccount(_ref24, _ref25) {
      var commit = _ref24.commit;
      var accountId = _ref25.accountId,
          payload = _ref25.payload;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('accounts/' + accountId, payload).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    updateAccountPreferences: function updateAccountPreferences(_ref26, _ref27) {
      var commit = _ref26.commit;
      var accountId = _ref27.accountId,
          payload = _ref27.payload;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('accounts/' + accountId + '/preferences', payload);
    },
    updateAuthAccount: function updateAuthAccount(_ref28, _ref29) {
      var commit = _ref28.commit;
      var clientId = _ref29.clientId,
          payload = _ref29.payload;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('auth/' + clientId, payload).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    updateAccountImpactPreferences: function updateAccountImpactPreferences(_ref30, _ref31) {
      var commit = _ref30.commit;
      var accountId = _ref31.accountId,
          payload = _ref31.payload;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('accounts/' + accountId + '/impact-preferences', payload).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getCurrentAmountBalance: function getCurrentAmountBalance(_ref32, _ref33) {
      var commit = _ref32.commit;
      var accountId = _ref33.accountId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('accounts/' + accountId + '/current-amount-balance');
    },
    updateAccountName: function updateAccountName(_ref34, _ref35) {
      var commit = _ref34.commit;
      var accountId = _ref35.accountId,
          name = _ref35.name;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('/accounts/' + accountId, { accountName: name }).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    editInstitutionAccountInformation: function editInstitutionAccountInformation(_ref36, _ref37) {
      var commit = _ref36.commit;
      var params = _ref37.params,
          payload = _ref37.payload;
      var accountId = params.accountId,
          organizationId = params.organizationId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('/accounts/' + accountId + '/organizations/' + organizationId, payload).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    editTrustAccountInformation: function editTrustAccountInformation(_ref38, _ref39) {
      var commit = _ref38.commit;
      var params = _ref39.params,
          payload = _ref39.payload;
      var accountId = params.accountId,
          organizationId = params.organizationId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('/accounts/' + accountId + '/trust/' + organizationId, payload).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getAccountTransactions: function getAccountTransactions(_ref40, _ref41) {
      var commit = _ref40.commit;
      var accountId = _ref41.accountId,
          params = _ref41.params;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId + '/transactions', params).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    deleteAccountEmail: function deleteAccountEmail(_ref42, _ref43) {
      var commit = _ref42.commit;
      var accountId = _ref43.accountId,
          email = _ref43.email;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].deleteV2('/accounts/' + accountId + '/emails', { email: email }).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    addAccountEmail: function addAccountEmail(_ref44, _ref45) {
      var commit = _ref44.commit;
      var accountId = _ref45.accountId,
          email = _ref45.email;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('/accounts/' + accountId + '/emails', { email: email }).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    createAccountUser: function createAccountUser(_ref46, _ref47) {
      var commit = _ref46.commit;
      var accountId = _ref47.accountId,
          userId = _ref47.userId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('/accounts/' + accountId + '/users/' + userId).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    updateAccountPrimaryInvestor: function updateAccountPrimaryInvestor(_ref48, _ref49) {
      var commit = _ref48.commit;
      var accountId = _ref49.accountId,
          userId = _ref49.userId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('accounts/' + accountId + '/primary-investor', { userId: userId }).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getAccountDocuments: function getAccountDocuments(_ref50, _ref51) {
      var commit = _ref50.commit;
      var accountId = _ref51.accountId,
          query = _ref51.query;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('accounts/' + accountId + '/documents', query).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getSummaryPageDocuments: function getSummaryPageDocuments(_ref52, _ref53) {
      var commit = _ref52.commit;
      var accountId = _ref53.accountId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('accounts/' + accountId + '/documents/summary').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    createAccountDocumentPresignedUrl: function createAccountDocumentPresignedUrl(_ref54, _ref55) {
      var commit = _ref54.commit;
      var accountId = _ref55.accountId,
          payload = _ref55.payload;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('accounts/' + accountId + '/documents/signed-url', payload).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getAccountDocumentUrl: function getAccountDocumentUrl(_ref56, _ref57) {
      var commit = _ref56.commit;
      var accountId = _ref57.accountId,
          Key = _ref57.Key;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].get('accounts/' + accountId + '/document', { Key: Key }).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    createDocumentView: function createDocumentView(_ref58, documentView) {
      var commit = _ref58.commit;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('documents-views', documentView).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getAccounts: function getAccounts(_ref59, _ref60) {
      var commit = _ref59.commit;
      var searchString = _ref60.searchString,
          searchBy = _ref60.searchBy;

      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["N" /* DISABLE_SUBMIT_SEARCH */]);
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('search', {
        searchString: searchString,
        searchBy: searchBy
      }).catch(function (err) {
        throw err;
      }).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["M" /* ENABLE_SUBMIT_SEARCH */]);
        return response;
      });
    },
    updateCommunicationPreferencesNotification: function updateCommunicationPreferencesNotification(_ref61, accountId) {
      var commit = _ref61.commit;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].put('accounts/' + accountId + '/communicationPreferencesUpdated').then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["Q" /* SET_NOTIFICATION_STATUS */], response.data);
        return response.data;
      }).catch(function (err) {
        throw err;
      });
    },
    setNotificationStatus: function setNotificationStatus(_ref62, value) {
      var commit = _ref62.commit;

      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["Q" /* SET_NOTIFICATION_STATUS */], value);
    },
    getAccountBeneficiaries: function getAccountBeneficiaries(_ref63, accountId) {
      var commit = _ref63.commit;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId + '/beneficiaries').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    deleteAccountBeneficiary: function deleteAccountBeneficiary(_ref64, _ref65) {
      var commit = _ref64.commit;
      var accountId = _ref65.accountId,
          beneficiaryId = _ref65.beneficiaryId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].deleteV2('/accounts/' + accountId + '/beneficiaries/' + beneficiaryId).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    saveAccountBeneficiary: function saveAccountBeneficiary(_ref66, _ref67) {
      var commit = _ref66.commit;
      var accountId = _ref67.accountId,
          beneficiary = _ref67.beneficiary;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('/accounts/' + accountId + '/beneficiaries', beneficiary).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getAccountExtraReinvestments: function getAccountExtraReinvestments(_ref68, accountId) {
      var commit = _ref68.commit;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId + '/extra-reinvestments').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    createAccountExtraReinvestment: function createAccountExtraReinvestment(_ref69, _ref70) {
      var commit = _ref69.commit;
      var accountId = _ref70.accountId,
          payload = _ref70.payload;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('/accounts/' + accountId + '/extra-reinvestments', payload).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    cancelAccountExtraReinvestment: function cancelAccountExtraReinvestment(_ref71, _ref72) {
      var commit = _ref71.commit;
      var accountId = _ref72.accountId,
          extraReinvestmentId = _ref72.extraReinvestmentId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].patchV2('/accounts/' + accountId + '/extra-reinvestments/' + extraReinvestmentId + '/cancel').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    }
  }
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutation_types__ = __webpack_require__(8);





var _mutations;





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    name: '',
    userId: '',
    suggestedAddress: {},
    suggestedAddressType: '',
    isSuggestedAddressModalVisible: false,
    methodForYesButton: undefined,
    suggestedAddressModalYesCall: false,
    isAccountCreationModalVisible: false,
    changeAddress: false,
    userByAdmin: {}
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["o" /* SET_SUGGESTED_ADDRESS */], function (state, address) {
    state.suggestedAddress = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, address);
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["p" /* SET_SUGGESTED_ADDRESS_TYPE */], function (state, addressType) {
    state.suggestedAddressType = addressType;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["q" /* SET_SUGGESTED_ADDRESS_MODAL_VISIBLE */], function (state, visible) {
    state.isSuggestedAddressModalVisible = visible;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["r" /* SET_SUGGESTED_ADDRESS_YES_METHOD */], function (state, method) {
    state.methodForYesButton = method;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["_7" /* SET_SUGGESTED_ADDRESS_YES_CALL */], function (state) {
    var called = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    state.suggestedAddressModalYesCall = called;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["A" /* HIDE_ACCOUNT_CREATION_MODAL */], function (state) {
    state.isAccountCreationModalVisible = false;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["z" /* SHOW_ACCOUNT_CREATION_MODAL */], function (state, _ref) {
    var userId = _ref.userId,
        name = _ref.name;

    state.userId = userId;
    state.name = name;
    state.isAccountCreationModalVisible = true;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["y" /* SET_USER_BY_ADMIN */], function (state, userByAdmin) {
    state.userByAdmin = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, userByAdmin);
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["s" /* SET_CHANGE_ADDRESS */], function (state, change) {
    state.changeAddress = change;
  }), _mutations),
  actions: {
    saveUserProfile: function saveUserProfile(_, _ref2) {
      var user = _ref2.user;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('users/register/provisioning', user);
    },
    updateAccountProvisioned: function updateAccountProvisioned(_, _ref3) {
      var user = _ref3.user;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('users/register/provisioning', user);
    },
    updateDwollaUser: function updateDwollaUser(_, user) {
      var socialSecurityNum = user.socialSecurityNum;
      var investor = {
        id: user.id,
        firstName: user.firstName,
        lastName: user.lastName,
        email: typeof user.email === 'string' ? user.email.toLowerCase() : '',
        userType: user.userType,
        dateOfBirth: user.dateOfBirth,
        socialSecurityNum: socialSecurityNum.indexOf('x') > -1 ? undefined : socialSecurityNum,
        secondaryEmail: typeof user.secondaryEmail === 'string' ? user.secondaryEmail.toLowerCase() : '',
        primaryPhoneNum: user.primaryPhoneNum,
        secondaryPhoneNum: user.secondaryPhoneNum,
        residentialAddress: user.residentialAddress,
        mailingAddress: user.mailingAddress,
        updateCount: user.updateCount,
        isResidentDefaultAddress: user.isResidentDefaultAddress,
        clientId: user.clientId
      };
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].post('user/edit-dwolla-user', investor).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    updateUserProfile: function updateUserProfile(_, user) {
      var investor = {
        id: user.id,
        firstName: user.firstName,
        lastName: user.lastName,
        email: typeof user.email === 'string' ? user.email.toLowerCase() : '',
        userType: user.userType,
        dateOfBirth: user.dateOfBirth,
        socialSecurityNum: user.socialSecurityNum,
        secondaryEmail: typeof user.secondaryEmail === 'string' ? user.secondaryEmail.toLowerCase() : '',
        primaryPhoneNum: user.primaryPhoneNum,
        secondaryPhoneNum: user.secondaryPhoneNum,
        residentialAddress: user.residentialAddress,
        mailingAddress: user.mailingAddress,
        updateCount: user.updateCount,
        isResidentDefaultAddress: user.isResidentDefaultAddress,
        hasBeenAllowedPOBox: user.hasBeenAllowedPOBox
      };
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('users/' + user.id + '/profile', investor).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    updateUserDwollaProfile: function updateUserDwollaProfile(_, _ref4) {
      var user = _ref4.user;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].post('user/update-dwolla-profile', user);
    },
    setDefaultAccount: function setDefaultAccount(_, _ref5) {
      var accountId = _ref5.accountId,
          userId = _ref5.userId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('users/' + userId + '/default-account/' + accountId);
    },
    getUserProfile: function getUserProfile() {
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('users/user', { needSSN: true });
    },
    getUserDetail: function getUserDetail(_, userId) {
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('users/' + userId, { needSSN: true }).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getClientDetail: function getClientDetail(_, userId) {
      return {
        id: userId,
        mailingAddress: {},
        residentialAddress: {},
        accounts: {}
      };
    },
    getAddressVerification: function getAddressVerification(_ref6, _ref7) {
      var commit = _ref6.commit;
      var addressType = _ref7.addressType,
          address = _ref7.address;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('address-verification/' + addressType, address);
    },
    verifyResidentialAddress: function verifyResidentialAddress(_ref8, address) {
      var dispatch = _ref8.dispatch;

      return dispatch('getAddressVerification', { addressType: 'residential', address: address });
    },
    verifyOrganizationAddress: function verifyOrganizationAddress(_ref9, address) {
      var dispatch = _ref9.dispatch;

      return dispatch('getAddressVerification', { addressType: 'organization', address: address });
    },
    verifyMailingAddress: function verifyMailingAddress(_ref10, address) {
      var dispatch = _ref10.dispatch;

      return dispatch('getAddressVerification', { addressType: 'mailing', address: address });
    },
    createAccountAdmin: function createAccountAdmin(_ref11, accountObject) {
      var commit = _ref11.commit;

      var endpoint = '';
      switch (accountObject.accountType) {
        case 'joint':
          endpoint = 'accounts/create-joint';
          break;
        case 'utma-ugma':
          endpoint = 'accounts/create-utma-ugma';
          break;
        default:
          break;
      }
      accountObject.accountType = undefined; // eslint-disable-line no-param-reassign

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].post(endpoint, accountObject).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    createAccountByAdmin: function createAccountByAdmin(_ref12, _ref13) {
      var commit = _ref12.commit;
      var userId = _ref13.userId,
          accountObject = _ref13.accountObject;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('users/' + userId + '/accounts', accountObject).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    createOrganizationAccount: function createOrganizationAccount(_ref14, _ref15) {
      var commit = _ref14.commit;
      var accountObject = _ref15.accountObject,
          files = _ref15.files;

      var endpointUrl = '';
      switch (accountObject.accountType) {
        case 'institution':
          endpointUrl = 'accounts/create-institution';
          break;
        case 'trust':
          endpointUrl = 'accounts/create-trust';
          break;
        default:
          break;
      }
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].uploadFilesAndForm(endpointUrl, accountObject, files).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    createOrganizationByAdmin: function createOrganizationByAdmin(_ref16, _ref17) {
      var commit = _ref16.commit;
      var accountId = _ref17.accountId,
          organizationObject = _ref17.organizationObject;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('accounts/' + accountId + '/organizations', organizationObject).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    createAccountDocuments: function createAccountDocuments(_ref18, _ref19) {
      var commit = _ref18.commit;
      var accountId = _ref19.accountId,
          files = _ref19.files;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('accounts/' + accountId + '/documents', files).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    putDocumentToS3: function putDocumentToS3(_ref20, _ref21) {
      var _this = this;

      var commit = _ref20.commit;
      var presignedUrl = _ref21.presignedUrl,
          file = _ref21.file;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(presignedUrl, file).catch(function (err) {
                  throw err;
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updateConsentModalFlag: function updateConsentModalFlag() {
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('users/account/consent/confirm').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    }
  }
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__entities_userProfile__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_config__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mutation_types__ = __webpack_require__(8);








var _mutations;








/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    geoLocation: {},
    reservedImpactPreferenceCodes: {},
    accountStatus: '',
    accountTypes: {},
    activeAccountId: null,
    activeAccount: {},
    communicationPreferences: {},
    fundingSourceTypes: {},
    institutionTypes: {},
    investmentsRestrictions: {},
    irAdmin: false,
    loggedUser: {},
    paymentPreferences: {},
    restrictedStates: {},
    transactionStatus: {},
    transactionTypes: {},
    trustTypes: {},
    upcomingTransactionActions: {},
    user: {},
    userTypes: {},
    userCommentCategories: {},
    maintenance: false,
    loadingRedirection: false,
    hasBeenDisabledSignUp: __WEBPACK_IMPORTED_MODULE_9__config_config__["g" /* settingsApp */].hasBeenDisablledSignUp || 'OFF'
  },
  getters: {
    hasBeenCreatedAccount: function hasBeenCreatedAccount(state) {
      return state.user && state.user.accounts && !!state.user.accounts.length;
    },
    hasBeenRedirected: function hasBeenRedirected(state) {
      return state.loadingRedirection;
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["a" /* SET_USER */], function (state, user) {
    if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(user).length === 0) {
      state.user = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, new __WEBPACK_IMPORTED_MODULE_8__entities_userProfile__["a" /* default */]());
      return;
    }
    state.user = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, user);
    state.irAdmin = user.roles.includes('IR_ADMIN');
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["b" /* SET_ACCOUNT_STATUS */], function (state, status) {
    state.accountStatus = status;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_15" /* SET_IR_ADMIN_ROLE */], function (state) {
    var isAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    state.irAdmin = isAdmin;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_16" /* SET_STATIC_INFORMATION */], function (state, staticInformation) {
    state = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(state, staticInformation); // eslint-disable-line no-param-reassign
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["f" /* SET_ACTIVE_ACCOUNT_ID */], function (state, account) {
    // Nothing to restore (e.g. sessionStorage has no active account yet).
    // Bailing out keeps the previous state instead of throwing half way
    // through and leaving activeAccount empty.
    if (!account) {
      return;
    }
    var data = {
      id: account.id,
      accountName: account.accountName,
      accountType: account.accountType,
      primaryInvestorId: account.primaryInvestorId,
      paymentPreference: account.paymentPreference,
      interestPreference: account.interestPreference
    };
    sessionStorage.setItem('activeAccount', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data));
    state.activeAccountId = account.id;
    state.activeAccount = account;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["_17" /* SET_MAINTENANCE */], function (state) {
    state.maintenance = true;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__mutation_types__["g" /* SET_LOADING_REDIRECTION */], function (state) {
    state.loadingRedirection = true;
  }), _mutations),
  actions: {
    getStaticInformation: function getStaticInformation(_ref) {
      var _this = this;

      var commit = _ref.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var staticInformation;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util__["P" /* retryFn */])(function () {
                  return __WEBPACK_IMPORTED_MODULE_7__api_HttpService__["a" /* default */].getV2('static-information');
                }, 3, 1000);

              case 3:
                staticInformation = _context.sent;


                commit(__WEBPACK_IMPORTED_MODULE_11__mutation_types__["_16" /* SET_STATIC_INFORMATION */], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, staticInformation, {
                  userCommentCategories: (staticInformation.userCommentCategories || []).map(function (d) {
                    return { id: d.id, name: d.name };
                  })
                }));
                if (__WEBPACK_IMPORTED_MODULE_9__config_config__["g" /* settingsApp */].showMaintenance === 'true') {
                  commit(__WEBPACK_IMPORTED_MODULE_11__mutation_types__["_17" /* SET_MAINTENANCE */]);
                }
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                commit(__WEBPACK_IMPORTED_MODULE_11__mutation_types__["_17" /* SET_MAINTENANCE */]);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    getRateAndTermByGroup: function getRateAndTermByGroup(_ref2, _ref3) {
      var commit = _ref2.commit;
      var manageRateAndTermGroupsId = _ref3.manageRateAndTermGroupsId;

      return __WEBPACK_IMPORTED_MODULE_7__api_HttpService__["a" /* default */].getV2('/rate-and-term-groups/' + manageRateAndTermGroupsId);
    }
  }
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_AuthService__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(8);


var _mutations;






/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    states: [],
    canadaStates: [],
    countries: [],
    registrationRequestIsPending: false,
    isUserIdle: false,
    loginRequestIsPending: false,
    redirectUrl: ''
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["_8" /* SET_STATES */], function (state) {
    var states = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    state.states = states;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["_9" /* SET_CANADA_STATES */], function (state) {
    var canadaStates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    state.canadaStates = canadaStates;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["_10" /* SET_COUNTRIES */], function (state) {
    var countries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    state.countries = countries;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["_11" /* START_REGISTRATION_REQUEST */], function (state) {
    state.registrationRequestIsPending = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["_12" /* STOP_REGISTRATION_REQUEST */], function (state) {
    state.registrationRequestIsPending = false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_IDLE_ON */], function (state) {
    state.isUserIdle = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["L" /* SET_IDLE_OFF */], function (state) {
    state.isUserIdle = false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["K" /* SET_REDIRECT_URL */], function (state, url) {
    state.redirectUrl = url;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["_13" /* START_LOGIN_REQUEST */], function (state) {
    state.loginRequestIsPending = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["_14" /* STOP_LOGIN_REQUEST */], function (state) {
    state.loginRequestIsPending = false;
  }), _mutations),
  actions: {
    getStates: function getStates(_ref) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_1__api_HttpService__["a" /* default */].get('states').then(function (states) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["_8" /* SET_STATES */], states);
        return states;
      });
    },
    getCanadaStates: function getCanadaStates(_ref2) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_1__api_HttpService__["a" /* default */].get('canada-states').then(function (canadaStates) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["_9" /* SET_CANADA_STATES */], canadaStates);
        return canadaStates;
      });
    },
    getCountries: function getCountries(_ref3) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_1__api_HttpService__["a" /* default */].get('countries').then(function (countries) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["_10" /* SET_COUNTRIES */], countries);
        return countries;
      });
    },
    register: function register(_ref4, _ref5) {
      var commit = _ref4.commit;
      var email = _ref5.email,
          password = _ref5.password,
          state = _ref5.state,
          recaptchaResponse = _ref5.recaptchaResponse;

      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["_11" /* START_REGISTRATION_REQUEST */]);
      return __WEBPACK_IMPORTED_MODULE_2__api_AuthService__["a" /* default */].register({
        email: email,
        password: password,
        state: state,
        recaptchaResponse: recaptchaResponse
      }).then(function (data) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["_12" /* STOP_REGISTRATION_REQUEST */]);
        return data;
      }).catch(function (e) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["_12" /* STOP_REGISTRATION_REQUEST */]);
        throw e;
      });
    },
    legacyLogin: function legacyLogin(_ref6, _ref7) {
      var commit = _ref6.commit;
      var password = _ref7.password,
          legacyToken = _ref7.legacyToken;

      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["_13" /* START_LOGIN_REQUEST */]);
      return __WEBPACK_IMPORTED_MODULE_1__api_HttpService__["a" /* default */].postV2('legacy-login', { password: password }, { legacyToken: legacyToken });
    },
    logIn: function logIn(_ref8, _ref9) {
      var commit = _ref8.commit;
      var email = _ref9.email,
          password = _ref9.password;

      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["_13" /* START_LOGIN_REQUEST */]);
      return __WEBPACK_IMPORTED_MODULE_2__api_AuthService__["a" /* default */].logIn({ email: email, password: password }).then(function (data) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["_14" /* STOP_LOGIN_REQUEST */]);
        return data;
      }).catch(function (e) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["_14" /* STOP_LOGIN_REQUEST */]);
        throw e;
      });
    },
    handleMfa: function handleMfa(_ref10, _ref11) {
      var commit = _ref10.commit;
      var mfaCode = _ref11.mfaCode;

      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["_13" /* START_LOGIN_REQUEST */]);
      return __WEBPACK_IMPORTED_MODULE_2__api_AuthService__["a" /* default */].handleMfa({ mfaCode: mfaCode }).then(function (data) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["_14" /* STOP_LOGIN_REQUEST */]);
        return data;
      }).catch(function (e) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["_14" /* STOP_LOGIN_REQUEST */]);
        throw e;
      });
    },
    forgotPassword: function forgotPassword(_, _ref12) {
      var email = _ref12.email;

      return __WEBPACK_IMPORTED_MODULE_1__api_HttpService__["a" /* default */].postV2('/auth/forgot-password', { email: email.toLowerCase() });
    },
    resetPassword: function resetPassword(_, _ref13) {
      var email = _ref13.email;

      return __WEBPACK_IMPORTED_MODULE_2__api_AuthService__["a" /* default */].resetPassword({ email: email });
    },
    verifyMigration: function verifyMigration(_, _ref14) {
      var email = _ref14.email;

      return __WEBPACK_IMPORTED_MODULE_1__api_HttpService__["a" /* default */].postV2('users/verify-migration', { email: email });
    },
    getUserMetadata: function getUserMetadata() {
      return __WEBPACK_IMPORTED_MODULE_1__api_HttpService__["a" /* default */].get('/authentication/userinfo');
    }
  }
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_HttpService__ = __webpack_require__(20);



var _mutations;




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    isCheckWireModalVisible: false,
    creationSucceeded: false,
    accountId: '',
    fundingSources: []
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["u" /* SET_CREATION_SUCCEEDED */], function (state, creationStatus) {
    state.creationSucceeded = creationStatus;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["t" /* SHOW_CHECK_WIRE_MODAL */], function (state, _ref) {
    var accountId = _ref.accountId,
        fundingSources = _ref.fundingSources;

    state.isCheckWireModalVisible = true;
    state.accountId = accountId;
    state.fundingSources = fundingSources;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["v" /* HIDE_CHECK_WIRE_MODAL */], function (state) {
    state.isCheckWireModalVisible = false;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["t" /* SHOW_CHECK_WIRE_MODAL */], function (state, _ref2) {
    var accountId = _ref2.accountId,
        fundingSources = _ref2.fundingSources;

    state.isCheckWireModalVisible = true;
    state.accountId = accountId;
    state.fundingSources = fundingSources;
  }), _mutations),
  actions: {
    createAccountFundingSources: function createAccountFundingSources(_ref3, _ref4) {
      var commit = _ref3.commit;
      var accountId = _ref4.accountId,
          payload = _ref4.payload;

      return __WEBPACK_IMPORTED_MODULE_3__api_HttpService__["a" /* default */].postV2('/accounts/' + accountId + '/funding-sources', payload).then(function (res) {
        return res;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }
  }
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(8);



var _mutations;





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    documentIsUploading: false,
    needsDocumentation: null,
    documentationReason: ''
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["_3" /* START_DOCUMENT_UPLOAD */], function (state) {
    state.documentIsUploading = true;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["_4" /* STOP_DOCUMENT_UPLOAD */], function (state) {
    state.documentIsUploading = false;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["D" /* SET_NEEDS_DOCUMENTATION */], function (state, value) {
    state.needsDocumentation = value;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["E" /* SET_DOCUMENTATION_REASON */], function (state, reason) {
    state.documentationReason = reason;
  }), _mutations),
  actions: {
    checkIfUserNeedsDocumentation: function checkIfUserNeedsDocumentation(_ref) {
      var commit = _ref.commit;

      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["D" /* SET_NEEDS_DOCUMENTATION */], null);
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["E" /* SET_DOCUMENTATION_REASON */], '');
      return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].getV2('users/user/needs-documentation').then(function (data) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["D" /* SET_NEEDS_DOCUMENTATION */], data.needs);
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["E" /* SET_DOCUMENTATION_REASON */], data.reason || '');
        return true;
      });
    },
    uploadDocument: function uploadDocument(_ref2, _ref3) {
      var commit = _ref2.commit;
      var file = _ref3.file,
          data = _ref3.data;

      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["_3" /* START_DOCUMENT_UPLOAD */]);
      return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].uploadFileV2('users/dwolla-documentation', file, data).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["_4" /* STOP_DOCUMENT_UPLOAD */]);
        return response;
      }).catch(function (error) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["_4" /* STOP_DOCUMENT_UPLOAD */]);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }
  }
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: {
    exportDocumentViewsReport: function exportDocumentViewsReport(_ref) {
      var commit = _ref.commit;
      // eslint-disable-line no-unused-vars
      return __WEBPACK_IMPORTED_MODULE_0__api_HttpService__["a" /* default */].getV2('reports/document-views').then(function (blob) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["N" /* downloadCSVBlob */])('document_views.csv', blob);
      });
    }
  }
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(8);


var _mutations;



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    listErrors: [],
    isVisibleErrorsModal: false
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* SHOW_ERRORS_MODAL */], function (state) {
    state.isVisibleErrorsModal = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* HIDE_ERRORS_MODAL */], function (state) {
    state.isVisibleErrorsModal = false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_ERRORS_MODAL_INFO */], function (state, errors) {
    state.listErrors = errors.length > 0 ? errors : null;
  }), _mutations)
});

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: {
    getFeedbackStatus: function getFeedbackStatus(_ref) {
      var commit = _ref.commit;
      // eslint-disable-line no-unused-vars
      return __WEBPACK_IMPORTED_MODULE_0__api_HttpService__["a" /* default */].getV2('feedback/status').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    submitFeedback: function submitFeedback(_ref2, payload) {
      var commit = _ref2.commit;
      // eslint-disable-line no-unused-vars
      return __WEBPACK_IMPORTED_MODULE_0__api_HttpService__["a" /* default */].postV2('feedback', payload).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getUserFeedback: function getUserFeedback(_ref3, userId) {
      var commit = _ref3.commit;
      // eslint-disable-line no-unused-vars
      return __WEBPACK_IMPORTED_MODULE_0__api_HttpService__["a" /* default */].getV2('users/' + userId + '/feedback').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    exportFeedbackReport: function exportFeedbackReport(_ref4) {
      var commit = _ref4.commit;
      // eslint-disable-line no-unused-vars
      return __WEBPACK_IMPORTED_MODULE_0__api_HttpService__["a" /* default */].getV2('reports/feedback').then(function (blob) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["N" /* downloadCSVBlob */])('feedback_results.csv', blob);
      });
    }
  }
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(8);







/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    currentDwollaCustomerId: null
  },
  mutations: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_5" /* SET_CURRENT_DWOLLA_CUSTOMER_ID */], function (state, customerId) {
    state.currentDwollaCustomerId = customerId;
  }),
  actions: {
    getToken: function getToken(_, dwollaCustomerId) {
      return __WEBPACK_IMPORTED_MODULE_3__api_HttpService__["a" /* default */].postV2('/iav-token/' + dwollaCustomerId);
    },
    deleteFundingSource: function deleteFundingSource(_, fundingSourceId) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__api_HttpService__["a" /* default */].deleteV2('/funding-sources/' + fundingSourceId));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    createDwollaUser: function createDwollaUser(_, userId) {
      return __WEBPACK_IMPORTED_MODULE_3__api_HttpService__["a" /* default */].postV2('users/dwolla/customer', { userId: userId }).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    updateDwollaCustomer: function updateDwollaCustomer() {
      return __WEBPACK_IMPORTED_MODULE_3__api_HttpService__["a" /* default */].putV2('users/dwolla/customer').catch(function (err) {
        throw err;
      });
    },
    getClientToken: function getClientToken(_, payload) {
      return __WEBPACK_IMPORTED_MODULE_3__api_HttpService__["a" /* default */].postV2('funding-sources/client-token', payload);
    }
  }
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    userStatus: null
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_6" /* SET_USER_STATUS */], function (state, userStatus) {
    state.userStatus = userStatus;
  }),
  actions: {
    getUserStatus: function getUserStatus(_ref, _ref2) {
      var commit = _ref.commit;
      var accountId = _ref2.accountId;

      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_6" /* SET_USER_STATUS */], null);

      return __WEBPACK_IMPORTED_MODULE_1__api_HttpService__["a" /* default */].getV2('users/user/accounts/' + accountId + '/status').then(function (status) {
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["_6" /* SET_USER_STATUS */], status);
        return status;
      });
    },
    setOnBoardingComplete: function setOnBoardingComplete() {
      return __WEBPACK_IMPORTED_MODULE_1__api_HttpService__["a" /* default */].postV2('/users/onboarding/complete');
    }
  }
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idle_js__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idle_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_idle_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(8);


var _mutations;





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    idleVue: null,
    idleTime: 540000, // 9 minutes
    idleStarted: false,
    isUserIdle: false
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_IDLE_ON */], function (state) {
    state.isUserIdle = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["L" /* SET_IDLE_OFF */], function (state) {
    state.isUserIdle = false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'setIdleTime', function setIdleTime(state, idleTime) {
    state.idleTime = idleTime;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'setIdleStarted', function setIdleStarted(state, idleStarted) {
    state.idleStarted = idleStarted;
  }), _mutations),
  actions: {
    startIdle: function startIdle(_ref) {
      var commit = _ref.commit,
          state = _ref.state;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (state.idleVue) state.idleVue.stop();

      if (options && options.idleTime) {
        commit('setIdleTime', options.idleTime);
      }

      state.idleVue = new __WEBPACK_IMPORTED_MODULE_1_idle_js___default.a({
        idle: state.idleTime,
        keepTracking: options && options.keepTracking || true,
        startAtIdle: options && options.startAtIdle || true,
        events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
        onIdle: function onIdle() {
          commit('SET_IDLE_ON', true);
        },
        onActive: function onActive() {
          commit('SET_IDLE_OFF', false);
        }
      });

      state.idleVue.start();
      commit('setIdleStarted', true);
    }
  }
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(9);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: {
    getNonDisplayedPreferences: function getNonDisplayedPreferences(_ref) {
      var commit = _ref.commit;
      // eslint-disable-line no-unused-vars
      return __WEBPACK_IMPORTED_MODULE_1__api_HttpService__["a" /* default */].get('impact-preferences/non-displayed').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getImpactPreferences: function getImpactPreferences(_ref2) {
      var commit = _ref2.commit;
      // eslint-disable-line no-unused-vars
      return __WEBPACK_IMPORTED_MODULE_1__api_HttpService__["a" /* default */].getV2('impact-preferences').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    exportImpactPreferencesReport: function exportImpactPreferencesReport(_ref3) {
      var commit = _ref3.commit;
      // eslint-disable-line no-unused-vars
      return __WEBPACK_IMPORTED_MODULE_1__api_HttpService__["a" /* default */].getV2('reports/impact-preferences').then(function (blob) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["N" /* downloadCSVBlob */])('impact_preferences.csv', blob);
      });
    },
    getSeparatedDisplayedAndNonDisplayedPreferencesAdmin: function getSeparatedDisplayedAndNonDisplayedPreferencesAdmin(_ref4, _ref5) {
      var commit = _ref4.commit;
      var impactPreferences = _ref5.impactPreferences,
          accountImpactPreferences = _ref5.accountImpactPreferences;

      var result = impactPreferences.reduce(function (acc, preference) {
        var preferenceObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, preference, { isSelected: false });
        var selectedPreference = accountImpactPreferences.find(function (accountPreference) {
          return accountPreference.id === preferenceObj.id;
        });
        if (selectedPreference) {
          selectedPreference.isSelected = !!selectedPreference;
        }

        if (preferenceObj.preferenceDisplay) {
          acc.displayedPreferences.push(selectedPreference || preferenceObj);
          acc.displayedPreferences.sort(function (a, b) {
            return a.id - b.id;
          });
        } else {
          acc.nonDisplayedPreferences.push(selectedPreference || preferenceObj);
        }
        return acc;
      }, { displayedPreferences: [], nonDisplayedPreferences: [] });
      result.nonDisplayedPreferences.sort(function (a, b) {
        return a.id - b.id;
      });
      result.displayedPreferences.sort(function (a, b) {
        return a.id - b.id;
      });
      return result;
    },
    getSeparatedDisplayedAndNonDisplayedPreferencesInvestor: function getSeparatedDisplayedAndNonDisplayedPreferencesInvestor(_ref6, _ref7) {
      var commit = _ref6.commit;
      var impactPreferences = _ref7.impactPreferences,
          accountImpactPreferences = _ref7.accountImpactPreferences;

      var result = impactPreferences.reduce(function (acc, preference) {
        var preferenceObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, preference, { isSelected: false });
        var selectedPreference = accountImpactPreferences.find(function (accountPreference) {
          return accountPreference.id === preferenceObj.id;
        });
        if (selectedPreference) {
          selectedPreference.isSelected = !!selectedPreference;
        }

        if (preferenceObj.preferenceDisplay) {
          acc.displayedPreferences.push(selectedPreference || preferenceObj);
          acc.displayedPreferences.sort(function (a, b) {
            return a.id - b.id;
          });
        } else if (selectedPreference) {
          acc.nonDisplayedPreferences.push(selectedPreference || preferenceObj);
        }
        return acc;
      }, { displayedPreferences: [], nonDisplayedPreferences: [] });
      result.nonDisplayedPreferences.sort(function (a, b) {
        return a.id - b.id;
      });
      result.displayedPreferences.sort(function (a, b) {
        return a.id - b.id;
      });
      return result;
    }
  }
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(8);


var _mutations;



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    isInformationModalVisible: false,
    message: ''
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["e" /* HIDE_INFORMATION_MODAL */], function (state) {
    state.isInformationModalVisible = false;
    state.message = '';
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["d" /* SHOW_INFORMATION_MODAL */], function (state, newMessage) {
    state.isInformationModalVisible = true;
    state.message = newMessage;
  }), _mutations)
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_HttpService__ = __webpack_require__(20);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    sessionId: null,
    questions: [],
    expiresAt: null,
    loading: false,
    error: null
  },
  mutations: {
    SET_LOADING: function SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_ERROR: function SET_ERROR(state, error) {
      state.error = error;
    },
    SET_SESSION_ID: function SET_SESSION_ID(state, id) {
      state.sessionId = id;
    },
    SET_QUESTIONS: function SET_QUESTIONS(state, payload) {
      state.questions = payload.questions || [];
      state.expiresAt = payload.expiresAt || null;
    },
    RESET: function RESET(state) {
      state.sessionId = null;
      state.questions = [];
      state.expiresAt = null;
      state.loading = false;
      state.error = null;
    }
  },
  actions: {
    initiate: function initiate(_ref, _ref2) {
      var _this = this;

      var commit = _ref.commit;
      var dwollaCustomerId = _ref2.dwollaCustomerId;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res, _ref3, dwollaKbaId;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit('SET_LOADING', true);
                commit('SET_ERROR', null);
                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].postV2('kba/initiate', { dwollaCustomerId: dwollaCustomerId });

              case 5:
                res = _context.sent;
                _ref3 = res || {}, dwollaKbaId = _ref3.dwollaKbaId;

                commit('SET_SESSION_ID', dwollaKbaId);
                return _context.abrupt('return', dwollaKbaId);

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](2);

                commit('SET_ERROR', _context.t0);
                throw _context.t0;

              case 15:
                _context.prev = 15;

                commit('SET_LOADING', false);
                return _context.finish(15);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 11, 15, 18]]);
      }))();
    },
    getQuestions: function getQuestions(_ref4, _ref5) {
      var _this2 = this;

      var commit = _ref4.commit,
          state = _ref4.state;
      var sessionId = _ref5.sessionId;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var id, res, _ref6, _ref6$questions, questions, _ref6$expiresAt, expiresAt;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = sessionId || state.sessionId;

                if (id) {
                  _context2.next = 3;
                  break;
                }

                throw new Error('Missing KBA session id');

              case 3:
                commit('SET_LOADING', true);
                commit('SET_ERROR', null);
                _context2.prev = 5;
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].getV2('kba/' + id + '/questions');

              case 8:
                res = _context2.sent;
                _ref6 = res || {}, _ref6$questions = _ref6.questions, questions = _ref6$questions === undefined ? [] : _ref6$questions, _ref6$expiresAt = _ref6.expiresAt, expiresAt = _ref6$expiresAt === undefined ? null : _ref6$expiresAt;

                commit('SET_QUESTIONS', { questions: questions, expiresAt: expiresAt });
                return _context2.abrupt('return', { questions: questions, expiresAt: expiresAt });

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](5);

                commit('SET_ERROR', _context2.t0);
                throw _context2.t0;

              case 18:
                _context2.prev = 18;

                commit('SET_LOADING', false);
                return _context2.finish(18);

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[5, 14, 18, 21]]);
      }))();
    },
    submitAnswers: function submitAnswers(_ref7, _ref8) {
      var _this3 = this;

      var commit = _ref7.commit,
          state = _ref7.state;
      var sessionId = _ref8.sessionId,
          answers = _ref8.answers;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var id, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = sessionId || state.sessionId;

                if (id) {
                  _context3.next = 3;
                  break;
                }

                throw new Error('Missing KBA session id');

              case 3:
                commit('SET_LOADING', true);
                commit('SET_ERROR', null);
                _context3.prev = 5;
                _context3.next = 8;
                return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].postV2('kba/' + id + '/answers', { answers: answers });

              case 8:
                res = _context3.sent;
                return _context3.abrupt('return', res);

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](5);

                commit('SET_ERROR', _context3.t0);
                throw _context3.t0;

              case 16:
                _context3.prev = 16;

                commit('SET_LOADING', false);
                return _context3.finish(16);

              case 19:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[5, 12, 16, 19]]);
      }))();
    }
  }
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_HttpService__ = __webpack_require__(20);


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    verifyMicroDeposit: function verifyMicroDeposit(_, _ref) {
      var microDeposit = _ref.microDeposit;
      var fundingSourceId = microDeposit.fundingSourceId;
      var _microDeposit$request = microDeposit.requestBody,
          amount1 = _microDeposit$request.amount1,
          amount2 = _microDeposit$request.amount2;

      var payload = {
        fundingSourceId: fundingSourceId,
        amount1: amount1,
        amount2: amount2
      };
      return __WEBPACK_IMPORTED_MODULE_0__api_HttpService__["a" /* default */].postV2('funding-sources/' + fundingSourceId + '/verify-micro-deposits', payload);
    },
    getMicroDepositStatus: function getMicroDepositStatus(_, _ref2) {
      var fundingSourceId = _ref2.fundingSourceId;

      return __WEBPACK_IMPORTED_MODULE_0__api_HttpService__["a" /* default */].get('funding-source/' + fundingSourceId + '/micro-deposit');
    }
  }
});

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: {
    exportMonthlyMaturitiesReport: function exportMonthlyMaturitiesReport(_ref) {
      var commit = _ref.commit;
      // eslint-disable-line no-unused-vars
      return __WEBPACK_IMPORTED_MODULE_0__api_HttpService__["a" /* default */].getV2('reports/monthly-maturities').then(function (blob) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["O" /* downloadBlob */])('monthly_maturities_report.xlsx', blob);
      });
    }
  }
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutation_types__ = __webpack_require__(8);






var _mutations;




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    purchasingNote: false,
    gettingNotesList: false
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["X" /* GET_NOTES_LIST_FAILURE */], function (state) {
    state.gettingNotesList = false;
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["Y" /* GET_NOTES_LIST_REQUEST */], function (state) {
    state.gettingNotesList = true;
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["Z" /* GET_NOTES_LIST_SUCCESS */], function (state) {
    state.gettingNotesList = false;
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["_0" /* PURCHASE_NOTE_FAILURE */], function (state) {
    state.purchasingNote = false;
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["_1" /* PURCHASE_NOTE_REQUEST */], function (state) {
    state.purchasingNote = true;
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["_2" /* PURCHASE_NOTE_SUCCESS */], function (state) {
    state.purchasingNote = false;
  }), _mutations),
  actions: {
    getInterestYearRates: function getInterestYearRates() {
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('notes/rates');
    },
    getRedeemNote: function getRedeemNote(_ref, noteId) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].get('/notes/' + noteId + '/redeem').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getAccountNoteRedeem: function getAccountNoteRedeem(_ref2, _ref3) {
      var commit = _ref2.commit;
      var accountId = _ref3.accountId,
          noteId = _ref3.noteId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId + '/notes/' + noteId + '/redemptions').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    validateRedemptionFunds: function validateRedemptionFunds(_ref4, noteId) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/notes/' + noteId + '/redeem-validate-funds').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    requestNoteRedemption: function requestNoteRedemption(_ref5, _ref6) {
      var commit = _ref5.commit;
      var accountId = _ref6.accountId,
          noteId = _ref6.noteId,
          payload = _ref6.payload;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('/accounts/' + accountId + '/notes/' + noteId + '/redemptions', payload).then(function () {
        return true;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    approveNoteRedemption: function approveNoteRedemption(_ref7, _ref8) {
      var commit = _ref7.commit;
      var noteId = _ref8.noteId,
          redeemRequest = _ref8.redeemRequest;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('/notes/' + noteId + '/redemption/approval', redeemRequest).then(function () {
        return true;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    cancelNoteRedemption: function cancelNoteRedemption(_ref9, _ref10) {
      var commit = _ref9.commit;
      var accountId = _ref10.accountId,
          noteId = _ref10.noteId,
          payload = _ref10.payload;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].deleteV2('/accounts/' + accountId + '/notes/' + noteId + '/redemptions', payload).then(function () {
        return true;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // Bulk "redeem/approve all open notes". The preview drives the modal: the
    // service fee is charged once for the batch, to whichever note is large
    // enough to absorb it, so the server decides where it lands and re-prices
    // whenever the admin edits it rather than the modal computing it.
    previewBulkRedemption: function previewBulkRedemption(_ref11, _ref12) {
      var commit = _ref11.commit;
      var accountId = _ref12.accountId,
          _ref12$serviceFee = _ref12.serviceFee,
          serviceFee = _ref12$serviceFee === undefined ? 0 : _ref12$serviceFee;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId + '/notes/bulk-redemptions/preview?serviceFee=' + serviceFee).then(function (response) {
        return response;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    createBulkRedemption: function createBulkRedemption(_ref13, _ref14) {
      var commit = _ref13.commit;
      var accountId = _ref14.accountId,
          payload = _ref14.payload;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('/accounts/' + accountId + '/notes/bulk-redemptions', payload).then(function (response) {
        return response;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    getBulkRedemption: function getBulkRedemption(_ref15, _ref16) {
      var commit = _ref15.commit;
      var accountId = _ref16.accountId,
          batchId = _ref16.batchId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId + '/notes/bulk-redemptions/' + batchId).then(function (response) {
        return response;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    approveBulkRedemption: function approveBulkRedemption(_ref17, _ref18) {
      var commit = _ref17.commit;
      var accountId = _ref18.accountId,
          batchId = _ref18.batchId,
          payload = _ref18.payload;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('/accounts/' + accountId + '/notes/bulk-redemptions/' + batchId + '/approval', payload).then(function (response) {
        return response;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    cancelBulkRedemption: function cancelBulkRedemption(_ref19, _ref20) {
      var commit = _ref19.commit;
      var accountId = _ref20.accountId,
          batchId = _ref20.batchId,
          payload = _ref20.payload;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].deleteV2('/accounts/' + accountId + '/notes/bulk-redemptions/' + batchId, payload).then(function (response) {
        return response;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // Bulk "transfer every note to another account". The preview reports which
    // notes can move and what it would cost the investor in cleared upcoming
    // transaction actions; the destination is optional because eligibility
    // depends on the source account alone.
    previewBulkNoteTransfer: function previewBulkNoteTransfer(_ref21, _ref22) {
      var commit = _ref21.commit;
      var accountId = _ref22.accountId,
          toAccountId = _ref22.toAccountId,
          includeClosedNotes = _ref22.includeClosedNotes;

      // Built up rather than declared: URLSearchParams would serialise an absent
      // value as the string "undefined" and the endpoint would reject it.
      var params = {};

      if (toAccountId) {
        params.toAccountId = toAccountId;
      }

      // Sent only when asked for. The endpoint leaves closed notes behind by
      // default, so omitting it keeps the conservative preview.
      if (includeClosedNotes) {
        params.includeClosedNotes = true;
      }

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId + '/notes/bulk-transfers/preview', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(params).length ? params : null).then(function (response) {
        return response;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    createBulkNoteTransfer: function createBulkNoteTransfer(_ref23, _ref24) {
      var commit = _ref23.commit;
      var accountId = _ref24.accountId,
          payload = _ref24.payload;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('/accounts/' + accountId + '/notes/bulk-transfers', payload).then(function (response) {
        return response;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    getBulkNoteTransfer: function getBulkNoteTransfer(_ref25, _ref26) {
      var commit = _ref25.commit;
      var accountId = _ref26.accountId,
          batchId = _ref26.batchId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/accounts/' + accountId + '/notes/bulk-transfers/' + batchId).then(function (response) {
        return response;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    approveBulkNoteTransfer: function approveBulkNoteTransfer(_ref27, _ref28) {
      var commit = _ref27.commit;
      var accountId = _ref28.accountId,
          batchId = _ref28.batchId,
          payload = _ref28.payload;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('/accounts/' + accountId + '/notes/bulk-transfers/' + batchId + '/approval', payload).then(function (response) {
        return response;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    cancelBulkNoteTransfer: function cancelBulkNoteTransfer(_ref29, _ref30) {
      var commit = _ref29.commit;
      var accountId = _ref30.accountId,
          batchId = _ref30.batchId,
          payload = _ref30.payload;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].deleteV2('/accounts/' + accountId + '/notes/bulk-transfers/' + batchId, payload).then(function (response) {
        return response;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    getNote: function getNote(_ref31, noteId) {
      var commit = _ref31.commit;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/notes/' + noteId).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    resetInterestAccrual: function resetInterestAccrual(_ref32, noteId) {
      var commit = _ref32.commit;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('/notes/' + noteId + '/interest-accrual').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    getNotes: function getNotes(_ref33, _ref34) {
      var commit = _ref33.commit;
      var accountId = _ref34.accountId;

      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["Y" /* GET_NOTES_LIST_REQUEST */]);
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].get('notes/account/' + accountId).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["Z" /* GET_NOTES_LIST_SUCCESS */]);
        return response;
      }).catch(function () {
        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["X" /* GET_NOTES_LIST_FAILURE */]);
      });
    },
    purchaseNote: function purchaseNote(_ref35, _ref36) {
      var commit = _ref35.commit;
      var data = _ref36.data;

      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["_1" /* PURCHASE_NOTE_REQUEST */]);
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('notes', data).then(function () {
        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["_2" /* PURCHASE_NOTE_SUCCESS */]);
        return true;
      }).catch(function (error) {
        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["_0" /* PURCHASE_NOTE_FAILURE */]);
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    adjustInterestForNote: function adjustInterestForNote(_ref37, _ref38) {
      var commit = _ref37.commit;
      var noteId = _ref38.noteId,
          adjustmentObject = _ref38.adjustmentObject;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('notes/' + noteId + '/interest', adjustmentObject).then(function () {
        return true;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    getAccountNoteTransfer: function getAccountNoteTransfer(_ref39, _ref40) {
      var commit = _ref39.commit;
      var accountId = _ref40.accountId,
          noteId = _ref40.noteId;

      try {
        return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('accounts/' + accountId + '/notes/' + noteId + '/transfer');
      } catch (err) {
        throw err;
      }
    },
    getAdditionalDepositInformation: function getAdditionalDepositInformation(_ref41, noteId) {
      var _this = this;

      var commit = _ref41.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('/notes/' + noteId + '/funds');

              case 3:
                response = _context.sent;
                return _context.abrupt('return', response);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                throw _context.t0;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    requestAddFunds: function requestAddFunds(_ref42, _ref43) {
      var _this2 = this;

      var commit = _ref42.commit;
      var noteId = _ref43.noteId,
          request = _ref43.request;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('/notes/' + noteId + '/funds', request);

              case 3:
                return _context2.abrupt('return', true);

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](0);
                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(_context2.t0));

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 6]]);
      }))();
    },
    approveAddFunds: function approveAddFunds(_ref44, _ref45) {
      var _this3 = this;

      var commit = _ref44.commit;
      var noteId = _ref45.noteId,
          request = _ref45.request;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('/notes/' + noteId + '/funds', request);

              case 3:
                return _context3.abrupt('return', true);

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](0);
                return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(_context3.t0));

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 6]]);
      }))();
    },
    cancelNoteAddFunds: function cancelNoteAddFunds(_ref46, _ref47) {
      var _this4 = this;

      var commit = _ref46.commit;
      var noteId = _ref47.noteId,
          request = _ref47.request;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].deleteV2('/notes/' + noteId + '/funds', request);

              case 3:
                return _context4.abrupt('return', true);

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4['catch'](0);
                return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(_context4.t0));

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 6]]);
      }))();
    },
    createAccountNoteTransfer: function createAccountNoteTransfer(_ref48, _ref49) {
      var _this5 = this;

      var commit = _ref48.commit;
      var noteId = _ref49.noteId,
          accountId = _ref49.accountId,
          payload = _ref49.payload;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('accounts/' + accountId + '/notes/' + noteId + '/transfer', payload);

              case 3:
                return _context5.abrupt('return', true);

              case 6:
                _context5.prev = 6;
                _context5.t0 = _context5['catch'](0);
                return _context5.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(_context5.t0));

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 6]]);
      }))();
    },
    updateAccountNoteTransfer: function updateAccountNoteTransfer(_ref50, _ref51) {
      var _this6 = this;

      var commit = _ref50.commit;
      var accountId = _ref51.accountId,
          noteId = _ref51.noteId,
          payload = _ref51.payload;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('accounts/' + accountId + '/notes/' + noteId + '/transfer', payload);

              case 3:
                return _context6.abrupt('return', true);

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6['catch'](0);
                return _context6.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(_context6.t0));

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 6]]);
      }))();
    },
    deleteAccountNoteTransfer: function deleteAccountNoteTransfer(_ref52, _ref53) {
      var _this7 = this;

      var commit = _ref52.commit;
      var accountId = _ref53.accountId,
          noteId = _ref53.noteId;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].deleteV2('accounts/' + accountId + '/notes/' + noteId + '/transfer');

              case 3:
                return _context7.abrupt('return', true);

              case 6:
                _context7.prev = 6;
                _context7.t0 = _context7['catch'](0);
                return _context7.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(_context7.t0));

              case 9:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 6]]);
      }))();
    }
  }
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(8);


var _mutations;



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    display: false,
    modalTitle: '',
    questionText: '',
    questionTextAppend: '',
    hyperLinkUrl: '',
    hyperLinkText: '',
    hyperLinkUrl2: '',
    hyperLinkText2: '',
    methodToExecute: '',
    yesButtonText: '',
    hideCancelButton: false
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* SHOW_QUESTION_MODAL */], function (state, data) {
    var title = data.title,
        question = data.question,
        questionAppend = data.questionAppend,
        hyperLinkUrl = data.hyperLinkUrl,
        hyperLinkText = data.hyperLinkText,
        hyperLinkUrl2 = data.hyperLinkUrl2,
        hyperLinkText2 = data.hyperLinkText2,
        method = data.method,
        yesButtonText = data.yesButtonText,
        hideCancelButton = data.hideCancelButton;


    state.display = true;
    state.hideCancelButton = hideCancelButton;
    state.modalTitle = title;
    state.questionText = question;
    state.questionTextAppend = questionAppend;
    state.hyperLinkUrl = hyperLinkUrl;
    state.hyperLinkText = hyperLinkText;
    state.hyperLinkUrl2 = hyperLinkUrl2;
    state.hyperLinkText2 = hyperLinkText2;
    state.methodToExecute = method;
    state.yesButtonText = yesButtonText;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* HIDE_QUESTION_MODAL */], function (state) {
    state.display = false;
    state.hideCancelButton = true;
    state.modalTitle = '';
    state.questionText = '';
    state.questionTextAppend = '';
    state.hyperLinkUrl = '';
    state.hyperLinkText = '';
    state.hyperLinkUrl2 = '';
    state.hyperLinkText2 = '';
    state.methodToExecute = '';
    state.yesButtonText = '';
  }), _mutations)
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(8);


var _mutations;



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    isSuccessModalVisible: false,
    message: ''
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["I" /* HIDE_SUCCESS_MODAL */], function (state) {
    state.isSuccessModalVisible = false;
    state.message = '';
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["H" /* SHOW_SUCCESS_MODAL */], function (state, newMessage) {
    state.isSuccessModalVisible = true;
    state.message = newMessage;
  }), _mutations)
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(8);


var _mutations;



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    isAlertVisible: false,
    message: ''
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["w" /* CLOSE_SUCCESS_ALERT */], function (state) {
    state.isAlertVisible = false;
    state.message = '';
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["x" /* SHOW_SUCCESS_ALERT */], function (state, newMessage) {
    state.isAlertVisible = true;
    state.message = newMessage;
  }), _mutations)
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__entities_transactionDetail__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutation_types__ = __webpack_require__(8);






var _mutations;





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    transaction: {},
    loading: false,
    disableSubmitDetailTransaction: false
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["R" /* SET_TRANSACTION */], function (state, transaction) {
    if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(transaction).length === 0) {
      state.transaction = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, new __WEBPACK_IMPORTED_MODULE_6__entities_transactionDetail__["a" /* default */]());
      return;
    }
    state.transaction = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, transaction);
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["S" /* GET_TRANSACTION_LIST_FAILURE */], function (state) {
    state.loading = false;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["T" /* GET_TRANSACTION_LIST_REQUEST */], function (state) {
    state.loading = true;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["U" /* GET_TRANSACTION_LIST_SUCCESS */], function (state) {
    state.loading = false;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["m" /* ENABLE_SUBMIT_DETAIL_TRANSACTION */], function (state) {
    state.disableSubmitDetailTransaction = false;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["l" /* DISABLE_SUBMIT_DETAIL_TRANSACTION */], function (state) {
    state.disableSubmitDetailTransaction = true;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["V" /* UPDATE_UPCOMING_TRANSACTION_REQUEST */], function (state) {
    state.loading = true;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["W" /* UPDATE_UPCOMING_TRANSACTION_RESPONDED */], function (state) {
    state.loading = false;
  }), _mutations),
  actions: {
    getTransaction: function getTransaction(_ref, transactionId) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('transactions/' + transactionId).catch(function (err) {
        throw err;
      });
    },
    getFailedCancelledTransactions: function getFailedCancelledTransactions(_ref2) {
      var commit = _ref2.commit;

      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["T" /* GET_TRANSACTION_LIST_REQUEST */]);
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('transactions/failed-cancelled').then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["U" /* GET_TRANSACTION_LIST_SUCCESS */]);
        return response;
      }).catch(function (err) {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["S" /* GET_TRANSACTION_LIST_FAILURE */]);
        throw err;
      });
    },
    retryTransaction: function retryTransaction(_ref3, transactionId) {
      var commit = _ref3.commit;

      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["l" /* DISABLE_SUBMIT_DETAIL_TRANSACTION */]);
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].post('transactions/' + transactionId + '/retry').then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["m" /* ENABLE_SUBMIT_DETAIL_TRANSACTION */]);
        return response;
      }).catch(function (error) {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["m" /* ENABLE_SUBMIT_DETAIL_TRANSACTION */]);
        throw error;
      });
    },
    retryFailedTransaction: function retryFailedTransaction(_ref4, payload) {
      var commit = _ref4.commit;
      var transactionId = payload.transactionId,
          comment = payload.comment,
          accountId = payload.accountId,
          fundingSourceId = payload.fundingSourceId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('/transactions/' + transactionId + '/retry', {
        comment: comment,
        accountId: accountId,
        fundingSourceId: fundingSourceId
      }).then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    saveLostComment: function saveLostComment(_ref5, _ref6) {
      var commit = _ref5.commit;
      var id = _ref6.id,
          comment = _ref6.comment;

      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["l" /* DISABLE_SUBMIT_DETAIL_TRANSACTION */]);
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].patchV2('transactions/' + id, { comment: comment }).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["m" /* ENABLE_SUBMIT_DETAIL_TRANSACTION */]);
        return response;
      }).catch(function (error) {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["m" /* ENABLE_SUBMIT_DETAIL_TRANSACTION */]);
        throw error;
      });
    },
    lostTransaction: function lostTransaction(_ref7, _ref8) {
      var commit = _ref7.commit;
      var transactionId = _ref8.transactionId;

      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["l" /* DISABLE_SUBMIT_DETAIL_TRANSACTION */]);
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('transactions/' + transactionId + '/lost').then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["m" /* ENABLE_SUBMIT_DETAIL_TRANSACTION */]);
        return response;
      }).catch(function (error) {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["m" /* ENABLE_SUBMIT_DETAIL_TRANSACTION */]);
        throw error;
      });
    },
    updateTransaction: function updateTransaction(_ref9, _ref10) {
      var commit = _ref9.commit;
      var transactionId = _ref10.transactionId,
          payload = _ref10.payload;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].patchV2('transactions/' + transactionId, payload).then(function (response) {
        return response;
      }).catch(function (error) {
        throw error;
      });
    },
    getAccountTransactionsSummary: function getAccountTransactionsSummary(_ref11, _ref12) {
      var commit = _ref11.commit;
      var accountId = _ref12.accountId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].getV2('accounts/' + accountId + '/transactions/summary').then(function (response) {
        return response;
      }).catch(function (err) {
        throw err;
      });
    },
    updateUpcomingTransaction: function updateUpcomingTransaction(_ref13, _ref14) {
      var commit = _ref13.commit;
      var payload = _ref14.payload,
          transactionId = _ref14.transactionId;

      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["V" /* UPDATE_UPCOMING_TRANSACTION_REQUEST */]);
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('transactions/upcoming/' + transactionId, payload).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["W" /* UPDATE_UPCOMING_TRANSACTION_RESPONDED */]);
        return response;
      }).catch(function (error) {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["W" /* UPDATE_UPCOMING_TRANSACTION_RESPONDED */]);
        throw error;
      });
    },
    updateUpcomingTransactionByAdmin: function updateUpcomingTransactionByAdmin(_ref15, _ref16) {
      var commit = _ref15.commit;
      var payload = _ref16.payload,
          transactionId = _ref16.transactionId;

      commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["V" /* UPDATE_UPCOMING_TRANSACTION_REQUEST */]);
      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].put('upcoming-transactions/' + transactionId + '/admin', payload).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["W" /* UPDATE_UPCOMING_TRANSACTION_RESPONDED */]);
        return response;
      }).catch(function (error) {
        commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["W" /* UPDATE_UPCOMING_TRANSACTION_RESPONDED */]);
        throw error;
      });
    },
    setTransactionAsProcessed: function setTransactionAsProcessed(_ref17, _ref18) {
      var commit = _ref17.commit;
      var transactionId = _ref18.transactionId;

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].putV2('transactions/' + transactionId + '/process-manually').then(function (response) {
        return response;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    markTransactionAsFailed: function markTransactionAsFailed(_ref20, _ref19) {
      var commit = _ref20.commit;

      var id = _ref19.id,
          body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref19, ['id']);

      return __WEBPACK_IMPORTED_MODULE_5__api_HttpService__["a" /* default */].postV2('transactions/' + id + '/mark-as-failed', body).then(function (response) {
        return response;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }
  }
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(8);


var _mutations;



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    isTransactionModalVisible: false,
    noteId: '',
    transactions: [],
    noteOpenedOn: ''
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["G" /* HIDE_TRANSACTION_MODAL */], function (state) {
    state.isTransactionModalVisible = false;
    state.noteId = '';
    state.transactions = [];
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["F" /* SHOW_TRANSACTION_MODAL */], function (state, note) {
    state.isTransactionModalVisible = true;
    state.noteId = note.id;
    state.transactions = note.transactions;
    state.noteOpenedOn = note.openedOn;
  }), _mutations)
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(8);



var _mutations;




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    investor: {},
    disableSubmitSearch: false,
    impactPreferencesUpdated: false,
    userSearched: null,
    newUserEmail: '',
    searchString: '',
    currentlySearchingBy: 'NAME_EMAIL'
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["M" /* ENABLE_SUBMIT_SEARCH */], function (state) {
    state.disableSubmitSearch = false;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["N" /* DISABLE_SUBMIT_SEARCH */], function (state) {
    state.disableSubmitSearch = true;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["J" /* SET_NEW_USER_EMAIL */], function (state, email) {
    state.newUserEmail = email;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["B" /* SET_SEARCH_STRING */], function (state, searchString) {
    state.searchString = searchString;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["C" /* SET_CURRENTLY_SEARCHING_BY */], function (state, searchingBy) {
    state.currentlySearchingBy = searchingBy;
  }), _mutations),
  actions: {
    getInvestors: function getInvestors(_ref, searchKeyword) {
      var commit = _ref.commit;

      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["N" /* DISABLE_SUBMIT_SEARCH */]);
      return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].get('users?search=' + searchKeyword).catch(function () {}).then(function (response) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["M" /* ENABLE_SUBMIT_SEARCH */]);
        return response;
      });
    },
    storeUserInSessionStorage: function storeUserInSessionStorage(_ref2, userId) {
      var commit = _ref2.commit;

      sessionStorage.setItem('searchedUser', userId);
    },
    resendEmailVerificationEmail: function resendEmailVerificationEmail(_ref3, email) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].post('user/resend-verification-email', { email: email });
    },
    getAnnouncement: function getAnnouncement() {
      return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].getV2('settings/announcement').catch(function () {
        return {};
      });
    },
    createAnnouncement: function createAnnouncement(_ref4, announcement) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].postV2('settings/announcement', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, announcement));
    },
    storeAccountTypeInSessionStorage: function storeAccountTypeInSessionStorage(_ref5, accountType) {
      var commit = _ref5.commit;

      sessionStorage.setItem('accountTypeToCreate', accountType);
    },
    updateFinancialAdvisor: function updateFinancialAdvisor(_ref6, _ref7) {
      var commit = _ref6.commit;
      var userId = _ref7.userId,
          provideLogin = _ref7.provideLogin,
          payload = _ref7.payload,
          _ref7$enableMfa = _ref7.enableMfa,
          enableMfa = _ref7$enableMfa === undefined ? false : _ref7$enableMfa;

      return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].putV2('users/' + userId + '/financial-advisor?provideLogin=' + provideLogin + '&enableMfa=' + enableMfa, payload).then(function (response) {
        return response;
      }).catch(function (error) {
        throw error;
      });
    },
    addUserComments: function addUserComments(_ref8, _ref9) {
      var commit = _ref8.commit;
      var userId = _ref9.userId,
          payload = _ref9.payload;

      return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].putV2('users/' + userId + '/comments', payload).then(function (response) {
        return response;
      }).catch(function (error) {
        throw error;
      });
    },
    mergePartialUser: function mergePartialUser(_ref10, _ref11) {
      var commit = _ref10.commit;
      var partialUserId = _ref11.partialUserId,
          targetUserId = _ref11.targetUserId;

      return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].postV2('users/merge-partial-user', {
        partialUserId: partialUserId,
        targetUserId: targetUserId
      }).then(function (response) {
        return response;
      }).catch(function (error) {
        throw error;
      });
    }
  }
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_HttpService__ = __webpack_require__(20);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: {
    checkAvailability: function checkAvailability(_, _ref) {
      var _this = this;

      var email = _ref.email,
          ssn = _ref.ssn;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var payload, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                payload = {};

                if (email) {
                  payload.email = email;
                } else if (ssn) {
                  payload.ssn = ssn;
                }
                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].postV2('users/availability', payload);

              case 5:
                response = _context.sent;
                return _context.abrupt('return', response.available);

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](2);

                console.error('Error checking availability:', _context.t0);
                throw _context.t0;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 9]]);
      }))();
    },
    provisionUser: function provisionUser(_, _ref2) {
      var user = _ref2.user,
          _ref2$provideLogin = _ref2.provideLogin,
          provideLogin = _ref2$provideLogin === undefined ? false : _ref2$provideLogin,
          _ref2$enableMfa = _ref2.enableMfa,
          enableMfa = _ref2$enableMfa === undefined ? false : _ref2$enableMfa;

      return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].postV2('users/provisioning?provideLogin=' + provideLogin + '&enableMfa=' + enableMfa, user);
    },
    updateUser: function updateUser(_, _ref3) {
      var userId = _ref3.userId,
          user = _ref3.user,
          _ref3$provideLogin = _ref3.provideLogin,
          provideLogin = _ref3$provideLogin === undefined ? false : _ref3$provideLogin,
          _ref3$enableMfa = _ref3.enableMfa,
          enableMfa = _ref3$enableMfa === undefined ? false : _ref3$enableMfa;

      return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].putV2('users/' + userId + '?provideLogin=' + provideLogin + '&enableMfa=' + enableMfa, user);
    },
    saveUserProfile: function saveUserProfile(_, _ref4) {
      var user = _ref4.user,
          files = _ref4.files,
          _ref4$provideLogin = _ref4.provideLogin,
          provideLogin = _ref4$provideLogin === undefined ? false : _ref4$provideLogin,
          _ref4$enableMfa = _ref4.enableMfa,
          enableMfa = _ref4$enableMfa === undefined ? false : _ref4$enableMfa;
      var firstName = user.firstName,
          lastName = user.lastName,
          email = user.email,
          organizationName = user.organizationName,
          alternateCompanyName = user.alternateCompanyName,
          CRDnumber = user.CRDnumber,
          primaryPhoneNum = user.primaryPhoneNum,
          secondaryPhoneNum = user.secondaryPhoneNum,
          residentialAddress = user.residentialAddress,
          mailingAddress = user.mailingAddress;

      if (user.userType === 'ADVISOR') {
        var advisor = {
          firstName: firstName,
          lastName: lastName,
          email: typeof email === 'string' ? email.toLowerCase() : '',
          organizationName: organizationName,
          alternateCompanyName: alternateCompanyName,
          CRDnumber: CRDnumber,
          primaryPhoneNum: primaryPhoneNum,
          secondaryPhoneNum: secondaryPhoneNum,
          residentialAddress: residentialAddress,
          mailingAddress: mailingAddress
        };
        return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].post('financial-user?provideLogin=' + provideLogin + '&enableMfa=' + enableMfa, advisor);
      }
      if (user.userType === 'INVESTOR' || user.userType === 'MINOR') {
        return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].uploadFilesAndForm('user/create-investor?provideLogin=' + provideLogin + '&enableMfa=' + enableMfa, user, files).then(function (response) {
          return response;
        }).catch(function (err) {
          throw err;
        });
      }
      if (user.userType === 'INSTITUTIONAL_REPRESENTATIVE' || user.userType === 'READ_ONLY') {
        return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].post('institutional-representative?provideLogin=' + provideLogin + '&enableMfa=' + enableMfa, user).then(function (response) {
          return response;
        }).catch(function (err) {
          throw err;
        });
      }
      var admin = {
        firstName: firstName,
        lastName: lastName,
        email: typeof email === 'string' ? email.toLowerCase() : '',
        organizationName: organizationName,
        primaryPhoneNum: primaryPhoneNum,
        secondaryPhoneNum: secondaryPhoneNum,
        residentialAddress: residentialAddress,
        mailingAddress: mailingAddress
      };
      return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].post('admin', admin);
    },
    updateUserProfile: function updateUserProfile(_, _ref5) {
      var user = _ref5.user,
          _ref5$provideLogin = _ref5.provideLogin,
          provideLogin = _ref5$provideLogin === undefined ? false : _ref5$provideLogin,
          _ref5$enableMfa = _ref5.enableMfa,
          enableMfa = _ref5$enableMfa === undefined ? false : _ref5$enableMfa;
      var id = user.id,
          firstName = user.firstName,
          lastName = user.lastName,
          email = user.email,
          dateOfBirth = user.dateOfBirth,
          secondaryEmail = user.secondaryEmail,
          primaryPhoneNum = user.primaryPhoneNum,
          secondaryPhoneNum = user.secondaryPhoneNum,
          mfaPhonePreference = user.mfaPhonePreference,
          residentialAddress = user.residentialAddress,
          mailingAddress = user.mailingAddress,
          socialSecurityNum = user.socialSecurityNum,
          userType = user.userType,
          hasBeenAllowedPOBox = user.hasBeenAllowedPOBox,
          hasBeenAllowedCommercialAddress = user.hasBeenAllowedCommercialAddress,
          commercialAddressOverrideComment = user.commercialAddressOverrideComment,
          commentCategories = user.commentCategories,
          comments = user.comments;

      if (user.userType === 'INVESTOR' || user.userType === 'MINOR' || user.userType === 'INSTITUTIONAL_REPRESENTATIVE' || user.userType === 'READ_ONLY') {
        var investor = {
          id: id,
          firstName: firstName,
          lastName: lastName,
          email: typeof email === 'string' ? email.toLowerCase() : '',
          dateOfBirth: dateOfBirth,
          socialSecurityNum: socialSecurityNum,
          secondaryEmail: typeof secondaryEmail === 'string' ? secondaryEmail.toLowerCase() : '',
          userType: userType,
          primaryPhoneNum: primaryPhoneNum,
          secondaryPhoneNum: secondaryPhoneNum,
          mfaPhonePreference: mfaPhonePreference,
          residentialAddress: residentialAddress,
          mailingAddress: mailingAddress,
          hasBeenAllowedPOBox: hasBeenAllowedPOBox,
          hasBeenAllowedCommercialAddress: hasBeenAllowedCommercialAddress,
          commercialAddressOverrideComment: commercialAddressOverrideComment,
          commentCategories: commentCategories,
          comments: comments
        };
        return __WEBPACK_IMPORTED_MODULE_2__api_HttpService__["a" /* default */].putV2('users/' + id + '/profile?provideLogin=' + provideLogin + '&enableMfa=' + enableMfa, investor).then(function (response) {
          return response;
        }).catch(function (err) {
          throw err;
        });
      }
      return false;
    }
  }
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return retryFn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);




// eslint-disable-next-line import/prefer-default-export
var retryFn = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(fn) {
    var _this = this;

    var retries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
    var attempt;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            attempt = function () {
              var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(retryCount) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return fn();

                      case 3:
                        return _context.abrupt("return", _context.sent);

                      case 6:
                        _context.prev = 6;
                        _context.t0 = _context["catch"](0);

                        if (!(retryCount <= 0)) {
                          _context.next = 10;
                          break;
                        }

                        throw _context.t0;

                      case 10:
                        _context.next = 12;
                        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (res) {
                          return setTimeout(res, delay);
                        });

                      case 12:
                        return _context.abrupt("return", attempt(retryCount - 1));

                      case 13:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, _this, [[0, 6]]);
              }));

              return function attempt(_x4) {
                return _ref2.apply(this, arguments);
              };
            }();

            return _context2.abrupt("return", attempt(retries));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function retryFn(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUserIdleTimeConfig;

// eslint-disable-next-line import/prefer-default-export
function getUserIdleTimeConfig(isAdmin) {
  return isAdmin ? 540000 : 300000;
}

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ConnectedOverlayScrollHandler__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ConnectedOverlayScrollHandler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_ConnectedOverlayScrollHandler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ObjectUtils__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ObjectUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utils_ObjectUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_DomHandler__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_DomHandler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__utils_DomHandler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ripple_Ripple__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ripple_Ripple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ripple_Ripple__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        value: null,
        options: Array,
        optionLabel: null,
        optionValue: null,
        optionDisabled: null,
        scrollHeight: {
            type: String,
            default: '200px'
        },
        placeholder: String,
        disabled: Boolean,
        filter: Boolean,
        tabindex: String,
        inputId: String,
        dataKey: null,
        filterPlaceholder: String,
        filterLocale: String,
        ariaLabelledBy: null,
        appendTo: {
            type: String,
            default: null
        },
        emptyFilterMessage: {
            type: String,
            default: 'No results found'
        },
        display: {
            type: String,
            default: 'comma'
        },
        selectionLimit: {
            type: Number,
            default: null
        },
        showToggleAll: {
            type: Boolean,
            default: true
        }
    },
    data: function data() {
        return {
            focused: false,
            headerCheckboxFocused: false,
            filterValue: null,
            overlayVisible: false
        };
    },

    outsideClickListener: null,
    resizeListener: null,
    scrollHandler: null,
    updated: function updated() {
        this.onFilterUpdated();
    },
    beforeDestroy: function beforeDestroy() {
        this.restoreAppend();
        this.unbindOutsideClickListener();
        this.unbindResizeListener();

        if (this.scrollHandler) {
            this.scrollHandler.destroy();
            this.scrollHandler = null;
        }
    },

    methods: {
        getOptionLabel: function getOptionLabel(option) {
            return this.optionLabel ? __WEBPACK_IMPORTED_MODULE_3__utils_ObjectUtils___default.a.resolveFieldData(option, this.optionLabel) : option;
        },
        getOptionValue: function getOptionValue(option) {
            return this.optionValue ? __WEBPACK_IMPORTED_MODULE_3__utils_ObjectUtils___default.a.resolveFieldData(option, this.optionValue) : option;
        },
        getOptionRenderKey: function getOptionRenderKey(option) {
            return this.dataKey ? __WEBPACK_IMPORTED_MODULE_3__utils_ObjectUtils___default.a.resolveFieldData(option, this.dataKey) : this.getOptionLabel(option);
        },
        isOptionDisabled: function isOptionDisabled(option) {
            if (this.maxSelectionLimitReached && !this.isSelected(option)) {
                return true;
            }
            return this.optionDisabled ? __WEBPACK_IMPORTED_MODULE_3__utils_ObjectUtils___default.a.resolveFieldData(option, this.optionDisabled) : false;
        },
        isSelected: function isSelected(option) {
            var selected = false;
            var optionValue = this.getOptionValue(option);

            if (this.value) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var val = _step.value;

                        if (__WEBPACK_IMPORTED_MODULE_3__utils_ObjectUtils___default.a.equals(val, optionValue, this.equalityKey)) {
                            selected = true;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            return selected;
        },
        show: function show() {
            this.$emit('before-show');
            this.overlayVisible = true;
        },
        hide: function hide() {
            this.$emit('before-hide');
            this.overlayVisible = false;
        },
        onFocus: function onFocus() {
            this.focused = true;
        },
        onBlur: function onBlur() {
            this.focused = false;
        },
        onHeaderCheckboxFocus: function onHeaderCheckboxFocus() {
            this.headerCheckboxFocused = true;
        },
        onHeaderCheckboxBlur: function onHeaderCheckboxBlur() {
            this.headerCheckboxFocused = false;
        },
        onClick: function onClick(event) {
            if (!this.disabled && (!this.$refs.overlay || !this.$refs.overlay.contains(event.target)) && !__WEBPACK_IMPORTED_MODULE_4__utils_DomHandler___default.a.hasClass(event.target, 'p-multiselect-close')) {
                if (this.overlayVisible) this.hide();else this.show();

                this.$refs.focusInput.focus();
            }
        },
        onCloseClick: function onCloseClick() {
            this.hide();
        },
        onKeyDown: function onKeyDown(event) {
            switch (event.which) {
                //down
                case 40:
                    if (this.visibleOptions && !this.overlayVisible && event.altKey) {
                        this.show();
                    }
                    break;

                //space
                case 32:
                    if (!this.overlayVisible) {
                        this.show();
                        event.preventDefault();
                    }
                    break;

                //enter and escape
                case 13:
                case 27:
                    if (this.overlayVisible) {
                        this.hide();
                        event.preventDefault();
                    }
                    break;

                //tab
                case 9:
                    this.hide();
                    break;

                default:
                    break;
            }
        },
        onOptionSelect: function onOptionSelect(event, option) {
            var _this = this;

            if (this.disabled || this.isOptionDisabled(option)) {
                return;
            }

            var selected = this.isSelected(option);
            var value = null;

            if (selected) value = this.value.filter(function (val) {
                return !__WEBPACK_IMPORTED_MODULE_3__utils_ObjectUtils___default.a.equals(val, _this.getOptionValue(option), _this.equalityKey);
            });else value = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.value || []), [this.getOptionValue(option)]);

            this.$emit('input', value);
            this.$emit('change', { originalEvent: event, value: value });
        },
        onOptionKeyDown: function onOptionKeyDown(event, option) {
            var listItem = event.target;

            switch (event.which) {
                //down
                case 40:
                    var nextItem = this.findNextItem(listItem);
                    if (nextItem) {
                        nextItem.focus();
                    }

                    event.preventDefault();
                    break;

                //up
                case 38:
                    var prevItem = this.findPrevItem(listItem);
                    if (prevItem) {
                        prevItem.focus();
                    }

                    event.preventDefault();
                    break;

                //enter
                case 13:
                    this.onOptionSelect(event, option);
                    event.preventDefault();
                    break;

                default:
                    break;
            }
        },
        findNextItem: function findNextItem(item) {
            var nextItem = item.nextElementSibling;

            if (nextItem) return __WEBPACK_IMPORTED_MODULE_4__utils_DomHandler___default.a.hasClass(nextItem, 'p-disabled') ? this.findNextItem(nextItem) : nextItem;else return null;
        },
        findPrevItem: function findPrevItem(item) {
            var prevItem = item.previousElementSibling;

            if (prevItem) return __WEBPACK_IMPORTED_MODULE_4__utils_DomHandler___default.a.hasClass(prevItem, 'p-disabled') ? this.findPrevItem(prevItem) : prevItem;else return null;
        },
        onOverlayEnter: function onOverlayEnter() {
            this.$refs.overlay.style.zIndex = String(__WEBPACK_IMPORTED_MODULE_4__utils_DomHandler___default.a.generateZIndex());
            this.appendContainer();
            this.alignOverlay();
            this.bindOutsideClickListener();
            this.bindScrollListener();
            this.bindResizeListener();
            this.$emit('show');

            if (this.filter) {
                this.$refs.filterInput.focus();
            }
        },
        onOverlayLeave: function onOverlayLeave() {
            this.unbindOutsideClickListener();
            this.unbindScrollListener();
            this.unbindResizeListener();
            this.$emit('hide');
        },
        alignOverlay: function alignOverlay() {
            if (this.appendTo) {
                __WEBPACK_IMPORTED_MODULE_4__utils_DomHandler___default.a.absolutePosition(this.$refs.overlay, this.$refs.container);
                this.$refs.overlay.style.minWidth = __WEBPACK_IMPORTED_MODULE_4__utils_DomHandler___default.a.getOuterWidth(this.$refs.container) + 'px';
            } else {
                __WEBPACK_IMPORTED_MODULE_4__utils_DomHandler___default.a.relativePosition(this.$refs.overlay, this.$refs.container);
            }
        },
        bindOutsideClickListener: function bindOutsideClickListener() {
            var _this2 = this;

            if (!this.outsideClickListener) {
                this.outsideClickListener = function (event) {
                    if (_this2.overlayVisible && _this2.isOutsideClicked(event)) {
                        _this2.hide();
                    }
                };
                document.addEventListener('click', this.outsideClickListener);
            }
        },
        unbindOutsideClickListener: function unbindOutsideClickListener() {
            if (this.outsideClickListener) {
                document.removeEventListener('click', this.outsideClickListener);
                this.outsideClickListener = null;
            }
        },
        bindScrollListener: function bindScrollListener() {
            var _this3 = this;

            if (!this.scrollHandler) {
                this.scrollHandler = new __WEBPACK_IMPORTED_MODULE_2__utils_ConnectedOverlayScrollHandler___default.a(this.$el, function () {
                    if (_this3.overlayVisible) {
                        _this3.hide();
                    }
                });
            }

            this.scrollHandler.bindScrollListener();
        },
        unbindScrollListener: function unbindScrollListener() {
            if (this.scrollHandler) {
                this.scrollHandler.unbindScrollListener();
            }
        },
        bindResizeListener: function bindResizeListener() {
            var _this4 = this;

            if (!this.resizeListener) {
                this.resizeListener = function () {
                    if (_this4.overlayVisible && !__WEBPACK_IMPORTED_MODULE_4__utils_DomHandler___default.a.isAndroid()) {
                        _this4.hide();
                    }
                };
                window.addEventListener('resize', this.resizeListener);
            }
        },
        unbindResizeListener: function unbindResizeListener() {
            if (this.resizeListener) {
                window.removeEventListener('resize', this.resizeListener);
                this.resizeListener = null;
            }
        },
        isOutsideClicked: function isOutsideClicked(event) {
            return !(this.$refs.container.isSameNode(event.target) || this.$refs.container.contains(event.target) || this.$refs.overlay && this.$refs.overlay.contains(event.target));
        },
        getLabelByValue: function getLabelByValue(val) {
            var label = null;

            if (this.options) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.options), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var option = _step2.value;

                        var optionValue = this.getOptionValue(option);

                        if (__WEBPACK_IMPORTED_MODULE_3__utils_ObjectUtils___default.a.equals(optionValue, val, this.equalityKey)) {
                            label = this.getOptionLabel(option);
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }

            return label;
        },
        onToggleAll: function onToggleAll(event) {
            var _this5 = this;

            var value = this.allSelected ? [] : this.visibleOptions && this.visibleOptions.map(function (option) {
                return _this5.getOptionValue(option);
            });

            this.$emit('input', value);
            this.$emit('change', { originalEvent: event, value: value });
        },
        appendContainer: function appendContainer() {
            if (this.appendTo) {
                if (this.appendTo === 'body') document.body.appendChild(this.$refs.overlay);else document.getElementById(this.appendTo).appendChild(this.$refs.overlay);
            }
        },
        restoreAppend: function restoreAppend() {
            if (this.$refs.overlay && this.appendTo) {
                if (this.appendTo === 'body') document.body.removeChild(this.$refs.overlay);else document.getElementById(this.appendTo).removeChild(this.$refs.overlay);
            }
        },
        onFilterChange: function onFilterChange(event) {
            this.$emit('filter', { originalEvent: event, value: event.target.value });
        },
        onFilterUpdated: function onFilterUpdated() {
            if (this.overlayVisible) {
                this.alignOverlay();
            }
        },
        removeChip: function removeChip(item) {
            var _this6 = this;

            var value = this.value.filter(function (val) {
                return !__WEBPACK_IMPORTED_MODULE_3__utils_ObjectUtils___default.a.equals(val, item, _this6.equalityKey);
            });

            this.$emit('input', value);
            this.$emit('change', { originalEvent: event, value: value });
        }
    },
    computed: {
        visibleOptions: function visibleOptions() {
            var _this7 = this;

            if (this.filterValue && this.filterValue.trim().length > 0) return this.options.filter(function (option) {
                return _this7.getOptionLabel(option).toLocaleLowerCase(_this7.filterLocale).indexOf(_this7.filterValue.toLocaleLowerCase(_this7.filterLocale)) > -1;
            });else return this.options;
        },
        containerClass: function containerClass() {
            return ['p-multiselect p-component p-inputwrapper', {
                'p-multiselect-chip': this.display === 'chip',
                'p-disabled': this.disabled,
                'p-focus': this.focused,
                'p-inputwrapper-filled': this.value && this.value.length,
                'p-inputwrapper-focus': this.focused || this.overlayVisible
            }];
        },
        labelClass: function labelClass() {
            return ['p-multiselect-label', {
                'p-placeholder': this.label === this.placeholder,
                'p-multiselect-label-empty': !this.placeholder && (!this.value || this.value.length === 0)
            }];
        },
        label: function label() {
            var label = void 0;

            if (this.value && this.value.length) {
                label = '';
                for (var i = 0; i < this.value.length; i++) {
                    if (i !== 0) {
                        label += ', ';
                    }

                    label += this.getLabelByValue(this.value[i]);
                }
            } else {
                label = this.placeholder;
            }

            return label;
        },
        allSelected: function allSelected() {
            if (this.filterValue && this.filterValue.trim().length > 0) {
                var allSelected = true;
                if (this.visibleOptions.length > 0) {
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.visibleOptions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var option = _step3.value;

                            if (!this.isSelected(option)) {
                                allSelected = false;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                } else allSelected = false;
                return allSelected;
            } else {
                return this.value && this.options && this.value.length > 0 && this.value.length === this.options.length;
            }
        },
        equalityKey: function equalityKey() {
            return this.optionValue ? null : this.dataKey;
        },
        maxSelectionLimitReached: function maxSelectionLimitReached() {
            return this.selectionLimit && this.value && this.value.length === this.selectionLimit;
        }
    },
    directives: {
        'ripple': __WEBPACK_IMPORTED_MODULE_5__ripple_Ripple___default.a
    }
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(128);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TopNavBar__ = __webpack_require__(2072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TopNavBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_TopNavBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SideBar__ = __webpack_require__(2071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SideBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_SideBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AccountSummary__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AccountSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_AccountSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IRAdminSideBar__ = __webpack_require__(2048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IRAdminSideBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_IRAdminSideBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Maintenance__ = __webpack_require__(2055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Maintenance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Maintenance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_MfaPhonePreferenceDialog__ = __webpack_require__(2056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_MfaPhonePreferenceDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_MfaPhonePreferenceDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__ = __webpack_require__(8);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var isAuthenticated, user;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getStaticInformation();

            case 2:
              _context.next = 4;
              return _this.$cognitoAuth.isAuthenticated();

            case 4:
              isAuthenticated = _context.sent;

              _this.shouldRoutesBeDisplayed = !_this.maintenance;

              if (!(isAuthenticated && _this.shouldRoutesBeDisplayed)) {
                _context.next = 16;
                break;
              }

              _context.next = 9;
              return _this.getUserProfile();

            case 9:
              user = _context.sent;

              console.log('beforeMount: User profile loaded', {
                userId: user.userId,
                isMfaEnabled: user.isMfaEnabled,
                mfaPhonePreference: user.mfaPhonePreference
              });
              _this.setUser(user);
              _this.user = user;
              _this.currentUser = user;
              _this.checkForAccountStatus(user);

              // Check if user needs to set up phone MFA after login
              _this.checkPhoneMfaSetup(user);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    console.log('mounted: Checking MFA setup', {
      shouldRoutesBeDisplayed: this.shouldRoutesBeDisplayed,
      hasUser: !!this.user,
      userId: this.user.userId
    });
    // Also check when component mounts (after route navigation)
    if (this.shouldRoutesBeDisplayed && this.user && this.user.userId) {
      this.checkPhoneMfaSetup(this.user);
    }
  },
  updated: function updated() {
    if (this.$refs.sidebar && this.hasBeenCreatedAccount) {
      this.$refs.sidebar.checkUserStatus();
    }
  },
  created: function created() {
    this.startIdleTimer();

    if (location.search) {
      var qs = location.search.slice(1);
      var qsObj = qs.split('&').reduce(function (obj, e) {
        var _e$split = e.split('='),
            _e$split2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_e$split, 2),
            key = _e$split2[0],
            value = _e$split2[1];

        obj[key] = decodeURIComponent(value); // eslint-disable-line no-param-reassign
        return obj;
      }, {});
      qsObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$router.currentRoute.query, qsObj);
      var newUrlHash = this.$router.resolve({
        query: qsObj
      }).href;
      location.replace('/' + newUrlHash);
    }
  },

  components: {
    sidebar: __WEBPACK_IMPORTED_MODULE_6__components_SideBar___default.a,
    topnavbar: __WEBPACK_IMPORTED_MODULE_5__components_TopNavBar___default.a,
    iradminsidebar: __WEBPACK_IMPORTED_MODULE_8__components_IRAdminSideBar___default.a,
    maintenance: __WEBPACK_IMPORTED_MODULE_9__components_Maintenance___default.a,
    accountSummary: __WEBPACK_IMPORTED_MODULE_7__components_AccountSummary___default.a,
    MfaPhonePreferenceDialog: __WEBPACK_IMPORTED_MODULE_10__components_MfaPhonePreferenceDialog___default.a
  },
  data: function data() {
    return {
      user: {
        roles: []
      },
      currentRoute: window.location.pathname,
      shouldRoutesBeDisplayed: false,
      showPhonePreferenceDialog: false,
      currentUser: null,
      isDrawerOpen: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["a" /* mapState */])('app', ['irAdmin', 'maintenance']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["b" /* mapGetters */])('app', ['hasBeenCreatedAccount']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["a" /* mapState */])('idle', ['isUserIdle'])),
  watch: {
    isUserIdle: function isUserIdle(idle) {
      if (idle) this.onIdle();
    },
    irAdmin: function irAdmin() {
      this.startIdleTimer();
    },

    $route: {
      handler: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
          var _this2 = this;

          var userToCheck;
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (this.checkRoute()) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt('return');

                case 2:

                  // Check phone MFA setup after route navigation
                  // This ensures the dialog shows after user lands on their page
                  console.log('Route changed, checking MFA setup', {
                    shouldRoutesBeDisplayed: this.shouldRoutesBeDisplayed,
                    hasUser: !!this.user,
                    userId: this.user.userId
                  });

                  if (!this.shouldRoutesBeDisplayed) {
                    _context2.next = 20;
                    break;
                  }

                  // Ensure we have fresh user data after route navigation
                  // This is especially important after login when App.vue is already mounted
                  userToCheck = this.user;

                  if (!(!userToCheck || !userToCheck.userId)) {
                    _context2.next = 19;
                    break;
                  }

                  _context2.prev = 6;
                  _context2.next = 9;
                  return this.getUserProfile();

                case 9:
                  userToCheck = _context2.sent;

                  this.setUser(userToCheck);
                  this.user = userToCheck;
                  this.currentUser = userToCheck;
                  _context2.next = 19;
                  break;

                case 15:
                  _context2.prev = 15;
                  _context2.t0 = _context2['catch'](6);

                  console.error('Error fetching user profile on route change:', _context2.t0);
                  return _context2.abrupt('return');

                case 19:

                  // Small delay to let the page render first
                  this.$nextTick(function () {
                    _this2.checkPhoneMfaSetup(userToCheck);
                  });

                case 20:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[6, 15]]);
        }));

        function handler() {
          return _ref.apply(this, arguments);
        }

        return handler;
      }()
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["c" /* mapActions */])('accountCreation', ['getUserProfile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["d" /* mapMutations */])('app', {
    setUser: __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__["a" /* SET_USER */],
    setAccountStatus: __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__["b" /* SET_ACCOUNT_STATUS */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["d" /* mapMutations */])('authentication', {
    setIdle: __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__["c" /* SET_IDLE_ON */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["c" /* mapActions */])('authentication', ['logOut']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_vuex__["c" /* mapActions */])('app', ['getStaticInformation']), {
    forceUpdate: function forceUpdate() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this3.$refs.accountSummary) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 3;
                return _this3.$refs.accountSummary.updateAccountSummary();

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    toggleDrawer: function toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
    },
    handleDrawerClosed: function handleDrawerClosed() {
      this.isDrawerOpen = false;
    },
    checkRoute: function checkRoute() {
      var name = this.$route.name;

      var excludedRoutes = ['Login', 'Registration', 'ResetPassword', 'ErrorAuth', 'EmbedLogin', 'ChangePassword', 'VerifyEmail'];
      return name && !excludedRoutes.includes(name);
    },
    checkForAccountStatus: function checkForAccountStatus(userInformation) {
      if (userInformation.accounts && userInformation.accounts.length) {
        var status = userInformation.accounts[0].status;

        this.setAccountStatus(status);
      }
    },
    startIdleTimer: function startIdleTimer() {
      this.$store.dispatch('idle/startIdle', {
        idleTime: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* getUserIdleTimeConfig */])(this.irAdmin)
      });
    },
    onIdle: function onIdle() {
      var isAutoLogoutView = this.checkRoute();
      if (isAutoLogoutView) {
        this.callLogout();
        this.setIdle();
      }
    },
    callLogout: function callLogout() {
      var _this4 = this;

      return this.$cognitoAuth.logout().then(function () {
        return _this4.getStaticInformation();
      }).then(function () {
        _this4.$router.push({ name: 'Login' });
      });
    },
    checkPhoneMfaSetup: function checkPhoneMfaSetup(user) {
      if (!user || !user.userId) {
        console.log('checkPhoneMfaSetup: No user or userId', { user: user, userId: user.userId });
        return;
      }

      // Don't show modal for admin users
      if (user.userType === 'ADMIN') {
        console.log('checkPhoneMfaSetup: Skipping admin user');
        return;
      }

      // Check if user needs to set up phone MFA
      var hasMfaPhonePreference = !!user.mfaPhonePreference;
      var hasPhoneNumbers = !!(user.primaryPhoneNum || user.secondaryPhoneNum);

      console.log('checkPhoneMfaSetup:', {
        mfaPhonePreference: user.mfaPhonePreference,
        hasMfaPhonePreference: hasMfaPhonePreference,
        hasPhoneNumbers: hasPhoneNumbers,
        primaryPhone: user.primaryPhoneNum,
        secondaryPhone: user.secondaryPhoneNum,
        shouldShow: !hasMfaPhonePreference && hasPhoneNumbers
      });

      // Show dialog if user has phone numbers but no MFA phone preference is set
      if (!hasMfaPhonePreference && hasPhoneNumbers) {
        console.log('Showing phone preference dialog');
        this.currentUser = user;
        this.showPhonePreferenceDialog = true;
      }
    },
    handlePhonePreferenceSaved: function handlePhonePreferenceSaved() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var updatedUser;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return _this5.getUserProfile();

              case 3:
                updatedUser = _context4.sent;

                _this5.setUser(updatedUser);
                _this5.user = updatedUser;
                _this5.currentUser = updatedUser;
                _this5.showPhonePreferenceDialog = false;
                _context4.next = 14;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](0);

                console.error('Error refreshing user profile:', _context4.t0);
                _this5.showPhonePreferenceDialog = false;

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 10]]);
      }))();
    },
    handlePhonePreferenceCancel: function handlePhonePreferenceCancel() {
      // User cancelled, close dialog
      this.showPhonePreferenceDialog = false;
    }
  })
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_static_events__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__(8);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountBeneficiaries',
  components: {
    Question: __WEBPACK_IMPORTED_MODULE_4__components_modals_Question___default.a
  },
  props: {
    beneficiaries: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      },
      validator: function validator(value) {
        return value.every(function (beneficiary) {
          return typeof beneficiary.beneficiaryName === 'string' && typeof beneficiary.percentage === 'number' && typeof beneficiary.id === 'number';
        });
      }
    },
    accountId: {
      type: [Number, String],
      required: false,
      default: 0
    }
  },
  data: function data() {
    return {
      editingIds: [],
      isLoading: false,
      newBeneficiary: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('question', ['display'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('account', ['deleteAccountBeneficiary', 'saveAccountBeneficiary']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('question', {
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */],
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */]
  }), {
    addNewBeneficiary: function addNewBeneficiary() {
      if (this.beneficiaries.length >= 10) return;
      var newBeneficiary = {
        id: 'B-' + (this.beneficiaries.length + 1),
        beneficiaryName: '',
        percentage: 0
      };
      this.beneficiaries.push(newBeneficiary);
      this.editingIds.push(newBeneficiary.id);
    },
    hasError: function hasError(id) {
      if (this.editingIds.includes(id)) {
        var findBeneficiary = this.beneficiaries.find(function (beneficiary) {
          return beneficiary.id === id;
        });
        if (findBeneficiary.percentage > 100 || findBeneficiary.percentage <= 0) {
          return true;
        }
        var totalPercentage = this.beneficiaries.reduce(function (sum, currentBeneficiary) {
          return sum + parseFloat(currentBeneficiary.percentage);
        }, 0);
        return totalPercentage > 100;
      }
      return false;
    },
    hasNameError: function hasNameError(id) {
      if (this.editingIds.includes(id)) {
        var findBeneficiary = this.beneficiaries.find(function (beneficiary) {
          return beneficiary.id === id;
        });
        return !findBeneficiary.beneficiaryName || !findBeneficiary.beneficiaryName.trim();
      }
      return false;
    },
    editBeneficiary: function editBeneficiary(id) {
      this.editingIds.push(id);
    },
    saveBeneficiary: function saveBeneficiary(id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var updatedBeneficiary, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.hasError(id) || _this.hasNameError(id))) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _this.isLoading = true;
                _context.prev = 3;
                updatedBeneficiary = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.beneficiaries.find(function (beneficiary) {
                  return beneficiary.id === id;
                }));

                if (typeof updatedBeneficiary.id === 'string') {
                  updatedBeneficiary.id = null;
                }
                _context.next = 8;
                return _this.saveAccountBeneficiary({
                  accountId: _this.accountId,
                  beneficiary: updatedBeneficiary
                });

              case 8:
                response = _context.sent;

                _this.beneficiaries = _this.beneficiaries.filter(function (beneficiary) {
                  return beneficiary.id !== id;
                });
                response.percentage = response.percentage.toFixed(2);
                _this.beneficiaries.push(response);

                _this.editingIds = _this.editingIds.filter(function (editingId) {
                  return editingId !== id;
                });
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](3);

                _this.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].BENEFICIARY_LOADING_FAILED);

              case 18:
                _context.prev = 18;

                _this.isLoading = false;
                return _context.finish(18);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 15, 18, 21]]);
      }))();
    },
    deleteBeneficiary: function deleteBeneficiary(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(typeof id === 'string')) {
                  _context3.next = 4;
                  break;
                }

                _this2.editingIds = _this2.editingIds.filter(function (editingId) {
                  return editingId !== id;
                });
                _this2.beneficiaries = _this2.beneficiaries.filter(function (beneficiary) {
                  return beneficiary.id !== id;
                });
                return _context3.abrupt('return');

              case 4:

                _this2.showQuestionModal({
                  title: 'Delete Beneficiary',
                  question: 'Are you sure you want to delete this beneficiary?',
                  method: function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _this2.isLoading = true;
                              _this2.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].BENEFICIARY_LOADING_STARTED);
                              _context2.prev = 2;
                              _context2.next = 5;
                              return _this2.deleteAccountBeneficiary({
                                accountId: _this2.accountId,
                                beneficiaryId: id
                              });

                            case 5:
                              _this2.editingIds = _this2.editingIds.filter(function (editingId) {
                                return editingId !== id;
                              });
                              _this2.beneficiaries = _this2.beneficiaries.filter(function (beneficiary) {
                                return beneficiary.id !== id;
                              });
                              _this2.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].BENEFICIARY_LOADING_SUCCEED);
                              _this2.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].BENEFICIARIES_UPDATED);
                              _context2.next = 14;
                              break;

                            case 11:
                              _context2.prev = 11;
                              _context2.t0 = _context2['catch'](2);

                              _this2.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].BENEFICIARY_LOADING_FAILED);

                            case 14:
                              _context2.prev = 14;

                              _this2.isLoading = false;
                              _this2.hideQuestionModal();
                              return _context2.finish(14);

                            case 18:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this2, [[2, 11, 14, 18]]);
                    }));

                    return function method() {
                      return _ref.apply(this, arguments);
                    };
                  }(),
                  yesButtonText: 'Yes',
                  hideCancelButton: false
                });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    }
  })
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_AddressSuggestion__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_AddressSuggestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_AddressSuggestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Success__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_modals_Success__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_OnboardingWizard__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_OnboardingWizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_OnboardingWizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_TermsOfConditions__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_TermsOfConditions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_TermsOfConditions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__entities_userProfile__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_formControls_RestrictedTwoInputs__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_formControls_RestrictedTwoInputs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_formControls_RestrictedTwoInputs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Addresses__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Addresses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Addresses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__data_static_constants__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__ = __webpack_require__(25);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'accountCreation',
  created: function created() {
    this.setUser(new __WEBPACK_IMPORTED_MODULE_15__entities_userProfile__["a" /* default */]());
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.loadUserProfile();

            case 2:
              if (_this.hasBeenCreatedAccount) {
                _context.next = 4;
                break;
              }

              return _context.abrupt('return');

            case 4:
              _context.next = 6;
              return _this.checkUserStatus();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.loadUserProfile();

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  data: function data() {
    return {
      minimumAge: 18,
      isResidentDefaultAddress: false,
      disableSubmit: false,
      agreeTerms: false,
      dateBirthConfig: {
        format: 'MM/DD/YYYY'
      },
      isBirthFieldInvalid: false,
      dateBirthFormat: 'YYYY-MM-DD',
      creationSucceeded: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('home', ['userStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('user', ['newUserEmail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('app', ['activeAccount', 'user', 'geoLocation']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('app', ['hasBeenCreatedAccount']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('authentication', ['states', 'countries']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('accountCreation', ['isSuggestedAddressModalVisible', 'suggestedAddressModalYesCall']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('success', ['isSuccessModalVisible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('question', ['display']), {
    hasValidationErrors: function hasValidationErrors() {
      return this.errors.has('FirstName') || this.errors.has('LastName') || this.errors.has('ssn') || this.errors.has('primaryPhoneNum');
    }
  }),
  watch: {
    suggestedAddressModalYesCall: function suggestedAddressModalYesCall(_ref) {
      var _this3 = this;

      var payload = _ref.payload,
          suggestedAddress = _ref.suggestedAddress,
          addressType = _ref.addressType;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var address;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                address = _this3.truncateAddressIfNecessary(suggestedAddress);

                if (!_this3.$refs.addresses.isMailingAddressDifferent) {
                  _this3.user.residentialAddress = address;
                  _this3.user.mailingAddress = address;
                  _this3.$refs.addresses.setResidencialAddress(address);
                  _this3.$refs.addresses.setMailingAddress(address);
                }
                if (['residential', 'organization'].includes(addressType)) {
                  _this3.user.residentialAddress = address;
                  _this3.$refs.addresses.setResidencialAddress(address);
                } else if (addressType === 'mailing') {
                  _this3.user.mailingAddress = address;
                  _this3.$refs.addresses.setMailingAddress(address);
                }
                _context3.next = 5;
                return _this3.save(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, payload, {
                  residentialAddress: _this3.user.residentialAddress,
                  mailingAddress: _this3.user.mailingAddress
                }));

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('app', ['activeAccountId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('home', ['getUserStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('accountCreation', ['saveUserProfile', 'updateAccountProvisioned', 'updateDwollaUser', 'getUserProfile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('app', {
    setActiveAccountId: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["f" /* SET_ACTIVE_ACCOUNT_ID */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('app', {
    setUser: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["a" /* SET_USER */],
    setAccountUser: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["b" /* SET_ACCOUNT_STATUS */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('success', {
    showSuccessModal: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["H" /* SHOW_SUCCESS_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('accountCreation', {
    setSuggestedAddress: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["o" /* SET_SUGGESTED_ADDRESS */],
    setSuggestedAddressType: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["p" /* SET_SUGGESTED_ADDRESS_TYPE */],
    setSuggestedAddressModalVisible: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["q" /* SET_SUGGESTED_ADDRESS_MODAL_VISIBLE */],
    setSuggestedAddressYesMethod: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["r" /* SET_SUGGESTED_ADDRESS_YES_METHOD */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), {
    residentialAdressUpdated: function residentialAdressUpdated($event) {
      this.user.residentialAddress.streetAddress1 = $event.primary;
      this.user.residentialAddress.streetAddress2 = $event.secondary;
    },
    mailingAddressUpdated: function mailingAddressUpdated($event) {
      this.user.mailingAddress.streetAddress1 = $event.primary;
      this.user.mailingAddress.streetAddress2 = $event.secondary;
    },
    loadUserProfile: function loadUserProfile() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var userData;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.getUserProfile();

              case 2:
                userData = _context4.sent;
                _context4.next = 5;
                return _this4.handleUserProfile(userData);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    handleUserProfile: function handleUserProfile(data) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!_this5.isNewUser(data)) {
                  _context5.next = 4;
                  break;
                }

                _context5.next = 3;
                return _this5.handleUserMetadata(data);

              case 3:
                return _context5.abrupt('return');

              case 4:
                user = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data);

                user.socialSecurityNum = 'xxx-xx-' + data.socialSecurityNum;
                user.dateOfBirth = __WEBPACK_IMPORTED_MODULE_7_moment___default.a.utc(data.dateOfBirth + ' 12:00:00');
                user.updateCount = user.updateCount ? user.updateCount : 0;
                user.isResidentDefaultAddress = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util__["L" /* addressAreEqual */])(user.residentialAddress, user.mailingAddress);
                _this5.setUser(user);

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    handleUserMetadata: function handleUserMetadata(_ref2) {
      var state = _ref2.state;

      var USCountry = this.geoLocation.countries.find(function (ct) {
        return ct.abbreviation.includes('US');
      });
      this.user.residentialAddress.state = state;
      this.user.residentialAddress.country = USCountry.abbreviation;
      this.user.mailingAddress.country = USCountry.abbreviation;
      this.user.dateOfBirth = '';
    },
    isNewUser: function isNewUser(data) {
      return data.email === '' || !data.firstName && !data.lastName;
    },
    isDateBirthValid: function isDateBirthValid(dateOfBirth) {
      if (dateOfBirth === '') {
        return false;
      }
      var birthYear = new Date(dateOfBirth).getFullYear();
      var currentYear = new Date().getFullYear();
      return currentYear - birthYear >= this.minimumAge;
    },
    getSsnDigits: function getSsnDigits(ssn) {
      return ssn.replace(/[- ]/g, '');
    },
    getPhoneDigits: function getPhoneDigits(phoneNum) {
      return phoneNum.replace(/[-() ]/g, '');
    },
    getDateOnlyDOB: function getDateOnlyDOB(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format(this.dateBirthFormat).toString();
    },
    copyMailingAddress: function copyMailingAddress() {
      this.user.mailingAddress = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.user.residentialAddress);
    },
    isStateSelected: function isStateSelected(userProfile) {
      return userProfile.residentialAddress.state.length > 0;
    },
    checkDateBirth: function checkDateBirth(dateOfBirth) {
      if (dateOfBirth === '' || dateOfBirth === null) {
        this.isBirthFieldInvalid = true;
      } else {
        this.isBirthFieldInvalid = false;
      }
    },
    validateUserProfile: function validateUserProfile(userProfile, agreeTerms) {
      var listUserErrors = [];
      if (!this.isDateBirthValid(userProfile.dateOfBirth)) {
        listUserErrors.push('You must be 18 years or older in order to invest with us.');
      }
      var SsnRegex = /^[0-9x]{3}\-?[0-9x]{2}\-?[0-9]{4}$/; // eslint-disable-line no-useless-escape
      if (!SsnRegex.test(userProfile.socialSecurityNum)) {
        listUserErrors.push('Enter a valid social security number.');
      }
      var phoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/; // eslint-disable-line no-useless-escape
      if (!phoneRegex.test(userProfile.primaryPhoneNum)) {
        listUserErrors.push('Enter a valid primary phone number.');
      }
      if (userProfile.secondaryPhoneNum && userProfile.secondaryPhoneNum.length > 0 && !phoneRegex.test(userProfile.secondaryPhoneNum)) {
        listUserErrors.push('Enter a valid secondary phone number.');
      }
      if (!__WEBPACK_IMPORTED_MODULE_18__util__["p" /* zipRegex */].test(userProfile.residentialAddress.zipCode)) {
        listUserErrors.push('Provide a valid residential zip code.');
      }
      if (this.isResidentDefaultAddress && !__WEBPACK_IMPORTED_MODULE_18__util__["p" /* zipRegex */].test(userProfile.mailingAddress.zipCode)) {
        listUserErrors.push('Provide a valid mailing zip code.');
      }
      if (!agreeTerms) {
        listUserErrors.push('Check the agree terms for submitting purposes.');
      }
      if (!this.isStateSelected(userProfile)) {
        listUserErrors.push('Please select a state in order to save your profile.');
      }
      return listUserErrors;
    },
    setDataWithoutMasks: function setDataWithoutMasks() {
      this.user.primaryPhoneNum = this.getPhoneDigits(this.user.primaryPhoneNum);
      this.user.socialSecurityNum = this.getSsnDigits(this.user.socialSecurityNum);
      this.user.dateOfBirth = this.getDateOnlyDOB(this.user.dateOfBirth);
      if (this.user.secondaryPhoneNum) {
        this.user.secondaryPhoneNum = this.getPhoneDigits(this.user.secondaryPhoneNum);
      }
    },
    truncateAddressIfNecessary: function truncateAddressIfNecessary(address) {
      var localAddress = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, address);
      var hasStreetAddress1 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress1');
      var hasStreetAddress2 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress2');
      if (hasStreetAddress1 && hasStreetAddress2) {
        var totalAdressLength = address.streetAddress1.length + address.streetAddress2.length;
        if (totalAdressLength > 50) {
          var charsToCut = totalAdressLength - 50;
          localAddress.streetAddress2 = address.streetAddress2.slice(0, -charsToCut);
          return localAddress;
        }
      }
      return address;
    },
    showRetryModal: function showRetryModal() {
      var _this6 = this;

      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_20__data_static_constants__["a" /* Constants */].fundingSource.modalTitle,
        question: __WEBPACK_IMPORTED_MODULE_20__data_static_constants__["a" /* Constants */].fundingSource.retrySelfRegisterDisclaimer,
        yesButtonText: __WEBPACK_IMPORTED_MODULE_20__data_static_constants__["a" /* Constants */].fundingSource.modalEditProfileButtonText,
        method: function () {
          var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _this6.hideQuestionModal();

                  case 1:
                  case 'end':
                    return _context6.stop();
                }
              }
            }, _callee6, _this6);
          }));

          return function method() {
            return _ref3.apply(this, arguments);
          };
        }() });
    },
    save: function save(payload) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var errorMessage, _user$accounts, account, status;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                if (!(_this7.hasBeenCreatedAccount && _this7.userStatus && _this7.userStatus.status === 'retry')) {
                  _context7.next = 6;
                  break;
                }

                _context7.next = 4;
                return _this7.updateAccountProvisioned({ user: payload });

              case 4:
                _context7.next = 8;
                break;

              case 6:
                _context7.next = 8;
                return _this7.saveUserProfile({ user: payload });

              case 8:
                _context7.next = 20;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7['catch'](0);

                _this7.disableSubmit = false;

                // Check if this is an SSN-specific error
                errorMessage = _context7.t0 && _context7.t0.message ? _context7.t0.message : 'An error occurred while saving your profile. Please try again.';

                if (!errorMessage.toLowerCase().includes('social security number')) {
                  _context7.next = 17;
                  break;
                }

                // Add SSN validation error to show below the input field
                _this7.$validator.errors.add({
                  field: 'ssn',
                  msg: 'The social security number that was entered is not accepted. Please contact us at info@calvertimpact.org to confirm',
                  id: 'ssn_error'
                });
                return _context7.abrupt('return');

              case 17:

                // Show error modal for any other API errors
                _this7.setErrorsModalInfo([errorMessage]);
                _this7.showErrorsModal();
                return _context7.abrupt('return');

              case 20:
                if (!_this7.isSuggestedAddressModalVisible) {
                  _context7.next = 23;
                  break;
                }

                _this7.disableSubmit = false;

                return _context7.abrupt('return');

              case 23:
                _context7.next = 25;
                return _this7.loadUserProfile();

              case 25:
                _user$accounts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_this7.user.accounts, 1), account = _user$accounts[0];
                status = account.status;

                _this7.setAccountUser(status);

                _this7.updateActiveAccount(account);

                _this7.getUserStatus({
                  accountId: _this7.activeAccount.id
                }).then(function (_ref4) {
                  var status2 = _ref4.status;
                  // eslint-disable-line no-shadow
                  _this7.disableSubmit = false;
                  if (status2 === 'suspended') {
                    _this7.$router.push({
                      name: 'AccountSuspended'
                    });
                  } else if (status2 === 'retry') {
                    _this7.showRetryModal();
                  } else {
                    _this7.creationSucceeded = true;
                    _this7.showSuccessModal(__WEBPACK_IMPORTED_MODULE_20__data_static_constants__["a" /* Constants */].home.successMessage);
                    window.dataLayer.push({
                      event: 'openInvestmentAccount',
                      userID: 'new_user:' + _this7.newUserEmail
                    });
                  }
                });

              case 30:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[0, 10]]);
      }))();
    },
    validateAndSubmitUserProfile: function validateAndSubmitUserProfile() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var listUserErrors, requestUser;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this8.disableSubmit = true;

                // Clear any previous SSN errors
                _this8.$validator.errors.remove('ssn');

                listUserErrors = _this8.validateUserProfile(_this8.user, _this8.agreeTerms);

                if (!(listUserErrors.length > 0)) {
                  _context8.next = 7;
                  break;
                }

                _this8.showUserModalsError(listUserErrors);
                _this8.disableSubmit = false;
                return _context8.abrupt('return', false);

              case 7:
                if (!_this8.$refs.addresses.isMailingAddressDifferent) {
                  _this8.copyMailingAddress();
                }
                _this8.setDataWithoutMasks();
                requestUser = {
                  firstName: _this8.user.firstName,
                  lastName: _this8.user.lastName,
                  userType: __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].INVESTOR.name,
                  primaryPhoneNum: _this8.user.primaryPhoneNum,
                  secondaryPhoneNum: _this8.user.secondaryPhoneNum === '' ? null : _this8.user.secondaryPhoneNum,
                  socialSecurityNum: _this8.user.socialSecurityNum,
                  dateOfBirth: _this8.user.dateOfBirth,
                  residentialAddress: _this8.user.residentialAddress,
                  mailingAddress: _this8.user.mailingAddress
                };
                return _context8.abrupt('return', _this8.save(requestUser));

              case 11:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    updateActiveAccount: function updateActiveAccount(account) {
      this.setActiveAccountId(account);
    },
    showUserModalsError: function showUserModalsError(listUserErrors) {
      this.setErrorsModalInfo(listUserErrors);
      this.showErrorsModal();
    },
    disableSubmitButton: function disableSubmitButton() {
      return !this.user.firstName || !this.user.lastName || !this.user.primaryPhoneNum || !this.user.socialSecurityNum || !this.user.dateOfBirth || this.disableSubmit || !this.agreeTerms || !this.user.residentialAddress.streetAddress1 || !this.user.residentialAddress.zipCode || !this.user.residentialAddress.city || !this.user.residentialAddress.state || this.isResidentDefaultAddress && (!this.user.mailingAddress.streetAddress1 || !this.user.mailingAddress.zipCode || !this.user.mailingAddress.city || !this.user.mailingAddress.state) ||
      // Check for validation errors
      this.errors.has('ssn') || this.errors.has('FirstName') || this.errors.has('LastName') || this.errors.has('primaryPhoneNum');
    },
    checkUserStatus: function checkUserStatus() {
      var _this9 = this;

      this.disableSubmit = true;
      var accountId = this.activeAccount.id;

      if (!this.hasBeenCreatedAccount) {
        this.disableSubmit = false;
        return;
      }

      // Without a real account there is no status to fetch. Asking for
      // account 0 returns a 403, which the HttpService interceptor turns
      // into a redirect to Home. Re-enable the form as the branch above does,
      // so the user is never left with a permanently disabled submit button.
      if (!accountId) {
        this.disableSubmit = false;
        return;
      }

      this.getUserStatus({
        accountId: accountId
      }).then(function (_ref5) {
        var status = _ref5.status,
            needs = _ref5.needs;

        if (status === 'retry') {
          _this9.disableSubmit = false;
          _this9.showRetryModal();
        } else if (status === 'suspended') {
          _this9.$router.push({
            name: 'AccountSuspended'
          });
        } else if (needs.includes('FUNDING_SOURCE')) {
          _this9.$router.push({
            name: 'AddFundingSource'
          });
        } else if (needs.includes('NOTE')) {
          _this9.$router.push({
            name: 'PurchaseNote',
            query: {
              first: 1
            }
          });
        } else if (!needs.length) {
          _this9.$router.push({
            name: 'Notes'
          });
        } else {
          _this9.disableSubmit = false;
        }
      }).catch(function () {
        _this9.disableSubmit = false;
      });
    },
    goToFundingSources: function goToFundingSources() {
      this.$router.push({
        name: 'AddFundingSource'
      });
    },
    ssnInput: function ssnInput() {
      this.$validator.errors.remove('ssn');
    }
  }),
  components: {
    datePicker: __WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker___default.a,
    errors: __WEBPACK_IMPORTED_MODULE_10__components_modals_Errors___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_14__components_widgets_Spinner___default.a,
    success: __WEBPACK_IMPORTED_MODULE_11__components_modals_Success___default.a,
    RestrictedTwoInputs: __WEBPACK_IMPORTED_MODULE_17__components_formControls_RestrictedTwoInputs___default.a,
    TermsOfConditions: __WEBPACK_IMPORTED_MODULE_13__components_TermsOfConditions___default.a,
    question: __WEBPACK_IMPORTED_MODULE_16__components_modals_Question___default.a,
    'address-suggestion': __WEBPACK_IMPORTED_MODULE_9__components_modals_AddressSuggestion___default.a,
    'onboarding-wizard': __WEBPACK_IMPORTED_MODULE_12__components_OnboardingWizard___default.a,
    'addresses-form': __WEBPACK_IMPORTED_MODULE_19__components_Addresses___default.a
  }
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_static_upcomingTransactionActions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_static_userTypes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_static_reinvestProhibitedStates__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_formControls_RestrictedSingleInput__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_formControls_RestrictedSingleInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_formControls_RestrictedSingleInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_widgets_Spinner__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




 // eslint-disable-line no-unused-vars








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'accountCreationAdmin',
  beforeMount: function beforeMount() {
    this.initializeState();
  },

  components: {
    spinner: __WEBPACK_IMPORTED_MODULE_11__components_widgets_Spinner___default.a,
    RestrictedSingleInput: __WEBPACK_IMPORTED_MODULE_9__components_formControls_RestrictedSingleInput___default.a,
    errors: __WEBPACK_IMPORTED_MODULE_5__components_modals_Errors___default.a
  },
  data: function data() {
    return {
      name: '',
      userId: '',
      user: {},
      accountId: '',
      accountType: '',
      accountName: '',
      interestPayment: '',
      principalPayment: '',
      isLoading: false,
      accountNameChanged: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), {
    isFromProhibitedState: function isFromProhibitedState() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_8__data_static_reinvestProhibitedStates__["a" /* default */].find(function (s) {
        return _this.user.residentialAddress && s === _this.user.residentialAddress.state;
      }) !== undefined;
    },
    paymentPreference: function paymentPreference() {
      return this.isFromProhibitedState ? [__WEBPACK_IMPORTED_MODULE_6__data_static_upcomingTransactionActions__["a" /* default */].cashout, __WEBPACK_IMPORTED_MODULE_6__data_static_upcomingTransactionActions__["a" /* default */].donate] : [__WEBPACK_IMPORTED_MODULE_6__data_static_upcomingTransactionActions__["a" /* default */].reinvest, __WEBPACK_IMPORTED_MODULE_6__data_static_upcomingTransactionActions__["a" /* default */].donate, __WEBPACK_IMPORTED_MODULE_6__data_static_upcomingTransactionActions__["a" /* default */].cashout];
    },

    interestPaymentSelected: {
      get: function get() {
        return this.interestPayment ? this.interestPayment : this.paymentPreference[0].name;
      },
      set: function set(preference) {
        this.interestPayment = preference;
      }
    },
    principalPaymentSelected: {
      get: function get() {
        return this.principalPayment ? this.principalPayment : this.paymentPreference[0].name;
      },
      set: function set(preference) {
        this.principalPayment = preference;
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('accountCreation', ['getUserDetail', 'createAccountByAdmin']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_10__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_10__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), {
    initializeState: function initializeState() {
      this.userId = this.$route.params.userId;
      this.name = this.$route.params.name;
      this.accountId = this.$route.params.accountId;
      this.accountType = this.$route.params.accountType;
      this.loadUserDetail();
    },
    loadUserDetail: function loadUserDetail() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.isLoading = true;
                _context.next = 3;
                return _this2.getUserDetail(_this2.userId).then(function (data) {
                  _this2.user = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data);
                  _this2.isLoading = false;
                }).catch(function () {
                  _this2.isLoading = false;
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    isSubmitButtonDisabled: function isSubmitButtonDisabled() {
      if (!this.interestPaymentSelected) {
        return true;
      }
      if (!this.principalPaymentSelected) {
        return true;
      }
      var length = this.accountName.trim().length;

      if (length === 0) {
        return true;
      }
      return false;
    },
    submitRequest: function submitRequest() {
      var _this3 = this;

      this.isLoading = true;

      var accountObject = {
        paymentPreference: this.principalPaymentSelected,
        interestPreference: this.interestPaymentSelected,
        accountName: this.accountName
      };

      if (this.accountType.includes('joint')) {
        accountObject.accountType = 'JOINT_ACCOUNT';
      } else if (this.accountType.includes('utma-ugma')) {
        accountObject.accountType = 'UTMA_UGMA_ACCOUNT';
      }

      return this.createAccountByAdmin({
        userId: this.userId,
        accountObject: accountObject
      }).then(function () {
        _this3.isLoading = false;
        _this3.goBack();
      }).catch(function (err) {
        _this3.isLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this3.setErrorsModalInfo(['Error when creating an account.']);
          _this3.showErrorsModal();
        }
      });
    },
    goBack: function goBack() {
      var name = this.name;
      var userId = this.userId;
      if (this.user.userType === __WEBPACK_IMPORTED_MODULE_7__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name) {
        this.$router.push({ name: 'EditUserFinancial', params: { name: name, userId: userId } });
      } else {
        this.$router.push({ name: 'UserDetail', params: { name: name, userId: userId } });
      }
    },
    onAccountNameUpdate: function onAccountNameUpdate(value) {
      this.accountNameChanged = true;
      this.accountName = value.trim();
    }
  })
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_email_validator__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_email_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_email_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_AddressSuggestion__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_AddressSuggestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_AddressSuggestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_static_institutionTypes__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_static_trustTypes__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_static_upcomingTransactionActions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_formControls_RestrictedTwoInputs__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_formControls_RestrictedTwoInputs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_formControls_RestrictedTwoInputs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_static_userTypes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__data_static_reinvestProhibitedStates__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_formControls_RestrictedSingleInput__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_formControls_RestrictedSingleInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_formControls_RestrictedSingleInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__data_static_addressErrors__ = __webpack_require__(130);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









 // eslint-disable-line no-unused-vars
 // eslint-disable-line no-unused-vars
 // eslint-disable-line no-unused-vars












var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_19__util__["b" /* formatDate */]
  }
};

var acceptedFileExtensions = ['png', 'jpg', 'jpeg', 'tif', 'pdf'];

var MAX_FILE_SIZE = 10485760;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'accountCreationInstitutionTrust',
  beforeMount: function beforeMount() {
    this.initializeState();
  },

  components: {
    spinner: __WEBPACK_IMPORTED_MODULE_20__components_widgets_Spinner___default.a,
    RestrictedTwoInputs: __WEBPACK_IMPORTED_MODULE_14__components_formControls_RestrictedTwoInputs___default.a,
    RestrictedSingleInput: __WEBPACK_IMPORTED_MODULE_17__components_formControls_RestrictedSingleInput___default.a,
    errors: __WEBPACK_IMPORTED_MODULE_9__components_modals_Errors___default.a,
    'address-suggestion': __WEBPACK_IMPORTED_MODULE_10__components_modals_AddressSuggestion___default.a
  },
  mixins: [mix],
  data: function data() {
    return {
      name: '',
      userId: '',
      accountId: '',
      accountType: '',
      accountName: '',
      user: {},
      institutionName: '',
      trustName: '',
      taxId: '',
      institutionTypeSelected: '',
      institutionTypes: [],
      trustTypeSelected: '',
      trustTypes: [],
      phoneNumber: '',
      residentialAddress: {
        streetAddress1: '',
        streetAddress2: '',
        zipCode: '',
        city: '',
        state: '',
        country: ''
      },
      mailingAddress: {
        streetAddress1: '',
        streetAddress2: '',
        zipCode: '',
        city: '',
        state: '',
        country: ''
      },
      hasDifferentMailingAddress: false,
      isFileInvalid: false,
      uploadFailed: false,
      uploadSucceeded: false,
      selectedFile: null,
      uploadedFiles: [],
      adjacentEmails: [''],
      interestPayment: '',
      principalPayment: '',
      isLoading: false,
      userDetailLoading: false,
      institutionNameChanged: false,
      trustNameChanged: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('app', ['geoLocation']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('accountCreation', ['isSuggestedAddressModalVisible', 'suggestedAddressModalYesCall']), {
    isFromProhibitedState: function isFromProhibitedState() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_16__data_static_reinvestProhibitedStates__["a" /* default */].find(function (s) {
        return s === _this.residentialAddress.state;
      }) !== undefined;
    },
    paymentPreference: function paymentPreference() {
      return this.isFromProhibitedState ? [__WEBPACK_IMPORTED_MODULE_13__data_static_upcomingTransactionActions__["a" /* default */].cashout, __WEBPACK_IMPORTED_MODULE_13__data_static_upcomingTransactionActions__["a" /* default */].donate] : [__WEBPACK_IMPORTED_MODULE_13__data_static_upcomingTransactionActions__["a" /* default */].reinvest, __WEBPACK_IMPORTED_MODULE_13__data_static_upcomingTransactionActions__["a" /* default */].donate, __WEBPACK_IMPORTED_MODULE_13__data_static_upcomingTransactionActions__["a" /* default */].cashout];
    },

    interestPaymentSelected: {
      get: function get() {
        return this.interestPayment ? this.interestPayment : this.paymentPreference[0].name;
      },
      set: function set(preference) {
        this.interestPayment = preference;
      }
    },
    principalPaymentSelected: {
      get: function get() {
        return this.principalPayment ? this.principalPayment : this.paymentPreference[0].name;
      },
      set: function set(preference) {
        this.principalPayment = preference;
      }
    }
  }),
  watch: {
    // eslint-disable-next-line no-unused-vars
    suggestedAddressModalYesCall: function suggestedAddressModalYesCall(_ref) {
      var _this2 = this;

      var _ = _ref._,
          suggestedAddress = _ref.suggestedAddress,
          addressType = _ref.addressType;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.hasDifferentMailingAddress) {
                  _this2.residentialAddress = suggestedAddress;
                  _this2.mailingAddress = suggestedAddress;
                }
                if (['organization'].includes(addressType)) {
                  _this2.residentialAddress = suggestedAddress;
                } else if (addressType === 'mailing') {
                  _this2.mailingAddress = suggestedAddress;
                }
                _context.next = 4;
                return _this2.submitRequest();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('accountCreation', ['createOrganizationAccount', 'createAccountDocuments', 'putDocumentToS3', 'createAccountByAdmin', 'createOrganizationByAdmin', 'verifyOrganizationAddress', 'verifyMailingAddress', 'getUserDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_18__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_18__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('accountCreation', {
    setSuggestedAddress: __WEBPACK_IMPORTED_MODULE_18__store_mutation_types__["o" /* SET_SUGGESTED_ADDRESS */],
    setSuggestedAddressType: __WEBPACK_IMPORTED_MODULE_18__store_mutation_types__["p" /* SET_SUGGESTED_ADDRESS_TYPE */],
    setSuggestedAddressModalVisible: __WEBPACK_IMPORTED_MODULE_18__store_mutation_types__["q" /* SET_SUGGESTED_ADDRESS_MODAL_VISIBLE */],
    setSuggestedAddressYesMethod: __WEBPACK_IMPORTED_MODULE_18__store_mutation_types__["r" /* SET_SUGGESTED_ADDRESS_YES_METHOD */]
  }), {
    countryStates: function countryStates(address) {
      if (this[address].country === this.geoLocation.countries[0].abbreviation) {
        if (address !== 'mailingAddress') {
          return this.geoLocation.states.filter(function (state) {
            return !state.onlyMailingAddress;
          });
        }
        return this.geoLocation.states;
      }
      return this.geoLocation.canadaStates;
    },
    truncateAddressIfNecessary: function truncateAddressIfNecessary(address) {
      var localAddress = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, address);
      var hasStreetAddress1 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress1');
      var hasStreetAddress2 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress2');
      if (hasStreetAddress1 && hasStreetAddress2) {
        var totalAdressLength = address.streetAddress1.length + address.streetAddress2.length;
        if (totalAdressLength > 50) {
          var charsToCut = totalAdressLength - 50;
          localAddress.streetAddress2 = address.streetAddress2.slice(0, -charsToCut);
          return localAddress;
        }
      }
      return address;
    },
    residentialAddressUpdated: function residentialAddressUpdated($event) {
      this.residentialAddress.streetAddress1 = $event.primary;
      this.residentialAddress.streetAddress2 = $event.secondary;
    },
    mailingAddressUpdated: function mailingAddressUpdated($event) {
      this.mailingAddress.streetAddress1 = $event.primary;
      this.mailingAddress.streetAddress2 = $event.secondary;
    },
    initializeState: function initializeState() {
      this.isLoading = true;
      this.userId = Number(sessionStorage.getItem('searchedUser'));
      this.name = this.$route.params.name;
      this.accountId = this.$route.params.accountId;
      this.accountType = sessionStorage.getItem('accountTypeToCreate');
      this.institutionTypes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_11__data_static_institutionTypes__["a" /* default */]).map(function (key) {
        return __WEBPACK_IMPORTED_MODULE_11__data_static_institutionTypes__["a" /* default */][key];
      });
      this.trustTypes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_12__data_static_trustTypes__["a" /* default */]).map(function (key) {
        return __WEBPACK_IMPORTED_MODULE_12__data_static_trustTypes__["a" /* default */][key];
      });
      this.isLoading = false;
      this.loadUserDetail();
    },
    loadUserDetail: function loadUserDetail() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.isLoading = true;
                _context2.next = 3;
                return _this3.getUserDetail(_this3.userId).then(function (data) {
                  _this3.user = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data);
                  if (_this3.geoLocation.countries && _this3.geoLocation.countries.length > 0) {
                    _this3.residentialAddress.country = _this3.geoLocation.countries[0].abbreviation;
                    _this3.mailingAddress.country = _this3.geoLocation.countries[0].abbreviation;
                  }
                  _this3.isLoading = false;
                }).catch(function () {
                  _this3.isLoading = false;
                });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    submitRequest: function submitRequest() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var accountObject, _ref2, documents, accountId, organizationObject, uploadedDocuments;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this4.isLoading = true;

                accountObject = {
                  paymentPreference: _this4.principalPaymentSelected,
                  interestPreference: _this4.interestPaymentSelected,
                  emails: _this4.getValidEmails(_this4.adjacentEmails),
                  // The address are only sent to verification proposes
                  address: _this4.residentialAddress,
                  mailingAddress: _this4.hasDifferentMailingAddress ? _this4.mailingAddress : _this4.residentialAddress
                };


                if (_this4.accountType.includes('trust')) {
                  accountObject.accountType = 'TRUST';
                  accountObject.accountName = _this4.trustName;
                } else if (_this4.accountType.includes('institution')) {
                  accountObject.accountType = 'INSTITUTION';
                  accountObject.accountName = _this4.institutionName;
                }

                accountObject.documents = _this4.uploadedFiles.map(function (file) {
                  var name = file.name,
                      size = file.size,
                      type = file.type;


                  return {
                    mimetype: type,
                    originalName: name,
                    size: size
                  };
                });

                _context4.next = 7;
                return _this4.createAccountByAdmin({
                  userId: _this4.userId,
                  accountObject: accountObject
                });

              case 7:
                _ref2 = _context4.sent;
                documents = _ref2.documents;
                accountId = _ref2.accountId;
                organizationObject = {
                  taxId: _this4.removeHypens(_this4.taxId),
                  phoneNumber: _this4.getPhoneDigits(_this4.phoneNumber),
                  mainAddress: _this4.residentialAddress,
                  mailingAddress: _this4.hasDifferentMailingAddress ? _this4.mailingAddress : _this4.residentialAddress,
                  hasDifferentMailingAddress: _this4.hasDifferentMailingAddress
                };


                if (_this4.accountType.includes('trust')) {
                  organizationObject.type = __WEBPACK_IMPORTED_MODULE_12__data_static_trustTypes__["a" /* default */][_this4.trustTypeSelected].key;
                  organizationObject.name = _this4.trustName;
                } else if (_this4.accountType.includes('institution')) {
                  organizationObject.type = __WEBPACK_IMPORTED_MODULE_11__data_static_institutionTypes__["a" /* default */][_this4.institutionTypeSelected].key;
                  organizationObject.name = _this4.institutionName;
                }

                uploadedDocuments = [];

                if (!documents.length) {
                  _context4.next = 17;
                  break;
                }

                _context4.next = 16;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(documents.map(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(doc) {
                    var file;
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            file = _this4.uploadedFiles.find(function (f) {
                              return decodeURIComponent(doc.url).includes(f.name);
                            });
                            _context3.next = 3;
                            return _this4.putDocumentToS3({ presignedUrl: doc.url, file: file });

                          case 3:
                            return _context3.abrupt('return', {
                              mimetype: file.type,
                              size: file.size,
                              originalName: file.originalName,
                              filename: doc.filename
                            });

                          case 4:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this4);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 16:
                uploadedDocuments = _context4.sent;

              case 17:
                _context4.next = 19;
                return _this4.createAccountDocuments({
                  accountId: accountId,
                  files: { documents: uploadedDocuments }
                });

              case 19:
                _context4.next = 21;
                return _this4.createOrganizationByAdmin({
                  organizationObject: organizationObject,
                  accountId: accountId
                });

              case 21:

                _this4.isLoading = false;
                _this4.goBack();
                _context4.next = 28;
                break;

              case 25:
                _context4.prev = 25;
                _context4.t0 = _context4['catch'](0);

                _this4.isLoading = false;

              case 28:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 25]]);
      }))();
    },
    displayModalWithErrorMessages: function displayModalWithErrorMessages(error) {
      if (!error || !error.message) {
        this.setErrorsModalInfo(['Something wrong happened. Please try again or contact Calvert support.']);
      } else if (__WEBPACK_IMPORTED_MODULE_21__data_static_addressErrors__["a" /* AddressErrors */][error.message]) {
        this.setErrorsModalInfo([__WEBPACK_IMPORTED_MODULE_21__data_static_addressErrors__["a" /* AddressErrors */][error.message]]);
      } else {
        this.setErrorsModalInfo(error.message.split(','));
      }
      this.showErrorsModal();
    },
    addEmailSubmit: function addEmailSubmit() {
      this.adjacentEmails.push('');
    },
    submitDifferentMailingAddress: function submitDifferentMailingAddress() {
      this.mailingAddress.streetAddress1 = '';
      this.mailingAddress.streetAddress2 = '';
      this.mailingAddress.zipCode = '';
      this.mailingAddress.city = '';
      this.mailingAddress.state = '';
    },
    fileChanged: function fileChanged(_ref4) {
      var files = _ref4.target.files;

      this.isLoading = true;
      this.isFileInvalid = false;
      if (files.length) {
        var selectedFile = files[0];
        var extension = selectedFile.name.split('.').pop().toLowerCase();
        var size = selectedFile.size;

        if (acceptedFileExtensions.indexOf(extension) === -1 || size > MAX_FILE_SIZE) {
          this.isFileInvalid = true;
          this.selectedFile = null;
        } else {
          this.selectedFile = null;
          this.selectedFile = selectedFile;
          this.uploadedFiles.push(this.selectedFile);
        }
      }
      this.isLoading = false;
    },
    removeDocument: function removeDocument(index) {
      if (index > -1) {
        this.uploadedFiles.splice(index, 1);
        this.selectedFile = null;
        var input = this.$refs.fileupload;
        input.type = 'text';
        input.type = 'file';
      }
    },
    getAcceptedFileExtensions: function getAcceptedFileExtensions() {
      return acceptedFileExtensions.map(function (ext) {
        return '.' + ext;
      }).join(',');
    },
    getValidEmails: function getValidEmails(emails) {
      var validEmails = emails.filter(function (email) {
        return __WEBPACK_IMPORTED_MODULE_7_email_validator__["validate"](email);
      });
      return validEmails;
    },
    getPhoneDigits: function getPhoneDigits(phoneNum) {
      return phoneNum.replace(/[-() ]/g, '');
    },
    removeHypens: function removeHypens(text) {
      return text.replace(/[-]/g, '');
    },
    isPhoneNumberInvalid: function isPhoneNumberInvalid(phoneNumber) {
      if (!phoneNumber) {
        return false;
      }
      var phoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
      return !phoneRegex.test(phoneNumber);
    },
    isTaxIdInvalid: function isTaxIdInvalid(taxId) {
      if (!taxId) {
        return false;
      }
      var taxIdRegex = /^\d{2}?[- ]?\d{7}$/;
      return !taxIdRegex.test(taxId);
    },
    isZipCodeInvalid: function isZipCodeInvalid(zipCode) {
      if (!zipCode) {
        return false;
      }
      return !__WEBPACK_IMPORTED_MODULE_19__util__["p" /* zipRegex */].test(zipCode);
    },
    requiredFieldsContainEmpty: function requiredFieldsContainEmpty() {
      if (this.accountType === 'institution') {
        if (!this.institutionName) {
          return true;
        }
        if (!this.institutionTypeSelected) {
          return true;
        }
      } else {
        if (!this.trustName) {
          return true;
        }
        if (!this.trustTypeSelected) {
          return true;
        }
      }
      if (!this.taxId) {
        return true;
      }
      if (!this.phoneNumber) {
        return true;
      }
      if (!this.residentialAddress.streetAddress1) {
        return true;
      }
      if (!this.residentialAddress.zipCode) {
        return true;
      }
      if (!this.residentialAddress.city) {
        return true;
      }
      if (!this.residentialAddress.state) {
        return true;
      }
      if (!this.interestPaymentSelected) {
        return true;
      }
      if (!this.principalPaymentSelected) {
        return true;
      }
      if (this.hasDifferentMailingAddress) {
        if (!this.mailingAddress.streetAddress1) {
          return true;
        }
        if (!this.mailingAddress.zipCode) {
          return true;
        }
        if (!this.mailingAddress.city) {
          return true;
        }
        if (!this.mailingAddress.state) {
          return true;
        }
      }
      return false;
    },
    isSubmitButtonDisabled: function isSubmitButtonDisabled(errors) {
      var _this5 = this;

      var cleanedErrors = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["filter"])(errors.items, function (item) {
        if (_this5.hasDifferentMailingAddress && (item.field === 'mailingStreetAddress1' || item.field === 'mailingZipCode' || item.field === 'mailingCity' || item.field === 'mailingState')) {
          return item;
        } else if (item.field !== 'mailingStreetAddress1' && item.field !== 'mailingZipCode' && item.field !== 'mailingCity' && item.field !== 'mailingState') {
          return item;
        }
        return false;
      });
      if (cleanedErrors.length > 0) {
        return true;
      }
      if (this.requiredFieldsContainEmpty()) {
        return true;
      }
      if (this.isPhoneNumberInvalid(this.phoneNumber)) {
        return true;
      }
      if (this.isTaxIdInvalid(this.taxId)) {
        return true;
      }
      if (this.isZipCodeInvalid(this.residentialAddress.zipCode)) {
        return true;
      }
      if (this.hasDifferentMailingAddress && this.isZipCodeInvalid(this.mailingAddress.zipCode)) {
        return true;
      }
      return false;
    },
    goBack: function goBack() {
      var name = this.name;
      var userId = this.userId;
      if (this.user.userType === __WEBPACK_IMPORTED_MODULE_15__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name) {
        this.$router.push({ name: 'EditUserFinancial', params: { name: name, userId: userId } });
      } else {
        this.$router.push({ name: 'UserDetail', params: { name: name, userId: userId } });
      }
    },
    onInstitutionNameUpdate: function onInstitutionNameUpdate(value) {
      this.institutionNameChanged = true;
      this.institutionName = value.trim();
    },
    onTrustNameUpdate: function onTrustNameUpdate(value) {
      this.trustNameChanged = true;
      this.trustName = value.trim();
    }
  })
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_CheckWireTransfer__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_CheckWireTransfer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_CheckWireTransfer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Breadcrumb__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_static_userTypes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__data_static_constants__ = __webpack_require__(16);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_13__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_13__util__["c" /* formatAmount */],
    formatRate: __WEBPACK_IMPORTED_MODULE_13__util__["s" /* formatRate */],
    formatTerm: __WEBPACK_IMPORTED_MODULE_13__util__["o" /* formatTerm */],
    formatType: __WEBPACK_IMPORTED_MODULE_13__util__["d" /* formatType */],
    formatPaymentPreference: __WEBPACK_IMPORTED_MODULE_13__util__["u" /* formatPaymentPreference */],
    findAccount: __WEBPACK_IMPORTED_MODULE_13__util__["v" /* findAccount */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'accountDetail',
  beforeMount: function beforeMount() {
    this.setParams();
    this.loadUserDetail();
    this.loadNotesList();
    this.loadAccountUsers();
    this.loadFundingSources();
  },

  mixins: [mix],
  components: {
    errors: __WEBPACK_IMPORTED_MODULE_7__components_modals_Errors___default.a,
    question: __WEBPACK_IMPORTED_MODULE_8__components_modals_Question___default.a,
    checkwire: __WEBPACK_IMPORTED_MODULE_9__components_modals_CheckWireTransfer___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_14__components_widgets_Spinner___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_10__components_Breadcrumb___default.a
  },
  watch: {
    user: function changedUser(newUser) {
      this.breadcrumbData = [];
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
        title: 'Search',
        goto: { name: 'Users' },
        selected: false
      }));
      var params = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, this.$route.params);
      var goto = void 0;
      if (newUser.userType === __WEBPACK_IMPORTED_MODULE_15__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name) {
        goto = { name: 'EditFinancialAdvisor', params: { name: params.name, userId: params.userId } };
      } else {
        goto = { name: 'UserDetail', params: { name: params.name, userId: params.userId } };
      }
      var title = newUser.firstName.concat(' ', newUser.lastName);
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
        title: title,
        goto: goto,
        selected: false
      }));
      var gotoAccount = { name: this.$route.name, params: params };
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, {
        title: this.userAccount.accountName,
        goto: gotoAccount,
        selected: true
      }));
    }
  },
  data: function data() {
    return {
      userId: '',
      accountId: '',
      name: '',
      breadcrumbData: [],
      user: [],
      userAccount: {
        defaultFundingSourceId: ''
      },
      notes: [],
      account: {},
      fundingSources: [],
      currentAmountBalance: 0,
      maxAmountFundingSources: 6,
      previousFundingSourceId: '',
      previousPaymentPreference: '',
      notesError: '',
      noteLoading: false,
      fundingLoading: false,
      userDetailLoading: false,
      accountUsersLoading: false,
      accountRepresentatives: [],
      beneficiaries: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('home', ['userStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('question', ['display']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('checkWireModal', ['isCheckWireModalVisible', 'creationSucceeded'])),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('account', ['getAccount', 'getAccountUsers', 'getAccountNotes', 'getAccountFundingSources', 'updateAccountPaymentPreference', 'setDefaultFundingSource', 'getAccountBeneficiaries']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('accountCreation', ['getUserDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_12__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_12__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_12__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_12__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('checkWireModal', {
    showCheckWireModal: __WEBPACK_IMPORTED_MODULE_12__store_mutation_types__["t" /* SHOW_CHECK_WIRE_MODAL */],
    setCreationStatus: __WEBPACK_IMPORTED_MODULE_12__store_mutation_types__["u" /* SET_CREATION_SUCCEEDED */]
  }), {
    setParams: function setParams() {
      this.userId = this.$route.params.userId;
      this.accountId = this.$route.params.accountId;
      this.name = this.$route.params.name;
    },
    loadUserDetail: function loadUserDetail() {
      var _this = this;

      this.userDetailLoading = true;
      return this.getUserDetail(this.userId).then(function (user) {
        _this.userDetailLoading = false;
        _this.user = user;
        _this.userAccount = _this.findAccount(user.accounts, _this.accountId);
        _this.previousFundingSourceId = _this.userAccount.defaultFundingSourceId;
      }).catch(function (err) {
        _this.userDetailLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this.setErrorsModalInfo(['We could not retrieve user detail']);
          _this.showErrorsModal();
        }
      });
    },
    loadAccountUsers: function loadAccountUsers() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, _ref2, account, accountRepresentatives;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.accountUsersLoading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this2.getAccount(_this2.accountId), _this2.getAccountUsers(_this2.accountId)]);

              case 4:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                account = _ref2[0];
                accountRepresentatives = _ref2[1];

                _this2.accountRepresentatives = accountRepresentatives;
                _this2.account = account;
                _this2.previousPaymentPreference = _this2.account.paymentPreference;
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({}));

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](0);

                if (!(_context.t0 !== 'UNAUTHORIZED')) {
                  _context.next = 20;
                  break;
                }

                _this2.setErrorsModalInfo(['We could not retrieve users list']);
                _this2.showErrorsModal();
                return _context.abrupt('return', _context.t0);

              case 20:
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(_context.t0));

              case 21:
                _context.prev = 21;

                _this2.accountUsersLoading = false;
                return _context.finish(21);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 14, 21, 24]]);
      }))();
    },
    loadNotesList: function loadNotesList() {
      var _this3 = this;

      this.noteLoading = true;
      return this.getAccountNotes(this.accountId).then(function (notes) {
        _this3.noteLoading = false;
        _this3.notes = notes;
        var openNotes = __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.filter(notes, { status: 'open' });
        _this3.currentAmountBalance = __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.sumBy(['currentBalance'], __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.partial(__WEBPACK_IMPORTED_MODULE_11_lodash___default.a.sumBy, openNotes));
      }).catch(function (err) {
        _this3.noteLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this3.setErrorsModalInfo(['We could not retrieve notes list']);
          _this3.showErrorsModal();
        }
      });
    },
    loadFundingSourceAfterModalSave: function loadFundingSourceAfterModalSave() {
      if (this.creationSucceeded) {
        this.loadUserDetail();
        this.loadFundingSources();
        this.setCreationStatus(false);
      }
    },
    loadFundingSources: function loadFundingSources() {
      var _this4 = this;

      this.fundingLoading = true;
      return this.getAccountFundingSources(this.accountId).then(function (data) {
        _this4.fundingLoading = false;
        _this4.fundingSources = data.filter(function (fss) {
          return !fss.removed && (fss.type === 'bank' || fss.type === 'check' || fss.type === 'wire/ach');
        });
      }).catch(function (err) {
        _this4.fundingLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this4.setErrorsModalInfo(['We could not retrieve bank accounts list']);
          _this4.showErrorsModal();
        }
      });
    },
    getAccountType: function getAccountType() {
      if (this.userAccount && this.userAccount.accountType) {
        var accountType = this.userAccount.accountType;
        return '' + accountType[0] + accountType.slice(1).toLowerCase();
      }
      return '';
    },
    getAccountBeneficiariesDetails: function getAccountBeneficiariesDetails() {
      var _this5 = this;

      this.getAccountBeneficiaries(this.accountId).then(function (beneficiaries) {
        _this5.beneficiaries = beneficiaries;
      });
    },
    showDefaultFundingSourceConfirmationModal: function showDefaultFundingSourceConfirmationModal(_ref3) {
      var _this6 = this;

      var fundingSource = _ref3.fundingSource;

      this.userAccount.defaultFundingSourceId = this.previousFundingSourceId;
      this.showQuestionModal({
        title: 'Bank account',
        question: 'Are you sure you want to select ' + fundingSource.name + ' as new default bank account?',
        method: function method() {
          _this6.methodToExecuteInDefaultFundingSourceQuestionModal(fundingSource.id);
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_16__data_static_constants__["a" /* Constants */].purchaseNote.modalYesButtonText,
        hideCancelButton: false
      });
    },
    showConfirmationModal: function showConfirmationModal(paymentPreference) {
      var _this7 = this;

      this.account.paymentPreference = this.previousPaymentPreference;
      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_16__data_static_constants__["a" /* Constants */].accountDetail.modalTitle,
        question: 'Are you sure you want to select ' + this.formatPaymentPreference(paymentPreference) + ' as your new default payment action?',
        method: function method() {
          _this7.methodToExecuteInQuestionModal(paymentPreference);
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_16__data_static_constants__["a" /* Constants */].accountDetail.modalYesButtonText,
        hideCancelButton: false
      });
    },
    methodToExecuteInDefaultFundingSourceQuestionModal: function methodToExecuteInDefaultFundingSourceQuestionModal(fundingSourceId) {
      var _this8 = this;

      this.hideQuestionModal();
      var account = this.userAccount;
      this.setDefaultFundingSource({
        accountId: account.id,
        fundingSourceId: fundingSourceId
      }).then(function () {
        _this8.previousFundingSourceId = fundingSourceId;
        _this8.userAccount.defaultFundingSourceId = fundingSourceId;
      });
    },
    methodToExecuteInQuestionModal: function methodToExecuteInQuestionModal(paymentPreference) {
      var _this9 = this;

      this.hideQuestionModal();
      this.updateAccountPaymentPreference({
        accountId: this.accountId,
        paymentPreference: paymentPreference
      }).then(function () {
        _this9.previousPaymentPreference = paymentPreference;
        _this9.account.paymentPreference = paymentPreference;
      });
    },
    openCheckWireModal: function openCheckWireModal() {
      var filteredFundingSources = this.fundingSources.filter(function (fss) {
        return fss.type === 'check' || fss.type === 'wire-transfer';
      });
      this.showCheckWireModal({ accountId: this.accountId,
        fundingSources: filteredFundingSources });
    },
    goToPurchaseInvestmentNote: function goToPurchaseInvestmentNote() {
      var accountId = this.accountId;
      var userId = this.userId;
      var name = this.name;
      this.$router.push({ name: 'PurchaseInvestmentNote', params: { accountId: accountId, userId: userId, name: name } });
    },
    goToViewDetail: function goToViewDetail(note) {
      var userId = this.userId;
      var name = this.name;

      var noteObj = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, note);
      var routeParams = { name: 'NoteDetail', params: { name: name, userId: userId, noteId: noteObj.id } };
      this.$router.push(routeParams);
    }
  })
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_static_logActions__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_3__util__["b" /* formatDate */]
  }
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountDocuments',
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.hasBeenCreatedAccount) {
                _context.next = 3;
                break;
              }

              _this.$router.push({ name: 'AccountSummary' });
              return _context.abrupt('return');

            case 3:
              _context.next = 5;
              return _this.checkUserStatus();

            case 5:
              _context.next = 7;
              return _this.fetchDocuments();

            case 7:
              _this.isLoading = false;
              _this.type = _this.$route.query.type;

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      documents: [],
      isLoading: true,
      type: ''
    };
  },

  mixins: [mix],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('account', ['getAccountDocuments', 'createDocumentView', 'createAccountDocumentPresignedUrl']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('home', ['getUserStatus']), {
    logDocumentViewed: function logDocumentViewed(doc) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var Key, LastModified, ETag, Url, logMessage;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Key = doc.Key, LastModified = doc.LastModified, ETag = doc.ETag, Url = doc.Url;
                _context2.next = 3;
                return _this2.createDocumentView({
                  fileName: Key,
                  lastModified: __WEBPACK_IMPORTED_MODULE_7_moment___default()(LastModified).toDate(),
                  url: Url.split('?')[0],
                  Etag: ETag,
                  userId: _this2.user.id,
                  accountId: _this2.activeAccountId
                });

              case 3:
                logMessage = 'User U' + _this2.user.id + ' viewed ' + Key + ' document';

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util__["m" /* logAction */])({
                  user: _this2.user.id,
                  level: 'info',
                  action: __WEBPACK_IMPORTED_MODULE_4__data_static_logActions__["a" /* default */].DOCUMENT_VIEW.name,
                  message: logMessage
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    openDocument: function openDocument(doc) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.createAccountDocumentPresignedUrl({
                  accountId: _this3.activeAccountId,
                  payload: {
                    key: doc.OriginalKey
                  }
                });

              case 2:
                res = _context3.sent;

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util__["l" /* openUrl */])(res.url);

                _context3.next = 6;
                return _this3.logDocumentViewed(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, doc, { Url: res.url }));

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    checkUserStatus: function checkUserStatus() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var accountId, response, status, needs;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                accountId = _this4.activeAccount.id;

                // Without a real account there is no status to fetch. Asking for
                // account 0 returns a 403, which the HttpService interceptor turns
                // into a redirect to Home.

                if (accountId) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt('return');

              case 4:
                _context4.next = 6;
                return _this4.getUserStatus({
                  accountId: accountId
                });

              case 6:
                response = _context4.sent;
                status = response.status, needs = response.needs;


                if (status === 'document') {
                  _this4.$router.push({ name: 'DocumentUpload' });
                } else if (status === 'retry') {
                  _this4.$router.push({ name: 'AccountCreation' });
                } else if (status === 'suspended') {
                  _this4.$router.push({ name: 'AccountSuspended' });
                } else if (!needs.includes('FUNDING_SOURCE') && needs.includes('NOTE')) {
                  _this4.$router.push({ name: 'PurchaseNote', query: { first: 1 } });
                }
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](0);

                console.error(_context4.t0);

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 11]]);
      }))();
    },
    fetchDocuments: function fetchDocuments() {
      var _this5 = this;

      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this5.getAccountDocuments({
                  accountId: _this5.activeAccountId,
                  query: { documentType: query || _this5.$route.query.type || 'reports' }
                });

              case 2:
                _this5.documents = _context5.sent;

                _this5.type = query || _this5.$route.query.type;

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('app', ['activeAccountId', 'activeAccount', 'user']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('app', ['hasBeenCreatedAccount'])),
  components: {
    spinner: __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default.a
  },
  watch: {
    $route: function $route(to) {
      var _this6 = this;

      this.isLoading = true;
      this.fetchDocuments(to.query.type).then(function () {
        _this6.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_static_events__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_static_constants__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SuccessAlert__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SuccessAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_SuccessAlert__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountEmails',
  beforeDestroy: function beforeDestroy() {
    this.hideSuccessMessage();
  },

  components: {
    SuccessAlert: __WEBPACK_IMPORTED_MODULE_7__components_SuccessAlert___default.a
  },
  data: function data() {
    return {
      errorMessage: null,
      isSuccessMessageDisplayed: false,
      newEmail: null,
      shouldFormForNewEmailBeDisplayed: false,
      successMessage: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('account', ['addAccountEmail', 'deleteAccountEmail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('successAlert', {
    hideSuccessAlert: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["w" /* CLOSE_SUCCESS_ALERT */],
    showSuccessAlert: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["x" /* SHOW_SUCCESS_ALERT */]
  }), {
    addNewEmail: function addNewEmail() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].ADDITIONAL_EMAILS_ADDING_STARTED);

                _context.next = 4;
                return _this.addAccountEmail({
                  accountId: _this.accountId,
                  email: _this.newEmail
                });

              case 4:

                _this.newEmail = null;
                _this.shouldFormForNewEmailBeDisplayed = false;
                _this.successMessage = __WEBPACK_IMPORTED_MODULE_6__data_static_constants__["a" /* Constants */].additionalEmail.successMessageAfterAddition;
                _this.isSuccessMessageDisplayed = true;
                _this.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].ADDITIONAL_EMAILS_ADDING_SUCCEED);
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](0);

                _this.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].ADDITIONAL_EMAILS_ADDING_FAILED, _context.t0);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 11]]);
      }))();
    },
    displayFormForNewEmail: function displayFormForNewEmail() {
      this.shouldFormForNewEmailBeDisplayed = true;
    },
    executeMethodInQuestionModalForDeletionOfEmail: function executeMethodInQuestionModalForDeletionOfEmail(email) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].ADDITIONAL_EMAILS_DELETING_STARTED);

                _context2.next = 4;
                return _this2.deleteAccountEmail({
                  accountId: _this2.accountId,
                  email: email
                });

              case 4:

                _this2.hideQuestionModal();
                _this2.successMessage = __WEBPACK_IMPORTED_MODULE_6__data_static_constants__["a" /* Constants */].additionalEmail.successMessageAfterDeletion;
                _this2.isSuccessMessageDisplayed = true;
                _this2.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].ADDITIONAL_EMAILS_DELETING_SUCCEED);
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                _this2.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].ADDITIONAL_EMAILS_DELETING_FAILED, _context2.t0);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 10]]);
      }))();
    },
    hideFormForNewEmail: function hideFormForNewEmail() {
      this.shouldFormForNewEmailBeDisplayed = false;
    },
    hideSuccessMessage: function hideSuccessMessage() {
      this.isSuccessMessageDisplayed = false;
    },
    isEmailUnique: function isEmailUnique() {
      var _this3 = this;

      var emailFound = this.emails.find(function (emailObj) {
        return emailObj.email === _this3.newEmail;
      });
      this.errorMessage = emailFound !== undefined ? 'Email cannot be a duplicate' : null;
      return emailFound === undefined;
    },
    showQuestionModalForDeletionOfEmail: function showQuestionModalForDeletionOfEmail(email) {
      var _this4 = this;

      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_6__data_static_constants__["a" /* Constants */].additionalEmail.modalTitle,
        question: __WEBPACK_IMPORTED_MODULE_6__data_static_constants__["a" /* Constants */].additionalEmail.modalQuestion,
        method: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this4.executeMethodInQuestionModalForDeletionOfEmail(email);

                  case 2:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, _this4);
          }));

          return function method() {
            return _ref.apply(this, arguments);
          };
        }(),
        yesButtonText: __WEBPACK_IMPORTED_MODULE_6__data_static_constants__["a" /* Constants */].additionalEmail.modalYesButtonText,
        hideCancelButton: false
      });
    }
  }),
  props: ['accountId', 'emails']
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_static_constants__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_static_events__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_CheckWireTransfer__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_CheckWireTransfer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_modals_CheckWireTransfer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_config__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_static_transactionTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_static_transactionStatuses__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(9);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var mix = {
  methods: {
    formatType: __WEBPACK_IMPORTED_MODULE_11__util__["d" /* formatType */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountFundingSources',
  created: function created() {
    this.configureDwolla();
  },
  beforeMount: function beforeMount() {
    this.currentDefaultFundingSourceId = this.defaultFundingSourceId;
    console.log('**this.account**', this.account);
  },
  mounted: function mounted() {
    this.initialize();
  },

  components: {
    CheckWire: __WEBPACK_IMPORTED_MODULE_7__components_modals_CheckWireTransfer___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['fundingSourceTypes']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('checkWireModal', ['isCheckWireModalVisible', 'creationSucceeded']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('home', ['userStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('fundingSource', ['currentDwollaCustomerId']), {
    currentDwollaCustomerIdFromStore: function currentDwollaCustomerIdFromStore() {
      return this.currentDwollaCustomerId;
    }
  }),
  data: function data() {
    return {
      currentDefaultFundingSourceId: '',
      fundingSources: [],
      showFundingTable: true,
      dwollaService: window.dwolla,
      showDwollaComponent: false,
      showDwollaAcknowledgeButton: false
    };
  },

  watch: {
    defaultFundingSourceId: function defaultFundingSourceId(val) {
      this.currentDefaultFundingSourceId = val;
      this.initialize();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('account', ['getAccountFundingSources', 'setDefaultFundingSource', 'getAccountTransactions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('fundingSource', ['getToken', 'createDwollaUser', 'getClientToken']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('accountCreation', ['getUserDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('checkWireModal', {
    showCheckWireModal: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["t" /* SHOW_CHECK_WIRE_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('fundingSource', {
    setCurrentDwollaCustomerId: 'SET_CURRENT_DWOLLA_CUSTOMER_ID'
  }), {
    getDwollaToken: function getDwollaToken(request) {
      var effectiveCustomerId = this.account.dwollaCustomerId || this.currentDwollaCustomerIdFromStore;
      var payload = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, request, { dwollaCustomerId: effectiveCustomerId });
      return this.$store.dispatch('fundingSource/getClientToken', payload);
    },
    configureDwolla: function configureDwolla() {
      var _this = this;

      this.dwollaService.configure({
        environment: __WEBPACK_IMPORTED_MODULE_8__config_config__["d" /* env */] === 'production' ? 'production' : 'sandbox',
        styles: 'static/dwolla-dropins.css',
        token: function token(req) {
          return _this.getDwollaToken(req);
        },
        success: function success(res) {
          console.log('Dwolla success:', res);
          // Keep modal visible for the user to read Dwolla's message; reveal Ok button
          _this.showDwollaAcknowledgeButton = true;
        },
        error: function error(err) {
          console.error('Dwolla error:', err);
          // Keep modal visible for the user to read Dwolla's message; reveal Ok button
          _this.showDwollaAcknowledgeButton = true;
        }
      });
    },
    initialize: function initialize() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var fundingSources;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.$emit(__WEBPACK_IMPORTED_MODULE_6__data_static_events__["a" /* Events */].FUNDING_SOURCES_LOADING_STARTED);
                _context.next = 3;
                return _this2.getAccountFundingSources(_this2.accountId);

              case 3:
                fundingSources = _context.sent;


                _this2.fundingSources = fundingSources.filter(function (fss) {
                  return !fss.removed && (fss.type === _this2.fundingSourceTypes.BANK.name || fss.type === _this2.fundingSourceTypes.CHECK.name || fss.type === _this2.fundingSourceTypes.WIRE_TRANSFER.name);
                });

                _this2.$emit(__WEBPACK_IMPORTED_MODULE_6__data_static_events__["a" /* Events */].FUNDING_SOURCES_LOADING_SUCCEED);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    methodToExecuteInDefaultFundingSourceQuestionModal: function methodToExecuteInDefaultFundingSourceQuestionModal(fundingSourceId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this3.hideQuestionModal();
                _this3.$emit(__WEBPACK_IMPORTED_MODULE_6__data_static_events__["a" /* Events */].FUNDING_SOURCES_LOADING_STARTED);

                _context2.next = 5;
                return _this3.setDefaultFundingSource({
                  accountId: _this3.accountId,
                  fundingSourceId: fundingSourceId
                });

              case 5:

                _this3.currentDefaultFundingSourceId = fundingSourceId.toString();

                // Check for upcoming transactions with destinations set
                _context2.next = 8;
                return _this3.checkForUpcomingTransactions();

              case 8:
                _context2.next = 10;
                return _this3.initialize();

              case 10:
                _this3.$emit(__WEBPACK_IMPORTED_MODULE_6__data_static_events__["a" /* Events */].DEFAULT_FUNDING_SOURCE_UPDATED);
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](0);

                _this3.$emit(__WEBPACK_IMPORTED_MODULE_6__data_static_events__["a" /* Events */].FUNDING_SOURCES_LOADING_FAILED);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 13]]);
      }))();
    },
    checkForUpcomingTransactions: function checkForUpcomingTransactions() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var accountTransactions;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this4.getAccountTransactions({
                  accountId: _this4.accountId,
                  params: {
                    transactionTypes: [__WEBPACK_IMPORTED_MODULE_9__data_static_transactionTypes__["a" /* default */].SELL_REINVEST, __WEBPACK_IMPORTED_MODULE_9__data_static_transactionTypes__["a" /* default */].SELL_DONATE, __WEBPACK_IMPORTED_MODULE_9__data_static_transactionTypes__["a" /* default */].SELL_MATURE, __WEBPACK_IMPORTED_MODULE_9__data_static_transactionTypes__["a" /* default */].INT_REINVEST, __WEBPACK_IMPORTED_MODULE_9__data_static_transactionTypes__["a" /* default */].INT_PAID, __WEBPACK_IMPORTED_MODULE_9__data_static_transactionTypes__["a" /* default */].INT_DONATE],
                    statuses: [__WEBPACK_IMPORTED_MODULE_10__data_static_transactionStatuses__["a" /* default */].PREPENDING]
                  }
                });

              case 3:
                accountTransactions = _context3.sent;


                // If there are upcoming transactions, emit event to show warning
                if (accountTransactions && accountTransactions.length > 0) {
                  _this4.$emit('showBankAccountChangedWarning');
                }
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.error('Failed to check for upcoming transactions:', _context3.t0);
                // Don't fail the whole operation if checking transactions fails

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 7]]);
      }))();
    },
    getDwollaOptions: function getDwollaOptions() {
      var _this5 = this;

      return {
        container: 'verifyContainer',
        stylesheets: ['https://fonts.googleapis.com/css?family=Lato&subset=latin,latin-ext'],
        microDeposits: true,
        fallbackToMicroDeposits: true,
        backButton: true,
        subscriber: function subscriber(_ref) {
          var currentPage = _ref.currentPage;

          if (currentPage === 'SuccessIAV') {
            _this5.checkUserStatus();
          }
        }
      };
    },
    createNewFundingSource: function createNewFundingSource(token) {
      var _this6 = this;

      var dwollaOptions = this.getDwollaOptions();
      return this.dwollaService.iav.start(token, dwollaOptions, function (err, res) {
        if (err) {
          return _this6.showErrorModal('Something went wrong please try again!');
        }
        return _this6.loadFundingSources().then(function (fundingSources) {
          var fundingSourceIdAdded = _this6.getFundingSourceId(res._links); // eslint-disable-line no-underscore-dangle
          return _this6.loadUserProfile().then(function () {
            _this6.selectDefaultFundingSource(fundingSources, fundingSourceIdAdded);
          });
        });
      });
    },
    addAccount: function addAccount() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var user, refreshedAccount, newCustomerId;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this7.account.dwollaCustomerId) {
                  _context4.next = 19;
                  break;
                }

                _context4.prev = 1;
                _context4.next = 4;
                return _this7.createDwollaUser(_this7.account.primaryInvestorId);

              case 4:
                _context4.next = 6;
                return _this7.getUserDetail(_this7.account.primaryInvestorId);

              case 6:
                user = _context4.sent;
                refreshedAccount = user && user.accounts ? user.accounts.find(function (acct) {
                  return acct.id === _this7.accountId;
                }) : null;
                newCustomerId = refreshedAccount && refreshedAccount.dwollaCustomerId;

                if (newCustomerId) {
                  _this7.setCurrentDwollaCustomerId(newCustomerId);
                }
                // Inform parent to refresh its data as well
                _this7.$emit(__WEBPACK_IMPORTED_MODULE_6__data_static_events__["a" /* Events */].RESTART);
                _context4.next = 17;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4['catch'](1);

                console.error('Failed to create Dwolla customer for user', _context4.t0);
                return _context4.abrupt('return');

              case 17:
                _context4.next = 20;
                break;

              case 19:
                _this7.setCurrentDwollaCustomerId(_this7.account.dwollaCustomerId);

              case 20:
                _this7.showDwollaComponent = true;

              case 21:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[1, 13]]);
      }))();
    },
    modalToAddNewFundingSourceHasBeenClosed: function modalToAddNewFundingSourceHasBeenClosed() {
      if (this.creationSucceeded) {
        this.initialize();
      }
    },
    openModal: function openModal() {
      this.$emit(__WEBPACK_IMPORTED_MODULE_6__data_static_events__["a" /* Events */].OPEN_MODAL_TO_ADD_NEW_FUNDING_SOURCE);
    },
    openModalToAddNewFundingSource: function openModalToAddNewFundingSource() {
      var _this8 = this;

      var filteredFundingSources = this.fundingSources.filter(function (fundingSource) {
        return fundingSource.type === _this8.fundingSourceTypes.CHECK.name || fundingSource.type === _this8.fundingSourceTypes.WIRE_TRANSFER.name;
      });

      this.showCheckWireModal({
        accountId: this.accountId,
        fundingSources: filteredFundingSources
      });
    },
    showDefaultFundingSourceConfirmationModal: function showDefaultFundingSourceConfirmationModal(_ref2) {
      var _this9 = this;

      var id = _ref2.id,
          name = _ref2.name;

      this.showQuestionModal({
        title: 'Bank account',
        question: 'Are you sure you want to select ' + name + ' as new default bank account?',
        method: function method() {
          _this9.methodToExecuteInDefaultFundingSourceQuestionModal(id);
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_5__data_static_constants__["a" /* Constants */].purchaseNote.modalYesButtonText,
        hideCancelButton: false
      });
    },
    closeDwollaModal: function closeDwollaModal() {
      this.showDwollaComponent = false;
    },
    acknowledgeDwollaMessage: function acknowledgeDwollaMessage() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // User has read the Dwolla message; now refresh and close
                _this10.showDwollaAcknowledgeButton = false;
                _context5.prev = 1;
                _context5.next = 4;
                return _this10.initialize();

              case 4:
                _this10.$emit(__WEBPACK_IMPORTED_MODULE_6__data_static_events__["a" /* Events */].RESTART);
                _context5.next = 10;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5['catch'](1);

                console.error('Failed to refresh funding sources after acknowledgement', _context5.t0);

              case 10:
                _context5.prev = 10;

                _this10.showDwollaComponent = false;
                return _context5.finish(10);

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this10, [[1, 7, 10, 13]]);
      }))();
    }
  }),
  mixins: [mix],
  props: ['accountId', 'defaultFundingSourceId', 'account']
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_static_events__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_BulkRedemption__ = __webpack_require__(2087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_BulkRedemption___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_modals_BulkRedemption__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_BulkTransfer__ = __webpack_require__(2088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_BulkTransfer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modals_BulkTransfer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(9);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var mix = {
  methods: {
    formatAmount: __WEBPACK_IMPORTED_MODULE_7__util__["c" /* formatAmount */],
    formatDate: __WEBPACK_IMPORTED_MODULE_7__util__["b" /* formatDate */],
    formatRate: __WEBPACK_IMPORTED_MODULE_7__util__["s" /* formatRate */],
    formatTerm: __WEBPACK_IMPORTED_MODULE_7__util__["o" /* formatTerm */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountNotes',
  components: {
    'bulk-redemption': __WEBPACK_IMPORTED_MODULE_5__components_modals_BulkRedemption___default.a,
    'bulk-transfer': __WEBPACK_IMPORTED_MODULE_6__components_modals_BulkTransfer___default.a
  },
  mounted: function mounted() {
    this.initialize();
  },
  data: function data() {
    return {
      currentAmountBalance: '',
      notes: [],
      orderedNotes: [],
      sortProperty: '',
      sortToggle: 1,
      isBulkRedemptionVisible: false,
      isBulkTransferVisible: false
    };
  },

  computed: {
    // The modal itself reports which notes actually qualify; this only keeps
    // the button from opening it on an account with nothing to redeem.
    hasOpenNotes: function hasOpenNotes() {
      return this.notes.some(function (note) {
        return note.status === 'open';
      });
    },

    // Deliberately looser than hasOpenNotes: the single-note transfer flow
    // gates on a pending transfer, never on status, so an account holding
    // only closed notes still has something to move.
    hasTransferableNotes: function hasTransferableNotes() {
      return this.notes.length > 0;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('account', ['getAccountNotes', 'getCurrentAmountBalance']), {
    initialize: function initialize() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var notes, amountBalanceResponse;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit(__WEBPACK_IMPORTED_MODULE_4__data_static_events__["a" /* Events */].NOTES_LOADING_STARTED);
                _context.next = 3;
                return _this.getAccountNotes(_this.accountId);

              case 3:
                notes = _context.sent;
                _context.next = 6;
                return _this.getCurrentAmountBalance({
                  accountId: _this.accountId
                });

              case 6:
                amountBalanceResponse = _context.sent;


                _this.currentAmountBalance = amountBalanceResponse.currentAmountBalance;
                _this.notes = notes.slice(0);
                _this.sortByStatus();
                _this.$emit(__WEBPACK_IMPORTED_MODULE_4__data_static_events__["a" /* Events */].NOTES_LOADING_SUCCEED);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    goToPurchaseInvestmentNote: function goToPurchaseInvestmentNote() {
      this.$emit(__WEBPACK_IMPORTED_MODULE_4__data_static_events__["a" /* Events */].REDIRECT_TO_PURCHASE_INVESTMENT_NOTE_VIEW);
    },
    openBulkRedemption: function openBulkRedemption() {
      this.isBulkRedemptionVisible = true;
    },
    closeBulkRedemption: function closeBulkRedemption() {
      this.isBulkRedemptionVisible = false;
    },

    // Balances and note statuses change once a batch is requested or approved,
    // so the list is reloaded rather than left showing pre-redemption state.
    onBulkRedemptionCompleted: function onBulkRedemptionCompleted() {
      this.initialize();
    },
    openBulkTransfer: function openBulkTransfer() {
      this.isBulkTransferVisible = true;
    },
    closeBulkTransfer: function closeBulkTransfer() {
      this.isBulkTransferVisible = false;
    },

    // Matters more here than for a redemption: approved notes belong to
    // another account now and leave this list entirely.
    onBulkTransferCompleted: function onBulkTransferCompleted() {
      this.initialize();
    },
    goToViewDetail: function goToViewDetail(note) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_4__data_static_events__["a" /* Events */].REDIRECT_TO_NOTE_DETAILS_VIEW, note);
    },
    gotToUpcomingTransactionsSegment: function gotToUpcomingTransactionsSegment() {
      this.$emit(__WEBPACK_IMPORTED_MODULE_4__data_static_events__["a" /* Events */].GO_TO_UPCOMING_TRANSACTIONS_SEGMENT);
    },
    sortNotesById: function sortNotesById(property) {
      var _this2 = this;

      this.sortToggle = this.sortProperty === property ? this.sortToggle * -1 : 1;

      this.orderedNotes = this.notes.sort(function (a, b) {
        if (!a[property] && !b[property]) {
          return 0;
        }
        if (!b[property]) {
          return 1 * _this2.sortToggle;
        }
        if (!a[property]) {
          return -1 * _this2.sortToggle;
        }
        return a[property].localeCompare(b[property], 'en', { numeric: true }) * _this2.sortToggle;
      });

      this.sortProperty = property;
    },
    sortByStatus: function sortByStatus() {
      var _this3 = this;

      this.sortToggle = this.sortProperty === 'status' ? this.sortToggle * -1 : -1;

      this.orderedNotes = this.notes.sort(function (a, b) {
        if (a.status < b.status || !a.status && b.status) {
          return -1 * _this3.sortToggle;
        }
        if (a.status > b.status || a.status && !b.status) {
          return 1 * _this3.sortToggle;
        }
        if (a.purchasedOn < b.purchasedOn || !a.purchasedOn && b.purchasedOn) {
          return 1;
        }
        if (a.purchasedOn > b.purchasedOn || a.purchasedOn && !b.purchasedOn) {
          return -1;
        }
        return 0;
      });

      this.sortProperty = 'status';
    },
    sortNotes: function sortNotes(property) {
      var _this4 = this;

      this.sortToggle = this.sortProperty === property ? this.sortToggle * -1 : 1;

      this.orderedNotes = this.notes.sort(function (a, b) {
        if (a[property] < b[property] || !a[property] && b[property]) {
          return -1 * _this4.sortToggle;
        }
        if (a[property] > b[property] || a[property] && !b[property]) {
          return 1 * _this4.sortToggle;
        }
        return 0;
      });

      this.sortProperty = property;
    },
    sortIconStyle: function sortIconStyle(property) {
      if (property === this.sortProperty) {
        return 'fa fa-sort-' + (this.sortToggle === 1 ? 'asc' : 'desc');
      }
      return 'fa fa-sort';
    }
  }),
  mixins: [mix],
  props: ['accountId', 'disableInvestment', 'displayAlertForUpcomingTransactionsWithAction', 'displayAlertForUpcomingTransactionsWithNoAction']
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_static_constants__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_static_events__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_static_logActions__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_formControls_RestrictedSingleInput__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_formControls_RestrictedSingleInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_formControls_RestrictedSingleInput__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountPreferences',
  props: ['accountId', 'communicationPreference', 'communication1099Preference', 'communicationImpactReportPreference', 'interestPreference', 'paymentPreference', 'user', 'redemptionRestriction'],
  data: function data() {
    return {
      communicationPreferenceSelected: null,
      redemptionRestrictionSelected: false,
      counterTextColor: 'green-counter',
      displayedPreferences: [],
      form1099Email: true,
      form1099SnailMail: false,
      impactReportEmail: true,
      impactReportSnailMail: false,
      indexOfGeneralPreference: 0,
      indexOfOtherPreference: 0,
      interestPreferenceSelected: null,
      nonDisplayedPreferences: [],
      other: '',
      paymentPreferenceSelected: null,
      reservedPreferenceCodes: null,
      addPreferences: [],
      removePreferences: [],
      otherText: null,
      otherTextId: null,
      accountImpactPreferencesIds: [],
      impactPreferencesIds: []
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.communicationPreferenceSelected = _this.communicationPreference;
              _this.redemptionRestrictionSelected = !_this.redemptionRestriction;
              _this.interestPreferenceSelected = _this.interestPreference;
              _this.paymentPreferenceSelected = _this.paymentPreference;
              if (_this.communication1099Preference === 'BOTH') {
                _this.form1099Email = true;
                _this.form1099SnailMail = true;
              } else if (_this.communication1099Preference === 'EMAIL') {
                _this.form1099Email = true;
                _this.form1099SnailMail = false;
              } else if (_this.communication1099Preference === 'SNAIL-MAIL') {
                _this.form1099Email = false;
                _this.form1099SnailMail = true;
              }
              if (_this.communicationImpactReportPreference === 'BOTH') {
                _this.impactReportEmail = true;
                _this.impactReportSnailMail = true;
              } else if (_this.communicationImpactReportPreference === 'EMAIL') {
                _this.impactReportEmail = true;
                _this.impactReportSnailMail = false;
              } else if (_this.communicationImpactReportPreference === 'SNAIL-MAIL') {
                _this.impactReportEmail = false;
                _this.impactReportSnailMail = true;
              }

              _this.hideQuestionModal();
              _this.initialize();

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('account', ['getAccountImpactPreferences', 'updateAccount', 'updateAccountPreferences', 'updateAccountImpactPreferences']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('impactPreferences', ['getImpactPreferences', 'getSeparatedDisplayedAndNonDisplayedPreferencesAdmin']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), {
    handleNotesRestrictionChange: function handleNotesRestrictionChange(event) {
      this.redemptionRestrictionSelected = event.target.checked;
    },
    handleForm1099EmailChange: function handleForm1099EmailChange(event) {
      this.form1099Email = event.target.checked;
    },
    handleForm1099SnailMailChange: function handleForm1099SnailMailChange(event) {
      this.form1099SnailMail = event.target.checked;
    },
    handleImpactReportEmailChange: function handleImpactReportEmailChange(event) {
      this.impactReportEmail = event.target.checked;
    },
    handleImpactReportSnailMailChange: function handleImpactReportSnailMailChange(event) {
      this.impactReportSnailMail = event.target.checked;
    },
    onChangeSelectImpactPreference: function onChangeSelectImpactPreference(event) {
      var _event$target = event.target,
          checked = _event$target.checked,
          preferenceId = _event$target.value;

      var parsedPreferenceId = Number(preferenceId);
      var belongsToAccount = this.accountImpactPreferencesIds.includes(parsedPreferenceId);
      if (checked && !belongsToAccount) {
        this.addPreferences.push(parsedPreferenceId);
      } else if (!checked && belongsToAccount) {
        this.removePreferences.push(parsedPreferenceId);
      } else if (checked && belongsToAccount) {
        this.removePreferences = this.removePreferences.filter(function (rp) {
          return rp !== parsedPreferenceId;
        });
      } else if (!checked && !belongsToAccount) {
        this.addPreferences = this.addPreferences.filter(function (rp) {
          return rp !== parsedPreferenceId;
        });
      }
    },
    createPayload: function createPayload() {
      var displayedPreferenceIds = this.displayedPreferences.filter(function (preference) {
        return preference.isSelected;
      }).map(function (preference) {
        return preference.id;
      });

      var nonDisplayedPreferenceIds = this.nonDisplayedPreferences.filter(function (preference) {
        return preference.isSelected;
      }).map(function (preference) {
        return preference.id;
      });

      var principalPreference = this.paymentPreferenceSelected === null ? this.paymentPreference : this.paymentPreferenceSelected;

      var interestPreference = this.interestPreferenceSelected === null ? this.interestPreference : this.interestPreferenceSelected;

      var communication1099Preference = this.getCommunicationPreferenceValue(this.form1099Email, this.form1099SnailMail);

      var communicationImpactReportPreference = this.getCommunicationPreferenceValue(this.impactReportEmail, this.impactReportSnailMail);

      return {
        communicationPreference: this.communicationPreferenceSelected,
        redemptionRestriction: !this.redemptionRestrictionSelected,
        interestPreference: interestPreference,
        otherText: this.other,
        principalPreference: principalPreference,
        preferences: displayedPreferenceIds.concat(nonDisplayedPreferenceIds),
        userId: this.user.id,
        communication1099Preference: communication1099Preference,
        communicationImpactReportPreference: communicationImpactReportPreference
      };
    },
    getCommunicationPreferenceValue: function getCommunicationPreferenceValue(email, snailMail) {
      if (email && snailMail) {
        return 'BOTH';
      }
      if (email) {
        return 'EMAIL';
      }
      if (snailMail) {
        return 'SNAIL-MAIL';
      }
      return null;
    },
    initialize: function initialize() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, _ref2, accountImpactPreferences, impactPreferences, separatedDisplayedAndNonDisplayedImpactPreferences;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$emit(__WEBPACK_IMPORTED_MODULE_8__data_static_events__["a" /* Events */].IMPACT_PREFERENCES_LOADING_STARTED);
                _context2.prev = 1;

                _this2.reservedPreferenceCodes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.reservedImpactPreferenceCodes);
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this2.getAccountImpactPreferences(_this2.accountId), _this2.getImpactPreferences()]);

              case 5:
                _ref = _context2.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                accountImpactPreferences = _ref2[0];
                impactPreferences = _ref2[1];

                _this2.accountImpactPreferencesIds = accountImpactPreferences.map(function (aip) {
                  return aip.id;
                });
                _this2.impactPreferencesIds = impactPreferences.map(function (ip) {
                  return ip.id;
                });
                _context2.next = 13;
                return _this2.getSeparatedDisplayedAndNonDisplayedPreferencesAdmin({
                  accountImpactPreferences: accountImpactPreferences,
                  impactPreferences: impactPreferences
                });

              case 13:
                separatedDisplayedAndNonDisplayedImpactPreferences = _context2.sent;

                _this2.setDisplayedPreferences({
                  displayedPreferences: separatedDisplayedAndNonDisplayedImpactPreferences.displayedPreferences,
                  reservedPreferenceCodes: _this2.reservedPreferenceCodes
                });
                _this2.setOtherText({
                  displayedPreferences: separatedDisplayedAndNonDisplayedImpactPreferences.displayedPreferences,
                  reservedPreferenceCodes: _this2.reservedPreferenceCodes
                });
                _this2.setNonDisplayedPreferences({
                  nonDisplayedPreferences: separatedDisplayedAndNonDisplayedImpactPreferences.nonDisplayedPreferences
                });
                _context2.next = 24;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](1);

                _this2.setErrorsModalInfo(['Something went wrong. Please try again.']);
                _this2.showErrorsModal();

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["m" /* logAction */])({
                  user: _this2.user.id,
                  level: 'error',
                  action: __WEBPACK_IMPORTED_MODULE_10__data_static_logActions__["a" /* default */].VIEW_INVESTOR_IMPACT_PREFERENCES.name,
                  message: _context2.t0.message,
                  stack: _context2.t0.stack,
                  tags: [__WEBPACK_IMPORTED_MODULE_9__util__["x" /* logglyTags */].auth0]
                });

              case 24:
                _context2.prev = 24;

                _this2.$emit(__WEBPACK_IMPORTED_MODULE_8__data_static_events__["a" /* Events */].IMPACT_PREFERENCES_LOADING_SUCCEED);
                return _context2.finish(24);

              case 27:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 19, 24, 27]]);
      }))();
    },
    isGeneralPreference: function isGeneralPreference(index) {
      return this.reservedPreferenceCodes !== null && this.displayedPreferences[index] !== undefined && this.displayedPreferences[index].code === this.reservedPreferenceCodes.general;
    },
    isOtherPreference: function isOtherPreference(index) {
      return this.reservedPreferenceCodes !== null && this.displayedPreferences[index] !== undefined && this.displayedPreferences[index].code === this.reservedPreferenceCodes.other;
    },
    selectOtherPreference: function selectOtherPreference(value) {
      var otherPreference = this.displayedPreferences[this.indexOfOtherPreference];
      otherPreference.isSelected = value.trim() !== '';
      otherPreference.otherText = value.trim();
      this.other = value;
      this.otherText = otherPreference.otherText;
      this.otherTextId = otherPreference.id;
    },
    setDisplayedPreferences: function setDisplayedPreferences(_ref3) {
      var displayedPreferences = _ref3.displayedPreferences,
          reservedPreferenceCodes = _ref3.reservedPreferenceCodes;

      this.displayedPreferences = displayedPreferences;

      this.indexOfGeneralPreference = this.displayedPreferences.findIndex(function (preference) {
        return preference.code === reservedPreferenceCodes.general;
      });

      this.indexOfOtherPreference = this.displayedPreferences.findIndex(function (preference) {
        return preference.code === reservedPreferenceCodes.other;
      });
    },
    setNonDisplayedPreferences: function setNonDisplayedPreferences(_ref4) {
      var nonDisplayedPreferences = _ref4.nonDisplayedPreferences;

      this.nonDisplayedPreferences = nonDisplayedPreferences;
    },
    setOtherText: function setOtherText(_ref5) {
      var displayedPreferences = _ref5.displayedPreferences,
          reservedPreferenceCodes = _ref5.reservedPreferenceCodes;

      var otherPreference = displayedPreferences.find(function (preference) {
        return preference.code === reservedPreferenceCodes.other;
      });

      var otherText = otherPreference.otherText;


      if (otherText) {
        var length = otherText.length > 50 ? 50 : otherText.length;
        this.other = otherText.substring(0, length);
        this.setOtherTextColor();
      }
    },
    setOtherTextColor: function setOtherTextColor() {
      if (this.other.length <= 29) {
        this.counterTextColor = 'green-counter';
      } else if (this.other.length > 29 && this.other.length <= 49) {
        this.counterTextColor = 'yellow-counter';
      } else if (this.other.length > 49) {
        this.counterTextColor = 'red-counter';
      }
    },
    showConfirmationModal: function showConfirmationModal() {
      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_7__data_static_constants__["a" /* Constants */].adminPreferences.modalTitle,
        question: __WEBPACK_IMPORTED_MODULE_7__data_static_constants__["a" /* Constants */].adminPreferences.modalQuestion,
        yesButtonText: __WEBPACK_IMPORTED_MODULE_7__data_static_constants__["a" /* Constants */].adminPreferences.modalYesButtonText,
        method: this.saveInvestorImpactPreferences
      });
    },
    saveInvestorImpactPreferences: function saveInvestorImpactPreferences() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var payload;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this3.hideQuestionModal();
                _this3.$emit(__WEBPACK_IMPORTED_MODULE_8__data_static_events__["a" /* Events */].UPDATE_IMPACT_PREFERENCES_STARTED);
                payload = _this3.createPayload();
                _context3.next = 6;
                return _this3.updateAccount({
                  accountId: _this3.accountId,
                  payload: {
                    redemptionRestriction: payload.redemptionRestriction,
                    communicationPreference: payload.communicationPreference,
                    communication1099Preference: payload.communication1099Preference,
                    communicationImpactReportPreference: payload.communicationImpactReportPreference
                  }
                });

              case 6:
                _context3.next = 8;
                return _this3.updateAccountPreferences({
                  accountId: _this3.accountId,
                  payload: {
                    interestPreference: payload.interestPreference,
                    paymentPreference: payload.principalPreference
                  }
                });

              case 8:
                _context3.next = 10;
                return _this3.updateAccountImpactPreferences({
                  accountId: _this3.accountId,
                  payload: {
                    addPreferences: _this3.addPreferences,
                    removePreferences: _this3.removePreferences,
                    otherText: _this3.otherText,
                    otherId: _this3.otherTextId
                  }
                });

              case 10:
                _this3.addPreferences = [];
                _this3.removePreferences = [];
                _this3.$emit(__WEBPACK_IMPORTED_MODULE_8__data_static_events__["a" /* Events */].UPDATE_IMPACT_PREFERENCES_SUCCEED);
                _context3.next = 15;
                return _this3.initialize();

              case 15:
                _context3.next = 23;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3['catch'](0);

                _this3.$emit(__WEBPACK_IMPORTED_MODULE_8__data_static_events__["a" /* Events */].UPDATE_IMPACT_PREFERENCES_FAILED);
                _this3.setErrorsModalInfo(['Something went wrong. Please try again.']);
                _this3.showErrorsModal();
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["m" /* logAction */])({
                  message: 'Something went wrong while trying to save investor preferences',
                  stack: _context3.t0.stack || 'NA',
                  level: 'error'
                });

              case 23:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 17]]);
      }))();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('app', ['communicationPreferences', 'paymentPreferences']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('app', ['reservedImpactPreferenceCodes']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('question', ['display']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), {
    selectedPreferences: function selectedPreferences() {
      return this.preferences.filter(function (preference) {
        return preference.isSelected;
      }).map(function (preference) {
        return {
          id: preference.id,
          otherText: preference.otherText
        };
      });
    }
  }),
  watch: {
    other: function other(value) {
      this.selectOtherPreference(value);
    }
  },
  components: {
    question: __WEBPACK_IMPORTED_MODULE_11__components_modals_Question___default.a,
    RestrictedSingleInput: __WEBPACK_IMPORTED_MODULE_12__components_formControls_RestrictedSingleInput___default.a
  }
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_static_userTypes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_static_events__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_static_accountTypes__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_static_constants__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modals_AddRepresentatives__ = __webpack_require__(2086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modals_AddRepresentatives___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__modals_AddRepresentatives__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var mix = {
  methods: {
    getUserTypeLabel: __WEBPACK_IMPORTED_MODULE_3__util__["w" /* getUserTypeLabel */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountRepresentatives',
  data: function data() {
    return {
      showAddModal: false
    };
  },

  components: {
    'add-representatives': __WEBPACK_IMPORTED_MODULE_10__modals_AddRepresentatives___default.a
  },
  mixins: [mix],
  props: {
    accountId: {
      type: [Number, String],
      required: false,
      default: 0
    },
    representatives: {
      type: Array,
      required: true,
      default: []
    },
    accountName: {
      type: String,
      required: true,
      default: ''
    },
    accountType: {
      type: String,
      required: true
    },
    primaryInvestorId: {
      type: Number,
      required: true
    }
  },
  computed: {
    isDeleteEnabled: function isDeleteEnabled() {
      return this.representatives.length > 1 && !this.isReadOnly;
    },
    accountTypeName: function accountTypeName() {
      return this.accountType.toUpperCase();
    },
    isIndividualAccount: function isIndividualAccount() {
      return this.accountTypeName === __WEBPACK_IMPORTED_MODULE_6__data_static_accountTypes__["a" /* AccountTypes */].INDIVIDUAL.name;
    },
    isReadOnly: function isReadOnly() {
      var app = this.$store && this.$store.state && this.$store.state.app;
      return !!(app && app.user && app.user.userType === 'READ_ONLY');
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    canRepresentativeBePrimary: function canRepresentativeBePrimary() {
      var userType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (this.accountTypeName !== __WEBPACK_IMPORTED_MODULE_6__data_static_accountTypes__["a" /* AccountTypes */].TRUST.name && this.accountTypeName !== __WEBPACK_IMPORTED_MODULE_6__data_static_accountTypes__["a" /* AccountTypes */].INSTITUTION.name) {
        return userType !== __WEBPACK_IMPORTED_MODULE_4__data_static_userTypes__["a" /* UserTypes */].ADVISOR && userType !== __WEBPACK_IMPORTED_MODULE_4__data_static_userTypes__["a" /* UserTypes */].INSTITUTIONAL_REPRESENTATIVE.name && userType !== __WEBPACK_IMPORTED_MODULE_4__data_static_userTypes__["a" /* UserTypes */].READ_ONLY.name;
      }
      return userType !== __WEBPACK_IMPORTED_MODULE_4__data_static_userTypes__["a" /* UserTypes */].ADVISOR && userType !== __WEBPACK_IMPORTED_MODULE_4__data_static_userTypes__["a" /* UserTypes */].READ_ONLY.name;
    },
    attemptRepresentativeDelete: function attemptRepresentativeDelete(representative) {
      if (representative.id === this.primaryInvestorId) {
        this.setErrorsModalInfo(['You cannot delete the primary investor for the account. Please select another investor to be primary and then try again']);
        this.showErrorsModal();
      } else {
        this.showConfirmationModal(representative);
      }
    },
    showConfirmationModal: function showConfirmationModal(representative) {
      var _this = this;

      var isDefaultAccount = this.representatives.find(function (rep) {
        return rep.id === representative.id && rep.defaultAccountId === _this.accountId;
      });
      var question = isDefaultAccount ? 'This is the default login account for this user, if removed, their INDIVIDUAL ACCOUNT will be set as the default.' : 'Are you sure you want to unlink ' + representative.fullName + ' from the account ' + this.accountName + '?';
      this.showQuestionModal({
        question: question,
        title: 'Unlink representative',
        method: function method() {
          _this.deleteRepresentative(representative, isDefaultAccount);
          _this.hideQuestionModal();
        },
        yesButtonText: 'Confirm',
        hideCancelButton: false
      });
    },
    attemptUpdatePrimaryInvestor: function attemptUpdatePrimaryInvestor(representative) {
      if (!(representative.id === this.primaryInvestorId) && this.accountType !== __WEBPACK_IMPORTED_MODULE_6__data_static_accountTypes__["a" /* AccountTypes */].INDIVIDUAL.name) {
        this.showPrimaryInvestorConfirmation(representative);
      }
    },
    showPrimaryInvestorConfirmation: function showPrimaryInvestorConfirmation(representative) {
      var _this2 = this;

      var question = this.accountType === __WEBPACK_IMPORTED_MODULE_6__data_static_accountTypes__["a" /* AccountTypes */].INSTITUTION.name ? __WEBPACK_IMPORTED_MODULE_7__data_static_constants__["a" /* Constants */].updatePrimaryInvestorMessage.institutionAccountMessage : __WEBPACK_IMPORTED_MODULE_7__data_static_constants__["a" /* Constants */].updatePrimaryInvestorMessage.notInstitutionAccountMessage;
      this.showQuestionModal({
        question: question,
        title: 'Are you sure you want to select ' + representative.fullName + ' as the primary investor for the account ' + this.accountName + '?',
        method: function method() {
          _this2.updatePrimaryInvestor(representative.id);
          _this2.hideQuestionModal();
        },
        yesButtonText: 'Confirm',
        hideCancelButton: false
      });
    },
    updatePrimaryInvestor: function updatePrimaryInvestor(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].REPRESENTATIVE_LOADING_STARTED);
                _context.next = 3;
                return _this3.updateAccountPrimaryInvestor({
                  accountId: _this3.accountId, userId: id
                });

              case 3:
                _this3.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].REPRESENTATIVE_LOADING_SUCCEED);
                _this3.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].REPRESENTATIVES_UPDATED);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    deleteRepresentative: function deleteRepresentative(representative, isDefaultAccount) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, routeParams;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!isDefaultAccount) {
                  _this4.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].REPRESENTATIVE_LOADING_STARTED);
                }
                _context2.next = 3;
                return _this4.deleteAccountUser({
                  accountId: _this4.accountId, userId: representative.id
                });

              case 3:

                if (isDefaultAccount) {
                  params = { name: representative.firstName, userId: representative.id };
                  routeParams = void 0;

                  if (representative.userType === __WEBPACK_IMPORTED_MODULE_4__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name) {
                    routeParams = { name: 'EditFinancialAdvisor', params: params };
                  } else {
                    routeParams = { name: 'UserDetail', params: params };
                  }
                  _this4.$router.push(routeParams);
                } else {
                  _this4.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].REPRESENTATIVE_LOADING_SUCCEED);
                  _this4.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].REPRESENTATIVES_UPDATED);
                }

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapActions */])('account', ['deleteAccountUser', 'updateAccountPrimaryInvestor']), {
    openAddModal: function openAddModal() {
      this.showAddModal = true;
    },
    closeAddModal: function closeAddModal() {
      this.showAddModal = false;
    },
    refreshRepresentatives: function refreshRepresentatives() {
      this.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].REPRESENTATIVES_UPDATED);
    },
    goToUserView: function goToUserView(userId, type, name) {
      var routeParams = {
        name: type === __WEBPACK_IMPORTED_MODULE_4__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name ? 'EditFinancialAdvisor' : 'UserDetail',
        params: { name: name, userId: userId }
      };
      this.$router.push(routeParams);
    }
  })
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_detect_browser__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_detect_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_detect_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_DismissableAlert__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_DismissableAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_widgets_DismissableAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_OnboardingWizard__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_OnboardingWizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_OnboardingWizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_Information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_Information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_modals_Information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_static_transactionTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__data_static_logActions__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_static_transactionStatuses__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_mutation_types__ = __webpack_require__(8);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_6__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_6__util__["c" /* formatAmount */],
    formatType: __WEBPACK_IMPORTED_MODULE_6__util__["d" /* formatType */],
    formatStatus: __WEBPACK_IMPORTED_MODULE_6__util__["e" /* formatStatus */],
    isStateRestricted: __WEBPACK_IMPORTED_MODULE_6__util__["f" /* isStateRestricted */],
    isFailTransaction: __WEBPACK_IMPORTED_MODULE_6__util__["g" /* isFailTransaction */],
    isCancelTransaction: __WEBPACK_IMPORTED_MODULE_6__util__["h" /* isCancelTransaction */],
    isPurchaseFailedTransaction: __WEBPACK_IMPORTED_MODULE_6__util__["i" /* isPurchaseFailedTransaction */],
    isPurchaseFailedTransactionWithSelectedErrorsCode: __WEBPACK_IMPORTED_MODULE_6__util__["j" /* isPurchaseFailedTransactionWithSelectedErrorsCode */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'accountSummary',
  data: function data() {
    return {
      announcementHTML: '',
      loading: false,
      currentAmountBalance: 0,
      transactions: [],
      isThereAnyUpcomingTransaction: false,
      showPurchaseCompleted: false,
      shouldDisplayBlock: false,
      isIE: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_detect_browser__["detect"])().name === 'ie',
      summaryPageDocuments: []
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _this.loading = true;

              if (_this.hasBeenCreatedAccount) {
                _context.next = 5;
                break;
              }

              _this.loading = false;
              return _context.abrupt('return');

            case 5:
              _context.next = 7;
              return _this.checkUserStatus();

            case 7:
              if (_this.activeAccountId) {
                _context.next = 10;
                break;
              }

              _this.loading = false;
              return _context.abrupt('return');

            case 10:
              _context.next = 12;
              return _this.getTransactionsSummary();

            case 12:
              _context.next = 14;
              return _this.getAmountBalance();

            case 14:
              _context.next = 16;
              return _this.fetchSummaryPageDocuments();

            case 16:
              _context.next = 18;
              return _this.initializeAnnouncement();

            case 18:
              _this.showPurchaseCompleted = _this.$route.params.purchasedNote;
              _this.loading = false;
              _context.next = 25;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context['catch'](0);

              _this.loading = false;

            case 25:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 22]]);
    }))();
  },

  mixins: [mix],
  components: {
    spinner: __WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner___default.a,
    information: __WEBPACK_IMPORTED_MODULE_12__components_modals_Information___default.a,
    'onboarding-wizard': __WEBPACK_IMPORTED_MODULE_11__components_OnboardingWizard___default.a,
    'dismissable-alert': __WEBPACK_IMPORTED_MODULE_10__components_widgets_DismissableAlert___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('information', ['isInformationModalVisible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('home', ['userStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('app', ['activeAccountId', 'activeAccount', 'accountTypes', 'user', 'announcement']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['hasBeenCreatedAccount', 'hasBeenRedirected']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('app', ['user']), {
    announcementHTMLWithSafeLinks: function announcementHTMLWithSafeLinks() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util__["k" /* normalizeRichTextLinks */])(this.announcementHTML);
    },
    isInstitutionAccount: function isInstitutionAccount() {
      return this.activeAccount.accountType === this.accountTypes.INSTITUTION.name;
    },
    disableInvestment: function disableInvestment() {
      var _this2 = this;

      var _user = this.user,
          accounts = _user.accounts,
          disableInvestment = _user.disableInvestment;

      var account = accounts.find(function (acct) {
        return acct.id === _this2.activeAccount.id;
      });
      return disableInvestment || (account ? account.disableInvestment : true);
    },
    isReadOnly: function isReadOnly() {
      return this.user && this.user.userType === 'READ_ONLY';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('information', {
    showInformationModal: __WEBPACK_IMPORTED_MODULE_16__store_mutation_types__["d" /* SHOW_INFORMATION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('home', ['getUserStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('transaction', ['getAccountTransactionsSummary']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('account', ['getSummaryPageDocuments', 'createDocumentView', 'getCurrentAmountBalance', 'createAccountDocumentPresignedUrl']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('user', ['getAnnouncement']), {
    initializeAnnouncement: function initializeAnnouncement() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var announcement;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.getAnnouncement();

              case 2:
                announcement = _context2.sent;


                _this3.announcementHTML = announcement.html || '';

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    isEmptyAnnouncement: function isEmptyAnnouncement() {
      var domParser = new DOMParser();
      var parsedAnnouncement = domParser.parseFromString(this.announcementHTML, 'text/html');
      var body = parsedAnnouncement.body;
      if (!body.firstChild) {
        return true;
      }
      return body.textContent.length === 0 || body.firstChild.textContent.length === 0;
    },
    goToAccountCreation: function goToAccountCreation() {
      this.$router.push({ name: 'AccountCreation' });
    },
    updateAccountSummary: function updateAccountSummary() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.loading = true;
                _context3.prev = 1;

                if (_this4.hasBeenCreatedAccount) {
                  _context3.next = 5;
                  break;
                }

                _this4.loading = false;
                return _context3.abrupt('return');

              case 5:
                _context3.next = 7;
                return _this4.checkUserStatus();

              case 7:
                if (_this4.activeAccountId) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt('return');

              case 9:
                _context3.next = 11;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this4.getTransactionsSummary(), _this4.getAmountBalance(), _this4.fetchSummaryPageDocuments()]);

              case 11:
                _context3.prev = 11;

                _this4.loading = false;
                return _context3.finish(11);

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[1,, 11, 14]]);
      }))();
    },
    goToNotePurchase: function goToNotePurchase() {
      var state = this.user.residentialAddress.state;
      if (this.isStateRestricted(state)) {
        var restrictedMessage = 'At this time, we cannot accept investments from persons resident in ' + state + ' state.\n          Please contact Calvert Impact Capital at info@calvertimpact.org or call us at 800-248-0337 if you have questions.';
        this.showInformationModal(restrictedMessage);
      } else if (this.userStatus.needs.includes('FUNDING_SOURCE') || this.userStatus.status === 'document_migrated_user' || this.userStatus.status === 'retry') {
        this.$router.push({ name: 'AddFundingSource' });
      } else {
        this.$router.push({ name: 'PurchaseNote' });
      }
    },
    checkUserStatus: function checkUserStatus() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var accountId, response, status, needs;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                accountId = _this5.activeAccount.id;

                // Without a real account there is no status to fetch. Asking for
                // account 0 returns a 403, which the HttpService interceptor turns
                // into a redirect to Home.

                if (accountId) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt('return');

              case 4:
                _context4.next = 6;
                return _this5.getUserStatus({
                  accountId: accountId
                });

              case 6:
                response = _context4.sent;
                status = response.status, needs = response.needs;


                if (status === 'kba') {
                  _this5.$router.push({ name: 'KbaVerification' });
                } else if (status === 'document') {
                  _this5.$router.push({ name: 'DocumentUpload' });
                } else if (status === 'retry') {
                  _this5.$router.push({ name: 'AccountCreation' });
                } else if (status === 'suspended') {
                  _this5.$router.push({ name: 'AccountSuspended' });
                } else if (!needs.includes('FUNDING_SOURCE') && needs.includes('NOTE')) {
                  _this5.$router.push({ name: 'PurchaseNote', query: { first: 1 } });
                }
                _context4.next = 15;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](0);

                _this5.loading = false;
                console.error(_context4.t0);

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 11]]);
      }))();
    },
    getAmountBalance: function getAmountBalance() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this6.getCurrentAmountBalance({ accountId: _this6.activeAccountId });

              case 2:
                response = _context5.sent;

                _this6.currentAmountBalance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* formatAmount */])(response.currentAmountBalance);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    isTransactionAboutPrependingPayment: function isTransactionAboutPrependingPayment(_ref) {
      var type = _ref.type,
          status = _ref.status,
          actionTaken = _ref.actionTaken;

      return (type === __WEBPACK_IMPORTED_MODULE_13__data_static_transactionTypes__["a" /* default */].INT_PAID || type === __WEBPACK_IMPORTED_MODULE_13__data_static_transactionTypes__["a" /* default */].SELL_MATURE || type === __WEBPACK_IMPORTED_MODULE_13__data_static_transactionTypes__["a" /* default */].INT_REINVEST || type === __WEBPACK_IMPORTED_MODULE_13__data_static_transactionTypes__["a" /* default */].SELL_REINVEST || type === __WEBPACK_IMPORTED_MODULE_13__data_static_transactionTypes__["a" /* default */].INT_DONATE || type === __WEBPACK_IMPORTED_MODULE_13__data_static_transactionTypes__["a" /* default */].SELL_DONATE) && status === __WEBPACK_IMPORTED_MODULE_15__data_static_transactionStatuses__["a" /* default */].PREPENDING && !actionTaken;
    },
    getTransactionsSummary: function getTransactionsSummary() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var transactions;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (_this7.activeAccountId) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt('return');

              case 2:
                _context6.next = 4;
                return _this7.getAccountTransactionsSummary({
                  accountId: _this7.activeAccountId
                });

              case 4:
                transactions = _context6.sent;

                _this7.transactions = transactions;
                _this7.shouldDisplayBlock = _this7.isIE && _this7.transactions.length > 8;
                _this7.isThereAnyUpcomingTransaction = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.some(transactions, function (transactionObject) {
                  return _this7.isTransactionAboutPrependingPayment(transactionObject);
                });

              case 8:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    fetchSummaryPageDocuments: function fetchSummaryPageDocuments() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this8.getSummaryPageDocuments({
                  accountId: _this8.activeAccountId
                });

              case 2:
                _this8.summaryPageDocuments = _context7.sent;

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    getIconUrl: function getIconUrl(icon, iconName) {
      if (icon) {
        return icon.Url;
      }
      return __webpack_require__(2217)("./" + iconName); // eslint-disable-line
    },
    openDocument: function openDocument(doc) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this9.createAccountDocumentPresignedUrl({
                  accountId: _this9.activeAccountId,
                  payload: {
                    key: doc.OriginalKey
                  }
                });

              case 2:
                res = _context8.sent;

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util__["l" /* openUrl */])(res.url);
                _context8.next = 6;
                return _this9.logDocumentViewed(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc, { Url: res.url }));

              case 6:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    logDocumentViewed: function logDocumentViewed(doc) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var Key, LastModified, ETag, Url, logMessage;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                Key = doc.Key, LastModified = doc.LastModified, ETag = doc.ETag, Url = doc.Url;
                _context9.next = 3;
                return _this10.createDocumentView({
                  fileName: Key,
                  lastModified: __WEBPACK_IMPORTED_MODULE_5_moment___default()(LastModified).toDate(),
                  url: Url.split('?')[0],
                  Etag: ETag,
                  userId: _this10.user.id,
                  accountId: _this10.activeAccountId
                });

              case 3:
                logMessage = 'User U' + _this10.user.id + ' viewed ' + Key + ' document';

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util__["m" /* logAction */])({
                  user: _this10.user.id,
                  level: 'info',
                  action: __WEBPACK_IMPORTED_MODULE_14__data_static_logActions__["a" /* default */].DOCUMENT_VIEW.name,
                  message: logMessage
                });

              case 5:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    },
    hidePurchaseCompletedAlert: function hidePurchaseCompletedAlert() {
      this.showPurchaseCompleted = false;
    }
  })
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_widgets_Spinner__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'accountSuspended',
  data: function data() {
    return {
      loading: false
    };
  },
  beforeMount: function beforeMount() {
    this.checkUserStatus();
  },

  components: {
    spinner: __WEBPACK_IMPORTED_MODULE_4__components_widgets_Spinner___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['activeAccount', 'user'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('home', ['getUserStatus']), {
    checkUserStatus: function checkUserStatus() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                return _context.abrupt('return', _this.getUserStatus({
                  accountId: _this.activeAccount.id
                }).then(function (_ref) {
                  var status = _ref.status;

                  if (status !== 'suspended') {
                    _this.$router.push({ name: 'Home' });
                  }
                  _this.loading = false;
                }).catch(function () {
                  _this.loading = false;
                }));

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  })
});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_static_constants__ = __webpack_require__(16);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var mix = {
  methods: {
    formatAmount: __WEBPACK_IMPORTED_MODULE_5__util__["c" /* formatAmount */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountsList',
  props: ['accounts', 'userType', 'defaultAccountId'],
  beforeMount: function beforeMount() {
    this.initializeState();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['userTypes'])),
  mixins: [mix],
  data: function data() {
    return {
      userId: '',
      name: '',
      showDefaultAccountChanged: false,
      fetchingSummaryReports: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('account', ['getAccountSummaryReport']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('accountCreation', {
    showAccountCreationModal: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["z" /* SHOW_ACCOUNT_CREATION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), {
    initializeState: function initializeState() {
      this.userId = this.$route.params.userId;
      this.name = this.$route.params.name;
    },
    openAccountCreationModal: function openAccountCreationModal() {
      var userId = this.userId;
      var name = this.name;
      this.showAccountCreationModal({ userId: userId, name: name });
    },
    generateSummaryReport: function generateSummaryReport(account) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var withoutAccruedInterestReport, withAccruedInterest;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.fetchingSummaryReports = true;
                _context.next = 3;
                return _this.getAccountSummaryReport({
                  accountId: account.id,
                  withAccruedInterest: false
                });

              case 3:
                withoutAccruedInterestReport = _context.sent;

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["I" /* downloadPDF */])(withoutAccruedInterestReport.fileName, withoutAccruedInterestReport.pdf.data);
                _context.next = 7;
                return _this.getAccountSummaryReport({
                  accountId: account.id,
                  withAccruedInterest: true
                });

              case 7:
                withAccruedInterest = _context.sent;

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["I" /* downloadPDF */])(withAccruedInterest.fileName, withAccruedInterest.pdf.data);
                _this.fetchingSummaryReports = false;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    goToViewDetail: function goToViewDetail(account) {
      var accountTypeProperties = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["n" /* getAccounTypeProperties */])(account.accountType);
      var routeParams = {
        name: accountTypeProperties.component,
        params: {
          accountId: account.id,
          name: this.name,
          userId: this.userId
        }
      };

      this.$router.push(routeParams);
    },
    changeDefaultAccount: function changeDefaultAccount(account) {
      var _this2 = this;

      this.showQuestionModal({
        title: 'Default Account',
        question: 'Are you sure you want to select ' + account.accountName + ' as new default account?',
        method: function method() {
          _this2.confirmChangeDefaultAccount(account.id);
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_7__data_static_constants__["a" /* Constants */].purchaseNote.modalYesButtonText,
        hideCancelButton: false
      });
    },
    confirmChangeDefaultAccount: function confirmChangeDefaultAccount(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$emit('confirmedChangeDefaultAccount', { accountId: id, userId: _this3.userId });
                _this3.hideQuestionModal();

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }),
  components: {
    spinner: __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default.a
  }
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_modals_Information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_BankAccountChangedWarning__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_BankAccountChangedWarning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_modals_BankAccountChangedWarning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_widgets_DismissableAlert__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_widgets_DismissableAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_widgets_DismissableAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_OnboardingWizard__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_OnboardingWizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_OnboardingWizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__data_static_logActions__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__data_static_constants__ = __webpack_require__(16);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















var mix = {
  methods: {
    formatType: __WEBPACK_IMPORTED_MODULE_17__util__["d" /* formatType */],
    isStateRestricted: __WEBPACK_IMPORTED_MODULE_17__util__["f" /* isStateRestricted */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'addFundingSource',
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.showFundingSourceActionSuccess = _this.$route.params.addedFundingSource;
              if (_this.showFundingSourceActionSuccess) {
                _this.fundingSourceAction = 'added';
              }
              _context.next = 4;
              return _this.initialize();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  mixins: [mix],
  data: function data() {
    return {
      maxAmountFundingSources: 3,
      fundingSourcesTypeBankLength: 0,
      previousFundingSourceId: null,
      fundingSources: [],
      showFundingTable: true,
      plaidService: window.Plaid,
      loading: false,
      isLegacyUser: false,
      showPendingMicrodepositsLabel: false,
      legacyFundingSourceMessageFirstLine: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].purchaseNote.legacyFundingSourceMessageFirstLine,
      legacyFundingSourceMessageSecondLine: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].purchaseNote.legacyFundingSourceMessageSecondLine,
      onBoardingCompleted: false,
      confirmConsentModalShown: false,
      activeAccountIndex: 0,
      showFundingSourceActionSuccess: false,
      fundingSourceAction: '',
      addFundingSourceUsingPlaidSuccess: false,
      isBankAccountChangedWarningVisible: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('account', ['settingDefaultFundingSource']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('home', ['userStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('app', ['user', 'activeAccountId', 'activeAccount', 'fundingSourceTypes']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('question', ['display']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('information', ['isInformationModalVisible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('app', ['hasBeenCreatedAccount']), {
    disableInvestment: function disableInvestment() {
      var _this2 = this;

      var _user = this.user,
          accounts = _user.accounts,
          disableInvestment = _user.disableInvestment;

      var account = accounts.find(function (acct) {
        return acct.id === _this2.activeAccount.id;
      });
      return disableInvestment || account.disableInvestment;
    },
    isReadOnly: function isReadOnly() {
      return this.user && this.user.userType === 'READ_ONLY';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('home', ['getUserStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('accountCreation', ['getUserProfile', 'updateConsentModalFlag']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('account', ['setDefaultFundingSource', 'getAccountFundingSources']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('fundingSource', ['createDwollaUser', 'updateDwollaCustomer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('fundingSource', ['deleteFundingSource']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('app', {
    setUser: __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["a" /* SET_USER */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('information', {
    showInformationModal: __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["d" /* SHOW_INFORMATION_MODAL */]
  }), {
    initialize: function initialize() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.loadUserProfile();

              case 2:
                _context2.next = 4;
                return _this3.checkUserStatus();

              case 4:
                response = _context2.sent;

                if (!(response && (response.status === 'document' || response.status === 'kba'))) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return');

              case 7:
                _context2.next = 9;
                return _this3.loadFundingSources();

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    loadUserProfile: function loadUserProfile() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.loading = true;

                _context3.next = 3;
                return _this4.getUserProfile();

              case 3:
                data = _context3.sent;

                _this4.setUser(data);

                data.accounts.forEach(function (account, idx) {
                  if (account.accountType === 'INDIVIDUAL') {
                    _this4.onBoardingCompleted = !!account.onBoardingCompleted;
                    _this4.confirmConsentModalShown = !!account.confirmConsentModalShown;
                    _this4.previousFundingSourceId = account.defaultFundingSourceId;
                  }

                  if (account.id === _this4.activeAccountId) {
                    _this4.activeAccountIndex = idx;
                  }
                });

                _this4.loading = false;

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    loadFundingSources: function loadFundingSources() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.loading = true;
                _this5.showFundingTable = true;
                _context4.next = 4;
                return _this5.getAccountFundingSources(_this5.activeAccountId);

              case 4:
                data = _context4.sent;


                _this5.fundingSources = data.filter(function (fss) {
                  return (fss.type === 'bank' || fss.type === 'check' || fss.type === 'wire/ach') && !fss.removed;
                });

                _this5.verifyFundingSources(_this5.fundingSources);
                if (_this5.fundingSources.length === 0) {
                  if (_this5.onBoardingCompleted) {
                    _this5.showFundingTable = true;
                  } else {
                    _this5.addAccount();
                  }
                }
                _this5.fundingSourcesTypeBankLength = _this5.fundingSources.filter(function (fs) {
                  return fs.type === 'bank';
                }).length;
                _this5.loading = false;
                return _context4.abrupt('return', _this5.fundingSources);

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    legacyFundingSourcesExist: function legacyFundingSourcesExist() {
      var containsLegacyFundingSource = this.fundingSources.find(function (fs) {
        return (fs.type === 'check' || fs.type === 'wire/ach') && !fs.removed;
      });

      return containsLegacyFundingSource !== undefined;
    },
    methodToExecuteInQuestionModal: function methodToExecuteInQuestionModal(fundingSourceId) {
      var _this6 = this;

      this.hideQuestionModal();
      var account = this.user.accounts[this.activeAccountIndex];
      this.setDefaultFundingSource({
        accountId: account.id,
        fundingSourceId: fundingSourceId
      }).then(function () {
        _this6.previousFundingSourceId = fundingSourceId;
        _this6.user.accounts[_this6.activeAccountIndex].defaultFundingSourceId = fundingSourceId;
        _this6.showBankAccountChangedWarning();
      });
    },
    redirectToConfirmMicrodepositPage: function redirectToConfirmMicrodepositPage(fundingSourceId) {
      if (this.isReadOnly) return;
      this.$router.push({
        name: 'MicroDepositsVerification',
        params: { id: fundingSourceId }
      });
    },
    showConfirmationModal: function showConfirmationModal(_ref) {
      var _this7 = this;

      var fundingSource = _ref.fundingSource;

      if (this.isReadOnly) return;
      this.user.accounts[this.activeAccountIndex].defaultFundingSourceId = this.previousFundingSourceId;
      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].fundingSource.defaultFundingSourceModalTitle,
        question: 'Are you sure you want to select ' + fundingSource.name + ' as your new default bank account?',
        method: function method() {
          _this7.methodToExecuteInQuestionModal(fundingSource.id);
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].purchaseNote.modalYesButtonText,
        hideCancelButton: false
      });
    },
    showDeleteConfirmationModal: function showDeleteConfirmationModal(fundingSourceId) {
      var _this8 = this;

      if (this.isReadOnly) return;
      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].fundingSource.deleteFundingSourceModalTitle,
        question: 'Are you sure you want to delete this bank account?',
        method: function method() {
          return _this8.deleteFundingSource(fundingSourceId).then(function () {
            _this8.hideQuestionModal();
            var indexToRemove = _this8.fundingSources.findIndex(function (fs) {
              return fs.id === fundingSourceId;
            });
            if (indexToRemove > -1) {
              _this8.fundingSources.splice(indexToRemove, 1);
            }
            _this8.showFundingSourceActionSuccess = true;
            _this8.fundingSourceAction = 'deleted';
            _this8.verifyFundingSources(_this8.fundingSources);
            _this8.loadFundingSources();
          }).catch(function (err) {
            _this8.loading = false;
            _this8.hideQuestionModal();
            var errorMessage = '';
            if (err.message === 'PENDING_TRANSACTIONS') {
              errorMessage = 'You may have a transaction in process or an upcoming payment for this bank account.\n              You won\'t be able to delete it until those transactions have been finalized or you have changed the upcoming payments to a different bank account.\n               If you believe that transactions in progress will not complete due to a block or other issue on your bank account,\n               please contact the Calvert Impact Capital and we will assist you.';
            }
            if (err.message === 'DEFAULT_FUNDING_SOURCE') {
              errorMessage = 'Please make sure you\'ve selected another bank account as your default one before attempting to delete this one.';
            }
            if (err.message === 'NOT_PRIMARY_INVESTOR') {
              errorMessage = 'Only primary investors can remove bank accounts, please ask the primary investor on this account to remove this bank account.';
            }
            _this8.showErrorModal(errorMessage || err);
          });
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].purchaseNote.modalYesButtonText,
        hideCancelButton: false
      });
    },
    hideFundingSourceActionSuccess: function hideFundingSourceActionSuccess() {
      this.showFundingSourceActionSuccess = false;
    },
    showErrorModal: function showErrorModal(err) {
      var listErrors = [];
      listErrors.push(err);

      this.setErrorsModalInfo(listErrors);
      this.showErrorsModal();
    },
    verifyFundingSources: function verifyFundingSources(fundingSources) {
      var matchedFundingSource = fundingSources.find(function (fundingSource) {
        return typeof fundingSource._links !== 'undefined' && // eslint-disable-line no-underscore-dangle
        !!fundingSource._links['verify-micro-deposits'];
      } // eslint-disable-line no-underscore-dangle
      );

      this.showPendingMicrodepositsLabel = !!(matchedFundingSource && matchedFundingSource.id);
    },
    selectDefaultFundingSource: function selectDefaultFundingSource(fundingSources, fundingSourceId) {
      if (this.previousFundingSourceId === null) {
        var fundingSource = fundingSources.find(function (fs) {
          return fs.id === fundingSourceId;
        });
        if (fundingSource.status === 'verified') {
          var account = this.user.accounts[this.activeAccountIndex];
          this.setDefaultFundingSource({ accountId: account.id, fundingSourceId: fundingSourceId });
          this.user.accounts[this.activeAccountIndex].defaultFundingSourceId = fundingSourceId;
          this.previousFundingSourceId = fundingSourceId;
          this.showBankAccountChangedWarning();
        }
      }
    },
    addAccount: function addAccount() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this9.showFundingTable = false;
                _this9.showPendingMicrodepositsLabel = false;
                _this9.hideFundingSourceActionSuccess();
                _this9.addFundingSourceUsingPlaid();

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this9);
      }))();
    },
    addedBankAccountSuccess: function addedBankAccountSuccess() {
      this.showFundingSourceActionSuccess = true;
      this.fundingSourceAction = 'added';
    },
    retryModal: function retryModal() {
      var _this10 = this;

      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].fundingSource.modalTitle,
        question: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].fundingSource.retryDisclamer,
        questionAppend: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].fundingSource.legacyDisclamerRetry,
        yesButtonText: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].fundingSource.modalEditProfileButtonText,
        method: function () {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _this10.hideQuestionModal();
                    _this10.loading = true;
                    _this10.$router.push({ name: 'EditUserProfile' });

                  case 3:
                  case 'end':
                    return _context6.stop();
                }
              }
            }, _callee6, _this10);
          }));

          return function method() {
            return _ref2.apply(this, arguments);
          };
        }() });
    },
    verifyPrimaryInvestor: function verifyPrimaryInvestor() {
      if (this.user.id !== this.activeAccount.primaryInvestorId) {
        var restrictedMessage = 'If you would like to purchase Notes online and/or have repayments go directly to a bank account, please ask the primary investor on this account to add one or more bank accounts.';
        this.showInformationModal(restrictedMessage);
      } else {
        this.addBankAccount();
      }
    },
    addFundingSourceUsingPlaid: function addFundingSourceUsingPlaid() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var activeAccount, dwollaCustomerId, linkHandler;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this11.success = false;
                activeAccount = _this11.user.accounts && _this11.user.accounts[_this11.activeAccountIndex];
                dwollaCustomerId = activeAccount && activeAccount.dwollaCustomerId || _this11.user.dwollaCustomerId;
                _context8.t0 = _this11.plaidService;
                _context8.next = 6;
                return __WEBPACK_IMPORTED_MODULE_7__api_HttpService__["a" /* default */].postV2('/funding-sources/link-token', {
                  dwollaCustomerId: dwollaCustomerId
                });

              case 6:
                _context8.t1 = _context8.sent.link_token;

                _context8.t2 = function onLoad() {
                  // The Link module finished loading.
                };

                _context8.t3 = function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7(publicToken, metadata) {
                    var response, _user$accounts$active, accountName, accountId, _metadata$accounts, account, selectedAccount, fundingSources, fundingSourceIdAdded, errorMessage;

                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            _this11.loading = true;
                            _this11.addFundingSourceUsingPlaidSuccess = true;
                            _this11.addedBankAccountSuccess();
                            _context7.prev = 3;
                            _context7.next = 6;
                            return __WEBPACK_IMPORTED_MODULE_7__api_HttpService__["a" /* default */].postV2('/funding-sources/exchange-link-token', {
                              publicToken: publicToken,
                              accounts: metadata.accounts,
                              dwollaCustomerId: dwollaCustomerId
                            });

                          case 6:
                            response = _context7.sent;
                            _user$accounts$active = _this11.user.accounts[_this11.activeAccountIndex], accountName = _user$accounts$active.accountName, accountId = _user$accounts$active.accountId;

                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util__["m" /* logAction */])({
                              user: _this11.user.userId,
                              level: 'info',
                              action: __WEBPACK_IMPORTED_MODULE_16__data_static_logActions__["a" /* default */].ADD_FUNDING_SOURCE.name,
                              message: 'New bank account added to account ' + accountId + ' ' + accountName,
                              tags: [__WEBPACK_IMPORTED_MODULE_17__util__["x" /* logglyTags */].dwolla]
                            });

                            _metadata$accounts = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(metadata.accounts, 1), account = _metadata$accounts[0];
                            selectedAccount = response.find(function (r) {
                              return r.id === account.id;
                            });
                            _context7.next = 13;
                            return _this11.loadFundingSources();

                          case 13:
                            fundingSources = _context7.sent;
                            _context7.next = 16;
                            return _this11.loadUserProfile();

                          case 16:

                            if (selectedAccount) {
                              fundingSourceIdAdded = selectedAccount.location.split('/').pop();

                              if (fundingSourceIdAdded) {
                                _this11.selectDefaultFundingSource(fundingSources, fundingSourceIdAdded);
                              }
                            }

                            _context7.next = 19;
                            return _this11.checkUserStatus();

                          case 19:
                            _context7.next = 26;
                            break;

                          case 21:
                            _context7.prev = 21;
                            _context7.t0 = _context7['catch'](3);
                            errorMessage = 'Something went wrong please try again!';


                            if (_context7.t0.message === 'DuplicateResource') {
                              errorMessage = 'You have already added the account.';
                            } else if (_context7.t0.message === 'DATABASE_AUTH_FAIL') {
                              errorMessage = "We couldn't verify this account with your bank. Please try a different account or use micro-deposit verification instead.";
                            }
                            _this11.showErrorModal(errorMessage);

                          case 26:
                            _context7.prev = 26;

                            _this11.loading = false;
                            _this11.showFundingTable = true;
                            return _context7.finish(26);

                          case 30:
                          case 'end':
                            return _context7.stop();
                        }
                      }
                    }, _callee7, _this11, [[3, 21, 26, 30]]);
                  }));

                  return function onSuccess(_x, _x2) {
                    return _ref3.apply(this, arguments);
                  };
                }();

                _context8.t4 = function onExit(err, metadata) {
                  if (!_this11.addFundingSourceUsingPlaidSuccess) {
                    _this11.showFundingTable = true;
                  }
                  // The user exited the Link flow.
                  if (err != null) {
                    // The user encountered a Plaid API error
                    // prior to exiting.
                  }
                  if (metadata) {
                    // metadata contains information about the institution
                    // that the user selected and the most recent
                    // API request IDs.
                    // Storing this information can be helpful for support.
                  }
                };

                _context8.t5 = {
                  token: _context8.t1,
                  onLoad: _context8.t2,
                  onSuccess: _context8.t3,
                  onExit: _context8.t4
                };
                linkHandler = _context8.t0.create.call(_context8.t0, _context8.t5);

                linkHandler.open();

              case 13:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this11);
      }))();
    },
    addBankAccount: function addBankAccount() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var isLegacyUser;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!_this12.isReadOnly) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt('return');

              case 2:
                if (!(!_this12.user.socialSecurityNum || !__WEBPACK_IMPORTED_MODULE_6_moment___default()(_this12.user.dateOfBirth, 'YYYY-MM-DD', true).isValid())) {
                  _context9.next = 5;
                  break;
                }

                _this12.retryModal();
                return _context9.abrupt('return');

              case 5:
                _context9.next = 7;
                return _this12.showLegacyDisclamer();

              case 7:
                isLegacyUser = _context9.sent;
                _context9.prev = 8;

                if (!(isLegacyUser && !_this12.confirmConsentModalShown)) {
                  _context9.next = 14;
                  break;
                }

                _context9.next = 12;
                return _this12.showDisclaimerConfirmationModal();

              case 12:
                _context9.next = 20;
                break;

              case 14:
                if (!(isLegacyUser && _this12.confirmConsentModalShown)) {
                  _context9.next = 20;
                  break;
                }

                _this12.loading = true;
                _context9.next = 18;
                return _this12.createDwollaUser(_this12.user.id);

              case 18:
                _context9.next = 20;
                return _this12.initialize();

              case 20:
                _context9.next = 28;
                break;

              case 22:
                _context9.prev = 22;
                _context9.t0 = _context9['catch'](8);

                _this12.loading = false;

                if (!(_context9.t0.statusCode === 400)) {
                  _context9.next = 28;
                  break;
                }

                _this12.retryModal();
                return _context9.abrupt('return');

              case 28:
                _this12.loading = true;

                if (!(_this12.userStatus && _this12.userStatus.status === 'retry')) {
                  _context9.next = 32;
                  break;
                }

                _context9.next = 32;
                return _this12.updateDwollaCustomer();

              case 32:
                _this12.getUserStatus({
                  userId: _this12.user.id,
                  accountId: _this12.activeAccount.id,
                  userFirstName: _this12.user.firstName,
                  userLastName: _this12.user.lastName
                }).then(function (_ref4) {
                  var status = _ref4.status;

                  _this12.loading = false;
                  if (status === 'retry') {
                    _this12.retryModal();
                  } else if (status === 'document_migrated_user') {
                    _this12.$router.push({ name: 'DocumentUpload' });
                  } else {
                    _this12.addAccount();
                  }
                });

              case 33:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this12, [[8, 22]]);
      }))();
    },
    showLegacyDisclamer: function showLegacyDisclamer() {
      var _this13 = this;

      return this.loadUserProfile().then(function () {
        var individualAccount = _this13.user.accounts.find(function (ac) {
          return ac.accountType === 'INDIVIDUAL';
        });
        _this13.isLegacyUser = individualAccount.dwollaCustomerId === null;
        return _this13.isLegacyUser;
      });
    },
    showDisclaimerConfirmationModal: function showDisclaimerConfirmationModal() {
      var _this14 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this14.showQuestionModal({
          title: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].fundingSource.modalTitle,
          question: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].fundingSource.legacyDisclamer,
          hyperLinkUrl: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].fundingSource.hyperLinkUrl,
          hyperLinkText: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].fundingSource.hyperLinkText,
          hyperLinkUrl2: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].fundingSource.hyperLinkUrl2,
          hyperLinkText2: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].fundingSource.hyperLinkText2,
          questionAppend: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].fundingSource.legacyDisclamerAppend,
          method: function () {
            var _ref5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10() {
              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                while (1) {
                  switch (_context10.prev = _context10.next) {
                    case 0:
                      _context10.prev = 0;

                      _this14.hideQuestionModal();
                      _this14.loading = true;
                      _this14.updateConsentModalFlag();
                      _context10.next = 6;
                      return _this14.createDwollaUser(_this14.user.id);

                    case 6:
                      _context10.next = 8;
                      return _this14.initialize();

                    case 8:
                      resolve(true);
                      _context10.next = 15;
                      break;

                    case 11:
                      _context10.prev = 11;
                      _context10.t0 = _context10['catch'](0);

                      _this14.loading = false;
                      if (_context10.t0.statusCode === 400) {
                        _this14.retryModal();
                      }

                    case 15:
                    case 'end':
                      return _context10.stop();
                  }
                }
              }, _callee10, _this14, [[0, 11]]);
            }));

            return function method() {
              return _ref5.apply(this, arguments);
            };
          }(),
          yesButtonText: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].fundingSource.modalYesButtonText,
          hideCancelButton: false
        });
      });
    },
    removeFundingSource: function removeFundingSource(fundingSourceId) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this15.showDeleteConfirmationModal(fundingSourceId);

              case 1:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this15);
      }))();
    },
    checkUserStatus: function checkUserStatus() {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var response, needs, status;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;

                _this16.loading = true;

                if (!_this16.hasBeenCreatedAccount) {
                  _this16.$router.push({ name: 'AccountSummary' });
                }

                _context12.next = 5;
                return _this16.getUserStatus({
                  accountId: _this16.activeAccount.id
                });

              case 5:
                response = _context12.sent;
                needs = response.needs, status = response.status;


                if (status === 'kba') {
                  _this16.$router.push({ name: 'KbaVerification' });
                } else if (status === 'document') {
                  _this16.$router.push({ name: 'DocumentUpload' });
                } else if (status === 'retry') {
                  _this16.$router.push({ name: 'AccountCreation' });
                } else if (status === 'suspended') {
                  _this16.$router.push({ name: 'AccountSuspended' });
                } else if (!needs.includes('FUNDING_SOURCE') && needs.includes('NOTE')) {
                  _this16.$router.push({ name: 'PurchaseNote', query: { first: 1 } });
                } else {
                  _this16.loading = false;
                }
                return _context12.abrupt('return', response);

              case 11:
                _context12.prev = 11;
                _context12.t0 = _context12['catch'](0);

                _this16.showErrorModal(_context12.t0.message);
                _this16.loading = false;
                return _context12.abrupt('return', _context12.t0);

              case 16:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this16, [[0, 11]]);
      }))();
    },
    showBankAccountChangedWarning: function showBankAccountChangedWarning() {
      this.isBankAccountChangedWarningVisible = true;
    },
    hideBankAccountChangedWarning: function hideBankAccountChangedWarning() {
      this.isBankAccountChangedWarningVisible = false;
    },
    handleGoToUpcomingTransactions: function handleGoToUpcomingTransactions() {
      this.$router.push({ name: 'UpcomingTransactions' });
    }
  }),
  components: {
    errors: __WEBPACK_IMPORTED_MODULE_9__components_modals_Errors___default.a,
    question: __WEBPACK_IMPORTED_MODULE_10__components_modals_Question___default.a,
    BankAccountChangedWarning: __WEBPACK_IMPORTED_MODULE_12__components_modals_BankAccountChangedWarning___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_13__components_widgets_Spinner___default.a,
    information: __WEBPACK_IMPORTED_MODULE_11__components_modals_Information___default.a,
    'onboarding-wizard': __WEBPACK_IMPORTED_MODULE_15__components_OnboardingWizard___default.a,
    'dismissable-alert': __WEBPACK_IMPORTED_MODULE_14__components_widgets_DismissableAlert___default.a
  }
});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_money__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Breadcrumb__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_static_constants__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_static_userTypes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_formControls_RestrictedTextArea__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_formControls_RestrictedTextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_formControls_RestrictedTextArea__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















var mix = {
  methods: {
    formatAmount: __WEBPACK_IMPORTED_MODULE_12__util__["c" /* formatAmount */],
    formatDecimal: __WEBPACK_IMPORTED_MODULE_12__util__["q" /* formatDecimal */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'addFunds',
  beforeMount: function beforeMount() {
    this.setParams();
    this.loadInformation();
    this.loadInvestmentsValidations();
  },

  components: {
    breadcrumb: __WEBPACK_IMPORTED_MODULE_7__components_Breadcrumb___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_10__components_widgets_Spinner___default.a,
    errors: __WEBPACK_IMPORTED_MODULE_8__components_modals_Errors___default.a,
    question: __WEBPACK_IMPORTED_MODULE_9__components_modals_Question___default.a,
    'restricted-textarea': __WEBPACK_IMPORTED_MODULE_14__components_formControls_RestrictedTextArea___default.a
  },
  mixins: [mix],
  directives: {
    money: __WEBPACK_IMPORTED_MODULE_6_v_money__["VMoney"]
  },
  watch: {
    information: function changeNote(newTransferNote) {
      var _newTransferNote$acco = newTransferNote.account,
          accountName = _newTransferNote$acco.accountName,
          accountType = _newTransferNote$acco.accountType,
          accountId = _newTransferNote$acco.id,
          users = _newTransferNote$acco.users;

      this.breadcrumbData = [];
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {
        title: 'Search',
        goto: { name: 'Users' },
        selected: false
      }));
      var params = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.$route.params);
      // prettier-ignore
      var user = users.find(function (search) {
        return search.id === Number(params.userId);
      });
      var userType = user.userType,
          firstName = user.firstName,
          lastName = user.lastName;

      var goto = void 0;
      if (userType === __WEBPACK_IMPORTED_MODULE_13__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name) {
        goto = {
          name: 'EditFinancialAdvisor',
          params: {
            name: params.name,
            userId: params.userId
          }
        };
      } else {
        goto = {
          name: 'UserDetail',
          params: { name: params.name, userId: params.userId }
        };
      }
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {
        goto: goto,
        title: firstName.concat(' ', lastName),
        selected: false
      }));
      var accountTypeProperties = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util__["n" /* getAccounTypeProperties */])(accountType);
      var gotoAccount = {
        name: accountTypeProperties.component,
        params: {
          accountId: accountId,
          name: params.name,
          userId: params.userId
        }
      };
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {
        title: accountName,
        goto: gotoAccount,
        selected: false
      }));
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {
        title: 'Note'.concat(' ', newTransferNote.noteId),
        goto: { name: 'NoteDetail', params: this.$route.params },
        selected: false
      }));
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, {
        title: 'Transfer',
        goto: { name: this.$route.name, params: this.$route.params },
        selected: true
      }));
    }
  },
  data: function data() {
    return {
      noteId: '',
      userId: '',
      name: '',
      breadcrumbData: [],
      loading: false,
      information: {},
      comment: '',
      investmentAmount: 0,
      isInvestmentAmountInvalid: false,
      minimumInvestmentAmount: null,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        precision: 2
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('question', ['display']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('app', ['investmentsRestrictions'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    commentUpdated: function commentUpdated($event) {
      this.comment = $event;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('note', ['getAdditionalDepositInformation', 'requestAddFunds', 'approveAddFunds', 'cancelNoteAddFunds']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), {
    loadInvestmentsValidations: function loadInvestmentsValidations() {
      this.minimumInvestmentAmount = this.investmentsRestrictions.minimumAmount;
      this.investmentAmountError = 'Please invest at least ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util__["c" /* formatAmount */])(parseInt(this.minimumInvestmentAmount, 10)) + ' in order to proceed';
    },
    getUnformattedValue: function getUnformattedValue(value) {
      var unformattedValue = value.toString().replace('$', '').replace(/,/g, '');
      return this.formatDecimal(unformattedValue);
    },
    removeNegative: function removeNegative() {
      this.investmentAmount = this.investmentAmount.toString().replace('-', '');
    },
    validateInvestmentAmount: function validateInvestmentAmount() {
      var investmentAmountValue = this.getUnformattedValue(this.investmentAmount);
      if (investmentAmountValue < this.minimumInvestmentAmount) {
        this.isInvestmentAmountInvalid = true;
      } else {
        this.isInvestmentAmountInvalid = false;
      }
    },
    setParams: function setParams() {
      this.name = this.$route.params.name;
      this.userId = this.$route.params.userId;
      this.noteId = this.$route.params.noteId;
    },
    loadInformation: function loadInformation() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return _this.getAdditionalDepositInformation(_this.noteId);

              case 4:
                response = _context.sent;

                _this.information = response;
                if (!_this.information.isNewRequest) {
                  _this.comment = _this.information.comment;
                  _this.investmentAmount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util__["q" /* formatDecimal */])(_this.information.amount).toFixed(2);
                }
                _this.loading = false;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](1);

                _this.loading = false;
                if (_context.t0 !== 'UNAUTHORIZED') {
                  _this.setErrorsModalInfo(['We could not retrieve the transfer note details.']);
                  _this.showErrorsModal();
                }

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 10]]);
      }))();
    },
    isCancelButtonDisabled: function isCancelButtonDisabled() {
      if (!this.comment) {
        return true;
      }
      if (this.comment === this.information.comment) {
        return true;
      }
      return false;
    },
    isButtonDisabled: function isButtonDisabled() {
      if (!this.comment) {
        return true;
      }
      if (this.comment === this.information.comment) {
        return true;
      }
      if (!this.investmentAmount) {
        return true;
      }
      return this.isInvestmentAmountInvalid;
    },
    submitRequest: function submitRequest() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var request;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                request = {
                  comment: _this2.comment,
                  amount: _this2.getUnformattedValue(_this2.investmentAmount).toFixed(2)
                };
                _context2.prev = 2;
                _context2.next = 5;
                return _this2.requestAddFunds({
                  noteId: _this2.noteId,
                  request: request
                });

              case 5:
                _this2.loading = false;
                _this2.goToNoteDetail();
                _context2.next = 14;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](2);

                _this2.loading = false;
                _this2.setErrorsModalInfo(['There was an error when submitting a request.']);
                _this2.showErrorsModal();

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 9]]);
      }))();
    },
    submitApproveAddFunds: function submitApproveAddFunds() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var request;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loading = true;
                request = {
                  comment: _this3.comment,
                  amount: _this3.getUnformattedValue(_this3.investmentAmount).toFixed(2)
                };
                _context3.prev = 2;
                _context3.next = 5;
                return _this3.approveAddFunds({
                  noteId: _this3.noteId,
                  request: request
                });

              case 5:
                _this3.loading = false;
                _this3.goToNoteDetail();
                _context3.next = 14;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](2);

                _this3.loading = false;
                _this3.setErrorsModalInfo(['There was an error when approving a request.']);
                _this3.showErrorsModal();

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[2, 9]]);
      }))();
    },
    showCancelConfirmationModal: function showCancelConfirmationModal() {
      var _this4 = this;

      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_11__data_static_constants__["a" /* Constants */].addFunds.modalTitle,
        question: __WEBPACK_IMPORTED_MODULE_11__data_static_constants__["a" /* Constants */].addFunds.modalQuestion,
        method: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            var request;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    request = {
                      comment: _this4.comment
                    };

                    _this4.loading = true;
                    _context4.prev = 2;
                    _context4.next = 5;
                    return _this4.cancelNoteAddFunds({
                      noteId: _this4.noteId,
                      request: request
                    });

                  case 5:
                    _this4.loading = false;
                    _this4.hideQuestionModal();
                    _this4.goToNoteDetail();
                    _context4.next = 16;
                    break;

                  case 10:
                    _context4.prev = 10;
                    _context4.t0 = _context4['catch'](2);

                    _this4.loading = false;
                    _this4.setErrorsModalInfo(['There was an error when canceling a request.']);
                    _this4.showErrorsModal();
                    _this4.hideQuestionModal();

                  case 16:
                  case 'end':
                    return _context4.stop();
                }
              }
            }, _callee4, _this4, [[2, 10]]);
          }));

          return function method() {
            return _ref.apply(this, arguments);
          };
        }(),
        yesButtonText: __WEBPACK_IMPORTED_MODULE_11__data_static_constants__["a" /* Constants */].addFunds.modalYesButtonText,
        hideCancelButton: false
      });
    },
    goToNoteDetail: function goToNoteDetail() {
      this.$router.push({
        name: 'NoteDetail',
        params: {
          name: this.name,
          noteId: this.noteId,
          userId: this.userId
        }
      });
    }
  })
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_formControls_RestrictedTwoInputs__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_formControls_RestrictedTwoInputs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_formControls_RestrictedTwoInputs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'address',
  props: ['parentAddress', 'states', 'canadaStates', 'countries', 'title', 'disabled', 'validateWashington', 'isAdmin', 'selectedUserType', 'isMailing'],
  beforeMount: function beforeMount() {
    this.addressO = this.parentAddress;
  },
  data: function data() {
    return {
      addressO: {
        streetAddress1: '',
        streetAddress2: '',
        city: '',
        state: '',
        zipCode: '',
        country: ''
      }
    };
  },

  components: {
    RestrictedTwoInputs: __WEBPACK_IMPORTED_MODULE_0__components_formControls_RestrictedTwoInputs___default.a
  },
  computed: {
    countryStates: function countryStates() {
      var country = this.countries.find(function (ct) {
        return ct.abbreviation.includes('US');
      });
      if (country && this.addressO.country === country.abbreviation) {
        if (!this.isMailing) {
          return this.states.filter(function (state) {
            return !state.onlyMailingAddress;
          });
        }
        return this.states;
      }
      return this.canadaStates;
    },
    streetAddressLabel: function streetAddressLabel() {
      return 'Street address' + (this.selectedUserType !== 'INSTITUTIONAL_REPRESENTATIVE' ? '*' : '');
    }
  },
  watch: {
    parentAddress: function parentAddress(newAddress) {
      this.addressO = newAddress;
    }
  },
  methods: {
    residentialAddressUpdated: function residentialAddressUpdated($event) {
      this.addressO.streetAddress1 = $event.primary;
      this.addressO.streetAddress2 = $event.secondary;
    },
    getData: function getData() {
      return {
        streetAddress1: this.addressO.streetAddress1,
        streetAddress2: this.addressO.streetAddress2,
        city: this.addressO.city,
        state: this.addressO.state,
        zipCode: this.addressO.zipCode,
        country: this.addressO.country
      };
    },
    isZipCodeInvalid: function isZipCodeInvalid(zipCode) {
      if (!zipCode) {
        return false;
      }
      return !__WEBPACK_IMPORTED_MODULE_1__util__["p" /* zipRegex */].test(zipCode);
    },
    isEmpty: function isEmpty() {
      return this.addressO.streetAddress1.trim() === '' && this.addressO.zipCode.trim() === '' && this.addressO.city.trim() === '' && this.addressO.state.trim() === '' && this.addressO.zipCode.trim() === '';
    },
    validate: function validate() {
      return this.addressO !== null && this.addressO.streetAddress1.trim() !== '' && this.addressO.zipCode.trim() !== '' && this.addressO.city.trim() !== '' && this.addressO.state.trim() !== '' && !this.isZipCodeInvalid(this.addressO.zipCode);
    },
    setAddress: function setAddress(newAddress) {
      this.addressO.streetAddress1 = newAddress.streetAddress1;
      this.addressO.streetAddress2 = newAddress.streetAddress2;
      this.addressO.city = newAddress.city;
      this.addressO.state = newAddress.state;
      this.addressO.zipCode = newAddress.zipCode;
      this.addressO.country = newAddress.country;
    }
  }
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Address__ = __webpack_require__(2023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Address___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Address__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'addresses',
  props: ['residentialAddress', 'mailingAddress', 'firstTitle', 'secondTitle', 'validateWashington', 'isAdmin', 'selectedUserType', 'userHasBeenAllowedPOBox', 'shouldShowAllowPOBoxInput'],
  beforeMount: function beforeMount() {
    this.loadState();
    this.hasBeenAllowedPOBox = this.userHasBeenAllowedPOBox;
    this.showPOBoxInput = this.shouldShowAllowPOBoxInput || false;
  },
  mounted: function mounted() {
    this.$emit('validated', this.validate());
  },
  data: function data() {
    return {
      isMailingAddressDifferent: false,
      hasBeenAllowedPOBox: false,
      showPOBoxInput: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('app', ['geoLocation'])),
  methods: {
    addressAreEqual: function addressAreEqual(adr1, adr2) {
      return adr1.city === adr2.city && adr1.state === adr2.state && adr1.streetAddress1 === adr2.streetAddress1 && adr1.streetAddress2 === adr2.streetAddress2 && adr1.zipCode === adr2.zipCode;
    },
    loadState: function loadState() {
      this.isMailingAddressDifferent = !this.addressAreEqual(this.residentialAddress, this.mailingAddress);
    },
    isResidentialAddressEmptyOrValid: function isResidentialAddressEmptyOrValid() {
      var isResidentialAddressValid = false;
      if (this.$refs.residentialComponent) {
        isResidentialAddressValid = this.$refs.residentialComponent.validate();
      }
      return this.$refs.residentialComponent.isEmpty() || isResidentialAddressValid;
    },
    isMailingAddressEmptyOrValid: function isMailingAddressEmptyOrValid() {
      var isMailingAddressValid = false;
      if (this.$refs.mailingComponent) {
        isMailingAddressValid = this.$refs.mailingComponent.validate();
      }
      return this.$refs.mailingComponent.isEmpty() || isMailingAddressValid;
    },
    areEmpty: function areEmpty() {
      return this.$refs.residentialComponent.isEmpty() && this.$refs.mailingComponent.isEmpty();
    },
    validate: function validate() {
      var isResidentialAddressValid = false;
      var isMailingAddressValid = false;
      if (this.$refs.residentialComponent) {
        isResidentialAddressValid = this.$refs.residentialComponent.validate();
      }
      if (this.$refs.mailingComponent) {
        isMailingAddressValid = this.$refs.mailingComponent.validate();
      }
      return isResidentialAddressValid && isMailingAddressValid;
    },
    getData: function getData() {
      var residentialAddress = this.$refs.residentialComponent.getData();
      var mailingAddress = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, residentialAddress);
      if (this.isMailingAddressDifferent) {
        mailingAddress = this.$refs.mailingComponent.getData();
      }
      return { residentialAddress: residentialAddress, mailingAddress: mailingAddress };
    },
    handleAllowPOBox: function handleAllowPOBox(event) {
      var checked = event.target.checked;

      this.hasBeenAllowedPOBox = checked;
    },
    updateMailingAddress: function updateMailingAddress(event) {
      var checked = event.target.checked;

      this.isMailingAddressDifferent = checked;
      if (!checked) {
        this.mailingAddress.streetAddress1 = this.residentialAddress.streetAddress1 || '';
        this.mailingAddress.streetAddress2 = this.residentialAddress.streetAddress2 || '';
        this.mailingAddress.zipCode = this.residentialAddress.zipCode || '';
        this.mailingAddress.city = this.residentialAddress.city || '';
        this.mailingAddress.state = this.residentialAddress.state || '';
        return;
      }
      this.mailingAddress.streetAddress1 = '';
      this.mailingAddress.streetAddress2 = '';
      this.mailingAddress.zipCode = '';
      this.mailingAddress.city = '';
      this.mailingAddress.state = '';
    },
    setResidencialAddress: function setResidencialAddress(newAddress) {
      if (this.$refs.residentialComponent) {
        this.$refs.residentialComponent.setAddress(newAddress);
      }
    },
    setMailingAddress: function setMailingAddress(newAddress) {
      if (this.$refs.residentialComponent) {
        this.$refs.mailingComponent.setAddress(newAddress);
      }
    }
  },
  components: {
    'address-form': __WEBPACK_IMPORTED_MODULE_3__components_Address___default.a
  }
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_static_logActions__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DocumentTabView_DocumentTabView__ = __webpack_require__(2029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DocumentTabView_DocumentTabView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_DocumentTabView_DocumentTabView__);

//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminAccountDocuments',
  data: function data() {
    return {};
  },

  methods: {
    logDocumentViewed: function logDocumentViewed(key) {
      var logMessage = 'User U' + this.user.id + ' viewed ' + key + ' document';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["m" /* logAction */])({
        user: this.user.id,
        level: 'info',
        action: __WEBPACK_IMPORTED_MODULE_2__data_static_logActions__["a" /* default */].DOCUMENT_VIEW.name,
        message: logMessage
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['user'])),
  components: {
    spinner: __WEBPACK_IMPORTED_MODULE_4__components_widgets_Spinner___default.a,
    DocumentTabView: __WEBPACK_IMPORTED_MODULE_5__components_DocumentTabView_DocumentTabView___default.a
  }
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__(2216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_static_constants__ = __webpack_require__(16);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// Quill keeps a link typed without a scheme (e.g. "www.calvertimpactcapital.org")
// as a relative href, which makes the browser resolve it against the portal
// origin instead of the external site. Default those links to https.
var Link = __WEBPACK_IMPORTED_MODULE_3_vue2_editor__["a" /* Quill */].import('formats/link');
var quillSanitize = Link.sanitize;

Link.sanitize = function sanitize(url) {
  var value = (url || '').trim();
  var hasScheme = /^[a-z][a-z0-9+.-]*:/i.test(value);
  var isInternalReference = value.startsWith('#') || value.startsWith('/');

  if (!value || hasScheme || isInternalReference) {
    return quillSanitize.call(this, value);
  }
  return quillSanitize.call(this, 'https://' + value);
};

__WEBPACK_IMPORTED_MODULE_3_vue2_editor__["a" /* Quill */].register(Link, true);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'adminSettings',
  components: {
    'vue-editor': __WEBPACK_IMPORTED_MODULE_3_vue2_editor__["b" /* VueEditor */],
    question: __WEBPACK_IMPORTED_MODULE_4__components_modals_Question___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default.a
  },
  beforeMount: function beforeMount() {
    this.initializeAnnouncement();
  },
  data: function data() {
    return {
      isSubmitSettingsLoading: false,
      announcementHTML: '',
      customEditorToolbar: __WEBPACK_IMPORTED_MODULE_9__data_static_constants__["a" /* Constants */].richtext.customEditorToolbar
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('app', ['announcement']), {
    announcementHTMLWithSafeLinks: function announcementHTMLWithSafeLinks() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["k" /* normalizeRichTextLinks */])(this.announcementHTML);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('question', ['display'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    initializeAnnouncement: function initializeAnnouncement() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var announcement;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getAnnouncement();

              case 2:
                announcement = _context.sent;


                _this.announcementHTML = announcement.html || '';

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handleSubmitSettings: function handleSubmitSettings() {
      var _this2 = this;

      this.showQuestionModal({
        title: 'Update Announcement',
        question: 'Are you sure about these changes?',
        method: function method() {
          _this2.methodToExecuteInUpdateAnnouncementQuestionModal();
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_9__data_static_constants__["a" /* Constants */].purchaseNote.modalYesButtonText,
        hideCancelButton: false
      });
    },
    methodToExecuteInUpdateAnnouncementQuestionModal: function methodToExecuteInUpdateAnnouncementQuestionModal() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.hideQuestionModal();
                _this3.isSubmitSettingsLoading = true;
                _context2.prev = 2;
                _context2.next = 5;
                return _this3.createAnnouncement({ html: _this3.announcementHTML });

              case 5:
                _context2.next = 7;
                return _this3.initializeAnnouncement();

              case 7:
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](2);

                _this3.setErrorsModalInfo([_context2.t0.message]);
                _this3.showErrorsModal();

              case 13:
                _context2.prev = 13;

                _this3.isSubmitSettingsLoading = false;
                return _context2.finish(13);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[2, 9, 13, 16]]);
      }))();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('user', ['getAnnouncement', 'createAnnouncement']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }))
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(9);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_4__util__["b" /* formatDate */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BasicFinancialInformation',
  mixins: [mix],
  props: ['basicFinancialInformation'],
  data: function data() {
    return {
      minimumAge: 18,
      email: '',
      firstName: '',
      lastName: '',
      primaryPhoneNum: '',
      secondaryPhoneNum: '',
      financialAccount: {}
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.email = _this.basicFinancialInformation.email;
              _this.firstName = _this.basicFinancialInformation.firstName;
              _this.lastName = _this.basicFinancialInformation.lastName;
              _this.primaryPhoneNum = _this.getPhoneDigits(_this.basicFinancialInformation.primaryPhoneNum);
              _this.secondaryPhoneNum = _this.getPhoneDigits(_this.basicFinancialInformation.secondaryPhoneNum);
              _this.financialAccount = _this.basicFinancialInformation.accounts.find(function (account) {
                return account.accountType === _this.accountTypes.ADVISOR.name;
              });

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    this.emailUpdated();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['accountTypes'])),
  watch: {
    email: function email() {
      this.formHasChanged();
    },
    firstName: function firstName() {
      this.formHasChanged();
    },
    lastName: function lastName() {
      this.formHasChanged();
    },
    primaryPhoneNum: function primaryPhoneNum() {
      this.formHasChanged();
    },
    secondaryPhoneNum: function secondaryPhoneNum() {
      this.formHasChanged();
    },

    financialAccount: {
      handler: function handler() {
        this.formHasChanged();
      },

      deep: true
    }
  },
  methods: {
    validate: function validate() {
      var primaryEmailValid = this.validEmail(this.email);
      return primaryEmailValid && this.firstName.trim() !== '' && this.lastName.trim() !== '' && this.primaryPhoneNum.trim() !== '' && this.financialAccount.organizationName.trim() !== '' && this.isValidPrimaryPhoneNumber();
    },
    formHasChanged: function formHasChanged() {
      this.$emit('validated', this.validate());
    },
    emailUpdated: function emailUpdated() {
      var valid = this.validEmail(this.email);
      this.$emit('emailUpdated', { valid: valid });
    },
    validEmail: function validEmail(email) {
      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
      return regex.test(email);
    },
    isValidPrimaryPhoneNumber: function isValidPrimaryPhoneNumber() {
      var regex = /^[0-9]{10}$/; // eslint-disable-line no-useless-escape
      return regex.test(this.getPhoneDigits(this.primaryPhoneNum));
    },
    getPhoneDigits: function getPhoneDigits(phoneNum) {
      return phoneNum ? phoneNum.replace(/[-() ]/g, '') : '';
    },
    getData: function getData() {
      return {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        alternateCompanyName: this.financialAccount.alternateCompanyName,
        organizationName: this.financialAccount.organizationName,
        CRDnumber: this.financialAccount.CRDnumber,
        primaryPhoneNum: this.getPhoneDigits(this.primaryPhoneNum),
        secondaryPhoneNum: this.getPhoneDigits(this.secondaryPhoneNum)
      };
    }
  }
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(9);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_5__util__["b" /* formatDate */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BasicInformation',
  mixins: [mix],
  props: {
    basicInformation: {
      type: Object,
      required: true,
      default: {}
    },
    looseValidation: {
      type: Boolean,
      required: false,
      default: false
    },
    enableMfa: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      minimumAge: 18,
      isBirthFieldInvalid: false,
      dateBirthConfig: {
        format: 'MM/DD/YYYY'
      },
      dateBirthFormat: 'YYYY-MM-DD',
      previousSSN: '',
      email: '',
      secondaryEmail: '',
      firstName: '',
      lastName: '',
      socialSecurityNum: '',
      primaryPhoneNum: '',
      secondaryPhoneNum: '',
      mfaPhonePreference: null,
      dateOfBirth: '',
      userType: '',
      ssnAvailabilityStatus: null,
      emailAvailabilityStatus: null
    };
  },

  watch: {
    basicInformation: function basicInformationUpdated(basicInformation) {
      this.email = basicInformation.email;
      this.secondaryEmail = basicInformation.secondaryEmail;
      this.firstName = basicInformation.firstName;
      this.lastName = basicInformation.lastName;
      if (basicInformation.socialSecurityNum) {
        this.socialSecurityNum = 'xxx-xx-' + basicInformation.socialSecurityNum;
      }
      this.primaryPhoneNum = basicInformation.primaryPhoneNum;
      this.secondaryPhoneNum = basicInformation.secondaryPhoneNum;
      this.mfaPhonePreference = basicInformation.mfaPhonePreference || null;
      this.userType = basicInformation.userType;
      this.dateOfBirth = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(basicInformation.dateOfBirth + ' 12:00:00');
      // Reset availability status when data changes
      this.emailAvailabilityStatus = null;
      this.ssnAvailabilityStatus = null;
      this.emailUpdated();
    }
  },
  computed: {
    emailRequired: function emailRequired() {
      return this.userType === 'INSTITUTIONAL_REPRESENTATIVE' || this.userType === 'READ_ONLY';
    },
    hasPrimaryPhone: function hasPrimaryPhone() {
      return !!this.getPhoneDigits(this.primaryPhoneNum);
    },
    hasSecondaryPhone: function hasSecondaryPhone() {
      return !!this.getPhoneDigits(this.secondaryPhoneNum);
    },
    canSetPreference: function canSetPreference() {
      return this.hasPrimaryPhone || this.hasSecondaryPhone;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('userCreationByAdmin', ['checkAvailability']), {
    validate: function validate() {
      var primaryEmailValid = this.email === null || this.email.trim() === '' || this.validEmail(this.email);
      var secondaryEmailValid = this.secondaryEmail === null || this.secondaryEmail.trim() === '' || this.validEmail(this.secondaryEmail);
      if (this.looseValidation) {
        return primaryEmailValid && secondaryEmailValid && this.firstName.trim() !== '' && this.lastName.trim() !== '' && this.primaryPhoneNum.trim() !== '' && !this.errors.has('primaryPhoneNum') && !this.errors.has('secondaryPhoneNum') && !this.errors.has('ssn') && !this.errors.has('PrimaryEmail');
      }
      return primaryEmailValid && secondaryEmailValid && this.firstName.trim() !== '' && this.lastName.trim() !== '' && this.primaryPhoneNum.trim() !== '' && this.socialSecurityNum.trim() !== '' && !this.isBirthFieldInvalid && !this.errors.has('primaryPhoneNum') && !this.errors.has('secondaryPhoneNum') && !this.errors.has('ssn') && !this.errors.has('PrimaryEmail');
    },
    checkDateBirth: function checkDateBirth(dateOfBirth) {
      if (dateOfBirth === '' || dateOfBirth === null) {
        this.isBirthFieldInvalid = true;
      } else {
        this.isBirthFieldInvalid = false;
      }
    },
    isDateBirthValid: function isDateBirthValid(dateOfBirth) {
      if (dateOfBirth === '') {
        return false;
      }
      if (this.basicInformation.userType !== 'INVESTOR') {
        return true;
      }
      var birthYear = new Date(dateOfBirth).getFullYear();
      var currentYear = new Date().getFullYear();
      return currentYear - birthYear >= this.minimumAge;
    },
    isSsnUpdated: function isSsnUpdated() {
      var ssn = this.getSsnDigits(this.socialSecurityNum);
      return !ssn.includes('x');
    },
    validEmail: function validEmail(email) {
      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
      return regex.test(email);
    },
    getSsnDigits: function getSsnDigits(ssn) {
      if (ssn.includes('x')) {
        return undefined;
      }
      return ssn.replace(/[- ]/g, '');
    },
    getPhoneDigits: function getPhoneDigits(phoneNum) {
      return phoneNum ? phoneNum.replace(/[-() ]/g, '') : '';
    },
    getDateOnlyDOB: function getDateOnlyDOB(date) {
      if (__WEBPACK_IMPORTED_MODULE_3_moment___default.a.isMoment(date)) {
        return date.isValid() ? date.format(this.dateBirthFormat).toString() : null;
      }

      return date === null || date === '' ? null : __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format(this.dateBirthFormat).toString();
    },
    emailUpdated: function emailUpdated() {
      var valid = this.validEmail(this.email);
      // Clear email errors and availability status when user types
      this.$validator.errors.remove('PrimaryEmail');
      this.emailAvailabilityStatus = null; // Reset availability status on input
      this.$emit('emailUpdated', { valid: valid });
    },
    ssnInput: function ssnInput() {
      // Clear SSN errors and availability status when user types
      this.$validator.errors.remove('ssn');
      this.ssnAvailabilityStatus = null;
    },
    onPhoneNumberChange: function onPhoneNumberChange() {
      // Auto-clear preference if the selected phone is removed
      if (this.mfaPhonePreference === 'PRIMARY' && !this.hasPrimaryPhone) {
        this.mfaPhonePreference = null;
      }
      if (this.mfaPhonePreference === 'SECONDARY' && !this.hasSecondaryPhone) {
        this.mfaPhonePreference = null;
      }
    },
    getData: function getData() {
      return {
        email: this.email,
        secondaryEmail: this.secondaryEmail,
        firstName: this.firstName,
        lastName: this.lastName,
        socialSecurityNum: this.getSsnDigits(this.socialSecurityNum),
        primaryPhoneNum: this.getPhoneDigits(this.primaryPhoneNum),
        secondaryPhoneNum: this.getPhoneDigits(this.secondaryPhoneNum),
        mfaPhonePreference: this.mfaPhonePreference,
        dateOfBirth: this.getDateOnlyDOB(this.dateOfBirth),
        userType: this.basicInformation.userType
      };
    },
    checkSsnAvailability: function checkSsnAvailability() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var ssnDigits, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Clear any previous SSN errors first
                _this.$validator.errors.remove('ssn');

                // Don't check if there are validation errors

                if (!(_this.errors.has('ssn') || !_this.socialSecurityNum || _this.socialSecurityNum.trim() === '')) {
                  _context.next = 4;
                  break;
                }

                _this.ssnAvailabilityStatus = null;
                return _context.abrupt('return');

              case 4:

                // Don't check if the SSN is the masked version (contains 'x')
                ssnDigits = _this.getSsnDigits(_this.socialSecurityNum);

                if (!(!ssnDigits || ssnDigits.includes('x'))) {
                  _context.next = 8;
                  break;
                }

                _this.ssnAvailabilityStatus = null;
                return _context.abrupt('return');

              case 8:
                if (!(_this.basicInformation && _this.basicInformation.socialSecurityNum && ssnDigits === _this.basicInformation.socialSecurityNum)) {
                  _context.next = 11;
                  break;
                }

                _this.ssnAvailabilityStatus = null;
                return _context.abrupt('return');

              case 11:

                _this.ssnAvailabilityStatus = 'checking';

                _context.prev = 12;
                _context.next = 15;
                return _this.checkAvailability({ ssn: ssnDigits });

              case 15:
                response = _context.sent;

                _this.ssnAvailabilityStatus = response ? 'available' : 'unavailable';

                // If SSN is not available, add validation error
                if (!response) {
                  _this.$validator.errors.add({
                    field: 'ssn',
                    msg: 'The social security number that was entered is not accepted.',
                    id: 'ssn_error'
                  });
                }
                _context.next = 25;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](12);

                console.error('Error checking SSN availability:', _context.t0);
                _this.ssnAvailabilityStatus = null;

                // Check if this is an SSN-specific error from the API
                if (_context.t0 && _context.t0.message && _context.t0.message.includes('social security number')) {
                  _this.ssnAvailabilityStatus = 'unavailable';
                  _this.$validator.errors.add({
                    field: 'ssn',
                    msg: 'The social security number that was entered is not accepted.',
                    id: 'ssn_error'
                  });
                }

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[12, 20]]);
      }))();
    },
    checkEmailAvailability: function checkEmailAvailability() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Clear any previous email errors first
                _this2.$validator.errors.remove('PrimaryEmail');

                // Don't check if there are validation errors or email is empty

                if (!(_this2.errors.has('PrimaryEmail') || !_this2.email || _this2.email.trim() === '' || !_this2.validEmail(_this2.email))) {
                  _context2.next = 4;
                  break;
                }

                _this2.emailAvailabilityStatus = null;
                return _context2.abrupt('return');

              case 4:
                if (!(_this2.basicInformation && _this2.basicInformation.email && _this2.email.toLowerCase() === _this2.basicInformation.email.toLowerCase())) {
                  _context2.next = 7;
                  break;
                }

                _this2.emailAvailabilityStatus = null;
                return _context2.abrupt('return');

              case 7:

                _this2.emailAvailabilityStatus = 'checking';

                _context2.prev = 8;
                _context2.next = 11;
                return _this2.checkAvailability({ email: _this2.email.toLowerCase() });

              case 11:
                response = _context2.sent;

                _this2.emailAvailabilityStatus = response ? 'available' : 'unavailable';

                // If email is not available, add validation error
                if (!response) {
                  _this2.$validator.errors.add({
                    field: 'PrimaryEmail',
                    msg: 'An account with the given email already exists',
                    id: 'email_error'
                  });
                }
                _context2.next = 21;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](8);

                console.error('Error checking email availability:', _context2.t0);
                _this2.emailAvailabilityStatus = null;

                // Check if this is an email-specific error from the API
                if (_context2.t0 && _context2.t0.message && (_context2.t0.message.includes('email') || _context2.t0.message.includes('Email'))) {
                  _this2.emailAvailabilityStatus = 'unavailable';
                  _this2.$validator.errors.add({
                    field: 'PrimaryEmail',
                    msg: 'An account with the given email already exists',
                    id: 'email_error'
                  });
                }

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[8, 16]]);
      }))();
    }
  })
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Breadcrumb',
  props: {
    breadcrumbsData: {
      type: Array,
      required: true,
      default: []
    }
  },
  methods: {
    onClick: function onClick(item) {
      var goto = this.getGoto(item);
      this.$router.push(goto);
    },
    getClass: function getClass(item) {
      return item && item.selected ? 'active' : '';
    },
    getGoto: function getGoto(item) {
      var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, obj.goto);
    }
  }
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_static_emailErrorsTypes__ = __webpack_require__(131);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'callback',
  created: function created() {
    var _$route$query = this.$route.query,
        email = _$route$query.email,
        success = _$route$query.success,
        resetEmail = _$route$query.resetEmail,
        message = _$route$query.message;

    if (resetEmail) {
      if (success === 'true') {
        this.$router.push({ name: 'Login', query: { resetEmail: resetEmail } });
      } else if (success === 'false') {
        this.$router.push({ name: 'ErrorAuth', query: { resetEmail: resetEmail, email: email, message: message, type: __WEBPACK_IMPORTED_MODULE_0__data_static_emailErrorsTypes__["a" /* default */].RESET_PASSWORD.name } });
      }
    } else {
      this.$router.push({ name: 'Login' });
    }
  }
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContactUsHeader__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContactUsHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ContactUsHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PasswordHint__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PasswordHint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PasswordHint__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChangePassword',
  components: {
    ContactUsHeader: __WEBPACK_IMPORTED_MODULE_2__ContactUsHeader___default.a,
    PasswordHint: __WEBPACK_IMPORTED_MODULE_3__PasswordHint___default.a
  },
  created: function created() {
    var _$route$query = this.$route.query,
        code = _$route$query.code,
        email = _$route$query.email;

    if (!code && !email) {
      this.$router.push({ name: 'ResetPassword' });
    }
  },
  data: function data() {
    return {
      password: '',
      passwordConfirmation: '',
      resetPasswordError: null
    };
  },

  computed: {
    code: function code() {
      return this.$route.query.code;
    },
    email: function email() {
      return this.$route.query.email;
    },
    canSubmit: function canSubmit() {
      return this.password === this.passwordConfirmation && this.isPasswordValid();
    }
  },
  methods: {
    isPasswordValid: function isPasswordValid() {
      return this.password.length >= 8 && /[A-Z]/.test(this.password) && /[a-z]/.test(this.password) && /[0-9]/.test(this.password) && /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(this.password);
    },
    submit: function submit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var email, password, code;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.canSubmit) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', false);

              case 2:
                email = _this.email, password = _this.password, code = _this.code;
                _context.prev = 3;
                _context.next = 6;
                return _this.$cognitoAuth.confirmResetPassword(email, code, password);

              case 6:

                _this.$router.push({ name: 'Login', query: { email: email } });
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](3);

                _this.resetPasswordError = _context.t0.message;

              case 12:
                return _context.abrupt('return', false);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 9]]);
      }))();
    }
  }
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContactUsHeader',
  methods: {
    handleRedirect: function handleRedirect() {
      var urlEndpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = 'https://calvertimpact.org' + urlEndpoint;
      window.location.href = url;
    }
  }
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_money__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_static_events__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(9);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'customRateTerm',
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var rateAndTermGroups, rateAndTermGroup, _selectRateAndTermToD, displayRateAndTerm, isCustomRateAndTerm;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;

              if (_this.isCurrentRateAndTerm) {
                _context.next = 19;
                break;
              }

              rateAndTermGroups = _this.investmentsRestrictions.rateAndTermGroups;
              _context.t0 = rateAndTermGroups[_this.manageRateAndTermGroupsId];

              if (_context.t0) {
                _context.next = 8;
                break;
              }

              _context.next = 7;
              return _this.getInvestmentOptions(_this.manageRateAndTermGroupsId);

            case 7:
              _context.t0 = _context.sent;

            case 8:
              rateAndTermGroup = _context.t0;

              if (!rateAndTermGroup.overrideManageRateAndTermGroupsId) {
                _context.next = 16;
                break;
              }

              _context.t1 = rateAndTermGroups[rateAndTermGroup.overrideManageRateAndTermGroupsId];

              if (_context.t1) {
                _context.next = 15;
                break;
              }

              _context.next = 14;
              return _this.getInvestmentOptions(rateAndTermGroup.overrideManageRateAndTermGroupsId);

            case 14:
              _context.t1 = _context.sent;

            case 15:
              rateAndTermGroup = _context.t1;

            case 16:

              _this.ratesAndTerms = rateAndTermGroup.investmentOptions;
              _context.next = 20;
              break;

            case 19:
              _this.ratesAndTerms = _this.investmentsRestrictions.ratesAndTerms;

            case 20:
              if (!_this.showDefaultValue) {
                _context.next = 25;
                break;
              }

              _this.rateTermSelected = _this.ratesAndTerms[0];
              _this.setRateAndTerm();
              _this.loading = false;
              return _context.abrupt('return');

            case 25:
              _selectRateAndTermToD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util__["D" /* selectRateAndTermToDisplay */])(_this.nt, _this.ratesAndTerms), displayRateAndTerm = _selectRateAndTermToD.selected, isCustomRateAndTerm = _selectRateAndTermToD.isCustom;


              if (!isCustomRateAndTerm) {
                _this.rateTermSelected = displayRateAndTerm;
                _this.setRateAndTerm();
              } else {
                _this.editedRate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util__["E" /* formatBaseAmount */])(displayRateAndTerm.rate);
                _this.editedTerm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util__["E" /* formatBaseAmount */])(displayRateAndTerm.term / 12);
                _this.customRateAndTermCheckbox = true;
              }
              _this.isAValidRate();
              _this.isAValidTerm();
              _this.loading = false;

            case 30:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      customRateAndTermCheckbox: false,
      editedRate: '0.00',
      editedTerm: '1.00',
      isRateValid: true,
      isTermValid: true,
      loading: false,
      mainContainerClass: 'col-md-6 ' + this.mainContainer,
      money: {
        decimal: '.',
        masked: false,
        precision: 2,
        prefix: '',
        suffix: '',
        thousands: ','
      },
      rateErrorMessage: '',
      ratesAndTerms: [],
      rateTermSelected: null,
      termErrorMessage: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['investmentsRestrictions'])),
  props: {
    mainContainer: String,
    predefinedRatesTerms: Array,
    rate: Number,
    rateLimit: Number,
    showDefaultValue: Boolean,
    term: Number,
    manageRateAndTermGroupsId: Number,
    isCurrentRateAndTerm: {
      type: Boolean,
      default: false
    },
    nt: {
      type: Object,
      default: {},
      required: false
    }
  },
  directives: { money: __WEBPACK_IMPORTED_MODULE_4_v_money__["VMoney"] },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getInvestmentOptions: function getInvestmentOptions(manageRateAndTermGroupsId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', _this2.getRateAndTermByGroup({
                  manageRateAndTermGroupsId: manageRateAndTermGroupsId
                }).then(function (data) {
                  return {
                    overrideManageRateAndTermGroupsId: data.overrideManageRateAndTermGroupsId,
                    investmentOptions: data.investmentOptions
                  };
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    setRateAndTerm: function setRateAndTerm() {
      if (!this.rateTermSelected) {
        this.rateTermSelected = this.ratesAndTerms[0];
      }

      var _rateTermSelected = this.rateTermSelected,
          term = _rateTermSelected.term,
          rate = _rateTermSelected.rate;


      this.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].RATE_CHANGED, rate);
      this.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].TERM_CHANGED, term);
      this.$emit(__WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].RATE_AND_TERM_IS_VALID);
    },
    isAValidTerm: function isAValidTerm() {
      if (!this.customRateAndTermCheckbox) {
        this.termErrorMessage = '';
        this.isTermValid = true;
        return true;
      }

      if (this.editedTerm < 0.5 || this.editedTerm % 0.25 !== 0) {
        this.termErrorMessage = 'Years must be a positive number greater than 0.5 in multiples of .25';
        this.isTermValid = false;
        return false;
      }

      this.isTermValid = true;
      return true;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('app', ['getRateAndTermByGroup']), {
    isAValidRate: function isAValidRate() {
      if (!this.customRateAndTermCheckbox) {
        this.rateErrorMessage = '';
        this.isRateValid = true;
        return true;
      }

      if (this.editedRate < 0) {
        this.rateErrorMessage = 'Negative numbers are not allowed';
        this.isRateValid = false;
        return false;
      }

      if (this.editedRate > this.rateLimit) {
        this.rateErrorMessage = 'The maximum allowed rate is ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util__["s" /* formatRate */])(this.rateLimit);
        this.isRateValid = false;
        return false;
      }

      this.isRateValid = true;
      return true;
    },
    emitValidation: function emitValidation() {
      var event = this.isRateValid && this.isTermValid ? __WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].RATE_AND_TERM_IS_VALID : __WEBPACK_IMPORTED_MODULE_5__data_static_events__["a" /* Events */].RATE_AND_TERM_IS_INVALID;

      this.$emit(event);
    },
    emitRateChange: function emitRateChange() {
      if (this.isAValidRate()) {
        this.$emit('rateChanged', Number(this.editedRate));
      }
    },
    emitTermChange: function emitTermChange() {
      if (this.isAValidTerm()) {
        this.$emit('termChanged', Number(this.editedTerm) * 12);
      }
    }
  }),
  watch: {
    customRateAndTermCheckbox: function customRateAndTermCheckbox(newValue) {
      if (!newValue) {
        this.setRateAndTerm();
      } else {
        this.emitRateChange();
        this.emitTermChange();
        this.emitValidation();
      }
    },
    editedRate: function editedRate(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }

      this.emitRateChange();
      this.emitValidation();
    },
    editedTerm: function editedTerm(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }

      this.emitTermChange();
      this.emitValidation();
    }
  }
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TabsComponent_Tabs__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TabsComponent_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_TabsComponent_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TabsComponent_Tab__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TabsComponent_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_TabsComponent_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DocumentView__ = __webpack_require__(2030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DocumentView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DocumentView__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DocumentTabView',
  components: {
    tabs: __WEBPACK_IMPORTED_MODULE_4__components_TabsComponent_Tabs___default.a,
    tab: __WEBPACK_IMPORTED_MODULE_5__components_TabsComponent_Tab___default.a,
    DocumentView: __WEBPACK_IMPORTED_MODULE_7__DocumentView___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['user'])),
  data: function data() {
    return {
      reports: [],
      monthlys: [],
      taxes: [],
      transactionNotices: [],
      isLoading: true
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getAccountDocuments({
                accountId: _this.$route.params.accountId,
                query: { documentType: 'reports' }
              });

            case 2:
              _this.reports = _context.sent;

              _this.isLoading = false;
              _this.getAccountDocuments({
                accountId: _this.$route.params.accountId,
                query: { documentType: 'monthly' }
              }).then(function (monthlys) {
                _this.monthlys = monthlys;
              });
              _this.getAccountDocuments({
                accountId: _this.$route.params.accountId,
                query: { documentType: 'tax' }
              }).then(function (taxes) {
                _this.taxes = taxes;
              });
              _this.getAccountDocuments({
                accountId: _this.$route.params.accountId,
                query: { documentType: 'transaction' }
              }).then(function (transactionNotices) {
                _this.transactionNotices = transactionNotices;
              });

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('account', ['getAccountDocuments']))
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_static_logActions__ = __webpack_require__(57);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DocumentView',
  props: ['documents', 'user'],
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    formatDate: __WEBPACK_IMPORTED_MODULE_5__util__["b" /* formatDate */]
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('account', ['createDocumentView', 'createAccountDocumentPresignedUrl']), {
    logDocumentViewed: function logDocumentViewed(doc) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var Key, LastModified, ETag, Url, logMessage;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Key = doc.Key, LastModified = doc.LastModified, ETag = doc.ETag, Url = doc.Url;
                _context.next = 3;
                return _this.createDocumentView({
                  fileName: Key,
                  lastModified: __WEBPACK_IMPORTED_MODULE_4_moment___default()(LastModified).toDate(),
                  url: Url.split('?')[0],
                  Etag: ETag,
                  userId: _this.user.id,
                  accountId: _this.$route.params.accountId
                });

              case 3:
                logMessage = 'User U' + _this.user.id + ' viewed ' + Key + ' document';

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["m" /* logAction */])({
                  user: _this.user.id,
                  level: 'info',
                  action: __WEBPACK_IMPORTED_MODULE_6__data_static_logActions__["a" /* default */].DOCUMENT_VIEW.name,
                  message: logMessage
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    openDocument: function openDocument(doc) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.createAccountDocumentPresignedUrl({
                  accountId: _this2.$route.params.accountId,
                  payload: {
                    key: doc.OriginalKey
                  }
                });

              case 2:
                res = _context2.sent;

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["l" /* openUrl */])(res.url);
                _context2.next = 6;
                return _this2.logDocumentViewed(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, doc, { Url: res.url }));

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  })
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_static_documentRejectionMessages__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_OnboardingWizard__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_OnboardingWizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_OnboardingWizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(9);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var personalAcceptedFileExtensions = ['png', 'jpg', 'jpeg'];

var businesAcceptedFileExtensions = ['png', 'jpg', 'jpeg', 'pdf'];

var MAX_FILE_SIZE = 10485760;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'documentUpload',
  data: function data() {
    return {
      documentType: 'other',
      isFileInvalid: false,
      uploadFailed: false,
      uploadSucceeded: false,
      selectedFile: null,
      loading: false,
      acceptedFileExtensions: businesAcceptedFileExtensions
    };
  },
  created: function created() {
    var _this = this;

    this.checkIfUserNeedsDocumentation();
    this.getUserProfile().then(function (user) {
      if (user.userType === 'INVESTOR') {
        _this.acceptedFileExtensions = personalAcceptedFileExtensions;
      }
      var status = user.accounts[0].status;

      _this.setAccountStatus(status);
    });
  },
  beforeMount: function beforeMount() {
    this.checkUserStatus();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['activeAccount', 'user']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('documentUpload', ['documentIsUploading', 'needsDocumentation', 'documentationReason']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('home', ['userStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['hasBeenCreatedAccount']), {
    supportedFileExtensions: function supportedFileExtensions() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["K" /* formatFileExtensions */])(this.acceptedFileExtensions);
    },
    documentationInReview: function documentationInReview() {
      return !this.needsDocumentation && this.documentationReason === 'DocumentPending';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('home', ['getUserStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('accountCreation', ['getUserProfile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('documentUpload', ['uploadDocument', 'checkIfUserNeedsDocumentation']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('app', {
    setAccountStatus: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["b" /* SET_ACCOUNT_STATUS */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('documentUpload', {
    setDocumentionNeeds: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["D" /* SET_NEEDS_DOCUMENTATION */],
    setDocumentationReason: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["E" /* SET_DOCUMENTATION_REASON */]
  }), {
    canSubmit: function canSubmit() {
      return !!this.needsDocumentation && !this.documentIsUploading && !!this.documentType && !!this.selectedFile && !this.uploadSucceeded;
    },
    getAcceptedFileExtensions: function getAcceptedFileExtensions() {
      return this.acceptedFileExtensions.map(function (ext) {
        return '.' + ext;
      }).join(',');
    },
    fileChanged: function fileChanged(_ref) {
      var files = _ref.target.files;

      this.isFileInvalid = false;
      if (files.length) {
        var selectedFile = files[0];
        var extension = selectedFile.name.split('.').pop().toLowerCase();
        var size = selectedFile.size;

        if (this.acceptedFileExtensions.indexOf(extension) === -1 || size > MAX_FILE_SIZE) {
          this.isFileInvalid = true;
          this.selectedFile = null;
        } else {
          this.selectedFile = selectedFile;
        }
      }
    },
    resetState: function resetState() {
      this.isFileInvalid = false;
      this.uploadFailed = false;
      this.uploadSucceeded = false;
    },
    handleUpload: function handleUpload() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.resetState();
                _this2.loading = true;
                return _context2.abrupt('return', _this2.uploadDocument({
                  file: _this2.selectedFile,
                  data: {
                    documentType: _this2.documentType
                  }
                }).then(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _this2.loading = false;
                          _this2.uploadSucceeded = true;
                          _context.next = 4;
                          return _this2.checkUserStatus();

                        case 4:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2);
                }))).catch(function () {
                  _this2.loading = false;
                  _this2.uploadFailed = true;
                }));

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getDocumentationReason: function getDocumentationReason() {
      var reason = __WEBPACK_IMPORTED_MODULE_4__data_static_documentRejectionMessages__["a" /* default */][this.documentationReason];
      return reason || __WEBPACK_IMPORTED_MODULE_4__data_static_documentRejectionMessages__["a" /* default */].default;
    },
    checkUserStatus: function checkUserStatus() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loading = true;

                if (_this3.hasBeenCreatedAccount) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt('return', _this3.$router.push({ name: 'AccountSummary' }));

              case 3:
                return _context3.abrupt('return', _this3.getUserStatus({
                  accountId: _this3.activeAccount.id
                }).then(function (_ref3) {
                  var status = _ref3.status,
                      needs = _ref3.needs;

                  if (status === 'suspended') {
                    _this3.$router.push({ name: 'AccountSuspended' });
                  } else if (status === 'document' || status === 'document_migrated_user') {
                    _this3.loading = false;
                  } else if (needs.includes('FUNDING_SOURCE')) {
                    _this3.$router.push({ name: 'AddFundingSource' });
                  } else if (needs.includes('NOTE')) {
                    _this3.$router.push({ name: 'PurchaseNote', query: { first: 1 } });
                  } else if (!needs.length) {
                    _this3.$router.push({ name: 'AccountSummary' });
                  }
                }).catch(function () {
                  _this3.loading = false;
                }));

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }),
  components: {
    spinner: __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default.a,
    'onboarding-wizard': __WEBPACK_IMPORTED_MODULE_7__components_OnboardingWizard___default.a
  }
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_orderBy__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_debounce__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_primevue_multiselect__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_primevue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_primevue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_bootstrap_datetimepicker__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_AddressSuggestion__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_AddressSuggestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_AddressSuggestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_Information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_Information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_modals_Information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_AccountCreation__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_AccountCreation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_modals_AccountCreation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Addresses__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Addresses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Addresses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_widgets_DismissableAlert__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_widgets_DismissableAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_widgets_DismissableAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_BasicFinancialInformation__ = __webpack_require__(2025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_BasicFinancialInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_BasicFinancialInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_UserTypeSelection__ = __webpack_require__(2081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_UserTypeSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_UserTypeSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_AccountsList__ = __webpack_require__(2021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_AccountsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_AccountsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Breadcrumb__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_formControls_RestrictedTextArea__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_formControls_RestrictedTextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_formControls_RestrictedTextArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__data_static_constants__ = __webpack_require__(16);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




























var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_23__util__["b" /* formatDate */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditFinancialAdvisor',
  beforeMount: function beforeMount() {
    this.initializeState();
    this.loadUserDetail();
  },

  watch: {
    suggestedAddressModalYesCall: function suggestedAddressModalYesCall(_ref) {
      var _this = this;

      var payload = _ref.payload,
          suggestedAddress = _ref.suggestedAddress,
          addressType = _ref.addressType;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.$refs.addresses.isMailingAddressDifferent) {
                  _this.user.residentialAddress = suggestedAddress;
                  _this.user.mailingAddress = suggestedAddress;
                  _this.$refs.addresses.setResidencialAddress(suggestedAddress);
                  _this.$refs.addresses.setMailingAddress(suggestedAddress);
                }
                if (['residential', 'organization'].includes(addressType)) {
                  _this.user.residentialAddress = suggestedAddress;
                  _this.$refs.addresses.setResidencialAddress(suggestedAddress);
                } else if (addressType === 'mailing') {
                  _this.user.mailingAddress = suggestedAddress;
                  _this.$refs.addresses.setMailingAddress(suggestedAddress);
                }
                _context.next = 4;
                return _this.save(payload);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    userCommentCategory: function userCommentCategory() {
      if (!this.userCommentCategoriesHasChanged) return;
      this.saveComments();
    },
    provideInvestorLogin: function provideInvestorLogin(_provideInvestorLogin) {
      if (!_provideInvestorLogin) {
        this.enableMfa = false;
      }
    },

    user: function changedUser(newUser) {
      this.breadcrumbData = [];
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
        title: 'Search',
        goto: { name: 'Users' },
        selected: false
      }));
      var title = newUser.firstName.concat(' ', newUser.lastName);
      var goto = { name: this.$route.name, params: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$route.params) };
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
        title: title,
        goto: goto,
        selected: true
      }));
    }
  },
  mixins: [mix],
  data: function data() {
    return {
      userId: '',
      minimumAge: 18,
      breadcrumbData: [],
      user: {},
      isLoading: true,
      showDefaultAccountChanged: false,
      isBasicInformationValid: true,
      creationSucceeded: false,
      isValidAddress: true,
      provideInvestorLogin: false,
      enableMfa: false,
      emailIsValid: false,
      userCommentCategory: [],
      userCommentInput: '',
      savingComment: false,
      commentSaved: false,
      commentSaveError: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('app', ['accountTypes', 'userCommentTypes']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('accountCreation', ['isSuggestedAddressModalVisible', 'isAccountCreationModalVisible', 'changeAddress', 'suggestedAddressModalYesCall']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('information', ['isInformationModalVisible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('question', ['display']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('app', ['userCommentCategories']), {
    userCommentCategoriesHasChanged: function userCommentCategoriesHasChanged() {
      return this.user.commentCategories !== this.userCommentCategory;
    },
    userCommentsHasChanged: function userCommentsHasChanged() {
      return this.user.comments !== this.userCommentInput;
    },
    shouldBeCheckedByDefault: function shouldBeCheckedByDefault() {
      return this.provideInvestorLogin || this.user.clientId !== null;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    setSavingComment: function setSavingComment() {
      this.savingComment = true;
      this.commentSaved = false;
      this.commentSaveError = false;
    },
    setCommentSaved: function setCommentSaved() {
      this.savingComment = false;
      this.commentSaved = true;
      this.commentSaveError = false;
    },
    setCommentSaveError: function setCommentSaveError() {
      this.savingComment = false;
      this.commentSaved = false;
      this.commentSaveError = true;
    },
    saveComments: function saveComments() {
      var _this2 = this;

      this.setSavingComment();

      var payload = {
        comments: this.userCommentInput,
        commentCategories: this.userCommentCategory.map(function (c) {
          return c.id;
        })
      };
      this.addUserComments({ userId: this.user.id, payload: payload }).then(function () {
        _this2.user = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_this2.user, { comments: _this2.userCommentInput });
        _this2.setCommentSaved();
      }).catch(function () {
        _this2.setCommentSaveError();
      });
    },

    debouncedSave: __WEBPACK_IMPORTED_MODULE_6_lodash_debounce___default()(function fn() {
      this.saveComments();
    }, 800),
    commentUpdated: function commentUpdated($event) {
      this.setSavingComment();
      this.userCommentInput = $event;
      if (!this.userCommentsHasChanged) return;

      this.debouncedSave();
    },
    hideDefaultAccountAlert: function hideDefaultAccountAlert() {
      this.showDefaultAccountChanged = false;
    },
    handleEmailChange: function handleEmailChange($event) {
      this.emailIsValid = $event.valid;
      if (!this.emailIsValid) {
        this.provideInvestorLogin = false;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('user', ['updateFinancialAdvisor', 'addUserComments']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('accountCreation', ['setDefaultAccount', 'getUserDetail', 'verifyOrganizationAddress', 'verifyMailingAddress']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('information', {
    showInformationModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["d" /* SHOW_INFORMATION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('accountCreation', {
    setSuggestedAddress: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["o" /* SET_SUGGESTED_ADDRESS */],
    setUserByAdmin: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["y" /* SET_USER_BY_ADMIN */],
    setSuggestedAddressType: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["p" /* SET_SUGGESTED_ADDRESS_TYPE */],
    setSuggestedAddressModalVisible: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["q" /* SET_SUGGESTED_ADDRESS_MODAL_VISIBLE */],
    setSuggestedAddressYesMethod: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["r" /* SET_SUGGESTED_ADDRESS_YES_METHOD */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), {
    initializeState: function initializeState() {
      this.userId = this.$route.params.userId;
      this.name = this.$route.params.name;
    },
    loadUserDetail: function loadUserDetail() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.isLoading = true;
                _context2.next = 3;
                return _this3.getUserDetail(_this3.userId).then(function (data) {
                  _this3.user = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
                    commentCategories: (data.commentCategories || []).map(function (c) {
                      return {
                        id: c.commentCategory.id,
                        name: c.commentCategory.name
                      };
                    })
                  }));
                  _this3.sortAccounts();
                  _this3.userCommentCategory = _this3.user.commentCategories;
                  _this3.userCommentInput = data.comments;
                  _this3.provideInvestorLogin = Boolean(data.clientId);
                  _this3.enableMfa = data.isMfaEnabled;
                  _this3.isLoading = false;
                }).catch(function () {
                  _this3.isLoading = false;
                });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    sortAccounts: function sortAccounts() {
      this.user.accounts = __WEBPACK_IMPORTED_MODULE_5_lodash_orderBy___default()(this.user.accounts, [function (account) {
        var name = account.accountName;
        return name ? account.accountName.toLowerCase() : '';
      }], ['asc']);
    },
    basicInformationValidated: function basicInformationValidated(isValid) {
      this.isBasicInformationValid = isValid;
    },
    addressesValidated: function addressesValidated(isValid) {
      this.isValidAddress = isValid;
    },
    updateAddress: function updateAddress(originalAddress, updatedAddress) {
      /* eslint-disable no-param-reassign */
      originalAddress.streetAddress1 = updatedAddress.streetAddress1;
      originalAddress.streetAddress2 = updatedAddress.streetAddress2;
      originalAddress.zipCode = updatedAddress.zipCode;
      originalAddress.state = updatedAddress.state;
      originalAddress.city = updatedAddress.city;
    },
    createPayload: function createPayload() {
      var basicInformation = this.$refs.basicFinancialInformation.getData();
      var alternateCompanyName = basicInformation.alternateCompanyName,
          CRDnumber = basicInformation.CRDnumber,
          email = basicInformation.email,
          firstName = basicInformation.firstName,
          lastName = basicInformation.lastName,
          organizationName = basicInformation.organizationName,
          primaryPhoneNum = basicInformation.primaryPhoneNum,
          secondaryPhoneNum = basicInformation.secondaryPhoneNum;


      var addressesInformation = this.$refs.addresses.getData();

      var mailingAddress = addressesInformation.mailingAddress,
          residentialAddress = addressesInformation.residentialAddress;


      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        email: email,
        firstName: firstName,
        lastName: lastName,
        mailingAddress: mailingAddress
      }, this.user.userType === 'ADVISOR' ? { organizationAddress: residentialAddress } : { residentialAddress: residentialAddress }, {
        primaryPhoneNum: primaryPhoneNum,
        secondaryPhoneNum: secondaryPhoneNum,
        alternateCompanyName: alternateCompanyName,
        CRDnumber: CRDnumber,
        organizationName: organizationName
      });
    },
    validateAndSubmitUser: function validateAndSubmitUser() {
      var _this4 = this;

      this.isLoading = true;
      this.setUserByAdmin(this.user);
      var payload = this.createPayload();

      this.user.residentialAddress = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.user.residentialAddress, payload.residentialAddress);

      this.user.mailingAddress = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.user.mailingAddress, payload.mailingAddress);

      var account = this.user.accounts.find(function (item) {
        return item.accountType === _this4.accountTypes.ADVISOR.name;
      });

      payload.accountId = account.id;
      payload.userType = this.user.userType;

      return this.showConfirmationModal(payload);
    },
    showUserModalsError: function showUserModalsError(listUserErrors) {
      this.setErrorsModalInfo(listUserErrors);
      this.showErrorsModal();
    },
    disableSubmitButton: function disableSubmitButton() {
      if (this.$refs.addresses) {
        this.isValidAddress = this.$refs.addresses.validate();
      }
      return !this.isBasicInformationValid || !this.isValidAddress || this.isLoading;
    },
    showConfirmationModal: function showConfirmationModal(payload) {
      var _this5 = this;

      this.isLoading = false;
      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_24__data_static_constants__["a" /* Constants */].userDetail.modalTitle,
        question: __WEBPACK_IMPORTED_MODULE_24__data_static_constants__["a" /* Constants */].userDetail.modalQuestion,
        method: function () {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this5.methodToExecuteInQuestionModal(payload);

                  case 2:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, _this5);
          }));

          return function method() {
            return _ref2.apply(this, arguments);
          };
        }(),
        yesButtonText: __WEBPACK_IMPORTED_MODULE_24__data_static_constants__["a" /* Constants */].userDetail.modalYesButtonText,
        hideCancelButton: false
      });
    },
    changedDefaultAccountId: function changedDefaultAccountId(data) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.isLoading = true;
                _context4.prev = 1;
                _context4.next = 4;
                return _this6.setDefaultAccount(data);

              case 4:
                _context4.next = 6;
                return _this6.loadUserDetail();

              case 6:
                _this6.isLoading = false;
                _this6.showDefaultAccountChanged = true;
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](1);

                _this6.isLoading = false;

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[1, 10]]);
      }))();
    },
    save: function save(userData) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var addressData, address, payload;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this7.isLoading = true;
                _context5.prev = 1;
                addressData = _this7.$refs.addresses.getData();

                // Advisors address -> organization

                address = _this7.user.userType === 'ADVISOR' ? { organizationAddress: addressData.residentialAddress } : { residentialAddress: addressData.residentialAddress };
                payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, userData, address, {
                  mailingAddress: addressData.mailingAddress
                });
                _context5.next = 7;
                return _this7.updateFinancialAdvisor({
                  payload: payload,
                  userId: _this7.user.id,
                  provideLogin: _this7.provideInvestorLogin,
                  enableMfa: _this7.enableMfa
                });

              case 7:

                _this7.isLoading = false;

                _context5.next = 10;
                return _this7.loadUserDetail();

              case 10:
                _context5.next = 15;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5['catch'](1);

                _this7.isLoading = false;

              case 15:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[1, 12]]);
      }))();
    },
    methodToExecuteInQuestionModal: function methodToExecuteInQuestionModal(payload) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this8.hideQuestionModal();
                _this8.isLoading = true;
                return _context6.abrupt('return', _this8.save(payload));

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    }
  }),
  components: {
    datePicker: __WEBPACK_IMPORTED_MODULE_9_vue_bootstrap_datetimepicker___default.a,
    errors: __WEBPACK_IMPORTED_MODULE_11__components_modals_Errors___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_13__components_widgets_Spinner___default.a,
    information: __WEBPACK_IMPORTED_MODULE_12__components_modals_Information___default.a,
    accountCreation: __WEBPACK_IMPORTED_MODULE_15__components_modals_AccountCreation___default.a,
    AccountsList: __WEBPACK_IMPORTED_MODULE_20__components_AccountsList___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_21__components_Breadcrumb___default.a,
    question: __WEBPACK_IMPORTED_MODULE_14__components_modals_Question___default.a,
    multiselect: __WEBPACK_IMPORTED_MODULE_8_primevue_multiselect___default.a,
    'address-suggestion': __WEBPACK_IMPORTED_MODULE_10__components_modals_AddressSuggestion___default.a,
    'addresses-form': __WEBPACK_IMPORTED_MODULE_16__components_Addresses___default.a,
    'dismissable-alert': __WEBPACK_IMPORTED_MODULE_17__components_widgets_DismissableAlert___default.a,
    'basicFinancial-information': __WEBPACK_IMPORTED_MODULE_18__components_BasicFinancialInformation___default.a,
    'userTypeSelection-form': __WEBPACK_IMPORTED_MODULE_19__components_UserTypeSelection___default.a,
    'restricted-textarea': __WEBPACK_IMPORTED_MODULE_22__components_formControls_RestrictedTextArea___default.a
  }
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AccountFundingSources__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AccountFundingSources___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_AccountFundingSources__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AccountNotes__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AccountNotes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_AccountNotes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AccountPreferences__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AccountPreferences___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_AccountPreferences__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AccountRepresentatives__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AccountRepresentatives___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_AccountRepresentatives__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_BankAccountChangedWarning__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_BankAccountChangedWarning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_modals_BankAccountChangedWarning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_SuccessAlert__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_SuccessAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_SuccessAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_UpcomingTransactions__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_UpcomingTransactions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_UpcomingTransactions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_AdminAccountDocuments__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_AdminAccountDocuments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_AdminAccountDocuments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_AccountBeneficiaries__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_AccountBeneficiaries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_AccountBeneficiaries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__data_static_userTypes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Breadcrumb__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__data_static_constants__ = __webpack_require__(16);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

























var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_21__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_21__util__["c" /* formatAmount */],
    formatRate: __WEBPACK_IMPORTED_MODULE_21__util__["s" /* formatRate */],
    formatTerm: __WEBPACK_IMPORTED_MODULE_21__util__["o" /* formatTerm */],
    formatType: __WEBPACK_IMPORTED_MODULE_21__util__["d" /* formatType */],
    formatPaymentPreference: __WEBPACK_IMPORTED_MODULE_21__util__["u" /* formatPaymentPreference */],
    findAccount: __WEBPACK_IMPORTED_MODULE_21__util__["v" /* findAccount */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editIndividualAccount',
  beforeDestroy: function beforeDestroy() {
    this.hidePreferencesSuccessMessage();
  },
  beforeMount: function beforeMount() {
    this.setParams();
    this.loadUserDetail();
    this.loadAccountUsers();
  },

  mixins: [mix],
  components: {
    UpcomingTransactions: __WEBPACK_IMPORTED_MODULE_16__components_UpcomingTransactions___default.a,
    AccountFundingSources: __WEBPACK_IMPORTED_MODULE_8__components_AccountFundingSources___default.a,
    AccountNotes: __WEBPACK_IMPORTED_MODULE_9__components_AccountNotes___default.a,
    AccountPreferences: __WEBPACK_IMPORTED_MODULE_10__components_AccountPreferences___default.a,
    AccountRepresentatives: __WEBPACK_IMPORTED_MODULE_11__components_AccountRepresentatives___default.a,
    errors: __WEBPACK_IMPORTED_MODULE_12__components_modals_Errors___default.a,
    question: __WEBPACK_IMPORTED_MODULE_13__components_modals_Question___default.a,
    BankAccountChangedWarning: __WEBPACK_IMPORTED_MODULE_14__components_modals_BankAccountChangedWarning___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_22__components_widgets_Spinner___default.a,
    SuccessAlert: __WEBPACK_IMPORTED_MODULE_15__components_SuccessAlert___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_23__components_Breadcrumb___default.a,
    AdminAccountDocuments: __WEBPACK_IMPORTED_MODULE_17__components_AdminAccountDocuments___default.a,
    AccountBeneficiaries: __WEBPACK_IMPORTED_MODULE_18__components_AccountBeneficiaries___default.a
  },
  watch: {
    user: function changedUser(newUser) {
      this.setBreadcrumbData(this.account, newUser);
    },
    account: function changedAccount(newAccount) {
      this.setBreadcrumbData(newAccount, this.user);
    }
  },
  data: function data() {
    return {
      accountId: '',
      account: {},
      breadcrumbData: [],
      accountUsersLoading: false,
      currentAmountBalance: 0,
      fundingSources: [],
      isBankAccountChangedWarningVisible: false,
      isFundingSourcesSegmentLoading: false,
      isNotesSegmentLoading: false,
      isPreferencesSuccessMessageVisible: false,
      isUnlinkRepresentativesLoading: false,
      isUpcomingTransactionsSegmentLoading: false,
      maxAmountFundingSources: 6,
      name: '',
      noteLoading: false,
      notes: [],
      notesError: '',
      preferencesSpinner: false,
      preferencesSuccessMessage: '',
      previousFundingSourceId: '',
      previousPaymentPreference: '',
      shouldUpcomingTransactionsWithActionsBeDisplayed: false,
      shouldUpcomingTransactionsWithNoActionsBeDisplayed: false,
      user: [],
      userAccount: { defaultFundingSourceId: '' },
      userDetailLoading: false,
      userId: '',
      accountRepresentatives: [],
      beneficiaries: [],
      beneficiariesSpinner: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('home', ['userStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('question', ['display']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('checkWireModal', ['isCheckWireModalVisible', 'creationSucceeded']), {
    accountName: function accountName() {
      return this.account.accountName;
    },
    accountType: function accountType() {
      return this.account.accountType;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('account', ['getAccount', 'getAccountUsers', 'getAccountNotes', 'getAccountFundingSources', 'updateAccountPaymentPreference', 'setDefaultFundingSource', 'getAccountBeneficiaries']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('accountCreation', ['getUserDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_20__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_20__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_20__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_20__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('checkWireModal', {
    showCheckWireModal: __WEBPACK_IMPORTED_MODULE_20__store_mutation_types__["t" /* SHOW_CHECK_WIRE_MODAL */],
    setCreationStatus: __WEBPACK_IMPORTED_MODULE_20__store_mutation_types__["u" /* SET_CREATION_SUCCEEDED */]
  }), {
    setBreadcrumbData: function setBreadcrumbData(account, user) {
      this.breadcrumbData = [];
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
        title: 'Search',
        goto: { name: 'Users' },
        selected: false
      }));
      var params = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.$route.params);
      var goto = void 0;
      if (user.userType === __WEBPACK_IMPORTED_MODULE_19__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name) {
        goto = { name: 'EditFinancialAdvisor', params: { name: params.name, userId: params.userId } };
      } else {
        goto = { name: 'UserDetail', params: { name: params.name, userId: params.userId } };
      }
      var title = user.firstName.concat(' ', user.lastName);
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
        title: title,
        goto: goto,
        selected: false
      }));
      var gotoAccount = { name: this.$route.name, params: params };
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
        title: account.accountName,
        goto: gotoAccount,
        selected: true
      }));
    },
    displayImpactPreferenceSuccessfulNotification: function displayImpactPreferenceSuccessfulNotification() {
      this.preferencesSuccessMessage = __WEBPACK_IMPORTED_MODULE_24__data_static_constants__["a" /* Constants */].adminPreferences.successMessage;
      this.isPreferencesSuccessMessageVisible = true;
      this.preferencesSpinner = false;
      this.goToSegment('preferences-segment');
    },
    displayUpcomingTransactionsWithActionAlert: function displayUpcomingTransactionsWithActionAlert() {
      this.shouldUpcomingTransactionsWithActionsBeDisplayed = true;
      this.shouldUpcomingTransactionsWithNoActionsBeDisplayed = false;
    },
    displayUpcomingTransactionsWithNoActionAlert: function displayUpcomingTransactionsWithNoActionAlert() {
      this.shouldUpcomingTransactionsWithActionsBeDisplayed = false;
      this.shouldUpcomingTransactionsWithNoActionsBeDisplayed = true;
    },
    goToSegment: function goToSegment(segment) {
      document.getElementById(segment).scrollIntoView();
    },
    hideUpcomingTransactionsAlerts: function hideUpcomingTransactionsAlerts() {
      this.shouldUpcomingTransactionsWithActionsBeDisplayed = false;
      this.shouldUpcomingTransactionsWithNoActionsBeDisplayed = false;
    },
    setFundingSourceSpinnerOff: function setFundingSourceSpinnerOff() {
      this.isFundingSourcesSegmentLoading = false;
    },
    setFundingSourceSpinnerOn: function setFundingSourceSpinnerOn() {
      this.isFundingSourcesSegmentLoading = true;
    },
    setNotesSpinnerOff: function setNotesSpinnerOff() {
      this.isNotesSegmentLoading = false;
    },
    setNotesSpinnerOn: function setNotesSpinnerOn() {
      this.isNotesSegmentLoading = true;
    },
    setRepresentativesSpinnerOn: function setRepresentativesSpinnerOn() {
      this.isUnlinkRepresentativesLoading = true;
    },
    setRepresentativesSpinnerOff: function setRepresentativesSpinnerOff() {
      this.isUnlinkRepresentativesLoading = false;
    },
    setParams: function setParams() {
      this.userId = this.$route.params.userId;
      this.accountId = this.$route.params.accountId;
      this.name = this.$route.params.name;
    },
    setPreferencesSpinnerOff: function setPreferencesSpinnerOff() {
      this.preferencesSpinner = false;
    },
    setPreferencesSpinnerOn: function setPreferencesSpinnerOn() {
      this.preferencesSpinner = true;
    },
    setUpcomingTransactionsSpinnerOff: function setUpcomingTransactionsSpinnerOff() {
      this.isUpcomingTransactionsSegmentLoading = false;
    },
    setUpcomingTransactionsSpinnerOn: function setUpcomingTransactionsSpinnerOn() {
      this.isUpcomingTransactionsSegmentLoading = true;
    },
    hidePreferencesSuccessMessage: function hidePreferencesSuccessMessage() {
      this.isPreferencesSuccessMessageVisible = false;
    },
    loadUserDetail: function loadUserDetail() {
      var _this = this;

      this.userDetailLoading = true;
      return this.getUserDetail(this.userId).then(function (user) {
        _this.userDetailLoading = false;
        _this.user = user;
        _this.userAccount = _this.findAccount(user.accounts, _this.accountId);
        _this.previousFundingSourceId = _this.userAccount.defaultFundingSourceId;
      }).catch(function (err) {
        _this.userDetailLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this.setErrorsModalInfo(['We could not retrieve user detail']);
          _this.showErrorsModal();
        }
      });
    },
    loadAccountUsers: function loadAccountUsers() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, _ref2, account, accountRepresentatives, beneficiaries;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.accountUsersLoading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this2.getAccount(_this2.accountId), _this2.getAccountUsers(_this2.accountId), _this2.getAccountBeneficiaries(_this2.accountId)]);

              case 4:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 3);
                account = _ref2[0];
                accountRepresentatives = _ref2[1];
                beneficiaries = _ref2[2];

                _this2.accountRepresentatives = accountRepresentatives;
                _this2.account = account;
                _this2.beneficiaries = beneficiaries;
                _this2.previousPaymentPreference = _this2.account.paymentPreference;
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({}));

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](0);

                if (!(_context.t0 !== 'UNAUTHORIZED')) {
                  _context.next = 22;
                  break;
                }

                _this2.setErrorsModalInfo(['We could not retrieve users list']);
                _this2.showErrorsModal();
                return _context.abrupt('return', _context.t0);

              case 22:
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(_context.t0));

              case 23:
                _context.prev = 23;

                _this2.accountUsersLoading = false;
                return _context.finish(23);

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 16, 23, 26]]);
      }))();
    },
    loadNotesList: function loadNotesList() {
      var _this3 = this;

      this.noteLoading = true;
      return this.getAccountNotes(this.accountId).then(function (notes) {
        _this3.noteLoading = false;
        _this3.notes = notes;
        var openNotes = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(notes, { status: 'open' });
        _this3.currentAmountBalance = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.sumBy(['currentBalance'], __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.partial(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.sumBy, openNotes));
      }).catch(function (err) {
        _this3.noteLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this3.setErrorsModalInfo(['We could not retrieve notes list']);
          _this3.showErrorsModal();
        }
      });
    },
    loadFundingSourceAfterModalSave: function loadFundingSourceAfterModalSave() {
      if (this.creationSucceeded) {
        this.loadUserDetail();
        this.loadFundingSources();
        this.setCreationStatus(false);
      }
    },
    loadAccountInformation: function loadAccountInformation() {
      this.loadUserDetail();
      this.loadAccountUsers();
    },
    loadFundingSources: function loadFundingSources() {
      var _this4 = this;

      this.fundingLoading = true;
      return this.getAccountFundingSources(this.accountId).then(function (data) {
        _this4.fundingLoading = false;
        _this4.fundingSources = data.filter(function (fss) {
          return !fss.removed && (fss.type === 'bank' || fss.type === 'check' || fss.type === 'wire/ach');
        });
      }).catch(function (err) {
        _this4.fundingLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this4.setErrorsModalInfo(['We could not retrieve bank accounts list']);
          _this4.showErrorsModal();
        }
      });
    },
    getAccountType: function getAccountType() {
      if (this.userAccount && this.userAccount.accountType) {
        var accountType = this.userAccount.accountType;
        return '' + accountType[0] + accountType.slice(1).toLowerCase();
      }
      return '';
    },
    showDefaultFundingSourceConfirmationModal: function showDefaultFundingSourceConfirmationModal(_ref3) {
      var _this5 = this;

      var fundingSource = _ref3.fundingSource;

      this.userAccount.defaultFundingSourceId = this.previousFundingSourceId;
      this.showQuestionModal({
        title: 'Bank account',
        question: 'Are you sure you want to select ' + fundingSource.name + ' as new default bank account?',
        method: function method() {
          _this5.methodToExecuteInDefaultFundingSourceQuestionModal(fundingSource.id);
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_24__data_static_constants__["a" /* Constants */].purchaseNote.modalYesButtonText,
        hideCancelButton: false
      });
    },
    showConfirmationModal: function showConfirmationModal(paymentPreference) {
      var _this6 = this;

      this.account.paymentPreference = this.previousPaymentPreference;
      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_24__data_static_constants__["a" /* Constants */].accountDetail.modalTitle,
        question: 'Are you sure you want to select ' + this.formatPaymentPreference(paymentPreference) + ' as your new default payment action?',
        method: function method() {
          _this6.methodToExecuteInQuestionModal(paymentPreference);
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_24__data_static_constants__["a" /* Constants */].accountDetail.modalYesButtonText,
        hideCancelButton: false
      });
    },
    methodToExecuteInDefaultFundingSourceQuestionModal: function methodToExecuteInDefaultFundingSourceQuestionModal(fundingSourceId) {
      var _this7 = this;

      this.hideQuestionModal();
      var account = this.userAccount;
      this.setDefaultFundingSource({
        accountId: account.id,
        fundingSourceId: fundingSourceId
      }).then(function () {
        _this7.previousFundingSourceId = fundingSourceId;
        _this7.userAccount.defaultFundingSourceId = fundingSourceId;
      });
    },
    methodToExecuteInQuestionModal: function methodToExecuteInQuestionModal(paymentPreference) {
      var _this8 = this;

      this.hideQuestionModal();
      this.updateAccountPaymentPreference({
        accountId: this.accountId,
        paymentPreference: paymentPreference
      }).then(function () {
        _this8.previousPaymentPreference = paymentPreference;
        _this8.account.paymentPreference = paymentPreference;
      });
    },
    openCheckWireModal: function openCheckWireModal() {
      var filteredFundingSources = this.fundingSources.filter(function (fss) {
        return fss.type === 'check' || fss.type === 'wire-transfer';
      });
      this.showCheckWireModal({ accountId: this.accountId,
        fundingSources: filteredFundingSources });
    },
    goToPurchaseInvestmentNote: function goToPurchaseInvestmentNote() {
      var accountId = this.accountId;
      var userId = this.userId;
      var name = this.name;
      this.$router.push({ name: 'PurchaseInvestmentNote', params: { accountId: accountId, userId: userId, name: name } });
    },
    goToViewDetail: function goToViewDetail(note) {
      var userId = this.userId;
      var name = this.name;

      var noteObj = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, note);
      var routeParams = { name: 'NoteDetail', params: { name: name, userId: userId, noteId: noteObj.id } };
      this.$router.push(routeParams);
    },
    setBeneficiariesSpinnerOn: function setBeneficiariesSpinnerOn() {
      this.beneficiariesSpinner = true;
    },
    setBeneficiariesSpinnerOff: function setBeneficiariesSpinnerOff() {
      this.beneficiariesSpinner = false;
    },
    handleDefaultFundingSourceUpdated: function handleDefaultFundingSourceUpdated() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this9.loadUserDetail(), _this9.loadAccountUsers()]);

              case 2:
                _context2.next = 4;
                return _this9.$nextTick();

              case 4:
                if (!_this9.$refs.upcomingTransactions) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 7;
                return _this9.$refs.upcomingTransactions.initializeState();

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this9);
      }))();
    },
    showBankAccountChangedWarning: function showBankAccountChangedWarning() {
      this.isBankAccountChangedWarningVisible = true;
    },
    hideBankAccountChangedWarning: function hideBankAccountChangedWarning() {
      this.isBankAccountChangedWarningVisible = false;
    },
    handleGoToUpcomingTransactions: function handleGoToUpcomingTransactions() {
      this.goToSegment('upcoming-transactions-segment');
    }
  })
});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AccountEmails__ = __webpack_require__(2019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AccountEmails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_AccountEmails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AccountFundingSources__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AccountFundingSources___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_AccountFundingSources__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AccountNotes__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AccountNotes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_AccountNotes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AccountPreferences__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AccountPreferences___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_AccountPreferences__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AccountRepresentatives__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AccountRepresentatives___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_AccountRepresentatives__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_BankAccountChangedWarning__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_BankAccountChangedWarning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_modals_BankAccountChangedWarning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_SuccessAlert__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_SuccessAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_SuccessAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_UpcomingTransactions__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_UpcomingTransactions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_UpcomingTransactions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Addresses__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Addresses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Addresses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_modals_AddressSuggestion__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_modals_AddressSuggestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_modals_AddressSuggestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Breadcrumb__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_AdminAccountDocuments__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_AdminAccountDocuments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_AdminAccountDocuments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__data_static_userTypes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_formControls_RestrictedSingleInput__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_formControls_RestrictedSingleInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_formControls_RestrictedSingleInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__data_static_constants__ = __webpack_require__(16);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




























var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_25__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_25__util__["c" /* formatAmount */],
    formatRate: __WEBPACK_IMPORTED_MODULE_25__util__["s" /* formatRate */],
    formatTerm: __WEBPACK_IMPORTED_MODULE_25__util__["o" /* formatTerm */],
    formatType: __WEBPACK_IMPORTED_MODULE_25__util__["d" /* formatType */],
    formatPaymentPreference: __WEBPACK_IMPORTED_MODULE_25__util__["u" /* formatPaymentPreference */],
    findAccount: __WEBPACK_IMPORTED_MODULE_25__util__["v" /* findAccount */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editInstitutionAccount',
  beforeDestroy: function beforeDestroy() {
    this.hidePreferencesSuccessMessage();
  },
  beforeMount: function beforeMount() {
    this.setParams();
    this.loadUserDetail();
    this.loadAccountUsers();
  },

  mixins: [mix],
  components: {
    AccountEmails: __WEBPACK_IMPORTED_MODULE_8__components_AccountEmails___default.a,
    AccountFundingSources: __WEBPACK_IMPORTED_MODULE_9__components_AccountFundingSources___default.a,
    AccountNotes: __WEBPACK_IMPORTED_MODULE_10__components_AccountNotes___default.a,
    AccountPreferences: __WEBPACK_IMPORTED_MODULE_11__components_AccountPreferences___default.a,
    AccountRepresentatives: __WEBPACK_IMPORTED_MODULE_12__components_AccountRepresentatives___default.a,
    Addresses: __WEBPACK_IMPORTED_MODULE_18__components_Addresses___default.a,
    AddressSuggestion: __WEBPACK_IMPORTED_MODULE_19__components_modals_AddressSuggestion___default.a,
    errors: __WEBPACK_IMPORTED_MODULE_13__components_modals_Errors___default.a,
    question: __WEBPACK_IMPORTED_MODULE_14__components_modals_Question___default.a,
    BankAccountChangedWarning: __WEBPACK_IMPORTED_MODULE_15__components_modals_BankAccountChangedWarning___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_26__components_widgets_Spinner___default.a,
    SuccessAlert: __WEBPACK_IMPORTED_MODULE_16__components_SuccessAlert___default.a,
    UpcomingTransactions: __WEBPACK_IMPORTED_MODULE_17__components_UpcomingTransactions___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_20__components_Breadcrumb___default.a,
    AdminAccountDocuments: __WEBPACK_IMPORTED_MODULE_21__components_AdminAccountDocuments___default.a,
    RestrictedSingleInput: __WEBPACK_IMPORTED_MODULE_23__components_formControls_RestrictedSingleInput___default.a
  },
  watch: {
    suggestedAddressModalYesCall: function suggestedAddressModalYesCall(_ref) {
      var _this = this;

      var payload = _ref.payload,
          suggestedAddress = _ref.suggestedAddress,
          addressType = _ref.addressType;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.$refs.addresses.isMailingAddressDifferent) {
                  _this.organization.mainAddress = suggestedAddress;
                  _this.organization.mailingAddress = suggestedAddress;
                  _this.$refs.addresses.setResidencialAddress(suggestedAddress);
                  _this.$refs.addresses.setMailingAddress(suggestedAddress);
                }
                if (['organization'].includes(addressType)) {
                  _this.organization.mainAddress = suggestedAddress;
                  _this.$refs.addresses.setResidencialAddress(suggestedAddress);
                } else if (addressType === 'mailing') {
                  _this.organization.mailingAddress = suggestedAddress;
                  _this.$refs.addresses.setMailingAddress(suggestedAddress);
                }
                _context.next = 4;
                return _this.save(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, payload, {
                  mailingAddress: _this.organization.mailingAddress,
                  mainAddress: _this.organization.mainAddress
                }));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    user: function changedUser(newUser) {
      this.setBreadcrumbData(this.account, newUser);
    },
    account: function changedAccount(newAccount) {
      this.setBreadcrumbData(newAccount, this.user);
    }
  },
  data: function data() {
    return {
      accountId: '',
      account: {},
      accountUsersLoading: false,
      breadcrumbData: [],
      currentAmountBalance: 0,
      fundingSources: [],
      isAdditionalEmailsLoading: false,
      isBankAccountChangedWarningVisible: false,
      isFundingSourcesSegmentLoading: false,
      isNotesSegmentLoading: false,
      isPreferencesSuccessMessageVisible: false,
      isUpcomingTransactionsSegmentLoading: false,
      isRepresentativesLoading: false,
      maxAmountFundingSources: 6,
      name: '',
      noteLoading: false,
      notes: [],
      notesError: '',
      organization: {
        name: ''
      },
      preferencesSpinner: false,
      preferencesSuccessMessage: '',
      previousFundingSourceId: '',
      previousPaymentPreference: '',
      shouldUpcomingTransactionsWithActionsBeDisplayed: false,
      shouldUpcomingTransactionsWithNoActionsBeDisplayed: false,
      user: [],
      userAccount: { defaultFundingSourceId: '' },
      userDetailLoading: false,
      userId: '',
      accountRepresentatives: [],
      accountEmails: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('accountCreation', ['isSuggestedAddressModalVisible', 'suggestedAddressModalYesCall']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('app', ['institutionTypes']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('home', ['userStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('question', ['display']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('checkWireModal', ['isCheckWireModalVisible', 'creationSucceeded']), {
    accountName: function accountName() {
      return this.account.accountName;
    },
    accountType: function accountType() {
      return this.account.accountType;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('account', ['getAccount', 'getAccountUsers', 'getAccountEmails', 'getAccountOrganizations', 'getAccountNotes', 'getAccountFundingSources', 'updateAccountPaymentPreference', 'setDefaultFundingSource', 'editInstitutionAccountInformation']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('accountCreation', ['getUserDetail', 'verifyOrganizationAddress', 'verifyMailingAddress']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('accountCreation', {
    setSuggestedAddress: __WEBPACK_IMPORTED_MODULE_24__store_mutation_types__["o" /* SET_SUGGESTED_ADDRESS */],
    setSuggestedAddressType: __WEBPACK_IMPORTED_MODULE_24__store_mutation_types__["p" /* SET_SUGGESTED_ADDRESS_TYPE */],
    setSuggestedAddressModalVisible: __WEBPACK_IMPORTED_MODULE_24__store_mutation_types__["q" /* SET_SUGGESTED_ADDRESS_MODAL_VISIBLE */],
    setSuggestedAddressYesMethod: __WEBPACK_IMPORTED_MODULE_24__store_mutation_types__["r" /* SET_SUGGESTED_ADDRESS_YES_METHOD */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_24__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_24__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_24__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_24__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('checkWireModal', {
    showCheckWireModal: __WEBPACK_IMPORTED_MODULE_24__store_mutation_types__["t" /* SHOW_CHECK_WIRE_MODAL */],
    setCreationStatus: __WEBPACK_IMPORTED_MODULE_24__store_mutation_types__["u" /* SET_CREATION_SUCCEEDED */]
  }), {
    setBreadcrumbData: function setBreadcrumbData(account, user) {
      this.breadcrumbData = [];
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
        title: 'Search',
        goto: { name: 'Users' },
        selected: false
      }));
      var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.$route.params);
      var goto = void 0;
      if (user.userType === __WEBPACK_IMPORTED_MODULE_22__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name) {
        goto = { name: 'EditFinancialAdvisor', params: { name: params.name, userId: params.userId } };
      } else {
        goto = { name: 'UserDetail', params: { name: params.name, userId: params.userId } };
      }
      var title = user.fullName;
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
        title: title,
        goto: goto,
        selected: false
      }));

      var gotoAccount = { name: this.$route.name, params: params };
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
        title: account.accountName,
        goto: gotoAccount,
        selected: true
      }));
    },
    showUpdateAccountConfirmationModal: function showUpdateAccountConfirmationModal() {
      var _this2 = this;

      this.accountUsersLoading = false;
      this.showQuestionModal({
        title: 'Update Institution Account Information',
        question: 'Are you sure about these changes?',
        method: function method() {
          _this2.methodToExecuteInUpdateAccountQuestionModal();
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_27__data_static_constants__["a" /* Constants */].purchaseNote.modalYesButtonText,
        hideCancelButton: false
      });
    },
    save: function save(payload) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.hideQuestionModal();
                _this3.accountUsersLoading = true;
                _context2.prev = 2;
                _context2.next = 5;
                return _this3.editInstitutionAccountInformation({
                  params: {
                    accountId: _this3.accountId,
                    organizationId: _this3.organization.id
                  },
                  payload: payload
                });

              case 5:
                _this3.loadAccountInformation();
                _this3.accountUsersLoading = false;
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](2);

                _this3.accountUsersLoading = false;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[2, 9]]);
      }))();
    },
    methodToExecuteInUpdateAccountQuestionModal: function methodToExecuteInUpdateAccountQuestionModal() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.hideQuestionModal();
                _context3.next = 3;
                return _this4.save({
                  name: _this4.organization.name,
                  type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__util__["H" /* camelToSnakeCase */])(_this4.organization.type).toUpperCase(),
                  phoneNumber: _this4.removeFormattingCharacters(_this4.organization.phoneNumber),
                  taxId: _this4.removeFormattingCharacters(_this4.organization.taxId),
                  mailingAddress: _this4.organization.mailingAddress,
                  mainAddress: _this4.organization.mainAddress
                });

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    displayImpactPreferenceSuccessfulNotification: function displayImpactPreferenceSuccessfulNotification() {
      this.preferencesSuccessMessage = __WEBPACK_IMPORTED_MODULE_27__data_static_constants__["a" /* Constants */].adminPreferences.successMessage;
      this.isPreferencesSuccessMessageVisible = true;
      this.preferencesSpinner = false;
      this.goToSegment('preferences-segment');
    },
    displayUpcomingTransactionsWithActionAlert: function displayUpcomingTransactionsWithActionAlert() {
      this.shouldUpcomingTransactionsWithActionsBeDisplayed = true;
      this.shouldUpcomingTransactionsWithNoActionsBeDisplayed = false;
    },
    displayUpcomingTransactionsWithNoActionAlert: function displayUpcomingTransactionsWithNoActionAlert() {
      this.shouldUpcomingTransactionsWithActionsBeDisplayed = false;
      this.shouldUpcomingTransactionsWithNoActionsBeDisplayed = true;
    },
    goToSegment: function goToSegment(segment) {
      document.getElementById(segment).scrollIntoView();
    },
    hideUpcomingTransactionsAlerts: function hideUpcomingTransactionsAlerts() {
      this.shouldUpcomingTransactionsWithActionsBeDisplayed = false;
      this.shouldUpcomingTransactionsWithNoActionsBeDisplayed = false;
    },
    setAdditionalEmailSpinnerOff: function setAdditionalEmailSpinnerOff() {
      this.isAdditionalEmailsLoading = false;
      this.loadAccountUsers();
    },
    setAdditionalEmailSpinnerOn: function setAdditionalEmailSpinnerOn() {
      this.isAdditionalEmailsLoading = true;
    },
    setFundingSourceSpinnerOff: function setFundingSourceSpinnerOff() {
      this.isFundingSourcesSegmentLoading = false;
    },
    setFundingSourceSpinnerOn: function setFundingSourceSpinnerOn() {
      this.isFundingSourcesSegmentLoading = true;
    },
    setNotesSpinnerOff: function setNotesSpinnerOff() {
      this.isNotesSegmentLoading = false;
    },
    setNotesSpinnerOn: function setNotesSpinnerOn() {
      this.isNotesSegmentLoading = true;
    },
    setParams: function setParams() {
      this.userId = this.$route.params.userId;
      this.accountId = this.$route.params.accountId;
      this.name = this.$route.params.name;
    },
    setPreferencesSpinnerOff: function setPreferencesSpinnerOff() {
      this.preferencesSpinner = false;
    },
    setPreferencesSpinnerOn: function setPreferencesSpinnerOn() {
      this.preferencesSpinner = true;
    },
    setUpcomingTransactionsSpinnerOff: function setUpcomingTransactionsSpinnerOff() {
      this.isUpcomingTransactionsSegmentLoading = false;
    },
    setUpcomingTransactionsSpinnerOn: function setUpcomingTransactionsSpinnerOn() {
      this.isUpcomingTransactionsSegmentLoading = true;
    },
    setRepresentativesSpinnerOn: function setRepresentativesSpinnerOn() {
      this.isRepresentativesLoading = true;
    },
    setRepresentativesSpinnerOff: function setRepresentativesSpinnerOff() {
      this.isRepresentativesLoading = false;
    },
    hidePreferencesSuccessMessage: function hidePreferencesSuccessMessage() {
      this.isPreferencesSuccessMessageVisible = false;
    },
    loadAccountInformation: function loadAccountInformation() {
      this.loadUserDetail();
      this.loadAccountUsers();
    },
    loadUserDetail: function loadUserDetail() {
      var _this5 = this;

      this.userDetailLoading = true;
      return this.getUserDetail(this.userId).then(function (user) {
        _this5.userDetailLoading = false;
        _this5.user = user;
        _this5.userAccount = _this5.findAccount(user.accounts, _this5.accountId);
        _this5.previousFundingSourceId = _this5.userAccount.defaultFundingSourceId;
      }).catch(function (err) {
        _this5.userDetailLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this5.setErrorsModalInfo(['We could not retrieve user detail']);
          _this5.showErrorsModal();
        }
      });
    },
    removeFormattingCharacters: function removeFormattingCharacters(text) {
      return text.replace(/[-_() ]/g, '');
    },
    validateAndSubmitAccount: function validateAndSubmitAccount() {
      this.accountUsersLoading = true;
      if (!this.$refs.addresses.isMailingAddressDifferent) {
        this.organization.mailingAddress = this.organization.mainAddress;
      }
      this.showUpdateAccountConfirmationModal();
    },
    showUserModalsError: function showUserModalsError(listUserErrors) {
      this.setErrorsModalInfo(listUserErrors);
      this.showErrorsModal();
    },
    shouldSubmitButtonBeDisabled: function shouldSubmitButtonBeDisabled() {
      if (!this.organization.id) {
        return true;
      }

      var areBothAddressesValid = this.areMainAndMailingAddressValid();
      var isPhoneNumberValid = this.isPhoneNumberValid();
      var isTaxIdValid = this.isTaxIdValid();

      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__util__["F" /* isStringValid */])(this.organization.name) || !isTaxIdValid || !isPhoneNumberValid || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__util__["F" /* isStringValid */])(this.organization.type) || !areBothAddressesValid;
    },
    areMainAndMailingAddressValid: function areMainAndMailingAddressValid() {
      var areBothAddressesValid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__util__["G" /* isAddressValid */])(this.organization.mainAddress);

      if (this.$refs.addresses && this.$refs.addresses.isMailingAddressDifferent) {
        areBothAddressesValid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__util__["G" /* isAddressValid */])(this.organization.mailingAddress);
      }

      return areBothAddressesValid;
    },
    isTaxIdValid: function isTaxIdValid() {
      var isTaxIdValid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__util__["F" /* isStringValid */])(this.organization.taxId);

      if (isTaxIdValid) {
        isTaxIdValid = this.removeFormattingCharacters(this.organization.taxId).length === 9;
      }

      return isTaxIdValid;
    },
    isPhoneNumberValid: function isPhoneNumberValid() {
      var isPhoneNumberValid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__util__["F" /* isStringValid */])(this.organization.phoneNumber);

      if (isPhoneNumberValid) {
        isPhoneNumberValid = this.removeFormattingCharacters(this.organization.phoneNumber).length === 10;
      }

      return isPhoneNumberValid;
    },
    truncateAddressIfNecessary: function truncateAddressIfNecessary(address) {
      var localAddress = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, address);
      var hasStreetAddress1 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress1');
      var hasStreetAddress2 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress2');
      if (hasStreetAddress1 && hasStreetAddress2) {
        var totalAdressLength = address.streetAddress1.length + address.streetAddress2.length;
        if (totalAdressLength > 50) {
          var charsToCut = totalAdressLength - 50;
          localAddress.streetAddress2 = address.streetAddress2.slice(0, -charsToCut);
          return localAddress;
        }
      }
      return address;
    },
    loadAccountUsers: function loadAccountUsers() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _ref2, _ref3, account, accountOrganizations, accountRepresentatives, accountEmails;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this6.getAccount(_this6.accountId), _this6.getAccountOrganizations(_this6.accountId), _this6.getAccountUsers(_this6.accountId), _this6.getAccountEmails(_this6.accountId)]);

              case 3:
                _ref2 = _context4.sent;
                _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref2, 4);
                account = _ref3[0];
                accountOrganizations = _ref3[1];
                accountRepresentatives = _ref3[2];
                accountEmails = _ref3[3];

                _this6.account = account;
                _this6.accountEmails = accountEmails;
                _this6.accountRepresentatives = accountRepresentatives;
                _this6.organization = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, accountOrganizations[0]);
                _this6.previousPaymentPreference = _this6.account.paymentPreference;
                return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve());

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4['catch'](0);

                if (!(_context4.t0 !== 'UNAUTHORIZED')) {
                  _context4.next = 23;
                  break;
                }

                _this6.setErrorsModalInfo(['We could not retrieve users list']);
                _this6.showErrorsModal();
                return _context4.abrupt('return', _context4.t0);

              case 23:
                return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject());

              case 24:
                _context4.prev = 24;

                _this6.accountUsersLoading = false;
                return _context4.finish(24);

              case 27:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 17, 24, 27]]);
      }))();
    },
    loadNotesList: function loadNotesList() {
      var _this7 = this;

      this.noteLoading = true;
      return this.getAccountNotes(this.accountId).then(function (notes) {
        _this7.noteLoading = false;
        _this7.notes = notes;
        var openNotes = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(notes, { status: 'open' });
        _this7.currentAmountBalance = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.sumBy(['currentBalance'], __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.partial(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.sumBy, openNotes));
      }).catch(function (err) {
        _this7.noteLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this7.setErrorsModalInfo(['We could not retrieve notes list']);
          _this7.showErrorsModal();
        }
      });
    },
    loadFundingSourceAfterModalSave: function loadFundingSourceAfterModalSave() {
      if (this.creationSucceeded) {
        this.loadUserDetail();
        this.loadFundingSources();
        this.setCreationStatus(false);
      }
    },
    loadFundingSources: function loadFundingSources() {
      var _this8 = this;

      this.fundingLoading = true;
      return this.getAccountFundingSources(this.accountId).then(function (data) {
        _this8.fundingLoading = false;
        _this8.fundingSources = data.filter(function (fss) {
          return !fss.removed && (fss.type === 'bank' || fss.type === 'check' || fss.type === 'wire/ach');
        });
      }).catch(function (err) {
        _this8.fundingLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this8.setErrorsModalInfo(['We could not retrieve bank accounts list']);
          _this8.showErrorsModal();
        }
      });
    },
    getAccountType: function getAccountType() {
      if (this.userAccount && this.userAccount.accountType) {
        var accountType = this.userAccount.accountType;
        return '' + accountType[0] + accountType.slice(1).toLowerCase();
      }
      return '';
    },
    showDefaultFundingSourceConfirmationModal: function showDefaultFundingSourceConfirmationModal(_ref4) {
      var _this9 = this;

      var fundingSource = _ref4.fundingSource;

      this.userAccount.defaultFundingSourceId = this.previousFundingSourceId;
      this.showQuestionModal({
        title: 'Bank account',
        question: 'Are you sure you want to select ' + fundingSource.name + ' as new default bank account?',
        method: function method() {
          _this9.methodToExecuteInDefaultFundingSourceQuestionModal(fundingSource.id);
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_27__data_static_constants__["a" /* Constants */].purchaseNote.modalYesButtonText,
        hideCancelButton: false
      });
    },
    showConfirmationModal: function showConfirmationModal(paymentPreference) {
      var _this10 = this;

      this.account.paymentPreference = this.previousPaymentPreference;
      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_27__data_static_constants__["a" /* Constants */].accountDetail.modalTitle,
        question: 'Are you sure you want to select ' + this.formatPaymentPreference(paymentPreference) + ' as your new default payment action?',
        method: function method() {
          _this10.methodToExecuteInQuestionModal(paymentPreference);
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_27__data_static_constants__["a" /* Constants */].accountDetail.modalYesButtonText,
        hideCancelButton: false
      });
    },
    methodToExecuteInDefaultFundingSourceQuestionModal: function methodToExecuteInDefaultFundingSourceQuestionModal(fundingSourceId) {
      var _this11 = this;

      this.hideQuestionModal();
      var account = this.userAccount;
      this.setDefaultFundingSource({
        accountId: account.id,
        fundingSourceId: fundingSourceId
      }).then(function () {
        _this11.previousFundingSourceId = fundingSourceId;
        _this11.userAccount.defaultFundingSourceId = fundingSourceId;
      });
    },
    methodToExecuteInQuestionModal: function methodToExecuteInQuestionModal(paymentPreference) {
      var _this12 = this;

      this.hideQuestionModal();
      this.updateAccountPaymentPreference({
        accountId: this.accountId,
        paymentPreference: paymentPreference
      }).then(function () {
        _this12.previousPaymentPreference = paymentPreference;
        _this12.account.paymentPreference = paymentPreference;
      });
    },
    openCheckWireModal: function openCheckWireModal() {
      var filteredFundingSources = this.fundingSources.filter(function (fss) {
        return fss.type === 'check' || fss.type === 'wire-transfer';
      });
      this.showCheckWireModal({ accountId: this.accountId,
        fundingSources: filteredFundingSources });
    },
    goToPurchaseInvestmentNote: function goToPurchaseInvestmentNote() {
      var accountId = this.accountId;
      var userId = this.userId;
      var name = this.name;
      this.$router.push({ name: 'PurchaseInvestmentNote', params: { accountId: accountId, userId: userId, name: name } });
    },
    goToViewDetail: function goToViewDetail(note) {
      var userId = this.userId;
      var name = this.name;
      this.$router.push({ name: 'NoteDetail', params: { name: name, userId: userId, noteId: note.id } });
    },
    goBack: function goBack() {
      this.$router.push({ name: 'Users', params: { name: this.name } });
    },
    onInstitutionNameUpdate: function onInstitutionNameUpdate(value) {
      if (value) {
        this.organization.name = value.trim();
      }
    },
    handleDefaultFundingSourceUpdated: function handleDefaultFundingSourceUpdated() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this13.loadUserDetail(), _this13.loadAccountUsers()]);

              case 2:
                _context5.next = 4;
                return _this13.$nextTick();

              case 4:
                if (!_this13.$refs.upcomingTransactions) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 7;
                return _this13.$refs.upcomingTransactions.initializeState();

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this13);
      }))();
    },
    showBankAccountChangedWarning: function showBankAccountChangedWarning() {
      this.isBankAccountChangedWarningVisible = true;
    },
    hideBankAccountChangedWarning: function hideBankAccountChangedWarning() {
      this.isBankAccountChangedWarningVisible = false;
    },
    handleGoToUpcomingTransactions: function handleGoToUpcomingTransactions() {
      this.goToSegment('upcoming-transactions-segment');
    }
  })
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AccountFundingSources__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AccountFundingSources___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_AccountFundingSources__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AccountNotes__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AccountNotes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_AccountNotes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AccountPreferences__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AccountPreferences___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_AccountPreferences__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AccountRepresentatives__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AccountRepresentatives___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_AccountRepresentatives__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AccountBeneficiaries__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AccountBeneficiaries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_AccountBeneficiaries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_BankAccountChangedWarning__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_BankAccountChangedWarning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_modals_BankAccountChangedWarning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_SuccessAlert__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_SuccessAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_SuccessAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_UpcomingTransactions__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_UpcomingTransactions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_UpcomingTransactions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Breadcrumb__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_AdminAccountDocuments__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_AdminAccountDocuments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_AdminAccountDocuments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_formControls_RestrictedSingleInput__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_formControls_RestrictedSingleInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_formControls_RestrictedSingleInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__data_static_userTypes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__data_static_constants__ = __webpack_require__(16);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


























var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_22__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_22__util__["c" /* formatAmount */],
    formatRate: __WEBPACK_IMPORTED_MODULE_22__util__["s" /* formatRate */],
    formatTerm: __WEBPACK_IMPORTED_MODULE_22__util__["o" /* formatTerm */],
    formatType: __WEBPACK_IMPORTED_MODULE_22__util__["d" /* formatType */],
    formatPaymentPreference: __WEBPACK_IMPORTED_MODULE_22__util__["u" /* formatPaymentPreference */],
    findAccount: __WEBPACK_IMPORTED_MODULE_22__util__["v" /* findAccount */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editJointAccount',
  beforeDestroy: function beforeDestroy() {
    this.hidePreferencesSuccessMessage();
  },
  beforeMount: function beforeMount() {
    this.setParams();
    this.loadUserDetail();
    this.loadAccountUsers();
  },

  mixins: [mix],
  components: {
    UpcomingTransactions: __WEBPACK_IMPORTED_MODULE_17__components_UpcomingTransactions___default.a,
    AccountFundingSources: __WEBPACK_IMPORTED_MODULE_8__components_AccountFundingSources___default.a,
    AccountNotes: __WEBPACK_IMPORTED_MODULE_9__components_AccountNotes___default.a,
    AccountPreferences: __WEBPACK_IMPORTED_MODULE_10__components_AccountPreferences___default.a,
    AccountRepresentatives: __WEBPACK_IMPORTED_MODULE_11__components_AccountRepresentatives___default.a,
    AccountBeneficiaries: __WEBPACK_IMPORTED_MODULE_12__components_AccountBeneficiaries___default.a,
    errors: __WEBPACK_IMPORTED_MODULE_13__components_modals_Errors___default.a,
    question: __WEBPACK_IMPORTED_MODULE_14__components_modals_Question___default.a,
    BankAccountChangedWarning: __WEBPACK_IMPORTED_MODULE_15__components_modals_BankAccountChangedWarning___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_24__components_widgets_Spinner___default.a,
    SuccessAlert: __WEBPACK_IMPORTED_MODULE_16__components_SuccessAlert___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_18__components_Breadcrumb___default.a,
    AdminAccountDocuments: __WEBPACK_IMPORTED_MODULE_19__components_AdminAccountDocuments___default.a,
    RestrictedSingleInput: __WEBPACK_IMPORTED_MODULE_20__components_formControls_RestrictedSingleInput___default.a
  },
  watch: {
    user: function changedUser(newUser) {
      this.setBreadcrumbData(this.account, newUser);
    },
    account: function changedAccount(newAccount) {
      this.setBreadcrumbData(newAccount, this.user);
    }
  },
  data: function data() {
    return {
      accountId: '',
      accountType: 'Joint',
      account: {},
      accountUsersLoading: false,
      breadcrumbData: [],
      currentAmountBalance: 0,
      fundingSources: [],
      isBankAccountChangedWarningVisible: false,
      isFundingSourcesSegmentLoading: false,
      isNotesSegmentLoading: false,
      isPreferencesSuccessMessageVisible: false,
      isUpcomingTransactionsSegmentLoading: false,
      isRepresentativesLoading: false,
      maxAmountFundingSources: 6,
      name: '',
      newAccountName: '',
      noteLoading: false,
      notes: [],
      notesError: '',
      preferencesSpinner: false,
      preferencesSuccessMessage: '',
      previousFundingSourceId: '',
      previousPaymentPreference: '',
      shouldUpcomingTransactionsWithActionsBeDisplayed: false,
      shouldUpcomingTransactionsWithNoActionsBeDisplayed: false,
      user: [],
      userAccount: { defaultFundingSourceId: '' },
      userDetailLoading: false,
      userId: '',
      accountRepresentatives: [],
      beneficiaries: [],
      beneficiariesSpinner: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('home', ['userStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('app', ['accountTypes']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('question', ['display']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('checkWireModal', ['isCheckWireModalVisible', 'creationSucceeded']), {
    accountName: function accountName() {
      return this.account.accountName;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('account', ['getAccount', 'getAccountUsers', 'getAccountNotes', 'getAccountFundingSources', 'updateAccountPaymentPreference', 'updateAccountName', 'setDefaultFundingSource', 'getAccountBeneficiaries']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('accountCreation', ['getUserDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_21__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_21__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_21__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_21__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('checkWireModal', {
    showCheckWireModal: __WEBPACK_IMPORTED_MODULE_21__store_mutation_types__["t" /* SHOW_CHECK_WIRE_MODAL */],
    setCreationStatus: __WEBPACK_IMPORTED_MODULE_21__store_mutation_types__["u" /* SET_CREATION_SUCCEEDED */]
  }), {
    setBreadcrumbData: function setBreadcrumbData(account, user) {
      this.breadcrumbData = [];
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
        title: 'Search',
        goto: { name: 'Users' },
        selected: false
      }));
      var params = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.$route.params);
      var goto = void 0;
      if (user.userType === __WEBPACK_IMPORTED_MODULE_23__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name) {
        goto = { name: 'EditFinancialAdvisor', params: { name: params.name, userId: params.userId } };
      } else {
        goto = { name: 'UserDetail', params: { name: params.name, userId: params.userId } };
      }

      var title = user.fullName;
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
        title: title,
        goto: goto,
        selected: false
      }));
      var gotoAccount = { name: this.$route.name, params: params };
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
        title: account.accountName,
        goto: gotoAccount,
        selected: true
      }));
    },
    displayImpactPreferenceSuccessfulNotification: function displayImpactPreferenceSuccessfulNotification() {
      this.preferencesSuccessMessage = __WEBPACK_IMPORTED_MODULE_25__data_static_constants__["a" /* Constants */].adminPreferences.successMessage;
      this.isPreferencesSuccessMessageVisible = true;
      this.preferencesSpinner = false;
      this.goToSegment('preferences-segment');
    },
    displayUpcomingTransactionsWithActionAlert: function displayUpcomingTransactionsWithActionAlert() {
      this.shouldUpcomingTransactionsWithActionsBeDisplayed = true;
      this.shouldUpcomingTransactionsWithNoActionsBeDisplayed = false;
    },
    displayUpcomingTransactionsWithNoActionAlert: function displayUpcomingTransactionsWithNoActionAlert() {
      this.shouldUpcomingTransactionsWithActionsBeDisplayed = false;
      this.shouldUpcomingTransactionsWithNoActionsBeDisplayed = true;
    },
    goToSegment: function goToSegment(segment) {
      document.getElementById(segment).scrollIntoView();
    },
    hideUpcomingTransactionsAlerts: function hideUpcomingTransactionsAlerts() {
      this.shouldUpcomingTransactionsWithActionsBeDisplayed = false;
      this.shouldUpcomingTransactionsWithNoActionsBeDisplayed = false;
    },
    setFundingSourceSpinnerOff: function setFundingSourceSpinnerOff() {
      this.isFundingSourcesSegmentLoading = false;
    },
    setFundingSourceSpinnerOn: function setFundingSourceSpinnerOn() {
      this.isFundingSourcesSegmentLoading = true;
    },
    setNotesSpinnerOff: function setNotesSpinnerOff() {
      this.isNotesSegmentLoading = false;
    },
    setNotesSpinnerOn: function setNotesSpinnerOn() {
      this.isNotesSegmentLoading = true;
    },
    setParams: function setParams() {
      this.userId = this.$route.params.userId;
      this.accountId = this.$route.params.accountId;
      this.name = this.$route.params.name;
    },
    setPreferencesSpinnerOff: function setPreferencesSpinnerOff() {
      this.preferencesSpinner = false;
    },
    setPreferencesSpinnerOn: function setPreferencesSpinnerOn() {
      this.preferencesSpinner = true;
    },
    setUpcomingTransactionsSpinnerOff: function setUpcomingTransactionsSpinnerOff() {
      this.isUpcomingTransactionsSegmentLoading = false;
    },
    setUpcomingTransactionsSpinnerOn: function setUpcomingTransactionsSpinnerOn() {
      this.isUpcomingTransactionsSegmentLoading = true;
    },
    setRepresentativesSpinnerOn: function setRepresentativesSpinnerOn() {
      this.isRepresentativesLoading = true;
    },
    setRepresentativesSpinnerOff: function setRepresentativesSpinnerOff() {
      this.isRepresentativesLoading = false;
    },
    setBeneficiariesSpinnerOn: function setBeneficiariesSpinnerOn() {
      this.beneficiariesSpinner = true;
    },
    setBeneficiariesSpinnerOff: function setBeneficiariesSpinnerOff() {
      this.beneficiariesSpinner = false;
    },
    loadAccountInformation: function loadAccountInformation() {
      this.loadUserDetail();
      this.loadAccountUsers();
    },
    disableSubmitButton: function disableSubmitButton() {
      return this.newAccountName.length === 0;
    },
    hidePreferencesSuccessMessage: function hidePreferencesSuccessMessage() {
      this.isPreferencesSuccessMessageVisible = false;
    },
    loadUserDetail: function loadUserDetail() {
      var _this = this;

      this.userDetailLoading = true;
      return this.getUserDetail(this.userId).then(function (user) {
        _this.userDetailLoading = false;
        _this.user = user;
        _this.userAccount = _this.findAccount(user.accounts, _this.accountId);

        if (_this.userAccount.accountType === _this.accountTypes.UTMA_UGMA_ACCOUNT.name) {
          _this.accountType = 'UTMA/UGMA';
        }
        _this.newAccountName = _this.userAccount.accountName;
        _this.previousFundingSourceId = _this.userAccount.defaultFundingSourceId;
      }).catch(function (err) {
        _this.userDetailLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this.setErrorsModalInfo(['We could not retrieve user detail']);
          _this.showErrorsModal();
        }
      });
    },
    loadAccountUsers: function loadAccountUsers() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, _ref2, account, accountRepresentatives, beneficiaries;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.accountUsersLoading = true;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this2.getAccount(_this2.accountId), _this2.getAccountUsers(_this2.accountId), _this2.getAccountBeneficiaries(_this2.accountId)]);

              case 4:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 3);
                account = _ref2[0];
                accountRepresentatives = _ref2[1];
                beneficiaries = _ref2[2];

                _this2.accountRepresentatives = accountRepresentatives;
                _this2.account = account;
                _this2.beneficiaries = beneficiaries;
                _this2.previousPaymentPreference = _this2.account.paymentPreference;
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({}));

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](0);

                if (!(_context.t0 !== 'UNAUTHORIZED')) {
                  _context.next = 22;
                  break;
                }

                _this2.setErrorsModalInfo(['We could not retrieve users list']);
                _this2.showErrorsModal();
                return _context.abrupt('return', _context.t0);

              case 22:
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(_context.t0));

              case 23:
                _context.prev = 23;

                _this2.accountUsersLoading = false;
                return _context.finish(23);

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 16, 23, 26]]);
      }))();
    },
    loadNotesList: function loadNotesList() {
      var _this3 = this;

      this.noteLoading = true;
      return this.getAccountNotes(this.accountId).then(function (notes) {
        _this3.noteLoading = false;
        _this3.notes = notes;
        var openNotes = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(notes, { status: 'open' });
        _this3.currentAmountBalance = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.sumBy(['currentBalance'], __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.partial(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.sumBy, openNotes));
      }).catch(function (err) {
        _this3.noteLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this3.setErrorsModalInfo(['We could not retrieve notes list']);
          _this3.showErrorsModal();
        }
      });
    },
    loadFundingSourceAfterModalSave: function loadFundingSourceAfterModalSave() {
      if (this.creationSucceeded) {
        this.loadUserDetail();
        this.loadFundingSources();
        this.setCreationStatus(false);
      }
    },
    loadFundingSources: function loadFundingSources() {
      var _this4 = this;

      this.fundingLoading = true;
      return this.getAccountFundingSources(this.accountId).then(function (data) {
        _this4.fundingLoading = false;
        _this4.fundingSources = data.filter(function (fss) {
          return !fss.removed && (fss.type === 'bank' || fss.type === 'check' || fss.type === 'wire/ach');
        });
      }).catch(function (err) {
        _this4.fundingLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this4.setErrorsModalInfo(['We could not retrieve bank accounts list']);
          _this4.showErrorsModal();
        }
      });
    },
    getAccountType: function getAccountType() {
      if (this.userAccount && this.userAccount.accountType) {
        var accountType = this.userAccount.accountType;
        return '' + accountType[0] + accountType.slice(1).toLowerCase();
      }
      return '';
    },
    showUpdateAccountConfirmationModal: function showUpdateAccountConfirmationModal() {
      var _this5 = this;

      this.showQuestionModal({
        title: 'Update Account Name',
        question: 'Are you sure about these changes?',
        method: function method() {
          _this5.methodToExecuteInUpdateAccountQuestionModal();
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_25__data_static_constants__["a" /* Constants */].purchaseNote.modalYesButtonText,
        hideCancelButton: false
      });
    },
    methodToExecuteInUpdateAccountQuestionModal: function methodToExecuteInUpdateAccountQuestionModal() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this6.hideQuestionModal();
                _this6.accountUsersLoading = true;
                _context2.next = 4;
                return _this6.updateAccountName({
                  accountId: _this6.accountId,
                  name: _this6.newAccountName
                });

              case 4:
                _this6.loadAccountInformation();
                _this6.accountUsersLoading = false;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    openCheckWireModal: function openCheckWireModal() {
      var filteredFundingSources = this.fundingSources.filter(function (fss) {
        return fss.type === 'check' || fss.type === 'wire-transfer';
      });
      this.showCheckWireModal({ accountId: this.accountId,
        fundingSources: filteredFundingSources });
    },
    goToPurchaseInvestmentNote: function goToPurchaseInvestmentNote() {
      var accountId = this.accountId;
      var userId = this.userId;
      var name = this.name;
      this.$router.push({ name: 'PurchaseInvestmentNote', params: { accountId: accountId, userId: userId, name: name } });
    },
    goToViewDetail: function goToViewDetail(note) {
      var userId = this.userId;
      var noteId = note.id;
      var name = this.name;

      var routeParams = { name: 'NoteDetail', params: { name: name, userId: userId, noteId: noteId } };
      this.$router.push(routeParams);
    },
    onNewAccountNameUpdate: function onNewAccountNameUpdate(value) {
      this.newAccountName = value.trim();
    },
    handleDefaultFundingSourceUpdated: function handleDefaultFundingSourceUpdated() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this7.loadUserDetail(), _this7.loadAccountUsers()]);

              case 2:
                _context3.next = 4;
                return _this7.$nextTick();

              case 4:
                if (!_this7.$refs.upcomingTransactions) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 7;
                return _this7.$refs.upcomingTransactions.initializeState();

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },
    showBankAccountChangedWarning: function showBankAccountChangedWarning() {
      this.isBankAccountChangedWarningVisible = true;
    },
    hideBankAccountChangedWarning: function hideBankAccountChangedWarning() {
      this.isBankAccountChangedWarningVisible = false;
    },
    handleGoToUpcomingTransactions: function handleGoToUpcomingTransactions() {
      this.goToSegment('upcoming-transactions-segment');
    }
  })
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AccountFundingSources__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AccountFundingSources___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_AccountFundingSources__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AccountNotes__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AccountNotes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_AccountNotes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AccountPreferences__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AccountPreferences___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_AccountPreferences__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AccountRepresentatives__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AccountRepresentatives___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_AccountRepresentatives__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AccountBeneficiaries__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AccountBeneficiaries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_AccountBeneficiaries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_BankAccountChangedWarning__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_BankAccountChangedWarning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_modals_BankAccountChangedWarning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_SuccessAlert__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_SuccessAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_SuccessAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Addresses__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Addresses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Addresses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_modals_AddressSuggestion__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_modals_AddressSuggestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_modals_AddressSuggestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__data_static_addressErrors__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_UpcomingTransactions__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_UpcomingTransactions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_UpcomingTransactions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Breadcrumb__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_AdminAccountDocuments__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_AdminAccountDocuments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_AdminAccountDocuments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__data_static_userTypes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__data_static_trustTypes__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_formControls_RestrictedSingleInput__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_formControls_RestrictedSingleInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_formControls_RestrictedSingleInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__config_config__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__data_static_constants__ = __webpack_require__(16);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
































var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_27__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_27__util__["c" /* formatAmount */],
    formatRate: __WEBPACK_IMPORTED_MODULE_27__util__["s" /* formatRate */],
    formatTerm: __WEBPACK_IMPORTED_MODULE_27__util__["o" /* formatTerm */],
    formatType: __WEBPACK_IMPORTED_MODULE_27__util__["d" /* formatType */],
    formatPaymentPreference: __WEBPACK_IMPORTED_MODULE_27__util__["u" /* formatPaymentPreference */],
    findAccount: __WEBPACK_IMPORTED_MODULE_27__util__["v" /* findAccount */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editTrustAccount',
  beforeDestroy: function beforeDestroy() {
    this.hidePreferencesSuccessMessage();
  },
  beforeMount: function beforeMount() {
    this.setParams();
    this.loadUserDetail();
    this.loadAccountUsers();
  },

  mixins: [mix],
  components: {
    AccountFundingSources: __WEBPACK_IMPORTED_MODULE_8__components_AccountFundingSources___default.a,
    AccountNotes: __WEBPACK_IMPORTED_MODULE_9__components_AccountNotes___default.a,
    AccountPreferences: __WEBPACK_IMPORTED_MODULE_10__components_AccountPreferences___default.a,
    AccountRepresentatives: __WEBPACK_IMPORTED_MODULE_11__components_AccountRepresentatives___default.a,
    AccountBeneficiaries: __WEBPACK_IMPORTED_MODULE_12__components_AccountBeneficiaries___default.a,
    Addresses: __WEBPACK_IMPORTED_MODULE_17__components_Addresses___default.a,
    AddressSuggestion: __WEBPACK_IMPORTED_MODULE_18__components_modals_AddressSuggestion___default.a,
    errors: __WEBPACK_IMPORTED_MODULE_13__components_modals_Errors___default.a,
    question: __WEBPACK_IMPORTED_MODULE_14__components_modals_Question___default.a,
    BankAccountChangedWarning: __WEBPACK_IMPORTED_MODULE_15__components_modals_BankAccountChangedWarning___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_28__components_widgets_Spinner___default.a,
    SuccessAlert: __WEBPACK_IMPORTED_MODULE_16__components_SuccessAlert___default.a,
    UpcomingTransactions: __WEBPACK_IMPORTED_MODULE_20__components_UpcomingTransactions___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_21__components_Breadcrumb___default.a,
    AdminAccountDocuments: __WEBPACK_IMPORTED_MODULE_22__components_AdminAccountDocuments___default.a,
    RestrictedSingleInput: __WEBPACK_IMPORTED_MODULE_25__components_formControls_RestrictedSingleInput___default.a
  },

  watch: {
    user: function changedUser(newUser) {
      this.setBreadcrumbData(this.account, newUser);
    },
    account: function changedAccount(newAccount) {
      this.setBreadcrumbData(newAccount, this.user);
    }
  },
  data: function data() {
    return {
      accountId: '',
      account: {},
      accountUsersLoading: false,
      breadcrumbData: [],
      currentAmountBalance: 0,
      fundingSources: [],
      isBankAccountChangedWarningVisible: false,
      isFundingSourcesSegmentLoading: false,
      isUpcomingTransactionsSegmentLoading: false,
      shouldUpcomingTransactionsWithActionsBeDisplayed: false,
      shouldUpcomingTransactionsWithNoActionsBeDisplayed: false,
      isNotesSegmentLoading: false,
      isPreferencesSuccessMessageVisible: false,
      isRepresentativesLoading: false,
      maxAmountFundingSources: 6,
      name: '',
      noteLoading: false,
      notes: [],
      notesError: '',
      organization: {},
      originalTaxId: '',
      preferencesSpinner: false,
      preferencesSuccessMessage: '',
      previousFundingSourceId: '',
      previousPaymentPreference: '',
      user: [],
      userAccount: { defaultFundingSourceId: '' },
      userDetailLoading: false,
      userId: '',
      accountRepresentatives: [],
      beneficiaries: [],
      beneficiariesSpinner: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('accountCreation', ['isSuggestedAddressModalVisible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('app', ['trustTypes']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('home', ['userStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('question', ['display']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('checkWireModal', ['isCheckWireModalVisible', 'creationSucceeded']), {
    accountName: function accountName() {
      return this.account.accountName;
    },
    accountType: function accountType() {
      return this.account.accountType;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('account', ['getAccount', 'getAccountUsers', 'getAccountOrganizations', 'getAccountNotes', 'getAccountFundingSources', 'updateAccountPaymentPreference', 'setDefaultFundingSource', 'editTrustAccountInformation', 'getAccountBeneficiaries']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('accountCreation', ['getUserDetail', 'verifyOrganizationAddress', 'verifyMailingAddress']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('accountCreation', {
    setSuggestedAddress: __WEBPACK_IMPORTED_MODULE_26__store_mutation_types__["o" /* SET_SUGGESTED_ADDRESS */],
    setSuggestedAddressType: __WEBPACK_IMPORTED_MODULE_26__store_mutation_types__["p" /* SET_SUGGESTED_ADDRESS_TYPE */],
    setSuggestedAddressModalVisible: __WEBPACK_IMPORTED_MODULE_26__store_mutation_types__["q" /* SET_SUGGESTED_ADDRESS_MODAL_VISIBLE */],
    setSuggestedAddressYesMethod: __WEBPACK_IMPORTED_MODULE_26__store_mutation_types__["r" /* SET_SUGGESTED_ADDRESS_YES_METHOD */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_26__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_26__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_26__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_26__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('checkWireModal', {
    showCheckWireModal: __WEBPACK_IMPORTED_MODULE_26__store_mutation_types__["t" /* SHOW_CHECK_WIRE_MODAL */],
    setCreationStatus: __WEBPACK_IMPORTED_MODULE_26__store_mutation_types__["u" /* SET_CREATION_SUCCEEDED */]
  }), {
    setBreadcrumbData: function setBreadcrumbData(account, user) {
      this.breadcrumbData = [];
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
        title: 'Search',
        goto: { name: 'Users' },
        selected: false
      }));
      var params = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.$route.params);
      var goto = void 0;
      if (user.userType === __WEBPACK_IMPORTED_MODULE_23__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name) {
        goto = { name: 'EditFinancialAdvisor', params: { name: params.name, userId: params.userId } };
      } else {
        goto = { name: 'UserDetail', params: { name: params.name, userId: params.userId } };
      }
      var title = user.fullName;
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
        title: title,
        goto: goto,
        selected: false
      }));
      var gotoAccount = { name: this.$route.name, params: params };
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
        title: account.accountName,
        goto: gotoAccount,
        selected: true
      }));
    },
    showUpdateAccountConfirmationModal: function showUpdateAccountConfirmationModal() {
      var _this = this;

      this.accountUsersLoading = false;
      this.showQuestionModal({
        title: 'Update Trust Account Information',
        question: 'Are you sure about these changes?',
        method: function method() {
          _this.methodToExecuteInUpdateAccountQuestionModal();
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_30__data_static_constants__["a" /* Constants */].purchaseNote.modalYesButtonText,
        hideCancelButton: false
      });
    },
    methodToExecuteInUpdateAccountQuestionModal: function methodToExecuteInUpdateAccountQuestionModal() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.hideQuestionModal();
                _this2.accountUsersLoading = true;
                _this2.editTrustAccountInformation({
                  params: {
                    accountId: _this2.accountId,
                    organizationId: _this2.organization.id
                  },
                  payload: {
                    name: _this2.organization.name,
                    type: __WEBPACK_IMPORTED_MODULE_24__data_static_trustTypes__["a" /* default */][_this2.organization.type].key,
                    phoneNumber: _this2.removeFormattingCharacters(_this2.organization.phoneNumber),
                    taxId: _this2.removeFormattingCharacters(_this2.organization.taxId),
                    mailingAddress: _this2.organization.mailingAddress,
                    mainAddress: _this2.organization.mainAddress
                  }
                }).then(function () {
                  _this2.loadAccountInformation();
                  _this2.accountUsersLoading = false;
                }).catch(function (err) {
                  _this2.accountUsersLoading = false;
                  if (err !== 'UNAUTHORIZED') {
                    _this2.setErrorsModalInfo([err.message]);
                    _this2.showErrorsModal();
                  }
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    displayImpactPreferenceSuccessfulNotification: function displayImpactPreferenceSuccessfulNotification() {
      this.preferencesSuccessMessage = __WEBPACK_IMPORTED_MODULE_30__data_static_constants__["a" /* Constants */].adminPreferences.successMessage;
      this.isPreferencesSuccessMessageVisible = true;
      this.preferencesSpinner = false;
      this.goToSegment('preferences-segment');
    },
    displayUpcomingTransactionsWithActionAlert: function displayUpcomingTransactionsWithActionAlert() {
      this.shouldUpcomingTransactionsWithActionsBeDisplayed = true;
      this.shouldUpcomingTransactionsWithNoActionsBeDisplayed = false;
    },
    displayUpcomingTransactionsWithNoActionAlert: function displayUpcomingTransactionsWithNoActionAlert() {
      this.shouldUpcomingTransactionsWithActionsBeDisplayed = false;
      this.shouldUpcomingTransactionsWithNoActionsBeDisplayed = true;
    },
    hideUpcomingTransactionsAlerts: function hideUpcomingTransactionsAlerts() {
      this.shouldUpcomingTransactionsWithActionsBeDisplayed = false;
      this.shouldUpcomingTransactionsWithNoActionsBeDisplayed = false;
    },
    goToSegment: function goToSegment(segment) {
      document.getElementById(segment).scrollIntoView();
    },
    setUpcomingTransactionsSpinnerOff: function setUpcomingTransactionsSpinnerOff() {
      this.isUpcomingTransactionsSegmentLoading = false;
    },
    setUpcomingTransactionsSpinnerOn: function setUpcomingTransactionsSpinnerOn() {
      this.isUpcomingTransactionsSegmentLoading = true;
    },
    setFundingSourceSpinnerOff: function setFundingSourceSpinnerOff() {
      this.isFundingSourcesSegmentLoading = false;
    },
    setFundingSourceSpinnerOn: function setFundingSourceSpinnerOn() {
      this.isFundingSourcesSegmentLoading = true;
    },
    setNotesSpinnerOff: function setNotesSpinnerOff() {
      this.isNotesSegmentLoading = false;
    },
    setNotesSpinnerOn: function setNotesSpinnerOn() {
      this.isNotesSegmentLoading = true;
    },
    setRepresentativesSpinnerOn: function setRepresentativesSpinnerOn() {
      this.isRepresentativesLoading = true;
    },
    setRepresentativesSpinnerOff: function setRepresentativesSpinnerOff() {
      this.isRepresentativesLoading = false;
    },
    setBeneficiariesSpinnerOn: function setBeneficiariesSpinnerOn() {
      this.beneficiariesSpinner = true;
    },
    setBeneficiariesSpinnerOff: function setBeneficiariesSpinnerOff() {
      this.beneficiariesSpinner = false;
    },
    loadAccountInformation: function loadAccountInformation() {
      this.loadUserDetail();
      this.loadAccountUsers();
    },
    setParams: function setParams() {
      this.userId = this.$route.params.userId;
      this.accountId = this.$route.params.accountId;
      this.name = this.$route.params.name;
    },
    setPreferencesSpinnerOff: function setPreferencesSpinnerOff() {
      this.preferencesSpinner = false;
    },
    setPreferencesSpinnerOn: function setPreferencesSpinnerOn() {
      this.preferencesSpinner = true;
    },
    hidePreferencesSuccessMessage: function hidePreferencesSuccessMessage() {
      this.isPreferencesSuccessMessageVisible = false;
    },
    loadUserDetail: function loadUserDetail() {
      var _this3 = this;

      this.userDetailLoading = true;
      return this.getUserDetail(this.userId).then(function (user) {
        _this3.userDetailLoading = false;
        _this3.user = user;
        _this3.userAccount = _this3.findAccount(user.accounts, _this3.accountId);
        _this3.previousFundingSourceId = _this3.userAccount.defaultFundingSourceId;
      }).catch(function (err) {
        _this3.userDetailLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this3.setErrorsModalInfo(['We could not retrieve user detail']);
          _this3.showErrorsModal();
        }
      });
    },
    removeFormattingCharacters: function removeFormattingCharacters(text) {
      return text.replace(/[-_() ]/g, '');
    },
    validateAndSubmitAccount: function validateAndSubmitAccount() {
      var _this4 = this;

      this.accountUsersLoading = true;
      if (!this.$refs.addresses.isMailingAddressDifferent) {
        this.organization.mailingAddress = this.organization.mainAddress;
      }
      return this.validateOrganizationAddress().then(function () {
        return _this4.validateMailingAddress();
      }).then(function () {
        return _this4.showUpdateAccountConfirmationModal();
      }).catch(function (err) {
        _this4.accountUsersLoading = false;
        if (err === 'SUGGESTED') {
          return;
        }
        var errorsModal = [];
        var errorMessage = __WEBPACK_IMPORTED_MODULE_19__data_static_addressErrors__["a" /* AddressErrors */][err.message] || err.message;
        errorsModal.push(errorMessage);
        _this4.showUserModalsError(errorsModal);
      });
    },
    showUserModalsError: function showUserModalsError(listUserErrors) {
      this.setErrorsModalInfo(listUserErrors);
      this.showErrorsModal();
    },
    validateOrganizationAddress: function validateOrganizationAddress() {
      var _this5 = this;

      return this.verifyOrganizationAddress(this.organization.mainAddress).then(function (verifiedAddress) {
        var mainAddress = _this5.organization.mainAddress;
        if (__WEBPACK_IMPORTED_MODULE_29__config_config__["d" /* env */] === 'production' && (mainAddress.streetAddress1 !== verifiedAddress.streetAddress1 || mainAddress.streetAddress2 !== verifiedAddress.streetAddress2 || mainAddress.zipCode !== verifiedAddress.zipCode || mainAddress.state !== verifiedAddress.state || mainAddress.city !== verifiedAddress.city)) {
          _this5.setSuggestedAddress(_this5.truncateAddressIfNecessary(verifiedAddress));
          _this5.setSuggestedAddressType('organization');
          _this5.setSuggestedAddressModalVisible(true);
          _this5.setSuggestedAddressYesMethod(function () {
            mainAddress.streetAddress1 = verifiedAddress.streetAddress1;
            mainAddress.streetAddress2 = verifiedAddress.streetAddress2;
            mainAddress.zipCode = verifiedAddress.zipCode;
            mainAddress.city = verifiedAddress.city;
            mainAddress.state = verifiedAddress.state;
            _this5.validateAndSubmitAccount();
          });
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject('SUGGESTED');
        }
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      });
    },
    validateMailingAddress: function validateMailingAddress() {
      var _this6 = this;

      if (!this.$refs.addresses.isMailingAddressDifferent) {
        return true;
      }
      return this.verifyMailingAddress(this.organization.mailingAddress).then(function (verifiedAddress) {
        var mailingAddress = _this6.organization.mailingAddress;
        if (__WEBPACK_IMPORTED_MODULE_29__config_config__["d" /* env */] === 'production' && (mailingAddress.streetAddress1 !== verifiedAddress.streetAddress1 || mailingAddress.streetAddress2 !== verifiedAddress.streetAddress2 || mailingAddress.zipCode !== verifiedAddress.zipCode || mailingAddress.state !== verifiedAddress.state || mailingAddress.city !== verifiedAddress.city)) {
          _this6.setSuggestedAddress(_this6.truncateAddressIfNecessary(verifiedAddress));
          _this6.setSuggestedAddressType('mailing');
          _this6.setSuggestedAddressModalVisible(true);
          _this6.setSuggestedAddressYesMethod(function () {
            mailingAddress.streetAddress1 = verifiedAddress.streetAddress1;
            mailingAddress.streetAddress2 = verifiedAddress.streetAddress2;
            mailingAddress.zipCode = verifiedAddress.zipCode;
            mailingAddress.city = verifiedAddress.city;
            mailingAddress.state = verifiedAddress.state;
            _this6.validateAndSubmitAccount();
          });
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject('SUGGESTED');
        }
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      });
    },
    shouldSubmitButtonBeDisabled: function shouldSubmitButtonBeDisabled() {
      if (!this.organization.id) {
        return true;
      }
      var areBothAddressesValid = this.areMainAndMailingAddressValid();
      var isPhoneNumberValid = this.isPhoneNumberValid();
      var isTaxIdValid = this.isTaxIdValid();
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__util__["F" /* isStringValid */])(this.organization.name) || !isTaxIdValid || !isPhoneNumberValid || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__util__["F" /* isStringValid */])(this.organization.type) || !areBothAddressesValid;
    },
    areMainAndMailingAddressValid: function areMainAndMailingAddressValid() {
      var areBothAddressesValid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__util__["G" /* isAddressValid */])(this.organization.mainAddress);
      if (this.$refs.addresses && this.$refs.addresses.isMailingAddressDifferent) {
        areBothAddressesValid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__util__["G" /* isAddressValid */])(this.organization.mailingAddress);
      }
      return areBothAddressesValid;
    },
    isTaxIdValid: function isTaxIdValid() {
      if (!this.organization.taxId) {
        return false;
      }
      var isTaxIdValid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__util__["F" /* isStringValid */])(this.organization.taxId) && this.organization.taxId;
      if (isTaxIdValid) {
        isTaxIdValid = this.removeFormattingCharacters(this.organization.taxId).length === 9 && /^[0-9]+$/.test(this.removeFormattingCharacters(this.organization.taxId));
      }
      return isTaxIdValid || this.originalTaxId === this.removeFormattingCharacters(this.organization.taxId);
    },
    isPhoneNumberValid: function isPhoneNumberValid() {
      var isPhoneNumberValid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__util__["F" /* isStringValid */])(this.organization.phoneNumber);
      if (isPhoneNumberValid) {
        isPhoneNumberValid = this.removeFormattingCharacters(this.organization.phoneNumber).length === 10;
      }
      return isPhoneNumberValid;
    },
    truncateAddressIfNecessary: function truncateAddressIfNecessary(address) {
      var localAddress = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, address);
      var hasStreetAddress1 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress1');
      var hasStreetAddress2 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress2');
      if (hasStreetAddress1 && hasStreetAddress2) {
        var totalAdressLength = address.streetAddress1.length + address.streetAddress2.length;
        if (totalAdressLength > 50) {
          var charsToCut = totalAdressLength - 50;
          localAddress.streetAddress2 = address.streetAddress2.slice(0, -charsToCut);
          return localAddress;
        }
      }
      return address;
    },
    loadAccountUsers: function loadAccountUsers() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, _ref2, account, accountOrganizations, accountRepresentatives, beneficiaries;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this7.accountUsersLoading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this7.getAccount(_this7.accountId), _this7.getAccountOrganizations(_this7.accountId), _this7.getAccountUsers(_this7.accountId), _this7.getAccountBeneficiaries(_this7.accountId)]);

              case 4:
                _ref = _context2.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 4);
                account = _ref2[0];
                accountOrganizations = _ref2[1];
                accountRepresentatives = _ref2[2];
                beneficiaries = _ref2[3];

                _this7.account = account;
                _this7.accountRepresentatives = accountRepresentatives;
                _this7.beneficiaries = beneficiaries;
                _this7.organization = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, accountOrganizations[0]);
                _this7.originalTaxId = _this7.organization.taxId;
                _this7.previousPaymentPreference = _this7.account.paymentPreference;
                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve());

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](0);

                if (!(_context2.t0 !== 'UNAUTHORIZED')) {
                  _context2.next = 25;
                  break;
                }

                _this7.setErrorsModalInfo(['We could not retrieve users list']);
                _this7.showErrorsModal();
                return _context2.abrupt('return', _context2.t0);

              case 25:
                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject());

              case 26:
                _context2.prev = 26;

                _this7.accountUsersLoading = false;
                return _context2.finish(26);

              case 29:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7, [[0, 19, 26, 29]]);
      }))();
    },
    loadNotesList: function loadNotesList() {
      var _this8 = this;

      this.noteLoading = true;
      return this.getAccountNotes(this.accountId).then(function (notes) {
        _this8.noteLoading = false;
        _this8.notes = notes;
        var openNotes = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(notes, { status: 'open' });
        _this8.currentAmountBalance = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.sumBy(['currentBalance'], __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.partial(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.sumBy, openNotes));
      }).catch(function (err) {
        _this8.noteLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this8.setErrorsModalInfo(['We could not retrieve notes list']);
          _this8.showErrorsModal();
        }
      });
    },
    loadFundingSourceAfterModalSave: function loadFundingSourceAfterModalSave() {
      if (this.creationSucceeded) {
        this.loadUserDetail();
        this.loadFundingSources();
        this.setCreationStatus(false);
      }
    },
    loadFundingSources: function loadFundingSources() {
      var _this9 = this;

      this.fundingLoading = true;
      return this.getAccountFundingSources(this.accountId).then(function (data) {
        _this9.fundingLoading = false;
        _this9.fundingSources = data.filter(function (fss) {
          return !fss.removed && (fss.type === 'bank' || fss.type === 'check' || fss.type === 'wire/ach');
        });
      }).catch(function (err) {
        _this9.fundingLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this9.setErrorsModalInfo(['We could not retrieve bank accounts list']);
          _this9.showErrorsModal();
        }
      });
    },
    getAccountType: function getAccountType() {
      if (this.userAccount && this.userAccount.accountType) {
        var accountType = this.userAccount.accountType;
        return '' + accountType[0] + accountType.slice(1).toLowerCase();
      }
      return '';
    },
    showDefaultFundingSourceConfirmationModal: function showDefaultFundingSourceConfirmationModal(_ref3) {
      var _this10 = this;

      var fundingSource = _ref3.fundingSource;

      this.userAccount.defaultFundingSourceId = this.previousFundingSourceId;
      this.showQuestionModal({
        title: 'Bank account',
        question: 'Are you sure you want to select ' + fundingSource.name + ' as new default bank account?',
        method: function method() {
          _this10.methodToExecuteInDefaultFundingSourceQuestionModal(fundingSource.id);
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_30__data_static_constants__["a" /* Constants */].purchaseNote.modalYesButtonText,
        hideCancelButton: false
      });
    },
    showConfirmationModal: function showConfirmationModal(paymentPreference) {
      var _this11 = this;

      this.account.paymentPreference = this.previousPaymentPreference;
      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_30__data_static_constants__["a" /* Constants */].accountDetail.modalTitle,
        question: 'Are you sure you want to select ' + this.formatPaymentPreference(paymentPreference) + ' as your new default payment action?',
        method: function method() {
          _this11.methodToExecuteInQuestionModal(paymentPreference);
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_30__data_static_constants__["a" /* Constants */].accountDetail.modalYesButtonText,
        hideCancelButton: false
      });
    },
    methodToExecuteInDefaultFundingSourceQuestionModal: function methodToExecuteInDefaultFundingSourceQuestionModal(fundingSourceId) {
      var _this12 = this;

      this.hideQuestionModal();
      var account = this.userAccount;
      this.setDefaultFundingSource({
        accountId: account.id,
        fundingSourceId: fundingSourceId
      }).then(function () {
        _this12.previousFundingSourceId = fundingSourceId;
        _this12.userAccount.defaultFundingSourceId = fundingSourceId;
      });
    },
    methodToExecuteInQuestionModal: function methodToExecuteInQuestionModal(paymentPreference) {
      var _this13 = this;

      this.hideQuestionModal();
      this.updateAccountPaymentPreference({
        accountId: this.accountId,
        paymentPreference: paymentPreference
      }).then(function () {
        _this13.previousPaymentPreference = paymentPreference;
        _this13.account.paymentPreference = paymentPreference;
      });
    },
    openCheckWireModal: function openCheckWireModal() {
      var filteredFundingSources = this.fundingSources.filter(function (fss) {
        return fss.type === 'check' || fss.type === 'wire-transfer';
      });
      this.showCheckWireModal({ accountId: this.accountId,
        fundingSources: filteredFundingSources });
    },
    goToPurchaseInvestmentNote: function goToPurchaseInvestmentNote() {
      var accountId = this.accountId;
      var userId = this.userId;
      var name = this.name;
      this.$router.push({ name: 'PurchaseInvestmentNote', params: { accountId: accountId, userId: userId, name: name } });
    },
    goToViewDetail: function goToViewDetail(note) {
      var userId = this.userId;
      var name = this.name;
      this.$router.push({ name: 'NoteDetail', params: { name: name, userId: userId, noteId: note.id } });
    },
    onTrustNameUpdate: function onTrustNameUpdate(value) {
      if (value) {
        this.organization.name = value.trim();
      }
    },
    handleDefaultFundingSourceUpdated: function handleDefaultFundingSourceUpdated() {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this14.loadUserDetail(), _this14.loadAccountUsers()]);

              case 2:
                _context3.next = 4;
                return _this14.$nextTick();

              case 4:
                if (!_this14.$refs.upcomingTransactions) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 7;
                return _this14.$refs.upcomingTransactions.initializeState();

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this14);
      }))();
    },
    showBankAccountChangedWarning: function showBankAccountChangedWarning() {
      this.isBankAccountChangedWarningVisible = true;
    },
    hideBankAccountChangedWarning: function hideBankAccountChangedWarning() {
      this.isBankAccountChangedWarningVisible = false;
    },
    handleGoToUpcomingTransactions: function handleGoToUpcomingTransactions() {
      this.goToSegment('upcoming-transactions-segment');
    }
  })
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_AddressSuggestion__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_AddressSuggestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_AddressSuggestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_modals_Information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_AccountCreation__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_AccountCreation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_modals_AccountCreation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_formControls_RestrictedTwoInputs__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_formControls_RestrictedTwoInputs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_formControls_RestrictedTwoInputs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Addresses__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Addresses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Addresses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__data_static_constants__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util__ = __webpack_require__(9);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_18__util__["b" /* formatDate */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditUserProfile',
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.checkUserStatus();

            case 2:
              _context.next = 4;
              return _this.loadUserDetail();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  mixins: [mix],
  data: function data() {
    return {
      minimumAge: 18,
      isResidentDefaultAddress: false,
      userProfile: {
        accounts: [],
        residentialAddress: {
          streetAddress1: ''
        },
        mailingAddress: {
          streetAddress1: ''
        }
      },
      userName: '',
      userType: '',
      isLoading: true,
      isBirthFieldInvalid: false,
      dateBirthConfig: {
        format: 'MM/DD/YYYY'
      },
      dateBirthFormat: 'YYYY-MM-DD',
      previousSSN: '',
      creationSucceeded: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('accountCreation', ['isSuggestedAddressModalVisible', 'isAccountCreationModalVisible', 'changeAddress', 'suggestedAddressModalYesCall']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('information', ['isInformationModalVisible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('question', ['display']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('app', ['activeAccount', 'activeAccountId', 'user', 'userTypes']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['hasBeenCreatedAccount']), {
    showDobAndSsn: function showDobAndSsn() {
      return this.userProfile.updateCount === 0 && this.userProfile.userType !== this.userTypes.FINANCIAL_ADVISOR.name;
    }
  }),
  watch: {
    suggestedAddressModalYesCall: function suggestedAddressModalYesCall(_ref) {
      var _this2 = this;

      var payload = _ref.payload,
          suggestedAddress = _ref.suggestedAddress,
          addressType = _ref.addressType;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.$refs.addresses.isMailingAddressDifferent) {
                  _this2.userProfile.residentialAddress = suggestedAddress;
                  _this2.userProfile.mailingAddress = suggestedAddress;
                  _this2.$refs.addresses.setResidencialAddress(suggestedAddress);
                  _this2.$refs.addresses.setMailingAddress(suggestedAddress);
                }
                if (['residential', 'organization'].includes(addressType)) {
                  _this2.userProfile.residentialAddress = suggestedAddress;
                  _this2.$refs.addresses.setResidencialAddress(suggestedAddress);
                } else if (addressType === 'mailing') {
                  _this2.userProfile.mailingAddress = suggestedAddress;
                  _this2.$refs.addresses.setMailingAddress(suggestedAddress);
                }
                _context2.next = 4;
                return _this2.save(payload);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('accountCreation', ['updateUserProfile', 'getUserProfile', 'verifyResidentialAddress', 'verifyOrganizationAddress', 'verifyMailingAddress']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('home', ['getUserStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('information', {
    showInformationModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["d" /* SHOW_INFORMATION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('app', {
    setUser: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["a" /* SET_USER */],
    setActiveAccountId: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["f" /* SET_ACTIVE_ACCOUNT_ID */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('accountCreation', {
    setSuggestedAddress: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["o" /* SET_SUGGESTED_ADDRESS */],
    setUserByAdmin: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["y" /* SET_USER_BY_ADMIN */],
    setSuggestedAddressType: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["p" /* SET_SUGGESTED_ADDRESS_TYPE */],
    setSuggestedAddressModalVisible: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["q" /* SET_SUGGESTED_ADDRESS_MODAL_VISIBLE */],
    setSuggestedAddressYesMethod: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["r" /* SET_SUGGESTED_ADDRESS_YES_METHOD */],
    showAccountCreationModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["z" /* SHOW_ACCOUNT_CREATION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), {
    residentialAddressUpdated: function residentialAddressUpdated($event) {
      this.userProfile.residentialAddress.streetAddress1 = $event.primary;
      this.userProfile.residentialAddress.streetAddress2 = $event.secondary;
    },
    mailingAddressUpdated: function mailingAddressUpdated($event) {
      this.userProfile.mailingAddress.streetAddress1 = $event.primary;
      this.userProfile.mailingAddress.streetAddress2 = $event.secondary;
    },
    addressAreEqual: function addressAreEqual(adr1, adr2) {
      return adr1.city === adr2.city && adr1.state === adr2.state && adr1.streetAddress1 === adr2.streetAddress1 && adr1.streetAddress2 === adr2.streetAddress2 && adr1.zipCode === adr2.zipCode;
    },
    loadUserDetail: function loadUserDetail() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.userName = _this3.userProfile.firstName + '  ' + _this3.userProfile.lastName;
                _this3.userType = 'Individual Investor';
                _context3.next = 4;
                return _this3.getUserProfile().then(function (data) {
                  _this3.userProfile = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(data);
                  _this3.setUser(_this3.userProfile);
                  _this3.userProfile.updateCount = data.updateCount ? data.updateCount : 0;
                  _this3.userProfile.organizationName = data.accounts[0].organizationName;
                  _this3.userProfile.CRDnumber = data.accounts[0].CRDnumber;
                  _this3.userProfile.socialSecurityNum = _this3.userProfile.socialSecurityNum ? 'xxx-xx-' + _this3.userProfile.socialSecurityNum : null;
                  _this3.userProfile.dateOfBirth = __WEBPACK_IMPORTED_MODULE_7_moment___default.a.utc(_this3.userProfile.dateOfBirth + ' 12:00:00');
                  var _userProfile = _this3.userProfile,
                      residentialAddress = _userProfile.residentialAddress,
                      mailingAddress = _userProfile.mailingAddress;

                  _this3.isResidentDefaultAddress = !_this3.addressAreEqual(residentialAddress, mailingAddress);
                  _this3.isLoading = false;
                }).catch(function () {
                  _this3.isLoading = false;
                });

              case 4:
                _this3.isLoading = false;

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    checkDateBirth: function checkDateBirth(dateOfBirth) {
      if (dateOfBirth === '' || dateOfBirth === null) {
        this.isBirthFieldInvalid = true;
      } else {
        this.isBirthFieldInvalid = false;
      }
    },
    isDateBirthValid: function isDateBirthValid(dateOfBirth) {
      if (dateOfBirth === '') {
        return false;
      }
      var birthYear = new Date(dateOfBirth).getFullYear();
      var currentYear = new Date().getFullYear();
      return currentYear - birthYear >= this.minimumAge;
    },
    isSsnUpdated: function isSsnUpdated() {
      var ssn = this.getSsnDigits(this.userProfile.socialSecurityNum);
      return !ssn.includes('x');
    },
    getSsnDigits: function getSsnDigits(ssn) {
      if (!ssn) {
        return 'x';
      }
      return ssn.replace(/[- ]/g, '');
    },
    getPhoneDigits: function getPhoneDigits(phoneNum) {
      if (typeof phoneNum === 'string') {
        return phoneNum.replace(/[-() ]/g, '');
      }
      return '';
    },
    getDateOnlyDOB: function getDateOnlyDOB(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format(this.dateBirthFormat).toString();
    },
    isStateSelected: function isStateSelected(userProfile) {
      return userProfile.residentialAddress.state.length > 0;
    },
    copyMailingAddress: function copyMailingAddress() {
      this.userProfile.mailingAddress = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.userProfile.residentialAddress);
    },
    validateUserProfile: function validateUserProfile(userProfile) {
      var listUserErrors = [];
      if (!this.isDateBirthValid(userProfile.dateOfBirth) && userProfile.userType !== this.userTypes.FINANCIAL_ADVISOR.name) {
        listUserErrors.push('You must be 18 years or older in order to invest with us.');
      }
      var SsnRegex = /^[0-9]{3}\-?[0-9]{2}\-?[0-9]{4}$/; // eslint-disable-line no-useless-escape
      if (!SsnRegex.test(userProfile.socialSecurityNum) && this.isSsnUpdated() && userProfile.userType !== this.userTypes.FINANCIAL_ADVISOR.name) {
        listUserErrors.push('Enter a valid social security number.');
      }
      var phoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/; // eslint-disable-line no-useless-escape
      if (!phoneRegex.test(userProfile.primaryPhoneNum)) {
        listUserErrors.push('Enter a valid primary phone number.');
      }
      if (userProfile && userProfile.secondaryPhoneNum && userProfile.secondaryPhoneNum.length > 0 && !phoneRegex.test(userProfile.secondaryPhoneNum)) {
        listUserErrors.push('Enter a valid secondary phone number.');
      }
      if (!__WEBPACK_IMPORTED_MODULE_18__util__["p" /* zipRegex */].test(userProfile.residentialAddress.zipCode)) {
        listUserErrors.push('Provide a valid residential zip code.');
      }
      if (this.isResidentDefaultAddress && !__WEBPACK_IMPORTED_MODULE_18__util__["p" /* zipRegex */].test(userProfile.mailingAddress.zipCode)) {
        listUserErrors.push('Provide a valid mailing zip code.');
      }
      if (!this.isStateSelected(userProfile)) {
        listUserErrors.push('Please select a state in order to save your profile.');
      }
      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
      if (userProfile.email) {
        if (!regex.test(userProfile.email)) {
          listUserErrors.push('Please, enter a valid email. ');
        }
      }
      return listUserErrors;
    },
    setDataWithoutMasks: function setDataWithoutMasks() {
      this.userProfile.primaryPhoneNum = this.getPhoneDigits(this.userProfile.primaryPhoneNum);
      this.userProfile.secondaryPhoneNum = this.getPhoneDigits(this.userProfile.secondaryPhoneNum);
      this.userProfile.socialSecurityNum = this.getSsnDigits(this.userProfile.socialSecurityNum);
      this.userProfile.dateOfBirth = this.getDateOnlyDOB(this.userProfile.dateOfBirth);
      this.previousSSN = this.userProfile.socialSecurityNum;
    },
    isZipCodeInvalid: function isZipCodeInvalid(zipCode) {
      if (!zipCode) {
        return false;
      }
      return !__WEBPACK_IMPORTED_MODULE_18__util__["p" /* zipRegex */].test(zipCode);
    },
    truncateAddressIfNecessary: function truncateAddressIfNecessary(address) {
      var localAddress = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, address);
      var hasStreetAddress1 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress1');
      var hasStreetAddress2 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress2');
      if (hasStreetAddress1 && hasStreetAddress2) {
        var totalAdressLength = address.streetAddress1.length + address.streetAddress2.length;
        if (totalAdressLength > 50) {
          var charsToCut = 50 - totalAdressLength;
          localAddress.streetAddress2 = address.streetAddress2.slice(0, -charsToCut);
          return localAddress;
        }
      }
      return address;
    },
    validateAndSubmitUser: function validateAndSubmitUser() {
      this.isLoading = true;
      this.setUserByAdmin(this.userProfile);

      var errorList = this.validateUserProfile(this.userProfile);

      if (errorList.length > 0) {
        this.showUserModalsError(errorList);
        this.isLoading = false;
        return false;
      }

      if (!this.$refs.addresses.isMailingAddressDifferent) {
        this.userProfile.mailingAddress = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.userProfile.residentialAddress);
      }

      this.setDataWithoutMasks();

      return this.showConfirmationModal();
    },
    save: function save(userData) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var provideLoging, options, addressData, address, payload;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.isLoading = true;
                _context4.prev = 1;
                provideLoging = false;
                options = provideLoging ? {
                  provideLogin: _this4.provideInvestorLogin,
                  enableMfa: _this4.enableMfa
                } : {};
                addressData = _this4.$refs.addresses.getData();

                // Advisors address -> organization

                address = _this4.userProfile.userType === 'ADVISOR' ? { organizationAddress: addressData.residentialAddress } : { residentialAddress: addressData.residentialAddress };
                payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, userData, address, {
                  mailingAddress: addressData.mailingAddress
                });
                _context4.next = 9;
                return _this4.updateUserProfile(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload, options));

              case 9:

                _this4.isLoading = false;
                _context4.next = 12;
                return _this4.loadUserDetail();

              case 12:
                _context4.next = 18;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4['catch'](1);

                _this4.isLoading = false;
                _this4.userProfile.socialSecurityNum = _this4.previousSSN;

              case 18:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[1, 14]]);
      }))();
    },
    showUserModalsError: function showUserModalsError(listUserErrors) {
      this.setErrorsModalInfo(listUserErrors);
      this.showErrorsModal();
    },
    submitDifferentMailingAddress: function submitDifferentMailingAddress() {
      this.userProfile.mailingAddress.streetAddress1 = '';
      this.userProfile.mailingAddress.streetAddress2 = '';
      this.userProfile.mailingAddress.zipCode = '';
      this.userProfile.mailingAddress.city = '';
      this.userProfile.mailingAddress.state = '';
    },
    disableSubmitButton: function disableSubmitButton() {
      return !this.userProfile.firstName || !this.userProfile.firstName.trim() || !this.userProfile.lastName.trim() || !this.userProfile.primaryPhoneNum || !this.userProfile.email.trim() || !this.userProfile.residentialAddress.streetAddress1.trim() || !this.userProfile.residentialAddress.zipCode.trim() || !this.userProfile.residentialAddress.city.trim() || !this.userProfile.residentialAddress.state || this.isResidentDefaultAddress && (!this.userProfile.mailingAddress.streetAddress1.trim() || !this.userProfile.mailingAddress.zipCode.trim() || !this.userProfile.mailingAddress.city.trim() || !this.userProfile.mailingAddress.state) || this.showDobAndSsn && !this.userProfile.socialSecurityNum || this.isBirthFieldInvalid || this.isLoading;
    },
    checkUserStatus: function checkUserStatus() {
      var _this5 = this;

      this.isLoading = true;
      if (!this.hasBeenCreatedAccount) {
        return this.$router.push({ name: 'AccountSummary' });
      }
      return this.getUserStatus({
        accountId: this.activeAccount.id
      }).then(function (_ref2) {
        var status = _ref2.status,
            needs = _ref2.needs;

        if (status === 'suspended') {
          _this5.$router.push({ name: 'AccountSuspended' });
        } else if (status === 'retry') {
          _this5.$router.push({ name: 'AccountCreation' });
        } else if (status === 'document') {
          _this5.$router.push({ name: 'DocumentUpload' });
        } else if (needs.includes('FUNDING_SOURCE')) {
          _this5.$router.push({ name: 'AddFundingSource' });
        } else if (needs.includes('NOTE')) {
          _this5.$router.push({ name: 'PurchaseNote', query: { first: 1 } });
        }
        _this5.isLoading = false;
        return true;
      });
    },
    showConfirmationModal: function showConfirmationModal() {
      var _this6 = this;

      this.isLoading = false;
      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_17__data_static_constants__["a" /* Constants */].userDetail.modalTitle,
        question: __WEBPACK_IMPORTED_MODULE_17__data_static_constants__["a" /* Constants */].userDetail.ModalUserConfirmation,
        method: function () {
          var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this6.methodToExecuteInQuestionModal();

                  case 2:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee5, _this6);
          }));

          return function method() {
            return _ref3.apply(this, arguments);
          };
        }(),
        yesButtonText: __WEBPACK_IMPORTED_MODULE_17__data_static_constants__["a" /* Constants */].userDetail.modalYesButtonText,
        hideCancelButton: false
      });
    },
    updateActiveAccount: function updateActiveAccount() {
      var _this7 = this;

      var account = this.userProfile.accounts.find(function (ac) {
        return ac.id === _this7.activeAccountId;
      });
      this.setActiveAccountId(account);
    },
    cleanPayload: function cleanPayload() {
      var userProfile = this.userProfile;

      if (!this.isSsnUpdated()) {
        delete userProfile.socialSecurityNum;
      }
      userProfile.updateCount += 1;
      userProfile.isResidentDefaultAddress = this.isResidentDefaultAddress;

      delete userProfile.dwollaCustomerId;
      delete userProfile.accounts;
      delete userProfile.roles;
      delete userProfile.accountType;
      delete userProfile.organizationName;
      delete userProfile.CRDnumber;
      delete userProfile.userId;

      if (userProfile.userType === this.userTypes.FINANCIAL_ADVISOR.name) {
        delete userProfile.socialSecurityNum;
        delete userProfile.dateOfBirth;
      }
      return userProfile;
    },
    methodToExecuteInQuestionModal: function methodToExecuteInQuestionModal() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var userProfile;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this8.hideQuestionModal();
                userProfile = _this8.cleanPayload();
                return _context6.abrupt('return', _this8.save(userProfile));

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    }
  }),
  components: {
    datePicker: __WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker___default.a,
    errors: __WEBPACK_IMPORTED_MODULE_10__components_modals_Errors___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_12__components_widgets_Spinner___default.a,
    information: __WEBPACK_IMPORTED_MODULE_11__components_modals_Information___default.a,
    accountCreation: __WEBPACK_IMPORTED_MODULE_14__components_modals_AccountCreation___default.a,
    RestrictedTwoInputs: __WEBPACK_IMPORTED_MODULE_15__components_formControls_RestrictedTwoInputs___default.a,
    question: __WEBPACK_IMPORTED_MODULE_13__components_modals_Question___default.a,
    'address-suggestion': __WEBPACK_IMPORTED_MODULE_9__components_modals_AddressSuggestion___default.a,
    'addresses-form': __WEBPACK_IMPORTED_MODULE_16__components_Addresses___default.a
  }
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_AddressSuggestion__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_AddressSuggestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_AddressSuggestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_modals_Information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_AccountCreation__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_AccountCreation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_modals_AccountCreation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_formControls_RestrictedTwoInputs__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_formControls_RestrictedTwoInputs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_formControls_RestrictedTwoInputs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Addresses__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Addresses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Addresses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__data_static_constants__ = __webpack_require__(16);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_17__util__["b" /* formatDate */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditUserProfileByAdvisor',
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.isLoading = true;
              _context.next = 3;
              return _this.loadUserDetail();

            case 3:
              _this.isLoading = false;

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  mixins: [mix],
  data: function data() {
    return {
      minimumAge: 18,
      isResidentDefaultAddress: false,
      userProfile: {
        accounts: [],
        residentialAddress: {
          streetAddress1: ''
        },
        mailingAddress: {
          streetAddress1: ''
        }
      },
      userName: '',
      userType: '',
      isLoading: true,
      isBirthFieldInvalid: false,
      dateBirthConfig: {
        format: 'MM/DD/YYYY'
      },
      dateBirthFormat: 'YYYY-MM-DD',
      previousSSN: '',
      creationSucceeded: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('accountCreation', ['isSuggestedAddressModalVisible', 'isAccountCreationModalVisible', 'changeAddress', 'suggestedAddressModalYesCall']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('information', ['isInformationModalVisible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('question', ['display']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('app', ['activeAccount', 'activeAccountId', 'user', 'geoLocation'])),
  watch: {
    suggestedAddressModalYesCall: function suggestedAddressModalYesCall(_ref) {
      var _this2 = this;

      var payload = _ref.payload,
          suggestedAddress = _ref.suggestedAddress,
          addressType = _ref.addressType;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.$refs.addresses.isMailingAddressDifferent) {
                  _this2.userProfile.residentialAddress = suggestedAddress;
                  _this2.userProfile.mailingAddress = suggestedAddress;
                  _this2.$refs.addresses.setResidencialAddress(suggestedAddress);
                  _this2.$refs.addresses.setMailingAddress(suggestedAddress);
                }
                if (['residential', 'organization'].includes(addressType)) {
                  _this2.userProfile.residentialAddress = suggestedAddress;
                  _this2.$refs.addresses.setResidencialAddress(suggestedAddress);
                } else if (addressType === 'mailing') {
                  _this2.userProfile.mailingAddress = suggestedAddress;
                  _this2.$refs.addresses.setMailingAddress(suggestedAddress);
                }
                _context2.next = 4;
                return _this2.save(payload);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('accountCreation', ['getUserDetail', 'verifyResidentialAddress', 'verifyMailingAddress', 'updateUserProfile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('information', {
    showInformationModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["d" /* SHOW_INFORMATION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('app', {
    setUser: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["a" /* SET_USER */],
    setActiveAccountId: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["f" /* SET_ACTIVE_ACCOUNT_ID */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('accountCreation', {
    setSuggestedAddress: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["o" /* SET_SUGGESTED_ADDRESS */],
    setUserByAdmin: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["y" /* SET_USER_BY_ADMIN */],
    setSuggestedAddressType: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["p" /* SET_SUGGESTED_ADDRESS_TYPE */],
    setSuggestedAddressModalVisible: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["q" /* SET_SUGGESTED_ADDRESS_MODAL_VISIBLE */],
    setSuggestedAddressYesMethod: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["r" /* SET_SUGGESTED_ADDRESS_YES_METHOD */],
    showAccountCreationModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["z" /* SHOW_ACCOUNT_CREATION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), {
    residentialAddressUpdated: function residentialAddressUpdated($event) {
      this.userProfile.residentialAddress.streetAddress1 = $event.primary;
      this.userProfile.residentialAddress.streetAddress2 = $event.secondary;
    },
    mailingAddressUpdated: function mailingAddressUpdated($event) {
      this.userProfile.mailingAddress.streetAddress1 = $event.primary;
      this.userProfile.mailingAddress.streetAddress2 = $event.secondary;
    },
    addressAreEqual: function addressAreEqual(adr1, adr2) {
      return adr1.city === adr2.city && adr1.state === adr2.state && adr1.streetAddress1 === adr2.streetAddress1 && adr1.streetAddress2 === adr2.streetAddress2 && adr1.zipCode === adr2.zipCode;
    },
    loadUserDetail: function loadUserDetail() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.userType = 'Individual Investor';
                _context3.next = 3;
                return _this3.getUserDetail(_this3.activeAccount.primaryInvestorId).then(function (data) {
                  _this3.userProfile = __WEBPACK_IMPORTED_MODULE_6_lodash_cloneDeep___default()(data);

                  _this3.userName = _this3.userProfile.firstName + '  ' + _this3.userProfile.lastName;
                  _this3.userProfile.updateCount = data.updateCount ? data.updateCount : 0;
                  _this3.userProfile.organizationName = data.accounts[0].organizationName;
                  _this3.userProfile.CRDnumber = data.accounts[0].CRDnumber;
                  _this3.userProfile.socialSecurityNum = 'xxx-xx-' + _this3.userProfile.socialSecurityNum;
                  _this3.userProfile.dateOfBirth = __WEBPACK_IMPORTED_MODULE_7_moment___default.a.utc(_this3.userProfile.dateOfBirth + ' 12:00:00');

                  var _userProfile = _this3.userProfile,
                      residentialAddress = _userProfile.residentialAddress,
                      mailingAddress = _userProfile.mailingAddress;

                  _this3.isResidentDefaultAddress = !_this3.addressAreEqual(residentialAddress, mailingAddress);

                  _this3.isLoading = false;
                }).catch(function () {
                  _this3.isLoading = false;
                });

              case 3:
                _this3.isLoading = false;

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getPhoneDigits: function getPhoneDigits(phoneNum) {
      return phoneNum.replace(/[-() ]/g, '');
    },
    copyMailingAddress: function copyMailingAddress() {
      this.userProfile.mailingAddress = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.userProfile.residentialAddress);
    },
    isStateSelected: function isStateSelected(userProfile) {
      return userProfile.residentialAddress.state.length > 0;
    },
    validateUserProfile: function validateUserProfile(userProfile) {
      var listUserErrors = [];

      var phoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/; // eslint-disable-line no-useless-escape
      if (!phoneRegex.test(userProfile.primaryPhoneNum)) {
        listUserErrors.push('Enter a valid primary phone number.');
      }
      if (userProfile.secondaryPhoneNum.length > 0 && !phoneRegex.test(userProfile.secondaryPhoneNum)) {
        listUserErrors.push('Enter a valid secondary phone number.');
      }
      if (!__WEBPACK_IMPORTED_MODULE_17__util__["p" /* zipRegex */].test(userProfile.residentialAddress.zipCode)) {
        listUserErrors.push('Provide a valid residential zip code.');
      }
      if (this.isResidentDefaultAddress && !__WEBPACK_IMPORTED_MODULE_17__util__["p" /* zipRegex */].test(userProfile.mailingAddress.zipCode)) {
        listUserErrors.push('Provide a valid mailing zip code.');
      }
      if (!this.isStateSelected(userProfile)) {
        listUserErrors.push('Please select a state in order to save your profile.');
      }
      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
      if (userProfile.email) {
        if (!regex.test(userProfile.email)) {
          listUserErrors.push('Please, enter a valid email. ');
        }
      }
      return listUserErrors;
    },
    setDataWithoutMasks: function setDataWithoutMasks() {
      this.userProfile.primaryPhoneNum = this.getPhoneDigits(this.userProfile.primaryPhoneNum);
      this.userProfile.secondaryPhoneNum = this.getPhoneDigits(this.userProfile.secondaryPhoneNum);
      this.previousSSN = this.userProfile.socialSecurityNum;
    },
    isZipCodeInvalid: function isZipCodeInvalid(zipCode) {
      if (!zipCode) {
        return false;
      }
      return !__WEBPACK_IMPORTED_MODULE_17__util__["p" /* zipRegex */].test(zipCode);
    },
    truncateAddressIfNecessary: function truncateAddressIfNecessary(address) {
      var localAddress = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, address);
      var hasStreetAddress1 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress1');
      var hasStreetAddress2 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress2');
      if (hasStreetAddress1 && hasStreetAddress2) {
        var totalAdressLength = address.streetAddress1.length + address.streetAddress2.length;
        if (totalAdressLength > 50) {
          var charsToCut = 50 - totalAdressLength;
          localAddress.streetAddress2 = address.streetAddress2.slice(0, -charsToCut);
          return localAddress;
        }
      }
      return address;
    },
    validateAndSubmitUser: function validateAndSubmitUser() {
      this.isLoading = true;
      this.setUserByAdmin(this.userProfile);
      var listUserErrors = this.validateUserProfile(this.userProfile);
      if (listUserErrors.length > 0) {
        this.showUserModalsError(listUserErrors);
        this.isLoading = false;
        return false;
      }
      if (!this.$refs.addresses.isMailingAddressDifferent) {
        this.copyMailingAddress();
      }
      this.setDataWithoutMasks();
      return this.showConfirmationModal();
    },
    save: function save(userData) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var provideLoging, options, addressData, address, payload;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.isLoading = true;
                _context4.prev = 1;
                provideLoging = false;
                options = provideLoging ? {
                  provideLogin: _this4.provideInvestorLogin,
                  enableMfa: _this4.enableMfa
                } : {};
                addressData = _this4.$refs.addresses.getData();

                // Advisors address -> organization

                address = _this4.userProfile.userType === 'ADVISOR' ? { organizationAddress: addressData.residentialAddress } : { residentialAddress: addressData.residentialAddress };
                payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, userData, address, {
                  mailingAddress: addressData.mailingAddress
                });
                _context4.next = 9;
                return _this4.updateUserProfile(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, payload, options));

              case 9:

                _this4.isLoading = false;
                _context4.next = 12;
                return _this4.loadUserDetail();

              case 12:
                _context4.next = 18;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4['catch'](1);

                _this4.isLoading = false;
                _this4.userProfile.socialSecurityNum = _this4.previousSSN;

              case 18:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[1, 14]]);
      }))();
    },
    showUserModalsError: function showUserModalsError(listUserErrors) {
      this.setErrorsModalInfo(listUserErrors);
      this.showErrorsModal();
    },
    submitDifferentMailingAddress: function submitDifferentMailingAddress() {
      this.userProfile.mailingAddress.streetAddress1 = '';
      this.userProfile.mailingAddress.streetAddress2 = '';
      this.userProfile.mailingAddress.zipCode = '';
      this.userProfile.mailingAddress.city = '';
      this.userProfile.mailingAddress.state = '';
    },
    disableSubmitButton: function disableSubmitButton() {
      return !this.userProfile.firstName || !this.userProfile.firstName.trim() || !this.userProfile.lastName.trim() || !this.userProfile.primaryPhoneNum || !this.userProfile.email.trim() || !this.userProfile.residentialAddress.streetAddress1.trim() || !this.userProfile.residentialAddress.zipCode.trim() || !this.userProfile.residentialAddress.city.trim() || !this.userProfile.residentialAddress.state || this.isResidentDefaultAddress && (!this.userProfile.mailingAddress.streetAddress1.trim() || !this.userProfile.mailingAddress.zipCode.trim() || !this.userProfile.mailingAddress.city.trim() || !this.userProfile.mailingAddress.state) || this.isLoading;
    },
    showConfirmationModal: function showConfirmationModal() {
      var _this5 = this;

      this.isLoading = false;
      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].userDetail.modalTitle,
        question: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].userDetail.ModalUserConfirmation,
        method: function () {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this5.methodToExecuteInQuestionModal();

                  case 2:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee5, _this5);
          }));

          return function method() {
            return _ref2.apply(this, arguments);
          };
        }(),
        yesButtonText: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].userDetail.modalYesButtonText,
        hideCancelButton: false
      });
    },
    updateActiveAccount: function updateActiveAccount() {
      var _this6 = this;

      var account = this.userProfile.accounts.find(function (ac) {
        return ac.id === _this6.activeAccountId;
      });
      this.setActiveAccountId(account);
    },
    methodToExecuteInQuestionModal: function methodToExecuteInQuestionModal() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var userProfile;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.hideQuestionModal();
                _this7.isLoading = true;
                userProfile = _this7.userProfile;

                userProfile.updateCount += 1;
                userProfile.isResidentDefaultAddress = _this7.isResidentDefaultAddress;

                delete userProfile.dwollaCustomerId;
                delete userProfile.accounts;
                delete userProfile.roles;
                delete userProfile.accountType;
                delete userProfile.organizationName;
                delete userProfile.CRDnumber;
                delete userProfile.userId;
                delete userProfile.socialSecurityNum;
                delete userProfile.dateOfBirth;
                return _context6.abrupt('return', _this7.save(userProfile));

              case 15:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    }
  }),
  components: {
    datePicker: __WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker___default.a,
    errors: __WEBPACK_IMPORTED_MODULE_10__components_modals_Errors___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_12__components_widgets_Spinner___default.a,
    information: __WEBPACK_IMPORTED_MODULE_11__components_modals_Information___default.a,
    accountCreation: __WEBPACK_IMPORTED_MODULE_14__components_modals_AccountCreation___default.a,
    RestrictedTwoInputs: __WEBPACK_IMPORTED_MODULE_15__components_formControls_RestrictedTwoInputs___default.a,
    question: __WEBPACK_IMPORTED_MODULE_13__components_modals_Question___default.a,
    'address-suggestion': __WEBPACK_IMPORTED_MODULE_9__components_modals_AddressSuggestion___default.a,
    'addresses-form': __WEBPACK_IMPORTED_MODULE_16__components_Addresses___default.a
  }
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_Success__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_Success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_modals_Success__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_static_logActions__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_static_emailErrorsTypes__ = __webpack_require__(131);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'embed-login',
  created: function created() {
    var _$route$query = this.$route.query,
        email = _$route$query.email,
        successMsg = _$route$query.success,
        message = _$route$query.message;

    if (successMsg === 'false') {
      this.$router.push({ name: 'ErrorAuth', query: { email: email, message: message, success: successMsg, type: __WEBPACK_IMPORTED_MODULE_7__data_static_emailErrorsTypes__["a" /* default */].CONFIRMATION_EMAIL.name } });
    }
  },
  beforeMount: function beforeMount() {
    document.title = 'Calvert Impact Capital Platform Login';
    var email = localStorage.getItem('email');
    this.setRedirectUrl(this.$route.query.redirectUrl);
    if (email) {
      this.email = email;
      this.rememberMe = true;
    }
  },
  data: function data() {
    return {
      email: '',
      emailError: '',
      password: '',
      passwordError: '',
      mfaCode: '',
      showPassword: false,
      loginError: '',
      otherErrors: '',
      rememberMe: false,
      needsMfa: false,
      submittedForm: false,
      submittedMfa: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('authentication', ['isUserIdle', 'redirectUrl']), {
    fromPasswordResetEmail: function fromPasswordResetEmail() {
      return !!this.$route.query.resetEmail;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('success', ['isSuccessModalVisible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['accountTypes', 'activeAccount', 'irAdmin', 'userTypes'])),
  components: {
    success: __WEBPACK_IMPORTED_MODULE_4__components_modals_Success___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('app', {
    setUser: __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["a" /* SET_USER */],
    setAccountStatus: __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["b" /* SET_ACCOUNT_STATUS */],
    setActiveAccountId: __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["f" /* SET_ACTIVE_ACCOUNT_ID */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('user', {
    setNewUserEmail: __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["J" /* SET_NEW_USER_EMAIL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('authentication', {
    setRedirectUrl: __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["K" /* SET_REDIRECT_URL */],
    setIdleOff: __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["L" /* SET_IDLE_OFF */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('app', ['getStaticInformation']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('authentication', ['logIn', 'handleMfa']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('accountCreation', ['getUserProfile']), {
    handleRememberMe: function handleRememberMe() {
      this.rememberMe = !this.rememberMe;
    },
    handleRedirection: function handleRedirection() {
      var urlEndpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var URL = window.origin + '/#/' + urlEndpoint;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["M" /* postMessageSuccessEmbedLogin */])(URL);
    },
    backToLogin: function backToLogin() {
      this.needsMfa = false;
      this.submittedForm = false;
      this.submittedMfa = false;
      this.otherErrors = '';
      this.mfaCode = '';
    },
    resetValidations: function resetValidations() {
      this.emailError = '';
      this.passwordError = '';
      this.otherErrors = '';
    },
    validateAndSubmitLogin: function validateAndSubmitLogin() {
      var _this = this;

      this.submittedForm = true;
      this.resetValidations();
      this.setIdleOff();
      if (!this.validateEmail(this.email) || !this.validatePassword(this.password)) {
        return false;
      }
      var email = this.email,
          password = this.password;

      return this.logIn({ email: email, password: password }).then(function (response) {
        if (response && response.needsMfa) {
          _this.needsMfa = response.needsMfa;
          return;
        }
        _this.continueLogin(email);
      }).catch(function (error) {
        _this.submittedForm = false;
        _this.otherErrors = error.description;
      });
    },
    validateMfaAndSubmitLogin: function validateMfaAndSubmitLogin() {
      var _this2 = this;

      this.submittedMfa = true;
      var mfaCode = this.mfaCode;

      if (mfaCode) {
        this.handleMfa({ mfaCode: mfaCode }).then(function () {
          _this2.continueLogin(_this2.email);
        }).catch(function (error) {
          _this2.submittedMfa = false;
          _this2.otherErrors = error.error_description.replace('binding_code', 'code').replace('mfa_token', 'Code');
        });
      }
    },
    continueLogin: function continueLogin(email) {
      var _this3 = this;

      var emailToSave = this.rememberMe ? this.email : '';
      var originPath = window.location.origin + '/#';
      localStorage.setItem('email', emailToSave);
      this.getUserProfile().then(function (user) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["m" /* logAction */])({
          user: user.userId,
          level: 'info',
          action: __WEBPACK_IMPORTED_MODULE_6__data_static_logActions__["a" /* default */].LOGIN.name,
          message: 'User logged in ' + user.userId + ' ' + email,
          tags: [__WEBPACK_IMPORTED_MODULE_5__util__["x" /* logglyTags */].auth0]
        });
        _this3.setUser(user);
        _this3.checkForAccountStatus(user);
        if (user.roles.includes('IR_ADMIN')) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["M" /* postMessageSuccessEmbedLogin */])(originPath + '/users');
        } else {
          if (_this3.redirectUrl && _this3.redirectUrl.includes('funding-sources')) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["M" /* postMessageSuccessEmbedLogin */])(originPath + '/funding-sources');
            return;
          }
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["M" /* postMessageSuccessEmbedLogin */])(originPath + '/account-summary');
        }
        window.dataLayer.push({
          event: 'login',
          userID: user.userId || 'new_user:' + _this3.email
        });
        _this3.setNewUserEmail(_this3.email);
        _this3.submittedForm = false;
        _this3.submittedMfa = false;
      });
    },
    checkForAccountStatus: function checkForAccountStatus(userInformation) {
      var account = {};
      var doesUserHaveAccounts = false;

      if (userInformation.accounts && userInformation.accounts.length) {
        doesUserHaveAccounts = true;
      }

      if (doesUserHaveAccounts) {
        account = userInformation.accounts.find(function (a) {
          return a.id === userInformation.defaultAccountId;
        });
      }
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(account)) {
        account = {
          accountName: userInformation.firstName + ' ' + userInformation.lastName,
          id: 0,
          accountType: userInformation.userType,
          status: undefined
        };
        if (account.accountType !== 'ADMIN') {
          account.accountType = 'INDIVIDUAL';
        }
      }

      this.setActiveAccountId(account);
      this.setAccountStatus(account.status);
    },
    validateEmail: function validateEmail(email) {
      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
      if (!regex.test(email)) {
        this.emailError = 'Please, enter a valid email';
        return false;
      }
      return true;
    },
    validatePassword: function validatePassword(password) {
      if (password.length < 1) {
        this.passwordError = 'Please enter a password';
        return false;
      }
      return true;
    }
  })
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_static_emailErrorsTypes__ = __webpack_require__(131);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ErrorAuth',
  data: function data() {
    return {
      errorDescription: '',
      resetPassword: false,
      emailConfirmation: false,
      email: '',
      sentEmailConfirmation: false
    };
  },
  mounted: function mounted() {
    /* eslint-disable camelcase */
    var _$route$query = this.$route.query,
        error_description = _$route$query.error_description,
        type = _$route$query.type,
        message = _$route$query.message,
        email = _$route$query.email;

    this.errorDescription = error_description || message || '';
    this.email = email || '';
    this.emailConfirmation = type === __WEBPACK_IMPORTED_MODULE_2__data_static_emailErrorsTypes__["a" /* default */].CONFIRMATION_EMAIL.name;
    this.resetPassword = type === __WEBPACK_IMPORTED_MODULE_2__data_static_emailErrorsTypes__["a" /* default */].RESET_PASSWORD.name || !this.emailConfirmation && this.errorDescription.includes('Access expired');
  },

  methods: {
    goToResetPassword: function goToResetPassword() {
      this.$router.push({ name: 'ResetPassword', query: { email: encodeURIComponent(this.email), resetEmail: true } });
    },
    resendEmailVerification: function resendEmailVerification() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$cognitoAuth.resendConfirmationCode(_this.email);

              case 2:
                _this.sentEmailConfirmation = true;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_formControls_RestrictedTextArea__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_formControls_RestrictedTextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_formControls_RestrictedTextArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Breadcrumb__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_static_userTypes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_mutation_types__ = __webpack_require__(8);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FailTransaction',
  components: {
    spinner: __WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_5__components_Breadcrumb___default.a,
    'restricted-textarea': __WEBPACK_IMPORTED_MODULE_4__components_formControls_RestrictedTextArea___default.a,
    question: __WEBPACK_IMPORTED_MODULE_6__components_modals_Question___default.a
  },
  mounted: function mounted() {
    this.setParams();
    this.loadTransaction();
  },
  data: function data() {
    return {
      name: '',
      userId: '',
      initialComment: '',
      noteId: '',
      transactionId: '',
      transaction: {
        comment: '',
        note: {
          account: { users: [] }
        }
      },
      breadcrumbData: [],
      loading: false
    };
  },

  watch: {
    transaction: function onChangeTransaction(newTransaction) {
      var _newTransaction$note$ = newTransaction.note.account,
          accountName = _newTransaction$note$.accountName,
          accountType = _newTransaction$note$.accountType,
          accountId = _newTransaction$note$.id,
          users = _newTransaction$note$.users;

      this.breadcrumbData = [];
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
        title: 'Search',
        goto: { name: 'Users' },
        selected: false
      }));
      var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$route.params);
      var user = users.find(function (search) {
        return search.id === Number(params.userId);
      });
      var userType = user.userType,
          firstName = user.firstName,
          lastName = user.lastName;

      var goto = void 0;
      if (userType === __WEBPACK_IMPORTED_MODULE_9__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name) {
        goto = {
          name: 'EditFinancialAdvisor',
          params: {
            name: params.name,
            userId: params.userId
          }
        };
      } else {
        goto = {
          name: 'UserDetail',
          params: { name: params.name, userId: params.userId }
        };
      }
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
        goto: goto,
        title: firstName.concat(' ', lastName),
        selected: false
      }));
      var accountTypeProperties = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["n" /* getAccounTypeProperties */])(accountType);
      var gotoAccount = {
        name: accountTypeProperties.component,
        params: {
          accountId: accountId,
          name: params.name,
          userId: params.userId
        }
      };
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
        title: accountName,
        goto: gotoAccount,
        selected: false
      }));
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
        title: 'Note'.concat(' ', newTransaction.note.noteId),
        goto: { name: 'NoteDetail', params: this.$route.params },
        selected: false
      }));
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, {
        title: 'Fail Transaction ' + newTransaction.transactionId,
        goto: { name: this.$route.name, params: this.$route.params },
        selected: true
      }));
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])('question', ['display']), {
    disableApprove: function disableApprove() {
      return this.transaction.hasPendingFailureApproval !== true || this.isButtonDisabled;
    },
    disableSubmit: function disableSubmit() {
      return this.hasCommentChanged || this.transaction.hasPendingFailureApproval === true;
    },
    disableCancel: function disableCancel() {
      return (this.transaction.hasPendingFailureApproval === null || this.transaction.hasPendingFailureApproval === true) && this.isButtonDisabled;
    },
    isButtonDisabled: function isButtonDisabled() {
      return this.hasCommentChanged;
    },
    hasCommentChanged: function hasCommentChanged() {
      return !this.transaction.comment || this.initialComment === this.transaction.comment;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])('transaction', ['getTransaction', 'markTransactionAsFailed']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_10__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_10__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_10__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_10__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), {
    fields: function fields() {
      return [{
        text: 'Note Id',
        accessor: 'note.noteId'
      }, {
        text: 'Transaction Id',
        accessor: 'transactionId'
      }, {
        text: 'Amount',
        accessor: 'amount'
      }];
    },
    getValue: function getValue() {
      var accessor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.transaction, accessor);
    },
    commentUpdated: function commentUpdated($event) {
      this.transaction.comment = $event;
    },
    loadTransaction: function loadTransaction() {
      var _this = this;

      this.loading = true;
      this.getTransaction(this.transactionId).then(function (transaction) {
        _this.transaction = transaction;
        _this.initialComment = transaction.comment;
        _this.transaction.comment = transaction.comment || '';
        _this.transaction.amount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["r" /* formatNegativeAmount */])(transaction.amount);
        _this.loading = false;
      });
    },
    setParams: function setParams() {
      this.name = this.$route.params.name;
      this.userId = this.$route.params.userId;
      this.noteId = this.$route.params.noteId;
      this.transactionId = this.$route.params.transactionId;
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    showConfirmationModal: function showConfirmationModal() {
      var _this2 = this;

      this.showQuestionModal({
        title: 'Cancel Request to Mark transaction as failed',
        question: 'Are you sure you want to cancel the request to mark T' + this.transaction.id + ' as failed?',
        method: function method() {
          _this2.submitRequest(true);
        },
        yesButtonText: 'Yes',
        hideCancelButton: false
      });
    },
    handleCancelRequest: function handleCancelRequest() {
      if (this.transaction.hasPendingFailureApproval === null) {
        this.goBack();
      } else {
        this.showConfirmationModal();
      }
    },
    submitRequest: function submitRequest() {
      var _this3 = this;

      var cancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _transaction = this.transaction,
          id = _transaction.id,
          comment = _transaction.comment;

      this.markTransactionAsFailed({ id: id, comment: comment, cancel: cancel }).then(function () {
        _this3.hideQuestionModal();
        _this3.$router.push({
          name: 'NoteDetail',
          params: {
            name: _this3.name,
            noteId: _this3.noteId,
            userId: _this3.userId
          }
        });
      }).catch(function () {
        var errors = [];
        if (_this3.transaction.hasPendingFailureApproval === null) {
          errors.push('Something went wrong while trying to request marking T' + id + ' as failed');
        } else {
          errors.push('Something went wrong while trying to approve mark T' + id + ' as failed');
        }
        _this3.setErrorsModalInfo(errors);
        _this3.showErrorsModal();
      });
    },
    approveFailTransaction: function approveFailTransaction() {
      this.submitRequest();
    }
  })
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_formControls_RestrictedTextArea__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_formControls_RestrictedTextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_formControls_RestrictedTextArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_static_transactionTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_static_constants__ = __webpack_require__(16);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_9__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_9__util__["c" /* formatAmount */],
    formatTerm: __WEBPACK_IMPORTED_MODULE_9__util__["o" /* formatTerm */],
    formatType: __WEBPACK_IMPORTED_MODULE_9__util__["d" /* formatType */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'failedTransactionDetail',
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setParams();
              _context.next = 3;
              return _this.loadTransactionDetail();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      transactionId: '',
      lostSuccess: false,
      lostCommentSuccess: false,
      previousLostComment: '',
      successMessage: '',
      account: '',
      note: {
        interestRate: 0
      },
      transaction: {
        noteId: '',
        amount: 0,
        dwollaTransferId: '',
        status: '',
        failureReason: '',
        createdAt: '',
        updatedAt: '',
        comment: ''
      },
      user: {
        name: ''
      }
    };
  },

  mixins: [mix],
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('transaction', ['disableSubmitDetailTransaction']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('authentication', ['states']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('question', ['display']), {
    failableTransactions: function failableTransactions() {
      return [__WEBPACK_IMPORTED_MODULE_12__data_static_transactionTypes__["a" /* default */].PAID_INT, __WEBPACK_IMPORTED_MODULE_12__data_static_transactionTypes__["a" /* default */].REPAID_ACCT, __WEBPACK_IMPORTED_MODULE_12__data_static_transactionTypes__["a" /* default */].REPAID_ACCT_FULL, __WEBPACK_IMPORTED_MODULE_12__data_static_transactionTypes__["a" /* default */].REPAID_ACCT_PARTIAL];
    },
    canTransactionBeRetriedWithDwollaOrLob: function canTransactionBeRetriedWithDwollaOrLob() {
      return this.failableTransactions.includes(this.transaction.type);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('transaction', ['getTransaction', 'retryTransaction', 'saveLostComment', 'lostTransaction', 'setTransactionAsProcessed', 'updateTransaction']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('note', ['getNote']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('account', ['getAccount']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('accountCreation', ['getUserDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('transaction', {
    disableSubmitDetailTransactionMutation: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["l" /* DISABLE_SUBMIT_DETAIL_TRANSACTION */],
    enableSubmitDetailTransactionMutation: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["m" /* ENABLE_SUBMIT_DETAIL_TRANSACTION */]
  }), {
    setParams: function setParams() {
      this.transactionId = this.$route.params.id;
    },
    commentUpdated: function commentUpdated($event) {
      this.transaction.comment = $event;
    },
    loadTransactionDetail: function loadTransactionDetail() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var transaction, note, account, user;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.disableSubmitDetailTransactionMutation();
                _context2.next = 4;
                return _this2.getTransaction(_this2.transactionId);

              case 4:
                transaction = _context2.sent;
                _context2.next = 7;
                return _this2.getNote(transaction.noteId);

              case 7:
                note = _context2.sent;
                _context2.next = 10;
                return _this2.getAccount(note.accountId);

              case 10:
                account = _context2.sent;
                _context2.next = 13;
                return _this2.getUserDetail(account.primaryInvestorId);

              case 13:
                user = _context2.sent;

                _this2.transaction = transaction;
                _this2.note = note;
                _this2.account = account;
                _this2.user = user;
                _this2.transaction.transactionDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(_this2.transaction.createdAt);
                _this2.transaction.lastUpdatedDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(_this2.transaction.updatedAt);
                _this2.enableSubmitDetailTransactionMutation();
                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(true));

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2['catch'](0);

                if (_context2.t0 !== 'UNAUTHORIZED') {
                  _this2.setErrorsModalInfo(['Something went wrong retrieving the transaction detail. Please try again.']);
                  _this2.showErrorsModal();
                }
                _this2.enableSubmitDetailTransactionMutation();
                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(false));

              case 29:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 24]]);
      }))();
    },
    submitRetryTransaction: function submitRetryTransaction() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (!_this3.canTransactionBeRetriedWithDwollaOrLob) {
                  _context3.next = 5;
                  break;
                }

                _this3.goToRetryTransactionManually();
                _context3.next = 8;
                break;

              case 5:
                _context3.next = 7;
                return _this3.retryTransaction(_this3.transactionId);

              case 7:
                _this3.$router.push({ name: 'FailedTransactionList' });

              case 8:
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);

                _this3.$router.push({ name: 'FailedTransactionList' });

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 10]]);
      }))();
    },
    goToRetryTransactionManually: function goToRetryTransactionManually() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.$router.push({
                  name: 'RetryFailedTransaction',
                  params: {
                    transaction: _this4.transaction,
                    account: _this4.account
                  }
                });

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    submitSaveLostComment: function submitSaveLostComment() {
      var _this5 = this;

      this.saveLostComment({ id: this.transactionId, comment: this.transaction.comment }).then(function () {
        _this5.lostSuccess = false;
        _this5.lostCommentSuccess = true;
      });
    },
    getCorrespondingMessageLostAction: function getCorrespondingMessageLostAction(lostTransaction) {
      return !lostTransaction ? __WEBPACK_IMPORTED_MODULE_13__data_static_constants__["a" /* Constants */].failedTransactiondetail.markAsLostMessage : __WEBPACK_IMPORTED_MODULE_13__data_static_constants__["a" /* Constants */].failedTransactiondetail.markAsUnlostMessage;
    },
    getCorrespondingSuccessMessageLostAction: function getCorrespondingSuccessMessageLostAction(lostTransaction) {
      return lostTransaction ? __WEBPACK_IMPORTED_MODULE_13__data_static_constants__["a" /* Constants */].failedTransactiondetail.flaggedAsLostSuccessMessage : __WEBPACK_IMPORTED_MODULE_13__data_static_constants__["a" /* Constants */].failedTransactiondetail.flaggedAsUnlostSuccessMessage;
    },
    getMethodToRequestTheProcessingOfTransaction: function getMethodToRequestTheProcessingOfTransaction() {
      var _this6 = this;

      var method = function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return _this6.updateTransaction({ transactionId: _this6.transaction.id,
                    payload: {
                      comment: _this6.transaction.comment
                    }
                  });

                case 2:
                  _context5.next = 4;
                  return _this6.setTransactionAsProcessed({ transactionId: _this6.transaction.id }).then(function () {
                    _this6.hideQuestionModal();
                    _this6.$router.push({ name: 'FailedTransactionList' });
                  }).catch(function () {
                    _this6.hideQuestionModal();
                    _this6.setErrorsModalInfo(['Something went wrong. Please try again.']);
                    _this6.showErrorsModal();
                  });

                case 4:
                case 'end':
                  return _context5.stop();
              }
            }
          }, _callee5, _this6);
        }));

        return function method() {
          return _ref.apply(this, arguments);
        };
      }();

      return method;
    },
    openModalToAskForProcessing: function openModalToAskForProcessing() {
      this.showQuestionModal({
        title: 'Set transaction as processed',
        question: 'Are you sure that you have processed this transaction manually?\n        Once you confirm, you will not see\n        this transaction on the Cancelled / Failed view any more.',
        method: this.getMethodToRequestTheProcessingOfTransaction(),
        yesButtonText: 'Confirm',
        hideCancelButton: false
      });
    },
    showLostConfirmationModal: function showLostConfirmationModal() {
      var _this7 = this;

      this.showQuestionModal({
        title: !this.transaction.lost ? 'Lost' : 'Unlost',
        question: this.getCorrespondingMessageLostAction(this.transaction.lost),
        method: function () {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
            var transaction;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.prev = 0;
                    _context6.next = 3;
                    return _this7.updateTransaction({ transactionId: _this7.transaction.id,
                      payload: {
                        comment: _this7.transaction.comment
                      }
                    });

                  case 3:
                    _context6.next = 5;
                    return _this7.lostTransaction({ transactionId: _this7.transaction.id });

                  case 5:
                    _context6.next = 7;
                    return _this7.getTransaction(_this7.transactionId);

                  case 7:
                    transaction = _context6.sent;

                    _this7.transaction = transaction;
                    _this7.successMessage = _this7.getCorrespondingSuccessMessageLostAction(transaction.lost);
                    _this7.previousLostComment = _this7.transaction.comment;
                    _this7.hideQuestionModal();
                    _this7.lostSuccess = true;
                    _this7.lostCommentSuccess = true;
                    _context6.next = 19;
                    break;

                  case 16:
                    _context6.prev = 16;
                    _context6.t0 = _context6['catch'](0);

                    _this7.hideQuestionModal();

                  case 19:
                  case 'end':
                    return _context6.stop();
                }
              }
            }, _callee6, _this7, [[0, 16]]);
          }));

          return function method() {
            return _ref2.apply(this, arguments);
          };
        }(),
        yesButtonText: __WEBPACK_IMPORTED_MODULE_13__data_static_constants__["a" /* Constants */].purchaseNote.modalYesButtonText,
        hideCancelButton: false
      });
    },
    shouldUserNotBeAllowedToRetry: function shouldUserNotBeAllowedToRetry() {
      return this.disableSubmitDetailTransaction || this.transaction.lost || !this.canTransactionBeRetriedWithDwollaOrLob && this.transaction.type !== __WEBPACK_IMPORTED_MODULE_12__data_static_transactionTypes__["a" /* default */].FUNDING && this.transaction.type !== __WEBPACK_IMPORTED_MODULE_12__data_static_transactionTypes__["a" /* default */].PURCHASE_NOTE;
    },
    goBack: function goBack() {
      this.$router.push({ name: 'FailedTransactionList' });
    }
  }),
  components: {
    'restricted-textarea': __WEBPACK_IMPORTED_MODULE_8__components_formControls_RestrictedTextArea___default.a,
    errors: __WEBPACK_IMPORTED_MODULE_7__components_modals_Errors___default.a,
    question: __WEBPACK_IMPORTED_MODULE_6__components_modals_Question___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_10__components_widgets_Spinner___default.a
  }
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_TabsComponent_Tabs__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_TabsComponent_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_TabsComponent_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TabsComponent_Tab__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TabsComponent_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_TabsComponent_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_FailedTransactionTabView__ = __webpack_require__(2044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_FailedTransactionTabView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_FailedTransactionTabView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_mutation_types__ = __webpack_require__(8);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'failedTransactionList',
  beforeMount: function beforeMount() {
    var _this = this;

    this.getUserProfile().then(function (user) {
      _this.setUser(user);
    });
    this.loadTransactionsList();
  },

  components: {
    spinner: __WEBPACK_IMPORTED_MODULE_10__components_widgets_Spinner___default.a,
    errors: __WEBPACK_IMPORTED_MODULE_8__components_modals_Errors___default.a,
    tabs: __WEBPACK_IMPORTED_MODULE_6__components_TabsComponent_Tabs___default.a,
    tab: __WEBPACK_IMPORTED_MODULE_7__components_TabsComponent_Tab___default.a,
    question: __WEBPACK_IMPORTED_MODULE_9__components_modals_Question___default.a,
    FailedTransactionTabView: __WEBPACK_IMPORTED_MODULE_11__components_FailedTransactionTabView___default.a
  },
  data: function data() {
    return {
      transactions: [],
      archivedTransactions: [],
      transactionError: '',
      loading: false,
      emptyTransactionsMessage: 'There are no cancelled or failed transactions at the moment.',
      emptyArchivedTransactionsMessage: 'There are no archived transactions at the moment.'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('question', ['display'])),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('accountCreation', ['getUserProfile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('transaction', ['getFailedCancelledTransactions', 'updateTransaction']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('app', {
    setUser: __WEBPACK_IMPORTED_MODULE_12__store_mutation_types__["a" /* SET_USER */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_12__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_12__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_12__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_12__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), {
    loadTransactionsList: function loadTransactionsList() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var transactionsFailedAndCancelled, _$partition, _$partition2, transactions, archivedTransactions;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return _this2.getFailedCancelledTransactions();

              case 4:
                transactionsFailedAndCancelled = _context.sent;
                _$partition = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.partition(transactionsFailedAndCancelled, function (t) {
                  return !t.archived;
                }), _$partition2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_$partition, 2), transactions = _$partition2[0], archivedTransactions = _$partition2[1];

                _this2.transactions = transactions;
                _this2.archivedTransactions = archivedTransactions;
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](1);

                if (_context.t0 !== 'UNAUTHORIZED') {
                  _this2.setErrorsModalInfo(['We could not retrieve transactions list']);
                  _this2.showErrorsModal();
                }

              case 13:
                _context.prev = 13;

                _this2.loading = false;
                return _context.finish(13);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 10, 13, 16]]);
      }))();
    },
    goToViewDetail: function goToViewDetail(transactionId) {
      this.$router.push({ name: 'FailedTransactionDetail', params: { id: transactionId } });
    },
    updateArchiveTransaction: function updateArchiveTransaction(transactionId) {
      var _this3 = this;

      var archived = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      return this.updateTransaction({
        transactionId: transactionId,
        payload: {
          archived: archived
        }
      }).then(function (response) {
        _this3.loadTransactionsList();
        _this3.hideQuestionModal();
        return response;
      });
    },
    archiveTransaction: function archiveTransaction(transactionId) {
      return this.updateArchiveTransaction(transactionId, true);
    },
    unarchiveTransaction: function unarchiveTransaction(transactionId) {
      return this.updateArchiveTransaction(transactionId, false);
    },
    handleArchiveTransaction: function handleArchiveTransaction(transaction) {
      var _this4 = this;

      this.showQuestionModal({
        title: 'Archive Transaction',
        question: 'Are you sure you want to archive the transaction ' + transaction.transactionId + '?',
        method: function method() {
          _this4.archiveTransaction(transaction.id);
        },
        yesButtonText: 'Confirm',
        hideCancelButton: false
      });
    },
    handleUnarchiveTransaction: function handleUnarchiveTransaction(transaction) {
      var _this5 = this;

      this.showQuestionModal({
        title: 'Unarchive Transaction',
        question: 'Are you sure you want to unarchive the transaction ' + transaction.transactionId + '?',
        method: function method() {
          _this5.unarchiveTransaction(transaction.id);
        },
        yesButtonText: 'Confirm',
        hideCancelButton: false
      });
    }
  })
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_0__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_0__util__["c" /* formatAmount */]
  }
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FailedTransactionTabView',
  props: {
    actionName: { required: true },
    emptyTransactionsMessage: { required: true },
    transactions: { required: true },
    goToViewDetail: { required: true },
    handleArchiveUnarchiveTransaction: { required: true }
  },
  mixins: [mix]
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_DismissableAlert__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_DismissableAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_widgets_DismissableAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_mutation_types__ = __webpack_require__(8);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'feedbackSurvey',
  components: {
    errors: __WEBPACK_IMPORTED_MODULE_6__components_modals_Errors___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner___default.a,
    'dismissable-alert': __WEBPACK_IMPORTED_MODULE_8__components_widgets_DismissableAlert___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      score: null,
      reason: '',
      hasProvidedFeedback: false,
      lastFeedbackAt: null,
      showPreviousFeedbackMessage: true,
      feedbackWasSubmitted: false,
      scoreOptions: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()({ length: 11 }, function (value, index) {
        return index;
      })
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.loadStatus();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('app', ['user']), {
    canSubmit: function canSubmit() {
      return this.score !== null && !this.isLoading;
    },
    previousFeedbackMessage: function previousFeedbackMessage() {
      if (!this.lastFeedbackAt) return '';
      return 'Thanks for your feedback on ' + this.formatFeedbackDate(this.lastFeedbackAt) + '. Feel free to share more with us anytime.';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('feedback', ['getFeedbackStatus', 'submitFeedback']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_9__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_9__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('app', {
    setUser: __WEBPACK_IMPORTED_MODULE_9__store_mutation_types__["a" /* SET_USER */]
  }), {
    loadStatus: function loadStatus() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var status;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.isLoading = true;
                _context2.next = 4;
                return _this2.getFeedbackStatus();

              case 4:
                status = _context2.sent;

                _this2.hasProvidedFeedback = !!(status && status.hasProvidedFeedback);
                _this2.lastFeedbackAt = status ? status.lastFeedbackAt : null;
                _this2.showPreviousFeedbackMessage = _this2.hasProvidedFeedback;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                // A missing status should not block the survey from being shown.
                _this2.hasProvidedFeedback = false;

              case 13:
                _context2.prev = 13;

                _this2.isLoading = false;
                return _context2.finish(13);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 10, 13, 16]]);
      }))();
    },
    selectScore: function selectScore(value) {
      this.score = value;
    },
    submit: function submit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var trimmedReason, status;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.canSubmit) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                _context3.prev = 2;

                _this3.isLoading = true;
                trimmedReason = _this3.reason.trim();
                _context3.next = 7;
                return _this3.submitFeedback(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                  score: _this3.score
                }, trimmedReason ? { reason: trimmedReason } : {}));

              case 7:
                status = _context3.sent;

                _this3.hasProvidedFeedback = true;
                _this3.lastFeedbackAt = status && status.lastFeedbackAt ? status.lastFeedbackAt : new Date().toISOString();
                // Keep the cached user in sync so the sidebar Feedback indicator
                // clears immediately, without requiring a full page reload.
                if (_this3.user) {
                  _this3.setUser(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this3.user, { lastFeedbackAt: _this3.lastFeedbackAt }));
                }
                _this3.feedbackWasSubmitted = true;
                _this3.showPreviousFeedbackMessage = false;
                _this3.score = null;
                _this3.reason = '';
                _context3.next = 21;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3['catch'](2);

                _this3.setErrorsModalInfo(['Something went wrong. Please try again.']);
                _this3.showErrorsModal();

              case 21:
                _context3.prev = 21;

                _this3.isLoading = false;
                return _context3.finish(21);

              case 24:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[2, 17, 21, 24]]);
      }))();
    },
    hidePreviousFeedbackMessage: function hidePreviousFeedbackMessage() {
      this.showPreviousFeedbackMessage = false;
    },
    hideSubmittedAlert: function hideSubmittedAlert() {
      this.feedbackWasSubmitted = false;
    },
    formatFeedbackDate: function formatFeedbackDate(value) {
      var date = new Date(value);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(date.getTime())) return '';
      var month = date.toLocaleDateString('en-US', { month: 'long' });
      var day = date.getDate();
      return month + ' ' + day + this.ordinalSuffix(day) + ' ' + date.getFullYear();
    },
    ordinalSuffix: function ordinalSuffix(day) {
      if (day > 3 && day < 21) return 'th';
      switch (day % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    }
  })
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_widgets_Spinner__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      loading: false,
      isWelcomeMessageDisplayed: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['activeAccount', 'user', 'userTypes']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['hasBeenCreatedAccount'])),
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _context.next = 3;
              return _this.determineWhatToDoWithLoggedInUser();

            case 3:
              _this.loading = false;

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('home', ['getUserStatus']), {
    determineWhatToDoWithLoggedInUser: function determineWhatToDoWithLoggedInUser() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var accountId, response, status, needs;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                accountId = _this2.activeAccount.id;

                if (!_this2.shouldWelcomeMessageBeDisplayed()) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return', true);

              case 4:
                if (accountId) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return', false);

              case 6:
                _context2.next = 8;
                return _this2.getUserStatus({
                  accountId: accountId
                });

              case 8:
                response = _context2.sent;
                status = response.status, needs = response.needs;

                if (!_this2.shouldUserBeRedirectedBecauseOfStatus(status)) {
                  _context2.next = 14;
                  break;
                }

                return _context2.abrupt('return', true);

              case 14:
                if (!_this2.shouldUserBeRedirectedBecauseOfInformationNeeds(needs)) {
                  _context2.next = 16;
                  break;
                }

                return _context2.abrupt('return', true);

              case 16:
                return _context2.abrupt('return', false);

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](0);
                return _context2.abrupt('return', false);

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 19]]);
      }))();
    },
    shouldUserBeRedirectedBecauseOfInformationNeeds: function shouldUserBeRedirectedBecauseOfInformationNeeds(needs) {
      var _this3 = this;

      var needsAsString = void 0;

      if (!needs.length) {
        needsAsString = 'false';
      } else if (needs.includes('FUNDING_SOURCE')) {
        needsAsString = 'FUNDING_SOURCE';
      } else if (needs.includes('NOTE')) {
        needsAsString = 'NOTE';
      }

      var options = {
        FUNDING_SOURCE: function FUNDING_SOURCE() {
          return _this3.$router.push({ name: 'AddFundingSource' });
        },
        NOTE: function NOTE() {
          return _this3.$router.push({ name: 'PurchaseNote', query: { first: 1 } });
        },
        false: function _false() {
          return _this3.$router.push({ name: 'AccountSummary' });
        }
      };

      if (typeof options[needsAsString] === 'function') {
        options[needsAsString]();
      }

      return typeof options[needsAsString] === 'function';
    },
    shouldUserBeRedirectedBecauseOfStatus: function shouldUserBeRedirectedBecauseOfStatus(status) {
      var _this4 = this;

      if (!this.hasBeenCreatedAccount) {
        this.$router.push({ name: 'AccountSummary' });
        return true;
      }

      var options = {
        suspended: function suspended() {
          return _this4.$router.push({ name: 'AccountSuspended' });
        },
        retry: function retry() {
          return _this4.$router.push({ name: 'AccountCreation' });
        },
        document: function document() {
          return _this4.$router.push({ name: 'DocumentUpload' });
        }
      };

      if (typeof options[status] === 'function') {
        options[status]();
      }

      return typeof options[status] === 'function';
    },
    shouldWelcomeMessageBeDisplayed: function shouldWelcomeMessageBeDisplayed() {
      var userType = this.user.userType;


      this.isWelcomeMessageDisplayed = userType === this.userTypes.FINANCIAL_ADVISOR.name;

      return this.isWelcomeMessageDisplayed;
    }
  }),
  components: {
    spinner: __WEBPACK_IMPORTED_MODULE_4__components_widgets_Spinner___default.a
  }
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_HttpService__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'irAdmin',
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__api_HttpService__["a" /* default */].get('authentication/ir-admin');
  }
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'irAdminSideBar',
  data: function data() {
    return {
      userProfile: {
        fullName: '',
        accountType: ''
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('impactPreferences', ['exportImpactPreferencesReport']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('documentViews', ['exportDocumentViewsReport']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('monthlyMaturities', ['exportMonthlyMaturitiesReport']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('feedback', ['exportFeedbackReport']), {
    downloadImpactPreferencesReport: function downloadImpactPreferencesReport() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.exportImpactPreferencesReport();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    downloadMonthlyMaturitiesReport: function downloadMonthlyMaturitiesReport() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.exportMonthlyMaturitiesReport();

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    downloadDocumentViewsReport: function downloadDocumentViewsReport() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.exportDocumentViewsReport();

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    downloadFeedbackReport: function downloadFeedbackReport() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.exportFeedbackReport();

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['user']))
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_static_accountTypes__ = __webpack_require__(174);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var mix = {
  methods: {
    getUserTypeLabel: __WEBPACK_IMPORTED_MODULE_7__util__["w" /* getUserTypeLabel */]
  }
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InvestorAccountDetails',
  mixins: [mix],
  data: function data() {
    return {
      representatives: [],
      isLoading: true,
      accountPrimaryInvestorId: 0,
      accountId: '',
      mainAddress: {},
      mailingAddress: {},
      phoneNumber: '',
      organizationName: '',
      alternateCompanyName: '',
      crdNumber: '',
      beneficiaries: []
    };
  },
  beforeMount: function beforeMount() {
    this.getAccountDetails();
    this.getAccountBeneficiariesDetails();
  },

  components: {
    spinner: __WEBPACK_IMPORTED_MODULE_8__components_widgets_Spinner___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('account', ['getAccountUsers', 'getAccount', 'getAccountOrganizations', 'getAccountBeneficiaries']), {
    getAccountDetails: function getAccountDetails() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, _ref2, accountUsersRepresentatives, account, accountOrganizations, accountOrganization;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this.getAccountUsers(_this.activeAccountId), _this.getAccount(_this.activeAccountId), _this.getAccountOrganizations(_this.activeAccountId)]);

              case 3:
                _ref = _context.sent;
                _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 3);
                accountUsersRepresentatives = _ref2[0];
                account = _ref2[1];
                accountOrganizations = _ref2[2];


                _this.accountPrimaryInvestorId = account.primaryInvestorId;
                _this.representatives = _this.sortRepresentatives(accountUsersRepresentatives);
                _this.accountId = account.accountId;
                if ((_this.isInstitution || _this.isTrust) && accountOrganizations.length) {
                  accountOrganization = accountOrganizations[0];

                  _this.mainAddress = accountOrganization.mainAddress;
                  _this.mailingAddress = accountOrganization.mailingAddress;
                  _this.phoneNumber = accountOrganization.phoneNumber;
                }
                if (_this.isAdvisor) {
                  _this.organizationName = account.organizationName;
                  _this.alternateCompanyName = account.alternateCompanyName;
                  _this.crdNumber = account.CRDnumber;
                }
                _this.isLoading = false;
                _context.next = 21;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](0);

                _this.setErrorsModalInfo(['We could not retrieve account details']);
                _this.showErrorsModal();
                _this.isLoading = false;

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 16]]);
      }))();
    },
    getAccountBeneficiariesDetails: function getAccountBeneficiariesDetails() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var beneficiaries;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.getAccountBeneficiaries(_this2.activeAccountId);

              case 2:
                beneficiaries = _context2.sent;

                _this2.beneficiaries = beneficiaries;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getStateFullName: function getStateFullName(abbreviation) {
      var foundState = this.geoLocation.states.find(function (state) {
        return state.abbreviation === abbreviation;
      });
      if (!foundState) {
        foundState = this.geoLocation.canadaStates.find(function (state) {
          return state.abbreviation === abbreviation;
        });
      }
      return abbreviation ? foundState.name : '';
    },
    formatPhoneNumber: function formatPhoneNumber(number) {
      return number.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    },
    getAccountImgUrl: function getAccountImgUrl(type) {
      var accountTypeIcon = '' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util__["n" /* getAccounTypeProperties */])(type).icon;
      return __webpack_require__(235)("./" + accountTypeIcon + '.svg'); // eslint-disable-line
    },
    sortRepresentatives: function sortRepresentatives() {
      var _this3 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      data.forEach(function (item, i) {
        if (item.id === _this3.accountPrimaryInvestorId) {
          data.splice(i, 1);
          data.unshift(item);
        }
      });
      return data;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('app', ['activeAccountId', 'activeAccount', 'geoLocation']), {
    isInstitution: function isInstitution() {
      return this.activeAccount.accountType === __WEBPACK_IMPORTED_MODULE_9__data_static_accountTypes__["a" /* AccountTypes */].INSTITUTION.name;
    },
    isTrust: function isTrust() {
      return this.activeAccount.accountType === __WEBPACK_IMPORTED_MODULE_9__data_static_accountTypes__["a" /* AccountTypes */].TRUST.name;
    },
    isAdvisor: function isAdvisor() {
      return this.activeAccount.accountType === __WEBPACK_IMPORTED_MODULE_9__data_static_accountTypes__["a" /* AccountTypes */].ADVISOR.name;
    },
    accountType: function accountType() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util__["J" /* capitalize */])(this.activeAccount.accountType);
    }
  })
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_DismissableAlert__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_DismissableAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_DismissableAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__ = __webpack_require__(8);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var EMAIL = 'EMAIL';
var POSTAL = 'SNAIL-MAIL';
var BOTH = 'BOTH';

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      communicationUpdated: false,
      isLoading: true,
      communicationPreference: EMAIL,
      communication1099Preference: EMAIL,
      communicationImpactReportPreference: EMAIL
    };
  },
  beforeMount: function beforeMount() {
    this.initialize();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('account', ['getAccount', 'updateAccount']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), {
    initialize: function initialize() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var account;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                _context.next = 3;
                return _this.getAccount(_this.activeAccountId);

              case 3:
                account = _context.sent;

                _this.communicationPreference = account.communicationPreference || EMAIL;
                _this.communication1099Preference = account.communication1099Preference || EMAIL;
                _this.communicationImpactReportPreference = account.communicationImpactReportPreference || EMAIL;
                _this.isLoading = false;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    persistPreferences: function persistPreferences(payload) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.isReadOnly) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.prev = 2;

                _this2.isLoading = true;
                _context2.next = 6;
                return _this2.updateAccount({
                  accountId: _this2.activeAccountId,
                  payload: payload
                });

              case 6:
                _context2.next = 8;
                return _this2.initialize();

              case 8:
                _this2.communicationUpdated = true;
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](2);

                _this2.setErrorsModalInfo(['Something went wrong. Please try again.']);
                _this2.showErrorsModal();

              case 15:
                _context2.prev = 15;

                _this2.isLoading = false;
                return _context2.finish(15);

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 11, 15, 18]]);
      }))();
    },
    setExclusivePreference: function setExclusivePreference(category, value) {
      if (this.isReadOnly) return;
      if (category === 'TRANSACTIONS') {
        if (this.communicationPreference === value) return;
        this.persistPreferences({ communicationPreference: value });
      } else if (category === 'IMPACT_REPORT') {
        if (this.communicationImpactReportPreference === value) return;
        this.persistPreferences({ communicationImpactReportPreference: value });
      }
    },
    toggle1099: function toggle1099(value) {
      if (this.isReadOnly) return;
      var next = void 0;
      if (value === EMAIL) {
        // unchecking email leaves postal; checking it adds to whatever is set
        next = this.form1099Email ? POSTAL : BOTH;
      } else {
        // unchecking postal leaves email; checking it adds to whatever is set
        next = this.form1099Postal ? EMAIL : BOTH;
      }
      this.persistPreferences({ communication1099Preference: next });
    },
    setAllToEmail: function setAllToEmail() {
      if (this.isReadOnly || this.allEmail) return;
      this.persistPreferences({
        communicationPreference: EMAIL,
        communication1099Preference: EMAIL,
        communicationImpactReportPreference: EMAIL
      });
    },
    hideCommunicationUpdatedAlert: function hideCommunicationUpdatedAlert() {
      this.communicationUpdated = false;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['activeAccountId', 'user']), {
    transactionsEmail: function transactionsEmail() {
      return this.communicationPreference === EMAIL;
    },
    transactionsPostal: function transactionsPostal() {
      return this.communicationPreference === POSTAL;
    },
    impactReportEmail: function impactReportEmail() {
      return this.communicationImpactReportPreference === EMAIL;
    },
    impactReportPostal: function impactReportPostal() {
      return this.communicationImpactReportPreference === POSTAL;
    },
    form1099Email: function form1099Email() {
      return this.communication1099Preference === EMAIL || this.communication1099Preference === BOTH;
    },
    form1099Postal: function form1099Postal() {
      return this.communication1099Preference === POSTAL || this.communication1099Preference === BOTH;
    },
    allEmail: function allEmail() {
      return this.communicationPreference === EMAIL && this.communication1099Preference === EMAIL && this.communicationImpactReportPreference === EMAIL;
    },
    isReadOnly: function isReadOnly() {
      return this.user && this.user.userType === 'READ_ONLY';
    }
  }),
  components: {
    errors: __WEBPACK_IMPORTED_MODULE_4__components_modals_Errors___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_5__components_widgets_Spinner___default.a,
    'dismissable-alert': __WEBPACK_IMPORTED_MODULE_6__components_widgets_DismissableAlert___default.a
  }
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_DismissableAlert__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_DismissableAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_DismissableAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_static_upcomingTransactionActions__ = __webpack_require__(48);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      paymentPreferenceUpdated: false,
      isLoading: false,
      paymentPreference: '',
      interestPreference: '',
      paymentPreferenceWasUpdated: false
    };
  },
  beforeMount: function beforeMount() {
    this.paymentPreference = this.activeAccount.paymentPreference;
    this.interestPreference = this.activeAccount.interestPreference;
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    hidePaymentPreferenceUpdated: function hidePaymentPreferenceUpdated() {
      this.paymentPreferenceWasUpdated = false;
    },
    updatePaymentPreferences: function updatePaymentPreferences() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.isReadOnly) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.prev = 2;

                _this.isLoading = true;
                _context.next = 6;
                return _this.updateAccountPreferences({
                  accountId: _this.activeAccountId,
                  payload: {
                    paymentPreference: _this.paymentPreference,
                    interestPreference: _this.interestPreference
                  }
                });

              case 6:
                _this.setActiveAccountId(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this.activeAccount, {
                  paymentPreference: _this.paymentPreference,
                  interestPreference: _this.interestPreference
                }));
                _this.paymentPreferenceWasUpdated = true;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](2);

                _this.setErrorsModalInfo(['Something went wrong. Please try again.']);
                _this.showErrorsModal();

              case 14:
                _context.prev = 14;

                _this.isLoading = false;
                return _context.finish(14);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 10, 14, 17]]);
      }))();
    },
    setPrincipalPreference: function setPrincipalPreference(preference) {
      this.paymentPreference = preference;
    },
    setInterestPreference: function setInterestPreference(preference) {
      this.interestPreference = preference;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('account', ['updateAccountPreferences']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('app', {
    setActiveAccountId: __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["f" /* SET_ACTIVE_ACCOUNT_ID */]
  })),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    availablePreferences: function availablePreferences() {
      var preferencesArray = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__data_static_upcomingTransactionActions__["a" /* default */]);
      return preferencesArray.sort(function (a, b) {
        return a.order - b.order;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('app', ['activeAccountId', 'activeAccount', 'user']), {
    isReadOnly: function isReadOnly() {
      return this.user && this.user.userType === 'READ_ONLY';
    }
  }),
  components: {
    errors: __WEBPACK_IMPORTED_MODULE_5__components_modals_Errors___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default.a,
    'dismissable-alert': __WEBPACK_IMPORTED_MODULE_7__components_widgets_DismissableAlert___default.a
  }
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Preferences__ = __webpack_require__(2060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Preferences___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Preferences__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SuccessAlert__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SuccessAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_SuccessAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_static_constants__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isSuccessMessageVisible: false,
      loading: true,
      successMessage: '',
      user: null
    };
  },
  beforeMount: function beforeMount() {
    this.initialize();
  },
  beforeDestroy: function beforeDestroy() {
    this.hideSuccessMessage();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('accountCreation', ['getUserProfile']), {
    initialize: function initialize() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getUserProfile().then(function (user) {
                  _this.user = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, user);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onPreferencesSaved: function onPreferencesSaved() {
      this.successMessage = __WEBPACK_IMPORTED_MODULE_8__data_static_constants__["a" /* Constants */].investorPreferences.successMessage;
      this.isSuccessMessageVisible = true;
    },
    hideSuccessMessage: function hideSuccessMessage() {
      this.isSuccessMessageVisible = false;
    },
    onPreferencesLoaded: function onPreferencesLoaded() {
      this.loading = false;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('app', ['activeAccountId'])),
  components: {
    errors: __WEBPACK_IMPORTED_MODULE_5__components_modals_Errors___default.a,
    SuccessAlert: __WEBPACK_IMPORTED_MODULE_7__components_SuccessAlert___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner___default.a,
    preferences: __WEBPACK_IMPORTED_MODULE_6__components_Preferences___default.a
  }
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_DismissableAlert__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_DismissableAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_widgets_DismissableAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_Information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_Information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_modals_Information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__(8);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'KbaVerification',
  components: {
    'dismissable-alert': __WEBPACK_IMPORTED_MODULE_4__components_widgets_DismissableAlert___default.a,
    information: __WEBPACK_IMPORTED_MODULE_5__components_modals_Information___default.a
  },
  data: function data() {
    return {
      localSessionId: null,
      timerInterval: null,
      now: Date.now(),
      selectedAnswers: {},
      submitting: false,
      successMessage: '',
      errorMessage: '',
      submissionResult: null,
      introMessage: 'In order to securely and instantly verify your identity, you will next be asked a short set of multiple-choice questions that only you should know. These are sourced from publicly available government records, and Calvert Impact Capital never sees or records these questions or answers. If you do not answer the questions correctly in 2 minutes to be instantly verified, you will be prompted to upload a color picture/scan of your government ID that will be reviewed in 1-2 business days before you can proceed.'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('kba', ['questions', 'expiresAt', 'loading', 'error', 'sessionId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('home', ['userStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['user', 'activeAccount']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('information', ['isInformationModalVisible']), {
    effectiveSessionId: function effectiveSessionId() {
      return this.localSessionId || this.sessionId;
    },
    deadlineMs: function deadlineMs() {
      return this.expiresAt ? new Date(this.expiresAt).getTime() : null;
    },
    remainingMs: function remainingMs() {
      if (!this.deadlineMs) return 0;
      var diff = this.deadlineMs - this.now;
      return diff > 0 ? diff : 0;
    },
    minutes: function minutes() {
      return Math.floor(this.remainingMs / 60000);
    },
    seconds: function seconds() {
      return Math.floor(this.remainingMs % 60000 / 1000);
    },
    formattedTime: function formattedTime() {
      var mm = String(this.minutes).padStart(2, '0');
      var ss = String(this.seconds).padStart(2, '0');
      return mm + ':' + ss;
    },
    expired: function expired() {
      return this.remainingMs <= 0 && !!this.expiresAt;
    },
    timeRemainingClass: function timeRemainingClass() {
      return '';
    },
    isComplete: function isComplete() {
      var _this = this;

      if (!this.questions.length) return false;
      return this.questions.every(function (q) {
        return _this.selectedAnswers[q.id];
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('kba', ['initiate', 'getQuestions', 'submitAnswers']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('home', ['getUserStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('information', { showInformationModal: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["d" /* SHOW_INFORMATION_MODAL */], hideInformationModal: __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["e" /* HIDE_INFORMATION_MODAL */] }), {
    beginKba: function beginKba() {
      this.hideInformationModal();
      this.start();
    },
    tick: function tick() {
      this.now = Date.now();
      if (this.expired) {
        this.clearTimer();
      }
    },
    clearTimer: function clearTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },
    start: function start() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var currentUser, customerId, sessionId, _ref, expiresAt, msg;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.successMessage = '';
                _this2.errorMessage = '';
                _this2.selectedAnswers = {};
                _this2.clearTimer();

                // Determine customerId from Vuex user
                currentUser = _this2.user || {};
                customerId = currentUser.dwollaCustomerId || currentUser.accounts && currentUser.accounts[0] && currentUser.accounts[0].dwollaCustomerId || _this2.activeAccount && _this2.activeAccount.dwollaCustomerId || null;

                if (customerId) {
                  _context.next = 10;
                  break;
                }

                _this2.errorMessage = 'Dwolla customer is not eligible for KBA at this time.';
                return _context.abrupt('return');

              case 10:
                _context.next = 12;
                return _this2.initiate({ dwollaCustomerId: customerId });

              case 12:
                sessionId = _context.sent;

                _this2.localSessionId = sessionId;
                _context.next = 16;
                return _this2.getQuestions({ sessionId: sessionId });

              case 16:
                _ref = _context.sent;
                expiresAt = _ref.expiresAt;

                if (expiresAt) {
                  _this2.now = Date.now();
                  _this2.timerInterval = setInterval(_this2.tick, 250);
                }
                _context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context['catch'](0);
                msg = _context.t0 && (_context.t0.error || _context.t0.message) || 'Failed to start KBA session.';

                _this2.errorMessage = msg;

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 21]]);
      }))();
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var answers, result, msg;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this3.isComplete || _this3.submitting || _this3.expired)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _this3.submitting = true;
                _this3.errorMessage = '';
                _context2.prev = 4;
                answers = _this3.questions.map(function (q) {
                  return {
                    questionId: String(q.id),
                    answerId: String(_this3.selectedAnswers[q.id])
                  };
                });
                _context2.next = 8;
                return _this3.submitAnswers({ sessionId: _this3.effectiveSessionId, answers: answers });

              case 8:
                result = _context2.sent;

                _this3.submissionResult = result || {};
                _this3.clearTimer();
                _this3.$router.push({ name: 'AccountSummary' });
                return _context2.abrupt('return');

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](4);
                msg = _context2.t0 && (_context2.t0.error || _context2.t0.message) || 'Failed to submit answers.';

                _this3.errorMessage = msg;

              case 19:
                _context2.prev = 19;

                _this3.submitting = false;
                return _context2.finish(19);

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[4, 15, 19, 22]]);
      }))();
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var status;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              if (!(!_this4.activeAccount || !_this4.activeAccount.id)) {
                _context3.next = 4;
                break;
              }

              // If we cannot determine account, show the intro and let user start manually
              _this4.showInformationModal(_this4.introMessage);
              return _context3.abrupt('return');

            case 4:
              _context3.next = 6;
              return _this4.getUserStatus({ accountId: _this4.activeAccount.id });

            case 6:
              status = _context3.sent;

              if (!((status && status.status) !== 'kba')) {
                _context3.next = 10;
                break;
              }

              _this4.$router.push({ name: 'AccountSummary' });
              return _context3.abrupt('return');

            case 10:
              // Do not auto-start; show intro modal and start only when the user clicks the button
              _this4.showInformationModal(_this4.introMessage);
              _context3.next = 16;
              break;

            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3['catch'](0);

              _this4.errorMessage = _context3.t0 && (_context3.t0.error || _context3.t0.message) || 'Unable to load status.';

            case 16:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this4, [[0, 13]]);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.clearTimer();
  }
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_Success__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_Success___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modals_Success__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ContactUsHeader__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ContactUsHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ContactUsHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_static_logActions__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_static_emailErrorsTypes__ = __webpack_require__(131);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  created: function created() {
    var _$route$query = this.$route.query,
        email = _$route$query.email,
        successMsg = _$route$query.success,
        message = _$route$query.message;

    if (email) {
      this.email = email;
    }
    if (successMsg === false) {
      this.$router.push({ name: 'ErrorAuth', query: { email: email, message: message, success: successMsg, type: __WEBPACK_IMPORTED_MODULE_11__data_static_emailErrorsTypes__["a" /* default */].CONFIRMATION_EMAIL.name } });
    }
  },
  beforeMount: function beforeMount() {
    var email = localStorage.getItem('email');
    this.setRedirectUrl(this.$route.query.redirectUrl);
    if (email) {
      this.email = email;
      this.rememberMe = true;
    }
  },
  data: function data() {
    return {
      // Form fields
      email: '',
      emailError: '',
      password: '',
      passwordError: '',
      mfaCode: '',
      showPassword: false,
      loginError: '',
      otherErrors: '',
      rememberMe: false,

      // MFA flow state
      loginStep: 'login', // 'login' | 'method' | 'code'
      needsMfa: false,
      mfaOptions: null,
      selectedMethod: 'EMAIL',
      initialMethodUsed: null, // Track which method was used when first code was sent
      sentTo: '',

      // Loading states
      submittedForm: false,
      submittedMfa: false,
      loadingMfaOptions: false,

      // Other
      migrationNeeded: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('authentication', ['isUserIdle', 'redirectUrl']), {
    fromPasswordResetEmail: function fromPasswordResetEmail() {
      return !!this.$route.query.resetEmail;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('success', ['isSuccessModalVisible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['accountTypes', 'activeAccount', 'irAdmin', 'userTypes', 'loadingRedirection']), {
    computedEmail: {
      get: function get() {
        return this.email;
      },
      set: function set(value) {
        this.email = value.toLowerCase();
      }
    }
  }),
  components: {
    success: __WEBPACK_IMPORTED_MODULE_6__components_modals_Success___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner___default.a,
    ContactUsHeader: __WEBPACK_IMPORTED_MODULE_8__components_ContactUsHeader___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('app', {
    setUser: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["a" /* SET_USER */],
    setAccountStatus: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["b" /* SET_ACCOUNT_STATUS */],
    setActiveAccountId: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["f" /* SET_ACTIVE_ACCOUNT_ID */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('user', {
    setNewUserEmail: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["J" /* SET_NEW_USER_EMAIL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('authentication', {
    setRedirectUrl: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["K" /* SET_REDIRECT_URL */],
    setIdleOff: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["L" /* SET_IDLE_OFF */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('app', ['getStaticInformation']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('authentication', ['logIn', 'handleMfa', 'legacyLogin', 'verifyMigration']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('accountCreation', ['getUserProfile']), {
    backToLogin: function backToLogin() {
      this.loginStep = 'login';
      this.needsMfa = false;
      this.submittedForm = false;
      this.submittedMfa = false;
      this.otherErrors = '';
      this.mfaCode = '';
      this.mfaOptions = null;
      this.selectedMethod = 'EMAIL';
      this.initialMethodUsed = null;
      this.sentTo = '';
      this.password = '';
    },
    backToMethodSelection: function backToMethodSelection() {
      this.loginStep = 'method';
      this.mfaCode = '';
      this.otherErrors = '';
      this.submittedMfa = false;
    },
    resetValidations: function resetValidations() {
      this.emailError = '';
      this.passwordError = '';
      this.otherErrors = '';
    },
    handleLoginSubmit: function handleLoginSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, options, prefersEmailOnly, hasBothMethods, methodToUse, sendResult, _sendResult;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.submittedForm = true;
                _this.resetValidations();

                if (!(!_this.validateEmail(_this.email) || !_this.validatePassword(_this.password))) {
                  _context.next = 5;
                  break;
                }

                _this.submittedForm = false;
                return _context.abrupt('return');

              case 5:
                _context.prev = 5;
                _context.next = 8;
                return _this.$cognitoAuth.login(_this.email.toLowerCase(), _this.password, 'DEFER');

              case 8:
                result = _context.sent;

                if (!(result.status === 'SUCCESS')) {
                  _context.next = 14;
                  break;
                }

                // No MFA required - login directly
                _this.continueLogin(_this.email);
                _this.submittedForm = false;
                _context.next = 63;
                break;

              case 14:
                if (!(result.status === 'NEEDS_MFA')) {
                  _context.next = 63;
                  break;
                }

                // MFA required - get options and proceed with MFA flow
                _this.loadingMfaOptions = true;

                _context.prev = 16;
                _context.next = 19;
                return _this.$http.getMfaOptions(_this.email.toLowerCase());

              case 19:
                options = _context.sent;

                _this.mfaOptions = options;

                // DEFER mode: no code was sent yet, user will choose method
                _this.initialMethodUsed = null;

                // If user has NONE preference, skip SMS and use email only
                prefersEmailOnly = options.mfaPhonePreference === 'NONE' || !options.smsAvailable;

                // Pre-select based on user's preference (default to EMAIL)

                if (prefersEmailOnly) {
                  _this.selectedMethod = 'EMAIL';
                } else if (options.mfaPhonePreference === 'PRIMARY' || options.mfaPhonePreference === 'SECONDARY') {
                  _this.selectedMethod = 'SMS';
                } else {
                  _this.selectedMethod = 'EMAIL';
                }

                // Check if user has both methods available
                hasBothMethods = options.emailAvailable && options.smsAvailable && !prefersEmailOnly;

                if (!hasBothMethods) {
                  _context.next = 31;
                  break;
                }

                // User has both methods - show method selection (no code sent yet)
                _this.loginStep = 'method';
                _this.submittedForm = false;
                _this.loadingMfaOptions = false;
                _context.next = 45;
                break;

              case 31:
                // User has only one method - send code now via that method
                // eslint-disable-next-line no-nested-ternary
                methodToUse = prefersEmailOnly ? 'EMAIL' : options.smsAvailable ? 'SMS' : 'EMAIL';
                _context.prev = 32;
                _context.next = 35;
                return _this.$cognitoAuth.login(_this.email.toLowerCase(), _this.password, methodToUse);

              case 35:
                sendResult = _context.sent;


                if (sendResult.status === 'NEEDS_MFA') {
                  _this.selectedMethod = methodToUse;
                  _this.initialMethodUsed = methodToUse;

                  if (methodToUse === 'SMS') {
                    if (options.mfaPhonePreference === 'SECONDARY') {
                      _this.sentTo = options.secondaryPhone || options.phone;
                    } else {
                      _this.sentTo = options.phone;
                    }
                  } else {
                    _this.sentTo = options.email;
                  }

                  _this.loginStep = 'code';
                  _this.needsMfa = true;
                }
                _context.next = 43;
                break;

              case 39:
                _context.prev = 39;
                _context.t0 = _context['catch'](32);

                console.error('Error sending MFA code:', _context.t0);
                _this.otherErrors = 'Failed to send verification code';

              case 43:

                _this.submittedForm = false;
                _this.loadingMfaOptions = false;

              case 45:
                _context.next = 63;
                break;

              case 47:
                _context.prev = 47;
                _context.t1 = _context['catch'](16);

                // If MFA options API fails, default to EMAIL and send code
                _this.mfaOptions = {
                  emailAvailable: true,
                  smsAvailable: false,
                  email: _this.email.toLowerCase(),
                  phone: null
                };

                _context.prev = 50;
                _context.next = 53;
                return _this.$cognitoAuth.login(_this.email.toLowerCase(), _this.password, 'EMAIL');

              case 53:
                _sendResult = _context.sent;


                if (_sendResult.status === 'NEEDS_MFA') {
                  _this.selectedMethod = 'EMAIL';
                  _this.initialMethodUsed = 'EMAIL';
                  _this.sentTo = _this.email.toLowerCase();
                  _this.loginStep = 'code';
                  _this.needsMfa = true;
                }
                _context.next = 61;
                break;

              case 57:
                _context.prev = 57;
                _context.t2 = _context['catch'](50);

                console.error('Error sending MFA code:', _context.t2);
                _this.otherErrors = 'Failed to send verification code';

              case 61:

                _this.submittedForm = false;
                _this.loadingMfaOptions = false;

              case 63:
                _context.next = 69;
                break;

              case 65:
                _context.prev = 65;
                _context.t3 = _context['catch'](5);

                // Password validation failed - show error immediately
                if (_context.t3.code === 'NotAuthorizedException') {
                  _this.otherErrors = 'Incorrect password';
                } else {
                  _this.otherErrors = _context.t3.message || 'Login failed';
                }
                _this.submittedForm = false;

              case 69:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[5, 65], [16, 47], [32, 39], [50, 57]]);
      }))();
    },
    handleMethodSubmit: function handleMethodSubmit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.submittedForm = true;
                _this2.resetValidations();

                // Send code via selected method (DEFER mode means no code was sent yet)
                _context2.prev = 2;
                _context2.next = 5;
                return _this2.$cognitoAuth.login(_this2.email.toLowerCase(), _this2.password, _this2.selectedMethod);

              case 5:
                result = _context2.sent;


                if (result.status === 'NEEDS_MFA') {
                  // Track which method was used
                  _this2.initialMethodUsed = _this2.selectedMethod;

                  // Set destination display
                  if (_this2.selectedMethod === 'SMS') {
                    if (_this2.mfaOptions.mfaPhonePreference === 'SECONDARY') {
                      _this2.sentTo = _this2.mfaOptions.secondaryPhone || _this2.mfaOptions.phone;
                    } else {
                      _this2.sentTo = _this2.mfaOptions.phone;
                    }
                  } else {
                    _this2.sentTo = _this2.mfaOptions.email;
                  }

                  _this2.loginStep = 'code';
                  _this2.needsMfa = true;
                } else if (result.status === 'SUCCESS') {
                  // Success without MFA
                  _this2.continueLogin(_this2.email);
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](2);

                if (_context2.t0.code === 'NotAuthorizedException') {
                  _this2.otherErrors = 'Incorrect password';
                } else {
                  _this2.otherErrors = _context2.t0.message || 'Login failed';
                }

              case 12:
                _context2.prev = 12;

                _this2.submittedForm = false;
                return _context2.finish(12);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 9, 12, 15]]);
      }))();
    },
    confirmCognitoMfaCode: function confirmCognitoMfaCode() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var mfaCode;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.submittedMfa = true;
                mfaCode = _this3.mfaCode;

                if (!(!mfaCode || mfaCode.length !== 6)) {
                  _context3.next = 6;
                  break;
                }

                _this3.otherErrors = 'Please enter a valid 6-character code';
                _this3.submittedMfa = false;
                return _context3.abrupt('return');

              case 6:
                _context3.prev = 6;
                _context3.next = 9;
                return _this3.$cognitoAuth.handleMfa(mfaCode);

              case 9:
                _this3.mfaCode = '';
                _this3.submittedMfa = false;
                _this3.needsMfa = false;
                _this3.continueLogin(_this3.email);
                _context3.next = 20;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3['catch'](6);

                _this3.otherErrors = 'Invalid verification code';
                _this3.mfaCode = '';
                _this3.submittedMfa = false;

              case 20:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[6, 15]]);
      }))();
    },
    resendWithDifferentMethod: function resendWithDifferentMethod(newMethod) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.submittedMfa = true;
                _this4.otherErrors = '';
                _this4.mfaCode = '';

                _context4.prev = 3;
                _context4.next = 6;
                return _this4.$cognitoAuth.resendCode(newMethod);

              case 6:
                result = _context4.sent;


                if (result.status === 'NEEDS_MFA') {
                  _this4.selectedMethod = newMethod;
                  _this4.initialMethodUsed = newMethod;

                  // Update destination display
                  if (newMethod === 'SMS') {
                    if (_this4.mfaOptions.mfaPhonePreference === 'SECONDARY') {
                      _this4.sentTo = _this4.mfaOptions.secondaryPhone || _this4.mfaOptions.phone;
                    } else {
                      _this4.sentTo = _this4.mfaOptions.phone;
                    }
                  } else {
                    _this4.sentTo = _this4.mfaOptions.email;
                  }
                }
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](3);

                _this4.otherErrors = _context4.t0.message || 'Failed to resend code';

              case 13:
                _context4.prev = 13;

                _this4.submittedMfa = false;
                return _context4.finish(13);

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[3, 10, 13, 16]]);
      }))();
    },
    resendCurrentMethod: function resendCurrentMethod() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this5.resendWithDifferentMethod(_this5.selectedMethod);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    validateMfaAndSubmitLogin: function validateMfaAndSubmitLogin() {
      var _this6 = this;

      this.submittedMfa = true;
      var mfaCode = this.mfaCode;

      if (mfaCode) {
        this.handleMfa({ mfaCode: mfaCode }).then(function () {
          _this6.continueLogin(_this6.email);
        }).catch(function (error) {
          _this6.submittedMfa = false;
          _this6.otherErrors = error.error_description.replace('binding_code', 'code').replace('mfa_token', 'Code');
        });
      }
    },
    continueLogin: function continueLogin(email) {
      var _this7 = this;

      var emailToSave = this.rememberMe ? this.email : '';
      localStorage.setItem('email', emailToSave);
      this.getUserProfile().then(function (user) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["m" /* logAction */])({
          user: user.userId,
          level: 'info',
          action: __WEBPACK_IMPORTED_MODULE_10__data_static_logActions__["a" /* default */].LOGIN.name,
          message: 'User logged in ' + user.userId + ' ' + email,
          tags: [__WEBPACK_IMPORTED_MODULE_9__util__["x" /* logglyTags */].auth0]
        });
        _this7.setUser(user);
        _this7.completeLogin(user);
      });
    },
    completeLogin: function completeLogin(user) {
      this.checkForAccountStatus(user);
      if (this.irAdmin) {
        this.$router.push({ name: 'Users' });
      } else {
        if (this.redirectUrl && this.redirectUrl.includes('funding-sources')) {
          this.$router.push(this.redirectUrl);
          return;
        }
        this.$router.push({ name: 'AccountSummary' });
      }
      window.dataLayer.push({
        event: 'login',
        userID: user.userId || 'new_user:' + this.email
      });
      this.setNewUserEmail(this.email);
      this.submittedForm = false;
      this.submittedMfa = false;
    },
    checkForAccountStatus: function checkForAccountStatus(userInformation) {
      var account = {};
      var doesUserHaveAccounts = !!(userInformation.accounts && userInformation.accounts.length);

      if (doesUserHaveAccounts) {
        account = userInformation.accounts.find(function (a) {
          return a.id === userInformation.defaultAccountId;
        });
      }
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEmpty"])(account)) {
        account = {
          accountName: userInformation.firstName + ' ' + userInformation.lastName,
          id: 0,
          accountType: userInformation.userType,
          status: undefined
        };
        if (account.accountType !== 'ADMIN') {
          account.accountType = 'INDIVIDUAL';
        }
      }

      this.setActiveAccountId(account);
      this.setAccountStatus(account.status);
    },
    validateEmail: function validateEmail(email) {
      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
      if (!regex.test(email)) {
        this.emailError = 'Please, enter a valid email';
        return false;
      }
      return true;
    },
    validatePassword: function validatePassword(password) {
      if (password.length < 1) {
        this.passwordError = 'Please enter a password';
        return false;
      }
      return true;
    }
  })
});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Maintenance'
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MfaPhonePreferenceDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      selectedPhone: null,
      editPrimaryPhone: '',
      editSecondaryPhone: '',
      editingPrimary: false,
      editingSecondary: false,
      saving: false,
      error: ''
    };
  },

  watch: {
    visible: function visible(newVal) {
      if (newVal) {
        this.initializeData();
      }
    },

    user: {
      handler: function handler() {
        if (this.visible) {
          this.initializeData();
        }
      },

      deep: true
    },
    editPrimaryPhone: function editPrimaryPhone() {
      // Don't auto-switch if user is actively editing this field
      if (this.editingPrimary) {
        return;
      }
      // Auto-select PRIMARY if it's the only valid phone
      if (this.hasValidPrimaryPhone && !this.hasValidSecondaryPhone) {
        if (!this.selectedPhone || this.selectedPhone === 'SECONDARY') {
          this.selectedPhone = 'PRIMARY';
        }
      }
      // If primary becomes invalid and secondary is valid, switch to secondary
      // But only if user is not actively editing primary
      if (!this.hasValidPrimaryPhone && this.hasValidSecondaryPhone && this.selectedPhone === 'PRIMARY') {
        this.selectedPhone = 'SECONDARY';
      }
    },
    editSecondaryPhone: function editSecondaryPhone() {
      // Don't auto-switch if user is actively editing this field
      if (this.editingSecondary) {
        return;
      }
      // Auto-select SECONDARY if it's the only valid phone
      if (this.hasValidSecondaryPhone && !this.hasValidPrimaryPhone) {
        if (!this.selectedPhone || this.selectedPhone === 'PRIMARY') {
          this.selectedPhone = 'SECONDARY';
        }
      }
      // If secondary becomes invalid and primary is valid, switch to primary
      // But only if user is not actively editing secondary
      if (!this.hasValidSecondaryPhone && this.hasValidPrimaryPhone && this.selectedPhone === 'SECONDARY') {
        this.selectedPhone = 'PRIMARY';
      }
    }
  },
  computed: {
    hasValidPrimaryPhone: function hasValidPrimaryPhone() {
      var digits = this.getPhoneDigits(this.editPrimaryPhone);
      return digits && digits.length === 10;
    },
    hasValidSecondaryPhone: function hasValidSecondaryPhone() {
      var digits = this.getPhoneDigits(this.editSecondaryPhone);
      return digits && digits.length === 10;
    },
    displayPrimaryPhone: function displayPrimaryPhone() {
      // Show primary phone from prop or from edit field
      if (this.primaryPhone) {
        return this.primaryPhone;
      }
      if (this.hasValidPrimaryPhone) {
        return this.formatPhoneForDisplay(this.getPhoneDigits(this.editPrimaryPhone));
      }
      return null;
    },
    displaySecondaryPhone: function displaySecondaryPhone() {
      // Show secondary phone from prop or from edit field
      if (this.secondaryPhone) {
        return this.secondaryPhone;
      }
      if (this.hasValidSecondaryPhone) {
        return this.formatPhoneForDisplay(this.getPhoneDigits(this.editSecondaryPhone));
      }
      return null;
    },
    hasExistingPrimaryPhone: function hasExistingPrimaryPhone() {
      // Check if user has an existing primary phone number
      return !!(this.user && this.user.primaryPhoneNum);
    },
    hasExistingSecondaryPhone: function hasExistingSecondaryPhone() {
      // Check if user has an existing secondary phone number
      return !!(this.user && this.user.secondaryPhoneNum);
    },
    canSave: function canSave() {
      // Must have at least one valid phone (10 digits) and select a preference
      if (!this.hasValidPrimaryPhone && !this.hasValidSecondaryPhone) {
        return false;
      }

      // Must select a preference for a valid phone
      if (this.hasValidPrimaryPhone && !this.hasValidSecondaryPhone) {
        return this.selectedPhone === 'PRIMARY';
      }
      if (!this.hasValidPrimaryPhone && this.hasValidSecondaryPhone) {
        return this.selectedPhone === 'SECONDARY';
      }
      if (this.hasValidPrimaryPhone && this.hasValidSecondaryPhone) {
        return this.selectedPhone === 'PRIMARY' || this.selectedPhone === 'SECONDARY';
      }

      return false;
    }
  },
  methods: {
    initializeData: function initializeData() {
      if (!this.user) return;

      // Initialize edit fields with current values
      this.editPrimaryPhone = this.formatPhoneForDisplay(this.user.primaryPhoneNum) || '';
      this.editSecondaryPhone = this.formatPhoneForDisplay(this.user.secondaryPhoneNum) || '';

      // Reset editing states - start in edit mode if no phone exists, view mode if phone exists
      this.editingPrimary = !this.hasExistingPrimaryPhone;
      this.editingSecondary = !this.hasExistingSecondaryPhone;

      // Set initial selection based on current data
      if (this.user.mfaPhonePreference) {
        this.selectedPhone = this.user.mfaPhonePreference;
        // If current preference is set but the phone is now invalid, clear it
        if (this.user.mfaPhonePreference === 'PRIMARY' && !this.hasValidPrimaryPhone) {
          this.selectedPhone = null;
        } else if (this.user.mfaPhonePreference === 'SECONDARY' && !this.hasValidSecondaryPhone) {
          this.selectedPhone = null;
        }
      } else if (this.hasValidPrimaryPhone && !this.hasValidSecondaryPhone) {
        // Auto-select PRIMARY if it's the only valid phone
        this.selectedPhone = 'PRIMARY';
      } else if (!this.hasValidPrimaryPhone && this.hasValidSecondaryPhone) {
        // Auto-select SECONDARY if it's the only valid phone
        this.selectedPhone = 'SECONDARY';
      } else if (this.hasValidPrimaryPhone && this.hasValidSecondaryPhone) {
        // Default to PRIMARY if both exist
        this.selectedPhone = 'PRIMARY';
      } else {
        // No valid phones
        this.selectedPhone = null;
      }
    },
    startEditingPrimary: function startEditingPrimary(event) {
      var _this = this;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
      console.log('startEditingPrimary called', this.editingPrimary);
      this.editingPrimary = true;
      this.$nextTick(function () {
        var input = _this.$el.querySelector('#editPrimaryPhone');
        if (input) {
          input.focus();
        }
      });
    },
    startEditingSecondary: function startEditingSecondary(event) {
      var _this2 = this;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
      console.log('startEditingSecondary called', this.editingSecondary);
      this.editingSecondary = true;
      this.$nextTick(function () {
        var input = _this2.$el.querySelector('#editSecondaryPhone');
        if (input) {
          input.focus();
        }
      });
    },
    stopEditingPrimary: function stopEditingPrimary() {
      // If there was an existing phone number, go back to display mode on blur
      // If adding a new number, only go back if field is empty
      if (this.hasExistingPrimaryPhone) {
        // Restore original value if user didn't make valid changes
        if (!this.hasValidPrimaryPhone) {
          this.editPrimaryPhone = this.formatPhoneForDisplay(this.user.primaryPhoneNum) || '';
        }
        this.editingPrimary = false;
      } else if (!this.editPrimaryPhone || !this.hasValidPrimaryPhone) {
        // Adding new number - only stop editing if field is empty
        // Keep editing if they're in the middle of typing
        // Only stop if field is completely empty
        if (!this.editPrimaryPhone) {
          this.editingPrimary = false;
        }
      } else {
        // Valid phone entered, can stop editing
        this.editingPrimary = false;
      }
    },
    stopEditingSecondary: function stopEditingSecondary() {
      // If there was an existing phone number, go back to display mode on blur
      // If adding a new number, only go back if field is empty
      if (this.hasExistingSecondaryPhone) {
        // Restore original value if user didn't make valid changes
        if (!this.hasValidSecondaryPhone) {
          this.editSecondaryPhone = this.formatPhoneForDisplay(this.user.secondaryPhoneNum) || '';
        }
        this.editingSecondary = false;
      } else if (!this.editSecondaryPhone || !this.hasValidSecondaryPhone) {
        // Adding new number - only stop editing if field is empty
        // Keep editing if they're in the middle of typing
        // Only stop if field is completely empty
        if (!this.editSecondaryPhone) {
          this.editingSecondary = false;
        }
      } else {
        // Valid phone entered, can stop editing
        this.editingSecondary = false;
      }
    },
    formatPhoneForDisplay: function formatPhoneForDisplay(phone) {
      if (!phone) return '';
      // Remove masking characters and format
      var digits = phone.replace(/\D/g, '');
      if (digits.length === 10) {
        return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
      }
      return phone;
    },
    getPhoneDigits: function getPhoneDigits(phone) {
      return phone ? phone.replace(/\D/g, '') : '';
    },
    handleSave: function handleSave() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var primaryDigits, secondaryDigits, userPayload, ssnDigits;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this3.canSave) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (!(!_this3.user || !_this3.user.userId)) {
                  _context.next = 5;
                  break;
                }

                _this3.error = 'User information is missing. Please try again.';
                return _context.abrupt('return');

              case 5:

                _this3.saving = true;
                _this3.error = '';

                _context.prev = 7;
                primaryDigits = _this3.getPhoneDigits(_this3.editPrimaryPhone);
                secondaryDigits = _this3.getPhoneDigits(_this3.editSecondaryPhone);

                // Validate phone numbers

                if (!(primaryDigits && primaryDigits.length !== 10)) {
                  _context.next = 14;
                  break;
                }

                _this3.error = 'Primary phone number must be 10 digits';
                _this3.saving = false;
                return _context.abrupt('return');

              case 14:
                if (!(secondaryDigits && secondaryDigits.length !== 10)) {
                  _context.next = 18;
                  break;
                }

                _this3.error = 'Secondary phone number must be 10 digits';
                _this3.saving = false;
                return _context.abrupt('return');

              case 18:

                // Build full user payload with all required fields
                // Merge phone number changes into the existing user object
                // Filter out properties that shouldn't be sent to the API
                userPayload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this3.user, {
                  mfaPhonePreference: _this3.selectedPhone,
                  primaryPhoneNum: primaryDigits || '',
                  secondaryPhoneNum: secondaryDigits || ''
                });

                // Remove properties that shouldn't be sent to the API

                delete userPayload.dwollaCustomerId;
                delete userPayload.accounts;
                delete userPayload.roles;
                delete userPayload.accountType;
                delete userPayload.organizationName;
                delete userPayload.CRDnumber;
                delete userPayload.userId;

                // Remove masked or partial SSN
                // This matches the pattern in EditUserProfile.vue cleanPayload()
                // Don't send SSN if:
                // 1. It contains 'x' (masked) OR
                // 2. It's not a valid 9-digit SSN (partial/incomplete)
                if (userPayload.socialSecurityNum) {
                  ssnDigits = userPayload.socialSecurityNum.replace(/[- ]/g, '');
                  // Remove if masked (contains x) or if not exactly 9 digits (incomplete/partial)

                  if (ssnDigits.includes('x') || ssnDigits.includes('X') || !/^\d{9}$/.test(ssnDigits)) {
                    delete userPayload.socialSecurityNum;
                  }
                }

                // Use the Vuex action which handles all required fields
                _context.next = 29;
                return _this3.$store.dispatch('userCreationByAdmin/updateUserProfile', {
                  user: userPayload,
                  provideLogin: true,
                  enableMfa: true
                });

              case 29:

                // Emit success event
                _this3.$emit('saved', {
                  mfaPhonePreference: _this3.selectedPhone,
                  primaryPhone: primaryDigits ? _this3.formatPhoneForDisplay(primaryDigits) : null,
                  secondaryPhone: secondaryDigits ? _this3.formatPhoneForDisplay(secondaryDigits) : null
                });

                _this3.handleCancel();
                _context.next = 36;
                break;

              case 33:
                _context.prev = 33;
                _context.t0 = _context['catch'](7);

                _this3.error = _context.t0.message || 'Failed to save phone preference. Please try again.';

              case 36:
                _context.prev = 36;

                _this3.saving = false;
                return _context.finish(36);

              case 39:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[7, 33, 36, 39]]);
      }))();
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
      this.error = '';
      this.initializeData();
    },
    handleEmailOnly: function handleEmailOnly() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var userPayload, ssnDigits;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this4.user || !_this4.user.userId)) {
                  _context2.next = 3;
                  break;
                }

                _this4.error = 'User information is missing. Please try again.';
                return _context2.abrupt('return');

              case 3:

                _this4.saving = true;
                _this4.error = '';

                _context2.prev = 5;

                // Build full user payload with NONE preference
                userPayload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this4.user, {
                  mfaPhonePreference: 'NONE'
                });

                // Remove properties that shouldn't be sent to the API

                delete userPayload.dwollaCustomerId;
                delete userPayload.accounts;
                delete userPayload.roles;
                delete userPayload.accountType;
                delete userPayload.organizationName;
                delete userPayload.CRDnumber;
                delete userPayload.userId;

                // Remove masked or partial SSN
                if (userPayload.socialSecurityNum) {
                  ssnDigits = userPayload.socialSecurityNum.replace(/[- ]/g, '');

                  if (ssnDigits.includes('x') || ssnDigits.includes('X') || !/^\d{9}$/.test(ssnDigits)) {
                    delete userPayload.socialSecurityNum;
                  }
                }

                // Use the Vuex action which handles all required fields
                _context2.next = 17;
                return _this4.$store.dispatch('userCreationByAdmin/updateUserProfile', {
                  user: userPayload,
                  provideLogin: true,
                  enableMfa: true
                });

              case 17:

                // Emit success event
                _this4.$emit('saved', {
                  mfaPhonePreference: 'NONE'
                });

                _this4.handleCancel();
                _context2.next = 24;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2['catch'](5);

                _this4.error = _context2.t0.message || 'Failed to save preference. Please try again.';

              case 24:
                _context2.prev = 24;

                _this4.saving = false;
                return _context2.finish(24);

              case 27:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[5, 21, 24, 27]]);
      }))();
    }
  }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'microDepositsVerification',
  beforeMount: function beforeMount() {
    this.loadUserProfile();
    this.hideQuestionModal();
    this.setFundingSourceId();
    this.setActiveAccountIndex();
  },
  data: function data() {
    return {
      maxAttempsReached: false,
      instructions: '',
      verifyError: '',
      amountError: '',
      microDeposit: {
        fundingSourceId: '',
        requestBody: {
          amount1: {
            value: '0.0',
            currency: 'USD'
          },
          amount2: {
            value: '0.0',
            currency: 'USD'
          }
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['user', 'activeAccountId'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('accountCreation', ['getUserProfile']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('account', ['setDefaultFundingSource', 'getAccountFundingSources']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('app', {
    setUser: __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["a" /* SET_USER */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('microDepositsVerification', ['verifyMicroDeposit']), {
    loadUserProfile: function loadUserProfile() {
      var _this = this;

      return this.getUserProfile().then(function (data) {
        _this.setUser(data);
        _this.previousFundingSourceId = data.accounts[0].defaultFundingSourceId;
      });
    },
    setFundingSourceId: function setFundingSourceId() {
      this.microDeposit.fundingSourceId = this.$route.params.id;
    },
    setActiveAccountIndex: function setActiveAccountIndex() {
      var _this2 = this;

      var activeAccount = this.user.accounts.find(function (ac) {
        return ac.id === _this2.activeAccountId;
      });
      this.activeAccountIndex = this.user.accounts.indexOf(activeAccount);
    },
    validateAmount: function validateAmount(amount) {
      if (amount >= 0.1) {
        this.amountError = 'Micro-deposits amount must be less than 10 cents';
        return false;
      }
      return true;
    },
    validateAmounts: function validateAmounts() {
      var firstAmount = this.microDeposit.requestBody.amount1.value;
      var secondAmount = this.microDeposit.requestBody.amount2.value;
      return this.validateAmount(firstAmount) && this.validateAmount(secondAmount);
    },
    showErrors: function showErrors(message) {
      var finalError = message.includes('INVALID_MAX_ATTEMPTS');
      if (!finalError) {
        this.verifyError = 'Amounts introduced are incorrect, please try again!';
      }
      if (finalError) {
        this.instructions = ['Removal of the bank account with failed micro-deposit verification attempts.', 'Wait 48 hours after the initial bank account was added to re-add the bank account.', 'Initiate new micro-deposits to the bank account.', 'Verify the bank account using the new posted micro-deposit amounts.'];
        this.verifyError = 'You have reached the maximum (3) of attempts!';
        this.maxAttempsReached = true;
      }
    },
    showInvestmentView: function showInvestmentView() {
      this.$router.replace({ name: 'AddFundingSource', params: { addedFundingSource: true } });
    },
    resetErrors: function resetErrors() {
      this.amountError = '';
      this.verifyError = '';
    },
    submitVerifyMicroDeposit: function submitVerifyMicroDeposit() {
      var _this3 = this;

      var microDeposit = this.microDeposit;

      this.resetErrors();
      var validAmounts = this.validateAmounts();
      if (!validAmounts) {
        return;
      }
      this.verifyMicroDeposit({
        microDeposit: microDeposit
      }).then(function (resp) {
        // Some API implementations return a resolved response with an error message.
        if (resp && resp.message) {
          _this3.showErrors(resp.message);
          return;
        }
        _this3.getAccountFundingSources(_this3.activeAccountId).then(function () {
          _this3.loadUserProfile().then(function () {
            if (!_this3.previousFundingSourceId) {
              var account = _this3.user.accounts[0];
              var fundingSourceId = _this3.microDeposit.fundingSourceId;
              _this3.setDefaultFundingSource({
                accountId: account.id,
                fundingSourceId: fundingSourceId
              }).then(function () {
                _this3.previousFundingSourceId = fundingSourceId;
                _this3.user.accounts[0].defaultFundingSourceId = fundingSourceId;
                _this3.showInvestmentView();
              });
            } else {
              _this3.showInvestmentView();
            }
          });
        });
      }).catch(function (err) {
        _this3.showErrors(err.message);
      });
    }
  })
});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bootstrap_datetimepicker__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_modals_Information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_EditTransactionComment__ = __webpack_require__(2089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_EditTransactionComment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_EditTransactionComment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_modals_InterestAdjustment__ = __webpack_require__(2090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_modals_InterestAdjustment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_modals_InterestAdjustment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_table_SortableTh__ = __webpack_require__(2093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_table_SortableTh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_table_SortableTh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Breadcrumb__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__data_static_userTypes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__data_static_transactionStatuses__ = __webpack_require__(97);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








 // eslint-disable-line no-unused-vars















var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_14__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_14__util__["c" /* formatAmount */],
    formatRate: __WEBPACK_IMPORTED_MODULE_14__util__["s" /* formatRate */],
    formatTerm: __WEBPACK_IMPORTED_MODULE_14__util__["o" /* formatTerm */],
    formatType: __WEBPACK_IMPORTED_MODULE_14__util__["d" /* formatType */],
    formatNegativeAmount: __WEBPACK_IMPORTED_MODULE_14__util__["r" /* formatNegativeAmount */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'noteDetail',
  beforeMount: function beforeMount() {
    this.setParams();
    this.loadData();
  },

  mixins: [mix],
  components: {
    errors: __WEBPACK_IMPORTED_MODULE_7__components_modals_Errors___default.a,
    information: __WEBPACK_IMPORTED_MODULE_8__components_modals_Information___default.a,
    question: __WEBPACK_IMPORTED_MODULE_10__components_modals_Question___default.a,
    'edit-transaction-comment': __WEBPACK_IMPORTED_MODULE_9__components_modals_EditTransactionComment___default.a,
    'interest-adjustment': __WEBPACK_IMPORTED_MODULE_16__components_modals_InterestAdjustment___default.a,
    'date-picker': __WEBPACK_IMPORTED_MODULE_6_vue_bootstrap_datetimepicker___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_15__components_widgets_Spinner___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_18__components_Breadcrumb___default.a,
    'sortable-th': __WEBPACK_IMPORTED_MODULE_17__components_table_SortableTh___default.a
  },
  watch: {
    note: function changeNote(newNote) {
      var account = newNote.account;
      var accountObj = {
        accountName: account.accountName || '',
        accountType: account.accountType || '',
        accountId: account.id || ''
      };

      this.breadcrumbData = [];
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
        title: 'Search',
        goto: { name: 'Users' },
        selected: false
      }));
      var params = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.$route.params);
      var user = this.user;
      var goto = void 0;
      if (user.userType === __WEBPACK_IMPORTED_MODULE_19__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name) {
        goto = {
          name: 'EditFinancialAdvisor',
          params: {
            name: params.name,
            userId: params.userId
          }
        };
      } else {
        goto = { name: 'UserDetail', params: { name: params.name, userId: params.userId } };
      }
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
        goto: goto,
        title: user.firstName.concat(' ', user.lastName),
        selected: false
      }));
      var accountTypeProperties = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util__["n" /* getAccounTypeProperties */])(accountObj.accountType);
      var gotoAccount = {
        name: accountTypeProperties.component,
        params: {
          accountId: accountObj.accountId,
          name: params.name,
          userId: params.userId
        }
      };
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
        title: accountObj.accountName,
        goto: gotoAccount,
        selected: false
      }));
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, {
        title: 'Note'.concat(' ', newNote.noteId),
        goto: { name: this.$route.name, params: this.$route.params },
        selected: true
      }));
    }
  },
  data: function data() {
    return {
      noteId: '',
      userId: '',
      name: '',
      note: {
        transactions: []
      },
      user: {},
      breadcrumbData: [],
      showAdjustmentModal: false,
      notesError: '',
      comment: '',
      isRedeemDisabled: false,
      isRerunInterestAccrualDisabled: false,
      isTransferDisabled: false,
      isAddFundsDisabled: false,
      loading: false,
      adjustmentAmount: null,
      dateConfig: {
        format: 'MM/DD/YYYY'
      },
      errorOnAdjustment: false,
      adjustmentWasSuccessfull: false,
      minimunInterestPaid: 0.005,
      isVisibleEditCommentModal: false,
      transaction: null,
      sortProperty: 'updatedAt',
      sortToggle: 1,
      orderedTransactions: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('information', ['isInformationModalVisible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('question', ['display']), {
    transactionToAdjust: function transactionToAdjust() {
      var intPaidTransactions = this.note.transactions.filter(function (transaction) {
        return transaction.type === 'INT-PAID' && transaction.status === 'PRE-PENDING';
      });
      return intPaidTransactions.length === 1 ? intPaidTransactions[0] : this.verifyRedemption(intPaidTransactions);
    },
    isAdjustmentPossible: function isAdjustmentPossible() {
      return __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.some(this.note.transactions, { status: 'PRE-PENDING', type: 'INT-PAID' });
    },
    interestAccrued: function interestAccrued() {
      var accrint = this.note.transactions.filter(function (transaction) {
        return transaction.type === 'ACCRINT';
      })[0];
      var amount = accrint ? accrint.amount : 0;
      return (amount + parseFloat(this.adjustmentAmount || 0)).toFixed(8);
    },
    interestPaid: function interestPaid() {
      var amount = this.transactionToAdjust ? this.transactionToAdjust.amount : 0;
      return (amount + parseFloat(this.adjustmentAmount || 0)).toFixed(8);
    },
    adjustmentDate: function adjustmentDate() {
      return new Date();
    },
    isSubmitDisabled: function isSubmitDisabled() {
      return !(Number(this.adjustmentAmount) && this.interestPaid > this.minimunInterestPaid && this.comment);
    },

    fixedAdjustmentAmount: {
      get: function get() {
        if (this.adjustmentAmount) {
          var hasDecimals = this.adjustmentAmount.toString().split('.')[1];
          var decimalPlaces = hasDecimals ? hasDecimals.length : 0;
          return !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(this.adjustmentAmount) && decimalPlaces > 1 ? parseFloat(this.adjustmentAmount).toFixed(2) : this.adjustmentAmount;
        }
        return this.adjustmentAmount;
      },
      set: function set(value) {
        this.adjustmentAmount = value;
      }
    },
    failableTransactions: function failableTransactions() {
      return [__WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].PAID_INT, __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].REPAID_ACCT, __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].REPAID_ACCT_FULL, __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].REPAID_ACCT_PARTIAL];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('note', ['getNote', 'adjustInterestForNote', 'resetInterestAccrual']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('accountCreation', ['getUserDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), {
    markAsFailedMessage: function markAsFailedMessage(transaction) {
      var baseMessage = 'Mark as failed';
      if (transaction.hasPendingFailureApproval) {
        return 'Approve ' + baseMessage;
      }
      return baseMessage;
    },
    sortTransactionsStrategy: function sortTransactionsStrategy() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      if (value === 'transactionId') {
        this.sortTransactionById('transactionId');
        return;
      } else if (value === 'status') {
        this.sortByStatus();
        return;
      } else if (value) {
        this.sortTransactionsByProperty(value);
        return;
      }
      this.orderedTransactions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util__["t" /* orderTransactions */])(this.note.transactions);
    },
    sortByStatus: function sortByStatus() {
      var _this = this;

      this.sortToggle = this.sortProperty === 'status' ? this.sortToggle * -1 : -1;

      this.orderedTransactions = this.note.transactions.sort(function (a, b) {
        if (a.status < b.status || !a.status && b.status) {
          return -1 * _this.sortToggle;
        }
        if (a.status > b.status || a.status && !b.status) {
          return 1 * _this.sortToggle;
        }
        if (a.createdAt < b.createdAt || !a.createdAt && b.createdAt) {
          return 1;
        }
        if (a.createdAt > b.createdAt || a.createdAt && !b.createdAt) {
          return -1;
        }
        return 0;
      });

      this.sortProperty = 'status';
    },
    sortTransactionsByProperty: function sortTransactionsByProperty(property) {
      var _this2 = this;

      this.sortToggle = this.sortProperty === property ? this.sortToggle * -1 : 1;

      this.orderedTransactions = this.note.transactions.sort(function (a, b) {
        if (a[property] < b[property] || !a[property] && b[property]) {
          return -1 * _this2.sortToggle;
        }
        if (a[property] > b[property] || a[property] && !b[property]) {
          return 1 * _this2.sortToggle;
        }
        return 0;
      });

      this.sortProperty = property;
    },
    sortTransactionById: function sortTransactionById(property) {
      var _this3 = this;

      this.sortToggle = this.sortProperty === property ? this.sortToggle * -1 : 1;

      this.orderedTransactions = this.note.transactions.sort(function (a, b) {
        if (!a[property] && !b[property]) {
          return 0;
        }
        if (!b[property]) {
          return 1 * _this3.sortToggle;
        }
        if (!a[property]) {
          return -1 * _this3.sortToggle;
        }
        return a[property].localeCompare(b[property], 'en', { numeric: true }) * _this3.sortToggle;
      });

      this.sortProperty = property;
    },
    failTransaction: function failTransaction(id) {
      this.$router.push({
        name: 'FailTransaction',
        params: {
          name: this.$route.params.name,
          userId: this.$route.params.userId,
          noteId: this.$route.params.noteId,
          transactionId: id
        }
      });
    },
    verifyRedemption: function verifyRedemption(transactions) {
      return __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.find(transactions, { origin: 'REDEMPTION' });
    },
    submitAdjustment: function submitAdjustment() {
      var _this4 = this;

      var adjustmentObject = {
        amount: parseFloat(this.adjustmentAmount).toFixed(2),
        comment: this.comment };
      this.adjustInterestForNote({
        noteId: this.note.id,
        adjustmentObject: adjustmentObject
      }).then(function () {
        _this4.loadNoteDetail();
        _this4.showAdjustmentModal = false;
        _this4.adjustmentWasSuccessfull = true;
      }).catch(function () {
        _this4.showAdjustmentModal = false;
        _this4.adjustmentWasSuccessfull = false;
        _this4.setErrorsModalInfo(['We could not process the adjustment.']);
        _this4.showErrorsModal();
      });
      this.cleanAdjustmentInformation();
    },
    cleanAdjustmentInformation: function cleanAdjustmentInformation() {
      this.adjustmentAmount = null;
      this.comment = '';
      this.showAdjustmentModal = false;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('information', {
    showInformationModal: __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__["d" /* SHOW_INFORMATION_MODAL */]
  }), {
    setParams: function setParams() {
      this.name = this.$route.params.name;
      this.userId = this.$route.params.userId;
      this.noteId = this.$route.params.noteId;
    },
    loadNoteDetail: function loadNoteDetail() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this5.loading = true;
                return _context.abrupt('return', _this5.getNote(_this5.noteId).then(function (note) {
                  _this5.note = note;
                  _this5.loading = false;
                  _this5.verifyRedeem(note);
                  _this5.hasRedemption(note);
                  _this5.verifyTransfer(note);
                  _this5.verifyAdditionalDeposit(note);
                  _this5.sortTransactionsStrategy('updatedAt');
                }).catch(function (err) {
                  _this5.loading = false;
                  if (err !== 'UNAUTHORIZED') {
                    _this5.setErrorsModalInfo(['We could not retrieve the note detail']);
                    _this5.showErrorsModal();
                  }
                }));

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    loadData: function loadData() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this6.loading = true;
                _context3.next = 3;
                return _this6.getUserDetail(_this6.userId).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(user) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _this6.user = user;
                            _context2.next = 3;
                            return _this6.loadNoteDetail();

                          case 3:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this6);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }()).then(function () {
                  _this6.loading = false;
                }).catch(function (err) {
                  _this6.loading = false;
                  if (err !== 'UNAUTHORIZED') {
                    _this6.setErrorsModalInfo(['We could not retrieve the user detail']);
                    _this6.showErrorsModal();
                  }
                });

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    canViewRedeemDetail: function canViewRedeemDetail(transaction) {
      return this.note.status === 'open' && transaction.status === 'PRE-PENDING' && (transaction.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].SELL_REDEEM_FULL || transaction.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].SELL_REDEEM_PARTIAL);
    },
    canViewTransferDetail: function canViewTransferDetail(transaction) {
      return transaction.status === 'PRE-PENDING' && transaction.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].ACCT_TRANSFER;
    },
    canViewAddFundsDetail: function canViewAddFundsDetail(transaction) {
      return transaction.status === 'PRE-PENDING' && transaction.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].ADDITIONAL_DEPOSIT;
    },
    canRerunInterestAccrual: function canRerunInterestAccrual(transaction) {
      return transaction.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].ACCRINT;
    },
    canTransactionBeFailed: function canTransactionBeFailed(transaction) {
      return this.failableTransactions.includes(transaction.type) && transaction.status === __WEBPACK_IMPORTED_MODULE_20__data_static_transactionStatuses__["a" /* default */].PROCESSED;
    },
    verifyRedeem: function verifyRedeem(note) {
      var redemptionExists = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.some(note.transactions, function (transaction) {
        return transaction.status === 'PRE-PENDING' && (transaction.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].SELL_REDEEM_FULL || transaction.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].SELL_REDEEM_PARTIAL);
      });
      var fullRedemptionProccessedExists = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.some(note.transactions, function (transaction) {
        return transaction.status === 'PROCESSED' && transaction.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].SELL_REDEEM_FULL;
      });
      var principalUpcomingTransaction = note.transactions.find(function (t) {
        return (t.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].SELL_REINVEST || t.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].SELL_DONATE || t.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].SELL_MATURE) && t.status === __WEBPACK_IMPORTED_MODULE_20__data_static_transactionStatuses__["a" /* default */].PREPENDING;
      });
      var interestUpcomingTransaction = note.transactions.find(function (t) {
        return (t.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].INT_REINVEST || t.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].INT_DONATE || t.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].INT_PAID) && t.status === __WEBPACK_IMPORTED_MODULE_20__data_static_transactionStatuses__["a" /* default */].PREPENDING;
      });
      if (redemptionExists || note.status !== 'open' || fullRedemptionProccessedExists || note.account.redemptionRestriction && (principalUpcomingTransaction || interestUpcomingTransaction)) {
        this.isRedeemDisabled = true;
      }
    },
    hasRedemption: function hasRedemption(note) {
      if (note.transactions.some(function (t) {
        return t.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].SELL_REDEEM_FULL || t.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].SELL_REDEEM_PARTIAL;
      })) {
        this.isRerunInterestAccrualDisabled = true;
      }
    },
    handleRerunInterestAccrual: function handleRerunInterestAccrual(noteId) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var isResetedInterestAccrual;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this7.resetInterestAccrual(noteId);

              case 2:
                isResetedInterestAccrual = _context4.sent;

                if (isResetedInterestAccrual.ok) {
                  _this7.loadNoteDetail();
                }

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    handleRerunInterestAccrualDisabledShowModal: function handleRerunInterestAccrualDisabledShowModal() {
      var restrictedMessage = 'Action can\'t be processed because note has a redemption. Please contact support team.';
      this.showInformationModal(restrictedMessage);
    },
    verifyTransfer: function verifyTransfer(note) {
      var transferExists = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.some(note.transactions, function (transaction) {
        return transaction.status === 'PRE-PENDING' && transaction.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].ACCT_TRANSFER;
      });
      if (transferExists) {
        this.isTransferDisabled = true;
      }
    },
    verifyAdditionalDeposit: function verifyAdditionalDeposit(note) {
      var existsSettlement = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.some(note.transactions, function (transaction) {
        return transaction.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].SETTLEMENT;
      });

      var existsAddFundsRequest = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.some(note.transactions, function (transaction) {
        return transaction.status === 'PRE-PENDING' && transaction.type === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionTypes__["a" /* default */].ADDITIONAL_DEPOSIT;
      });

      this.isAddFundsDisabled = !existsSettlement || existsAddFundsRequest;
    },
    goToRedeem: function goToRedeem() {
      var name = this.name;
      var userId = this.userId;
      var noteId = this.noteId;
      var accountId = this.note.accountId;

      var routeParams = { name: 'Redeem',
        params: {
          name: name,
          userId: userId,
          noteId: noteId,
          accountId: accountId
        }
      };
      this.$router.push(routeParams);
    },
    goToTransfer: function goToTransfer() {
      var name = this.name;
      var userId = this.userId;
      var noteId = this.noteId;

      var routeParams = { name: 'Transfer', params: { name: name, userId: userId, noteId: noteId } };
      this.$router.push(routeParams);
    },
    goToAddFunds: function goToAddFunds() {
      var name = this.name;
      var userId = this.userId;
      var noteId = this.noteId;

      var routeParams = { name: 'AddFunds', params: { name: name, userId: userId, noteId: noteId } };
      this.$router.push(routeParams);
    },
    goToViewDetail: function goToViewDetail() {
      var name = this.name;
      var userId = this.userId;
      var noteId = this.noteId;
      var accountId = this.note.accountId;

      this.$router.push({ name: 'Redeem', params: { name: name, userId: userId, noteId: noteId, accountId: accountId } });
    },
    goToViewTransferDetail: function goToViewTransferDetail() {
      var name = this.name;
      var userId = this.userId;
      var noteId = this.noteId;
      this.$router.push({ name: 'Transfer', params: { name: name, userId: userId, noteId: noteId } });
    },
    getWholeAmount: function getWholeAmount(amount) {
      var character = amount < 0 ? '(' : '';
      return character + '$' + Math.abs(amount).toFixed(2).toString().split('.')[0];
    },
    getDecimals: function getDecimals(amount) {
      var character = amount < 0 ? ')' : '';
      return '' + Math.abs(amount).toFixed(2).toString().split('.')[1] + character;
    },
    openEditCommentModal: function openEditCommentModal(transaction) {
      this.transaction = transaction;
      this.isVisibleEditCommentModal = true;
    },
    closeEditCommentModal: function closeEditCommentModal() {
      this.isVisibleEditCommentModal = false;
      this.transaction = null;
    }
  })
});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_DismissableAlert__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_DismissableAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_DismissableAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Transaction__ = __webpack_require__(2092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Transaction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_modals_Transaction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_Information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_Information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_Information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_static_transactionStatuses__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__ = __webpack_require__(8);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_12__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_12__util__["c" /* formatAmount */],
    formatRate: __WEBPACK_IMPORTED_MODULE_12__util__["s" /* formatRate */],
    formatTerm: __WEBPACK_IMPORTED_MODULE_12__util__["o" /* formatTerm */],
    isStateRestricted: __WEBPACK_IMPORTED_MODULE_12__util__["f" /* isStateRestricted */]
  }
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notesList',
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.showPurchaseCompleted = _this.$route.params.purchasedNote;
              _this.loadNotesList();
              _this.checkUserStatus();
              _context.next = 5;
              return _this.getAmountBalance();

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  mixins: [mix],
  components: {
    errors: __WEBPACK_IMPORTED_MODULE_5__components_modals_Errors___default.a,
    'dismissable-alert': __WEBPACK_IMPORTED_MODULE_7__components_widgets_DismissableAlert___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default.a,
    transaction: __WEBPACK_IMPORTED_MODULE_8__components_modals_Transaction___default.a,
    information: __WEBPACK_IMPORTED_MODULE_9__components_modals_Information___default.a
  },
  data: function data() {
    return {
      notes: [],
      notesError: '',
      loading: false,
      orderedNotes: [],
      sortProperty: '',
      sortToggle: 1,
      showPurchaseCompleted: false,
      currentAmountBalance: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('information', ['isInformationModalVisible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('home', ['userStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('transactionModal', ['isTransactionModalVisible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['activeAccountId', 'user', 'activeAccount', 'accountTypes']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['hasBeenCreatedAccount']), {
    isInstitutionAccount: function isInstitutionAccount() {
      return this.activeAccount.accountType === this.accountTypes.INSTITUTION.name;
    },
    disableInvestment: function disableInvestment() {
      var _this2 = this;

      var _user = this.user,
          accounts = _user.accounts,
          disableInvestment = _user.disableInvestment;

      var account = accounts.find(function (acct) {
        return acct.id === _this2.activeAccount.id;
      });
      return disableInvestment || account.disableInvestment;
    },
    isReadOnly: function isReadOnly() {
      return this.user && this.user.userType === 'READ_ONLY';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('information', {
    showInformationModal: __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__["d" /* SHOW_INFORMATION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('home', ['getUserStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('account', ['getCurrentAmountBalance', 'getAccountNotes', 'getAccountNoteTransactions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('transactionModal', {
    showTransactionModal: __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__["F" /* SHOW_TRANSACTION_MODAL */]
  }), {
    getAmountBalance: function getAmountBalance() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.getCurrentAmountBalance({ accountId: _this3.activeAccountId });

              case 2:
                response = _context2.sent;

                _this3.currentAmountBalance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util__["c" /* formatAmount */])(response.currentAmountBalance);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    loadNotesList: function loadNotesList() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', _this4.getAccountNotes(_this4.activeAccountId).then(function (notes) {
                  _this4.notes = notes;
                  _this4.sortByStatus();
                }).catch(function () {
                  _this4.setErrorsModalInfo(['We could not retrieve notes list']);
                  _this4.showErrorsModal();
                }));

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    purchaseNote: function purchaseNote() {
      if (this.isReadOnly) return;
      var state = this.user.residentialAddress.state;
      if (this.isStateRestricted(state)) {
        var restrictedMessage = 'At this time, we cannot accept investments from persons resident in ' + state + ' state.\n          Please contact Calvert Impact Capital at info@calvertimpact.org or call us at 800-248-0337 if you have questions. ';
        this.showInformationModal(restrictedMessage);
      } else if (this.userStatus.needs.includes('FUNDING_SOURCE') || this.userStatus.status === 'document_migrated_user' || this.userStatus.status === 'retry') {
        this.$router.push({ name: 'AddFundingSource' });
      } else {
        this.$router.push({ name: 'PurchaseNote' });
      }
    },
    checkUserStatus: function checkUserStatus() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.loading = true;

                if (_this5.hasBeenCreatedAccount) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt('return', _this5.$router.push({ name: 'AccountSummary' }));

              case 3:
                return _context4.abrupt('return', _this5.getUserStatus({
                  accountId: _this5.activeAccount.id
                }).then(function (_ref) {
                  var status = _ref.status,
                      needs = _ref.needs;

                  if (status === 'retry') {
                    _this5.$router.push({ name: 'AccountCreation' });
                  } else if (status === 'document') {
                    _this5.$router.push({ name: 'DocumentUpload' });
                  } else if (status === 'suspended') {
                    _this5.$router.push({ name: 'AccountSuspended' });
                  } else if (!needs.includes('FUNDING_SOURCE') && needs.includes('NOTE')) {
                    _this5.$router.push({ name: 'PurchaseNote', query: { first: 1 } });
                  } else {
                    _this5.loading = false;
                  }
                }).catch(function () {
                  _this5.loading = false;
                }));

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    isTransactionAProcessedUpcomingPayment: function isTransactionAProcessedUpcomingPayment(_ref2) {
      var type = _ref2.type,
          status = _ref2.status;

      return (type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].INT_PAID || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].SELL_MATURE || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].INT_REINVEST || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].SELL_REINVEST || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].INT_DONATE || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].SELL_DONATE) && (status === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionStatuses__["a" /* default */].PROCESSED || status === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionStatuses__["a" /* default */].PREPENDING);
    },
    isTransactionACancelledUpcomingPayment: function isTransactionACancelledUpcomingPayment(_ref3) {
      var type = _ref3.type,
          status = _ref3.status;

      return (type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].INT_PAID || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].SELL_MATURE || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].INT_REINVEST || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].SELL_REINVEST || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].INT_DONATE || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].SELL_DONATE) && (status === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionStatuses__["a" /* default */].CANCELLED || status === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionStatuses__["a" /* default */].FAILED);
    },
    isTransactionAFundingAccount: function isTransactionAFundingAccount(_ref4) {
      var type = _ref4.type,
          dwollaTransferId = _ref4.dwollaTransferId;

      return type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].FUNDING && dwollaTransferId === null;
    },
    filterTransaction: function filterTransaction(transactionObject) {
      var retry = transactionObject.retry,
          type = transactionObject.type,
          status = transactionObject.status,
          dwollaTransferId = transactionObject.dwollaTransferId;

      if (status === __WEBPACK_IMPORTED_MODULE_11__data_static_transactionStatuses__["a" /* default */].PREPENDING) {
        return false;
      } else if (retry) {
        return false;
      } else if (this.isTransactionAFundingAccount({ type: type, dwollaTransferId: dwollaTransferId })) {
        return true;
      } else if (this.isTransactionAProcessedUpcomingPayment({ type: type, status: status })) {
        return true;
      } else if (type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].PURCHASE_NOTE || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].ADDITIONAL_DEPOSIT || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].PURCH_INT_REINVEST || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].PURCH_REINVEST || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].REPAID_ACCT || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].PAID_INT || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].REPAID_ACCT_FULL || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].FEE_SERV || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].REPAID_ACCT_PARTIAL || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].PURCH_RENEWAL || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].ACCT_TRANSFER || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].PURCH_INT_CAP || type === __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].SETTLEMENT) {
        return true;
      }
      return false;
    },
    cleanTransactionBasedOnCashoutProcess: function cleanTransactionBasedOnCashoutProcess(transactions) {
      var isThereAnyRepaidAcct = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.some(transactions, { type: __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].REPAID_ACCT });
      var isThereAnyPaidInt = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.some(transactions, { type: __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].PAID_INT });

      if (!isThereAnyRepaidAcct && !isThereAnyPaidInt) {
        return transactions;
      }

      var cleanedTransactions = transactions;

      if (isThereAnyRepaidAcct) {
        cleanedTransactions = this.cleanTransactionsFromSellMature(transactions);
      }

      if (isThereAnyPaidInt) {
        cleanedTransactions = this.cleanTransactionsFromIntPaid(cleanedTransactions);
      }

      return cleanedTransactions;
    },
    cleanTransactionsFromCancelledUpcoming: function cleanTransactionsFromCancelledUpcoming(transactions) {
      var _this6 = this;

      var cleanedTransactions = [];
      __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(transactions, function (t) {
        if (!_this6.isTransactionACancelledUpcomingPayment(t)) {
          cleanedTransactions.push(t);
        }
      });
      return cleanedTransactions;
    },
    cleanTransactionsFromIntPaid: function cleanTransactionsFromIntPaid(transactions) {
      var intPaidTransactions = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(transactions, { type: __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].INT_PAID });

      __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(intPaidTransactions, function (intPaid) {
        var paidIntTransaction = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(transactions, {
          type: __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].PAID_INT,
          createdAt: intPaid.maturityDate
        });

        if (paidIntTransaction) {
          __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.remove(transactions, { id: intPaid.id });
        }
      });

      return transactions;
    },
    cleanTransactionsFromSellMature: function cleanTransactionsFromSellMature(transactions) {
      var sellMatureTransactions = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(transactions, { type: __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].SELL_MATURE });

      __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.forEach(sellMatureTransactions, function (sellMature) {
        var repaidAccTransaction = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(transactions, {
          type: __WEBPACK_IMPORTED_MODULE_10__data_static_transactionTypes__["a" /* default */].REPAID_ACCT,
          createdAt: sellMature.maturityDate
        });

        if (repaidAccTransaction) {
          __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.remove(transactions, { id: sellMature.id });
        }
      });

      return transactions;
    },
    goToViewDetail: function goToViewDetail(note) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var transactions, transactionsFiltered, cleanedTransactions, orderedTransactions, noteObject;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this7.getAccountNoteTransactions({
                  noteId: note.id,
                  accountId: _this7.activeAccount.id
                });

              case 2:
                transactions = _context5.sent;
                transactionsFiltered = transactions.filter(function (transactionObject) {
                  return _this7.filterTransaction(transactionObject);
                });
                cleanedTransactions = _this7.cleanTransactionBasedOnCashoutProcess(transactionsFiltered);

                cleanedTransactions = _this7.cleanTransactionsFromCancelledUpcoming(cleanedTransactions);

                orderedTransactions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util__["t" /* orderTransactions */])(cleanedTransactions);

                if (!_this7.isReadOnly) {
                  _context5.next = 9;
                  break;
                }

                return _context5.abrupt('return');

              case 9:
                noteObject = {
                  id: note.noteId,
                  transactions: orderedTransactions,
                  openedOn: note.openedOn
                };

                _this7.showTransactionModal(noteObject);

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    sortByNoteId: function sortByNoteId() {
      var _this8 = this;

      this.sortToggle = this.sortProperty === 'noteId' ? this.sortToggle * -1 : 1;

      this.orderedNotes = this.notes.sort(function (a, b) {
        if (+a.noteId.match(/\d+/g) < +b.noteId.match(/\d+/g)) {
          return -1 * _this8.sortToggle;
        }
        if (+a.noteId.match(/\d+/g) > +b.noteId.match(/\d+/g)) {
          return 1 * _this8.sortToggle;
        }
        return 0;
      });

      this.sortProperty = 'noteId';
    },
    sortByStatus: function sortByStatus() {
      var _this9 = this;

      this.sortToggle = this.sortProperty === 'status' ? this.sortToggle * -1 : -1;

      this.orderedNotes = this.notes.sort(function (a, b) {
        if (a.status < b.status || !a.status && b.status) {
          return -1 * _this9.sortToggle;
        }
        if (a.status > b.status || a.status && !b.status) {
          return 1 * _this9.sortToggle;
        }
        if (a.purchasedOn < b.purchasedOn || !a.purchasedOn && b.purchasedOn) {
          return 1;
        }
        if (a.purchasedOn > b.purchasedOn || a.purchasedOn && !b.purchasedOn) {
          return -1;
        }
        return 0;
      });

      this.sortProperty = 'status';
    },
    sortNotes: function sortNotes(property) {
      var _this10 = this;

      this.sortToggle = this.sortProperty === property ? this.sortToggle * -1 : 1;

      this.orderedNotes = this.notes.sort(function (a, b) {
        if (a[property] < b[property] || !a[property] && b[property]) {
          return -1 * _this10.sortToggle;
        }
        if (a[property] > b[property] || a[property] && !b[property]) {
          return 1 * _this10.sortToggle;
        }
        return 0;
      });

      this.sortProperty = property;
    },
    sortIconStyle: function sortIconStyle(property) {
      if (property === this.sortProperty) {
        return 'fa fa-sort-' + (this.sortToggle === 1 ? 'asc' : 'desc');
      }
      return 'fa fa-sort';
    },
    hidePurchaseCompletedAlert: function hidePurchaseCompletedAlert() {
      this.showPurchaseCompleted = false;
    }
  })
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'onboardingWizard',
  props: ['userStatus'],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('home', ['getUserStatus', 'setOnBoardingComplete'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])('app', ['hasBeenCreatedAccount']), {
    wizardStep: function wizardStep() {
      var _this = this;

      var _userStatus = this.userStatus,
          status = _userStatus.status,
          needs = _userStatus.needs,
          onBoardingCompleted = _userStatus.onBoardingCompleted;

      if (!this.hasBeenCreatedAccount || status === 'retry' || status === 'document') {
        return 'personalInformation';
      }
      if (status === 'verified') {
        if (needs.includes('FUNDING_SOURCE') && !onBoardingCompleted) {
          return 'addFundingSource';
        }
        if (needs.includes('NOTE')) {
          return 'firstInvestment';
        }
        if (!onBoardingCompleted) {
          this.setOnBoardingComplete().then(function () {
            _this.getUserStatus({
              accountId: _this.activeAccount.id
            });
          });
        }
      }
      return 'done';
    }
  })
});

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PasswordHint',
  props: {
    password: {
      type: String,
      default: ''
    }
  },
  computed: {
    criteria: function criteria() {
      return [{
        id: 'lowercase',
        text: 'At least one lowercase letter',
        matched: /[a-z]/.test(this.password)
      }, {
        id: 'uppercase',
        text: 'At least one uppercase letter',
        matched: /[A-Z]/.test(this.password)
      }, {
        id: 'number',
        text: 'At least one number',
        matched: /[0-9]/.test(this.password)
      }, {
        id: 'special',
        text: 'At least one special character',
        matched: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(this.password)
      }, {
        id: 'length',
        text: 'Minimum of 8 characters',
        matched: this.password.length >= 8
      }];
    }
  }
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_static_logActions__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_static_constants__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_formControls_RestrictedSingleInput__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_formControls_RestrictedSingleInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_formControls_RestrictedSingleInput__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['accountId', 'primaryInvestor'],
  data: function data() {
    return {
      addPreferences: [],
      removePreferences: [],
      preferences: [],
      middleIndex: 0,
      other: '',
      otherText: null,
      otherTextId: null,
      reservedPreferenceCodes: null
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.checkUserStatus();

            case 2:
              _this.hideQuestionModal();
              _this.initialize();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('account', ['getAccountImpactPreferences']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('impactPreferences', ['getImpactPreferences', 'getSeparatedDisplayedAndNonDisplayedPreferencesInvestor']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('home', ['getUserStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('account', ['updateAccountImpactPreferences']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), {
    checkUserStatus: function checkUserStatus() {
      var _this2 = this;

      if (!this.hasBeenCreatedAccount) {
        this.$router.push({ name: 'AccountSummary' });
      }

      return this.getUserStatus({
        accountId: this.activeAccount.id
      }).then(function (_ref) {
        var status = _ref.status,
            needs = _ref.needs,
            hasFundingSource = _ref.hasFundingSource;

        if (status === 'suspended') {
          _this2.$router.push({ name: 'AccountSuspended' });
        } else if (status === 'retry') {
          _this2.$router.push({ name: 'AccountCreation' });
        } else if (status === 'document') {
          _this2.$router.push({ name: 'DocumentUpload' });
        } else if (needs.includes('FUNDING_SOURCE') && !hasFundingSource) {
          _this2.$router.push({ name: 'AddFundingSource' });
        } else if (needs.includes('NOTE')) {
          _this2.$router.push({ name: 'PurchaseNote', query: { first: 1 } });
        }
        return true;
      });
    },
    initialize: function initialize() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref2, _ref3, accountImpactPreferences, impactPreferences, _ref4, displayedPreferences, nonDisplayedPreferences;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this3.getAccountImpactPreferences(_this3.accountId), _this3.getImpactPreferences()]);

              case 3:
                _ref2 = _context2.sent;
                _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                accountImpactPreferences = _ref3[0];
                impactPreferences = _ref3[1];

                _this3.accountImpactPreferencesIds = accountImpactPreferences.map(function (aip) {
                  return aip.id;
                });
                _this3.impactPreferencesIds = impactPreferences.map(function (ip) {
                  return ip.id;
                });

                _context2.next = 11;
                return _this3.getSeparatedDisplayedAndNonDisplayedPreferencesInvestor({
                  impactPreferences: impactPreferences,
                  accountImpactPreferences: accountImpactPreferences
                });

              case 11:
                _ref4 = _context2.sent;
                displayedPreferences = _ref4.displayedPreferences;
                nonDisplayedPreferences = _ref4.nonDisplayedPreferences;


                _this3.preferences = displayedPreferences.concat(nonDisplayedPreferences);

                _this3.reservedPreferenceCodes = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this3.reservedImpactPreferenceCodes);

                _this3.setOtherText({
                  displayedPreferences: _this3.preferences,
                  reservedPreferenceCodes: _this3.reservedPreferenceCodes
                });

                _this3.middleIndex = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(_this3.preferences.length / 2) + 1;
                _context2.next = 25;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2['catch'](0);

                _this3.setErrorsModalInfo(['Something went wrong. Please try again.']);
                _this3.showErrorsModal();

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["m" /* logAction */])({
                  user: _this3.primaryInvestor.id,
                  level: 'error',
                  action: __WEBPACK_IMPORTED_MODULE_9__data_static_logActions__["a" /* default */].VIEW_INVESTOR_IMPACT_PREFERENCES.name,
                  message: _context2.t0.message,
                  stack: _context2.t0.stack,
                  tags: [__WEBPACK_IMPORTED_MODULE_8__util__["x" /* logglyTags */].auth0]
                });

              case 25:
                _context2.prev = 25;

                _this3.$emit('loaded');
                return _context2.finish(25);

              case 28:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 20, 25, 28]]);
      }))();
    },
    isGeneralPreference: function isGeneralPreference(index) {
      return this.reservedPreferenceCodes !== null && this.preferences[index] !== undefined && this.preferences[index].code === this.reservedPreferenceCodes.general;
    },
    isOtherPreference: function isOtherPreference(index) {
      return this.reservedPreferenceCodes !== null && this.preferences[index] !== undefined && this.preferences[index].code === this.reservedPreferenceCodes.other;
    },
    selectOtherPreference: function selectOtherPreference(text) {
      var _this4 = this;

      if (this.isReadOnly) return;
      this.other = text.trim();
      this.preferences = this.preferences.map(function (preference) {
        if (preference.id === 2) {
          _this4.otherText = preference.otherText;
          _this4.otherTextId = preference.id;
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, preference, {
            isSelected: text.trim() !== '',
            otherText: text.trim()
          });
        }
        return preference;
      });
    },
    setOtherText: function setOtherText(_ref5) {
      var displayedPreferences = _ref5.displayedPreferences,
          reservedPreferenceCodes = _ref5.reservedPreferenceCodes;

      var otherPreference = displayedPreferences.find(function (preference) {
        return preference.code === reservedPreferenceCodes.other;
      });

      if (!otherPreference) return;

      var otherText = otherPreference.otherText;


      if (otherText) {
        var length = otherText.length > 50 ? 50 : otherText.length;
        this.other = otherText.substring(0, length);
      }
    },
    showConfirmationModal: function showConfirmationModal() {
      if (this.isReadOnly) return;
      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_10__data_static_constants__["a" /* Constants */].investorPreferences.modalTitle,
        question: __WEBPACK_IMPORTED_MODULE_10__data_static_constants__["a" /* Constants */].investorPreferences.modalQuestion,
        yesButtonText: __WEBPACK_IMPORTED_MODULE_10__data_static_constants__["a" /* Constants */].investorPreferences.modalYesButtonText,
        method: this.saveInvestorImpactPreferences
      });
    },
    onChangeSelectImpactPreference: function onChangeSelectImpactPreference(event) {
      if (this.isReadOnly) return;
      var _event$target = event.target,
          checked = _event$target.checked,
          preferenceId = _event$target.value;

      var parsedPreferenceId = Number(preferenceId);
      var belongsToAccount = this.accountImpactPreferencesIds.includes(parsedPreferenceId);

      if (checked && !belongsToAccount) {
        this.addPreferences.push(parsedPreferenceId);
        this.removePreferences = this.removePreferences.filter(function (rp) {
          return rp !== parsedPreferenceId;
        });
      } else if (!checked && belongsToAccount) {
        this.removePreferences.push(parsedPreferenceId);
        this.addPreferences = this.addPreferences.filter(function (rp) {
          return rp !== parsedPreferenceId;
        });
      }
    },
    saveInvestorImpactPreferences: function saveInvestorImpactPreferences() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.hideQuestionModal();
                _this5.loading = true;
                return _context4.abrupt('return', _this5.updateAccountImpactPreferences({
                  accountId: _this5.accountId,
                  payload: {
                    addPreferences: _this5.addPreferences,
                    removePreferences: _this5.removePreferences,
                    otherText: _this5.otherText,
                    otherId: _this5.otherTextId
                  }
                }).then(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _this5.addPreferences = [];
                          _this5.removePreferences = [];
                          _context3.next = 4;
                          return _this5.initialize().then(function () {
                            _this5.loading = false;
                            _this5.$emit('saved');
                          });

                        case 4:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this5);
                }))).catch(function (error) {
                  _this5.loading = false;
                  _this5.setErrorsModalInfo(['Something went wrong. Please try again.']);
                  _this5.showErrorsModal();
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["m" /* logAction */])({
                    message: 'Something went wrong while trying to save investor preferences',
                    stack: error.stack || 'NA',
                    level: 'error'
                  });
                }));

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('app', ['activeAccount', 'user']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('question', ['display']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('app', ['reservedImpactPreferenceCodes']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])('app', ['hasBeenCreatedAccount']), {
    isReadOnly: function isReadOnly() {
      return this.user && this.user.userType === 'READ_ONLY';
    },
    selectedPreferences: function selectedPreferences() {
      return this.preferences.filter(function (preference) {
        return preference.isSelected;
      }).map(function (preference) {
        return {
          id: preference.id,
          otherText: preference.otherText
        };
      });
    }
  }),
  watch: {
    other: function other(value) {
      this.selectOtherPreference(value);
    }
  },
  components: {
    question: __WEBPACK_IMPORTED_MODULE_11__components_modals_Question___default.a,
    RestrictedSingleInput: __WEBPACK_IMPORTED_MODULE_12__components_formControls_RestrictedSingleInput___default.a
  }
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_money__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CustomRateAndTerm__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CustomRateAndTerm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_CustomRateAndTerm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_static_constants__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_config__ = __webpack_require__(45);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















var mix = {
  methods: {
    formatAmount: __WEBPACK_IMPORTED_MODULE_6__util__["c" /* formatAmount */],
    formatDecimal: __WEBPACK_IMPORTED_MODULE_6__util__["q" /* formatDecimal */],
    findAccount: __WEBPACK_IMPORTED_MODULE_6__util__["v" /* findAccount */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'purchaseInvestmentNote',
  beforeMount: function beforeMount() {
    this.setParams();
    this.loadYearsRates();
    this.loadFundingSources();
    this.loadInvestmentsValidations();
  },

  mixins: [mix],
  components: {
    errors: __WEBPACK_IMPORTED_MODULE_2__components_modals_Errors___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner___default.a,
    question: __WEBPACK_IMPORTED_MODULE_8__components_modals_Question___default.a,
    CustomRateAndTerm: __WEBPACK_IMPORTED_MODULE_9__components_CustomRateAndTerm___default.a
  },
  data: function data() {
    return {
      name: '',
      userId: '',
      accountId: '',
      userAccount: {},
      investmentAmount: 0,
      distributorFee: 0,
      brokerageFee: 0,
      cusip: '',
      interestYearRates: [],
      fundingSources: [],
      fundingSourceSelected: '',
      yearsRatesLoading: false,
      userDetailLoading: false,
      isInvestmentAmountInvalid: false,
      isCusipInvalid: false,
      investmentAmountError: '',
      isDateFundedInvalid: false,
      minimumInvestmentAmount: null,
      rate: 0,
      term: 1,
      isRateAndTermValid: true,
      dateFunded: '',
      dateFormat: 'YYYY-MM-DD',
      dateConfig: {
        format: 'MM/DD/YYYY'
      },
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        precision: 2
      },
      isSubmitting: false,
      dateFundedInThePastError: false,
      dateFundedInTheFutureError: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['fundingSourceTypes', 'investmentsRestrictions', 'investmentsRestrictions']), {
    dateFundedError: function dateFundedError() {
      return this.dateFundedInThePastError ? 'The date funded cannot be more than 10 days in the past' : 'Please input a past or present date.';
    },
    isBrokerageEnabled: function isBrokerageEnabled() {
      var brokerageEnabledAccountIds = __WEBPACK_IMPORTED_MODULE_10__data_static_constants__["a" /* Constants */].purchaseInvestmentNote.brokerageEnabledAccountIds;

      var enabledAccountIds = __WEBPACK_IMPORTED_MODULE_11__config_config__["d" /* env */] === 'production' ? brokerageEnabledAccountIds.production : brokerageEnabledAccountIds.default;
      return enabledAccountIds.includes(String(this.accountId));
    }
  }),
  directives: {
    money: __WEBPACK_IMPORTED_MODULE_3_v_money__["VMoney"]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('note', ['getInterestYearRates', 'purchaseNote']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('accountCreation', ['getUserDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), {
    setParams: function setParams() {
      this.userId = this.$route.params.userId;
      this.name = this.$route.params.name;
      this.accountId = this.$route.params.accountId;
    },
    loadYearsRates: function loadYearsRates() {
      this.interestYearRates = this.investmentsRestrictions.ratesAndTerms;
    },
    loadFundingSources: function loadFundingSources() {
      this.fundingSources = [{
        name: this.fundingSourceTypes.CHECK.label,
        type: this.fundingSourceTypes.CHECK.name
      }, {
        name: this.fundingSourceTypes.WIRE_TRANSFER.label,
        type: this.fundingSourceTypes.WIRE_TRANSFER.name
      }];

      if (this.isBrokerageEnabled) {
        this.fundingSources.push({
          name: this.fundingSourceTypes.BROKERAGE.label,
          type: this.fundingSourceTypes.BROKERAGE.name
        });
      }
    },
    loadUserDetail: function loadUserDetail() {
      var _this = this;

      this.userDetailLoading = true;
      return this.getUserDetail(this.userId).then(function (user) {
        _this.userDetailLoading = false;
        _this.userAccount = _this.findAccount(user.accounts, _this.accountId);
        _this.fundingSourceSelected = _this.userAccount.defaultFundingSourceId;
      }).catch(function (err) {
        _this.userDetailLoading = false;
        if (err !== 'UNAUTHORIZED') {
          _this.setErrorsModalInfo(['We could not retrieve user detail']);
          _this.showErrorsModal();
        }
      });
    },
    loadInvestmentsValidations: function loadInvestmentsValidations() {
      this.minimumInvestmentAmount = this.investmentsRestrictions.minimumAmount;
      this.investmentAmountError = 'Please invest at least ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* formatAmount */])(parseInt(this.minimumInvestmentAmount, 10)) + ' in order to proceed';
    },
    removeNegative: function removeNegative() {
      this.investmentAmount = this.investmentAmount.toString().replace('-', '');
      this.distributorFee = this.distributorFee.toString().replace('-', '');
      this.brokerageFee = this.brokerageFee.toString().replace('-', '');
    },
    validateInvestmentAmount: function validateInvestmentAmount() {
      var investmentAmountValue = this.getUnformattedValue(this.investmentAmount);
      if (investmentAmountValue < this.minimumInvestmentAmount) {
        this.isInvestmentAmountInvalid = true;
      } else {
        this.isInvestmentAmountInvalid = false;
      }
    },
    validateCusip: function validateCusip() {
      if (!this.cusip || this.cusip.includes('_')) {
        this.isCusipInvalid = true;
      } else {
        this.isCusipInvalid = false;
      }
    },
    validateDateFunded: function validateDateFunded() {
      var dateFunded = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.dateFunded);
      var today = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
      var dayDifference = dateFunded.diff(today, 'days');
      this.dateFundedInThePastError = dayDifference < -10;
      this.dateFundedInTheFutureError = dateFunded > today;
      this.isDateFundedInvalid = this.dateFundedInThePastError || this.dateFundedInTheFutureError;
    },
    rateChanged: function rateChanged(newRate) {
      this.rate = newRate;
    },
    termChanged: function termChanged(newTerm) {
      this.term = newTerm;
    },
    isSubmitButtonDisabled: function isSubmitButtonDisabled() {
      var _this2 = this;

      var investmentAmountValue = this.getUnformattedValue(this.investmentAmount);
      if (investmentAmountValue < this.minimumInvestmentAmount) {
        return true;
      }
      if (!this.fundingSourceSelected) {
        return true;
      }
      if (!this.dateFunded || this.isDateFundedInvalid) {
        return true;
      }
      var brokerageOption = this.fundingSources.find(function (fs) {
        return fs.type === _this2.fundingSourceTypes.BROKERAGE.name;
      });
      if (brokerageOption && this.fundingSourceSelected === brokerageOption.name && (!this.cusip || this.cusip.includes('_'))) {
        return true;
      }

      if (!this.isRateAndTermValid) {
        return true;
      }
      return false;
    },
    getUnformattedValue: function getUnformattedValue(value) {
      var unformattedValue = value.toString().replace('$', '').replace(/,/g, '');
      return this.formatDecimal(unformattedValue);
    },
    submitRequest: function submitRequest() {
      var _this3 = this;

      var purchaseObject = {
        userId: this.userId,
        investmentAmount: this.getUnformattedValue(this.investmentAmount).toFixed(2),
        rate: this.rate,
        term: this.term,
        fundingSourceType: this.fundingSourceSelected,
        dateFunded: __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.dateFunded).format(this.dateFormat).toString(),
        distributorFee: this.getUnformattedValue(this.distributorFee).toFixed(2),
        brokerageFee: this.getUnformattedValue(this.brokerageFee).toFixed(2),
        cusip: this.cusip
      };

      this.isSubmitting = true;

      this.purchaseNote({
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          accountId: this.accountId
        }, purchaseObject)
      }).then(function () {
        _this3.isSubmitting = false;
        _this3.goBack();
      }).catch(function () {
        _this3.isSubmitting = false;
        _this3.setErrorsModalInfo(['Something went wrong. Please try again.']);
        _this3.showErrorsModal();
      });
    },
    rateAndTermIsInvalid: function rateAndTermIsInvalid() {
      this.isRateAndTermValid = false;
    },
    rateAndTermIsValid: function rateAndTermIsValid() {
      this.isRateAndTermValid = true;
    },
    goBack: function goBack() {
      this.$router.go(-1);
    }
  })
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_OnboardingWizard__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_OnboardingWizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_OnboardingWizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TermsOfConditions__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TermsOfConditions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_TermsOfConditions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_money__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_static_constants__ = __webpack_require__(16);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















var mix = {
  methods: {
    formatAmount: __WEBPACK_IMPORTED_MODULE_11__util__["c" /* formatAmount */],
    formatDecimal: __WEBPACK_IMPORTED_MODULE_11__util__["q" /* formatDecimal */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'purchaseNote',
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, isRedirected;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.checkUserStatus();

            case 2:
              _ref = _context.sent;
              isRedirected = _ref.isRedirected;

              if (!isRedirected) {
                _context.next = 6;
                break;
              }

              return _context.abrupt('return');

            case 6:
              _this.hideQuestionModal();
              _this.loadYearsRates();
              _this.loadFundingSources();
              _this.loadInvestmentsValidations();
              _this.setActiveAccountIndex();

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  components: {
    errors: __WEBPACK_IMPORTED_MODULE_4__components_modals_Errors___default.a,
    question: __WEBPACK_IMPORTED_MODULE_5__components_modals_Question___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default.a,
    'onboarding-wizard': __WEBPACK_IMPORTED_MODULE_7__components_OnboardingWizard___default.a,
    TermsOfConditions: __WEBPACK_IMPORTED_MODULE_8__components_TermsOfConditions___default.a
  },
  mixins: [mix],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['activeAccount', 'activeAccountId', 'user', 'investmentsRestrictions']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('home', ['userStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('note', ['purchasingNote']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('question', ['display']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['hasBeenCreatedAccount'])),
  data: function data() {
    return {
      fundingSources: [],
      interestYearRates: [],
      interestYearRateSelected: null,
      fundingSourceSelected: null,
      investmentAmount: null,
      dwollaTermsCheck: false,
      maximumInvestmentAmount: null,
      minimumInvestmentAmount: null,
      investmentAmountError: '',
      interestYearRateErrorMessage: '',
      fundingSourceErrorMessage: '',
      prospectusAndDwollaTermsErrorMessage: '',
      dwollaTermsUrl: __WEBPACK_IMPORTED_MODULE_12__data_static_constants__["a" /* Constants */].purchaseNote.dwollaTermsUrl,
      prospectusTermUrl: __WEBPACK_IMPORTED_MODULE_12__data_static_constants__["a" /* Constants */].purchaseNote.prospectusTermUrl,
      loading: false,
      isInvestmentAmountInvalid: false,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        precision: 2
      }
    };
  },

  directives: {
    money: __WEBPACK_IMPORTED_MODULE_9_v_money__["VMoney"]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_10__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_10__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('account', ['getAccountFundingSources']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('home', ['getUserStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('note', ['getInterestYearRates', 'purchaseNote']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_10__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_10__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), {
    setActiveAccountIndex: function setActiveAccountIndex() {
      var _this2 = this;

      var activeAccount = this.user.accounts.find(function (ac) {
        return ac.id === _this2.activeAccountId;
      });
      this.activeAccountIndex = this.user.accounts.indexOf(activeAccount);
    },
    loadInvestmentsValidations: function loadInvestmentsValidations() {
      this.minimumInvestmentAmount = this.investmentsRestrictions.minimumAmount;
      this.investmentAmountError = 'Please invest at least ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util__["c" /* formatAmount */])(parseInt(this.minimumInvestmentAmount, 10)) + ' in order to proceed';
    },
    loadYearsRates: function loadYearsRates() {
      var _this3 = this;

      this.getInterestYearRates().then(function (interestYearRates) {
        _this3.interestYearRates = interestYearRates;
      });
    },
    loadAccountInformation: function loadAccountInformation() {
      var account = this.user.accounts[0];
      this.fundingSourceSelected = !account.defaultFundingSourceId ? this.fundingSources[0].id : account.defaultFundingSourceId;
    },
    loadFundingSources: function loadFundingSources() {
      var _this4 = this;

      this.getAccountFundingSources(this.activeAccountId).then(function (fundingSources) {
        _this4.fundingSources = fundingSources.filter(function (fss) {
          return fss.type === 'bank' && fss.status === 'verified';
        });

        _this4.loadAccountInformation();
      });
    },
    resetValidations: function resetValidations() {
      this.investmentAmountError = '';
      this.interestYearRateErrorMessage = '';
      this.fundingSourceErrorMessage = '';
      this.prospectusAndDwollaTermsErrorMessage = '';
    },
    isInvestmentAmountValid: function isInvestmentAmountValid() {
      this.validateInvestmentAmount();
      return !this.isInvestmentAmountInvalid;
    },
    validateInvestmentAmount: function validateInvestmentAmount() {
      var investmentAmountValue = this.getUnformattedValue(this.investmentAmount);
      this.isInvestmentAmountInvalid = false;
      this.investmentAmountError = '';

      if (investmentAmountValue === null || investmentAmountValue === '' || typeof investmentAmountValue === 'undefined') {
        if (!this.investmentAmount && this.investmentAmount !== 0) {
          this.investmentAmountError = __WEBPACK_IMPORTED_MODULE_12__data_static_constants__["a" /* Constants */].purchaseNote.investmentRequiredError;
          this.isInvestmentAmountInvalid = true;
          return;
        }
      }

      var numericAmount = parseFloat(investmentAmountValue);
      var HARDCODED_MAX_AMOUNT = 100000;

      if (numericAmount < this.minimumInvestmentAmount) {
        this.isInvestmentAmountInvalid = true;
        this.investmentAmountError = 'Please invest at least ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util__["c" /* formatAmount */])(parseInt(this.minimumInvestmentAmount, 10)) + ' in order to proceed';
      } else if (numericAmount > HARDCODED_MAX_AMOUNT) {
        this.isInvestmentAmountInvalid = true;
        this.investmentAmountError = 'The maximum per-transaction amount is $100,000.00. If you would like to invest a higher amount, you can make multiple $100,000 or less purchases in a row, and contact us to combine them into one Note.';
      } else {
        this.isInvestmentAmountInvalid = false;
        this.investmentAmountError = '';
      }
    },
    isFormValid: function isFormValid() {
      this.resetValidations();

      if (!this.interestYearRateSelected) {
        this.interestYearRateErrorMessage = __WEBPACK_IMPORTED_MODULE_12__data_static_constants__["a" /* Constants */].purchaseNote.interestYearRateError;
      }

      if (!this.fundingSourceSelected) {
        this.fundingSourceErrorMessage = __WEBPACK_IMPORTED_MODULE_12__data_static_constants__["a" /* Constants */].purchaseNote.fundingSourceError;
      }

      if (!this.dwollaTermsCheck) {
        this.prospectusAndDwollaTermsErrorMessage = __WEBPACK_IMPORTED_MODULE_12__data_static_constants__["a" /* Constants */].purchaseNote.propectusAndDwollaTermsError;
      }

      var isInvestmentAmountValid = this.isInvestmentAmountValid();

      var isValid = this.interestYearRateErrorMessage === '' && this.fundingSourceErrorMessage === '' && isInvestmentAmountValid && this.prospectusAndDwollaTermsErrorMessage === '';

      return isValid;
    },
    methodToExecuteInQuestionModal: function methodToExecuteInQuestionModal(_ref2) {
      var _this5 = this;

      var data = _ref2.data;

      this.hideQuestionModal();
      this.purchaseNote({
        data: data
      }).then(function () {
        if (_this5.$route.query.first) {
          _this5.$router.push({
            name: 'AccountSummary',
            params: { purchasedNote: true }
          });
        } else {
          _this5.$router.push({
            name: 'Notes',
            params: { purchasedNote: true }
          });
        }
        window.dataLayer.push({
          event: 'purchaseNote',
          userID: _this5.user.userId
        });
      }).catch(function () {
        _this5.setErrorsModalInfo(['Something went wrong. Please try again.']);
        _this5.showErrorsModal();
      });
    },
    validateAndSubmitInvestment: function validateAndSubmitInvestment() {
      var _this6 = this;

      var isFormValid = this.isFormValid();
      var unformattedValue = this.getUnformattedValue(this.investmentAmount);
      var investmentAmount = parseFloat(unformattedValue.toFixed(2));
      if (isFormValid) {
        var data = {
          fundingSourceId: this.fundingSourceSelected,
          interestYearRateId: this.interestYearRateSelected,
          accountId: this.activeAccountId,
          investmentAmount: investmentAmount
        };

        this.showQuestionModal({
          title: __WEBPACK_IMPORTED_MODULE_12__data_static_constants__["a" /* Constants */].purchaseNote.modalTitle,
          question: __WEBPACK_IMPORTED_MODULE_12__data_static_constants__["a" /* Constants */].purchaseNote.modalQuestion,
          method: function method() {
            _this6.methodToExecuteInQuestionModal({
              data: data
            });
          },
          yesButtonText: __WEBPACK_IMPORTED_MODULE_12__data_static_constants__["a" /* Constants */].purchaseNote.modalYesButtonText,
          hideCancelButton: false
        });
      }
    },
    checkUserStatus: function checkUserStatus() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this7.loading = true;

                if (_this7.hasBeenCreatedAccount) {
                  _context2.next = 4;
                  break;
                }

                _this7.$router.push({ name: 'AccountSummary' });
                return _context2.abrupt('return', {
                  isRedirected: true
                });

              case 4:
                return _context2.abrupt('return', _this7.getUserStatus({
                  accountId: _this7.activeAccount.id
                }).then(function (_ref3) {
                  var status = _ref3.status,
                      needs = _ref3.needs;

                  if (status === 'suspended') {
                    _this7.$router.push({ name: 'AccountSuspended' });
                    return {
                      isRedirected: true
                    };
                  } else if (needs.includes('FUNDING_SOURCE')) {
                    _this7.$router.push({ name: 'AddFundingSource' });
                    return {
                      isRedirected: true
                    };
                  }
                  _this7.loading = false;
                  return {
                    isRedirected: false
                  };
                }).catch(function () {
                  _this7.loading = false;
                }));

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7);
      }))();
    },
    isSubmitButtonDisabled: function isSubmitButtonDisabled() {
      var investmentAmountValue = this.getUnformattedValue(this.investmentAmount);
      var numericAmount = parseFloat(investmentAmountValue);
      var HARDCODED_MAX_AMOUNT = 100000;

      var isInvalidForSubmit = false;
      if (numericAmount < this.minimumInvestmentAmount) {
        isInvalidForSubmit = true;
      } else if (numericAmount > HARDCODED_MAX_AMOUNT) {
        isInvalidForSubmit = true;
      }

      return isInvalidForSubmit || !this.fundingSourceSelected || !this.interestYearRateSelected || !this.dwollaTermsCheck;
    },
    getUnformattedValue: function getUnformattedValue(value) {
      var unformattedValue = value ? value.toString().replace('$', '').replace(/,/g, '') : '';
      return this.formatDecimal(unformattedValue);
    },
    removeNegative: function removeNegative() {
      if (this.investmentAmount === null) return;
      this.investmentAmount = this.investmentAmount.toString().replace('-', '');
    }
  })
});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_HttpService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(9);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecentRecords',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      records: []
    };
  },
  beforeMount: function beforeMount() {
    this.loadRecentRecords();
  },

  methods: {
    loadRecentRecords: function loadRecentRecords() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__api_HttpService__["a" /* default */].getV2('recent-records');

              case 3:
                data = _context.sent;

                _this.records = Array.isArray(data) ? data : [];
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                _this.records = [];

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    typeLabel: function typeLabel(type) {
      if (type === 'user') return 'User';
      if (type === 'account') return 'Account';
      if (type === 'note') return 'Note';
      return '';
    },
    displayLabel: function displayLabel(record) {
      if (record.type === 'user') {
        var fullName = ((record.firstName || '') + ' ' + (record.lastName || '')).trim();
        return fullName ? 'U' + record.id + ' - ' + fullName : 'U' + record.id;
      }
      if (record.type === 'account') {
        return record.accountName ? 'A' + record.id + ' - ' + record.accountName : 'A' + record.id;
      }
      if (record.type === 'note') {
        return record.noteId || '#' + record.id;
      }
      return '';
    },
    formatViewedAt: function formatViewedAt(viewedAt) {
      if (!viewedAt) return '';
      var d = new Date(viewedAt);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(d.getTime())) return '';
      return d.toLocaleString();
    },
    goTo: function goTo(record) {
      if (record.type === 'user') {
        this.$router.push({
          name: 'UserDetail',
          params: {
            userId: record.id,
            name: record.firstName || ''
          }
        });
        return;
      }
      if (record.type === 'account') {
        var accountTypeProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["n" /* getAccounTypeProperties */])(record.accountType);
        var routeName = accountTypeProps && accountTypeProps.component || 'AccountDetail';
        this.$router.push({
          name: routeName,
          params: {
            accountId: record.id,
            userId: record.userId,
            name: record.userFirstName || ''
          }
        });
        return;
      }
      if (record.type === 'note') {
        this.$router.push({
          name: 'NoteDetail',
          params: {
            noteId: record.id,
            userId: record.userId,
            name: record.userFirstName || ''
          }
        });
      }
    }
  }
});

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_money__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Breadcrumb__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_static_userTypes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_static_upcomingTransactionActions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_formControls_RestrictedTextArea__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_formControls_RestrictedTextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_formControls_RestrictedTextArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_static_constants__ = __webpack_require__(16);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















var mix = {
  methods: {
    formatDecimal: __WEBPACK_IMPORTED_MODULE_8__util__["q" /* formatDecimal */],
    formatNegativeAmount: __WEBPACK_IMPORTED_MODULE_8__util__["r" /* formatNegativeAmount */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'redeem',
  beforeMount: function beforeMount() {
    this.setParams();
    this.loadRedeemNote();
  },

  mixins: [mix],
  components: {
    errors: __WEBPACK_IMPORTED_MODULE_5__components_modals_Errors___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner___default.a,
    question: __WEBPACK_IMPORTED_MODULE_10__components_modals_Question___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_11__components_Breadcrumb___default.a,
    'restricted-textarea': __WEBPACK_IMPORTED_MODULE_14__components_formControls_RestrictedTextArea___default.a
  },
  watch: {
    redeemNote: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(newRedeemNote) {
        var _newRedeemNote$accoun, accountName, accountType, accountId, users, params, user, userType, firstName, lastName, goto, accountTypeProperties, gotoAccount;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _newRedeemNote$accoun = newRedeemNote.account, accountName = _newRedeemNote$accoun.accountName, accountType = _newRedeemNote$accoun.accountType, accountId = _newRedeemNote$accoun.id;
                _context.next = 3;
                return this.getAccountUsers(this.accountId);

              case 3:
                users = _context.sent;

                this.breadcrumbData = [];
                this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
                  title: 'Search',
                  goto: { name: 'Users' },
                  selected: false
                }));
                params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.$route.params);
                user = users.find(function (search) {
                  return search.id === Number(params.userId);
                });
                userType = user.userType, firstName = user.firstName, lastName = user.lastName;
                goto = void 0;

                if (userType === __WEBPACK_IMPORTED_MODULE_12__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name) {
                  goto = {
                    name: 'EditFinancialAdvisor',
                    params: {
                      name: params.name,
                      userId: params.userId
                    }
                  };
                } else {
                  goto = { name: 'UserDetail', params: { name: params.name, userId: params.userId } };
                }
                this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
                  goto: goto,
                  title: firstName.concat(' ', lastName),
                  selected: false
                }));
                accountTypeProperties = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["n" /* getAccounTypeProperties */])(accountType);
                gotoAccount = {
                  name: accountTypeProperties.component,
                  params: {
                    accountId: accountId,
                    name: params.name,
                    userId: params.userId
                  }
                };

                this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
                  title: accountName,
                  goto: gotoAccount,
                  selected: false
                }));
                this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
                  title: 'Note'.concat(' ', newRedeemNote.noteId),
                  goto: { name: 'NoteDetail', params: this.$route.params },
                  selected: false
                }));
                this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
                  title: 'Redeem',
                  goto: { name: this.$route.name, params: this.$route.params },
                  selected: true
                }));

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function changeNote(_x) {
        return _ref.apply(this, arguments);
      }

      return changeNote;
    }()
  },
  data: function data() {
    return {
      noteId: '',
      userId: '',
      name: '',
      accountId: '',
      breadcrumbData: [],
      redeemNote: {
        principalAmount: 0,
        interestToReedem: 0,
        currentAccrintValue: 0,
        serviceFee: 0,
        redeemAmount: 0,
        redemptionCategoryId: 0,
        redemptionCategoryHelperText: '',
        redemptionCategories: []
      },
      initialComment: '',
      totalPaidOut: 0,
      loading: false,
      noteHasSufficientFunds: false,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        precision: 2
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('question', ['display']), {
    donateFundingSource: function donateFundingSource() {
      return __WEBPACK_IMPORTED_MODULE_13__data_static_upcomingTransactionActions__["a" /* default */].donate;
    },
    displayRedemptionCategoryHelperText: function displayRedemptionCategoryHelperText() {
      var _this = this;

      var category = this.redeemNote.redemptionCategories.find(function (redemptionCategory) {
        return redemptionCategory.id === _this.redeemNote.redemptionCategoryId;
      }) || {};
      if (!category.needsHelperText) {
        this.redeemNote.redemptionCategoryHelperText = '';
      }
      return category.needsHelperText || false;
    },
    disableApprove: function disableApprove() {
      return this.redeemNote.isNewRedemption || !this.noteHasSufficientFunds || this.isButtonDisabled() || this.displayRedemptionCategoryHelperText && this.redeemNote.redemptionCategoryHelperText === '';
    },
    disableSubmit: function disableSubmit() {
      return !this.redeemNote.isNewRedemption || this.isButtonDisabled() || this.displayRedemptionCategoryHelperText && this.redeemNote.redemptionCategoryHelperText === '';
    }
  }),
  directives: {
    money: __WEBPACK_IMPORTED_MODULE_6_v_money__["VMoney"]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    commentUpdated: function commentUpdated($event) {
      this.redeemNote.comment = $event;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('note', ['getRedeemNote', 'getAccountNoteRedeem', 'validateRedemptionFunds', 'requestNoteRedemption', 'approveNoteRedemption', 'cancelNoteRedemption']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('account', ['getAccountUsers']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), {
    displayPaidOutError: function displayPaidOutError(redeemFull) {
      return !redeemFull && (this.totalPaidOut <= 0 || this.getUnformattedValue(this.redeemNote.redeemAmount) <= 0 || this.getUnformattedValue(this.redeemNote.redeemAmount) <= this.getUnformattedValue(this.redeemNote.serviceFee));
    },
    setParams: function setParams() {
      this.name = this.$route.params.name;
      this.userId = this.$route.params.userId;
      this.noteId = this.$route.params.noteId;
      this.accountId = this.$route.params.accountId;
    },
    validateRedeemFunds: function validateRedeemFunds() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                return _context2.abrupt('return', _this2.validateRedemptionFunds(_this2.noteId).then(function (_ref2) {
                  var isValid = _ref2.isValid;

                  _this2.noteHasSufficientFunds = isValid;
                  _this2.loading = false;
                }).catch(function (err) {
                  _this2.loading = false;
                  if (err !== 'UNAUTHORIZED') {
                    _this2.setErrorsModalInfo(['We could not validate the note\'s fund.']);
                    _this2.showErrorsModal();
                  }
                }));

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    loadRedeemNote: function loadRedeemNote() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loading = true;
                _context3.next = 3;
                return _this3.getAccountNoteRedeem({
                  noteId: _this3.noteId,
                  accountId: _this3.accountId
                }).then(function (redeemNote) {
                  _this3.redeemNote = redeemNote;
                  _this3.redeemNote.principalAmount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["q" /* formatDecimal */])(redeemNote.principalAmount);
                  _this3.redeemNote.serviceFee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["q" /* formatDecimal */])(redeemNote.serviceFee).toFixed(2);
                  _this3.redeemNote.interestToReedem = _this3.redeemNote.redeemFull ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["q" /* formatDecimal */])(_this3.redeemNote.currentAccrintValue).toFixed(2) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["q" /* formatDecimal */])(_this3.redeemNote.interestToReedem).toFixed(2);
                  _this3.redeemNote.redeemAmount = redeemNote.isNewRedemption ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["q" /* formatDecimal */])(redeemNote.principalAmount).toFixed(2) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["q" /* formatDecimal */])(redeemNote.redeemAmount).toFixed(2);

                  _this3.redeemNote.fundingSources = redeemNote.fundingSources.filter(function (fundingSource) {
                    return (fundingSource.type === 'bank' || fundingSource.type === 'check' || fundingSource.type === 'wire/ach') && fundingSource.status === 'verified' && !fundingSource.removed;
                  });

                  _this3.initialComment = redeemNote.comment;
                  _this3.loading = false;
                  if (!redeemNote.isNewRedemption) {
                    _this3.validateRedeemFunds();
                  }
                }).catch(function (err) {
                  _this3.loading = false;
                  if (err !== 'UNAUTHORIZED') {
                    _this3.setErrorsModalInfo(['We could not retrieve the redeem note details.']);
                    _this3.showErrorsModal();
                  }
                });

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    checkRemainingPrincipalAmount: function checkRemainingPrincipalAmount() {
      var redeemAmount = this.getUnformattedValue(this.redeemNote.redeemAmount);
      var remainingAmount = this.redeemNote.principalAmount - redeemAmount;
      if (!this.redeemNote.redeemFull && remainingAmount < 20) {
        return true;
      }
      return false;
    },
    removeNegative: function removeNegative() {
      this.redeemNote.redeemAmount = this.redeemNote.redeemAmount.toString().replace('-', '');
      this.redeemNote.serviceFee = this.redeemNote.serviceFee.toString().replace('-', '');
      this.redeemNote.interestToReedem = this.redeemNote.interestToReedem.toString().replace('-', '');
    },
    resetRadioValue: function resetRadioValue() {
      this.redeemNote.serviceFee = 0;
      if (this.redeemNote.redeemFull) {
        this.redeemNote.redeemAmount = this.redeemNote.principalAmount;
        this.redeemNote.interestToReedem = this.redeemNote.currentAccrintValue;
      } else {
        this.redeemNote.redeemAmount = 0;
        this.redeemNote.interestToReedem = 0;
      }
    },
    getUnformattedValue: function getUnformattedValue(value) {
      var unformattedValue = value.toString().replace('$', '').replace(/,/g, '');
      return this.formatDecimal(unformattedValue);
    },
    getTotalAmount: function getTotalAmount() {
      var redeemAmount = this.getUnformattedValue(this.redeemNote.redeemAmount);
      var redeemInterest = this.formatDecimal(this.getUnformattedValue(this.redeemNote.interestToReedem));
      return redeemAmount + redeemInterest;
    },
    getTotalPaidOut: function getTotalPaidOut() {
      var redeemAmount = this.getUnformattedValue(this.redeemNote.redeemAmount);
      var serviceFee = this.getUnformattedValue(this.redeemNote.serviceFee);
      var totalAmount = redeemAmount + this.formatDecimal(this.getUnformattedValue(this.redeemNote.interestToReedem));
      this.totalPaidOut = totalAmount - serviceFee;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["r" /* formatNegativeAmount */])(this.totalPaidOut);
    },
    getPrincipalToRepay: function getPrincipalToRepay() {
      var redeemAmount = this.getUnformattedValue(this.redeemNote.redeemAmount);
      var serviceFee = this.getUnformattedValue(this.redeemNote.serviceFee);
      var amountToRepay = redeemAmount - serviceFee;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["r" /* formatNegativeAmount */])(amountToRepay);
    },
    isCancelButtonDisabled: function isCancelButtonDisabled() {
      if (!this.redeemNote.comment) {
        return true;
      }
      if (this.initialComment === this.redeemNote.comment) {
        return true;
      }
      return false;
    },
    currentFundingSourceExists: function currentFundingSourceExists() {
      var _this4 = this;

      if (!this.redeemNote.fundingSource) {
        return false;
      }

      var existingFundingSource = this.redeemNote.fundingSources.filter(function (fundingSource) {
        return fundingSource.id.toString() === _this4.redeemNote.fundingSource.toString();
      });

      return existingFundingSource.length !== 0 || this.redeemNote.fundingSource === 'donate';
    },
    isButtonDisabled: function isButtonDisabled() {
      if (!this.redeemNote.comment) {
        return true;
      }
      if (this.initialComment === this.redeemNote.comment) {
        return true;
      }
      if (this.totalPaidOut <= 0) {
        return true;
      }
      var redeemAmount = this.getUnformattedValue(this.redeemNote.redeemAmount);
      var serviceFee = this.getUnformattedValue(this.redeemNote.serviceFee);
      var amountToRepay = redeemAmount - serviceFee;
      if (amountToRepay <= 0) {
        return true;
      }
      if (this.getUnformattedValue(this.redeemNote.redeemAmount) <= 0) {
        return true;
      }
      if (!this.redeemNote.fundingSources || !this.currentFundingSourceExists()) {
        return true;
      }
      if (this.checkRemainingPrincipalAmount()) {
        return true;
      }
      if (!this.redeemNote.redeemFull && this.getUnformattedValue(this.redeemNote.interestToReedem) > this.getUnformattedValue(this.redeemNote.currentAccrintValue)) {
        return true;
      }
      return false;
    },
    getInterestToRedeem: function getInterestToRedeem() {
      if (this.redeemNote.redeemFull) {
        return this.redeemNote.currentAccrintValue;
      } else if (!this.redeemNote.redeemFull && this.redeemNote.interestToReedem === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["r" /* formatNegativeAmount */])(this.redeemNote.currentAccrintValue)) {
        // eslint-disable-line max-len
        return this.redeemNote.currentAccrintValue;
      }
      return this.getUnformattedValue(this.redeemNote.interestToReedem);
    },
    submitRequest: function submitRequest() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var redeemRequest;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                redeemRequest = {
                  isRedeemFull: _this5.redeemNote.redeemFull,
                  amount: _this5.getUnformattedValue(_this5.redeemNote.redeemAmount),
                  serviceFee: _this5.getUnformattedValue(_this5.redeemNote.serviceFee),
                  comment: _this5.redeemNote.comment,
                  fundingSourceId: _this5.redeemNote.fundingSource.toString(),
                  interestAmount: _this5.getInterestToRedeem(),
                  categoryId: _this5.redeemNote.redemptionCategoryId,
                  categoryHelperText: _this5.redeemNote.redemptionCategoryHelperText
                };
                _context4.next = 4;
                return _this5.requestNoteRedemption({
                  noteId: _this5.noteId,
                  accountId: _this5.accountId,
                  payload: redeemRequest
                });

              case 4:
                _this5.loading = false;
                _this5.$router.push({
                  name: 'NoteDetail',
                  params: {
                    name: _this5.name,
                    noteId: _this5.noteId,
                    userId: _this5.userId
                  }
                });
                _context4.next = 13;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](0);

                _this5.loading = false;
                _this5.setErrorsModalInfo(['There was an error when submitting a request.']);
                _this5.showErrorsModal();

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 8]]);
      }))();
    },
    approveRedemption: function approveRedemption() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var redeemRequest;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.loading = true;
                redeemRequest = {
                  redeemServiceFee: _this6.getUnformattedValue(_this6.redeemNote.serviceFee),
                  redeemComment: _this6.redeemNote.comment,
                  redemptionCategoryId: _this6.redeemNote.redemptionCategoryId,
                  redemptionCategoryHelperText: _this6.redeemNote.redemptionCategoryHelperText
                };
                return _context5.abrupt('return', _this6.approveNoteRedemption({
                  noteId: _this6.noteId,
                  redeemRequest: redeemRequest
                }).then(function () {
                  _this6.loading = false;
                  _this6.$router.push({
                    name: 'NoteDetail',
                    params: {
                      name: _this6.name,
                      noteId: _this6.noteId,
                      userId: _this6.userId
                    }
                  });
                }).catch(function () {
                  _this6.loading = false;
                  _this6.setErrorsModalInfo(['There was an error when approving a request.']);
                  _this6.showErrorsModal();
                }));

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    showRedeemConfirmationModal: function showRedeemConfirmationModal() {
      var _this7 = this;

      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_15__data_static_constants__["a" /* Constants */].redeem.modalTitle,
        question: __WEBPACK_IMPORTED_MODULE_15__data_static_constants__["a" /* Constants */].redeem.modalQuestion,
        method: function () {
          var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
            var redeemRequest;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.prev = 0;
                    redeemRequest = {
                      comment: _this7.redeemNote.comment
                    };

                    _this7.loading = true;
                    _context6.next = 5;
                    return _this7.cancelNoteRedemption({
                      noteId: _this7.noteId,
                      accountId: _this7.accountId,
                      payload: redeemRequest
                    });

                  case 5:
                    _this7.loading = false;
                    _this7.hideQuestionModal();
                    _this7.$router.push({
                      name: 'NoteDetail',
                      params: {
                        name: _this7.name,
                        noteId: _this7.noteId,
                        userId: _this7.userId
                      }
                    });
                    _context6.next = 15;
                    break;

                  case 10:
                    _context6.prev = 10;
                    _context6.t0 = _context6['catch'](0);

                    _this7.loading = false;
                    _this7.setErrorsModalInfo(['There was an error when canceling a request.']);
                    _this7.hideQuestionModal();

                  case 15:
                  case 'end':
                    return _context6.stop();
                }
              }
            }, _callee6, _this7, [[0, 10]]);
          }));

          return function method() {
            return _ref3.apply(this, arguments);
          };
        }(),
        yesButtonText: __WEBPACK_IMPORTED_MODULE_15__data_static_constants__["a" /* Constants */].redeem.modalYesButtonText,
        hideCancelButton: false
      });
    },
    goBack: function goBack() {
      this.$router.go(-1);
    }
  })
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_recaptcha__ = __webpack_require__(2213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_recaptcha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_static_constants__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContactUsHeader__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContactUsHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ContactUsHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PasswordHint__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PasswordHint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__PasswordHint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AddFundingSource__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AddFundingSource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AddFundingSource__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'registration',
  beforeMount: function beforeMount() {
    if (this.$route.query.email && this.$route.query.message && this.$route.query.success === 'true') {
      this.$router.push({
        path: 'login',
        query: this.$route.query
      });
    }
    this.setIdleOff();
  },
  data: function data() {
    return {
      recaptchaIsVerified: false,
      sitekey: __WEBPACK_IMPORTED_MODULE_3__config_config__["e" /* auth */].recaptchaSitekey,
      email: '',
      password: '',
      passwordConfirmation: '',
      state: '',
      recaptchaResponse: '',
      showPassword: false,
      emailError: '',
      passwordErrors: [],
      passConfirmationError: '',
      stateError: '',
      registrationError: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('app', ['hasBeenDisabledSignUp', 'geoLocation']), {
    filteredStates: function filteredStates() {
      return this.geoLocation.states.filter(function (state) {
        return !state.onlyMailingAddress;
      });
    },

    computedEmail: {
      get: function get() {
        return this.email;
      },
      set: function set(value) {
        this.email = value.toLowerCase();
      }
    }
  }),
  components: {
    'vue-recaptcha': __WEBPACK_IMPORTED_MODULE_4_vue_recaptcha___default.a,
    ContactUsHeader: __WEBPACK_IMPORTED_MODULE_6__ContactUsHeader___default.a,
    PasswordHint: __WEBPACK_IMPORTED_MODULE_7__PasswordHint___default.a,
    AddFundingSource: __WEBPACK_IMPORTED_MODULE_8__AddFundingSource___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('authentication', ['register']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('authentication', {
    setIdleOff: __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["L" /* SET_IDLE_OFF */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('success', {
    showSuccessModal: __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["H" /* SHOW_SUCCESS_MODAL */]
  }), {
    onVerify: function onVerify(response) {
      this.recaptchaResponse = response;
      this.recaptchaIsVerified = true;
    },
    resetValidations: function resetValidations() {
      this.emailError = '';
      this.passwordErrors = [];
      this.passConfirmationError = '';
      this.stateError = '';
      this.registrationError = '';
    },
    validateAndSubmitRegistration: function validateAndSubmitRegistration() {
      var _this = this;

      this.resetValidations();
      var isEmailValid = this.validateEmail(this.email);
      var isStateValid = this.validateState(this.state);
      var isPasswordValid = this.validatePassword(this.password);
      var isPasswordConfirmationValid = this.validatePasswordConfirmation(this.password, this.passwordConfirmation);
      if (!isEmailValid || !isStateValid || !isPasswordValid || !isPasswordConfirmationValid || !this.recaptchaIsVerified) {
        return false;
      }
      var email = this.email,
          password = this.password,
          state = this.state,
          recaptchaResponse = this.recaptchaResponse;

      return this.register({
        email: email,
        password: password,
        state: state,
        recaptchaResponse: recaptchaResponse
      }).then(function (response) {
        if (response.error) {
          _this.registrationError = response.message;
        } else {
          _this.showSuccessModal(__WEBPACK_IMPORTED_MODULE_5__data_static_constants__["a" /* Constants */].registration.successMessage);
          _this.$router.push({ name: 'Login' });
          window.dataLayer.push({
            event: 'registerAccount',
            userID: 'new_user:' + _this.email
          });
        }
      }).catch(function (response) {
        if (response.error) {
          if (response.message.includes('If you entered a registered email in our system')) {
            _this.emailError = response.message;
            return;
          }
          _this.registrationError = response.message;
        }
      }).finally(function () {
        _this.$refs.recaptcha.reset();
      });
    },
    validateEmail: function validateEmail(email) {
      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
      if (!regex.test(email)) {
        this.emailError = 'Please, enter a valid email';
        return false;
      }
      return true;
    },
    validatePassword: function validatePassword(password) {
      if (password.length < 8) {
        this.passwordErrors.push('Password should have a minimum length of 8 characters');
      }
      if (!/[A-Z]/.test(password)) {
        this.passwordErrors.push('Password should have at least one uppercase letter');
      }
      if (!/[a-z]/.test(password)) {
        this.passwordErrors.push('Password should have at least one lowercase letter');
      }
      if (!/[0-9]/.test(password)) {
        this.passwordErrors.push('Password should have at least one number');
      }
      if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) {
        this.passwordErrors.push('Password should have at least one special character');
      }
      return this.passwordErrors.length === 0;
    },
    validatePasswordConfirmation: function validatePasswordConfirmation(pass1, pass2) {
      if (pass1 !== pass2) {
        this.passConfirmationError = 'Passwords should match';
        return false;
      }
      return true;
    },
    validateState: function validateState(state) {
      if (!state) {
        this.stateError = 'Please select a state';
        return false;
      }
      return true;
    }
  })
});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContactUsHeader__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContactUsHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ContactUsHeader__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'resetPassword',
  components: {
    ContactUsHeader: __WEBPACK_IMPORTED_MODULE_4__ContactUsHeader___default.a
  },
  created: function created() {
    var _$route$query = this.$route.query,
        email = _$route$query.email,
        resetEmail = _$route$query.resetEmail;

    if (resetEmail) {
      this.email = decodeURIComponent(email) || '';
    }
  },
  data: function data() {
    return {
      resetMessage: "Password Reset Email Sent. If you entered a registered email in our system, we've sent you a link to reset your password. If you don't receive an email within 5 minutes (and perhaps checked your spam and/or tried again to make sure email entered correctly), then please contact us at info@calvertimpact.org or 800.248.0337.",
      email: '',
      emailError: '',
      resetPasswordError: '',
      linkExpiredError: '',
      resetFeedback: false
    };
  },

  computed: {
    linkExpired: function linkExpired() {
      return !!this.$route.query.resetEmail;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('authentication', ['forgotPassword']), {
    resetValidations: function resetValidations() {
      this.emailError = '';
      this.resetPasswordError = '';
    },
    validateAndSubmitResetPassword: function validateAndSubmitResetPassword() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var email, _ref, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.resetValidations();

                if (_this.validateEmail(_this.email)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', false);

              case 3:
                email = _this.email;
                _context.prev = 4;
                _context.next = 7;
                return _this.forgotPassword({ email: email });

              case 7:
                _ref = _context.sent;
                data = _ref.data;

                _this.resetFeedback = !!data;
                return _context.abrupt('return', true);

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](4);

                // TODO: stop using error
                _this.resetPasswordError = _context.t0.message;

              case 16:
                return _context.abrupt('return', false);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 13]]);
      }))();
    },
    validateEmail: function validateEmail(email) {
      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
      if (!regex.test(email)) {
        this.emailError = 'Please, enter a valid email';
        return false;
      }
      return true;
    }
  })
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_static_upcomingTransactionActions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RetryPayment',
  data: function data() {
    return {
      fundingSources: [],
      selectedFundingSource: '',
      comment: '',
      isLoading: true
    };
  },

  components: {
    spinner: __WEBPACK_IMPORTED_MODULE_6__components_widgets_Spinner___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['fundingSourceTypes']), {
    donateFundingSource: function donateFundingSource() {
      return __WEBPACK_IMPORTED_MODULE_5__data_static_upcomingTransactionActions__["a" /* default */].donate;
    },
    transactionAmount: function transactionAmount() {
      return this.$route.params.transaction.amount;
    },
    transactionId: function transactionId() {
      return this.$route.params.transaction.transactionId;
    },
    accountId: function accountId() {
      return this.$route.params.account.id;
    },
    id: function id() {
      return this.$route.params.transaction.id;
    },
    isSubmitDisabled: function isSubmitDisabled() {
      return this.errors.has('comment') || this.errors.has('fundingSource') || this.comment === '';
    }
  }),
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var fundingSources;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getAccountFundingSources(_this.$route.params.account.id);

            case 2:
              fundingSources = _context.sent;


              _this.fundingSources = fundingSources.filter(function (fss) {
                return fss.status === 'verified' && (fss.type === _this.fundingSourceTypes.BANK.name || fss.type === _this.fundingSourceTypes.CHECK.name || fss.type === _this.fundingSourceTypes.WIRE_TRANSFER.name);
              });
              _this.isLoading = false;

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('transaction', ['retryFailedTransaction']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('account', ['getAccountFundingSources']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), {
    submitRequest: function submitRequest() {
      var _this2 = this;

      this.isLoading = true;
      this.retryFailedTransaction({
        accountId: this.accountId,
        fundingSourceId: this.selectedFundingSource,
        transactionId: this.id,
        comment: this.comment
      }).then(function () {
        _this2.$router.push({ name: 'FailedTransactionList' });
      }).catch(function () {
        _this2.setErrorsModalInfo(['Something went wrong. Please try again.']);
        _this2.showErrorsModal();
      }).finally(function () {
        _this2.isLoading = false;
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    }
  })
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SearchByAccountResults',
  data: function data() {
    return {};
  },

  props: {
    results: {
      type: Object,
      required: true,
      default: {}
    },
    searchMessage: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
    account: function account() {
      return this.results.account;
    },
    hasNotes: function hasNotes() {
      if (this.account) {
        return this.account.notes.length > 0;
      }
      return false;
    },
    resultsLength: function resultsLength() {
      if (this.account) {
        return this.hasNotes ? this.account.notes.length : 1;
      }
      return 0;
    },
    user: function user() {
      return this.account.primaryInvestor;
    },
    userId: function userId() {
      return this.user ? this.user.id : 0;
    },
    userName: function userName() {
      return this.user ? this.user.firstName : '';
    },
    userType: function userType() {
      return this.user ? this.user.userType : '';
    },
    notes: function notes() {
      return this.account.notes;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['storeUserInSessionStorage']), {
    getAccountComponentAndAccountId: function getAccountComponentAndAccountId(account) {
      var accountTypeProperties = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["n" /* getAccounTypeProperties */])(account.accountType);
      return {
        component: accountTypeProperties.component,
        accountId: account.id,
        accountName: account.accountName
      };
    },
    goToNoteDetails: function goToNoteDetails(note) {
      var routeParams = {
        name: 'NoteDetail',
        params: {
          noteId: note.id,
          userId: this.userId,
          name: this.userName
        }
      };

      this.$router.push(routeParams);
    },
    goToAccountDetail: function goToAccountDetail(account) {
      var _getAccountComponentA = this.getAccountComponentAndAccountId(account),
          component = _getAccountComponentA.component,
          accountId = _getAccountComponentA.accountId;

      var routeParams = {
        name: component,
        params: {
          accountId: accountId,
          name: this.userName,
          userId: this.userId
        }
      };

      this.$router.push(routeParams);
    }
  })
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_static_userTypes__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SearchByNameOrEmailResults',
  data: function data() {
    return {};
  },

  props: {
    results: {
      type: Object,
      required: true,
      default: {}
    },
    searchMessage: {
      type: String,
      required: true,
      default: ''
    },
    showCompanyNames: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    investors: function investors() {
      return this.results.users || [];
    },
    accounts: function accounts() {
      return this.results.accounts || [];
    },
    resultsLength: function resultsLength() {
      var totalAccountsFromUsers = 0;
      var totalUsersFromAccounts = 0;
      this.investors.forEach(function (investor) {
        // Count each account or count 1 if no accounts
        totalAccountsFromUsers += Math.max((investor.accounts || []).length, 1);
      });
      this.accounts.forEach(function (account) {
        totalUsersFromAccounts += account.users.length;
      });
      return totalAccountsFromUsers + totalUsersFromAccounts;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['storeUserInSessionStorage']), {
    goToViewDetail: function goToViewDetail(userId, type, name) {
      this.storeUserInSessionStorage(userId);

      var routeParams = void 0;
      if (type === __WEBPACK_IMPORTED_MODULE_2__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name) {
        routeParams = { name: 'EditFinancialAdvisor', params: { name: name, userId: userId } };
      } else {
        routeParams = { name: 'UserDetail', params: { name: name, userId: userId } };
      }
      this.$router.push(routeParams);
    }
  })
});

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SearchByCUSIPResults',
  data: function data() {
    return {};
  },

  props: {
    results: {
      type: Object,
      required: true,
      default: {}
    },
    searchMessage: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
    notes: function notes() {
      return this.results.notes;
    },
    resultsLengthText: function resultsLengthText() {
      return this.notes.length + ' ' + (this.notes.length > 1 ? 'results' : 'result');
    },
    sortedNotes: function sortedNotes() {
      return this.notes;
    }
  },
  methods: {
    getPrimaryInvestor: function getPrimaryInvestor(note) {
      return note.account.primaryInvestor;
    },
    getNameAndUserId: function getNameAndUserId(note) {
      var user = this.getPrimaryInvestor(note);
      return {
        userId: user.id,
        name: user.firstName,
        lastName: user.lastName
      };
    },
    goToNoteDetails: function goToNoteDetails(note) {
      var _getNameAndUserId = this.getNameAndUserId(note),
          userId = _getNameAndUserId.userId,
          name = _getNameAndUserId.name;

      var routeParams = {
        name: 'NoteDetail',
        params: {
          noteId: note.id,
          userId: userId,
          name: name
        }
      };

      this.$router.push(routeParams);
    },
    goToAccountDetail: function goToAccountDetail(note) {
      var _getNameAndUserId2 = this.getNameAndUserId(note),
          userId = _getNameAndUserId2.userId,
          name = _getNameAndUserId2.name;

      var account = note.account;

      var accountTypeProperties = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["n" /* getAccounTypeProperties */])(account.accountType);

      var routeParams = {
        name: accountTypeProperties.component,
        params: {
          accountId: account.id,
          userId: userId,
          name: name
        }
      };

      this.$router.push(routeParams);
    }
  }
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_user_img_profile_advisor_svg__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_user_img_profile_advisor_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_user_img_profile_advisor_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__widgets_NotificationIcon__ = __webpack_require__(2094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__widgets_NotificationIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__widgets_NotificationIcon__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sideBar',
  props: {
    drawerOpen: {
      type: Boolean,
      default: false
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.hasBeenCreatedAccount) {
                _context.next = 3;
                break;
              }

              _this.disableSubmit = true;
              return _context.abrupt('return');

            case 3:
              _this.determineIfUserIsFinancialAdvisor();

              if (_this.isFinancialAdvisor) {
                _context.next = 7;
                break;
              }

              _context.next = 7;
              return _this.checkUserStatus();

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  components: {
    'notification-icon': __WEBPACK_IMPORTED_MODULE_7__widgets_NotificationIcon___default.a
  },
  data: function data() {
    return {
      userProfile: {
        fullName: '',
        accountType: ''
      },
      financialAdvisorAvatar: __WEBPACK_IMPORTED_MODULE_6__assets_img_user_img_profile_advisor_svg___default.a,
      disableSubmit: false,
      hasFundingSources: true,
      isFinancialAdvisor: false,
      documentsAccordionOpen: true,
      preferencesAccordionOpen: true,
      isDrawerOpen: false,
      overlayEl: null,
      preferences: [{
        route: 'InvestorPreferences',
        title: 'Impact'
      }, {
        route: 'InvestorPaymentPreferences',
        title: 'Payment'
      }, {
        route: 'InvestorCommunicationPreferences',
        title: 'Communication'
      }]
    };
  },
  mounted: function mounted() {
    this.createOverlay();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },

  watch: {
    drawerOpen: function drawerOpen(newVal) {
      this.isDrawerOpen = newVal;
      this.updateOverlay();
    },
    isDrawerOpen: function isDrawerOpen(newVal) {
      this.updateOverlay();
      if (newVal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    $route: function $route() {
      if (this.isDrawerOpen) {
        this.closeDrawer();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('home', ['getUserStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('account', ['setNotificationStatus']), {
    createOverlay: function createOverlay() {
      if (typeof window === 'undefined') return;
      this.overlayEl = document.createElement('div');
      this.overlayEl.className = 'drawer-overlay';
      this.overlayEl.style.display = 'none';
      this.overlayEl.addEventListener('click', this.closeDrawer);
      document.body.appendChild(this.overlayEl);
    },
    removeOverlay: function removeOverlay() {
      if (this.overlayEl) {
        this.overlayEl.removeEventListener('click', this.closeDrawer);
        if (this.overlayEl.parentNode) {
          this.overlayEl.parentNode.removeChild(this.overlayEl);
        }
        this.overlayEl = null;
      }
    },
    updateOverlay: function updateOverlay() {
      if (this.overlayEl) {
        this.overlayEl.style.display = this.isDrawerOpen ? 'block' : 'none';
      }
    },
    openDrawer: function openDrawer() {
      this.isDrawerOpen = true;
      document.body.style.overflow = 'hidden';
    },
    closeDrawer: function closeDrawer() {
      this.isDrawerOpen = false;
      document.body.style.overflow = '';
      this.$emit('drawer-closed');
    },
    toggleDrawer: function toggleDrawer() {
      if (this.isDrawerOpen) {
        this.closeDrawer();
      } else {
        this.openDrawer();
      }
    },
    displayNotificationIcon: function displayNotificationIcon(preference) {
      return preference.title === 'Communication' && ['COMMUNICATION_PREFERENCE', 'ENABLE_MFA'].includes(this.notificationStatus);
    },
    isAccountStatusAsPending: function isAccountStatusAsPending() {
      return this.accountStatus === 'pending' || this.accountStatus === 'denied';
    },
    isAccountStatusAsActive: function isAccountStatusAsActive() {
      return this.accountStatus === 'active';
    },
    determineIfUserIsFinancialAdvisor: function determineIfUserIsFinancialAdvisor() {
      var userType = this.user.userType;

      this.isFinancialAdvisor = userType === this.userTypes.FINANCIAL_ADVISOR.name;
    },
    getAccountDescription: function getAccountDescription(type) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["n" /* getAccounTypeProperties */])(type).text;
    },
    getAccountImgUrl: function getAccountImgUrl(type) {
      var accountTypeIcon = '' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util__["n" /* getAccounTypeProperties */])(type).icon;
      return __webpack_require__(235)("./" + accountTypeIcon + '.svg'); // eslint-disable-line
    },
    checkUserStatus: function checkUserStatus() {
      var _this2 = this;

      var accountId = this.activeAccount.id;

      // Without a real account there is no status to fetch. Asking for
      // account 0 returns a 403, which the HttpService interceptor turns
      // into a redirect to Home.
      if (!accountId) {
        this.disableSubmit = false;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return this.getUserStatus({
        accountId: accountId
      }).then(function (_ref) {
        var hasFundingSources = _ref.hasFundingSources,
            notificationStatus = _ref.notificationStatus;

        if (!_this2.hasBeenCreatedAccount) {
          _this2.disableSubmit = true;
        }
        _this2.hasFundingSources = hasFundingSources;
        _this2.setNotificationStatus(notificationStatus);
      }).catch(function () {
        _this2.disableSubmit = false;
      });
    },
    togglePreferencesAccordion: function togglePreferencesAccordion() {
      this.preferencesAccordionOpen = !this.preferencesAccordionOpen;
    },
    toggleDocumentsAccordion: function toggleDocumentsAccordion() {
      this.documentsAccordionOpen = !this.documentsAccordionOpen;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('app', ['user', 'activeAccount', 'accountTypes', 'accountStatus', 'userTypes']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('account', ['notificationStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])('app', ['hasBeenCreatedAccount']), {
    notificationMessage: function notificationMessage() {
      var messages = {
        COMMUNICATION_PREFERENCE: 'Link an account to securely receive faster payments and make new investments.',
        ENABLE_MFA: 'Enable multi-factor authentication for more security'
      };
      return messages[this.notificationStatus] || '';
    },
    isInstitutionAccount: function isInstitutionAccount() {
      return this.activeAccount.accountType === this.accountTypes.INSTITUTION.name;
    },
    isPreferencesViewActive: function isPreferencesViewActive() {
      var _this3 = this;

      return this.preferences.find(function (p) {
        return p.route === _this3.$route.name;
      }) !== undefined;
    },
    displayedPreferences: function displayedPreferences() {
      return this.preferencesAccordionOpen && this.activeAccount.accountType !== this.accountTypes.ADVISOR.name ? this.preferences : [];
    },
    isReadOnly: function isReadOnly() {
      return this.user && this.user.userType === this.userTypes.READ_ONLY.name;
    },
    showFeedbackIndicator: function showFeedbackIndicator() {
      // Highlight Feedback until the user has submitted it at least once.
      return !!this.user && !this.user.lastFeedbackAt;
    },
    documentOptions: function documentOptions() {
      return this.documentsAccordionOpen ? [{ text: 'Reports', value: 'reports' }, { text: 'Monthly Statements', value: 'monthly' }, { text: 'Tax Documents', value: 'tax' }, { text: 'Transaction Notices', value: 'transaction' }] : [];
    }
  })
});

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_static_events__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'successAlert',
  data: function data() {
    return {
      isAlertVisible: false
    };
  },

  methods: {
    hide: function hide() {
      this.$emit(__WEBPACK_IMPORTED_MODULE_0__data_static_events__["a" /* Events */].HIDE_SUCCESS_ALERT);
    }
  },
  props: {
    isVisible: {
      required: true,
      type: Boolean,
      default: false
    },
    message: {
      required: true,
      type: String
    }
  }
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tab',
  props: {
    name: { required: true },
    selected: { default: false }
  },
  data: function data() {
    return {
      isActive: false
    };
  },
  mounted: function mounted() {
    this.isActive = this.selected;
  }
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tabs',
  data: function data() {
    return {
      tabs: []
    };
  },
  created: function created() {
    this.tabs = this.$children;
  },

  methods: {
    selectTab: function selectTab(selectedTab) {
      this.tabs = this.tabs.map(function (tab) {
        tab.isActive = tab.name === selectedTab.name; // eslint-disable-line
        return tab;
      });
    }
  }
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TermOfConditions',
  props: {
    hideStateDisclosures: {
      default: false,
      type: Boolean
    }
  }
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_orderBy__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_orderBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_config__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_user_img_profile_advisor_svg__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_user_img_profile_advisor_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_user_img_profile_advisor_svg__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'topNavBar',
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.determineIfGoBackButtonShouldBeDisplayed();
              _this.initializeAccount();
              _this.loadInvestorSince(_this.activeAccountId);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    activeAccountId: function activeAccountId(id) {
      this.loadInvestorSince(id);
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_4_jquery___default()('.user-block-toggle').dropdown();
  },
  data: function data() {
    return {
      financialAdvisorAvatar: __WEBPACK_IMPORTED_MODULE_9__assets_img_user_img_profile_advisor_svg___default.a,
      isFinancialAdvisor: false,
      shouldGoBackButtonBeDisplayed: false,
      investorSince: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('app', ['getStaticInformation', 'activeAccountName']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('account', ['setNotificationStatus', 'getAccount']), {
    loadInvestorSince: function loadInvestorSince(accountId) {
      var _this2 = this;

      if (!accountId) {
        this.investorSince = null;
        return;
      }
      this.getAccount(accountId).then(function (account) {
        _this2.investorSince = account && account.investorSince ? account.investorSince : null;
      }).catch(function () {
        _this2.investorSince = null;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('app', {
    setActiveAccountId: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["f" /* SET_ACTIVE_ACCOUNT_ID */],
    setLoadingRedirection: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["g" /* SET_LOADING_REDIRECTION */]
  }), {
    toggleSidebar: function toggleSidebar() {
      this.$emit('toggle-drawer');
    },
    initializeAccount: function initializeAccount() {
      var storeActiveAccount = JSON.parse(sessionStorage.getItem('activeAccount'));

      if (!storeActiveAccount) {
        return;
      }

      this.setActiveAccountId(storeActiveAccount);
    },
    getAccountImgUrl: function getAccountImgUrl(type) {
      if (!type) {
        return __webpack_require__(123); // eslint-disable-line
      }
      var accountTypeIcon = '' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util__["n" /* getAccounTypeProperties */])(type).icon;
      return __webpack_require__(235)("./" + accountTypeIcon + '.svg'); // eslint-disable-line
    },
    getAccountDescription: function getAccountDescription(type) {
      if (!type) {
        return 'Individual Investor'; // eslint-disable-line
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util__["n" /* getAccounTypeProperties */])(type).text;
    },
    determineIfGoBackButtonShouldBeDisplayed: function determineIfGoBackButtonShouldBeDisplayed() {
      var _this3 = this;

      var _user = this.user,
          accounts = _user.accounts,
          userType = _user.userType;


      var advisorAccount = accounts.find(function (account) {
        return account.accountType === _this3.accountTypes.ADVISOR.name;
      });

      var isActiveAccountOfAdvisorType = false;

      if (advisorAccount) {
        isActiveAccountOfAdvisorType = this.activeAccountId === advisorAccount.id;
      }

      this.isFinancialAdvisor = userType === this.userTypes.FINANCIAL_ADVISOR.name;

      this.shouldGoBackButtonBeDisplayed = this.isFinancialAdvisor && !isActiveAccountOfAdvisorType;
    },
    activateAdvisorAccount: function activateAdvisorAccount() {
      var _this4 = this;

      var accounts = this.user.accounts;


      var advisorAccount = accounts.find(function (account) {
        return account.accountType === _this4.accountTypes.ADVISOR.name;
      });

      this.activateAccount(advisorAccount);
    },
    activateAccount: function activateAccount(account) {
      this.setActiveAccountId(account);
      this.initializeAccount();
      this.setNotificationStatus('init');
      this.$emit('force-update');
      this.determineIfGoBackButtonShouldBeDisplayed();
    },
    callLogOut: function callLogOut() {
      var _this5 = this;

      return this.$cognitoAuth.logout().then(function () {
        return _this5.getStaticInformation();
      }).then(function () {
        _this5.setLoadingRedirection();
        window.location.href = __WEBPACK_IMPORTED_MODULE_8__config_config__["c" /* logoutRedirectionURL */];
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['activeAccount', 'activeAccountId', 'accountTypes', 'irAdmin', 'user', 'userTypes', 'loadingRedirection']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])('app', ['hasBeenCreatedAccount']), {
    sortedAccounts: function sortedAccounts() {
      return __WEBPACK_IMPORTED_MODULE_6_lodash_orderBy___default()(this.user.accounts, [function (account) {
        var name = account.accountName;
        return name ? account.accountName.toLowerCase() : '';
      }], ['asc']);
    }
  })
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Breadcrumb__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_static_constants__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_static_userTypes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_static_searchTypes__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_formControls_RestrictedTextArea__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_formControls_RestrictedTextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_formControls_RestrictedTextArea__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'transfer',
  beforeMount: function beforeMount() {
    this.setParams();
    this.loadTransferNote();
  },

  components: {
    breadcrumb: __WEBPACK_IMPORTED_MODULE_6__components_Breadcrumb___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner___default.a,
    errors: __WEBPACK_IMPORTED_MODULE_7__components_modals_Errors___default.a,
    question: __WEBPACK_IMPORTED_MODULE_8__components_modals_Question___default.a,
    'restricted-textarea': __WEBPACK_IMPORTED_MODULE_14__components_formControls_RestrictedTextArea___default.a
  },
  watch: {
    transferNote: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(newTransferNote) {
        var _newTransferNote$from, accountName, accountType, accountId, users, params, user, userType, firstName, lastName, goto, accountTypeProperties, gotoAccount;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _newTransferNote$from = newTransferNote.fromAccount, accountName = _newTransferNote$from.accountName, accountType = _newTransferNote$from.accountType, accountId = _newTransferNote$from.id;
                _context.next = 3;
                return this.getAccountUsers(accountId);

              case 3:
                users = _context.sent;

                this.breadcrumbData = [];
                this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
                  title: 'Search',
                  goto: { name: 'Users' },
                  selected: false
                }));
                params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.$route.params);
                // prettier-ignore

                user = users.find(function (search) {
                  return search.id === Number(params.userId);
                });
                userType = user.userType, firstName = user.firstName, lastName = user.lastName;
                goto = void 0;

                if (userType === __WEBPACK_IMPORTED_MODULE_12__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name) {
                  goto = {
                    name: 'EditFinancialAdvisor',
                    params: {
                      name: params.name,
                      userId: params.userId
                    }
                  };
                } else {
                  goto = {
                    name: 'UserDetail',
                    params: { name: params.name, userId: params.userId }
                  };
                }
                this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
                  goto: goto,
                  title: firstName.concat(' ', lastName),
                  selected: false
                }));
                accountTypeProperties = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util__["n" /* getAccounTypeProperties */])(accountType);
                gotoAccount = {
                  name: accountTypeProperties.component,
                  params: {
                    accountId: accountId,
                    name: params.name,
                    userId: params.userId
                  }
                };

                this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
                  title: accountName,
                  goto: gotoAccount,
                  selected: false
                }));
                this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
                  title: 'Note'.concat(' ', newTransferNote.noteId),
                  goto: { name: 'NoteDetail', params: this.$route.params },
                  selected: false
                }));
                this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
                  title: 'Transfer',
                  goto: { name: this.$route.name, params: this.$route.params },
                  selected: true
                }));

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function changeNote(_x) {
        return _ref.apply(this, arguments);
      }

      return changeNote;
    }()
  },
  data: function data() {
    return {
      noteId: '',
      userId: '',
      name: '',
      note: {},
      transaction: {},
      breadcrumbData: [],
      loading: false,
      transferNote: {},
      comment: '',
      selectedAccount: null,
      search: {
        text: '',
        hasSearched: false,
        account: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('question', ['display'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    commentUpdated: function commentUpdated($event) {
      this.comment = $event;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('note', ['getAccountNoteTransfer', 'createAccountNoteTransfer', 'updateAccountNoteTransfer', 'deleteAccountNoteTransfer', 'getNote']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('transaction', ['updateTransaction', 'getTransaction']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('account', ['getAccounts', 'getAccountUsers']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), {
    setParams: function setParams() {
      this.name = this.$route.params.name;
      this.userId = this.$route.params.userId;
      this.noteId = this.$route.params.noteId;
    },
    loadTransferNote: function loadTransferNote() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var note, response, transaction;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.loading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return _this.getNote(_this.noteId);

              case 4:
                note = _context2.sent;

                _this.note = note;
                _context2.next = 8;
                return _this.getAccountNoteTransfer({
                  noteId: _this.noteId,
                  accountId: note.accountId
                });

              case 8:
                response = _context2.sent;

                _this.transferNote = response;

                if (!_this.transferNote.transactionId) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 13;
                return _this.getTransaction(_this.transferNote.transactionId);

              case 13:
                transaction = _context2.sent;

                _this.transaction = transaction;
                _this.comment = transaction.comment;
                _this.selectedAccount = _this.transferNote.toAccount;

              case 17:
                _this.loading = false;
                _context2.next = 24;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2['catch'](1);

                _this.loading = false;
                if (_context2.t0 !== 'UNAUTHORIZED') {
                  _this.setErrorsModalInfo(['We could not retrieve the transfer note details.']);
                  _this.showErrorsModal();
                }

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[1, 20]]);
      }))();
    },
    isCancelButtonDisabled: function isCancelButtonDisabled() {
      if (!this.comment) {
        return true;
      }
      if (this.comment === this.transaction.comment) {
        return true;
      }
      return false;
    },
    isButtonDisabled: function isButtonDisabled() {
      if (!this.comment) {
        return true;
      }
      if (this.comment === this.transaction.comment) {
        return true;
      }
      if (!this.selectedAccount) {
        return true;
      }
      return false;
    },
    submitRequest: function submitRequest() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var transferRequest;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.loading = true;
                transferRequest = {
                  toAccountId: _this2.selectedAccount.id,
                  comment: _this2.comment
                };
                _context3.prev = 2;
                _context3.next = 5;
                return _this2.createAccountNoteTransfer({
                  noteId: _this2.noteId,
                  accountId: _this2.note.accountId,
                  payload: transferRequest
                });

              case 5:
                _this2.loading = false;
                _this2.goToNoteDetail();
                _context3.next = 14;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](2);

                _this2.loading = false;
                _this2.setErrorsModalInfo(['There was an error when submitting a request.']);
                _this2.showErrorsModal();

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[2, 9]]);
      }))();
    },
    approveTransfer: function approveTransfer() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var transferRequest;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.loading = true;
                transferRequest = {
                  comment: _this3.comment
                };
                _context4.prev = 2;
                _context4.next = 5;
                return _this3.updateAccountNoteTransfer({
                  noteId: _this3.noteId,
                  accountId: _this3.note.accountId,
                  payload: transferRequest
                });

              case 5:
                _this3.loading = false;
                _this3.goToNoteDetail(true);
                _context4.next = 14;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](2);

                _this3.loading = false;
                _this3.setErrorsModalInfo(['There was an error when approving a request.']);
                _this3.showErrorsModal();

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3, [[2, 9]]);
      }))();
    },
    showTransferConfirmationModal: function showTransferConfirmationModal() {
      var _this4 = this;

      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_10__data_static_constants__["a" /* Constants */].transfer.modalTitle,
        question: __WEBPACK_IMPORTED_MODULE_10__data_static_constants__["a" /* Constants */].transfer.modalQuestion,
        method: function () {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _this4.loading = true;
                    _context5.prev = 1;

                    _this4.updateTransaction({
                      transactionId: _this4.transferNote.transactionId,
                      payload: {
                        comment: _this4.comment
                      }
                    });
                    _context5.next = 5;
                    return _this4.deleteAccountNoteTransfer({
                      noteId: _this4.noteId,
                      accountId: _this4.note.accountId
                    });

                  case 5:
                    _this4.loading = false;
                    _this4.hideQuestionModal();
                    _this4.goToNoteDetail();
                    _context5.next = 16;
                    break;

                  case 10:
                    _context5.prev = 10;
                    _context5.t0 = _context5['catch'](1);

                    _this4.loading = false;
                    _this4.setErrorsModalInfo(['There was an error when canceling a request.']);
                    _this4.showErrorsModal();
                    _this4.hideQuestionModal();

                  case 16:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee5, _this4, [[1, 10]]);
          }));

          return function method() {
            return _ref2.apply(this, arguments);
          };
        }(),
        yesButtonText: __WEBPACK_IMPORTED_MODULE_10__data_static_constants__["a" /* Constants */].transfer.modalYesButtonText,
        hideCancelButton: false
      });
    },
    goToNoteDetail: function goToNoteDetail(transferApproved) {
      this.$router.push({
        name: 'NoteDetail',
        params: {
          name: this.name,
          noteId: this.noteId,
          userId: transferApproved ? this.transferNote.toAccount.primaryInvestorId : this.userId
        }
      });
    },
    isSearchDisabled: function isSearchDisabled() {
      return !this.search.text.length > 0;
    },
    searchAccount: function searchAccount() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!_this5.search.text) {
                  _context6.next = 13;
                  break;
                }

                _context6.prev = 1;
                _context6.next = 4;
                return _this5.getAccounts({
                  searchString: _this5.search.text,
                  searchBy: __WEBPACK_IMPORTED_MODULE_13__data_static_searchTypes__["a" /* SearchTypes */].ACCOUNT_NUMBER.name
                });

              case 4:
                response = _context6.sent;

                _this5.search.hasSearched = true;
                if (response.statusCode === 401) {
                  _this5.search.account = null;
                } else {
                  _this5.search.account = response.account;
                }
                _context6.next = 13;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6['catch'](1);

                _this5.setErrorsModalInfo(['We could not retrieve the account']);
                _this5.showErrorsModal();

              case 13:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this5, [[1, 9]]);
      }))();
    },
    selectAccount: function selectAccount(account) {
      if (account.id === this.transferNote.fromAccount.id) {
        this.setErrorsModalInfo(['Please select a different account']);
        this.showErrorsModal();
      } else {
        this.selectedAccount = account;
      }
    }
  })
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_money__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_static_events__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_widgets_DismissableAlert__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_widgets_DismissableAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_widgets_DismissableAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_CustomRateAndTerm__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_CustomRateAndTerm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_CustomRateAndTerm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_AddAdditionalReinvestment__ = __webpack_require__(2084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_AddAdditionalReinvestment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_modals_AddAdditionalReinvestment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__data_static_upcomingTransactionActions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__data_static_transactionTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__data_static_transactionStatuses__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__data_static_constants__ = __webpack_require__(16);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















 // eslint-disable-line no-unused-vars
 // eslint-disable-line no-unused-vars
 // eslint-disable-line no-unused-vars



var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_15__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_15__util__["c" /* formatAmount */],
    formatRate: __WEBPACK_IMPORTED_MODULE_15__util__["s" /* formatRate */],
    formatTerm: __WEBPACK_IMPORTED_MODULE_15__util__["o" /* formatTerm */],
    isStateRestricted: __WEBPACK_IMPORTED_MODULE_15__util__["f" /* isStateRestricted */],
    findRates: __WEBPACK_IMPORTED_MODULE_15__util__["y" /* findRates */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'upcomingTransactions',
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.initializeState();

            case 2:
              _this.loadInvestmentsValidations();
              _this.setActiveAccountIndex();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  props: ['accountId', 'defaultFundingSourceId', 'investorAccountIdentifier'],
  mixins: [mix],
  components: {
    errors: __WEBPACK_IMPORTED_MODULE_9__components_modals_Errors___default.a,
    'dismissable-alert': __WEBPACK_IMPORTED_MODULE_12__components_widgets_DismissableAlert___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_11__components_widgets_Spinner___default.a,
    CustomRateAndTerm: __WEBPACK_IMPORTED_MODULE_13__components_CustomRateAndTerm___default.a,
    AddAdditionalReinvestment: __WEBPACK_IMPORTED_MODULE_14__components_modals_AddAdditionalReinvestment___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('transaction', ['loading']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('transaction', ['loading']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('app', ['user', 'fundingSourceTypes', 'investmentsRestrictions', 'activeAccountId']), {
    isExtraReinvestmentsEnabled: function isExtraReinvestmentsEnabled() {
      return true;
    },
    hasAdditionalReinvestments: function hasAdditionalReinvestments() {
      return this.additionalReinvestments !== null && this.additionalReinvestments.length > 0;
    },
    isShowingReinvestmentNotice: function isShowingReinvestmentNotice() {
      return this.notesTransactionsWithAction !== null && this.notesTransactionsWithAction.length > 0 || this.notesTransactionsWithNoAction !== null && this.notesTransactionsWithNoAction.length > 0;
    },
    availableFundingSources: function availableFundingSources() {
      return [{
        name: this.fundingSourceTypes.CHECK.label,
        type: this.fundingSourceTypes.CHECK.name
      }, {
        name: this.fundingSourceTypes.WIRE_TRANSFER.label,
        type: this.fundingSourceTypes.WIRE_TRANSFER.name
      }];
    }
  }),
  data: function data() {
    return {
      actions: __WEBPACK_IMPORTED_MODULE_16__data_static_upcomingTransactionActions__["a" /* default */],
      yearRates: [],
      fundingSources: [],
      dwollaTermsUrl: __WEBPACK_IMPORTED_MODULE_19__data_static_constants__["a" /* Constants */].purchaseNote.dwollaTermsUrl,
      prospectusTermUrl: __WEBPACK_IMPORTED_MODULE_19__data_static_constants__["a" /* Constants */].purchaseNote.prospectusTermUrl,
      notesTransactionsWithNoAction: null,
      notesTransactionsWithAction: null,
      additionalReinvestments: [],
      minimumInvestmentAmount: null,
      submitsDisabled: false,
      initializingState: false,
      showAdditionalReinvestmentModal: false,
      cancellingReinvestmentId: null,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      activeAccountIndex: 0
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_8__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('account', ['getAccountTransactions', 'getAccountFundingSources', 'getAccountExtraReinvestments', 'createAccountExtraReinvestment', 'cancelAccountExtraReinvestment']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('note', ['getInterestYearRates']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('transaction', ['getUpcomingTransactions', 'updateUpcomingTransaction']), {
    setActiveAccountIndex: function setActiveAccountIndex() {
      var _this2 = this;

      var activeAccount = this.user.accounts.find(function (ac) {
        return ac.id === _this2.activeAccountId;
      });
      this.activeAccountIndex = this.user.accounts.indexOf(activeAccount);
    },
    determineIfNotificationShouldBeDisplayed: function determineIfNotificationShouldBeDisplayed() {
      if (this.notesTransactionsWithNoAction.length > 0) {
        this.$emit(__WEBPACK_IMPORTED_MODULE_10__data_static_events__["a" /* Events */].SHOW_ALERT_FOR_UPCOMING_TRANSACTIONS_WITH_NO_ACTION);
      } else if (this.notesTransactionsWithAction.length > 0) {
        this.$emit(__WEBPACK_IMPORTED_MODULE_10__data_static_events__["a" /* Events */].SHOW_ALERT_FOR_UPCOMING_TRANSACTIONS_WITH_ACTION);
      } else {
        this.$emit(__WEBPACK_IMPORTED_MODULE_10__data_static_events__["a" /* Events */].HIDE_ALERT_FOR_UPCOMING_TRANSACTIONS);
      }
    },
    initializeState: function initializeState() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var fundingSources, accountTransactions;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this3.$emit(__WEBPACK_IMPORTED_MODULE_10__data_static_events__["a" /* Events */].UPCOMING_TRANSACTIONS_LOADING_STARTED);
                _context2.next = 4;
                return _this3.getAccountFundingSources(_this3.accountId);

              case 4:
                fundingSources = _context2.sent;


                _this3.fundingSources = fundingSources.filter(function (fss) {
                  return fss.status === 'verified' && (fss.type === _this3.fundingSourceTypes.BANK.name || fss.type === _this3.fundingSourceTypes.CHECK.name || fss.type === _this3.fundingSourceTypes.WIRE_TRANSFER.name);
                });

                _this3.yearRates = _this3.investmentsRestrictions.ratesAndTerms;

                _context2.next = 9;
                return _this3.getAccountTransactions({
                  accountId: _this3.accountId,
                  params: {
                    transactionTypes: [__WEBPACK_IMPORTED_MODULE_17__data_static_transactionTypes__["a" /* default */].SELL_REINVEST, __WEBPACK_IMPORTED_MODULE_17__data_static_transactionTypes__["a" /* default */].SELL_DONATE, __WEBPACK_IMPORTED_MODULE_17__data_static_transactionTypes__["a" /* default */].SELL_MATURE, __WEBPACK_IMPORTED_MODULE_17__data_static_transactionTypes__["a" /* default */].INT_REINVEST, __WEBPACK_IMPORTED_MODULE_17__data_static_transactionTypes__["a" /* default */].INT_PAID, __WEBPACK_IMPORTED_MODULE_17__data_static_transactionTypes__["a" /* default */].INT_DONATE],
                    statuses: [__WEBPACK_IMPORTED_MODULE_18__data_static_transactionStatuses__["a" /* default */].PREPENDING]
                  }
                });

              case 9:
                accountTransactions = _context2.sent;

                _this3.buildNotesTransactionsObjects(accountTransactions);
                _context2.next = 13;
                return _this3.loadAdditionalReinvestments();

              case 13:
                _this3.determineIfNotificationShouldBeDisplayed();
                _this3.$emit(__WEBPACK_IMPORTED_MODULE_10__data_static_events__["a" /* Events */].UPCOMING_TRANSACTIONS_LOADING_SUCCEED);
                _context2.next = 23;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2['catch'](0);

                _this3.$emit(__WEBPACK_IMPORTED_MODULE_10__data_static_events__["a" /* Events */].UPCOMING_TRANSACTIONS_LOADING_FAILED);
                _this3.setErrorsModalInfo(['Something went wrong. Please try reloading the website.']);
                _this3.showErrorsModal();
                _this3.initializingState = false;

              case 23:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 17]]);
      }))();
    },
    showStateRestrictionMessage: function showStateRestrictionMessage() {
      var state = this.user.residentialAddress.state;
      return this.isStateRestricted(state);
    },
    isThereAnyUpcomingTransactionWithNoAction: function isThereAnyUpcomingTransactionWithNoAction() {
      return this.notesTransactionsWithNoAction !== null && this.notesTransactionsWithNoAction.length > 0;
    },
    loadInvestmentsValidations: function loadInvestmentsValidations() {
      this.minimumInvestmentAmount = this.investmentsRestrictions.minimumAmount;
    },
    isThereAnyUpcomingTransactionWithAction: function isThereAnyUpcomingTransactionWithAction() {
      return this.notesTransactionsWithAction !== null && this.notesTransactionsWithAction.length > 0;
    },
    getHeaderMessage: function getHeaderMessage() {
      return 'According to your default preference your money will be';
    },
    getAlertMessage: function getAlertMessage(upcomingTransaction) {
      var _upcomingTransaction$ = upcomingTransaction.transaction,
          type = _upcomingTransaction$.type,
          actionTaken = _upcomingTransaction$.actionTaken;

      var isActionTaken = actionTaken !== undefined && actionTaken !== null;
      if (type === __WEBPACK_IMPORTED_MODULE_17__data_static_transactionTypes__["a" /* default */].INT_PAID || type === __WEBPACK_IMPORTED_MODULE_17__data_static_transactionTypes__["a" /* default */].SELL_MATURE) {
        return isActionTaken ? 'repay account' : 'repaid';
      } else if (type === __WEBPACK_IMPORTED_MODULE_17__data_static_transactionTypes__["a" /* default */].INT_DONATE || type === __WEBPACK_IMPORTED_MODULE_17__data_static_transactionTypes__["a" /* default */].SELL_DONATE) {
        return isActionTaken ? 'donate to Calvert Impact Capital' : 'donated to Calvert Impact Capital';
      }
      return isActionTaken ? 'reinvest in a new note' : 'reinvested in a new note';
    },
    goToFundingSourcesSegment: function goToFundingSourcesSegment() {
      this.$emit(__WEBPACK_IMPORTED_MODULE_10__data_static_events__["a" /* Events */].GO_TO_FUNDING_SOURCES_SEGMENT);
    },
    buildNotesTransactionsObjects: function buildNotesTransactionsObjects(transactions) {
      var _this4 = this;

      var _transactions$reduce = transactions.reduce(function (acc, t) {
        var actionTaken = t.actionTaken,
            amount = t.amount,
            fundingSourceId = t.fundingSourceId,
            note = t.note,
            rate = t.rate,
            term = t.term,
            type = t.type;


        var action = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["z" /* setActionTakenUpcomingTransactionHelper */])(actionTaken, type);

        var newRate = rate;
        var newTerm = term;

        if (action && action.name === __WEBPACK_IMPORTED_MODULE_16__data_static_upcomingTransactionActions__["a" /* default */].reinvest.name && !term) {
          var interestTerm = term !== 0 ? term : note.interestTerm;
          var interestRate = rate !== 0 ? rate : note.interestRate;

          var interestYearRatesSelectedPreviously = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["y" /* findRates */])(_this4.yearRates, interestTerm, interestRate, true);
          newRate = interestYearRatesSelectedPreviously.rate;
          newTerm = interestYearRatesSelectedPreviously.term;
        }

        var fundingSource = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["A" /* setFundingSourceUpcomingTransactionHelper */])(action, fundingSourceId, _this4.defaultFundingSourceId.toString(), _this4.fundingSources);

        var transactionObject = {
          action: action,
          transaction: t,
          fundingSource: fundingSource,
          amountForDonation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["c" /* formatAmount */])(amount),
          rate: newRate,
          term: newTerm,
          isRateAndTermValid: false
        };

        if (!actionTaken) {
          acc.transactionsWithoutActionTaken.push(transactionObject);
        } else {
          acc.transactionsWithActionTaken.push(transactionObject);
        }

        return acc;
      }, {
        transactionsWithActionTaken: [],
        transactionsWithoutActionTaken: []
      }),
          transactionsWithActionTaken = _transactions$reduce.transactionsWithActionTaken,
          transactionsWithoutActionTaken = _transactions$reduce.transactionsWithoutActionTaken;

      this.notesTransactionsWithAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["B" /* orderUpcomingTransactions */])(transactionsWithActionTaken);
      this.notesTransactionsWithNoAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["B" /* orderUpcomingTransactions */])(transactionsWithoutActionTaken);

      return {
        transactionsWithActionTaken: this.notesTransactionsWithAction,
        transactionsWithoutActionTaken: this.notesTransactionsWithNoAction
      };
    },
    setRate: function setRate(newRate, index, type) {
      var noteTransaction = type === 'no-action' ? this.notesTransactionsWithNoAction[index] : this.notesTransactionsWithAction[index];

      noteTransaction.rate = newRate;
    },
    setTerm: function setTerm(newTerm, index, type) {
      var noteTransaction = type === 'no-action' ? this.notesTransactionsWithNoAction[index] : this.notesTransactionsWithAction[index];

      noteTransaction.term = newTerm;
    },
    setRateAndTermAsInvalid: function setRateAndTermAsInvalid(index, type) {
      var noteTransaction = type === 'no-action' ? this.notesTransactionsWithNoAction[index] : this.notesTransactionsWithAction[index];

      noteTransaction.isRateAndTermValid = false;
    },
    setRateAndTermAsValid: function setRateAndTermAsValid(index, type) {
      var noteTransaction = type === 'no-action' ? this.notesTransactionsWithNoAction[index] : this.notesTransactionsWithAction[index];

      noteTransaction.isRateAndTermValid = true;
    },
    getActionsAllowedForThisTransaction: function getActionsAllowedForThisTransaction() {
      return this.notesTransactionsWithNoAction.concat(this.notesTransactionsWithAction).reduce(function (acc, val) {
        return acc + val.transaction.amount;
      }, 0) >= this.minimumInvestmentAmount ? [__WEBPACK_IMPORTED_MODULE_16__data_static_upcomingTransactionActions__["a" /* default */].reinvest, __WEBPACK_IMPORTED_MODULE_16__data_static_upcomingTransactionActions__["a" /* default */].donate, __WEBPACK_IMPORTED_MODULE_16__data_static_upcomingTransactionActions__["a" /* default */].cashout] : [__WEBPACK_IMPORTED_MODULE_16__data_static_upcomingTransactionActions__["a" /* default */].donate, __WEBPACK_IMPORTED_MODULE_16__data_static_upcomingTransactionActions__["a" /* default */].cashout];
    },
    isCashoutActionTaken: function isCashoutActionTaken(action) {
      return action.name === __WEBPACK_IMPORTED_MODULE_16__data_static_upcomingTransactionActions__["a" /* default */].cashout.name;
    },
    isDonateActionTaken: function isDonateActionTaken(action) {
      return action.name === __WEBPACK_IMPORTED_MODULE_16__data_static_upcomingTransactionActions__["a" /* default */].donate.name;
    },
    isReinvestActionTaken: function isReinvestActionTaken(action) {
      return action.name === __WEBPACK_IMPORTED_MODULE_16__data_static_upcomingTransactionActions__["a" /* default */].reinvest.name;
    },
    getTypeOfPayment: function getTypeOfPayment(type) {
      return type === __WEBPACK_IMPORTED_MODULE_17__data_static_transactionTypes__["a" /* default */].INT_PAID || type === __WEBPACK_IMPORTED_MODULE_17__data_static_transactionTypes__["a" /* default */].INT_DONATE || type === __WEBPACK_IMPORTED_MODULE_17__data_static_transactionTypes__["a" /* default */].INT_REINVEST ? 'Interest payment' : 'Principal payment';
    },
    shouldSubmitButtonBeDisabled: function shouldSubmitButtonBeDisabled(index, type) {
      // eslint-disable-line
      var noteTransaction = type === 'no-action' ? this.notesTransactionsWithNoAction[index] : this.notesTransactionsWithAction[index];

      var action = noteTransaction.action;

      if (action.name === __WEBPACK_IMPORTED_MODULE_16__data_static_upcomingTransactionActions__["a" /* default */].cashout.name) {
        return noteTransaction.fundingSource === undefined || noteTransaction.fundingSource === null;
      } else if (action.name === __WEBPACK_IMPORTED_MODULE_16__data_static_upcomingTransactionActions__["a" /* default */].reinvest.name) {
        return !noteTransaction.isRateAndTermValid;
      }
      return false;
    },
    actionChanged: function actionChanged(action, index, actionPreviousTaken) {
      var _this5 = this;

      var upcomingTransaction = actionPreviousTaken ? this.notesTransactionsWithAction[index] : this.notesTransactionsWithNoAction[index];

      upcomingTransaction.fundingSource = null;
      upcomingTransaction.interestRateAndTerm = null;

      if (action.name === __WEBPACK_IMPORTED_MODULE_16__data_static_upcomingTransactionActions__["a" /* default */].cashout.name) {
        upcomingTransaction.fundingSource = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["find"])(this.fundingSources, function (fs) {
          return fs.id.toString() === _this5.defaultFundingSourceId.toString();
        });
      } else if (action.name === __WEBPACK_IMPORTED_MODULE_16__data_static_upcomingTransactionActions__["a" /* default */].reinvest.name) {
        var _upcomingTransaction$2 = upcomingTransaction.transaction,
            note = _upcomingTransaction$2.note,
            term = _upcomingTransaction$2.term;

        var interestTerm = term !== 0 && term ? term : note.interestTerm;
        var interestYearRatesSelectedPreviously = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["y" /* findRates */])(this.yearRates, interestTerm, note.interestRate);
        upcomingTransaction.rate = interestYearRatesSelectedPreviously.rate;
        upcomingTransaction.term = interestYearRatesSelectedPreviously.term;
      }
    },
    submitUpcomingTransaction: function submitUpcomingTransaction(noteTransaction) {
      var _this6 = this;

      this.$emit(__WEBPACK_IMPORTED_MODULE_10__data_static_events__["a" /* Events */].UPCOMING_TRANSACTIONS_LOADING_STARTED);
      this.submitsDisabled = true;

      var action = noteTransaction.action,
          fundingSource = noteTransaction.fundingSource,
          rate = noteTransaction.rate,
          term = noteTransaction.term,
          transaction = noteTransaction.transaction;


      var upcomingTransactionToUpdate = {
        actionTaken: action.name,
        fundingSourceId: fundingSource ? String(fundingSource.id) : '',
        term: this.isReinvestActionTaken(action) ? term : -1,
        rate: this.isReinvestActionTaken(action) ? rate : -1,
        termsOfConditionAcceptance: true
      };

      this.updateUpcomingTransaction({
        payload: upcomingTransactionToUpdate,
        transactionId: transaction.id
      }).then(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this6.initializeState();

              case 2:
                _this6.submitsDisabled = false;

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))).catch(function (errors) {
        _this6.$emit(__WEBPACK_IMPORTED_MODULE_10__data_static_events__["a" /* Events */].UPCOMING_TRANSACTIONS_LOADING_FAILED);
        _this6.setErrorsModalInfo(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["C" /* convertErrorStringsToArrayStrings */])(errors.message));
        _this6.showErrorsModal();
        _this6.submitsDisabled = false;
      });
      this.resetComponent();
    },
    resetComponent: function resetComponent() {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
    },
    isAValidTerm: function isAValidTerm(index, type) {
      var noteTransaction = type === 'no-action' ? this.notesTransactionsWithNoAction[index] : this.notesTransactionsWithAction[index];

      var customTerm = noteTransaction.customTerm,
          addCustomRateAndTerm = noteTransaction.addCustomRateAndTerm;


      if (!addCustomRateAndTerm) {
        noteTransaction.termErrorMessage = '';
        return true;
      }

      if (customTerm < 1 || customTerm % 0.25 !== 0) {
        noteTransaction.termErrorMessage = 'Years must be a positive number greater than 1 in multiples of .25';
        return false;
      }

      return true;
    },
    isAValidRate: function isAValidRate(index, type) {
      var noteTransaction = type === 'no-action' ? this.notesTransactionsWithNoAction[index] : this.notesTransactionsWithAction[index];

      var customRate = noteTransaction.customRate,
          addCustomRateAndTerm = noteTransaction.addCustomRateAndTerm;


      if (!addCustomRateAndTerm) {
        noteTransaction.rateErrorMessage = '';
        return true;
      }

      if (customRate < 0) {
        noteTransaction.rateErrorMessage = 'Negative numbers are not allowed';
        return false;
      }

      if (customRate > this.investmentsRestrictions.rateLimit) {
        noteTransaction.rateErrorMessage = 'The maximum allowed rate is ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["s" /* formatRate */])(this.investmentsRestrictions.rateLimit);
        return false;
      }
      return true;
    },
    loadAdditionalReinvestments: function loadAdditionalReinvestments() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return _this7.getAccountExtraReinvestments(_this7.accountId);

              case 3:
                response = _context4.sent;

                _this7.additionalReinvestments = response || [];
                _context4.next = 11;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);

                console.error('Error loading additional reinvestments:', _context4.t0);
                _this7.additionalReinvestments = [];

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[0, 7]]);
      }))();
    },
    openAddAdditionalReinvestmentModal: function openAddAdditionalReinvestmentModal() {
      this.showAdditionalReinvestmentModal = true;
    },
    closeAddAdditionalReinvestmentModal: function closeAddAdditionalReinvestmentModal() {
      this.showAdditionalReinvestmentModal = false;
    },
    getAvailableNoteIds: function getAvailableNoteIds() {
      var allTransactions = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.notesTransactionsWithAction || []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.notesTransactionsWithNoAction || []));

      if (allTransactions.length === 0) {
        return [];
      }

      return allTransactions.filter(function (nt) {
        return nt.action && nt.action.name === __WEBPACK_IMPORTED_MODULE_16__data_static_upcomingTransactionActions__["a" /* default */].reinvest.name;
      }).map(function (nt) {
        return {
          noteId: nt.transaction.note.noteId,
          label: 'Note ' + nt.transaction.note.noteId
        };
      }).filter(function (item, index, self) {
        return index === self.findIndex(function (t) {
          return t.noteId === item.noteId;
        });
      });
    },
    saveAdditionalReinvestment: function saveAdditionalReinvestment(additionalReinvestment) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var payload;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                payload = {
                  amount: additionalReinvestment.amount,
                  noteId: additionalReinvestment.noteId,
                  fundingSourceType: additionalReinvestment.fundingSourceType
                };

                if (additionalReinvestment.fundingSourceId) {
                  payload.fundingSourceId = additionalReinvestment.fundingSourceId;
                  payload.fundingSourceName = additionalReinvestment.fundingSourceName;
                }
                _context5.next = 5;
                return _this8.createAccountExtraReinvestment({
                  accountId: _this8.accountId,
                  payload: payload
                });

              case 5:
                _context5.next = 7;
                return _this8.loadAdditionalReinvestments();

              case 7:
                _context5.next = 14;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](0);

                console.error('Error saving additional reinvestment:', _context5.t0);
                _this8.setErrorsModalInfo(['Error saving additional reinvestment. Please try again.']);
                _this8.showErrorsModal();

              case 14:
                _context5.prev = 14;

                _this8.closeAddAdditionalReinvestmentModal();
                return _context5.finish(14);

              case 17:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8, [[0, 9, 14, 17]]);
      }))();
    },
    confirmCancelReinvestment: function confirmCancelReinvestment(reinvestment) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (window.confirm('Are you sure you want to cancel this reinvestment of ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["c" /* formatAmount */])(reinvestment.amount) + '?')) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt('return');

              case 2:
                _this9.cancellingReinvestmentId = reinvestment.id;
                _context6.prev = 3;
                _context6.next = 6;
                return _this9.cancelAccountExtraReinvestment({
                  accountId: _this9.accountId,
                  extraReinvestmentId: reinvestment.id
                });

              case 6:
                _context6.next = 8;
                return _this9.loadAdditionalReinvestments();

              case 8:
                _context6.next = 14;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6['catch'](3);

                _this9.setErrorsModalInfo(['Error cancelling reinvestment. Please try again.']);
                _this9.showErrorsModal();

              case 14:
                _context6.prev = 14;

                _this9.cancellingReinvestmentId = null;
                return _context6.finish(14);

              case 17:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9, [[3, 10, 14, 17]]);
      }))();
    }
  }),

  directives: { money: __WEBPACK_IMPORTED_MODULE_7_v_money__["VMoney"] }
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(9);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CustomRatesAndTermsForInvestor',
  props: {
    nt: {
      type: Object,
      required: true
    },
    showDefaultValue: true,
    actionProvided: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data: function data() {
    return {
      yearRates: [],
      defaultRateAndTermId: 0,
      loading: false
    };
  },
  beforeMount: function beforeMount() {
    this.loading = true;
    this.initializeData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['investmentsRestrictions'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('app', ['getRateAndTermByGroup']), {
    initializeData: function initializeData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var rateAndTermGroups, rateAndTermGroup, _selectRateAndTermToD, displayRateAndTerm, isCustomRateAndTerm;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                rateAndTermGroups = _this.investmentsRestrictions.rateAndTermGroups;
                _context.t0 = rateAndTermGroups[_this.nt.transaction.manageRateAndTermGroupsId];

                if (_context.t0) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return _this.getInvestmentOptions(_this.nt.transaction.manageRateAndTermGroupsId);

              case 5:
                _context.t0 = _context.sent;

              case 6:
                rateAndTermGroup = _context.t0;

                if (!rateAndTermGroup.overrideManageRateAndTermGroupsId) {
                  _context.next = 14;
                  break;
                }

                _context.t1 = rateAndTermGroups[rateAndTermGroup.overrideManageRateAndTermGroupsId];

                if (_context.t1) {
                  _context.next = 13;
                  break;
                }

                _context.next = 12;
                return _this.getInvestmentOptions(rateAndTermGroup.overrideManageRateAndTermGroupsId);

              case 12:
                _context.t1 = _context.sent;

              case 13:
                rateAndTermGroup = _context.t1;

              case 14:

                _this.yearRates = rateAndTermGroup.investmentOptions;

                _selectRateAndTermToD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["D" /* selectRateAndTermToDisplay */])(_this.nt, _this.yearRates), displayRateAndTerm = _selectRateAndTermToD.selected, isCustomRateAndTerm = _selectRateAndTermToD.isCustom;


                if (isCustomRateAndTerm) {
                  _this.yearRates.push(displayRateAndTerm);
                }

                _this.defaultRateAndTermId = displayRateAndTerm.id;
                _this.$emit('setRateAndTerm', displayRateAndTerm);
                _this.loading = false;

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getInvestmentOptions: function getInvestmentOptions(manageRateAndTermGroupsId) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', _this2.getRateAndTermByGroup({
                  manageRateAndTermGroupsId: manageRateAndTermGroupsId
                }).then(function (data) {
                  return {
                    overrideManageRateAndTermGroupsId: data.overrideManageRateAndTermGroupsId,
                    investmentOptions: data.investmentOptions
                  };
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleSelectRateAndTerm: function handleSelectRateAndTerm(e) {
      var rateAndTerm = this.yearRates.find(function (item) {
        return item.id === parseInt(e.target.value, 10);
      });
      this.$emit('setRateAndTerm', rateAndTerm);
    }
  })
});

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_static_transactionTypes__ = __webpack_require__(58);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // eslint-disable-line no-unused-vars

var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_0__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_0__util__["c" /* formatAmount */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpcomingTransactionsData',
  mixins: [mix],
  props: {
    transactionId: {
      type: String,
      default: ''
    },
    maturityDate: {
      type: String
    },
    noteId: {
      type: String,
      default: ''
    },
    paymentType: {
      type: String,
      default: ''
    },
    amount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    getPaymentType: function getPaymentType() {
      var paymentType = this.paymentType;

      return paymentType === __WEBPACK_IMPORTED_MODULE_1__data_static_transactionTypes__["a" /* default */].INT_PAID || paymentType === __WEBPACK_IMPORTED_MODULE_1__data_static_transactionTypes__["a" /* default */].INT_DONATE || paymentType === __WEBPACK_IMPORTED_MODULE_1__data_static_transactionTypes__["a" /* default */].INT_REINVEST ? 'Interest payment' : 'Principal payment';
    }
  }
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UpcomingTransactions_NoUpcomingTransactions__ = __webpack_require__(2075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UpcomingTransactions_NoUpcomingTransactions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_UpcomingTransactions_NoUpcomingTransactions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UpcomingTransactions_UpcomingTransactionsData__ = __webpack_require__(2076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UpcomingTransactions_UpcomingTransactionsData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_UpcomingTransactions_UpcomingTransactionsData__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UpcomingTransactions_CustomRatesAndTermsForInvestor__ = __webpack_require__(2074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UpcomingTransactions_CustomRatesAndTermsForInvestor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_UpcomingTransactions_CustomRatesAndTermsForInvestor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TermsOfConditions__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TermsOfConditions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_TermsOfConditions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_static_upcomingTransactionActions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_static_transactionTypes__ = __webpack_require__(58);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







 // eslint-disable-line no-unused-vars
 // eslint-disable-line no-unused-vars

var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_4__util__["b" /* formatDate */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpcomingTransactions',
  mixins: [mix],
  components: {
    'no-upcoming-transactions': __WEBPACK_IMPORTED_MODULE_0__components_UpcomingTransactions_NoUpcomingTransactions___default.a,
    'upcoming-transaction-data': __WEBPACK_IMPORTED_MODULE_1__components_UpcomingTransactions_UpcomingTransactionsData___default.a,
    'terms-of-conditions': __WEBPACK_IMPORTED_MODULE_3__components_TermsOfConditions___default.a,
    CustomRatesAndTermsForInvestor: __WEBPACK_IMPORTED_MODULE_2__components_UpcomingTransactions_CustomRatesAndTermsForInvestor___default.a
  },
  props: {
    notesTransactions: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    allowedActions: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    fundingSources: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    yearRates: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    submitsDisabled: {
      type: Boolean,
      required: true,
      default: false
    },
    actionProvided: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    headerMessage: function headerMessage() {
      return 'According to your default preference your money will be';
    }
  },
  data: function data() {
    return {
      rateAndTerm: {
        id: 0,
        label: '0.00%, 0 year',
        manageRateAndTermGroupsId: 0,
        precedence: 0,
        rate: 0,
        term: 0
      }
    };
  },

  methods: {
    setRateAndTerm: function setRateAndTerm(rateAndTerm) {
      this.rateAndTerm = rateAndTerm;
    },
    getAlertMessage: function getAlertMessage(upcomingTransaction) {
      var _upcomingTransaction$ = upcomingTransaction.transaction,
          type = _upcomingTransaction$.type,
          actionTaken = _upcomingTransaction$.actionTaken;

      var isActionTaken = actionTaken !== undefined && actionTaken !== null;
      if (type === __WEBPACK_IMPORTED_MODULE_6__data_static_transactionTypes__["a" /* default */].INT_PAID || type === __WEBPACK_IMPORTED_MODULE_6__data_static_transactionTypes__["a" /* default */].SELL_MATURE) {
        return isActionTaken ? 'repay account' : 'repaid';
      } else if (type === __WEBPACK_IMPORTED_MODULE_6__data_static_transactionTypes__["a" /* default */].INT_DONATE || type === __WEBPACK_IMPORTED_MODULE_6__data_static_transactionTypes__["a" /* default */].SELL_DONATE) {
        return isActionTaken ? 'donate to Calvert Impact Capital' : 'donated to Calvert Impact Capital';
      }
      return isActionTaken ? 'reinvest in a new note' : 'reinvested in a new note';
    },
    shouldSubmitButtonBeDisabled: function shouldSubmitButtonBeDisabled(noteTransaction) {
      var action = noteTransaction.action;

      if (action.name === __WEBPACK_IMPORTED_MODULE_5__data_static_upcomingTransactionActions__["a" /* default */].cashout.name) {
        return noteTransaction.fundingSource === undefined || noteTransaction.fundingSource === null;
      } else if (action.name === __WEBPACK_IMPORTED_MODULE_5__data_static_upcomingTransactionActions__["a" /* default */].reinvest.name) {
        return !noteTransaction.termsOfConditionAcceptance;
      }

      return false;
    },
    isCashoutActionTaken: function isCashoutActionTaken(action) {
      return action.name === __WEBPACK_IMPORTED_MODULE_5__data_static_upcomingTransactionActions__["a" /* default */].cashout.name;
    },
    isDonateActionTaken: function isDonateActionTaken(action) {
      return action.name === __WEBPACK_IMPORTED_MODULE_5__data_static_upcomingTransactionActions__["a" /* default */].donate.name;
    },
    isReinvestActionTaken: function isReinvestActionTaken(action) {
      return action.name === __WEBPACK_IMPORTED_MODULE_5__data_static_upcomingTransactionActions__["a" /* default */].reinvest.name;
    }
  }
});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_Information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_Information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_Information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_DismissableAlert__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_DismissableAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_widgets_DismissableAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_UpcomingTransactions_index__ = __webpack_require__(2077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_UpcomingTransactions_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_UpcomingTransactions_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_AddMoney__ = __webpack_require__(2085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_AddMoney___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_modals_AddMoney__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_static_upcomingTransactionActions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__data_static_transactionTypes__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__data_static_transactionStatuses__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__data_static_constants__ = __webpack_require__(16);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















 // eslint-disable-line no-unused-vars
 // eslint-disable-line no-unused-vars
 // eslint-disable-line no-unused-vars



var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_14__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_14__util__["c" /* formatAmount */],
    formatRate: __WEBPACK_IMPORTED_MODULE_14__util__["s" /* formatRate */],
    formatTerm: __WEBPACK_IMPORTED_MODULE_14__util__["o" /* formatTerm */],
    isStateRestricted: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* isStateRestricted */],
    findRates: __WEBPACK_IMPORTED_MODULE_14__util__["y" /* findRates */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'upcomingTransactionsForInvestor',
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.checkUserStatus();

            case 2:
              _this.setActiveAccountIndex();
              if (_this.isReadOnly) {
                _this.submitsDisabled = true;
              }
              _context.next = 6;
              return _this.initializeState();

            case 6:
              _this.loadInvestmentsValidations();

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  mixins: [mix],
  components: {
    errors: __WEBPACK_IMPORTED_MODULE_8__components_modals_Errors___default.a,
    information: __WEBPACK_IMPORTED_MODULE_9__components_modals_Information___default.a,
    'dismissable-alert': __WEBPACK_IMPORTED_MODULE_11__components_widgets_DismissableAlert___default.a,
    'upcoming-transactions': __WEBPACK_IMPORTED_MODULE_12__components_UpcomingTransactions_index___default.a,
    'add-money-modal': __WEBPACK_IMPORTED_MODULE_13__components_modals_AddMoney___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_10__components_widgets_Spinner___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('information', ['isInformationModalVisible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('transaction', ['loading']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('app', ['fundingSourceTypes', 'investmentsRestrictions', 'user', 'activeAccountId']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])('app', ['hasBeenCreatedAccount']), {
    isReadOnly: function isReadOnly() {
      return this.user && this.user.userType === 'READ_ONLY';
    },
    isExtraReinvestmentsEnabled: function isExtraReinvestmentsEnabled() {
      return true;
    },
    isShowingReinvestmentNotice: function isShowingReinvestmentNotice() {
      return this.notesTransactionsWithAction !== null && this.notesTransactionsWithAction.length > 0 || this.notesTransactionsWithNoAction !== null && this.notesTransactionsWithNoAction.length > 0;
    },
    actionsAllowedForThisTransaction: function actionsAllowedForThisTransaction() {
      if (this.isReadOnly) {
        return [];
      }
      return this.notesTransactionsWithNoAction.concat(this.notesTransactionsWithAction).reduce(function (acc, val) {
        return acc + val.transaction.amount;
      }, 0) >= this.minimumInvestmentAmount ? [__WEBPACK_IMPORTED_MODULE_15__data_static_upcomingTransactionActions__["a" /* default */].reinvest, __WEBPACK_IMPORTED_MODULE_15__data_static_upcomingTransactionActions__["a" /* default */].donate, __WEBPACK_IMPORTED_MODULE_15__data_static_upcomingTransactionActions__["a" /* default */].cashout] : [__WEBPACK_IMPORTED_MODULE_15__data_static_upcomingTransactionActions__["a" /* default */].donate, __WEBPACK_IMPORTED_MODULE_15__data_static_upcomingTransactionActions__["a" /* default */].cashout];
    },
    availableFundingSources: function availableFundingSources() {
      var _this2 = this;

      return this.fundingSources.filter(function (fs) {
        return !fs.removed && fs.type === _this2.fundingSourceTypes.BANK.name;
      });
    },
    hasUpcomingTransactions: function hasUpcomingTransactions() {
      return this.notesTransactionsWithNoAction && this.notesTransactionsWithNoAction.length > 0 || this.notesTransactionsWithAction && this.notesTransactionsWithAction.length > 0;
    },
    availableNotesForReinvestment: function availableNotesForReinvestment() {
      var _this3 = this;

      var allTransactions = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.notesTransactionsWithNoAction || []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.notesTransactionsWithAction || []));

      var noteMap = {};
      allTransactions.forEach(function (nt) {
        var maturityDate = nt.transaction.maturityDate;

        var noteId = nt.transaction.note.noteId;
        if (!maturityDate || !noteId) return;
        if (!_this3.isWithinAllowedWindow(maturityDate)) return;

        if (!noteMap[noteId]) {
          noteMap[noteId] = {
            noteId: noteId,
            maturityDate: maturityDate
          };
        }
      });

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(noteMap);
    }
  }),
  data: function data() {
    return {
      actions: __WEBPACK_IMPORTED_MODULE_15__data_static_upcomingTransactionActions__["a" /* default */],
      yearRates: [],
      fundingSources: [],
      dwollaTermsUrl: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].purchaseNote.dwollaTermsUrl,
      prospectusTermUrl: __WEBPACK_IMPORTED_MODULE_18__data_static_constants__["a" /* Constants */].purchaseNote.prospectusTermUrl,
      notesTransactionsWithNoAction: [],
      notesTransactionsWithAction: [],
      minimumInvestmentAmount: null,
      submitsDisabled: false,
      initializingState: false,
      activeAccountIndex: -1,
      showAddMoneyModal: false,
      addMoneyLoading: false,
      scheduledAdditionalInvestments: [],
      editingInvestment: null,
      showCancelConfirmModal: false,
      cancellingInvestment: null,
      cancellingLoading: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    getYearRatesForNote: function getYearRatesForNote(_ref) {
      var shouldDisplayZeroRate = _ref.shouldDisplayZeroRate,
          noteInterestTerm = _ref.noteInterestTerm,
          noteInterestRate = _ref.noteInterestRate;

      var availableRateAndTerms = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.yearRates));
      if (shouldDisplayZeroRate) {
        availableRateAndTerms.unshift({
          id: 'custom-id',
          label: '0.00%, ' + noteInterestTerm / 12 + ' year' + (noteInterestTerm > 12 ? 's' : ''),
          months: noteInterestTerm,
          active: true,
          rate: noteInterestRate
        });
      }
      return availableRateAndTerms;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('information', {
    showInformationModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["d" /* SHOW_INFORMATION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('account', ['getAccountFundingSources', 'getAccountTransactions', 'getAccountNotes', 'getAccountExtraReinvestments', 'createAccountExtraReinvestment', 'cancelAccountExtraReinvestment']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('note', ['getInterestYearRates']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('home', ['getUserStatus']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('transaction', ['updateUpcomingTransaction']), {
    setActiveAccountIndex: function setActiveAccountIndex() {
      var _this4 = this;

      var activeAccount = this.user.accounts.find(function (ac) {
        return ac.id === _this4.activeAccountId;
      });
      this.activeAccountIndex = this.user.accounts.indexOf(activeAccount);
    },
    checkUserStatus: function checkUserStatus() {
      var _this5 = this;

      this.initializingState = true;
      if (!this.hasBeenCreatedAccount) {
        this.$router.push({ name: 'AccountSummary' });
        this.initializingState = false;
        return true;
      }

      return this.getUserStatus({
        accountId: this.activeAccountId
      }).then(function (_ref2) {
        var status = _ref2.status,
            needs = _ref2.needs,
            hasFundingSource = _ref2.hasFundingSource;

        if (status === 'suspended') {
          _this5.$router.push({ name: 'AccountSuspended' });
        } else if (status === 'retry') {
          _this5.$router.push({ name: 'AccountCreation' });
        } else if (status === 'document') {
          _this5.$router.push({ name: 'DocumentUpload' });
        } else if (needs.includes('FUNDING_SOURCE') && !hasFundingSource) {
          _this5.$router.push({ name: 'AddFundingSource' });
        } else if (needs.includes('NOTE')) {
          _this5.$router.push({ name: 'PurchaseNote', query: { first: 1 } });
        }
        _this5.initializingState = false;
        return true;
      });
    },
    initializeState: function initializeState() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var fundingSources, accountTransactions;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this6.initializingState = true;

                _context2.next = 4;
                return _this6.getAccountFundingSources(_this6.activeAccountId);

              case 4:
                fundingSources = _context2.sent;


                _this6.fundingSources = fundingSources.filter(function (fss) {
                  return fss.status === 'verified' && (fss.type === _this6.fundingSourceTypes.BANK.name || fss.type === _this6.fundingSourceTypes.CHECK.name || fss.type === _this6.fundingSourceTypes.WIRE_TRANSFER.name);
                });

                _this6.yearRates = _this6.investmentsRestrictions.ratesAndTerms;

                _context2.next = 9;
                return _this6.getAccountTransactions({
                  accountId: _this6.activeAccountId,
                  params: {
                    transactionTypes: [__WEBPACK_IMPORTED_MODULE_16__data_static_transactionTypes__["a" /* default */].SELL_REINVEST, __WEBPACK_IMPORTED_MODULE_16__data_static_transactionTypes__["a" /* default */].SELL_DONATE, __WEBPACK_IMPORTED_MODULE_16__data_static_transactionTypes__["a" /* default */].SELL_MATURE, __WEBPACK_IMPORTED_MODULE_16__data_static_transactionTypes__["a" /* default */].INT_REINVEST, __WEBPACK_IMPORTED_MODULE_16__data_static_transactionTypes__["a" /* default */].INT_PAID, __WEBPACK_IMPORTED_MODULE_16__data_static_transactionTypes__["a" /* default */].INT_DONATE],
                    statuses: __WEBPACK_IMPORTED_MODULE_17__data_static_transactionStatuses__["a" /* default */].PREPENDING
                  }
                });

              case 9:
                accountTransactions = _context2.sent;


                _this6.buildNotesTransactionsObjects(accountTransactions);

                _context2.next = 13;
                return _this6.loadExtraReinvestments();

              case 13:

                _this6.initializingState = false;
                _context2.next = 21;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](0);

                _this6.setErrorsModalInfo(['Something went wrong. Please try reloading the website.']);
                _this6.showErrorsModal();
                _this6.initializingState = false;

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[0, 16]]);
      }))();
    },
    loadExtraReinvestments: function loadExtraReinvestments() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this7.getAccountExtraReinvestments(_this7.activeAccountId);

              case 3:
                response = _context3.sent;

                _this7.scheduledAdditionalInvestments = response || [];
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                _this7.scheduledAdditionalInvestments = [];

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7, [[0, 7]]);
      }))();
    },
    loadInvestmentsValidations: function loadInvestmentsValidations() {
      this.minimumInvestmentAmount = this.investmentsRestrictions.minimumAmount;
    },
    buildNotesTransactionsObjects: function buildNotesTransactionsObjects(transactions) {
      var _this8 = this;

      var _transactions$reduce = transactions.reduce(function (acc, t) {
        var term = t.term,
            actionTaken = t.actionTaken,
            type = t.type,
            amount = t.amount,
            fundingSourceId = t.fundingSourceId,
            rate = t.rate;

        var interestYearRatesSelectedPreviously = null;

        var action = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util__["z" /* setActionTakenUpcomingTransactionHelper */])(actionTaken, type);
        var fundingSource = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util__["A" /* setFundingSourceUpcomingTransactionHelper */])(action, fundingSourceId, _this8.user.accounts[_this8.activeAccountIndex].defaultFundingSourceId, _this8.fundingSources);

        if (!actionTaken) {
          var newRate = rate;
          var newTerm = term;
          if (action.name === __WEBPACK_IMPORTED_MODULE_15__data_static_upcomingTransactionActions__["a" /* default */].reinvest.name) {
            var reinvestmentOption = _this8.handleReinvestment({ transaction: t });
            interestYearRatesSelectedPreviously = reinvestmentOption.interestRateAndTerm;
            newTerm = reinvestmentOption.term;
            newRate = reinvestmentOption.rate;
          }

          acc.transactionsWithoutActionTaken.push({
            interestRateAndTerm: interestYearRatesSelectedPreviously,
            transaction: t,
            termsOfConditionAcceptance: false,
            amountForDonation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util__["c" /* formatAmount */])(amount),
            rate: newRate,
            term: newTerm,
            fundingSource: fundingSource,
            action: action
          });
          return acc;
        }
        acc.transactionsWithActionTaken.push({
          interestRateAndTerm: null,
          transaction: t,
          termsOfConditionAcceptance: false,
          amountForDonation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util__["c" /* formatAmount */])(amount),
          rate: rate,
          term: term,
          fundingSource: fundingSource,
          action: action
        });
        return acc;
      }, {
        transactionsWithActionTaken: [],
        transactionsWithoutActionTaken: []
      }),
          transactionsWithoutActionTaken = _transactions$reduce.transactionsWithoutActionTaken,
          transactionsWithActionTaken = _transactions$reduce.transactionsWithActionTaken;

      this.notesTransactionsWithNoAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util__["B" /* orderUpcomingTransactions */])(transactionsWithoutActionTaken);
      this.notesTransactionsWithAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util__["B" /* orderUpcomingTransactions */])(transactionsWithActionTaken);

      return {
        transactionsWithActionTaken: this.notesTransactionsWithAction,
        transactionsWithoutActionTaken: this.notesTransactionsWithNoAction
      };
    },
    getZeroPctCustomRateAndTerm: function getZeroPctCustomRateAndTerm(term) {
      return {
        id: 'zero-pct-id',
        label: '0.00%, ' + term / 12 + ' year' + (term > 12 ? 's' : ''),
        rate: 0,
        term: term
      };
    },
    handleReinvestment: function handleReinvestment(upcomingTransaction) {
      var previousActionTaken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _upcomingTransaction$ = upcomingTransaction.transaction,
          note = _upcomingTransaction$.note,
          rate = _upcomingTransaction$.rate,
          term = _upcomingTransaction$.term,
          actionTaken = _upcomingTransaction$.actionTaken;

      var interestTerm = term !== 0 ? term : note.interestTerm;
      var interestRate = rate !== 0 ? rate : note.interestRate;

      var interestRateAndTerm = void 0;
      var newRate = void 0;
      var newTerm = void 0;

      var yearRatesForNote = this.getYearRatesForNote(upcomingTransaction);
      var filteredYearRates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["filter"])(this.yearRates, function (r) {
        return r.rate === interestRate && r.term === interestTerm;
      });
      var needsCustom = filteredYearRates.length === 0 && note.interestRate === 0 && note.interestTerm > 1;

      if (!needsCustom) {
        interestRateAndTerm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util__["y" /* findRates */])(this.yearRates, interestTerm, interestRate);
        newRate = interestRateAndTerm.rate;
        newTerm = interestRateAndTerm.term;
        return {
          interestRateAndTerm: interestRateAndTerm,
          rate: newRate,
          term: newTerm
        };
      }

      if (!term && !rate && previousActionTaken) {
        var lowerRates = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["filter"])(yearRatesForNote, function (item) {
          return item.term <= interestTerm;
        });
        interestRateAndTerm = lowerRates[0] || this.yearRates[0];
        newTerm = interestRateAndTerm.term;
        newRate = interestRateAndTerm.rate;
        return {
          interestRateAndTerm: interestRateAndTerm,
          rate: newRate,
          term: newTerm
        };
      }

      newRate = !actionTaken ? note.interestRate : rate;
      newTerm = !actionTaken ? note.interestTerm : term;
      interestRateAndTerm = this.getZeroPctCustomRateAndTerm(newTerm);

      return {
        interestRateAndTerm: interestRateAndTerm,
        rate: newRate,
        term: newTerm
      };
    },
    actionChanged: function actionChanged(_ref3) {
      var _this9 = this;

      var action = _ref3.action,
          index = _ref3.index,
          actionPreviousTaken = _ref3.actionPreviousTaken;

      var upcomingTransaction = actionPreviousTaken ? this.notesTransactionsWithAction[index] : this.notesTransactionsWithNoAction[index];

      upcomingTransaction.fundingSource = null;
      upcomingTransaction.interestRateAndTerm = null;

      if (action.name === __WEBPACK_IMPORTED_MODULE_15__data_static_upcomingTransactionActions__["a" /* default */].cashout.name) {
        upcomingTransaction.fundingSource = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["find"])(this.fundingSources, function (fs) {
          return fs.id === _this9.user.accounts[_this9.activeAccountIndex].defaultFundingSourceId;
        });
      } else if (action.name === __WEBPACK_IMPORTED_MODULE_15__data_static_upcomingTransactionActions__["a" /* default */].reinvest.name) {
        var reinvestOption = this.handleReinvestment(upcomingTransaction, actionPreviousTaken);
        upcomingTransaction.interestRateAndTerm = reinvestOption.interestRateAndTerm;
        upcomingTransaction.rate = reinvestOption.rate;
        upcomingTransaction.term = reinvestOption.term;
      }
    },
    submitUpcomingTransaction: function submitUpcomingTransaction(noteTransaction, selectedRateAndTerm) {
      var _this10 = this;

      if (this.isReadOnly) {
        return;
      }
      this.submitsDisabled = true;

      var transaction = noteTransaction.transaction,
          fundingSource = noteTransaction.fundingSource,
          action = noteTransaction.action,
          termsOfConditionAcceptance = noteTransaction.termsOfConditionAcceptance;


      var upcomingTransactionToUpdate = {
        actionTaken: action.name,
        fundingSourceId: fundingSource ? String(fundingSource.id) : '',
        rate: selectedRateAndTerm ? selectedRateAndTerm.rate : -1,
        term: selectedRateAndTerm ? selectedRateAndTerm.term : -1,
        termsOfConditionAcceptance: termsOfConditionAcceptance
      };

      this.updateUpcomingTransaction({
        payload: upcomingTransactionToUpdate,
        transactionId: transaction.id
      }).then(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this10.initializeState();

              case 2:
                _this10.submitsDisabled = false;

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this10);
      }))).catch(function (errors) {
        _this10.setErrorsModalInfo(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util__["C" /* convertErrorStringsToArrayStrings */])(errors.message));
        _this10.showErrorsModal();
        _this10.submitsDisabled = false;
      });
    },
    isWithinAllowedWindow: function isWithinAllowedWindow(maturityDate) {
      if (!maturityDate) return false;
      var maturity = new Date(maturityDate);
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      maturity.setHours(0, 0, 0, 0);
      var diffTime = maturity - today;
      var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays >= 4 && diffDays <= 45;
    },
    handleAddFundsToReinvestments: function handleAddFundsToReinvestments() {
      if (this.isReadOnly) {
        return;
      }
      this.editingInvestment = null;
      this.showAddMoneyModal = true;
    },
    closeAddMoneyModal: function closeAddMoneyModal() {
      this.showAddMoneyModal = false;
      this.editingInvestment = null;
    },
    submitAddMoney: function submitAddMoney(_ref5) {
      var _this11 = this;

      var noteId = _ref5.noteId,
          fundingSourceId = _ref5.fundingSourceId,
          fundingSourceType = _ref5.fundingSourceType,
          fundingSourceName = _ref5.fundingSourceName,
          amount = _ref5.amount;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this11.addMoneyLoading = true;
                _context5.prev = 1;

                if (!_this11.editingInvestment) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 5;
                return _this11.cancelAccountExtraReinvestment({
                  accountId: _this11.activeAccountId,
                  extraReinvestmentId: _this11.editingInvestment.id
                });

              case 5:
                _context5.next = 7;
                return _this11.createAccountExtraReinvestment({
                  accountId: _this11.activeAccountId,
                  payload: { amount: amount, noteId: noteId, fundingSourceId: fundingSourceId, fundingSourceType: fundingSourceType, fundingSourceName: fundingSourceName }
                });

              case 7:
                _context5.next = 9;
                return _this11.loadExtraReinvestments();

              case 9:

                if (_this11.editingInvestment) {
                  _this11.showInformationModal('Your additional investment has been updated successfully.');
                } else {
                  _this11.showInformationModal('Your additional investment of ' + _this11.formatAmount(amount) + ' has been scheduled successfully.');
                }

                _this11.closeAddMoneyModal();
                _context5.next = 17;
                break;

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5['catch'](1);

                _this11.setErrorsModalInfo(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util__["C" /* convertErrorStringsToArrayStrings */])(_context5.t0.message || 'Failed to process your request. Please try again.'));
                _this11.showErrorsModal();

              case 17:
                _context5.prev = 17;

                _this11.addMoneyLoading = false;
                return _context5.finish(17);

              case 20:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this11, [[1, 13, 17, 20]]);
      }))();
    },
    editAdditionalInvestment: function editAdditionalInvestment(investment) {
      this.editingInvestment = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, investment);
      this.showAddMoneyModal = true;
    },
    confirmCancelAdditionalInvestment: function confirmCancelAdditionalInvestment(investment) {
      this.cancellingInvestment = investment;
      this.showCancelConfirmModal = true;
    },
    closeCancelConfirmModal: function closeCancelConfirmModal() {
      this.showCancelConfirmModal = false;
      this.cancellingInvestment = null;
    },
    cancelAdditionalInvestment: function cancelAdditionalInvestment() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (_this12.cancellingInvestment) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt('return');

              case 2:
                _this12.cancellingLoading = true;
                _context6.prev = 3;
                _context6.next = 6;
                return _this12.cancelAccountExtraReinvestment({
                  accountId: _this12.activeAccountId,
                  extraReinvestmentId: _this12.cancellingInvestment.id
                });

              case 6:
                _context6.next = 8;
                return _this12.loadExtraReinvestments();

              case 8:
                _this12.showInformationModal('Your additional investment has been cancelled.');
                _this12.closeCancelConfirmModal();
                _context6.next = 16;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6['catch'](3);

                _this12.setErrorsModalInfo(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util__["C" /* convertErrorStringsToArrayStrings */])(_context6.t0.message || 'Failed to cancel investment. Please try again.'));
                _this12.showErrorsModal();

              case 16:
                _context6.prev = 16;

                _this12.cancellingLoading = false;
                return _context6.finish(16);

              case 19:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this12, [[3, 12, 16, 19]]);
      }))();
    }
  })
});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_bootstrap_datetimepicker__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_AddressSuggestion__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_AddressSuggestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_AddressSuggestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_CommercialAddressOverride__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_CommercialAddressOverride___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_modals_CommercialAddressOverride__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_Information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_Information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_modals_Information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__entities_userProfile__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_formControls_RestrictedTwoInputs__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_formControls_RestrictedTwoInputs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_formControls_RestrictedTwoInputs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__data_static_upcomingTransactionActions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__data_static_reinvestProhibitedStates__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__data_static_constants__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__ = __webpack_require__(25);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














 // eslint-disable-line no-unused-vars




var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_17__util__["b" /* formatDate */]
  }
};

var acceptedFileExtensions = ['png', 'jpg', 'jpeg', 'tif', 'pdf'];

var MAX_FILE_SIZE = 10485760;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserCreationByAdmin',
  created: function created() {
    this.loadUserProfile();
  },
  beforeMount: function beforeMount() {
    this.loadUserProfile();
    this.loadPaymentPreference();
  },

  mixins: [mix],
  data: function data() {
    return {
      minimumAge: 18,
      isResidentDefaultAddress: false,
      disableSubmit: false,
      newUser: null,
      uploadedFiles: [],
      isFileInvalid: false,
      uploadFailed: false,
      uploadSucceeded: false,
      selectedFile: null,
      isLoading: false,
      isBirthFieldInvalid: false,
      dateBirthConfig: {
        format: 'MM/DD/YYYY'
      },
      dateBirthFormat: 'YYYY-MM-DD',
      creationSucceeded: false,
      provideInvestorLogin: false,
      enableMfa: false,
      mfaPhonePreference: null,
      paymentPreference: [],
      ssnAvailabilityStatus: null,
      emailAvailabilityStatus: null,
      hasBeenAllowedCommercialAddress: false,
      commercialAddressOverrideComment: '',
      isCommercialOverrideModalVisible: false
    };
  },

  watch: {
    isSuggestedAddressModalVisible: function isSuggestedAddressModalVisible(newVal) {
      if (newVal) {
        this.disableSubmit = false;
      }
    },
    suggestedAddressModalYesCall: function suggestedAddressModalYesCall(_ref) {
      var _this = this;

      var suggestedAddress = _ref.suggestedAddress,
          addressType = _ref.addressType;
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.isResidentDefaultAddress) {
                  _this.newUser.residentialAddress = suggestedAddress;
                  _this.newUser.mailingAddress = suggestedAddress;
                }

                if (['residential', 'organization'].includes(addressType)) {
                  _this.newUser.residentialAddress = suggestedAddress;
                } else if (addressType === 'mailing') {
                  _this.newUser.mailingAddress = suggestedAddress;
                }
                _context.next = 4;
                return _this.validateAndSubmitUser();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    newUser: {
      handler: function handler(_ref2) {
        var paymentPreference = _ref2.paymentPreference,
            interestPreference = _ref2.interestPreference,
            state = _ref2.residentialAddress.state;

        if (this.isProhibitedStateSelected(state)) {
          if (paymentPreference === 'reinvest') {
            this.newUser.paymentPreference = 'payout';
          }
          if (interestPreference === 'reinvest') {
            this.newUser.interestPreference = 'payout';
          }
        }
      },

      deep: true
    },
    provideInvestorLogin: function provideInvestorLogin(newValue) {
      if (!newValue) {
        this.enableMfa = false;
        // Clear MFA phone preference when login is disabled
        this.mfaPhonePreference = null;
      }
    },
    enableMfa: function enableMfa(newValue) {
      // Clear MFA phone preference when MFA is disabled
      if (!newValue) {
        this.mfaPhonePreference = null;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    hasPrimaryPhone: function hasPrimaryPhone() {
      return !!this.getPhoneDigits(this.newUser.primaryPhoneNum);
    },
    hasSecondaryPhone: function hasSecondaryPhone() {
      return !!this.getPhoneDigits(this.newUser.secondaryPhoneNum);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('app', ['user', 'geoLocation']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('accountCreation', ['isSuggestedAddressModalVisible', 'changeAddress', 'suggestedAddressModalYesCall']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])('information', ['isInformationModalVisible']), {
    emailRequired: function emailRequired() {
      return this.selectedUserType === 'INSTITUTIONAL_REPRESENTATIVE' || this.selectedUserType === 'READ_ONLY';
    },
    selectedUserType: function selectedUserType() {
      return this.newUser && this.newUser.userType || '';
    },
    isInstitutionalRepresentative: function isInstitutionalRepresentative() {
      return this.selectedUserType === 'INSTITUTIONAL_REPRESENTATIVE';
    },
    streetAddressLabel: function streetAddressLabel() {
      return 'Street address' + (this.selectedUserType !== 'INSTITUTIONAL_REPRESENTATIVE' && this.selectedUserType !== 'READ_ONLY' ? '*' : '');
    },
    showProvideLoginOption: function showProvideLoginOption() {
      return this.newUser.userType === 'INVESTOR' || this.newUser.userType === 'ADVISOR' || this.newUser.userType === 'MINOR' || this.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || this.newUser.userType === 'READ_ONLY';
    },
    showLoginNotice: function showLoginNotice() {
      return this.newUser.userType === 'MINOR' && this.provideInvestorLogin;
    },
    emailIsInvalid: function emailIsInvalid() {
      return !this.newUser.email || this.errors.items.find(function (err) {
        return err.field === 'PrimaryEmail';
      });
    },
    paymentPreferences: function paymentPreferences() {
      return this.isProhibitedStateSelected(this.newUser.residentialAddress.state) ? this.paymentPreference.filter(function (preference) {
        return preference.name !== 'reinvest';
      }) : this.paymentPreference;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('userCreationByAdmin', ['saveUserProfile', 'provisionUser', 'checkAvailability']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])('accountCreation', ['updateUserDwollaProfile', 'putDocumentToS3', 'createAccountDocuments']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('information', {
    showInformationModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["d" /* SHOW_INFORMATION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('accountCreation', {
    setSuggestedAddress: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["o" /* SET_SUGGESTED_ADDRESS */],
    setUserByAdmin: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["y" /* SET_USER_BY_ADMIN */],
    setSuggestedAddressType: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["p" /* SET_SUGGESTED_ADDRESS_TYPE */],
    setSuggestedAddressModalVisible: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["q" /* SET_SUGGESTED_ADDRESS_MODAL_VISIBLE */],
    setSuggestedAddressYesMethod: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["r" /* SET_SUGGESTED_ADDRESS_YES_METHOD */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), {
    loadUserProfile: function loadUserProfile() {
      this.newUser = new __WEBPACK_IMPORTED_MODULE_15__entities_userProfile__["a" /* default */]();
      this.newUser.userType = 'INVESTOR';
      this.newUser.interestPreference = 'reinvest';
      this.newUser.paymentPreference = 'reinvest';
      if (this.geoLocation.countries && this.geoLocation.countries.length > 0) {
        this.newUser.residentialAddress.country = this.geoLocation.countries[0].abbreviation;
        this.newUser.mailingAddress.country = this.geoLocation.countries[0].abbreviation;
      }
    },
    countryStates: function countryStates(address) {
      if (this.newUser[address].country === this.geoLocation.countries[0].abbreviation) {
        if (address !== 'mailingAddress') {
          return this.geoLocation.states.filter(function (state) {
            return !state.onlyMailingAddress;
          });
        }
        return this.geoLocation.states;
      }
      return this.geoLocation.canadaStates;
    },
    loadPaymentPreference: function loadPaymentPreference() {
      this.paymentPreference = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_18__data_static_upcomingTransactionActions__["a" /* default */]).map(function (key) {
        return __WEBPACK_IMPORTED_MODULE_18__data_static_upcomingTransactionActions__["a" /* default */][key];
      });
    },
    checkDateBirth: function checkDateBirth() {
      return false;
    },
    residentialAddressUpdated: function residentialAddressUpdated($event) {
      this.newUser.residentialAddress.streetAddress1 = $event.primary;
      this.newUser.residentialAddress.streetAddress2 = $event.secondary;
    },
    mailingAddressUpdated: function mailingAddressUpdated($event) {
      this.newUser.mailingAddress.streetAddress1 = $event.primary;
      this.newUser.mailingAddress.streetAddress2 = $event.secondary;
    },
    truncateAddressIfNecessary: function truncateAddressIfNecessary(address) {
      var localAddress = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, address);
      var hasStreetAddress1 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress1');
      var hasStreetAddress2 = Object.prototype.hasOwnProperty.call(localAddress, 'streetAddress2');
      if (hasStreetAddress1 && hasStreetAddress2) {
        var totalAdressLength = address.streetAddress1.length + address.streetAddress2.length;
        if (totalAdressLength > 50) {
          var charsToCut = totalAdressLength - 50;
          localAddress.streetAddress2 = address.streetAddress2.slice(0, -charsToCut);
          return localAddress;
        }
      }
      return address;
    },
    isDateBirthValid: function isDateBirthValid(dateOfBirth) {
      if (dateOfBirth === '') {
        return true;
      }
      var birthYear = new Date(dateOfBirth).getFullYear();
      var currentYear = new Date().getFullYear();
      return currentYear - birthYear >= this.minimumAge;
    },
    getAcceptedFileExtensions: function getAcceptedFileExtensions() {
      return acceptedFileExtensions.map(function (ext) {
        return '.' + ext;
      }).join(',');
    },
    getSsnDigits: function getSsnDigits(ssn) {
      return ssn.replace(/[- ]/g, '');
    },
    getCRDDigits: function getCRDDigits(crd) {
      return crd.replace(/[- ]/g, '');
    },
    getPhoneDigits: function getPhoneDigits(phoneNum) {
      return phoneNum ? phoneNum.replace(/[-() ]/g, '') : '';
    },
    onPhoneNumberChange: function onPhoneNumberChange() {
      // Auto-clear preference if the selected phone is removed
      if (this.mfaPhonePreference === 'PRIMARY' && !this.hasPrimaryPhone) {
        this.mfaPhonePreference = null;
      }
      if (this.mfaPhonePreference === 'SECONDARY' && !this.hasSecondaryPhone) {
        this.mfaPhonePreference = null;
      }
    },
    getDateOnlyDOB: function getDateOnlyDOB(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).format(this.dateBirthFormat).toString();
    },
    copyMailingAddress: function copyMailingAddress() {
      this.newUser.mailingAddress = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.newUser.residentialAddress);
    },
    isStateSelected: function isStateSelected(userProfile) {
      return userProfile.residentialAddress.state.length > 0;
    },
    validateUserProfile: function validateUserProfile(userProfile) {
      var listUserErrors = [];
      if (!this.isDateBirthValid(userProfile.dateOfBirth) && (userProfile.userType === 'INVESTOR' || userProfile.userType === 'INSTITUTIONAL_REPRESENTATIVE')) {
        listUserErrors.push('You must be 18 years or older in order to invest with us.');
      }
      var SsnRegex = /^[0-9]{3}-?[0-9]{2}-?[0-9]{4}$/;
      if (userProfile.socialSecurityNum && !SsnRegex.test(userProfile.socialSecurityNum)) {
        listUserErrors.push('Enter a valid social security number.');
      }
      var phoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/; // eslint-disable-line no-useless-escape
      if (!phoneRegex.test(userProfile.primaryPhoneNum)) {
        listUserErrors.push('Enter a valid primary phone number.');
      }
      if (userProfile.secondaryPhoneNum.length > 0 && !phoneRegex.test(userProfile.secondaryPhoneNum)) {
        listUserErrors.push('Enter a valid secondary phone number.');
      }
      if (userProfile.userType === 'ADVISOR' || userProfile.userType === 'INVESTOR' || userProfile.userType === 'MINOR') {
        if (!__WEBPACK_IMPORTED_MODULE_17__util__["p" /* zipRegex */].test(userProfile.residentialAddress.zipCode)) {
          listUserErrors.push('Provide a valid residential zip code.');
        }
        if (this.isResidentDefaultAddress && !__WEBPACK_IMPORTED_MODULE_17__util__["p" /* zipRegex */].test(userProfile.mailingAddress.zipCode)) {
          listUserErrors.push('Provide a valid mailing zip code.');
        }
        if (!this.isStateSelected(userProfile)) {
          listUserErrors.push('Please select a state in order to save your profile.');
        }
      }
      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
      if ((userProfile.userType !== 'INVESTOR' || userProfile.userType === 'MINOR') && userProfile.email) {
        if (!regex.test(userProfile.email)) {
          listUserErrors.push('Please, enter a valid email. ');
        }
      }
      return listUserErrors;
    },
    setDataWithoutMasks: function setDataWithoutMasks() {
      this.newUser.primaryPhoneNum = this.getPhoneDigits(this.newUser.primaryPhoneNum);
      this.newUser.secondaryPhoneNum = this.getPhoneDigits(this.newUser.secondaryPhoneNum);
      this.newUser.socialSecurityNum = this.getSsnDigits(this.newUser.socialSecurityNum);
      this.newUser.dateOfBirth = this.getDateOnlyDOB(this.newUser.dateOfBirth);
      if (this.newUser.CRDnumber) {
        this.newUser.CRDnumber = this.getCRDDigits(this.newUser.CRDnumber);
      }
    },
    isProhibitedStateSelected: function isProhibitedStateSelected(state) {
      return __WEBPACK_IMPORTED_MODULE_19__data_static_reinvestProhibitedStates__["a" /* default */].find(function (s) {
        return s === state;
      }) !== undefined;
    },
    isZipCodeInvalid: function isZipCodeInvalid(zipCode) {
      if (!zipCode) {
        return false;
      }
      return !__WEBPACK_IMPORTED_MODULE_17__util__["p" /* zipRegex */].test(zipCode);
    },
    validateAndSubmitUser: function validateAndSubmitUser() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var listUserErrors, newUser, created, _created, _created2, _created3, _created4;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.disableSubmit = true;
                _this2.setUserByAdmin(_this2.newUser);
                listUserErrors = _this2.validateUserProfile(_this2.newUser);

                if (!(listUserErrors.length > 0)) {
                  _context2.next = 8;
                  break;
                }

                _this2.showUserModalsError(listUserErrors);
                _this2.disableSubmit = false;

                return _context2.abrupt('return');

              case 8:
                if (!_this2.isResidentDefaultAddress) {
                  _this2.copyMailingAddress();
                }
                _this2.setDataWithoutMasks();

                // Add mfaPhonePreference to newUser before saving
                _this2.newUser.mfaPhonePreference = _this2.mfaPhonePreference;

                newUser = _this2.newUser;

                if (newUser.userType !== 'INVESTOR' && newUser.userType !== 'MINOR' && newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' || newUser.dateOfBirth === 'Invalid date') {
                  newUser.dateOfBirth = null;
                }

                if (!(newUser.userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].INVESTOR.name)) {
                  _context2.next = 21;
                  break;
                }

                _context2.next = 16;
                return _this2.createInvestor(newUser);

              case 16:
                created = _context2.sent;

                if (created) _this2.goBack();
                return _context2.abrupt('return');

              case 21:
                if (!(newUser.userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name)) {
                  _context2.next = 29;
                  break;
                }

                _context2.next = 24;
                return _this2.createFinancialAdvisor(newUser);

              case 24:
                _created = _context2.sent;

                if (_created) _this2.goBack();
                return _context2.abrupt('return');

              case 29:
                if (!(newUser.userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].INSTITUTIONAL_REPRESENTATIVE.name)) {
                  _context2.next = 37;
                  break;
                }

                _context2.next = 32;
                return _this2.createInstitutionalRepresentative(newUser);

              case 32:
                _created2 = _context2.sent;

                if (_created2) _this2.goBack();
                return _context2.abrupt('return');

              case 37:
                if (!(newUser.userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].READ_ONLY.name)) {
                  _context2.next = 45;
                  break;
                }

                _context2.next = 40;
                return _this2.createReadOnly(newUser);

              case 40:
                _created3 = _context2.sent;

                if (_created3) _this2.goBack();
                return _context2.abrupt('return');

              case 45:
                if (!(newUser.userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].ADMIN.name)) {
                  _context2.next = 51;
                  break;
                }

                _context2.next = 48;
                return _this2.createUserAdmin(newUser);

              case 48:
                _created4 = _context2.sent;

                if (_created4) _this2.goBack();
                return _context2.abrupt('return');

              case 51:

                if (newUser.userType === 'MINOR') {
                  newUser.streetAddress1 = newUser.residentialAddress.streetAddress1;
                  newUser.streetAddress2 = newUser.residentialAddress.streetAddress2;
                  newUser.zipCode = newUser.residentialAddress.zipCode;
                  newUser.city = newUser.residentialAddress.city;
                  newUser.state = newUser.residentialAddress.state;
                  newUser.country = newUser.residentialAddress.country;
                  newUser.mailingStreetAddress1 = newUser.mailingAddress.streetAddress1;
                  newUser.mailingStreetAddress2 = newUser.mailingAddress.streetAddress2;
                  newUser.mailingZipCode = newUser.mailingAddress.zipCode;
                  newUser.mailingCity = newUser.mailingAddress.city;
                  newUser.mailingState = newUser.mailingAddress.state;
                  newUser.mailingCountry = newUser.mailingAddress.country;
                  newUser.isResidentDefaultAddress = _this2.isResidentDefaultAddress;
                }
                _context2.next = 54;
                return _this2.saveUserProfile({
                  user: newUser,
                  files: _this2.uploadedFiles,
                  provideLogin: _this2.provideInvestorLogin,
                  enableMfa: _this2.enableMfa
                });

              case 54:

                _this2.creationSucceeded = true;
                _this2.disableSubmit = false;
                _this2.goBack();
                return _context2.abrupt('return');

              case 60:
                _context2.prev = 60;
                _context2.t0 = _context2['catch'](0);

                _this2.disableSubmit = false;
                // Admins can override a commercial residential address via a modal
                // (re-confirmed each time, not a stored flag).
                if (_context2.t0 && _context2.t0.errorMessage === 'RESIDENTIAL_COMMERCIAL_ADDRESS_NOT_ALLOWED') {
                  _this2.isCommercialOverrideModalVisible = true;
                }

              case 64:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 60]]);
      }))();
    },
    createFinancialAdvisor: function createFinancialAdvisor(newUser) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var CreateUserInvestorData, response;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                CreateUserInvestorData = {
                  firstName: newUser.firstName,
                  lastName: newUser.lastName,
                  email: newUser.email,
                  userType: newUser.userType,
                  organizationName: newUser.organizationName,
                  alternateCompanyName: newUser.alternateCompanyName === '' ? null : newUser.alternateCompanyName,
                  primaryPhoneNum: newUser.primaryPhoneNum,
                  secondaryPhoneNum: newUser.secondaryPhoneNum === '' ? null : newUser.secondaryPhoneNum,
                  mfaPhonePreference: newUser.mfaPhonePreference || _this3.mfaPhonePreference,
                  CRDnumber: newUser.CRDnumber,
                  hasBeenAllowedPOBox: false,
                  mailingAddress: newUser.mailingAddress,
                  businessAddress: newUser.residentialAddress
                };
                _context3.next = 3;
                return _this3.provisionUser({
                  user: CreateUserInvestorData,
                  provideLogin: _this3.provideInvestorLogin,
                  enableMfa: _this3.enableMfa
                });

              case 3:
                response = _context3.sent;


                _this3.disableSubmit = false;
                _this3.creationSucceeded = true;

                if (!(response.statusCode === 422)) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt('return', false);

              case 8:
                return _context3.abrupt('return', true);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    createUserAdmin: function createUserAdmin(newUser) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var CreateUserAdminData, response;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                CreateUserAdminData = {
                  firstName: newUser.firstName,
                  lastName: newUser.lastName,
                  email: newUser.email,
                  userType: newUser.userType,
                  primaryPhoneNum: newUser.primaryPhoneNum,
                  secondaryPhoneNum: newUser.secondaryPhoneNum === '' ? null : newUser.secondaryPhoneNum,
                  mfaPhonePreference: newUser.mfaPhonePreference
                };
                _context4.next = 3;
                return _this4.provisionUser({
                  user: CreateUserAdminData,
                  provideLogin: true,
                  enableMfa: true
                });

              case 3:
                response = _context4.sent;


                _this4.disableSubmit = false;
                _this4.creationSucceeded = true;

                if (!(response.statusCode === 422)) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt('return', false);

              case 8:
                return _context4.abrupt('return', true);

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    createInstitutionalRepresentative: function createInstitutionalRepresentative(newUser) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var data, response;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                data = {
                  firstName: newUser.firstName,
                  lastName: newUser.lastName,
                  email: newUser.email,
                  userType: newUser.userType,
                  secondaryEmail: newUser.secondaryEmail === '' ? undefined : newUser.secondaryEmail,
                  primaryPhoneNum: newUser.primaryPhoneNum,
                  secondaryPhoneNum: newUser.secondaryPhoneNum === '' ? undefined : newUser.secondaryPhoneNum,
                  mfaPhonePreference: newUser.mfaPhonePreference,
                  socialSecurityNum: newUser.socialSecurityNum ? newUser.socialSecurityNum : undefined,
                  dateOfBirth: newUser.dateOfBirth ? newUser.dateOfBirth : undefined,
                  hasBeenAllowedPOBox: false,
                  mailingAddress: newUser.mailingAddress.streetAddress1 ? newUser.mailingAddress : undefined,
                  businessAddress: newUser.residentialAddress.streetAddress1 ? newUser.residentialAddress : undefined
                };
                _context5.next = 3;
                return _this5.provisionUser({
                  user: data,
                  provideLogin: _this5.provideInvestorLogin,
                  enableMfa: _this5.enableMfa
                });

              case 3:
                response = _context5.sent;


                _this5.disableSubmit = false;
                _this5.creationSucceeded = true;

                if (!(response.statusCode === 422)) {
                  _context5.next = 8;
                  break;
                }

                return _context5.abrupt('return', false);

              case 8:
                return _context5.abrupt('return', true);

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    createReadOnly: function createReadOnly(newUser) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var data, response;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                data = {
                  firstName: newUser.firstName,
                  lastName: newUser.lastName,
                  email: newUser.email,
                  userType: newUser.userType, // 'READ_ONLY'
                  secondaryEmail: newUser.secondaryEmail === '' ? undefined : newUser.secondaryEmail,
                  primaryPhoneNum: newUser.primaryPhoneNum,
                  secondaryPhoneNum: newUser.secondaryPhoneNum === '' ? undefined : newUser.secondaryPhoneNum,
                  socialSecurityNum: newUser.socialSecurityNum ? newUser.socialSecurityNum : undefined,
                  dateOfBirth: newUser.dateOfBirth ? newUser.dateOfBirth : undefined,
                  hasBeenAllowedPOBox: false,
                  mailingAddress: newUser.mailingAddress.streetAddress1 ? newUser.mailingAddress : undefined,
                  businessAddress: newUser.residentialAddress.streetAddress1 ? newUser.residentialAddress : undefined
                };
                _context6.next = 3;
                return _this6.provisionUser({
                  user: data,
                  provideLogin: _this6.provideInvestorLogin,
                  enableMfa: _this6.enableMfa
                });

              case 3:
                response = _context6.sent;


                _this6.disableSubmit = false;
                _this6.creationSucceeded = true;

                if (!(response.statusCode === 422)) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt('return', false);

              case 8:
                return _context6.abrupt('return', true);

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    createInvestor: function createInvestor(newUser) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var documentsToUpload, user, response, accountId, documents, uploadedDocuments;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                documentsToUpload = _this7.uploadedFiles.map(function (file) {
                  var name = file.name,
                      size = file.size,
                      type = file.type;


                  return {
                    mimetype: type,
                    originalName: name,
                    size: size
                  };
                });
                user = {
                  firstName: newUser.firstName,
                  lastName: newUser.lastName,
                  email: newUser.email,
                  userType: newUser.userType,
                  secondaryEmail: newUser.secondaryEmail === '' ? null : newUser.secondaryEmail,
                  primaryPhoneNum: newUser.primaryPhoneNum,
                  secondaryPhoneNum: newUser.secondaryPhoneNum === '' ? null : newUser.secondaryPhoneNum,
                  mfaPhonePreference: newUser.mfaPhonePreference,
                  socialSecurityNum: newUser.socialSecurityNum || null,
                  dateOfBirth: newUser.dateOfBirth,
                  paymentPreference: newUser.paymentPreference,
                  interestPreference: newUser.interestPreference,
                  documents: documentsToUpload,
                  hasBeenAllowedPOBox: false,
                  hasBeenAllowedCommercialAddress: _this7.hasBeenAllowedCommercialAddress,
                  commercialAddressOverrideComment: _this7.hasBeenAllowedCommercialAddress ? _this7.commercialAddressOverrideComment : undefined,
                  mailingAddress: newUser.mailingAddress,
                  address: newUser.residentialAddress
                };
                _context8.next = 4;
                return _this7.provisionUser({
                  user: user,
                  provideLogin: _this7.provideInvestorLogin,
                  enableMfa: _this7.enableMfa
                });

              case 4:
                response = _context8.sent;
                accountId = response.accountId, documents = response.documents;

                if (accountId) {
                  _context8.next = 8;
                  break;
                }

                return _context8.abrupt('return', false);

              case 8:
                uploadedDocuments = [];

                if (!documentsToUpload.length) {
                  _context8.next = 13;
                  break;
                }

                _context8.next = 12;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(documents.map(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7(doc) {
                    var file;
                    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            file = _this7.uploadedFiles.find(function (f) {
                              return decodeURIComponent(doc.url).includes(f.name);
                            });
                            _context7.next = 3;
                            return _this7.putDocumentToS3({ presignedUrl: doc.url, file: file });

                          case 3:
                            return _context7.abrupt('return', {
                              mimetype: file.type,
                              size: file.size,
                              originalName: file.originalName,
                              filename: doc.filename
                            });

                          case 4:
                          case 'end':
                            return _context7.stop();
                        }
                      }
                    }, _callee7, _this7);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 12:
                uploadedDocuments = _context8.sent;

              case 13:
                _context8.next = 15;
                return _this7.createAccountDocuments({
                  accountId: accountId,
                  files: { documents: uploadedDocuments }
                });

              case 15:

                _this7.disableSubmit = false;
                _this7.creationSucceeded = true;

                return _context8.abrupt('return', true);

              case 18:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this7);
      }))();
    },
    showUserModalsError: function showUserModalsError(listUserErrors) {
      this.setErrorsModalInfo(listUserErrors);
      this.showErrorsModal();
    },
    goBack: function goBack() {
      this.$router.push({
        name: 'Users'
      });
    },
    selectAdmin: function selectAdmin() {
      this.newUser.organizationName = __WEBPACK_IMPORTED_MODULE_20__data_static_constants__["a" /* Constants */].companyInformation.name;
    },
    selectAdvisor: function selectAdvisor() {
      this.newUser.organizationName = '';
      this.newUser.alternateCompanyName = '';
      this.newUser.CRDnumber = '';
    },
    fileChanged: function fileChanged(_ref4) {
      var files = _ref4.target.files;

      this.isLoading = true;
      this.isFileInvalid = false;
      if (files.length) {
        var selectedFile = files[0];
        var extension = selectedFile.name.split('.').pop().toLowerCase();
        var size = selectedFile.size;

        if (acceptedFileExtensions.indexOf(extension) === -1 || size > MAX_FILE_SIZE) {
          this.isFileInvalid = true;
          this.selectedFile = null;
        } else {
          this.selectedFile = null;
          this.selectedFile = selectedFile;
          this.uploadedFiles.push(this.selectedFile);
        }
      }
      this.isLoading = false;
    },
    removeDocument: function removeDocument(index) {
      if (index > -1) {
        this.uploadedFiles.splice(index, 1);
        this.selectedFile = null;
        var input = this.$refs.fileupload;
        input.type = 'text';
        input.type = 'file';
      }
    },
    submitDifferentMailingAddress: function submitDifferentMailingAddress() {
      this.newUser.mailingAddress.streetAddress1 = '';
      this.newUser.mailingAddress.streetAddress2 = '';
      this.newUser.mailingAddress.zipCode = '';
      this.newUser.mailingAddress.city = '';
      this.newUser.mailingAddress.state = '';
      this.newUser.mailingAddress.state = '';
    },
    confirmCommercialOverride: function confirmCommercialOverride(comment) {
      var _this8 = this;

      this.isCommercialOverrideModalVisible = false;
      this.hasBeenAllowedCommercialAddress = true;
      this.commercialAddressOverrideComment = comment;
      this.disableSubmit = true;
      this.createInvestor(this.newUser).then(function (created) {
        if (created) _this8.goBack();
      });
    },
    cancelCommercialOverride: function cancelCommercialOverride() {
      this.isCommercialOverrideModalVisible = false;
      this.hasBeenAllowedCommercialAddress = false;
      this.commercialAddressOverrideComment = '';
    },
    disableSubmitButton: function disableSubmitButton() {
      return !this.newUser.firstName || !this.newUser.lastName || !this.newUser.primaryPhoneNum || !this.newUser.email && this.newUser.userType !== 'INVESTOR' && this.newUser.userType !== 'MINOR' || (this.newUser.userType === 'ADVISOR' || this.newUser.userType === 'INVESTOR' || this.newUser.userType === 'MINOR') && (!this.newUser.residentialAddress.streetAddress1 || !this.newUser.residentialAddress.zipCode || !this.newUser.residentialAddress.city || !this.newUser.residentialAddress.state || this.isResidentDefaultAddress && (!this.newUser.mailingAddress.streetAddress1 || !this.newUser.mailingAddress.zipCode || !this.newUser.mailingAddress.city || !this.newUser.mailingAddress.state)) || this.newUser.userType === 'ADVISOR' && !this.newUser.organizationName || this.disableSubmit ||
      // Check for SSN validation errors
      this.errors.has('ssn') ||
      // Check for email validation errors (different field names for different user types)
      this.errors.has('Email') || this.errors.has('PrimaryEmail');
    },
    ssnInput: function ssnInput() {
      // Clear SSN errors and availability status when user types
      this.$validator.errors.remove('ssn');
      this.ssnAvailabilityStatus = null;
    },
    checkSsnAvailability: function checkSsnAvailability() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var ssnDigits, response;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                // Clear any previous SSN errors first
                _this9.$validator.errors.remove('ssn');

                // Don't check if there are validation errors or SSN is empty

                if (!(_this9.errors.has('ssn') || !_this9.newUser.socialSecurityNum || _this9.newUser.socialSecurityNum.trim() === '')) {
                  _context9.next = 4;
                  break;
                }

                _this9.ssnAvailabilityStatus = null;
                return _context9.abrupt('return');

              case 4:
                ssnDigits = _this9.getSsnDigits(_this9.newUser.socialSecurityNum);

                if (!(!ssnDigits || ssnDigits.length !== 9)) {
                  _context9.next = 8;
                  break;
                }

                _this9.ssnAvailabilityStatus = null;
                return _context9.abrupt('return');

              case 8:
                if (!(_this9.newUser.id && _this9.newUser.originalSocialSecurityNum && ssnDigits === _this9.newUser.originalSocialSecurityNum)) {
                  _context9.next = 11;
                  break;
                }

                _this9.ssnAvailabilityStatus = null;
                return _context9.abrupt('return');

              case 11:

                _this9.ssnAvailabilityStatus = 'checking';

                _context9.prev = 12;
                _context9.next = 15;
                return _this9.checkAvailability({ ssn: ssnDigits });

              case 15:
                response = _context9.sent;

                _this9.ssnAvailabilityStatus = response ? 'available' : 'unavailable';

                // If SSN is not available, add validation error
                if (!response) {
                  _this9.$validator.errors.add({
                    field: 'ssn',
                    msg: 'The social security number that was entered is not accepted.',
                    id: 'ssn_error'
                  });
                }
                _context9.next = 25;
                break;

              case 20:
                _context9.prev = 20;
                _context9.t0 = _context9['catch'](12);

                console.error('Error checking SSN availability:', _context9.t0);
                _this9.ssnAvailabilityStatus = null;

                // Check if this is an SSN-specific error from the API
                if (_context9.t0 && _context9.t0.message && _context9.t0.message.includes('social security number')) {
                  _this9.ssnAvailabilityStatus = 'unavailable';
                  _this9.$validator.errors.add({
                    field: 'ssn',
                    msg: 'The social security number that was entered is not accepted.',
                    id: 'ssn_error'
                  });
                }

              case 25:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9, [[12, 20]]);
      }))();
    },
    emailInput: function emailInput() {
      // Clear email errors and availability status when user types
      this.$validator.errors.remove('PrimaryEmail');
      this.$validator.errors.remove('Email');
      this.emailAvailabilityStatus = null;
    },
    checkEmailAvailability: function checkEmailAvailability() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var emailRegex, response, fieldName, _fieldName;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                // Clear any previous email errors first
                _this10.$validator.errors.remove('PrimaryEmail');
                _this10.$validator.errors.remove('Email');

                // Don't check if there are validation errors or email is empty

                if (!(_this10.errors.has('PrimaryEmail') || _this10.errors.has('Email') || !_this10.newUser.email || _this10.newUser.email.trim() === '')) {
                  _context10.next = 5;
                  break;
                }

                _this10.emailAvailabilityStatus = null;
                return _context10.abrupt('return');

              case 5:

                // Basic email validation
                emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                if (emailRegex.test(_this10.newUser.email)) {
                  _context10.next = 9;
                  break;
                }

                _this10.emailAvailabilityStatus = null;
                return _context10.abrupt('return');

              case 9:
                if (!(_this10.newUser.id && _this10.newUser.originalEmail && _this10.newUser.email.toLowerCase() === _this10.newUser.originalEmail.toLowerCase())) {
                  _context10.next = 12;
                  break;
                }

                _this10.emailAvailabilityStatus = null;
                return _context10.abrupt('return');

              case 12:

                _this10.emailAvailabilityStatus = 'checking';

                _context10.prev = 13;
                _context10.next = 16;
                return _this10.checkAvailability({ email: _this10.newUser.email.toLowerCase() });

              case 16:
                response = _context10.sent;

                _this10.emailAvailabilityStatus = response ? 'available' : 'unavailable';

                // If email is not available, add validation error
                if (!response) {
                  // Determine which field name to use based on user type
                  fieldName = _this10.newUser.userType === 'ADMIN' || _this10.newUser.userType === 'ADVISOR' ? 'Email' : 'PrimaryEmail';

                  _this10.$validator.errors.add({
                    field: fieldName,
                    msg: 'An account with the given email already exists',
                    id: 'email_error'
                  });
                }
                _context10.next = 26;
                break;

              case 21:
                _context10.prev = 21;
                _context10.t0 = _context10['catch'](13);

                console.error('Error checking email availability:', _context10.t0);
                _this10.emailAvailabilityStatus = null;

                // Check if this is an email-specific error from the API
                if (_context10.t0 && _context10.t0.message && (_context10.t0.message.includes('email') || _context10.t0.message.includes('Email'))) {
                  _this10.emailAvailabilityStatus = 'unavailable';
                  // Determine which field name to use based on user type
                  _fieldName = _this10.newUser.userType === 'ADMIN' || _this10.newUser.userType === 'ADVISOR' ? 'Email' : 'PrimaryEmail';

                  _this10.$validator.errors.add({
                    field: _fieldName,
                    msg: 'An account with the given email already exists',
                    id: 'email_error'
                  });
                }

              case 26:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10, [[13, 21]]);
      }))();
    }
  }),
  components: {
    datePicker: __WEBPACK_IMPORTED_MODULE_9_vue_bootstrap_datetimepicker___default.a,
    errors: __WEBPACK_IMPORTED_MODULE_11__components_modals_Errors___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_14__components_widgets_Spinner___default.a,
    information: __WEBPACK_IMPORTED_MODULE_13__components_modals_Information___default.a,
    RestrictedTwoInputs: __WEBPACK_IMPORTED_MODULE_16__components_formControls_RestrictedTwoInputs___default.a,
    'address-suggestion': __WEBPACK_IMPORTED_MODULE_10__components_modals_AddressSuggestion___default.a,
    'commercial-address-override': __WEBPACK_IMPORTED_MODULE_12__components_modals_CommercialAddressOverride___default.a
  }
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_primevue_multiselect__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_primevue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_primevue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_AddressSuggestion__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_AddressSuggestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modals_AddressSuggestion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_CommercialAddressOverride__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modals_CommercialAddressOverride___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_modals_CommercialAddressOverride__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_Information__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals_Information___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_modals_Information__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_widgets_DismissableAlert__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_widgets_DismissableAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_widgets_DismissableAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_modals_AccountCreation__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_modals_AccountCreation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_modals_AccountCreation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_modals_MergePartialUser__ = __webpack_require__(2091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_modals_MergePartialUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_modals_MergePartialUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Addresses__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Addresses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Addresses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_BasicInformation__ = __webpack_require__(2026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_BasicInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_BasicInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__data_static_addressErrors__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Breadcrumb__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_formControls_RestrictedTextArea__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_formControls_RestrictedTextArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_formControls_RestrictedTextArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__data_static_constants__ = __webpack_require__(16);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




























var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_25__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_25__util__["c" /* formatAmount */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserDetail',
  beforeMount: function beforeMount() {
    this.initializeState();
    this.loadUserDetail();
    this.loadUserFeedback();
  },

  watch: {
    suggestedAddressModalYesCall: function suggestedAddressModalYesCall(_ref) {
      var _this = this;

      var payload = _ref.payload,
          suggestedAddress = _ref.suggestedAddress,
          addressType = _ref.addressType;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.$refs.addresses.isMailingAddressDifferent) {
                  _this.user.residentialAddress = suggestedAddress;
                  _this.user.mailingAddress = suggestedAddress;
                  _this.$refs.addresses.setResidencialAddress(suggestedAddress);
                  _this.$refs.addresses.setMailingAddress(suggestedAddress);
                }
                if (['residential', 'organization'].includes(addressType)) {
                  _this.user.residentialAddress = suggestedAddress;
                  _this.$refs.addresses.setResidencialAddress(suggestedAddress);
                } else if (addressType === 'mailing') {
                  _this.user.mailingAddress = suggestedAddress;
                  _this.$refs.addresses.setMailingAddress(suggestedAddress);
                }
                _context.next = 4;
                return _this.save(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, payload, {
                  residentialAddress: _this.user.residentialAddress,
                  mailingAddress: _this.user.mailingAddress
                }));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    userCommentCategory: function userCommentCategory() {
      if (!this.userCommentCategoriesHasChanged) return;
      this.saveComments();
    },
    provideInvestorLogin: function provideInvestorLogin(_provideInvestorLogin) {
      if (!_provideInvestorLogin) {
        this.enableMfa = false;
      }
    },
    enableMfa: function enableMfa(newValue) {
      // Clear MFA phone preference when MFA is disabled
      if (!newValue && this.$refs.basicInformation) {
        this.$refs.basicInformation.mfaPhonePreference = null;
      }
    },

    user: function changedUser(newUser) {
      this.defaultAccountId = newUser.defaultAccountId;
      this.breadcrumbData = [];
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
        title: 'Search',
        goto: { name: 'Users' },
        selected: false
      }));
      var title = newUser.firstName.concat(' ', newUser.lastName);
      var goto = { name: this.$route.name, params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$route.params) };
      this.breadcrumbData.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
        title: title,
        goto: goto,
        selected: true
      }));
    }
  },
  mixins: [mix],
  data: function data() {
    return {
      userId: '',
      minimumAge: 18,
      breadcrumbData: [],
      user: {},
      defaultAccountId: null,
      showDefaultAccountChanged: false,
      isLoading: false,
      creationSucceeded: false,
      fetchingSummaryReports: false,
      userTypes: __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */],
      provideInvestorLogin: false,
      enableMfa: false,
      emailIsValid: false,
      userHasBeenAllowedPOBox: false,
      isCommercialOverrideModalVisible: false,
      pendingCommercialOverridePayload: null,
      userCommentCategory: [],
      userCommentInput: '',
      savingComment: false,
      commentSaved: false,
      commentSaveError: false,
      isMergePartialUserModalVisible: false,
      userFeedback: [],
      fetchingFeedback: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('accountCreation', ['isSuggestedAddressModalVisible', 'isAccountCreationModalVisible', 'changeAddress', 'suggestedAddressModalYesCall']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('information', ['isInformationModalVisible']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('question', ['display']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('app', {
    userCommentCategories: function userCommentCategories(state) {
      return state.userCommentCategories;
    },
    loggedUser: function loggedUser(state) {
      return state.user;
    }
  }), {
    userCommentCategoriesHasChanged: function userCommentCategoriesHasChanged() {
      return this.user.commentCategories !== this.userCommentCategory;
    },
    userCommentsHasChanged: function userCommentsHasChanged() {
      return this.user.comments !== this.userCommentInput;
    },
    showProvideLoginOption: function showProvideLoginOption() {
      return this.user.userType === this.userTypes.INVESTOR.name || this.user.userType === this.userTypes.MINOR.name || this.user.userType === this.userTypes.INSTITUTIONAL_REPRESENTATIVE.name || this.user.userType === this.userTypes.READ_ONLY.name;
    },
    showLoginNotice: function showLoginNotice() {
      return this.user.userType === this.userTypes.MINOR.name && this.provideInvestorLogin;
    },
    shouldBeCheckedByDefault: function shouldBeCheckedByDefault() {
      return this.provideInvestorLogin || this.user.clientId !== null;
    },
    showRecentActivity: function showRecentActivity() {
      return true;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    formatLoginTimestamp: function formatLoginTimestamp(date) {
      if (!date) return '----------';
      return __WEBPACK_IMPORTED_MODULE_10_moment___default()(date).format('MM/DD/YYYY h:mm A');
    },
    loadUserFeedback: function loadUserFeedback() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.fetchingFeedback = true;
                _context2.next = 3;
                return _this2.getUserFeedback(_this2.userId).then(function (data) {
                  _this2.userFeedback = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["orderBy"])(data || [], ['createdAt'], ['desc']);
                }).catch(function (error) {
                  // Feedback is supplemental, so a failure here must not block the page.
                  console.error('Error fetching user feedback:', error);
                  _this2.userFeedback = [];
                });

              case 3:
                _this2.fetchingFeedback = false;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    formatFeedbackDate: function formatFeedbackDate(date) {
      if (!date) return '----------';
      return __WEBPACK_IMPORTED_MODULE_10_moment___default()(date).format('MM/DD/YYYY h:mm A');
    },
    formatFeedbackScore: function formatFeedbackScore(score) {
      // Out of 10, so the number reads as a rating rather than a count.
      return score === null || score === undefined ? '—' : score + '/10';
    },
    setSavingComment: function setSavingComment() {
      this.savingComment = true;
      this.commentSaved = false;
      this.commentSaveError = false;
    },
    setCommentSaved: function setCommentSaved() {
      this.savingComment = false;
      this.commentSaved = true;
      this.commentSaveError = false;
    },
    setCommentSaveError: function setCommentSaveError() {
      this.savingComment = false;
      this.commentSaved = false;
      this.commentSaveError = true;
    },
    saveComments: function saveComments() {
      var _this3 = this;

      this.setSavingComment();
      var payload = {
        comments: this.userCommentInput,
        commentCategories: this.userCommentCategory.map(function (c) {
          return c.id;
        })
      };

      this.addUserComments({ userId: this.user.id, payload: payload }).then(function () {
        _this3.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this3.user, { comments: _this3.userCommentInput });
        _this3.setCommentSaved();
      }).catch(function () {
        _this3.setCommentSaveError();
      });
    },

    debouncedSave: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["debounce"])(function fn() {
      this.saveComments();
    }, 800),
    commentUpdated: function commentUpdated($event) {
      this.setSavingComment();
      this.userCommentInput = $event;
      if (!this.userCommentsHasChanged) return;

      this.debouncedSave();
    },
    getHasBeenAllowedPOBoxValue: function getHasBeenAllowedPOBoxValue() {
      return this.$refs.addresses.hasBeenAllowedPOBox;
    },
    hideDefaultAccountAlert: function hideDefaultAccountAlert() {
      this.showDefaultAccountChanged = false;
    },
    changeDefaultAccount: function changeDefaultAccount(account) {
      var _this4 = this;

      if (this.loggedUser && this.loggedUser.userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].READ_ONLY.name && this.user && this.user.id !== this.loggedUser.id) {
        return;
      }
      this.showQuestionModal({
        title: 'Default Account',
        question: 'Are you sure you want to select ' + account.accountName + ' as new default account?',
        method: function method() {
          _this4.confirmChangeDefaultAccount(account.id);
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_26__data_static_constants__["a" /* Constants */].purchaseNote.modalYesButtonText,
        hideCancelButton: false
      });
    },
    confirmChangeDefaultAccount: function confirmChangeDefaultAccount(id) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this5.loggedUser && _this5.loggedUser.userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].READ_ONLY.name && _this5.user && _this5.user.id !== _this5.loggedUser.id)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                _this5.isLoading = true;
                _context3.prev = 3;
                _context3.next = 6;
                return _this5.setDefaultAccount({
                  accountId: id,
                  userId: _this5.user.id
                });

              case 6:
                _this5.hideQuestionModal();
                _context3.next = 9;
                return _this5.loadUserDetail();

              case 9:
                _this5.isLoading = false;
                _this5.showDefaultAccountChanged = true;
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](3);

                _this5.isLoading = false;

              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[3, 13]]);
      }))();
    },
    handleEmailChange: function handleEmailChange($event) {
      this.emailIsValid = $event.valid;
      if (!this.emailIsValid) {
        this.provideInvestorLogin = false;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('userCreationByAdmin', ['updateUserProfile', 'updateUser']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('user', ['addUserComments']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('feedback', ['getUserFeedback']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('account', ['getAccountSummaryReport', 'getDocumentFromS3']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('accountCreation', ['setDefaultAccount', 'getUserDetail']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */],
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('information', {
    showInformationModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["d" /* SHOW_INFORMATION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('accountCreation', {
    setSuggestedAddress: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["o" /* SET_SUGGESTED_ADDRESS */],
    setUserByAdmin: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["y" /* SET_USER_BY_ADMIN */],
    setSuggestedAddressType: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["p" /* SET_SUGGESTED_ADDRESS_TYPE */],
    setSuggestedAddressModalVisible: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["q" /* SET_SUGGESTED_ADDRESS_MODAL_VISIBLE */],
    setSuggestedAddressYesMethod: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["r" /* SET_SUGGESTED_ADDRESS_YES_METHOD */],
    showAccountCreationModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["z" /* SHOW_ACCOUNT_CREATION_MODAL */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), {
    initializeState: function initializeState() {
      this.userId = this.$route.params.userId;
      this.name = this.$route.params.name;
    },
    loadUserDetail: function loadUserDetail() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this6.isLoading = true;
                _context4.next = 3;
                return _this6.getUserDetail(_this6.userId).then(function (data) {
                  _this6.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, data, {
                    commentCategories: (data.commentCategories || []).map(function (c) {
                      return {
                        id: c.commentCategory.id,
                        name: c.commentCategory.name
                      };
                    })
                  }));
                  _this6.sortAccounts();
                  _this6.userCommentCategory = _this6.user.commentCategories;
                  _this6.userCommentInput = data.comments;
                  _this6.userHasBeenAllowedPOBox = data.hasBeenAllowedPOBox;
                  _this6.provideInvestorLogin = Boolean(data.clientId);
                  _this6.enableMfa = data.isMfaEnabled;
                  _this6.isLoading = false;
                }).catch(function (error) {
                  console.error('Error fetching user detail:', error);
                  _this6.isLoading = false;
                });

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    sortAccounts: function sortAccounts() {
      this.user.accounts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["orderBy"])(this.user.accounts, [function (account) {
        var name = account.accountName;
        return name ? account.accountName.toLowerCase() : '';
      }], ['asc']);
    },
    updateAddress: function updateAddress(originalAddress, updatedAddress) {
      /* eslint-disable no-param-reassign */
      originalAddress.streetAddress1 = updatedAddress.streetAddress1;
      originalAddress.streetAddress2 = updatedAddress.streetAddress2;
      originalAddress.zipCode = updatedAddress.zipCode;
      originalAddress.state = updatedAddress.state;
      originalAddress.city = updatedAddress.city;
    },
    validateAndSubmitUser: function validateAndSubmitUser() {
      this.isLoading = true;
      this.setUserByAdmin(this.user);
      var request = {
        id: this.user.id
      };
      if (this.$refs.basicInformation) {
        request = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(request, this.$refs.basicInformation.getData());
      }
      if (this.$refs.addresses) {
        request = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(request, this.$refs.addresses.getData());

        this.user.residentialAddress = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.user.residentialAddress, request.residentialAddress);
        this.$refs.addresses.setResidencialAddress(request.residentialAddress);
        this.user.mailingAddress = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.user.mailingAddress, request.mailingAddress);
        this.$refs.addresses.setMailingAddress(request.mailingAddress);
      }

      return this.showConfirmationModal(request);
    },
    save: function save(payload, commercialOverrideComment) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var userData, rawError, errorMessage;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this7.hideQuestionModal();
                _context5.prev = 1;
                userData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, payload, {
                  hasBeenAllowedPOBox: _this7.getHasBeenAllowedPOBoxValue(),
                  hasBeenAllowedCommercialAddress: !!commercialOverrideComment,
                  commercialAddressOverrideComment: commercialOverrideComment || undefined
                });
                _context5.next = 5;
                return _this7.updateUserProfile({
                  user: userData,
                  provideLogin: _this7.provideInvestorLogin,
                  enableMfa: _this7.enableMfa
                });

              case 5:
                _context5.next = 7;
                return _this7.loadUserDetail();

              case 7:
                _context5.next = 21;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](1);

                _this7.isLoading = false;
                _this7.user.socialSecurityNum = _this7.previousSSN;

                // A commercial residential address can be overridden by an admin via
                // a dedicated modal (instead of a global checkbox). Re-confirmed on
                // each save, so we don't auto-resend a stored flag.

                if (!(_context5.t0 && _context5.t0.errorMessage === 'RESIDENTIAL_COMMERCIAL_ADDRESS_NOT_ALLOWED')) {
                  _context5.next = 17;
                  break;
                }

                _this7.pendingCommercialOverridePayload = payload;
                _this7.isCommercialOverrideModalVisible = true;
                return _context5.abrupt('return');

              case 17:

                // The API returns address validation errors as `errorMessage` (an
                // error code we map to a friendly description); other errors use
                // `message`. Reading the wrong field showed admins a generic message
                // instead of the real reason.
                rawError = _context5.t0 && (_context5.t0.errorMessage || _context5.t0.message) || '';
                errorMessage = __WEBPACK_IMPORTED_MODULE_22__data_static_addressErrors__["a" /* AddressErrors */][rawError] || rawError || 'An error occurred while saving the user profile. Please try again.';

                _this7.setErrorsModalInfo([errorMessage]);
                _this7.showErrorsModal();

              case 21:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[1, 9]]);
      }))();
    },
    confirmCommercialOverride: function confirmCommercialOverride(comment) {
      this.isCommercialOverrideModalVisible = false;
      var payload = this.pendingCommercialOverridePayload;
      this.pendingCommercialOverridePayload = null;
      this.isLoading = true;
      this.save(payload, comment);
    },
    cancelCommercialOverride: function cancelCommercialOverride() {
      this.isCommercialOverrideModalVisible = false;
      this.pendingCommercialOverridePayload = null;
    },
    showUserModalsError: function showUserModalsError(listUserErrors) {
      this.setErrorsModalInfo(listUserErrors);
      this.showErrorsModal();
    },
    disableSubmitButton: function disableSubmitButton() {
      var userType = this.user.userType;
      if (userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].ADMIN.name || userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name) {
        return true;
      }
      // READ_ONLY users cannot submit updates for other users
      if (this.loggedUser && this.loggedUser.userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].READ_ONLY.name && this.user && this.user.id !== this.loggedUser.id) {
        return true;
      }
      var basicInformationValid = false;
      var addressesValid = false;

      if (this.$refs.addresses) {
        addressesValid = this.$refs.addresses.validate();
        if ((userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].INSTITUTIONAL_REPRESENTATIVE.name || userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].READ_ONLY.name) && (this.$refs.addresses.areEmpty() || !this.$refs.addresses.isMailingAddressDifferent && this.$refs.addresses.isResidentialAddressEmptyOrValid() && this.$refs.addresses.isMailingAddressEmptyOrValid())) {
          addressesValid = true;
        }
      }
      if (this.$refs.basicInformation) {
        basicInformationValid = this.$refs.basicInformation.validate();
        if (basicInformationValid && this.$refs.basicInformation.getData().email === '' && (userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].INSTITUTIONAL_REPRESENTATIVE.name || userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].READ_ONLY.name)) {
          basicInformationValid = false;
        }
      }
      return !basicInformationValid || !addressesValid || this.isLoading;
    },
    showConfirmationModal: function showConfirmationModal(userToUpdate) {
      var _this8 = this;

      this.isLoading = false;
      this.showQuestionModal({
        title: __WEBPACK_IMPORTED_MODULE_26__data_static_constants__["a" /* Constants */].userDetail.modalTitle,
        question: !this.getHasBeenAllowedPOBoxValue() ? __WEBPACK_IMPORTED_MODULE_26__data_static_constants__["a" /* Constants */].userDetail.modalQuestion : __WEBPACK_IMPORTED_MODULE_26__data_static_constants__["a" /* Constants */].userDetail.modalQuestionPOBox,
        method: function method() {
          return _this8.save(userToUpdate);
        },
        yesButtonText: __WEBPACK_IMPORTED_MODULE_26__data_static_constants__["a" /* Constants */].userDetail.modalYesButtonText,
        hideCancelButton: false
      });
    },
    openAccountCreationModal: function openAccountCreationModal() {
      var userId = this.userId;
      var name = this.name;
      this.showAccountCreationModal({ userId: userId, name: name });
    },
    mergePartialUser: function mergePartialUser() {
      this.isMergePartialUserModalVisible = true;
    },
    closeMergePartialUserModal: function closeMergePartialUserModal() {
      this.isMergePartialUserModalVisible = false;
    },
    handleUserMerge: function handleUserMerge(_ref2) {
      var _this9 = this;

      var targetUserId = _ref2.targetUserId;

      // Close the merge modal first to prevent z-index issues
      this.closeMergePartialUserModal();
      // Show confirmation modal
      this.showQuestionModal({
        title: 'Merge Partial User',
        question: 'Are you sure you want to merge this partial user? This action cannot be undone.',
        method: function method() {
          _this9.executeMerge(targetUserId);
        },
        yesButtonText: 'Confirm',
        hideCancelButton: false
      });
    },
    executeMerge: function executeMerge(targetUserId) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var errorMessage;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this10.hideQuestionModal();
                _this10.isLoading = true;
                _context6.prev = 2;
                _context6.next = 5;
                return _this10.$store.dispatch('user/mergePartialUser', {
                  partialUserId: _this10.user.id,
                  targetUserId: targetUserId
                });

              case 5:

                // Success - redirect to the search page
                _this10.$router.push({ name: 'Users' });
                _context6.next = 14;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6['catch'](2);

                console.error('Error merging users:', _context6.t0);
                errorMessage = _context6.t0 && _context6.t0.response && _context6.t0.response.data && _context6.t0.response.data.message || 'Failed to merge users. Please try again.';

                _this10.setErrorsModalInfo([errorMessage]);
                _this10.showErrorsModal();

              case 14:
                _context6.prev = 14;

                _this10.isLoading = false;
                return _context6.finish(14);

              case 17:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this10, [[2, 8, 14, 17]]);
      }))();
    },
    generateSummaryReport: function generateSummaryReport(account) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var responseWithoutAccrued, htmlWithoutAccrued, responseWithAccrued, htmlWithAccrued;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this11.fetchingSummaryReports = true;

                _context7.next = 3;
                return _this11.getAccountSummaryReport({
                  accountId: account.id,
                  withAccruedInterest: false
                });

              case 3:
                responseWithoutAccrued = _context7.sent;
                _context7.next = 6;
                return _this11.getDocumentFromS3({
                  presignedUrl: responseWithoutAccrued.url
                });

              case 6:
                htmlWithoutAccrued = _context7.sent;


                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__util__["I" /* downloadPDF */])(responseWithoutAccrued.filename, htmlWithoutAccrued.data);

                _context7.next = 10;
                return _this11.getAccountSummaryReport({
                  accountId: account.id,
                  withAccruedInterest: true
                });

              case 10:
                responseWithAccrued = _context7.sent;
                _context7.next = 13;
                return _this11.getDocumentFromS3({
                  presignedUrl: responseWithAccrued.url
                });

              case 13:
                htmlWithAccrued = _context7.sent;


                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__util__["I" /* downloadPDF */])(responseWithAccrued.filename, htmlWithAccrued.data);

                _this11.fetchingSummaryReports = false;

              case 16:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this11);
      }))();
    },
    goToViewDetail: function goToViewDetail(account) {
      var accountTypeProperties = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__util__["n" /* getAccounTypeProperties */])(account.accountType);
      var routeParams = {
        name: accountTypeProperties.component,
        params: {
          accountId: account.id,
          name: this.name,
          userId: this.userId
        }
      };

      this.$router.push(routeParams);
    },
    getStyleClassForUserTypeRadioButton: function getStyleClassForUserTypeRadioButton(type) {
      return this.user.userType === type.name ? 'radio-item' : 'radio-item radio-item-unselected';
    },
    isFinancialAdvisorAdminOrInstitutional: function isFinancialAdvisorAdminOrInstitutional() {
      return this.user.userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name || this.user.userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].ADMIN.name || this.user.userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].INSTITUTIONAL_REPRESENTATIVE.name || this.user.userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].READ_ONLY.name;
    },
    isFinancialAdvisorOrAdmin: function isFinancialAdvisorOrAdmin() {
      return this.user.userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name || this.user.userType === __WEBPACK_IMPORTED_MODULE_21__data_static_userTypes__["a" /* UserTypes */].ADMIN.name;
    }
  }),
  components: {
    datePicker: __WEBPACK_IMPORTED_MODULE_8_vue_bootstrap_datetimepicker___default.a,
    errors: __WEBPACK_IMPORTED_MODULE_11__components_modals_Errors___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_14__components_widgets_Spinner___default.a,
    information: __WEBPACK_IMPORTED_MODULE_13__components_modals_Information___default.a,
    accountCreation: __WEBPACK_IMPORTED_MODULE_17__components_modals_AccountCreation___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_23__components_Breadcrumb___default.a,
    question: __WEBPACK_IMPORTED_MODULE_15__components_modals_Question___default.a,
    multiselect: __WEBPACK_IMPORTED_MODULE_6_primevue_multiselect___default.a,
    'dismissable-alert': __WEBPACK_IMPORTED_MODULE_16__components_widgets_DismissableAlert___default.a,
    'address-suggestion': __WEBPACK_IMPORTED_MODULE_9__components_modals_AddressSuggestion___default.a,
    'addresses-form': __WEBPACK_IMPORTED_MODULE_19__components_Addresses___default.a,
    'basic-information': __WEBPACK_IMPORTED_MODULE_20__components_BasicInformation___default.a,
    'restricted-textarea': __WEBPACK_IMPORTED_MODULE_24__components_formControls_RestrictedTextArea___default.a,
    'merge-partial-user': __WEBPACK_IMPORTED_MODULE_18__components_modals_MergePartialUser___default.a,
    'commercial-address-override': __WEBPACK_IMPORTED_MODULE_12__components_modals_CommercialAddressOverride___default.a
  }
});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_static_userTypes__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserTypeSelection',
  props: ['user'],
  data: function data() {
    return {
      userTypes: __WEBPACK_IMPORTED_MODULE_2__data_static_userTypes__["a" /* UserTypes */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('authentication', ['states'])),
  methods: {
    getStyleClassForUserTypeRadioButton: function getStyleClassForUserTypeRadioButton(type) {
      return this.user.userType === type.name ? 'radio-item' : 'radio-item radio-item-unselected';
    },
    isFinanciaAdvisorOrAdmin: function isFinanciaAdvisorOrAdmin() {
      return this.user.userType === __WEBPACK_IMPORTED_MODULE_2__data_static_userTypes__["a" /* UserTypes */].FINANCIAL_ADVISOR.name || this.user.userType === __WEBPACK_IMPORTED_MODULE_2__data_static_userTypes__["a" /* UserTypes */].ADMIN.name;
    }
  }
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_modals_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_RecentRecords__ = __webpack_require__(2063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_RecentRecords___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_RecentRecords__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SearchByAccountResults__ = __webpack_require__(2068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SearchByAccountResults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_SearchByAccountResults__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SearchByNameOrEmailResults__ = __webpack_require__(2069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SearchByNameOrEmailResults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SearchByNameOrEmailResults__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SearchByNoteNumberOrCUSIPResults__ = __webpack_require__(2070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SearchByNoteNumberOrCUSIPResults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_SearchByNoteNumberOrCUSIPResults__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_static_searchTypes__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__ = __webpack_require__(8);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'investorList',
  beforeMount: function beforeMount() {
    this.setParams();
    this.searchInvestors();
  },

  components: {
    errors: __WEBPACK_IMPORTED_MODULE_6__components_modals_Errors___default.a,
    'recent-records': __WEBPACK_IMPORTED_MODULE_7__components_RecentRecords___default.a,
    'search-by-account-results': __WEBPACK_IMPORTED_MODULE_9__components_SearchByAccountResults___default.a,
    'search-by-name-or-email-results': __WEBPACK_IMPORTED_MODULE_10__components_SearchByNameOrEmailResults___default.a,
    'search-by-note-number-or-cusip-results': __WEBPACK_IMPORTED_MODULE_11__components_SearchByNoteNumberOrCUSIPResults___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_8__components_widgets_Spinner___default.a
  },
  data: function data() {
    return {
      results: {},
      hasSearched: false,
      search: '',
      investorError: '',
      searchTypes: __WEBPACK_IMPORTED_MODULE_12__data_static_searchTypes__["a" /* SearchTypes */],
      searchingBy: '',
      isSearchOpen: false,
      isSearchLoading: false,
      searchMessage: '',
      isSearchFocused: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('user', ['disableSubmitSearch', 'searchString', 'currentlySearchingBy']), {
    isNotesEmpty: function isNotesEmpty() {
      return this.results.notes ? !this.results.notes.length : true;
    },
    isAccountsEmpty: function isAccountsEmpty() {
      return this.results.accounts ? !this.results.accounts.length : true;
    },
    isUsersEmpty: function isUsersEmpty() {
      return this.results.users ? !this.results.users.length : true;
    },
    isAccountEmpty: function isAccountEmpty() {
      return !this.results.account;
    },
    areResultsEmpty: function areResultsEmpty() {
      return this.isNotesEmpty && this.isAccountEmpty && this.isAccountsEmpty && this.isUsersEmpty && this.hasSearched;
    },
    currentSearchByDisplay: function currentSearchByDisplay() {
      var _this = this;

      var currentlySearchingBy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["find"])(__WEBPACK_IMPORTED_MODULE_12__data_static_searchTypes__["a" /* SearchTypes */], function (searchType) {
        return searchType.name === _this.searchingBy;
      });
      return currentlySearchingBy.displayName;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('user', ['getInvestors', 'storeUserInSessionStorage']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('account', ['getAccounts']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('user', {
    setSearchString: __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__["B" /* SET_SEARCH_STRING */],
    setCurrentlySearchingBy: __WEBPACK_IMPORTED_MODULE_13__store_mutation_types__["C" /* SET_CURRENTLY_SEARCHING_BY */]
  }), {
    setParams: function setParams() {
      this.search = this.searchString;
      this.searchingBy = this.currentlySearchingBy;
    },
    goToCreateUser: function goToCreateUser() {
      this.$router.push({ name: 'UserCreationByAdmin' });
    },
    searchInvestors: function searchInvestors(e) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (e) {
                  e.preventDefault();
                }
                if (_this2.$refs.searchInput) {
                  _this2.$refs.searchInput.blur();
                }

                if (!_this2.search) {
                  _context.next = 5;
                  break;
                }

                _this2.startSearch();
                return _context.abrupt('return', _this2.getAccounts({ searchString: _this2.search, searchBy: _this2.searchingBy }).then(function (data) {
                  _this2.searchMessage = _this2.search;
                  _this2.hasSearched = true;
                  if (data.statusCode === 401) {
                    _this2.results = {};
                  } else {
                    _this2.results = data;
                  }
                  _this2.isSearchLoading = false;
                }).catch(function () {
                  _this2.setErrorsModalInfo(['We could not retrieve investors list']);
                  _this2.showErrorsModal();
                  _this2.isSearchLoading = false;
                }));

              case 5:
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve());

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    startSearch: function startSearch() {
      this.results = {};
      this.isSearchLoading = true;
      this.setSearchString(this.search);
      this.setCurrentlySearchingBy(this.searchingBy);
    },
    updatedSearchingBy: function updatedSearchingBy(searchBy) {
      if (this.searchingBy !== searchBy.name) {
        this.searchingBy = searchBy.name;
        this.hasSearched = false;
      }
    },
    toggleIsSearchOpen: function toggleIsSearchOpen() {
      this.isSearchOpen = !this.isSearchOpen;
    },
    onSearchFocus: function onSearchFocus() {
      this.isSearchFocused = true;
    },
    onSearchBlur: function onSearchBlur() {
      this.isSearchFocused = false;
    },
    clearSearch: function clearSearch(e) {
      if (e.target.id === 'clear-icon') {
        this.search = '';
        this.hasSearched = false;
        this.accounts = [];
        this.investors = [];
        this.setSearchString('');
      }
    }
  })
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_widgets_Spinner__);


//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VerifyEmail',
  components: {
    spinner: __WEBPACK_IMPORTED_MODULE_2__components_widgets_Spinner___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var email, code, success, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              email = _this.email, code = _this.code;
              success = true;
              _context.prev = 2;

              if (!(email && code)) {
                _context.next = 8;
                break;
              }

              _context.next = 6;
              return _this.$cognitoAuth.verifyEmail(email, code);

            case 6:
              res = _context.sent;

              if (res.name === 'ExpiredCodeException') {
                success = false;
              }

            case 8:
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](2);

              success = false;

            case 13:
              _context.prev = 13;

              _this.$router.push({ name: 'Login', query: { email: email, success: success } });
              return _context.finish(13);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 10, 13, 16]]);
    }))();
  },
  data: function data() {
    return {
      password: '',
      passwordConfirmation: ''
    };
  },

  computed: {
    code: function code() {
      return this.$route.query.code;
    },
    email: function email() {
      return this.$route.query.email;
    }
  }
});

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RestrictedSingleInput',
  props: {
    input: {
      type: String,
      required: true,
      default: ''
    },
    instructionsLabel: {
      type: String,
      required: false
    },
    fieldLabel: {
      type: String,
      required: false
    },
    placeholderText: {
      type: String,
      required: false,
      default: ''
    },
    dual: {
      type: Boolean,
      required: false,
      default: false
    },
    limit: {
      type: Number,
      required: false,
      default: 50
    },
    warningLimit: {
      type: Number,
      required: false,
      default: 20
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      errorMessage: 'You\'ve reached the ' + this.limit + ' characters limit',
      showLimit: false
    };
  },

  computed: {
    inputValue: {
      get: function get() {
        return this.input;
      },
      set: function set(value) {
        this.$emit('inputUpdated', value);
      }
    },
    charactersRemaining: function charactersRemaining() {
      return this.limit - this.inputValue.length;
    }
  },
  methods: {
    enableShowLimit: function enableShowLimit() {
      this.showLimit = true;
    },
    disableShowLimit: function disableShowLimit() {
      this.showLimit = false;
    },
    getColor: function getColor() {
      if (!this.showLimit) {
        return 'transparent-text';
      }
      var numberOfCharacters = this.inputValue.length;

      if (numberOfCharacters > 0 && numberOfCharacters <= this.warningLimit) {
        return 'green-text';
      } else if (numberOfCharacters > this.warningLimit && numberOfCharacters < this.limit) {
        return 'yellow-text';
      }
      return 'red-text';
    }
  }
});

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RestrictedTextArea',
  props: {
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    input: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    limit: {
      type: Number,
      required: false,
      default: 255
    },
    warningLimit: {
      type: Number,
      required: false,
      default: 100
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    showNotice: {
      type: Boolean,
      required: false,
      default: true
    },
    textColorClass: {
      type: String,
      default: 'black-text'
    }
  },
  data: function data() {
    return {
      showLimit: false
    };
  },

  computed: {
    inputValue: {
      get: function get() {
        return this.input || '';
      },
      set: function set(value) {
        this.$emit('inputUpdated', value);
      }
    },
    charactersRemaining: function charactersRemaining() {
      return this.limit - this.inputValue.length;
    }
  },
  methods: {
    enableShowLimit: function enableShowLimit() {
      this.showLimit = true;
    },
    disableShowLimit: function disableShowLimit() {
      this.showLimit = false;
    },
    getColor: function getColor() {
      if (!this.showLimit) {
        return 'transparent-text';
      }
      var numberOfCharacters = this.inputValue.length;

      if (numberOfCharacters === 0) {
        return '';
      }
      if (numberOfCharacters > 0 && numberOfCharacters <= this.warningLimit) {
        return 'green-text';
      } else if (numberOfCharacters > this.warningLimit && numberOfCharacters < this.limit) {
        return 'yellow-text';
      }
      return 'red-text';
    }
  }
});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RestrictedTwoInputs',
  props: {
    primaryInput: {
      type: String,
      required: true,
      default: ''
    },
    secondaryInput: {
      type: String,
      required: false,
      default: ''
    },
    instructionsLabel: {
      type: String,
      required: false,
      default: ''
    },
    fieldLabel: {
      type: String,
      required: false,
      default: 'label for primary input'
    },
    primaryPlaceholder: {
      type: String,
      required: false,
      default: ''
    },
    secondaryPlaceholder: {
      type: String,
      required: false,
      default: ''
    },
    dual: {
      type: Boolean,
      required: false,
      default: false
    },
    limit: {
      type: Number,
      required: false,
      default: 50
    },
    warningLimit: {
      type: Number,
      required: false,
      default: 29
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isFirstInputRequired: {
      type: Boolean,
      required: false,
      default: false
    },
    isSecondInputRequired: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      primary: this.primaryInput,
      secondary: this.secondaryInput,
      errorMessage: 'You\'ve reached the ' + this.limit + ' character limit',
      showLimitOnPrimary: false,
      showLimitOnSecondary: false
    };
  },

  computed: {
    primaryInputMessage: {
      get: function get() {
        return this.primaryInput;
      },
      set: function set(value) {
        this.$emit('inputUpdated', { primary: value, secondary: this.secondaryInputMessage });
      }
    },
    secondaryInputMessage: {
      get: function get() {
        return this.secondaryInput;
      },
      set: function set(value) {
        this.$emit('inputUpdated', { primary: this.primaryInputMessage, secondary: value });
      }
    },
    primaryInputLimit: function primaryInputLimit() {
      return this.limit - this.secondaryInputMessage.length;
    },
    secondaryInputLimit: function secondaryInputLimit() {
      return this.limit - this.primaryInputMessage.length;
    },
    charactersUsed: function charactersUsed() {
      return this.primaryInputMessage.length + this.secondaryInputMessage.length;
    }
  },
  methods: {
    enableShowLimit: function enableShowLimit(input) {
      input === 'primary' ? this.showLimitOnPrimary = true : this.showLimitOnSecondary = true; // eslint-disable-line no-unused-expressions
    },
    disableShowLimit: function disableShowLimit(input) {
      input === 'primary' ? this.showLimitOnPrimary = false : this.showLimitOnSecondary = false; // eslint-disable-line no-unused-expressions
    },
    getColor: function getColor(input) {
      if (input === 'primary' && !this.showLimitOnPrimary || input === 'secondary' && !this.showLimitOnSecondary) {
        return 'transparent-text';
      }
      if (this.charactersUsed <= this.warningLimit) {
        return 'green-text';
      } else if (this.charactersUsed >= this.warningLimit && this.charactersUsed < this.limit) {
        return 'yellow-text';
      }
      return 'red-text';
    }
  }
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'accountCreation',
  props: ['closeAction'],
  data: function data() {
    return {
      accountType: '',
      isLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('accountCreation', ['userId', 'name']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('user', ['storeAccountTypeInSessionStorage']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('accountCreation', {
    hideAccountCreationModal: __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["A" /* HIDE_ACCOUNT_CREATION_MODAL */]
  }), {
    submitAccountType: function submitAccountType() {
      this.isLoading = true;
      this.hideAccountCreationModal();
      var routeName = '';
      if (this.accountType === 'joint' || this.accountType === 'utma-ugma') {
        routeName = 'AccountCreationAdmin';
      } else if (this.accountType === 'institution' || this.accountType === 'trust') {
        routeName = 'AccountCreationOrganization';
      }
      this.storeAccountTypeInSessionStorage(this.accountType);
      this.isLoading = false;
      this.$router.push({
        name: routeName,
        params: {
          name: this.name,
          userId: this.userId,
          accountType: this.accountType
        }
      });
    },
    closeModal: function closeModal() {
      this.hideAccountCreationModal();
      if (typeof this.closeAction === 'function') {
        this.closeAction();
      }
    }
  })
});

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_money__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_v_money__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddAdditionalReinvestment',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    availableNoteIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fundingSources: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      formData: {
        amount: '',
        noteId: ''
      },
      selectedFundingSourceIndex: '',
      errors: {
        amount: '',
        noteId: '',
        fundingSourceType: ''
      },
      submitting: false,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        suffix: '',
        precision: 2,
        masked: false
      }
    };
  },

  computed: {
    selectedFundingSource: function selectedFundingSource() {
      if (this.selectedFundingSourceIndex === '') return null;
      return this.fundingSources[this.selectedFundingSourceIndex];
    },
    isFormValid: function isFormValid() {
      return this.formData.amount && this.formData.noteId && this.selectedFundingSource && this.parseAmount(this.formData.amount) > 0 && this.availableNoteIds.length > 0;
    }
  },
  watch: {
    isVisible: function isVisible(newVal) {
      if (newVal) {
        this.resetForm();
      }
    }
  },
  methods: {
    closeModal: function closeModal() {
      this.$emit('close');
    },
    parseAmount: function parseAmount(amountString) {
      var cleanAmount = amountString.replace(/[^0-9.]/g, '');
      return parseFloat(cleanAmount) || 0;
    },
    validateForm: function validateForm() {
      var isValid = true;
      this.errors = {
        amount: '',
        noteId: '',
        fundingSourceType: ''
      };

      var amount = this.parseAmount(this.formData.amount);
      if (!this.formData.amount || amount <= 0) {
        this.errors.amount = 'Please enter a valid amount greater than $0';
        isValid = false;
      }

      if (!this.formData.noteId) {
        this.errors.noteId = 'Please select a note';
        isValid = false;
      }

      if (!this.selectedFundingSource) {
        this.errors.fundingSourceType = 'Please select a funding source type';
        isValid = false;
      }

      return isValid;
    },
    handleSubmit: function handleSubmit() {
      var _this = this;

      if (!this.validateForm()) {
        return;
      }

      this.submitting = true;

      var payload = {
        amount: this.parseAmount(this.formData.amount),
        noteId: this.formData.noteId,
        fundingSourceType: this.selectedFundingSource.type
      };
      if (this.selectedFundingSource.fundingSourceId) {
        payload.fundingSourceId = this.selectedFundingSource.fundingSourceId;
        payload.fundingSourceName = this.selectedFundingSource.name;
      }

      this.$emit('save', payload);

      // Reset submitting state after a short delay
      setTimeout(function () {
        _this.submitting = false;
      }, 500);
    },
    resetForm: function resetForm() {
      this.formData = {
        amount: '',
        noteId: ''
      };
      this.selectedFundingSourceIndex = '';
      this.errors = {
        amount: '',
        noteId: '',
        fundingSourceType: ''
      };
      this.submitting = false;
    }
  },
  directives: { money: __WEBPACK_IMPORTED_MODULE_0_v_money__["VMoney"] }
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_money__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_v_money__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddMoney',
  directives: {
    money: __WEBPACK_IMPORTED_MODULE_1_v_money__["VMoney"]
  },
  props: {
    fundingSources: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    availableNotes: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    editingInvestment: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      selectedFundingSource: null,
      amount: '$0.00',
      selectedNote: null,
      amountError: '',
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        precision: 2
      }
    };
  },

  computed: {
    isEditing: function isEditing() {
      return this.editingInvestment !== null;
    },
    isFormValid: function isFormValid() {
      return this.selectedNote && this.selectedFundingSource && !this.selectedFundingSource.removed && this.amount && this.isAmountValid();
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.editingInvestment) {
      var note = this.availableNotes.find(function (n) {
        return n.noteId === _this.editingInvestment.noteId;
      });
      if (note) {
        this.selectedNote = note;
      }
      this.amount = '$' + parseFloat(this.editingInvestment.amount).toFixed(2);
      var fundingSource = this.fundingSources.find(function (fs) {
        return fs.type === _this.editingInvestment.fundingSourceType;
      });
      if (fundingSource) {
        this.selectedFundingSource = fundingSource;
      }
    }
  },

  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_0__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_0__util__["c" /* formatAmount */],
    isAmountValid: function isAmountValid() {
      var amountValue = parseFloat(this.amount.replace(/[^0-9.]/g, ''));
      var minimumAmount = 20;
      if (!amountValue || isNaN(amountValue)) {
        this.amountError = 'Please enter a valid amount';
        return false;
      }
      if (amountValue < minimumAmount) {
        this.amountError = 'Amount must be at least $' + minimumAmount;
        return false;
      }
      this.amountError = '';
      return true;
    },
    closeModal: function closeModal() {
      this.$emit('close');
    },
    submitAddMoney: function submitAddMoney() {
      if (!this.isFormValid) return;

      var amountValue = parseFloat(this.amount.replace(/[^0-9.]/g, ''));
      var payload = {
        noteId: this.selectedNote.noteId,
        fundingSourceId: this.selectedFundingSource.id,
        fundingSourceType: this.selectedFundingSource.type,
        fundingSourceName: this.selectedFundingSource.name,
        amount: amountValue
      };

      this.$emit('submit', payload);
    }
  },
  watch: {
    amount: function amount() {
      if (this.amount && this.amount !== '$0.00') {
        this.isAmountValid();
      } else {
        this.amountError = '';
      }
    }
  }
});

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_static_events__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_static_searchTypes__ = __webpack_require__(108);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var mix = {
  methods: {
    getUserTypeLabel: __WEBPACK_IMPORTED_MODULE_6__util__["w" /* getUserTypeLabel */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddRepresentatives',
  data: function data() {
    return {
      searchText: '',
      investors: [],
      lastRepresentativeAdded: '',
      representativeWasAdded: false,
      hasSearched: false,
      searchTypes: __WEBPACK_IMPORTED_MODULE_7__data_static_searchTypes__["a" /* SearchTypes */]
    };
  },

  mixins: [mix],
  props: {
    closeAction: {
      type: Function,
      required: true
    },
    representatives: {
      type: Array,
      required: true,
      default: []
    },
    accountId: {
      type: Number,
      required: true
    }
  },
  computed: {
    isSearchDisabled: function isSearchDisabled() {
      return !this.searchText.length > 0;
    },
    authorizedRepresentatives: function authorizedRepresentatives() {
      return this.representatives;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    closeModal: function closeModal() {
      this.closeAction();
    },
    searchInvestors: function searchInvestors() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (_this.searchText.length) {
                  _context.next = 4;
                  break;
                }

                _this.investors = [];
                return _context.abrupt('return');

              case 4:
                _context.next = 6;
                return _this.getAccounts({
                  searchString: _this.searchText,
                  searchBy: _this.searchTypes.NAME_EMAIL.name
                });

              case 6:
                response = _context.sent;

                _this.hasSearched = true;
                if (response.statusCode === 401) {
                  _this.investors = [];
                } else {
                  _this.investors = response.users;
                }
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](0);

                _this.setErrorsModalInfo(['We could not retrieve investors list']);
                _this.showErrorsModal();

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 11]]);
      }))();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('account', ['createAccountUser', 'getAccounts']), {
    addRepresentativeToAccount: function addRepresentativeToAccount(investor) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.createAccountUser({ accountId: _this2.accountId, userId: investor.id });

              case 2:
                _this2.$emit(__WEBPACK_IMPORTED_MODULE_4__data_static_events__["a" /* Events */].REPRESENTATIVE_ADDED);
                _this2.lastRepresentativeAdded = investor.firstName + ' ' + investor.lastName;
                _this2.representativeWasAdded = true;

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    isAccountRepresentative: function isAccountRepresentative(id) {
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.some(this.authorizedRepresentatives, ['id', id]);
    }
  })
});

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(8);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'addressSuggestion',
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['user']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('accountCreation', ['suggestedAddress', 'suggestedAddressType', 'methodForYesButton', 'userByAdmin'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('accountCreation', {
    setSuggestedAddressModalVisible: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["q" /* SET_SUGGESTED_ADDRESS_MODAL_VISIBLE */],
    setChangeAddress: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["s" /* SET_CHANGE_ADDRESS */]
  }), {
    acceptSuggestion: function acceptSuggestion() {
      this.setChangeAddress(true);
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.userByAdmin).length > 0) {
        this.userByAdmin[this.suggestedAddressType + 'Address'] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.suggestedAddress);
      } else {
        this.user[this.suggestedAddressType + 'Address'] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.suggestedAddress);
      }
      this.methodForYesButton();
      this.closeModal();
    },
    closeModal: function closeModal() {
      this.setChangeAddress(false);
      this.setSuggestedAddressModalVisible(false);
    }
  })
});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BankAccountChangedWarning',
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    isAdminView: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleOk: function handleOk() {
      this.$emit('close');
    },
    goToUpcomingTransactions: function goToUpcomingTransactions() {
      if (this.isAdminView) {
        // For admin view, emit event to scroll to segment on current page
        this.$emit('goToUpcomingTransactions');
      } else {
        // For non-admin users, navigate to the Upcoming Transactions page
        this.$router.push({ name: 'UpcomingTransactionsForInvestor' });
      }
      this.$emit('close');
    }
  }
});

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_money__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_static_upcomingTransactionActions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_widgets_Spinner__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/** How often the batch status is polled while a phase runs in the background. */
var POLL_INTERVAL_MS = 2000;
/** Stop polling after this long so a stalled batch cannot spin forever. */
var POLL_TIMEOUT_MS = 10 * 60 * 1000;
/** Settle time after the admin stops typing before re-pricing the batch. */
var FEE_DEBOUNCE_MS = 500;

var emptyPreview = function emptyPreview() {
  return {
    eligibleCount: 0,
    ineligibleCount: 0,
    eligibleNotes: [],
    ineligibleNotes: [],
    redemptionCategories: [],
    serviceFee: 0,
    feeBearer: null,
    feeError: null,
    totals: { principal: 0, interest: 0, fee: 0, netPayout: 0 },
    openBatch: null,
    fundingSources: []
  };
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bulk-redemption',
  components: {
    question: __WEBPACK_IMPORTED_MODULE_10__components_modals_Question___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_11__components_widgets_Spinner___default.a
  },
  props: ['accountId'],
  directives: { money: __WEBPACK_IMPORTED_MODULE_6_v_money__["VMoney"] },
  data: function data() {
    return {
      loading: true,
      loadingText: 'Loading…',
      refreshing: false,
      preview: emptyPreview(),
      fundingSourceId: '',
      serviceFeeInput: '0.00',
      categoryId: null,
      categoryHelperText: '',
      comment: '',
      approvalComment: '',
      // The requester's comment as it arrived, so the approver's box can be
      // pre-filled with it and still be told apart from an untouched one.
      requestComment: '',
      showNotes: false,
      showExcluded: false,
      result: null,
      pollTimer: null,
      feeTimer: null,
      money: { decimal: '.', thousands: ',', prefix: '$', precision: 2 }
    };
  },
  beforeMount: function beforeMount() {
    this.loadPreview();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopPolling();
    this.stopFeeTimer();
    // The question modal lives in the store, so an open confirmation would
    // outlive this modal and strand the user behind it.
    this.hideQuestionModal();
  },

  watch: {
    /**
     * Re-prices the batch when the fee changes.
     *
     * The fee no longer decides which notes qualify, but it still decides
     * which note bears it and whether any note can, so the server re-prices
     * rather than the modal guessing.
     *
     * Watched rather than bound to @change because the v-money directive
     * dispatches a synthetic change event every time it binds. Combined with a
     * request that re-renders this input, that produced an endless
     * refresh loop. Guarding on the parsed value means a re-bind that does not
     * actually change the number is ignored.
     */
    serviceFeeInput: function serviceFeeInput(next, previous) {
      var _this = this;

      if (this.unformat(next) === this.unformat(previous)) return;

      this.stopFeeTimer();
      this.feeTimer = setTimeout(function () {
        if (_this.unformat(_this.serviceFeeInput) === _this.preview.serviceFee) {
          return;
        }
        _this.loadPreview({ silent: true });
      }, FEE_DEBOUNCE_MS);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])('question', { displayQuestion: 'display' }), {
    donateFundingSource: function donateFundingSource() {
      return __WEBPACK_IMPORTED_MODULE_9__data_static_upcomingTransactionActions__["a" /* default */].donate;
    },
    openBatch: function openBatch() {
      return this.preview.openBatch || {};
    },

    /** A batch already awaiting approval turns this modal into the approve step. */
    isApproval: function isApproval() {
      return Boolean(this.preview.openBatch && this.preview.openBatch.status === 'PENDING_APPROVAL');
    },
    fundingSources: function fundingSources() {
      return (this.preview.fundingSources || []).filter(function (fs) {
        return ['bank', 'check', 'wire/ach'].indexOf(fs.type) !== -1 && fs.status === 'verified' && !fs.removed;
      });
    },
    needsCategoryHelperText: function needsCategoryHelperText() {
      var _this2 = this;

      var category = (this.preview.redemptionCategories || []).find(function (rc) {
        return rc.id === _this2.categoryId;
      });
      return Boolean(category && category.needsHelperText);
    },

    /** The notes the open request named, from its own snapshot. */
    requestNotes: function requestNotes() {
      return this.openBatch.notes || [];
    },
    requestTotals: function requestTotals() {
      return this.openBatch.totals || { principal: 0, interest: 0, fee: 0 };
    },
    requestNetPayout: function requestNetPayout() {
      var totals = this.requestTotals;
      return totals.principal + totals.interest - totals.fee;
    },

    /** The note carrying the batch fee, for the caption beside the amount. */
    requestFeeBearer: function requestFeeBearer() {
      return this.requestNotes.find(function (note) {
        return note.feeAmount > 0;
      }) || null;
    },

    /**
     * The request's payment destination, named rather than shown as an id.
     *
     * Donations are stored in the same column as a funding source id, so the
     * donate sentinel is checked before looking the id up.
     */
    requestFundingSourceLabel: function requestFundingSourceLabel() {
      var id = this.openBatch.fundingSourceId;
      if (!id) return 'Not recorded';
      if (id === this.donateFundingSource.name) {
        return this.donateFundingSource.text;
      }
      var match = (this.preview.fundingSources || []).find(function (fs) {
        return String(fs.id) === String(id);
      });
      return match ? match.name : 'Funding source ' + id;
    },
    requestCategoryLabel: function requestCategoryLabel() {
      var _this3 = this;

      var category = (this.preview.redemptionCategories || []).find(function (rc) {
        return rc.id === _this3.openBatch.redemptionCategoryId;
      });
      if (!category) return 'Not recorded';
      return this.openBatch.redemptionCategoryHelperText ? category.label + ' \u2014 ' + this.openBatch.redemptionCategoryHelperText : category.label;
    },

    /**
     * Whether the approver has actually added something.
     *
     * Matches the server rule and the single-note screen: the box starts with
     * the requester's comment, so leaving it untouched is not an approval.
     */
    hasAppendedComment: function hasAppendedComment() {
      return Boolean(this.approvalComment && this.approvalComment !== this.requestComment);
    },
    canSubmit: function canSubmit() {
      if (!this.preview.eligibleCount) return false;
      // A fee no note can carry is rejected server side; block it here so the
      // admin fixes the amount instead of getting a 400.
      if (this.preview.feeError) return false;
      if (!this.fundingSourceId) return false;
      if (!this.categoryId) return false;
      if (this.needsCategoryHelperText && !this.categoryHelperText) return false;
      if (!this.comment) return false;
      return true;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
    formatAmount: __WEBPACK_IMPORTED_MODULE_8__util__["c" /* formatAmount */]
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])('note', ['previewBulkRedemption', 'createBulkRedemption', 'getBulkRedemption', 'approveBulkRedemption', 'cancelBulkRedemption']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapMutations */])('question', {
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */],
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */]
  }), {
    unformat: function unformat(value) {
      var raw = String(value).replace('$', '').replace(/,/g, '');
      var parsed = parseFloat(raw);
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default()(parsed) ? 0 : parsed;
    },

    /**
     * `silent` keeps the form mounted while re-pricing. Swapping it for the
     * spinner would destroy and rebuild the fee input, and the v-money
     * directive fires a change event on every bind.
     */
    loadPreview: function loadPreview() {
      var _this4 = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$silent = _ref.silent,
          silent = _ref$silent === undefined ? false : _ref$silent;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var preview;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (silent) {
                  _this4.refreshing = true;
                } else {
                  _this4.loading = true;
                  _this4.loadingText = 'Loading…';
                }

                _context.prev = 1;
                _context.next = 4;
                return _this4.previewBulkRedemption({
                  accountId: _this4.accountId,
                  serviceFee: _this4.unformat(_this4.serviceFeeInput)
                });

              case 4:
                preview = _context.sent;

                _this4.preview = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(emptyPreview(), preview);
                if (!_this4.categoryId && _this4.preview.redemptionCategories.length) {
                  _this4.categoryId = _this4.preview.redemptionCategories[0].id;
                }
                _this4.seedApprovalComment();
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](1);

                _this4.fail(_this4.errorText(_context.t0, 'We could not load the bulk redemption preview.'));

              case 13:
                _context.prev = 13;

                _this4.loading = false;
                _this4.refreshing = false;
                return _context.finish(13);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[1, 10, 13, 17]]);
      }))();
    },
    stopFeeTimer: function stopFeeTimer() {
      if (this.feeTimer) {
        clearTimeout(this.feeTimer);
        this.feeTimer = null;
      }
    },

    /**
     * Puts the requester's comment in the approver's box, once.
     *
     * Only on the first load that finds a request awaiting approval: a later
     * reload must not overwrite what the approver has typed.
     */
    seedApprovalComment: function seedApprovalComment() {
      var batch = this.preview.openBatch;
      if (!batch || !batch.requestComment) return;
      if (this.requestComment) return;

      this.requestComment = batch.requestComment;
      this.approvalComment = batch.requestComment;
    },
    confirmSubmit: function confirmSubmit() {
      var total = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util__["c" /* formatAmount */])(this.preview.totals.netPayout);
      this.askToConfirm({
        title: 'Request this bulk redemption?',
        question: 'This redeems ' + this.preview.eligibleCount + ' notes and pays ' + (total + ' to the investor. Another admin must approve it before ') + 'any money moves.',
        yesButtonText: 'Request',
        method: this.submit
      });
    },
    submit: function submit() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref2, batchId;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this5.loading = true;
                _this5.loadingText = 'Requesting redemptions…';
                _context2.prev = 2;
                _context2.next = 5;
                return _this5.createBulkRedemption({
                  accountId: _this5.accountId,
                  payload: {
                    fundingSourceId: String(_this5.fundingSourceId),
                    serviceFee: _this5.unformat(_this5.serviceFeeInput),
                    comment: _this5.comment,
                    categoryId: _this5.categoryId,
                    categoryHelperText: _this5.categoryHelperText,
                    noteIds: _this5.preview.eligibleNotes.map(function (note) {
                      return note.noteId;
                    }),
                    expectedTotalPrincipal: _this5.preview.totals.principal
                  }
                });

              case 5:
                _ref2 = _context2.sent;
                batchId = _ref2.batchId;
                _context2.next = 9;
                return _this5.pollUntilSettled(batchId, 'CREATING', 'Redemption requested');

              case 9:
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](2);

                _this5.fail(_this5.errorText(_context2.t0, 'We could not submit the bulk redemption.'));

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[2, 11]]);
      }))();
    },
    confirmApproval: function confirmApproval() {
      this.askToConfirm({
        title: 'Approve this bulk redemption?',
        question: 'This approves the redemption of ' + this.openBatch.noteCount + ' ' + 'notes and releases the payment. It cannot be undone here.',
        yesButtonText: 'Approve',
        method: this.approve
      });
    },
    confirmCancelBatch: function confirmCancelBatch() {
      this.askToConfirm({
        title: 'Withdraw this bulk redemption?',
        question: 'This withdraws the request for all ' + this.openBatch.noteCount + ' ' + 'notes. Nothing is redeemed and the account is left as it was.',
        yesButtonText: 'Withdraw',
        method: this.cancelBatch
      });
    },

    /**
     * Asks the shared question modal, then runs the action on confirm.
     *
     * The modal is the app's own confirmation dialog; window.confirm was a
     * placeholder and is blocked outright in some embedded contexts.
     */
    askToConfirm: function askToConfirm(_ref3) {
      var _this6 = this;

      var title = _ref3.title,
          question = _ref3.question,
          yesButtonText = _ref3.yesButtonText,
          _method = _ref3.method;

      this.showQuestionModal({
        title: title,
        question: question,
        yesButtonText: yesButtonText,
        hideCancelButton: false,
        method: function method() {
          _this6.hideQuestionModal();
          _method();
        }
      });
    },
    approve: function approve() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this7.loading = true;
                _this7.loadingText = 'Redeeming notes…';
                _context3.prev = 2;
                _context3.next = 5;
                return _this7.approveBulkRedemption({
                  accountId: _this7.accountId,
                  batchId: _this7.openBatch.id,
                  payload: { comment: _this7.approvalComment }
                });

              case 5:
                _context3.next = 7;
                return _this7.pollUntilSettled(_this7.openBatch.id, 'APPROVING', 'Redemptions approved');

              case 7:
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](2);

                _this7.fail(_this7.errorText(_context3.t0, 'We could not approve the bulk redemption.'));

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7, [[2, 9]]);
      }))();
    },
    cancelBatch: function cancelBatch() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _ref4, cancelledNotes;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this8.loading = true;
                _this8.loadingText = 'Withdrawing requests…';
                _context4.prev = 2;
                _context4.next = 5;
                return _this8.cancelBulkRedemption({
                  accountId: _this8.accountId,
                  batchId: _this8.openBatch.id,
                  payload: { comment: _this8.approvalComment }
                });

              case 5:
                _ref4 = _context4.sent;
                cancelledNotes = _ref4.cancelledNotes;

                _this8.loading = false;
                _this8.result = {
                  title: 'Request cancelled',
                  message: cancelledNotes + ' note redemption request(s) were cancelled.',
                  failed: false,
                  failures: []
                };
                _this8.$emit('completed');
                _context4.next = 15;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4['catch'](2);

                _this8.fail(_this8.errorText(_context4.t0, 'We could not cancel the bulk redemption.'));

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this8, [[2, 12]]);
      }))();
    },

    /**
     * Both phases return 202 and finish in the background, so the modal polls
     * the batch until it leaves the in-progress status.
     */
    pollUntilSettled: function pollUntilSettled(batchId, inProgressStatus, successTitle) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var startedAt, check;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                startedAt = Date.now();

                check = function () {
                  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
                    var batch, done, failedSuffix;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            batch = void 0;
                            _context5.prev = 1;
                            _context5.next = 4;
                            return _this9.getBulkRedemption({
                              accountId: _this9.accountId,
                              batchId: batchId
                            });

                          case 4:
                            batch = _context5.sent;
                            _context5.next = 11;
                            break;

                          case 7:
                            _context5.prev = 7;
                            _context5.t0 = _context5['catch'](1);

                            _this9.fail('We lost track of this batch. Reopen to see its status.');
                            return _context5.abrupt('return');

                          case 11:
                            if (!(batch.status === inProgressStatus)) {
                              _context5.next = 17;
                              break;
                            }

                            if (!(Date.now() - startedAt > POLL_TIMEOUT_MS)) {
                              _context5.next = 15;
                              break;
                            }

                            _this9.fail('This is taking longer than expected. Reopen the modal to check progress.');
                            return _context5.abrupt('return');

                          case 15:
                            _this9.pollTimer = setTimeout(check, POLL_INTERVAL_MS);
                            return _context5.abrupt('return');

                          case 17:

                            _this9.stopPolling();
                            _this9.loading = false;

                            // Which count means "processed" depends on the phase: requesting
                            // leaves notes awaiting approval, approving redeems them.
                            done = inProgressStatus === 'CREATING' ? batch.progress.requested : batch.progress.done;
                            failedSuffix = batch.progress.failed ? ' ' + batch.progress.failed + ' failed.' : '';

                            _this9.result = {
                              title: successTitle,
                              message: done + ' of ' + batch.noteCount + ' notes processed.' + failedSuffix,
                              failed: batch.progress.failed > 0,
                              failures: batch.failures || []
                            };
                            _this9.$emit('completed');

                          case 23:
                          case 'end':
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this9, [[1, 7]]);
                  }));

                  return function check() {
                    return _ref5.apply(this, arguments);
                  };
                }();

                _context6.next = 4;
                return check();

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    stopPolling: function stopPolling() {
      if (this.pollTimer) {
        clearTimeout(this.pollTimer);
        this.pollTimer = null;
      }
    },
    errorText: function errorText(error, fallback) {
      var message = error && error.response && error.response.data && error.response.data.message;
      return message || fallback;
    },
    fail: function fail(message) {
      this.stopPolling();
      this.stopFeeTimer();
      this.loading = false;
      this.refreshing = false;
      this.setErrorsModalInfo([message]);
      this.showErrorsModal();
    },
    close: function close() {
      this.stopPolling();
      this.stopFeeTimer();
      this.$emit('close');
    }
  })
});

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_static_searchTypes__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Question__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Question___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_modals_Question__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/** How often the batch status is polled while a phase runs in the background. */
var POLL_INTERVAL_MS = 2000;
/** Stop polling after this long so a stalled batch cannot spin forever. */
var POLL_TIMEOUT_MS = 10 * 60 * 1000;

var PHASE_TEXT = {
  REQUEST: 'could not be requested',
  APPROVAL: 'request raised but not approved',
  CANCELLATION: 'request could not be reversed'
};

var emptyPreview = function emptyPreview() {
  return {
    fromAccount: null,
    toAccount: null,
    eligibleCount: 0,
    ineligibleCount: 0,
    terminalNoteCount: 0,
    electionsToReset: 0,
    eligibleNotes: [],
    ineligibleNotes: [],
    warnings: [],
    totals: { principal: 0 },
    openBatch: null
  };
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bulk-transfer',
  components: {
    question: __WEBPACK_IMPORTED_MODULE_8__components_modals_Question___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_9__components_widgets_Spinner___default.a
  },
  props: ['accountId'],
  data: function data() {
    return {
      loading: true,
      loadingText: 'Loading…',
      loadFailed: false,
      loadError: '',
      searching: false,
      preview: emptyPreview(),
      selectedAccount: null,
      includeClosedNotes: false,
      comment: '',
      approvalComment: '',
      showNotes: false,
      showExcluded: false,
      result: null,
      pollTimer: null,
      search: {
        text: '',
        hasSearched: false,
        account: null
      }
    };
  },
  beforeMount: function beforeMount() {
    this.loadPreview();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopPolling();
    // The question modal lives in the store, so an open confirmation would
    // outlive this modal and strand the user behind it.
    this.hideQuestionModal();
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])('question', { displayQuestion: 'display' }), {
    openBatch: function openBatch() {
      return this.preview.openBatch || {};
    },

    /** A batch already awaiting approval turns this modal into the approve step. */
    isApproval: function isApproval() {
      return Boolean(this.preview.openBatch && this.preview.openBatch.status === 'PENDING_APPROVAL');
    },
    destinationLabel: function destinationLabel() {
      if (this.preview.toAccount) {
        return this.preview.toAccount.accountNumber;
      }
      return this.openBatch.toAccountId;
    },

    /** The notes the open request named, from its own snapshot. */
    requestNotes: function requestNotes() {
      return this.openBatch.notes || [];
    },
    approvalMatchesRequest: function approvalMatchesRequest() {
      return Boolean(this.approvalComment && this.approvalComment === this.openBatch.requestComment);
    },
    canApprove: function canApprove() {
      return Boolean(this.approvalComment) && !this.approvalMatchesRequest;
    },
    canSubmit: function canSubmit() {
      if (!this.preview.eligibleCount) return false;
      if (!this.selectedAccount) return false;
      if (!this.comment) return false;
      return true;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    formatAmount: __WEBPACK_IMPORTED_MODULE_6__util__["c" /* formatAmount */],
    formatDate: __WEBPACK_IMPORTED_MODULE_6__util__["b" /* formatDate */]
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('note', ['previewBulkNoteTransfer', 'createBulkNoteTransfer', 'getBulkNoteTransfer', 'approveBulkNoteTransfer', 'cancelBulkNoteTransfer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])('account', ['getAccounts']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])('question', {
    showQuestionModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["k" /* SHOW_QUESTION_MODAL */],
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */]
  }), {
    loadPreview: function loadPreview() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var preview;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _this.loadingText = 'Loading…';
                _this.loadFailed = false;

                _context.prev = 3;
                _context.next = 6;
                return _this.previewBulkNoteTransfer({
                  accountId: _this.accountId,
                  toAccountId: _this.selectedAccount ? _this.selectedAccount.id : null,
                  includeClosedNotes: _this.includeClosedNotes
                });

              case 6:
                preview = _context.sent;

                _this.preview = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(emptyPreview(), preview);
                _this.seedApprovalComment();
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](3);

                _this.loadError = _this.errorText(_context.t0, 'The request failed. The notes on this account have not been checked.');
                _this.loadFailed = true;
                _this.fail(_this.loadError);

              case 16:
                _context.prev = 16;

                _this.loading = false;
                return _context.finish(16);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 11, 16, 19]]);
      }))();
    },

    /**
     * Puts the requester's comment in the approver's box, once.
     *
     * Only on the first load that finds a request awaiting approval: a later
     * reload must not overwrite what the approver has typed.
     */
    seedApprovalComment: function seedApprovalComment() {
      var batch = this.preview.openBatch;
      if (!batch || !batch.requestComment) return;
      if (this.approvalComment) return;

      this.approvalComment = batch.requestComment;
    },
    searchAccount: function searchAccount() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.search.text) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:

                _this2.searching = true;

                _context2.prev = 3;
                _context2.next = 6;
                return _this2.getAccounts({
                  searchString: _this2.search.text,
                  searchBy: __WEBPACK_IMPORTED_MODULE_7__data_static_searchTypes__["a" /* SearchTypes */].ACCOUNT_NUMBER.name
                });

              case 6:
                response = _context2.sent;

                _this2.search.hasSearched = true;
                _this2.search.account = response.statusCode === 401 ? null : response.account;
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](3);

                _this2.setErrorsModalInfo(['We could not retrieve the account.']);
                _this2.showErrorsModal();

              case 15:
                _context2.prev = 15;

                _this2.searching = false;
                return _context2.finish(15);

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[3, 11, 15, 18]]);
      }))();
    },
    isSelected: function isSelected(account) {
      return Boolean(this.selectedAccount && this.selectedAccount.id === account.id);
    },

    /**
     * Re-previews against the chosen destination. The note assessment does
     * not change, but the destination checks — inactive account, different
     * investor, nothing to pay out through — only exist once there is one.
     */
    selectAccount: function selectAccount(account) {
      if (String(account.id) === String(this.accountId)) {
        this.setErrorsModalInfo(['Please select a different account.']);
        this.showErrorsModal();
        return;
      }

      this.selectedAccount = account;
      this.loadPreview();
    },
    confirmSubmit: function confirmSubmit() {
      var destination = this.selectedAccount.accountId || this.selectedAccount.id;

      var question = 'This transfers ' + this.preview.eligibleCount + ' notes to account ' + (destination + '.');

      if (this.includeClosedNotes) {
        question += ' Closed notes are included in that count.';
      }

      if (this.preview.electionsToReset) {
        question += ' It resets ' + this.preview.electionsToReset + ' upcoming ' + 'transaction(s) once approved, and anything the investor already ' + 'chose must be chosen again on the destination account.';
      }

      question += ' Another admin must approve it before any note moves.';

      this.askToConfirm({
        title: 'Request this bulk transfer?',
        question: question,
        yesButtonText: 'Request',
        method: this.submit
      });
    },
    submit: function submit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref, batchId;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loading = true;
                _this3.loadingText = 'Requesting transfers…';

                _context3.prev = 2;
                _context3.next = 5;
                return _this3.createBulkNoteTransfer({
                  accountId: _this3.accountId,
                  payload: {
                    toAccountId: _this3.selectedAccount.id,
                    comment: _this3.comment,
                    includeClosedNotes: _this3.includeClosedNotes,
                    noteIds: _this3.preview.eligibleNotes.map(function (note) {
                      return note.noteId;
                    }),
                    expectedNoteCount: _this3.preview.eligibleCount
                  }
                });

              case 5:
                _ref = _context3.sent;
                batchId = _ref.batchId;
                _context3.next = 9;
                return _this3.pollUntilSettled(batchId, 'CREATING', 'Transfer requested');

              case 9:
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](2);

                _this3.fail(_this3.errorText(_context3.t0, 'We could not submit the bulk transfer.'));

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[2, 11]]);
      }))();
    },
    confirmApproval: function confirmApproval() {
      this.askToConfirm({
        title: 'Approve this bulk transfer?',
        question: 'This moves ' + this.openBatch.noteCount + ' notes to account ' + (this.destinationLabel + '. It cannot be undone here \u2014 reversing ') + 'it means transferring them back.',
        yesButtonText: 'Approve',
        method: this.approve
      });
    },
    approve: function approve() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.loading = true;
                _this4.loadingText = 'Transferring notes…';

                _context4.prev = 2;
                _context4.next = 5;
                return _this4.approveBulkNoteTransfer({
                  accountId: _this4.accountId,
                  batchId: _this4.openBatch.id,
                  payload: { comment: _this4.approvalComment }
                });

              case 5:
                _context4.next = 7;
                return _this4.pollUntilSettled(_this4.openBatch.id, 'APPROVING', 'Notes transferred');

              case 7:
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](2);

                _this4.fail(_this4.errorText(_context4.t0, 'We could not approve the bulk transfer.'));

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[2, 9]]);
      }))();
    },
    confirmCancelBatch: function confirmCancelBatch() {
      this.askToConfirm({
        title: 'Withdraw this bulk transfer?',
        question: 'This withdraws every request raised for the ' + this.openBatch.noteCount + ' ' + 'notes in this batch. They stay where they are.',
        yesButtonText: 'Withdraw',
        method: this.cancelBatch
      });
    },

    /**
     * Asks the shared question modal, then runs the action on confirm.
     *
     * The modal is the app's own confirmation dialog; window.confirm was a
     * placeholder and is blocked outright in some embedded contexts.
     */
    askToConfirm: function askToConfirm(_ref2) {
      var _this5 = this;

      var title = _ref2.title,
          question = _ref2.question,
          yesButtonText = _ref2.yesButtonText,
          _method = _ref2.method;

      this.showQuestionModal({
        title: title,
        question: question,
        yesButtonText: yesButtonText,
        hideCancelButton: false,
        method: function method() {
          _this5.hideQuestionModal();
          _method();
        }
      });
    },
    cancelBatch: function cancelBatch() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _ref3, cancelledNotes;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.loading = true;
                _this6.loadingText = 'Withdrawing requests…';

                _context5.prev = 2;
                _context5.next = 5;
                return _this6.cancelBulkNoteTransfer({
                  accountId: _this6.accountId,
                  batchId: _this6.openBatch.id,
                  payload: { comment: _this6.approvalComment }
                });

              case 5:
                _ref3 = _context5.sent;
                cancelledNotes = _ref3.cancelledNotes;

                _this6.loading = false;
                _this6.result = {
                  title: 'Request cancelled',
                  message: cancelledNotes + ' note transfer request(s) were withdrawn.',
                  failed: false,
                  failures: []
                };
                _this6.$emit('completed');
                _context5.next = 15;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5['catch'](2);

                _this6.fail(_this6.errorText(_context5.t0, 'We could not cancel the bulk transfer.'));

              case 15:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[2, 12]]);
      }))();
    },

    /**
     * Both phases return 202 and finish in the background, so the modal polls
     * the batch until it leaves the in-progress status.
     */
    pollUntilSettled: function pollUntilSettled(batchId, inProgressStatus, successTitle) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var startedAt, check;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                startedAt = Date.now();

                check = function () {
                  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
                    var batch, done, failedSuffix;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            batch = void 0;
                            _context6.prev = 1;
                            _context6.next = 4;
                            return _this7.getBulkNoteTransfer({
                              accountId: _this7.accountId,
                              batchId: batchId
                            });

                          case 4:
                            batch = _context6.sent;
                            _context6.next = 11;
                            break;

                          case 7:
                            _context6.prev = 7;
                            _context6.t0 = _context6['catch'](1);

                            _this7.fail('We lost track of this batch. Reopen to see its status.');
                            return _context6.abrupt('return');

                          case 11:
                            if (!(batch.status === inProgressStatus)) {
                              _context6.next = 17;
                              break;
                            }

                            if (!(Date.now() - startedAt > POLL_TIMEOUT_MS)) {
                              _context6.next = 15;
                              break;
                            }

                            _this7.fail('This is taking longer than expected. Reopen the modal to check progress.');
                            return _context6.abrupt('return');

                          case 15:
                            _this7.pollTimer = setTimeout(check, POLL_INTERVAL_MS);
                            return _context6.abrupt('return');

                          case 17:

                            _this7.stopPolling();
                            _this7.loading = false;

                            // Which count means "processed" depends on the phase: requesting
                            // leaves notes awaiting approval, approving moves them.
                            done = inProgressStatus === 'CREATING' ? batch.progress.requested : batch.progress.transferred;
                            failedSuffix = batch.progress.failed ? ' ' + batch.progress.failed + ' failed.' : '';


                            _this7.result = {
                              title: successTitle,
                              message: done + ' of ' + batch.noteCount + ' notes processed.' + failedSuffix,
                              failed: batch.progress.failed > 0,
                              failures: batch.failures || []
                            };
                            _this7.$emit('completed');

                          case 23:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, _this7, [[1, 7]]);
                  }));

                  return function check() {
                    return _ref4.apply(this, arguments);
                  };
                }();

                _context7.next = 4;
                return check();

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    stopPolling: function stopPolling() {
      if (this.pollTimer) {
        clearTimeout(this.pollTimer);
        this.pollTimer = null;
      }
    },
    failedPhaseText: function failedPhaseText(phase) {
      return PHASE_TEXT[phase] || phase;
    },
    errorText: function errorText(error, fallback) {
      var message = error && error.response && error.response.data && error.response.data.message;
      return message || fallback;
    },
    fail: function fail(message) {
      this.stopPolling();
      this.loading = false;
      this.setErrorsModalInfo([message]);
      this.showErrorsModal();
    },
    close: function close() {
      this.stopPolling();
      this.$emit('close');
    }
  })
});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Errors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_modals_Errors__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_6__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_6__util__["c" /* formatAmount */],
    formatType: __WEBPACK_IMPORTED_MODULE_6__util__["d" /* formatType */],
    formatStatus: __WEBPACK_IMPORTED_MODULE_6__util__["e" /* formatStatus */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'checkWire',
  beforeMount: function beforeMount() {
    this.fundingSourceType = this.fundingSourceTypes.CHECK.name;
  },

  props: ['closeAction'],
  mixins: [mix],
  components: {
    errors: __WEBPACK_IMPORTED_MODULE_8__components_modals_Errors___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_7__components_widgets_Spinner___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('app', ['fundingSourceTypes']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('checkWireModal', ['accountId', 'fundingSources']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal'])),
  data: function data() {
    return {
      fundingSourceType: 'check',
      isLoading: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('checkWireModal', ['createAccountFundingSources']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('checkWireModal', {
    hideCheckWireModal: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["v" /* HIDE_CHECK_WIRE_MODAL */],
    setCreationStatus: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["u" /* SET_CREATION_SUCCEEDED */]
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('errors', {
    showErrorsModal: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["h" /* SHOW_ERRORS_MODAL */],
    setErrorsModalInfo: __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["i" /* SET_ERRORS_MODAL_INFO */]
  }), {
    saveModal: function saveModal() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var fundingSourceKey, containsFundingSourceType;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.isLoading = true;
                fundingSourceKey = '';
                containsFundingSourceType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["find"])(_this.fundingSources, function (fs) {
                  return fs.type === _this.fundingSourceType && !fs.removed;
                });

                if (!containsFundingSourceType) {
                  _context.next = 9;
                  break;
                }

                _this.setErrorsModalInfo(['Please note that ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util__["d" /* formatType */])(_this.fundingSourceType, 'investor') + '\n          already exists as a bank account. Try adding a different type of bank account.']);
                _this.showErrorsModal();
                _this.isLoading = false;
                return _context.abrupt('return');

              case 9:
                if (_this.fundingSourceType.includes('check')) {
                  fundingSourceKey = 'CHECK';
                } else if (_this.fundingSourceType.includes('wire')) {
                  fundingSourceKey = 'WIRE_TRANSFER';
                }
                _context.next = 12;
                return _this.createAccountFundingSources({
                  accountId: _this.accountId,
                  payload: {
                    type: fundingSourceKey
                  }
                });

              case 12:
                _this.isLoading = false;
                _this.setCreationStatus(true);
                _this.hideCheckWireModal();
                _this.closeAction();
                _context.next = 23;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](0);

                _this.isLoading = false;
                _this.setCreationStatus(false);
                if (_context.t0 !== 'UNAUTHORIZED') {
                  _this.setErrorsModalInfo(['We could not save the bank account']);
                  _this.showErrorsModal();
                }

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 18]]);
      }))();
    },
    closeModal: function closeModal() {
      this.setCreationStatus(false);
      this.hideCheckWireModal();
      if (typeof this.closeAction === 'function') {
        this.closeAction();
      }
    }
  })
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'commercialAddressOverride',
  data: function data() {
    return {
      allowed: false,
      comment: ''
    };
  },

  computed: {
    canSave: function canSave() {
      return this.allowed && this.comment.trim().length > 0;
    }
  },
  methods: {
    confirm: function confirm() {
      if (!this.canSave) return;
      this.$emit('confirm', this.comment.trim());
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editTransactionComment',
  props: {
    closeAction: {
      type: Function,
      required: true
    },
    transaction: {
      type: Object,
      required: true
    },
    loadNoteDetail: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: false,
      comment: this.transaction.comment
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])('errors', ['isVisibleErrorsModal'])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('transaction', ['saveLostComment']), {
    saveComment: function saveComment() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                _context.next = 3;
                return _this.saveLostComment({
                  id: _this.transaction.id,
                  comment: _this.comment
                });

              case 3:
                _context.next = 5;
                return _this.loadNoteDetail();

              case 5:
                _this.isLoading = false;
                _this.closeModal();

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    closeModal: function closeModal() {
      if (typeof this.closeAction === 'function') {
        this.closeAction();
      }
    }
  })
});

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'errors',
  data: function data() {
    return {
      message: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('errors', ['listErrors']), {
    reducedErrors: function reducedErrors() {
      if (Array.isArray(this.listErrors)) {
        return this.listErrors.slice(0, 3);
      }

      return this.listErrors;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('errors', {
    hideErrorsModal: __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["n" /* HIDE_ERRORS_MODAL */]
  }), {
    closeModal: function closeModal() {
      this.hideErrorsModal();
    }
  })
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'information',
  props: ['closeAction'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('information', ['message'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('information', {
    hideInformationModal: __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["e" /* HIDE_INFORMATION_MODAL */]
  }), {
    closeModal: function closeModal() {
      this.hideInformationModal();
      if (typeof this.closeAction === 'function') {
        this.closeAction();
      }
    }
  })
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'interestAdjustment',
  props: {
    noteId: {
      type: String,
      required: true
    },
    isSubmitDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    submitAction: {
      type: Function,
      required: true
    },
    cancelAction: {
      type: Function,
      required: true
    }
  },
  methods: {
    closeModal: function closeModal() {
      this.cancelAction();
    }
  }
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_static_events__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_static_searchTypes__ = __webpack_require__(108);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var mix = {
  methods: {
    getUserTypeLabel: __WEBPACK_IMPORTED_MODULE_5__util__["w" /* getUserTypeLabel */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MergePartialUser',
  data: function data() {
    return {
      searchText: '',
      users: [],
      hasSearched: false,
      isSearching: false,
      searchTypes: __WEBPACK_IMPORTED_MODULE_6__data_static_searchTypes__["a" /* SearchTypes */]
    };
  },

  mixins: [mix],
  props: {
    closeAction: {
      type: Function,
      required: true
    },
    partialUserId: {
      type: Number,
      required: true
    }
  },
  computed: {
    isSearchDisabled: function isSearchDisabled() {
      return !this.searchText.length > 0;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    closeModal: function closeModal() {
      this.closeAction();
    },
    searchUsers: function searchUsers() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (_this.searchText.length) {
                  _context.next = 4;
                  break;
                }

                _this.users = [];
                return _context.abrupt('return');

              case 4:
                _this.isSearching = true;
                _context.next = 7;
                return _this.getAccounts({
                  searchString: _this.searchText,
                  searchBy: _this.searchTypes.NAME_EMAIL.name
                });

              case 7:
                response = _context.sent;

                _this.hasSearched = true;
                if (response.statusCode === 401) {
                  _this.users = [];
                } else {
                  // Filter to only show users with accounts (accounts.length > 0)
                  // and exclude the current partial user
                  _this.users = (response.users || []).filter(function (user) {
                    return user.accounts && user.accounts.length > 0 && user.id !== _this.partialUserId;
                  });
                }
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](0);

                _this.setErrorsModalInfo(['We could not retrieve users list']);
                _this.showErrorsModal();

              case 16:
                _context.prev = 16;

                _this.isSearching = false;
                return _context.finish(16);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 12, 16, 19]]);
      }))();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('account', ['getAccounts']), {
    confirmMergeUser: function confirmMergeUser(user) {
      this.$emit(__WEBPACK_IMPORTED_MODULE_4__data_static_events__["a" /* Events */].USER_MERGE_REQUESTED, { targetUserId: user.id });
    }
  })
});

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'question',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('question', ['modalTitle', 'questionText', 'questionTextAppend', 'hyperLinkUrl', 'hyperLinkText', 'hyperLinkUrl2', 'hyperLinkText2', 'methodToExecute', 'yesButtonText', 'hideCancelButton'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('question', {
    hideQuestionModal: __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["j" /* HIDE_QUESTION_MODAL */]
  }), {
    executeAction: function executeAction() {
      this.methodToExecute();
    }
  })
});

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'success',
  props: ['closeAction'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('success', ['message'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('success', {
    hideInformationModal: __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["I" /* HIDE_SUCCESS_MODAL */]
  }), {
    closeModal: function closeModal() {
      this.hideInformationModal();
      if (typeof this.closeAction === 'function') {
        this.closeAction();
      }
    }
  })
});

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(9);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var mix = {
  methods: {
    formatDate: __WEBPACK_IMPORTED_MODULE_3__util__["b" /* formatDate */],
    formatAmount: __WEBPACK_IMPORTED_MODULE_3__util__["c" /* formatAmount */],
    formatType: __WEBPACK_IMPORTED_MODULE_3__util__["d" /* formatType */],
    formatStatus: __WEBPACK_IMPORTED_MODULE_3__util__["e" /* formatStatus */],
    isFailTransaction: __WEBPACK_IMPORTED_MODULE_3__util__["g" /* isFailTransaction */],
    isCancelTransaction: __WEBPACK_IMPORTED_MODULE_3__util__["h" /* isCancelTransaction */],
    isPurchaseFailedTransaction: __WEBPACK_IMPORTED_MODULE_3__util__["i" /* isPurchaseFailedTransaction */],
    isPurchaseFailedTransactionWithSelectedErrorsCode: __WEBPACK_IMPORTED_MODULE_3__util__["j" /* isPurchaseFailedTransactionWithSelectedErrorsCode */]
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'transaction',
  data: function data() {
    return {
      showScrollRightHint: false
    };
  },

  props: {
    closeAction: {
      type: Function,
      required: false,
      default: function _default() {}
    },
    informationMessage: {
      type: String,
      required: false,
      default: ''
    }
  },
  mixins: [mix],
  watch: {
    transactions: {
      handler: function handler() {
        var _this = this;

        this.$nextTick(function () {
          return _this.updateScrollRightHint();
        });
      },

      deep: true
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      return _this2.initTableScrollHint();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.teardownTableScrollHint();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])('transactionModal', ['noteId', 'transactions', 'noteOpenedOn']), {
    showInformationMessage: function showInformationMessage() {
      return new Date(this.noteOpenedOn) < new Date(2013, 1, 1);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])('transactionModal', {
    hideTransactionModal: __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["G" /* HIDE_TRANSACTION_MODAL */]
  }), {
    closeModal: function closeModal() {
      this.hideTransactionModal();
      if (typeof this.closeAction === 'function') {
        this.closeAction();
      }
    },
    onTableScrollResize: function onTableScrollResize() {
      this.updateScrollRightHint();
    },
    onTableScroll: function onTableScroll() {
      this.updateScrollRightHint();
    },
    initTableScrollHint: function initTableScrollHint() {
      var _this3 = this;

      var el = this.$refs.tableScroll;
      if (!el) {
        return;
      }
      if (typeof window !== 'undefined' && window.ResizeObserver) {
        this.tableScrollResizeObserver = new window.ResizeObserver(function () {
          _this3.updateScrollRightHint();
        });
        this.tableScrollResizeObserver.observe(el);
      }
      window.addEventListener('resize', this.onTableScrollResize);
      this.updateScrollRightHint();
    },
    teardownTableScrollHint: function teardownTableScrollHint() {
      window.removeEventListener('resize', this.onTableScrollResize);
      if (this.tableScrollResizeObserver) {
        this.tableScrollResizeObserver.disconnect();
        this.tableScrollResizeObserver = null;
      }
    },
    updateScrollRightHint: function updateScrollRightHint() {
      var el = this.$refs.tableScroll;
      if (!el) {
        this.showScrollRightHint = false;
        return;
      }
      var maxScroll = el.scrollWidth - el.clientWidth;
      var epsilon = 2;
      var hasOverflow = maxScroll > epsilon;
      var notAtEnd = el.scrollLeft < maxScroll - epsilon;
      this.showScrollRightHint = hasOverflow && notAtEnd;
    },
    scrollTableToEnd: function scrollTableToEnd() {
      var el = this.$refs.tableScroll;
      if (!el) {
        return;
      }
      var maxLeft = el.scrollWidth - el.clientWidth;
      el.scrollTo({ left: maxLeft, behavior: 'smooth' });
    }
  })
});

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sortableTh',
  props: {
    property: {
      type: String,
      required: true,
      default: ''
    },
    label: {
      type: String,
      required: true,
      default: ''
    },
    sortProperty: {
      type: String,
      required: true,
      default: ''
    },
    sortToggle: {
      type: Number,
      required: true,
      default: ''
    }
  },
  methods: {
    handleSortStrategy: function handleSortStrategy() {
      this.$emit('handleSortStrategy', this.property);
    },
    sortIconStyle: function sortIconStyle() {
      if (this.property === this.sortProperty) {
        return 'fa fa-sort-' + (this.sortToggle === 1 ? 'asc' : 'desc');
      }
      return 'fa fa-sort';
    }
  }
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DismissableAlert',
  props: {
    alertType: {
      type: String,
      required: false,
      default: 'success'
    },
    isShowing: {
      type: Boolean,
      required: true,
      default: false
    },
    closeAction: {
      type: Function,
      required: false,
      default: function _default() {}
    },
    title: {
      type: String,
      required: true,
      default: ''
    },
    subtitle: {
      type: String,
      required: false,
      default: ''
    },
    dismissible: {
      type: Boolean,
      required: false,
      default: true
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    notice: {
      type: String,
      default: null,
      required: false
    }
  },
  methods: {
    getAlertImageUrl: function getAlertImageUrl() {
      return __webpack_require__(2218)("./icon-" + this.icon + '.svg'); // eslint-disable-line
    }
  }
});

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotificationIcon',
  props: ['content']
});

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'spinner',
  props: {
    /**
     * Optional caption under the spinner. Worth setting when the wait is long
     * enough, or has enough distinct phases, that "something is happening" is
     * not an answer on its own.
     */
    text: {
      type: String,
      default: ''
    },
    /**
     * Renders in the content flow instead of masking the whole page. Use it
     * inside a panel or a modal, where a full-screen overlay would hide the
     * very thing the spinner belongs to.
     */
    inline: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 970 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 971 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 972 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 974 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 975 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 976 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 978 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 979 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 980 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 982 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 983 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 986 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 988 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 991 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 992 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 996 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 999 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */
/***/ (function(module, exports) {

module.exports = {"version":"2017c","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|01213454545454545454545454545454545454545454545454543|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Etc/GMT+0|GMT|0|0|","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Sao_Tome","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT+0|Etc/GMT","Etc/GMT+0|Etc/GMT-0","Etc/GMT+0|Etc/GMT0","Etc/GMT+0|Etc/Greenwich","Etc/GMT+0|GMT","Etc/GMT+0|GMT+0","Etc/GMT+0|GMT-0","Etc/GMT+0|GMT0","Etc/GMT+0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 1203 */,
/* 1204 */,
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 351,
	"./af.js": 351,
	"./ar": 358,
	"./ar-dz": 352,
	"./ar-dz.js": 352,
	"./ar-kw": 353,
	"./ar-kw.js": 353,
	"./ar-ly": 354,
	"./ar-ly.js": 354,
	"./ar-ma": 355,
	"./ar-ma.js": 355,
	"./ar-sa": 356,
	"./ar-sa.js": 356,
	"./ar-tn": 357,
	"./ar-tn.js": 357,
	"./ar.js": 358,
	"./az": 359,
	"./az.js": 359,
	"./be": 360,
	"./be.js": 360,
	"./bg": 361,
	"./bg.js": 361,
	"./bm": 362,
	"./bm.js": 362,
	"./bn": 363,
	"./bn.js": 363,
	"./bo": 364,
	"./bo.js": 364,
	"./br": 365,
	"./br.js": 365,
	"./bs": 366,
	"./bs.js": 366,
	"./ca": 367,
	"./ca.js": 367,
	"./cs": 368,
	"./cs.js": 368,
	"./cv": 369,
	"./cv.js": 369,
	"./cy": 370,
	"./cy.js": 370,
	"./da": 371,
	"./da.js": 371,
	"./de": 374,
	"./de-at": 372,
	"./de-at.js": 372,
	"./de-ch": 373,
	"./de-ch.js": 373,
	"./de.js": 374,
	"./dv": 375,
	"./dv.js": 375,
	"./el": 376,
	"./el.js": 376,
	"./en-au": 377,
	"./en-au.js": 377,
	"./en-ca": 378,
	"./en-ca.js": 378,
	"./en-gb": 379,
	"./en-gb.js": 379,
	"./en-ie": 380,
	"./en-ie.js": 380,
	"./en-nz": 381,
	"./en-nz.js": 381,
	"./eo": 382,
	"./eo.js": 382,
	"./es": 385,
	"./es-do": 383,
	"./es-do.js": 383,
	"./es-us": 384,
	"./es-us.js": 384,
	"./es.js": 385,
	"./et": 386,
	"./et.js": 386,
	"./eu": 387,
	"./eu.js": 387,
	"./fa": 388,
	"./fa.js": 388,
	"./fi": 389,
	"./fi.js": 389,
	"./fo": 390,
	"./fo.js": 390,
	"./fr": 393,
	"./fr-ca": 391,
	"./fr-ca.js": 391,
	"./fr-ch": 392,
	"./fr-ch.js": 392,
	"./fr.js": 393,
	"./fy": 394,
	"./fy.js": 394,
	"./gd": 395,
	"./gd.js": 395,
	"./gl": 396,
	"./gl.js": 396,
	"./gom-latn": 397,
	"./gom-latn.js": 397,
	"./gu": 398,
	"./gu.js": 398,
	"./he": 399,
	"./he.js": 399,
	"./hi": 400,
	"./hi.js": 400,
	"./hr": 401,
	"./hr.js": 401,
	"./hu": 402,
	"./hu.js": 402,
	"./hy-am": 403,
	"./hy-am.js": 403,
	"./id": 404,
	"./id.js": 404,
	"./is": 405,
	"./is.js": 405,
	"./it": 406,
	"./it.js": 406,
	"./ja": 407,
	"./ja.js": 407,
	"./jv": 408,
	"./jv.js": 408,
	"./ka": 409,
	"./ka.js": 409,
	"./kk": 410,
	"./kk.js": 410,
	"./km": 411,
	"./km.js": 411,
	"./kn": 412,
	"./kn.js": 412,
	"./ko": 413,
	"./ko.js": 413,
	"./ky": 414,
	"./ky.js": 414,
	"./lb": 415,
	"./lb.js": 415,
	"./lo": 416,
	"./lo.js": 416,
	"./lt": 417,
	"./lt.js": 417,
	"./lv": 418,
	"./lv.js": 418,
	"./me": 419,
	"./me.js": 419,
	"./mi": 420,
	"./mi.js": 420,
	"./mk": 421,
	"./mk.js": 421,
	"./ml": 422,
	"./ml.js": 422,
	"./mr": 423,
	"./mr.js": 423,
	"./ms": 425,
	"./ms-my": 424,
	"./ms-my.js": 424,
	"./ms.js": 425,
	"./mt": 426,
	"./mt.js": 426,
	"./my": 427,
	"./my.js": 427,
	"./nb": 428,
	"./nb.js": 428,
	"./ne": 429,
	"./ne.js": 429,
	"./nl": 431,
	"./nl-be": 430,
	"./nl-be.js": 430,
	"./nl.js": 431,
	"./nn": 432,
	"./nn.js": 432,
	"./pa-in": 433,
	"./pa-in.js": 433,
	"./pl": 434,
	"./pl.js": 434,
	"./pt": 436,
	"./pt-br": 435,
	"./pt-br.js": 435,
	"./pt.js": 436,
	"./ro": 437,
	"./ro.js": 437,
	"./ru": 438,
	"./ru.js": 438,
	"./sd": 439,
	"./sd.js": 439,
	"./se": 440,
	"./se.js": 440,
	"./si": 441,
	"./si.js": 441,
	"./sk": 442,
	"./sk.js": 442,
	"./sl": 443,
	"./sl.js": 443,
	"./sq": 444,
	"./sq.js": 444,
	"./sr": 446,
	"./sr-cyrl": 445,
	"./sr-cyrl.js": 445,
	"./sr.js": 446,
	"./ss": 447,
	"./ss.js": 447,
	"./sv": 448,
	"./sv.js": 448,
	"./sw": 449,
	"./sw.js": 449,
	"./ta": 450,
	"./ta.js": 450,
	"./te": 451,
	"./te.js": 451,
	"./tet": 452,
	"./tet.js": 452,
	"./th": 453,
	"./th.js": 453,
	"./tl-ph": 454,
	"./tl-ph.js": 454,
	"./tlh": 455,
	"./tlh.js": 455,
	"./tr": 456,
	"./tr.js": 456,
	"./tzl": 457,
	"./tzl.js": 457,
	"./tzm": 459,
	"./tzm-latn": 458,
	"./tzm-latn.js": 458,
	"./tzm.js": 459,
	"./uk": 460,
	"./uk.js": 460,
	"./ur": 461,
	"./ur.js": 461,
	"./uz": 463,
	"./uz-latn": 462,
	"./uz-latn.js": 462,
	"./uz.js": 463,
	"./vi": 464,
	"./vi.js": 464,
	"./x-pseudo": 465,
	"./x-pseudo.js": 465,
	"./yo": 466,
	"./yo.js": 466,
	"./zh-cn": 467,
	"./zh-cn.js": 467,
	"./zh-hk": 468,
	"./zh-hk.js": 468,
	"./zh-tw": 469,
	"./zh-tw.js": 469
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1205;

/***/ }),
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/calvert-logo-transparent-background.123e24f.png";

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg.ee92a3c.jpg";

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg3.9cf201e.jpg";

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPYAAAD1CAYAAABjhghmAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAA3BSURBVHgB7d1LbFxXHcfxvz0ev+bhjO14bGI7j9ZJlcSgJK2UkhJeoVCyaJFYNEhsYBGxKGwICwSoamFTugIWICTEqgkICTamFIQEpRWRgCyIg6hT2jxME79iz9gz9oxf3P+AUVon9ng8j3P/9/uRblNNW9Uaz2/O/557zv+IAAAAAAAAAAAAAL5VJ6iJP41ce7s7HtvTGAoJfGV1ZWX1ub3JxLPisAZBTcwszEvKuzojEenwLgKOcqoX1NRkJiNvT03JdDYrQLkQbAfkl5dlNJWSNycnC38PbBfBdsj84qK8MT4ut9JpAo5tIdgOojzHdhFsR1GeYzsItuPWyvPRmRkCjqLxuMsnpufnJZPPS1c0KonWVgE2wojtI2vluY7gjN7YCMH2IQ015Tk2QinuY5TnuB9GbJ+jPMe9EGwjKM9xN0pxYyjPoRixDaI8B8E2jPI8uCjFA4DyPHgYsQOC8jxYCHbAUJ4HA6V4QK2V59qWSdszwRZG7ADTEVubOugIrrvIYAfBRiHguu+b8twOSnH831p5Pr+8IpPZvFjTGKqX3raY7Eu0iXUEG++iI7Y2Qk40heR6OisLS7ZG8NH0nPcFtiDH3pcUyyjFcU86ug0kotIba5Fwva2PyRuT0/LWdEosI9jYUKK5UQbao5KMNIklo6lZsYxgY1Ohujrpam2WA+0xiTfZuHvLe/MIlhFsFE3L893xiMny3Bomz7BlWp7Hm8IyNZ+TsUxO4B6+dlESi+W5JQQb2+LX8jzR0iyW8VWLstDyXK/x7ILz5XkkHJaHOhNimdPBnpxJrYpR17znqMsr9mZmd0Za5GhPg/esOC1vzaTFNRrqk3t2SaQxLJYxYtfIHuPLGhtCYdnbvkNcorcN1kvwNQQbFZFobpKYrTUtvsLkGWAQwQYMItiAQQQbMIjJM1SEbot8ZzYrLgmHQtIbj0oyar8FM8FGRYxnsk7ueX5j8o4MJjsLl2WU4gicy2OTMjbnVjVRbgQbgfQ2HVQAe+byttstE2zAIIINGESwAYMINgIpanzbJsFGIFl/js0CFQSKtm86titJowUrXr9xSy6PTcmV8SnBxg51dchj/T1yONkhpdqbaJP2FreWboZD9dIdjRT+tM58sG+kZuWZoVcLwUaxrhb+enpgtzx/6rj0t8Vkq5KRVumwvyTbWaa/ujTUT740RKhLNHT1unzsJ7+U4TGqHL8xG+y1UN9MzQlKN5PLy1PnhyS1YO9YXcvMBvuF1y4R6jKZ8UL9Xe/9hH+YDfbLI9cF5XNheIRR20dMTp7pPXUqx4ewnDTUw94ThRPebHkxRtOzMpF16+AAnQ3vi8fMP+pSJoPNyFIZOm9xQooN9pyMTLm3NfLSO+M0WvArRmtshEYLgFE0WgAMotECAN8h2IBBBBswiGAjkGi0ABh0oDMhltFoAYFS511H35eUREuzWEawURF6RlZTg1vlrnZPeaB9B40WgFL1xmPSHdt6gwaUB/fYgEEEGzCIYAMGEWzAICbPUBFjmaykFtzaaNEYCklvW1SCgGCjInRbpIuNFrR7yrGepPmAU4ojUDL5Rbk4ekum5xfEMoKNwMkvL8tb02mxjGAjkBixAfgOwQYMItiAQQQbgdRofIcXwUYg6e4zywg2AkdPAdnX3iaWsfIMFaEH3y+tiFN0SemueFSS0VaxjmCjIvYm2qRvh+1R0WWU4oBBBBswiGADBhFswCAmz1ARc4uLDjZaqDffT3wNwUZFDI9NOtto4dS+/sKfllGKI1C00cLLV68V/rSMYCNwtNHCPyenxTKCjUCi0QIA3yHYgEEEGzCIYCOQaLQAGESjBcAY3VJKowWgBNHGsHRF3GpooOW3jtTWQ60INiricFenPLRTUCOU4oBBBBswiGADBhFswCAmz1AR+ZUVmV9clnLS9sFh4wtLysVksPvbooLya2tqLPrfvfTOWEUaLegjtEf7esw3Stguk19/BLsy+ttqv1prPJMNRKOE7TIZ7D7vA3iiv0dQPv07YnI42SEuCEKjhO0ye8Py9OCAoDzqvOvciSPiktH0rOD+zAb7zOB+L9z7BdujoX5i/27eS58xPcX4g9Mn5ezDhwWlWQv19z99UuAv5h93fefUce/esF0uXL4qr9+4JViv7h4v6BzF2YcPyRMDewT+E4jn2FqW65VayMnw+B3B/ekjrT7vqUJbc5O4LFzP8+yNBGqBin5YmS234YH2HYL742sPvhMNh2VfgrO3N8KSUlSELv2MhMu/OkybJDzU2c7S0k0QbFTEsZ6kfKA7KagNvvYAgwg2YFBgSvG1R103UnNSDW3NjdIfjzqzvhrBYj7YGugf/fWK/PAvw5LO5aXaDnd1FBbJ8JgN1WQ62NdTs/LUS0Nys0qj9L0Mj0/Jk97P8LXHjhauoFj93+WKOgkW08Gudajv9sJrlwqrus4+Yn/tugb63CuvyvnLV6XW4t57fryvRx5/cLd89tBAYAJuNtgaJFdCvUZ/Jt0lpfffxUh7txETmazklsrbYqgYO6OtstOxhv+l0Nuv3755vXD94spVefGTHyrs17fObLDPXx5Z99oO79tb92nHq7AO+qZ3G/DeESvlfcgueD9XMaP2qPff61UrGohbsxk56M0RNBhZl33x5i058/Nfy9DnP1P0l6tfmQz28NjUutFa2yX96nOnq9reJ97U5E3cDb/rNd1htlmwc0tLNQ31mmx+UW574e41NMLdTM/JV73bhB8/eUosMxns1D1mv3V2uto9u3Sy7L3BvuxNpm1mIjMvrtBbgVKCrfe2ffHa954b9YL83km833lluY7eeu9tlclg3+tZdS1Kr1L/n7W4py4nnaD61keOy9c/fFxqTUfop382VAj4Gg36K164LQeblWcwTauGFz+1vgPMv9NuTayWG8GGefe6lUjncmIZwXZQqD5oyylQbgTbQc2hkLiiyaGfBcUj2A7qjLY6E6gHOhIC/yHYDtIFIQeTnYVHRjX7GerqZP/OdmlqYMT2IzqoOEoDpeHWR1+55SWppoa6emnl0DtfI9iO04AzamKrKMUBgwg2YBDBBgwi2IBBTJ45TLdv6p7o5ZUVqaaQ97hN96y3tzQL/IlgO2piLiv/ujMjtaL7sHtiEdnNUTq+RCnuIB2paxnqNVot6AX/IdgOcqnRwqRXOcB/CLaDXGq0sLRa3ft7lAfBBgwi2IBBJoM92NW+7jXtg1btkymGRq6ve60/AD2tUXsmH3dpQ3g9dePubqXa9veZoT/K2YcPV6WxoX6RfOP3f173unZL3Uwk3CAT4gYaLfiTyWBrcAeTHfKaF+a7Xbh8tXDV0tlHDm3672ijBX3MlFuu/SSanggC/zF7j/290ycLJ3+45MzgQFGl+FqjhVqOltpoQRenWDjmJ4jMrjzTAD1/6lH5sld+u3Dq4/u9+/5vf7z4Ptu6B/vIrmShm2YtHn8lWprNHO0TRKaXlP53hIwWwl2LyTOl/Ub1vv7cY0e8W4StnxmmxwRJ5Y8agzHm14rrgfN/+9LThUP6fuPNUuuE2o0qnMKpM/N93pfKE/v3cOg9qi4wm0DODO4vXEAQcBMFGESwAYMINmAQwQYMItiAQQQbMIhgAwYRbMCgwCxQWVpZken5BcHmtP2wbh1taqCJrV8F4jd3Oz0no+lZL9wubAfxj962WOGC/5gvxdMLObk2kybUJRhNzRbeP/iP+WDrhxOl4/3zJ/PBdqELiZ/x/vkTs+KwL4B3YQQbpmmmL968te71QgMLw3iegYpYldoPlOn5nFyZmJLn/nBx3T873tstlpkPtjYEdOnIHL9pqNt6UaeBPvfKq3K+xh1h76euTuTxgT1imflSnPa529Mdj4gl2oPui0cOSW88KpbZD3akVbpjtj6c1aLvnaX2wxrqg10d8s2PFt8t1q8CcY+9J9Em7a3Ncie7IMsrnB65GV1S2t7SLPFmOxNMWn7rSP2VDx6VIAjM5JnOglqfCXVJvKlR+hwodw9qt9h4TD7x4G453hecbrF14rDJmRTrQH0qt7QqSzZ/e6srK6vP7U0mnhWH8RwbMIhgAwYRbMCgQK08y+QXmRUvkqUZ8SAKRLB1T/HI5B32ZG+Bnvapx+jqYy/4j/1tm0tL8o/xKUK9RboMd2TiDo0WfIpGC9gQ758/mQ92ZnFRUDoaLfiT+WAvU4IjgHjcBRhEsAGDzAdbGy2gdKU0WkDtmf+tsdBiexKtPMf2I/PB1pMsEi2EuxSt4TAngfhUIFaeHdjZIROZrExnFwpneGFjDfX1XqXTKN0x2+2DLAvMWnFrbX58wOpzRhcasG6K9sOohNXm0OoXOhKJnwpqgilPwCCCDRhEsAGDAnWPrTPiNFrYnLYf1plx+Fcggp3NL8q16ZSkc3lBcVobw3KgMyFNDcyv+lFAGi1MEuot0i/Dv9+eLLx/8J9ANFqge0pp9Lbl2nRa4D80WsCGsrx/vkSjBcAgpj4Bgwg2YJD5YIfqnT530Hk0WvAn87+19pYWQen0eTb8x3ywu2MR2iOVSN83Gi34k/llRbo0crBnp9yezcid7LwsrzJLXgzdu65fiiwt9adArBfUD6eOPIw+CAq+jgGDCDZgEMEGDCLYgEEEGzCIYAMGEWzAIIINGESwAYMINmAQwQYMItiAQQQbMIhgAwYRbMAg1/dj0xXBn3xxODwAAAAAAAAAAAAAAKiO/wDCG0Rnji+bbgAAAABJRU5ErkJggg=="

/***/ }),
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(969)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(609),
  /* template */
  __webpack_require__(2096),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-000ad58c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1066)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(610),
  /* template */
  __webpack_require__(2194),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ab4dee36",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1011)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(611),
  /* template */
  __webpack_require__(2140),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ebb120d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1040)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(612),
  /* template */
  __webpack_require__(2169),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-70adab28",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(989)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(613),
  /* template */
  __webpack_require__(2118),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-234f5326",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1020)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(614),
  /* template */
  __webpack_require__(2149),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5512c772",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1050)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(620),
  /* template */
  __webpack_require__(2178),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1082)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(621),
  /* template */
  __webpack_require__(2209),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f008ecf4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1076)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(2203),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cea242e2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(972)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(624),
  /* template */
  __webpack_require__(2098),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05d50302",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1084)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(627),
  /* template */
  __webpack_require__(2211),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f4b1c7c0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1005)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(628),
  /* template */
  __webpack_require__(2134),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3077f53f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1019)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(629),
  /* template */
  __webpack_require__(2148),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51ce0a00",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(631),
  /* template */
  __webpack_require__(2121),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1008)
  __webpack_require__(1009)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(632),
  /* template */
  __webpack_require__(2138),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-38b7284d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1053)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(2181),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7b0451dd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1007)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(2137),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-386f3b9c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1062)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(2190),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-90117f44",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1083)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(2210),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f439cefa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1030)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(639),
  /* template */
  __webpack_require__(2159),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-60ca2df8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1063)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(2191),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-94c12a3e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1016)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(2145),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4bc3d7cf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1035)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(2164),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67fd5541",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(991)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(2120),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23e527fc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1046)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(2174),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-758cef37",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1085)
  __webpack_require__(1086)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(2212),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fe4b5f1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1039)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(2168),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6fe2335e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1004)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(2133),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3003dfee",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1024)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(2153),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-574c4220",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(979)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(2106),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-12c26dad",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(990)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(2119),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23d6c09b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1034)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(2163),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-65c9b9be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1033)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(2162),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6500557e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(2116),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(973)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(2099),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06de54f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(977)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(655),
  /* template */
  __webpack_require__(2104),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1133b622",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1072)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(2199),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bfd44448",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1056)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(657),
  /* template */
  __webpack_require__(2184),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-811081a8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1078)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(658),
  /* template */
  __webpack_require__(2205),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d059d964",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1002)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(2131),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e49c9b3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(970)
  __webpack_require__(971)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(660),
  /* template */
  __webpack_require__(2097),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-005fb977",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1059)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(661),
  /* template */
  __webpack_require__(2187),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8774f0be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1021)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(2150),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5536ce2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(980)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(663),
  /* template */
  __webpack_require__(2107),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-12dc227c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1079)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(664),
  /* template */
  __webpack_require__(2206),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d6e1d476",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1001)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(665),
  /* template */
  __webpack_require__(2130),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d2361e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1017)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(668),
  /* template */
  __webpack_require__(2146),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e9ef906",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1032)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(669),
  /* template */
  __webpack_require__(2161),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-643fc728",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(999)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(670),
  /* template */
  __webpack_require__(2128),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-292ebcf5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1058)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(2186),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-83662f16",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1010)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(672),
  /* template */
  __webpack_require__(2139),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-393a6e04",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1043)
  __webpack_require__(1044)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(673),
  /* template */
  __webpack_require__(2172),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7364621b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(985)
  __webpack_require__(986)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(674),
  /* template */
  __webpack_require__(2114),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21998ed0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1080)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(675),
  /* template */
  __webpack_require__(2207),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e4a7edc0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1057)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(676),
  /* template */
  __webpack_require__(2185),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-811c3f2c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(677),
  /* template */
  __webpack_require__(2103),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1074)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(678),
  /* template */
  __webpack_require__(2201),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c46462e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1069)
  __webpack_require__(1070)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(679),
  /* template */
  __webpack_require__(2197),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-baabd36c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1065)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(684),
  /* template */
  __webpack_require__(2193),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-aae0c29a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(997)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(685),
  /* template */
  __webpack_require__(2126),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-27e77d4d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(996)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(687),
  /* template */
  __webpack_require__(2125),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-27aef95b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1018)
}
var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(2147),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-506ae95e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1038)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(688),
  /* template */
  __webpack_require__(2167),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6fb5f872",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1013)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(689),
  /* template */
  __webpack_require__(2142),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42320436",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1073)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(690),
  /* template */
  __webpack_require__(2200),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c4438b84",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(998)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(691),
  /* template */
  __webpack_require__(2127),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2801cb1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1077)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(692),
  /* template */
  __webpack_require__(2204),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d03fd344",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1022)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(693),
  /* template */
  __webpack_require__(2151),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5579e375",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1055)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(694),
  /* template */
  __webpack_require__(2183),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7c21f096",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(695),
  /* template */
  __webpack_require__(2108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1025)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(700),
  /* template */
  __webpack_require__(2154),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57d06472",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1064)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(701),
  /* template */
  __webpack_require__(2192),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-95985f14",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1003)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(702),
  /* template */
  __webpack_require__(2132),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ff11ca8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(983)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(705),
  /* template */
  __webpack_require__(2111),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1aca2a74",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(988)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(706),
  /* template */
  __webpack_require__(2117),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23453074",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1071)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(709),
  /* template */
  __webpack_require__(2198),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-baae763c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1047)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(712),
  /* template */
  __webpack_require__(2175),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-76da9d64",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1041)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(713),
  /* template */
  __webpack_require__(2170),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-70f45beb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1028)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(716),
  /* template */
  __webpack_require__(2157),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5df7ad52",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1042)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(717),
  /* template */
  __webpack_require__(2171),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-711db862",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1068)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(719),
  /* template */
  __webpack_require__(2196),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ba6abf74",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1045)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(2173),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2096 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isSuccessModalVisible) ? _c('success', {
    attrs: {
      "closeAction": _vm.creationSucceeded ? _vm.goToFundingSources : null
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSuggestedAddressModalVisible) ? _c('address-suggestion') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.disableSubmit) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('onboarding-wizard', {
    attrs: {
      "userStatus": _vm.userStatus
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateAndSubmitUserProfile($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("First name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('FirstName')
    },
    attrs: {
      "type": "text",
      "name": "FirstName",
      "id": "FirstName",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('FirstName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Last name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('LastName')
    },
    attrs: {
      "type": "text",
      "name": "LastName",
      "id": "LastName",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('LastName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "date-time-input"
    }
  }, [_vm._v("Date of birth*")]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-group date birth-field-bottom"
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.isBirthFieldInvalid
    },
    attrs: {
      "placeholder": "mm/dd/yyyy",
      "id": "date-time-input",
      "name": "date-time-input",
      "wrap": true,
      "config": _vm.dateBirthConfig
    },
    nativeOn: {
      "blur": function($event) {
        _vm.checkDateBirth(_vm.user.dateOfBirth)
      }
    },
    model: {
      value: (_vm.user.dateOfBirth),
      callback: function($$v) {
        _vm.user.dateOfBirth = $$v
      },
      expression: "user.dateOfBirth"
    }
  }), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), (_vm.isBirthFieldInvalid) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ssn"
    }
  }, [_vm._v("Social security number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.socialSecurityNum),
      expression: "user.socialSecurityNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('***-**-9999'),
      expression: "'***-**-9999'"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('ssn')
    },
    attrs: {
      "type": "text",
      "name": "ssn",
      "id": "ssn",
      "placeholder": "000-00-0000",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.user.socialSecurityNum)
    },
    on: {
      "click": function($event) {
        _vm.user.socialSecurityNum = ''
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.user.socialSecurityNum = $event.target.value
      }, _vm.ssnInput]
    }
  }), _vm._v(" "), (_vm.errors.has('ssn')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('ssn')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "primaryPhoneNum"
    }
  }, [_vm._v("Primary phone number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.primaryPhoneNum),
      expression: "user.primaryPhoneNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('primaryPhoneNum')
    },
    attrs: {
      "type": "text",
      "id": "primaryPhoneNum",
      "name": "primaryPhoneNum",
      "placeholder": "Phone number"
    },
    domProps: {
      "value": (_vm.user.primaryPhoneNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.primaryPhoneNum = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('primaryPhoneNum')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ssn"
    }
  }, [_vm._v("Secondary phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.secondaryPhoneNum),
      expression: "user.secondaryPhoneNum"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "spn"
    },
    domProps: {
      "value": (_vm.user.secondaryPhoneNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.secondaryPhoneNum = $event.target.value
      }
    }
  })])])]), _vm._v(" "), (_vm.user.residentialAddress && _vm.user.mailingAddress) ? _c('addresses-form', {
    key: 1,
    ref: "addresses",
    attrs: {
      "firstTitle": 'Residential Address',
      "residentialAddress": _vm.user.residentialAddress,
      "secondTitle": 'Mailing Address',
      "mailingAddress": _vm.user.mailingAddress
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreeTerms),
      expression: "agreeTerms"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "agreeTerms"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreeTerms) ? _vm._i(_vm.agreeTerms, "") > -1 : (_vm.agreeTerms)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.agreeTerms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreeTerms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.agreeTerms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreeTerms = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), _c('terms-of-conditions')], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitButton()
    }
  }, [_vm._v("Submit")])])]), _vm._v(" "), (_vm.hasValidationErrors) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(3)]) : _vm._e()], 1)])], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Personal information\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading top-margin"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n              Personal Information\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "validation-error-message"
  }, [_vm._v("\n                  Please see errors above\n                ")])])
}]}

/***/ }),
/* 2097 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    attrs: {
      "align": "center"
    }
  }, [_c('ContactUsHeader'), _vm._v(" "), (_vm.loadingRedirection) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isSuccessModalVisible) ? _c('success') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-center mt-xl wd-xl"
  }, [_c('div', {
    staticClass: "panel panel-dark panel-flat"
  }, [(_vm.loginStep === 'login' && !_vm.needsMfa) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "text-center login-intro-desktop"
  }, [_vm._v("\n          Log in to your account below |\n          "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Registration'
      }
    }
  }, [_vm._v("First time user?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "login-intro-mobile"
  }, [_c('p', {
    staticClass: "text-center login-intro-main"
  }, [_vm._v("Log in to your account below")]), _vm._v(" "), _c('p', {
    staticClass: "text-center login-intro-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Registration'
      }
    }
  }, [_vm._v("First time user?")])], 1)]), _vm._v(" "), (_vm.migrationNeeded) ? _c('div', {
    staticClass: "alert alert-info text-center"
  }, [_vm._v("\n          We've updated our system. Please\n          "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ResetPassword'
      }
    }
  }, [_vm._v("Reset Password")]), _vm._v("\n          to access your account.\n        ")], 1) : _vm._e(), _vm._v(" "), _c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.otherErrors))])]), _vm._v(" "), (_vm.isUserIdle) ? _c('p', [_c('strong', {
    staticClass: "text-red"
  }, [_vm._v("You have been logged out of your account due to\n            inactivity.")])]) : _vm._e(), _vm._v(" "), (_vm.fromPasswordResetEmail) ? _c('p', [_c('strong', {
    staticClass: "text-success"
  }, [_vm._v("Your password has been reset\n            successfully.")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleLoginSubmit()
      }
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.emailError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.computedEmail),
      expression: "computedEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "signupInputEmail1",
      "type": "email",
      "placeholder": "Enter email",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.computedEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.computedEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "form-icon icon-envelope"
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock2"
    }
  }, [_vm._v(_vm._s(_vm.emailError))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.passwordError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "signupInputPassword1",
      "type": "password",
      "placeholder": "Password",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "form-icon icon-lock"
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock4"
    }
  }, [_vm._v(_vm._s(_vm.passwordError))])]), _vm._v(" "), _c('div', {
    staticClass: "remember-forgot-container"
  }, [_c('div', {
    staticClass: "checkbox c-checkbox mt0"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "rememberMe"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, "") > -1 : (_vm.rememberMe)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "name": "check"
    }
  })], 1), _vm._v("Remember Me")])]), _vm._v(" "), _c('div', {
    staticClass: "forgot-password-link"
  }, [_c('router-link', {
    staticClass: "text-muted",
    attrs: {
      "to": {
        name: 'ResetPassword'
      }
    }
  }, [_vm._v("Forgot your password?")])], 1)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default btn-lg mt-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.submittedForm || _vm.loadingMfaOptions
    }
  }, [_vm._v("\n            " + _vm._s(_vm.loadingMfaOptions ? 'Loading...' : 'Log in') + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.loginError
    }
  }, [_c('strong', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock6"
    }
  }, [_vm._v(_vm._s(_vm.loginError))])])])]) : _vm._e(), _vm._v(" "), (_vm.loginStep === 'method') ? _c('div', {
    staticClass: "panel-body"
  }, [_vm._m(0), _vm._v(" "), _c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.otherErrors))])]), _vm._v(" "), _c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleMethodSubmit()
      }
    }
  }, [_c('div', {
    staticClass: "method-selector mb-lg"
  }, [(_vm.mfaOptions && _vm.mfaOptions.emailAvailable) ? _c('label', {
    staticClass: "method-option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMethod),
      expression: "selectedMethod"
    }],
    attrs: {
      "type": "radio",
      "name": "method",
      "value": "EMAIL"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedMethod, "EMAIL")
    },
    on: {
      "__c": function($event) {
        _vm.selectedMethod = "EMAIL"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "method-text"
  }, [_c('strong', [_vm._v("Email")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Send code to " + _vm._s(_vm.mfaOptions.email))])])]) : _vm._e(), _vm._v(" "), (_vm.mfaOptions && _vm.mfaOptions.smsAvailable) ? _c('label', {
    staticClass: "method-option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMethod),
      expression: "selectedMethod"
    }],
    attrs: {
      "type": "radio",
      "name": "method",
      "value": "SMS"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedMethod, "SMS")
    },
    on: {
      "__c": function($event) {
        _vm.selectedMethod = "SMS"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "method-text"
  }, [_c('strong', [_vm._v("Text Message")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Send code to " + _vm._s(_vm.mfaOptions.mfaPhonePreference === 'SECONDARY' ? _vm.mfaOptions.secondaryPhone : _vm.mfaOptions.phone))])])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default btn-lg mt-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.submittedForm
    }
  }, [_vm._v("\n            " + _vm._s(_vm.submittedForm ? 'Sending...' : 'Send Code') + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "pt-lg text-center border-top mt-lg"
  }, [_c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.backToLogin
    }
  }, [_vm._v("Back")])])])]) : _vm._e(), _vm._v(" "), (_vm.loginStep === 'code' && _vm.needsMfa) ? _c('div', {
    staticClass: "panel-body"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n          Code sent to "), _c('strong', [_vm._v(_vm._s(_vm.sentTo))]), _vm._v(" via " + _vm._s(_vm.selectedMethod === 'SMS' ? 'text message' : 'email') + "\n        ")]), _vm._v(" "), _c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.otherErrors))])]), _vm._v(" "), _c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.confirmCognitoMfaCode()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mfaCode),
      expression: "mfaCode"
    }],
    staticClass: "form-control code-input",
    attrs: {
      "id": "mfaCode",
      "type": "text",
      "placeholder": "Enter code",
      "autocomplete": "off",
      "required": "",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.mfaCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mfaCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default btn-lg mt-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.submittedMfa || _vm.mfaCode.length !== 6
    }
  }, [_vm._v("\n            " + _vm._s(_vm.submittedMfa ? 'Verifying...' : 'Verify') + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "resend-options"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Didn't receive the code?")]), _vm._v(" "), (_vm.selectedMethod === 'EMAIL' && _vm.mfaOptions && _vm.mfaOptions.smsAvailable) ? _c('button', {
    staticClass: "link-button",
    attrs: {
      "type": "button",
      "disabled": _vm.submittedMfa
    },
    on: {
      "click": function($event) {
        _vm.resendWithDifferentMethod('SMS')
      }
    }
  }, [_vm._v("\n            Send via text message instead\n          ")]) : _vm._e(), _vm._v(" "), (_vm.selectedMethod === 'SMS' && _vm.mfaOptions && _vm.mfaOptions.emailAvailable) ? _c('button', {
    staticClass: "link-button",
    attrs: {
      "type": "button",
      "disabled": _vm.submittedMfa
    },
    on: {
      "click": function($event) {
        _vm.resendWithDifferentMethod('EMAIL')
      }
    }
  }, [_vm._v("\n            Send via email instead\n          ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "link-button",
    attrs: {
      "type": "button",
      "disabled": _vm.submittedMfa
    },
    on: {
      "click": function($event) {
        _vm.resendCurrentMethod()
      }
    }
  }, [_vm._v("\n            Resend code\n          ")])]), _vm._v(" "), _c('p', {
    staticClass: "pt-lg text-center border-top mt-lg"
  }, [_c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.backToMethodSelection
    }
  }, [_vm._v("Back")])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center pv"
  }, [_c('strong', [_vm._v("Choose verification method")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center pv"
  }, [_c('strong', [_vm._v("Enter verification code")])])
}]}

/***/ }),
/* 2098 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 top-margin"
  }, [_c('RestrictedTwoInputs', {
    attrs: {
      "fieldLabel": _vm.streetAddressLabel,
      "id": "ResidentialAddress",
      "instructionsLabel": "Make sure your address doesn't exceed 50 characters.",
      "primaryPlaceholder": "Street and number e.g. 123 Any Street",
      "secondaryPlaceholder": "(optional) Apartment, building, floor, etc.",
      "dual": true,
      "isDisabled": _vm.disabled,
      "primaryInput": _vm.addressO.streetAddress1,
      "secondaryInput": _vm.addressO.streetAddress2,
      "isFirstInputRequired": true
    },
    on: {
      "inputUpdated": _vm.residentialAddressUpdated
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressO.zipCode),
      expression: "addressO.zipCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('zipCode') && !_vm.disabled && _vm.isZipCodeInvalid(_vm.addressO.zipCode)
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "name": "zipCode",
      "id": "zipCode",
      "placeholder": "Zip code"
    },
    domProps: {
      "value": (_vm.addressO.zipCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressO.zipCode = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('zipCode') || _vm.isZipCodeInvalid(_vm.addressO.zipCode) && !_vm.disabled) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    class: {
      'col-md-6': !_vm.isAdmin, 'col-md-3': _vm.isAdmin
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressO.city),
      expression: "addressO.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('city') && !_vm.disabled
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "name": "city",
      "id": "city",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.addressO.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addressO.city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('city') && !_vm.disabled) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressO.state),
      expression: "addressO.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('state') && !_vm.disabled
    },
    attrs: {
      "disabled": _vm.disabled,
      "id": "state",
      "name": "state",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addressO.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _vm._l((_vm.countryStates), function(state, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": state.abbreviation
      }
    }, [_vm._v(_vm._s(state.name))])
  })], 2), _vm._v(" "), (_vm.errors.has('state') && !_vm.disabled) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addressO.country),
      expression: "addressO.country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('country') && !_vm.disabled
    },
    attrs: {
      "disabled": _vm.disabled,
      "id": "state",
      "name": "state",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addressO.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _vm._l((_vm.countries), function(country, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": country.abbreviation
      }
    }, [_vm._v(_vm._s(country.name))])
  })], 2), _vm._v(" "), (_vm.errors.has('country') && !_vm.disabled) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "zip-code"
    }
  }, [_vm._v("Zip code "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("State "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("Country "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "aside"
  }, [_c('div', {
    staticClass: "aside-inner"
  }, [_c('nav', {
    staticClass: "sidebar",
    attrs: {
      "data-sidebar-anyclick-close": ""
    }
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "has-user-block"
  }, [_c('div', {
    staticClass: "collapse in",
    attrs: {
      "id": "user-block"
    }
  }, [_c('div', {
    staticClass: "item user-block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "user-block-info"
  }, [_c('span', {
    staticClass: "user-block-name"
  }, [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))]), _vm._v(" "), _c('span', {
    staticClass: "user-block-role"
  }, [_vm._v("IR Admin")])])])])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.$route.name === 'Users'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Users'
      },
      "title": "all users",
      "replace": ""
    }
  }, [_c('em', {
    staticClass: "icon-people"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.ACCOUNT"
    }
  }, [_vm._v("All Users")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.$route.name === 'FailedTransactionList'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'FailedTransactionList'
      },
      "title": "trasactions",
      "replace": ""
    }
  }, [_c('em', {
    staticClass: "icon-dislike"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Cancelled/Failed Transactions")])])], 1), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.downloadImpactPreferencesReport
    }
  }, [_c('em', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('span', [_vm._v("Export Impact Preferences Report")])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.downloadMonthlyMaturitiesReport
    }
  }, [_c('em', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('span', [_vm._v("Export Monthly Maturities Report")])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.downloadDocumentViewsReport
    }
  }, [_c('em', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('span', [_vm._v("Export Document Views Report")])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.downloadFeedbackReport
    }
  }, [_c('em', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('span', [_vm._v("Export Feedback Report")])])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.$route.name === 'AdminSettings'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'AdminSettings'
      },
      "title": "settings",
      "replace": ""
    }
  }, [_c('em', {
    staticClass: "fa fa-gear"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Settings")])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-block-picture"
  }, [_c('div', {
    staticClass: "user-block-status"
  }, [_c('img', {
    staticClass: "img-thumbnail img-circle",
    attrs: {
      "src": __webpack_require__(231),
      "alt": "Avatar",
      "width": "60",
      "height": "60"
    }
  })])])
}]}

/***/ }),
/* 2100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.mainContainerClass
  }, [(!_vm.customRateAndTermCheckbox && !_vm.loading) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rateTermSelected),
      expression: "rateTermSelected"
    }],
    staticClass: "form-control input-md",
    attrs: {
      "name": "iry",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rateTermSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setRateAndTerm]
    }
  }, [(_vm.showDefaultValue) ? _c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select rate and term")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.ratesAndTerms), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.customRateAndTermCheckbox && !_vm.loading) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 padding-right-0"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.editedRate),
      expression: "editedRate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control text-right': true, 'form-control-error': !_vm.isAValidRate()
    },
    attrs: {
      "type": "text",
      "name": "editedRate",
      "id": "customRate",
      "placeholder": "",
      "aria-describedby": "basic-addon2"
    },
    domProps: {
      "value": (_vm.editedRate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editedRate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    }
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 padding-right-0"
  }, [_c('div', {
    staticClass: "form-group margin-0"
  }, [_c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.editedTerm),
      expression: "editedTerm"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control margin-0 text-right': true, 'form-control-error': !_vm.isAValidTerm()
    },
    attrs: {
      "type": "text",
      "name": "editedTerm",
      "id": "custom-term-input",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.editedTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editedTerm = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 padding-right-0"
  }, [(!_vm.isAValidRate()) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("\n              " + _vm._s(this.rateErrorMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 padding-right-0 term-error-message"
  }, [(!_vm.isAValidTerm()) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("\n              " + _vm._s(this.termErrorMessage) + "\n            ")]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customRateAndTermCheckbox),
      expression: "customRateAndTermCheckbox"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.customRateAndTermCheckbox) ? _vm._i(_vm.customRateAndTermCheckbox, null) > -1 : (_vm.customRateAndTermCheckbox)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.customRateAndTermCheckbox,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.customRateAndTermCheckbox = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.customRateAndTermCheckbox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.customRateAndTermCheckbox = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n            Add a custom rate and term\n          ")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 padding-right-0"
  }, [_c('div', {
    staticClass: "form-group margin-0"
  }, [_c('span', [_vm._v("Years")])])])
}]}

/***/ }),
/* 2101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animationload",
    class: {
      'animationload-inline': _vm.inline
    }
  }, [_c('div', {
    staticClass: "osahanloading"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "loading-text"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.userStatus && _vm.wizardStep !== 'done') ? _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "wizard clearfix",
    attrs: {
      "role": "application",
      "id": "steps-uid-0"
    }
  }, [_c('div', {
    staticClass: "steps clearfix"
  }, [_c('ul', {
    staticClass: "onboarding",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "first",
    class: {
      disabled: _vm.wizardStep !== 'personalInformation', current: _vm.wizardStep === 'personalInformation'
    },
    attrs: {
      "role": "tab",
      "aria-disabled": "false",
      "aria-selected": "true"
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.wizardStep !== 'addFundingSource', current: _vm.wizardStep === 'addFundingSource'
    },
    attrs: {
      "role": "tab",
      "aria-disabled": "true"
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('li', {
    staticClass: "last",
    class: {
      disabled: _vm.wizardStep !== 'firstInvestment', current: _vm.wizardStep === 'firstInvestment'
    },
    attrs: {
      "role": "tab",
      "aria-disabled": "true"
    }
  }, [_vm._m(2)])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "steps-uid-0-t-0",
      "aria-controls": "steps-uid-0-p-0"
    }
  }, [_c('span', {
    staticClass: "current-info audible"
  }, [_vm._v("current step: ")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v("1.")]), _vm._v(" Personal information\n            "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Add your personal information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "steps-uid-0-t-1",
      "aria-controls": "steps-uid-0-p-1"
    }
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("2.")]), _vm._v(" Bank account\n            "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Add a bank account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "steps-uid-0-t-2",
      "aria-controls": "steps-uid-0-p-2"
    }
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("3.")]), _vm._v(" Investments\n            "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Make your first investment")])])
}]}

/***/ }),
/* 2103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n    " + _vm._s(_vm.resultsLength) + " results found for \""), _c('b', [_vm._v(_vm._s(_vm.searchMessage))]), _vm._v("\"\n  ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped bank-accounts table-fundings"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("First name")]), _vm._v(" "), _c('th', [_vm._v("Last name")]), _vm._v(" "), (_vm.showCompanyNames) ? _c('th', [_vm._v("Company name 1")]) : _vm._e(), _vm._v(" "), (_vm.showCompanyNames) ? _c('th', [_vm._v("Company name 2")]) : _vm._e(), _vm._v(" "), (!_vm.showCompanyNames) ? _c('th', [_vm._v("Account name")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.investors), function(investor) {
    return [_vm._l((investor.accounts), function(account, index) {
      return _c('tr', {
        key: (index + "-account-" + (account.accountId))
      }, [_c('td', [_vm._v(_vm._s(investor.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(investor.lastName))]), _vm._v(" "), (_vm.showCompanyNames) ? _c('td', [_vm._v(_vm._s(account.organizationName || '---'))]) : _vm._e(), _vm._v(" "), (_vm.showCompanyNames) ? _c('td', [_vm._v(_vm._s(account.alternateCompanyName || '---'))]) : _vm._e(), _vm._v(" "), (!_vm.showCompanyNames) ? _c('td', [_vm._v(_vm._s(account.accountName))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(investor.email))]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-details btn-outline",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.goToViewDetail(investor.id, investor.userType, investor.firstName)
          }
        }
      }, [_vm._v("View details")])])])
    }), _vm._v(" "), (!investor.accounts || investor.accounts.length === 0) ? _c('tr', {
      key: investor.id
    }, [_c('td', [_vm._v(_vm._s(investor.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(investor.lastName))]), _vm._v(" "), (_vm.showCompanyNames) ? _c('td', [_vm._v("---")]) : _vm._e(), _vm._v(" "), (_vm.showCompanyNames) ? _c('td', [_vm._v("---")]) : _vm._e(), _vm._v(" "), (!_vm.showCompanyNames) ? _c('td', [_vm._v("---")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(investor.email))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(investor.id, investor.userType, investor.firstName)
        }
      }
    }, [_vm._v("View details")])])]) : _vm._e()]
  }), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _vm._l((account.users), function(user, index) {
      return _c('tr', {
        key: (index + "-user-" + (user.userId))
      }, [_c('td', [_vm._v(_vm._s(user.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.lastName))]), _vm._v(" "), (_vm.showCompanyNames) ? _c('td', [_vm._v(_vm._s(account.organizationName || '---'))]) : _vm._e(), _vm._v(" "), (_vm.showCompanyNames) ? _c('td', [_vm._v(_vm._s(account.alternateCompanyName || '---'))]) : _vm._e(), _vm._v(" "), (!_vm.showCompanyNames) ? _c('td', [_vm._v(_vm._s(account.accountName))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-details btn-outline",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.goToViewDetail(user.id, user.userType, user.firstName)
          }
        }
      }, [_vm._v("View details")])])])
    })
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 2104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper content-wrapper-banner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel b text-white banner-width"
  }, [_c('div', {
    staticClass: "panel-body bg-cover clearfix"
  }, [_c('div', {
    staticClass: "media mt0"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-thumbnail img-circle thumb45",
    attrs: {
      "src": _vm.getAccountImgUrl(_vm.activeAccount.accountType),
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body media-middle"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('p', {
    staticClass: "information-title"
  }, [_vm._v(_vm._s(_vm.accountType) + " account")]), _vm._v(" "), _c('h4', {
    staticClass: "media-heading m0"
  }, [_vm._v(_vm._s(_vm.activeAccount.accountName))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper content-wrapper-container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Account information\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-flex"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Account name")]), _vm._v(" "), _c('label', {
    staticClass: "value-label",
    attrs: {
      "id": "account-name"
    }
  }, [_vm._v(_vm._s(_vm.activeAccount.accountName))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-flex"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Account ID")]), _vm._v(" "), _c('label', {
    staticClass: "value-label",
    attrs: {
      "id": "account-id"
    }
  }, [_vm._v(_vm._s(_vm.accountId))])])]), _vm._v(" "), (_vm.isAdvisor) ? _c('div', {
    attrs: {
      "id": "advisor-info-container"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-flex"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Organization name")]), _vm._v(" "), _c('label', {
    staticClass: "value-label",
    attrs: {
      "id": "account-id"
    }
  }, [_vm._v(_vm._s(_vm.organizationName))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-flex"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Optional organization name")]), _vm._v(" "), _c('label', {
    staticClass: "value-label",
    attrs: {
      "id": "account-id"
    }
  }, [_vm._v(_vm._s(_vm.alternateCompanyName))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 empty-container"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "form-group form-flex"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("CRD number")]), _vm._v(" "), _c('label', {
    staticClass: "value-label",
    attrs: {
      "id": "account-id"
    }
  }, [_vm._v(_vm._s(_vm.crdNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])]) : _vm._e()]), _vm._v(" "), (_vm.isInstitution || _vm.isTrust) ? _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-flex"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('label', {
    staticClass: "value-label",
    attrs: {
      "id": "account-id"
    }
  }, [_vm._v(_vm._s(_vm.formatPhoneNumber(_vm.phoneNumber)))])])])]) : _vm._e(), _vm._v(" "), (!_vm.isAdvisor) ? _c('div', {
    attrs: {
      "id": "users-container"
    }
  }, [_c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n                Authorized representatives\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive bottom-margin",
    class: {
      'table-fixed-header--md cols-9': _vm.representatives.length > 6
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.representatives), function(representative, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(representative.firstName) + " " + _vm._s(representative.lastName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.getUserTypeLabel(representative.userType)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(representative.userType !== 'ADVISOR' && representative.id === _vm.accountPrimaryInvestorId) ? _c('div', {
      class: {
        'radio-item': true, 'radio-item-unselected': representative.id !== _vm.accountPrimaryInvestorId
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "readonly": ""
      },
      domProps: {
        "value": true
      }
    }), _vm._v(" "), _c('label')]) : _vm._e()])])
  }))])])]) : _vm._e(), _vm._v(" "), (!_vm.isInstitution) ? _c('div', {
    attrs: {
      "id": "users-container"
    }
  }, [_c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n                Beneficiary Information\n              ")]), _vm._v(" "), (_vm.beneficiaries.length > 0) ? _c('div', {
    staticClass: "table-responsive bottom-margin",
    class: {
      'table-fixed-header--md cols-9': _vm.beneficiaries.length > 6
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.beneficiaries), function(beneficiary, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(beneficiary.beneficiaryName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(beneficiary.percentage) + "%")])])
  }))])]) : _c('div', [_vm._m(3)])]) : _vm._e(), _vm._v(" "), (_vm.isInstitution || _vm.isTrust) ? _c('div', [_c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            " + _vm._s(_vm.accountType) + " Address\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-flex"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Street Address")]), _vm._v(" "), _c('label', {
    staticClass: "value-label",
    attrs: {
      "id": "residentail-addressa"
    }
  }, [_vm._v(_vm._s(_vm.mainAddress.streetAddress1))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group form-flex"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Zip code")]), _vm._v(" "), _c('label', {
    staticClass: "value-label",
    attrs: {
      "id": "residentail-zipCode"
    }
  }, [_vm._v(_vm._s(_vm.mainAddress.zipCode))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group form-flex"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("City")]), _vm._v(" "), _c('label', {
    staticClass: "value-label",
    attrs: {
      "id": "residentail-Address"
    }
  }, [_vm._v(_vm._s(_vm.mainAddress.city))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group form-flex"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("State")]), _vm._v(" "), _c('label', {
    staticClass: "value-label",
    attrs: {
      "id": "residentail-State"
    }
  }, [_vm._v(_vm._s(_vm.getStateFullName(_vm.mainAddress.state)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Mailing Address\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-flex"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Street Address")]), _vm._v(" "), _c('label', {
    staticClass: "value-label",
    attrs: {
      "id": "mailing-address"
    }
  }, [_vm._v(_vm._s(_vm.mailingAddress.streetAddress1))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group form-flex"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Zip code")]), _vm._v(" "), _c('label', {
    staticClass: "value-label",
    attrs: {
      "id": "mailing-zipCode"
    }
  }, [_vm._v(_vm._s(_vm.mailingAddress.zipCode))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group form-flex"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("City")]), _vm._v(" "), _c('label', {
    staticClass: "value-label",
    attrs: {
      "id": "mailing-City"
    }
  }, [_vm._v(_vm._s(_vm.mailingAddress.city))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group form-flex"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("State")]), _vm._v(" "), _c('label', {
    staticClass: "value-label",
    attrs: {
      "id": "mailing-State"
    }
  }, [_vm._v(_vm._s(_vm.getStateFullName(_vm.mailingAddress.state)))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _vm._m(4)])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Account details\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Primary investor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Percentage")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v("No beneficiaries found.")]), _vm._v(" "), _c('p', [_vm._v("Go to "), _c('a', {
    staticClass: "alert-link",
    attrs: {
      "href": "https://calvertimpact.org/beneficiary",
      "target": "_blank"
    }
  }, [_vm._v("calvertimpact.org/beneficiary")]), _vm._v(" and follow the instructions to request beneficiaries to be added.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-notice"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    staticClass: "information-message"
  }, [_vm._v("Please contact us at info@calvertimpact.org if you have any account questions or changes.")])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    staticClass: "information-message"
  }, [_vm._v("Calvert Impact staff will never have access to or ask you for your password. You can reset your password anytime at "), _c('a', {
    attrs: {
      "href": "https://invest.calvertimpactcapital.org/#/reset-password"
    }
  }, [_vm._v("https://invest.calvertimpactcapital.org/#/reset-password")]), _vm._v(".")])])])
}]}

/***/ }),
/* 2105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-close col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "modal-button",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title "
  }, [_vm._v("Create an account")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body mt-lg"
  }, [_vm._t("body", [_c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n                Choose the type of account to get started\n            ")]), _vm._v(" "), _c('fieldset', {
    staticClass: "row pt-lg"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: _vm.accountType === 'joint' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accountType),
      expression: "accountType"
    }],
    attrs: {
      "id": "ritema",
      "name": "accountType",
      "type": "radio"
    },
    domProps: {
      "value": 'joint',
      "checked": _vm._q(_vm.accountType, 'joint')
    },
    on: {
      "__c": function($event) {
        _vm.accountType = 'joint'
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ritema"
    }
  }, [_vm._v("Joint")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: _vm.accountType === 'institution' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accountType),
      expression: "accountType"
    }],
    attrs: {
      "id": "ritemb",
      "name": "accountType",
      "type": "radio"
    },
    domProps: {
      "value": 'institution',
      "checked": _vm._q(_vm.accountType, 'institution')
    },
    on: {
      "__c": function($event) {
        _vm.accountType = 'institution'
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ritemb"
    }
  }, [_vm._v("Institution")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: _vm.accountType === 'trust' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accountType),
      expression: "accountType"
    }],
    attrs: {
      "id": "ritemc",
      "name": "accountType",
      "type": "radio"
    },
    domProps: {
      "value": 'trust',
      "checked": _vm._q(_vm.accountType, 'trust')
    },
    on: {
      "__c": function($event) {
        _vm.accountType = 'trust'
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ritemc"
    }
  }, [_vm._v("Trust")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: _vm.accountType === 'utma-ugma' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accountType),
      expression: "accountType"
    }],
    attrs: {
      "id": "ritemd",
      "name": "accountType",
      "type": "radio"
    },
    domProps: {
      "value": 'utma-ugma',
      "checked": _vm._q(_vm.accountType, 'utma-ugma')
    },
    on: {
      "__c": function($event) {
        _vm.accountType = 'utma-ugma'
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ritemd"
    }
  }, [_vm._v("UTMA/UGMA")])])])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_vm._t("body", [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-outline",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-create",
    attrs: {
      "type": "submit",
      "disabled": !_vm.accountType
    },
    on: {
      "click": function($event) {
        _vm.submitAccountType()
      }
    }
  }, [_vm._v("Create account")])])])])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper main-container"
  }, [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tabs', [_c('tab', {
    attrs: {
      "name": "Failed Transactions",
      "selected": true
    }
  }, [_c('FailedTransactionTabView', {
    attrs: {
      "emptyTransactionsMessage": _vm.emptyTransactionsMessage,
      "actionName": "Archive",
      "transactions": _vm.transactions,
      "goToViewDetail": _vm.goToViewDetail,
      "handleArchiveUnarchiveTransaction": _vm.handleArchiveTransaction
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Archived"
    }
  }, [_c('FailedTransactionTabView', {
    attrs: {
      "emptyTransactionsMessage": _vm.emptyArchivedTransactionsMessage,
      "actionName": "Unarchive",
      "transactions": _vm.archivedTransactions,
      "goToViewDetail": _vm.goToViewDetail,
      "handleArchiveUnarchiveTransaction": _vm.handleUnarchiveTransaction
    }
  })], 1)], 1)], 1)])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Cancelled/Failed transactions\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n              Transaction list\n            ")])])
}]}

/***/ }),
/* 2107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [(_vm.instructions.length > 0) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v(" "), _c('strong', [_c('ol', _vm._l((_vm.instructions), function(instruction) {
    return _c('li', [_vm._v(_vm._s(instruction))])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default panel-height",
    attrs: {
      "id": "panelChart9"
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "top-margin"
  }, [_vm._v("Please input the two micro-deposited amounts that we have made on your bank account: ")]), _vm._v(" "), _c('form', {
    staticClass: "mb-lg top-margin",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitVerifyMicroDeposit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "amount1"
    }
  }, [_vm._v("Amount 1")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.microDeposit.requestBody.amount1.value),
      expression: "microDeposit.requestBody.amount1.value"
    }],
    staticClass: "form-control",
    attrs: {
      "step": "0.0001",
      "type": "number",
      "id": "amount1",
      "placeholder": "Micro Deposit - Amount 1",
      "required": ""
    },
    domProps: {
      "value": (_vm.microDeposit.requestBody.amount1.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.microDeposit.requestBody.amount1.value = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "amount2"
    }
  }, [_vm._v("Amount 2")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.microDeposit.requestBody.amount2.value),
      expression: "microDeposit.requestBody.amount2.value"
    }],
    staticClass: "form-control",
    attrs: {
      "step": "0.0001",
      "type": "number",
      "id": "amount2",
      "placeholder": "Micro Deposit - Amount 2",
      "required": ""
    },
    domProps: {
      "value": (_vm.microDeposit.requestBody.amount2.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.microDeposit.requestBody.amount2.value = $event.target.value
      }
    }
  })])])]), _vm._v(" "), (_vm.verifyError.length !== 0 || _vm.amountError.length !== 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.verifyError))])]), _vm._v(" "), _c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.amountError))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.microDeposit.fundingSourceId.length === 0 || _vm.maxAttempsReached
    }
  }, [_vm._v("Submit")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Micro Deposits\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon-exclamation pr-sm"
  }), _vm._v("Please take the following steps to retry bank account verification via micro deposit:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accounts-title"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n              Micro Deposits - Verifications\n            ")])])
}]}

/***/ }),
/* 2108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('spinner')], 1)
},staticRenderFns: []}

/***/ }),
/* 2109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [(_vm.showAddModal) ? _c('add-representatives', {
    attrs: {
      "closeAction": _vm.closeAddModal,
      "representatives": _vm.representatives,
      "accountId": _vm.accountId
    },
    on: {
      "representativeAdded": _vm.refreshRepresentatives
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Authorized representatives")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.representatives.length === 0) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.representatives.length > 0) ? _c('div', {
    class: {
      'table-fixed-header--md cols-4': _vm.representatives.length > 6, 'table-responsive': true, 'bottom-margin': true
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.representatives), function(representative, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-left"
    }, [_c('a', {
      staticClass: "account-representative",
      on: {
        "click": function($event) {
          _vm.goToUserView(representative.id, representative.userType, representative.firstName)
        }
      }
    }, [_vm._v(_vm._s(representative.fullName))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.getUserTypeLabel(representative.userType)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.canRepresentativeBePrimary(representative.userType)) ? _c('div', {
      class: {
        'radio-item': true, 'radio-item-unselected': !(representative.id === _vm.primaryInvestorId)
      },
      style: ({
        pointerEvents: _vm.isReadOnly ? 'none' : null,
        opacity: _vm.isReadOnly ? 0.5 : 1
      }),
      on: {
        "click": function($event) {
          _vm.attemptUpdatePrimaryInvestor(representative)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "readonly": ""
      },
      domProps: {
        "value": true
      }
    }), _vm._v(" "), _c('label')]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.isDeleteEnabled) ? _c('button', {
      staticClass: "btn btn-trash",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.attemptRepresentativeDelete(representative)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-trash fa-2x delete-icon"
    })]) : _vm._e()])])
  }))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg btn-add-representative",
    attrs: {
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": _vm.openAddModal
    }
  }, [_vm._v("Add new representative")]), _vm._v(" "), (_vm.isIndividualAccount) ? _c('div', {
    staticClass: "panel-body account-notice"
  }, [_vm._m(2)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        No authorized representatives found.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("User type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Primary user")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("The primary investor for an INDIVIDUAL account cannot be changed")])])
}]}

/***/ }),
/* 2110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('em', {
    staticClass: "sa-icon sa-info icon-exclamation"
  }), _vm._v(" "), _c('h2', {
    staticClass: "modal-title "
  }, [_vm._v(_vm._s(_vm.modalTitle))]), _vm._v(" "), _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n          " + _vm._s(_vm.questionText) + "\n          "), (_vm.hyperLinkUrl && _vm.hyperLinkText) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.hyperLinkUrl
    }
  }, [_vm._v(" " + _vm._s(_vm.hyperLinkText) + " ")]) : _vm._e(), _vm._v(" "), (_vm.hyperLinkUrl2 && _vm.hyperLinkText2) ? _c('span', [_vm._v(" and ")]) : _vm._e(), _vm._v(" "), (_vm.hyperLinkUrl2 && _vm.hyperLinkText2) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.hyperLinkUrl2
    }
  }, [_vm._v(" " + _vm._s(_vm.hyperLinkText2) + " ")]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.questionTextAppend) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_vm._t("body", [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [(!_vm.hideCancelButton) ? _c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.hideQuestionModal()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.executeAction()
      }
    }
  }, [_vm._v(_vm._s(_vm.yesButtonText) + "\n                ")])])])])], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 2111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible bulk-wrapper",
    attrs: {
      "data-animation": "pop"
    }
  }, [(_vm.displayQuestion) ? _c('question') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-close col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "modal-button",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("Redeem/approve all open notes")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body mt-lg"
  }, [(_vm.loading) ? _c('spinner', {
    attrs: {
      "text": _vm.loadingText,
      "inline": ""
    }
  }) : (_vm.result) ? _c('div', [_c('div', {
    staticClass: "alert",
    class: _vm.result.failed ? 'alert-warning' : 'alert-success',
    attrs: {
      "role": "alert"
    }
  }, [(!_vm.result.failed) ? _c('h4', [_vm._v(_vm._s(_vm.result.title))]) : _c('h4', [_vm._v(_vm._s(_vm.result.title) + " — with failures")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.result.message))])]), _vm._v(" "), (_vm.result.failed) ? _c('div', {
    staticClass: "failures-block"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n            These notes were not processed and must be handled individually:\n          ")]), _vm._v(" "), _c('ul', {
    staticClass: "failure-list"
  }, _vm._l((_vm.result.failures), function(failure) {
    return _c('li', {
      key: failure.noteId
    }, [_vm._v("\n              Note #" + _vm._s(failure.noteId) + " — " + _vm._s(failure.errorMessage) + "\n            ")])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                Done\n              ")])])])])]) : (_vm.isApproval) ? _c('div', [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v("\n            A bulk redemption request for\n            "), _c('strong', [_vm._v(_vm._s(_vm.openBatch.noteCount))]), _vm._v(" notes is awaiting\n            approval on this account. Check the details below before\n            approving.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Bank account")]), _vm._v(" "), _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.requestFundingSourceLabel))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Service fee (whole batch)")]), _vm._v(" "), _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v("\n                " + _vm._s(_vm.formatAmount(_vm.openBatch.serviceFee || 0)) + "\n                "), (_vm.requestFeeBearer) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                  — charged once, to note " + _vm._s(_vm.requestFeeBearer.noteNumber) + "\n                ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Redemption category")]), _vm._v(" "), _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.requestCategoryLabel))])])])]), _vm._v(" "), _c('div', {
    staticClass: "totals-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Notes to redeem")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('strong', [_vm._v(_vm._s(_vm.openBatch.noteCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Principal")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v("\n              " + _vm._s(_vm.formatAmount(_vm.requestTotals.principal)) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Interest")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v("\n              " + _vm._s(_vm.formatAmount(_vm.requestTotals.interest)) + "\n            ")])]), _vm._v(" "), (_vm.requestTotals.fee > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Service fee")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right text-danger"
  }, [_vm._v("\n              −" + _vm._s(_vm.formatAmount(_vm.requestTotals.fee)) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row total-row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Total paid to investor")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right total-amount"
  }, [_vm._v("\n              " + _vm._s(_vm.formatAmount(_vm.requestNetPayout)) + "\n            ")])])]), _vm._v(" "), (_vm.requestNotes.length) ? _c('p', {
    staticClass: "toggle-link"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showNotes = !_vm.showNotes
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.showNotes ? 'Hide' : 'Show') + " the " + _vm._s(_vm.requestNotes.length) + " notes\n            being redeemed\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.showNotes && _vm.requestNotes.length) ? _c('div', {
    staticClass: "note-list"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Note")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Principal")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Interest")]), _vm._v(" "), (_vm.requestTotals.fee > 0) ? _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Fee")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.requestNotes), function(note) {
    return _c('tr', {
      key: note.noteId
    }, [_c('td', [_vm._v(_vm._s(note.noteNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.principalAmount)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.interestAmount)))]), _vm._v(" "), (_vm.requestTotals.fee > 0) ? _c('td', {
      staticClass: "text-right"
    }, [(note.feeAmount > 0) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("\n                    −" + _vm._s(_vm.formatAmount(note.feeAmount)) + "\n                  ")]) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("—")])]) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkApprovalComment"
    }
  }, [_vm._v("Please append your comment below *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.approvalComment),
      expression: "approvalComment",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bulkApprovalComment",
      "rows": "4",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.approvalComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.approvalComment = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.hasAppendedComment) ? _c('p', {
    staticClass: "text-danger"
  }, [_c('em', [_vm._v("You must enter or append a comment.")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                Close\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-discard",
    attrs: {
      "type": "button",
      "disabled": !_vm.hasAppendedComment
    },
    on: {
      "click": _vm.confirmCancelBatch
    }
  }, [_vm._v("\n                Cancel request\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button",
      "disabled": !_vm.hasAppendedComment
    },
    on: {
      "click": _vm.confirmApproval
    }
  }, [_vm._v("\n                Approve all\n              ")])])])])]) : _c('div', [(_vm.preview.eligibleCount === 0) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v("\n            No notes on this account can be bulk redeemed\n            "), (_vm.preview.ineligibleCount) ? _c('span', [_vm._v("\n              — all " + _vm._s(_vm.preview.ineligibleCount) + " open notes are excluded.\n              See the reasons below.\n            ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkFundingSource"
    }
  }, [_vm._v("Bank account *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fundingSourceId),
      expression: "fundingSourceId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bulkFundingSource"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fundingSourceId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Please select")]), _vm._v(" "), _vm._l((_vm.fundingSources), function(fs) {
    return _c('option', {
      key: fs.id,
      domProps: {
        "value": String(fs.id)
      }
    }, [_vm._v("\n                  " + _vm._s(fs.name) + "\n                ")])
  }), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.donateFundingSource.name
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.donateFundingSource.text) + "\n                ")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkServiceFee"
    }
  }, [_vm._v("Service fee (whole batch)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.serviceFeeInput),
      expression: "serviceFeeInput"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "id": "bulkServiceFee",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.serviceFeeInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serviceFeeInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fee-hint",
    class: _vm.preview.feeError ? 'text-danger' : 'text-muted'
  }, [(_vm.refreshing) ? _c('span', [_vm._v("Recalculating…")]) : (_vm.preview.feeError) ? _c('span', [_vm._v(_vm._s(_vm.preview.feeError))]) : (_vm.preview.feeBearer) ? _c('span', [_vm._v("\n                  Charged once, to note " + _vm._s(_vm.preview.feeBearer.noteNumber) + "\n                  (" + _vm._s(_vm.formatAmount(_vm.preview.feeBearer.currentBalance)) + ") — the\n                  largest note in the batch.\n                ")]) : _c('span', [_vm._v("\n                  Charged once for the whole batch, not per note.\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkCategory"
    }
  }, [_vm._v("Redemption category *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categoryId),
      expression: "categoryId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bulkCategory"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.categoryId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.preview.redemptionCategories), function(rc) {
    return _c('option', {
      key: rc.id,
      domProps: {
        "value": rc.id
      }
    }, [_vm._v("\n                  " + _vm._s(rc.label) + "\n                ")])
  }))])]), _vm._v(" "), (_vm.needsCategoryHelperText) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkCategoryHelperText"
    }
  }, [_vm._v("Category detail *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.categoryHelperText),
      expression: "categoryHelperText",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bulkCategoryHelperText",
      "placeholder": "Enter a redemption category…",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.categoryHelperText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.categoryHelperText = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "totals-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Notes to redeem")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('strong', [_vm._v(_vm._s(_vm.preview.eligibleCount))]), _vm._v(" "), (_vm.preview.ineligibleCount) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                (" + _vm._s(_vm.preview.ineligibleCount) + " excluded)\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Principal")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v(_vm._s(_vm.formatAmount(_vm.preview.totals.principal)))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Interest")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v(_vm._s(_vm.formatAmount(_vm.preview.totals.interest)))])]), _vm._v(" "), (_vm.preview.totals.fee > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("\n                Service fee\n                "), (_vm.preview.feeBearer) ? _c('span', [_vm._v("\n                  (on note " + _vm._s(_vm.preview.feeBearer.noteNumber) + ")\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right text-danger"
  }, [_vm._v("\n              −" + _vm._s(_vm.formatAmount(_vm.preview.totals.fee)) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row total-row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Total paid to investor")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right total-amount"
  }, [_vm._v("\n              " + _vm._s(_vm.formatAmount(_vm.preview.totals.netPayout)) + "\n            ")])])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkComment"
    }
  }, [_vm._v("Please append your comment *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.comment),
      expression: "comment",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bulkComment",
      "rows": "2",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toggle-link"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showNotes = !_vm.showNotes
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.showNotes ? 'Hide' : 'Show') + " the " + _vm._s(_vm.preview.eligibleCount) + " notes\n            being redeemed\n          ")])]), _vm._v(" "), (_vm.showNotes) ? _c('div', {
    staticClass: "note-list"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Note")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Principal")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Interest")]), _vm._v(" "), (_vm.preview.totals.fee > 0) ? _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Fee")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.preview.eligibleNotes), function(note) {
    return _c('tr', {
      key: note.noteId
    }, [_c('td', [_vm._v(_vm._s(note.noteNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.accruedInterest)))]), _vm._v(" "), (_vm.preview.totals.fee > 0) ? _c('td', {
      staticClass: "text-right"
    }, [(note.serviceFee > 0) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("\n                    −" + _vm._s(_vm.formatAmount(note.serviceFee)) + "\n                  ")]) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("—")])]) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.preview.ineligibleCount) ? _c('p', {
    staticClass: "toggle-link"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showExcluded = !_vm.showExcluded
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.showExcluded ? 'Hide' : 'Show') + " the " + _vm._s(_vm.preview.ineligibleCount) + " excluded\n            notes\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.showExcluded) ? _c('div', {
    staticClass: "note-list"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Note")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Principal")]), _vm._v(" "), _c('th', [_vm._v("Why it is excluded")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.preview.ineligibleNotes), function(note) {
    return _c('tr', {
      key: note.noteId
    }, [_c('td', [_vm._v(_vm._s(note.noteNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(note.ineligibilityText))])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                Cancel\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button",
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": _vm.confirmSubmit
    }
  }, [_vm._v("\n                Redeem " + _vm._s(_vm.preview.eligibleCount) + " notes\n              ")])])])])])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive),
      expression: "isActive"
    }]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 2113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tabs is-fullwidth is-centered"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.name,
      class: {
        'is-active': tab.isActive
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.selectTab(tab)
        }
      }
    }, [_vm._v(_vm._s(tab.name))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "tabs-details"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 2114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    attrs: {
      "align": "center"
    }
  }, [_c('ContactUsHeader'), _vm._v(" "), _c('div', {
    staticClass: "block-center mt-xl wd-xl"
  }, [_c('div', {
    staticClass: "panel panel-dark panel-flat"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.resetFeedback),
      expression: "!resetFeedback"
    }],
    staticClass: "panel-body"
  }, [_vm._m(0), _vm._v(" "), (!_vm.linkExpired) ? _c('p', [_vm._v("Enter your email to receive instructions on how to reset your password.")]) : _vm._e(), _vm._v(" "), (_vm.linkExpired) ? _c('p', {
    staticClass: "text-red"
  }, [_c('strong', [_vm._v("Your reset password link has expired. Please request a new one.")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateAndSubmitResetPassword($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.emailError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "signupInputEmail1",
      "type": "email",
      "placeholder": "Enter email",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "form-icon icon-envelope"
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock2"
    }
  }, [_vm._v(_vm._s(_vm.emailError))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default btn-lg mt-xl",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Reset password")]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.resetPasswordError
    }
  }, [_c('strong', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock6"
    }
  }, [_vm._v(_vm._s(_vm.resetPasswordError))])])])]), _vm._v(" "), (_vm.resetFeedback) ? _c('div', {
    staticClass: "panel-body"
  }, [_vm._m(1)]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center pv"
  }, [_c('strong', [_vm._v("Reset Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', {
    attrs: {
      "id": "helpBlock7"
    }
  }, [_vm._v("Password Reset Email Sent.")]), _vm._v(" "), _c('br'), _vm._v("\n           If you entered a registered email in our system, we’ve sent you a link to reset your password. If you don’t receive an email within 5 minutes (and perhaps checked your spam and /or tried again to make sure email entered correctly),\n           "), _c('br'), _vm._v(" "), _c('strong', {
    attrs: {
      "id": "helpBlock8"
    }
  }, [_vm._v("then please contact us at info@calvertimpact.org or 800.248.0337.")])])
}]}

/***/ }),
/* 2115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.isVisible) ? _c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "false",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('em', {
    staticClass: "sa-icon sa-success icon-success"
  }), _vm._v(" "), _c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("Bank Account Updated")]), _vm._v(" "), (!_vm.isAdminView) ? _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n        Thanks for updating your bank account information. Your upcoming transactions have been automatically \n        updated to use your new default bank account. You can review these changes in the\n        "), _c('strong', [_c('a', {
    staticClass: "upcoming-transactions-link",
    attrs: {
      "href": "/#/upcoming-transactions"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToUpcomingTransactions($event)
      }
    }
  }, [_vm._v("Upcoming Transactions")])]), _vm._v("\n        section if you'd like to verify the updates.\n      ")]) : _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n        The user's bank account information has been successfully updated. Their upcoming transactions have been automatically \n        updated to use the new default bank account. You can review these changes in the\n        "), _c('strong', [_c('a', {
    staticClass: "upcoming-transactions-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToUpcomingTransactions($event)
      }
    }
  }, [_vm._v("Upcoming Transactions")])]), _vm._v("\n        section if you'd like to verify the updates.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v("OK")])])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      You're an admin! HOORAY!\n    ")])])])
}]}

/***/ }),
/* 2117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible bulk-wrapper",
    attrs: {
      "data-animation": "pop"
    }
  }, [(_vm.displayQuestion) ? _c('question') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-close col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "modal-button",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("Transfer all notes to another account")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body mt-lg"
  }, [(_vm.loading) ? _c('spinner', {
    attrs: {
      "text": _vm.loadingText,
      "inline": ""
    }
  }) : (_vm.loadFailed) ? _c('div', [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('h4', [_vm._v("We could not load this account's notes")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.loadError))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                  Close\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadPreview
    }
  }, [_vm._v("\n                  Try again\n                ")])])])])]) : (_vm.result) ? _c('div', [_c('div', {
    staticClass: "alert",
    class: _vm.result.failed ? 'alert-warning' : 'alert-success',
    attrs: {
      "role": "alert"
    }
  }, [(!_vm.result.failed) ? _c('h4', [_vm._v(_vm._s(_vm.result.title))]) : _c('h4', [_vm._v(_vm._s(_vm.result.title) + " — with failures")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.result.message))])]), _vm._v(" "), (_vm.result.failed) ? _c('div', {
    staticClass: "failures-block"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n              These notes were not processed and must be handled individually\n              from each note's Transfer page:\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "failure-list"
  }, _vm._l((_vm.result.failures), function(failure) {
    return _c('li', {
      key: failure.noteId
    }, [_vm._v("\n                Note #" + _vm._s(failure.noteId) + "\n                "), (failure.failedPhase) ? _c('span', [_vm._v("\n                  (" + _vm._s(_vm.failedPhaseText(failure.failedPhase)) + ")\n                ")]) : _vm._e(), _vm._v("\n                — " + _vm._s(failure.errorMessage) + "\n              ")])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                  Done\n                ")])])])])]) : (_vm.isApproval) ? _c('div', [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v("\n              A bulk transfer of "), _c('strong', [_vm._v(_vm._s(_vm.openBatch.noteCount))]), _vm._v(" notes\n              to account "), _c('strong', [_vm._v(_vm._s(_vm.destinationLabel))]), _vm._v(" is awaiting\n              approval on this account.\n            ")])]), _vm._v(" "), (_vm.openBatch.electionsToReset) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.openBatch.electionsToReset) + " upcoming transaction(s) are\n              scheduled on these notes. Approving resets them, and anything\n              the investor already chose must be chosen again on the\n              destination account.\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "totals-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Notes to transfer")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('strong', [_vm._v(_vm._s(_vm.openBatch.noteCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Principal")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v("\n                " + _vm._s(_vm.formatAmount(_vm.openBatch.totalPrincipal || 0)) + "\n              ")])]), _vm._v(" "), (_vm.openBatch.electionsToReset) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Upcoming transactions")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.openBatch.electionsToReset) + "\n              ")])]) : _vm._e()]), _vm._v(" "), (_vm.requestNotes.length) ? _c('p', {
    staticClass: "toggle-link"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showNotes = !_vm.showNotes
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.showNotes ? 'Hide' : 'Show') + " the " + _vm._s(_vm.requestNotes.length) + " notes\n              being transferred\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.showNotes && _vm.requestNotes.length) ? _c('div', {
    staticClass: "note-list"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Note")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Balance")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Upcoming")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.requestNotes), function(note) {
    return _c('tr', {
      key: note.noteId
    }, [_c('td', [_vm._v(_vm._s(note.noteNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.principalAmount)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(note.electionsToReset) ? _c('span', {
      staticClass: "text-danger"
    }, [_c('em', {
      staticClass: "fa fa-warning pr-sm"
    }), _vm._v(_vm._s(note.electionsToReset) + "\n                    ")]) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("—")])])])
  }))])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkTransferApprovalComment"
    }
  }, [_vm._v("\n              Please append your comment below *\n            ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.approvalComment),
      expression: "approvalComment",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bulkTransferApprovalComment",
      "rows": "4",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.approvalComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.approvalComment = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.canApprove) ? _c('p', {
    staticClass: "text-danger"
  }, [_c('em', [_vm._v("You must enter or append a comment.")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                  Close\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-discard",
    attrs: {
      "type": "button",
      "disabled": !_vm.canApprove
    },
    on: {
      "click": _vm.confirmCancelBatch
    }
  }, [_vm._v("\n                  Cancel request\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button",
      "disabled": !_vm.canApprove
    },
    on: {
      "click": _vm.confirmApproval
    }
  }, [_vm._v("\n                  Approve all\n                ")])])])])]) : _c('div', [(_vm.preview.eligibleCount === 0) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v("\n              No notes on this account can be transferred\n              "), (_vm.preview.ineligibleCount) ? _c('span', [_vm._v("\n                — all " + _vm._s(_vm.preview.ineligibleCount) + " of them are excluded.\n                See the reasons below.\n              ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkTransferSearch"
    }
  }, [_vm._v("Destination account *")]), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.searchAccount($event)
      }
    }
  }, [_c('div', {
    staticClass: "searchbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.text),
      expression: "search.text"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bulkTransferSearch",
      "type": "text",
      "placeholder": "Search account number",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.search.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "submit",
      "disabled": !_vm.search.text || _vm.searching
    }
  }, [_c('em', {
    staticClass: "icon-magnifier pr-sm"
  }), _vm._v(" Search\n                ")])])])]), _vm._v(" "), (_vm.search.hasSearched && !_vm.search.account && !_vm.searching) ? _c('div', {
    staticClass: "alert alert-info not-found-alert",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("No results found.")])]) : _vm._e(), _vm._v(" "), (_vm.selectedAccount || _vm.search.account) ? _c('table', {
    staticClass: "table table-striped bank-accounts table-fundings"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Account number")]), _vm._v(" "), _c('th', [_vm._v("Account name")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [(_vm.selectedAccount) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.selectedAccount.accountId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedAccount.accountName))]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "action-span green-text"
  }, [_c('i', {
    staticClass: "fa fa-check check"
  }), _vm._v("Selected\n                  ")])])]) : _vm._e(), _vm._v(" "), (_vm.search.account && !_vm.isSelected(_vm.search.account)) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.search.account.accountId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.search.account.accountName))]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-details btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectAccount(_vm.search.account)
      }
    }
  }, [_vm._v("\n                    Select account\n                  ")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.preview.warnings.length) ? _c('div', {
    staticClass: "alert alert-warning warnings-block",
    attrs: {
      "role": "alert"
    }
  }, [_c('h4', [_vm._v("Before this account is migrated")]), _vm._v(" "), _c('ul', {
    staticClass: "warning-list"
  }, _vm._l((_vm.preview.warnings), function(warning) {
    return _c('li', {
      key: warning.code
    }, [_vm._v("\n                " + _vm._s(warning.text) + "\n              ")])
  }))]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "checkbox c-checkbox closed-notes-toggle"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeClosedNotes),
      expression: "includeClosedNotes"
    }],
    attrs: {
      "type": "checkbox",
      "name": "includeClosedNotes"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeClosedNotes) ? _vm._i(_vm.includeClosedNotes, null) > -1 : (_vm.includeClosedNotes)
    },
    on: {
      "change": function($event) {
        _vm.loadPreview()
      },
      "__c": function($event) {
        var $$a = _vm.includeClosedNotes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeClosedNotes = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.includeClosedNotes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeClosedNotes = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n              Include closed notes\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted closed-notes-hint"
  }, [_vm._v("\n              Closed notes carry no balance. Moving them keeps the account's\n              history together rather than splitting it across two accounts.\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "totals-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Notes to transfer")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('strong', [_vm._v(_vm._s(_vm.preview.eligibleCount))]), _vm._v(" "), (_vm.preview.ineligibleCount) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                  (" + _vm._s(_vm.preview.ineligibleCount) + " excluded)\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Principal moving")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v("\n                " + _vm._s(_vm.formatAmount(_vm.preview.totals.principal)) + "\n              ")])]), _vm._v(" "), (_vm.preview.electionsToReset) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("\n                  Upcoming transactions\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.preview.electionsToReset) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.preview.terminalNoteCount) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "totals-label"
  }, [_vm._v("Closed or cancelled notes staying here")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_vm._v(_vm._s(_vm.preview.terminalNoteCount))])]) : _vm._e()]), _vm._v(" "), _c('fieldset', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bulkTransferComment"
    }
  }, [_vm._v("Please append your comment *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.comment),
      expression: "comment",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bulkTransferComment",
      "rows": "2",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.preview.eligibleCount) ? _c('p', {
    staticClass: "toggle-link"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showNotes = !_vm.showNotes
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.showNotes ? 'Hide' : 'Show') + " the " + _vm._s(_vm.preview.eligibleCount) + " notes\n              being transferred\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.showNotes) ? _c('div', {
    staticClass: "note-list"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Note")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Balance")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Maturity")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Upcoming")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.preview.eligibleNotes), function(note) {
    return _c('tr', {
      key: note.noteId
    }, [_c('td', [_vm._v(_vm._s(note.noteNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.maturityDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(note.electionsToReset) ? _c('span', {
      staticClass: "text-danger"
    }, [_c('em', {
      staticClass: "fa fa-warning pr-sm"
    }), _vm._v(_vm._s(note.electionsToReset) + "\n                    ")]) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("—")])])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.preview.ineligibleCount) ? _c('p', {
    staticClass: "toggle-link"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showExcluded = !_vm.showExcluded
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.showExcluded ? 'Hide' : 'Show') + " the " + _vm._s(_vm.preview.ineligibleCount) + " notes\n              that would stay\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.showExcluded) ? _c('div', {
    staticClass: "note-list"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Note")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Balance")]), _vm._v(" "), _c('th', [_vm._v("Why it stays")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.preview.ineligibleNotes), function(note) {
    return _c('tr', {
      key: note.noteId
    }, [_c('td', [_vm._v(_vm._s(note.noteNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(note.ineligibilityText))])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                  Cancel\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button",
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": _vm.confirmSubmit
    }
  }, [_vm._v("\n                  Transfer " + _vm._s(_vm.preview.eligibleCount) + " notes\n                ")])])])])])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      " + _vm._s(_vm.type === 'transaction' ? 'Transaction Notices' : 'Documents') + "\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "table-responsive top-margin table-fixed-header--md desktop-table"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-right with-right-padding"
  }, [_vm._v(_vm._s(_vm.type === 'transaction' ? 'Sent on' : 'Uploaded on'))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.documents), function(document) {
    return _c('tr', {
      key: document.Key
    }, [_c('td', {
      staticClass: "file file-name td-blocked",
      on: {
        "click": function($event) {
          _vm.openDocument(document)
        }
      }
    }, [_c('i', {
      staticClass: "icon fa fa-file-text-o"
    }), _c('a', [_vm._v(_vm._s(document.Key))])]), _vm._v(" "), _c('td', {
      staticClass: "file-updated-date text-right with-right-padding td-blocked"
    }, [_vm._v(_vm._s(_vm.formatDate(!!document.Head &&
      !!document.Head.Metadata &&
      !!document.Head.Metadata.uploaded_at ?
      document.Head.Metadata.uploaded_at : document.LastModified)))])])
  }), _vm._v(" "), (!_vm.documents.length) ? _c('tr', {
    staticClass: "align-center"
  }, [_c('td', {
    staticClass: "file file-name td-blocked"
  }, [_vm._v("No Documents to display")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-card-view"
  }, [(_vm.documents.length) ? _c('div', {
    staticClass: "document-cards"
  }, _vm._l((_vm.documents), function(document) {
    return _c('div', {
      key: document.Key,
      staticClass: "document-card",
      on: {
        "click": function($event) {
          _vm.openDocument(document)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "document-card-content"
    }, [_c('div', {
      staticClass: "document-card-name"
    }, [_vm._v(_vm._s(document.Key))]), _vm._v(" "), _c('div', {
      staticClass: "document-card-date"
    }, [_vm._v("\n                 " + _vm._s(_vm.type === 'transaction' ? 'Sent on' : 'Uploaded on') + ": \n                 " + _vm._s(_vm.formatDate(!!document.Head &&
      !!document.Head.Metadata &&
      !!document.Head.Metadata.uploaded_at ?
      document.Head.Metadata.uploaded_at : document.LastModified)) + "\n               ")])]), _vm._v(" "), _vm._m(1, true)])
  })) : _c('div', {
    staticClass: "no-documents-mobile"
  }, [_c('i', {
    staticClass: "fa fa-folder-open-o"
  }), _vm._v(" "), _c('p', [_vm._v("No Documents to display")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-card-icon"
  }, [_c('i', {
    staticClass: "icon fa fa-file-text-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-card-arrow"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])
}]}

/***/ }),
/* 2119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.transactions.length === 0) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.emptyTransactionsMessage) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.transactions.length > 0) ? _c('div', {
    staticClass: "table-responsive top-margin"
  }, [_c('table', {
    staticClass: "table table-striped bank-accounts table-fundings"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Transaction number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Note number")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Transaction date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Last update date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("View details")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.actionName))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.transactions), function(transaction) {
    return _c('tr', {
      key: transaction.id
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(transaction.transactionId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(transaction.noteId))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(transaction.amount)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(transaction.createdAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(transaction.updatedAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(transaction.status == 'CANCELLED') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("cancelled")]) : _vm._e(), _vm._v(" "), (transaction.status == 'FAILED') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("failed")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(transaction.id)
        }
      }
    }, [_vm._v("\n              View details\n            ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.handleArchiveUnarchiveTransaction(transaction)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.actionName) + "\n            ")])])])
  }))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.isAccountCreationModalVisible) ? _c('accountCreation') : _vm._e(), _vm._v(" "), (_vm.isSuggestedAddressModalVisible) ? _c('address-suggestion') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper content-wrapper-banner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel b text-white banner-width title-panel"
  }, [_c('div', {
    staticClass: "panel-body bg-cover clearfix"
  }, [_c('div', {
    staticClass: "media mt0"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "media-body media-middle"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('p', {
    staticClass: "information-title"
  }, [_vm._v("Personal Information")]), _vm._v(" "), _c('h3', {
    staticClass: "media-heading m0"
  }, [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper content-wrapper-container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [(_vm.userProfile.updateCount === 0 && _vm.userProfile.userType !== _vm.userTypes.FINANCIAL_ADVISOR.name) ? _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.userProfile.updateCount > 0 && _vm.userProfile.userType !== _vm.userTypes.FINANCIAL_ADVISOR.name) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Edit your profile information\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("First name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfile.firstName),
      expression: "userProfile.firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('FirstName')
    },
    attrs: {
      "type": "text",
      "name": "FirstName",
      "id": "FirstName",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.userProfile.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userProfile.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('FirstName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Last name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfile.lastName),
      expression: "userProfile.lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('LastName')
    },
    attrs: {
      "type": "text",
      "name": "LastName",
      "id": "LastName",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.userProfile.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userProfile.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('LastName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), (_vm.showDobAndSsn) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "date-time-input"
    }
  }, [_vm._v("Date of birth*")]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-group date birth-field-bottom"
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.isBirthFieldInvalid
    },
    attrs: {
      "placeholder": "mm/dd/yyyy",
      "id": "date-time-input",
      "name": "date-time-input",
      "wrap": true,
      "config": _vm.dateBirthConfig
    },
    nativeOn: {
      "blur": function($event) {
        _vm.checkDateBirth(_vm.userProfile.dateOfBirth)
      }
    },
    model: {
      value: (_vm.userProfile.dateOfBirth),
      callback: function($$v) {
        _vm.userProfile.dateOfBirth = $$v
      },
      expression: "userProfile.dateOfBirth"
    }
  }), _vm._v(" "), _vm._m(4)], 1), _vm._v(" "), (_vm.isBirthFieldInvalid) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()]), _vm._v(" "), (_vm.userProfile.userType !== _vm.userTypes.FINANCIAL_ADVISOR.name) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ssn"
    }
  }, [_vm._v("Social security number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfile.socialSecurityNum),
      expression: "userProfile.socialSecurityNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('***-**-9999'),
      expression: "'***-**-9999'"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('ssn')
    },
    attrs: {
      "type": "text",
      "name": "ssn",
      "id": "ssn",
      "placeholder": "000-00-0000",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.userProfile.socialSecurityNum)
    },
    on: {
      "click": function($event) {
        _vm.userProfile.socialSecurityNum = ''
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userProfile.socialSecurityNum = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('ssn')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Email*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfile.email),
      expression: "userProfile.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('Email')
    },
    attrs: {
      "type": "text",
      "name": "Email",
      "id": "Email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.userProfile.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userProfile.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('Email')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "primaryPhoneNum"
    }
  }, [_vm._v("Primary phone number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfile.primaryPhoneNum),
      expression: "userProfile.primaryPhoneNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('primaryPhoneNum')
    },
    attrs: {
      "id": "primaryPhoneNum",
      "name": "primaryPhoneNum",
      "placeholder": "Phone number"
    },
    domProps: {
      "value": (_vm.userProfile.primaryPhoneNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userProfile.primaryPhoneNum = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('primaryPhoneNum')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ssn"
    }
  }, [_vm._v("Secondary phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfile.secondaryPhoneNum),
      expression: "userProfile.secondaryPhoneNum"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "spn"
    },
    domProps: {
      "value": (_vm.userProfile.secondaryPhoneNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userProfile.secondaryPhoneNum = $event.target.value
      }
    }
  })])])]), _vm._v(" "), (_vm.userProfile.residentialAddress.state) ? _c('addresses-form', {
    key: 1,
    ref: "addresses",
    attrs: {
      "firstTitle": 'Residential Address',
      "residentialAddress": _vm.userProfile.residentialAddress,
      "secondTitle": 'Mailing Address',
      "mailingAddress": _vm.userProfile.mailingAddress
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitButton()
    },
    on: {
      "click": function($event) {
        _vm.validateAndSubmitUser()
      }
    }
  }, [_vm._v("Submit")])])])], 1)])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Personal information\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-thumbnail img-circle thumb45",
    attrs: {
      "src": __webpack_require__(123),
      "alt": "Image"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("Be aware that you will be able to edit "), _c('strong', [_vm._v("Date of birth")]), _vm._v(" and "), _c('strong', [_vm._v("Social security number")]), _vm._v(" fields just once.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', {
    staticClass: "icon-exclamation pr-sm"
  }), _vm._v("If you want to update your "), _c('strong', [_vm._v("Date of birth")]), _vm._v(" or "), _c('strong', [_vm._v("Social security number")]), _vm._v(" please contact Calvert Impact Capital for assistance.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "fa fa-calendar"
  })])
}]}

/***/ }),
/* 2121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container panel-heading"
  }, [_c('div', [_c('img', {
    staticClass: "pull-left pointer",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "src": __webpack_require__(1224),
      "alt": "Image",
      "width": "180"
    },
    on: {
      "click": function($event) {
        _vm.handleRedirect()
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "pull-right contact-us-title pointer",
    staticStyle: {
      "margin-right": "10px",
      "margin-top": "30px"
    },
    on: {
      "click": function($event) {
        _vm.handleRedirect('/contact')
      }
    }
  }, [_vm._v("\n      Contact Us\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "shadow-bar"
  })])
},staticRenderFns: []}

/***/ }),
/* 2123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelBeneficiaries"
    }
  }, [_c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Beneficiary Information")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.beneficiaries.length === 0) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.beneficiaries.length > 0) ? _c('div', {
    class: {
      'table-fixed-header--md': _vm.beneficiaries.length > 10,
        'table-responsive': true,
        'bottom-margin': true,
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.beneficiaries), function(beneficiary, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-left"
    }, [(_vm.editingIds.includes(beneficiary.id)) ? [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (beneficiary.beneficiaryName),
        expression: "beneficiary.beneficiaryName"
      }],
      staticClass: "form-control",
      class: {
        'is-invalid': _vm.hasNameError(beneficiary.id),
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (beneficiary.beneficiaryName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          beneficiary.beneficiaryName = $event.target.value
        }
      }
    }), _vm._v(" "), (_vm.hasNameError(beneficiary.id)) ? _c('div', {
      staticClass: "invalid-feedback"
    }, [_vm._v("\n                Beneficiary name is required\n              ")]) : _vm._e()] : [_vm._v("\n              " + _vm._s(beneficiary.beneficiaryName) + "\n            ")]], 2), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [(_vm.editingIds.includes(beneficiary.id)) ? [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (beneficiary.percentage),
        expression: "beneficiary.percentage",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control",
      class: {
        'is-invalid': _vm.hasError(beneficiary.id)
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (beneficiary.percentage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          beneficiary.percentage = _vm._n($event.target.value)
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), (_vm.hasError(beneficiary.id)) ? _c('div', {
      staticClass: "invalid-feedback"
    }, [_vm._v("\n                Total percentage cannot exceed 100% or be less than 0\n              ")]) : _vm._e()] : [_vm._v(" " + _vm._s(beneficiary.percentage) + "% ")]], 2), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.editingIds.includes(beneficiary.id)) ? [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button",
        "disabled": _vm.isLoading || _vm.hasError(beneficiary.id)
      },
      on: {
        "click": function($event) {
          _vm.saveBeneficiary(beneficiary.id)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-save fa-2x"
    })])] : [_c('button', {
      staticClass: "btn btn-edit",
      attrs: {
        "type": "button",
        "aria-label": "Edit beneficiary"
      },
      on: {
        "click": function($event) {
          _vm.editBeneficiary(beneficiary.id)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-edit fa-2x"
    })])], _vm._v(" "), _c('button', {
      staticClass: "btn btn-trash",
      attrs: {
        "type": "button",
        "disabled": _vm.isLoading,
        "aria-label": "Delete beneficiary"
      },
      on: {
        "click": function($event) {
          _vm.deleteBeneficiary(beneficiary.id)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-trash fa-2x"
    })])], 2)])
  }))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg btn-add-beneficiary",
    attrs: {
      "disabled": _vm.beneficiaries.length >= 10
    },
    on: {
      "click": _vm.addNewBeneficiary
    }
  }, [_vm._v("\n    Add new beneficiary\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        No beneficiaries found.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Percentage")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Actions")])])])
}]}

/***/ }),
/* 2124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isInformationModalVisible) ? _c('information') : _vm._e(), _vm._v(" "), _c('bank-account-changed-warning', {
    attrs: {
      "isVisible": _vm.isBankAccountChangedWarningVisible
    },
    on: {
      "close": _vm.hideBankAccountChangedWarning,
      "goToUpcomingTransactions": _vm.handleGoToUpcomingTransactions
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [(!_vm.onBoardingCompleted) ? _c('onboarding-wizard', {
    attrs: {
      "userStatus": _vm.userStatus
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default panel-height",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('dismissable-alert', {
    attrs: {
      "title": ("You've successfully " + _vm.fundingSourceAction + " a bank account!"),
      "closeAction": _vm.hideFundingSourceActionSuccess,
      "isShowing": _vm.showFundingSourceActionSuccess
    }
  }), _vm._v(" "), (_vm.legacyFundingSourcesExist()) ? _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_c('h4', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v(_vm._s(_vm.legacyFundingSourceMessageFirstLine))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.legacyFundingSourceMessageSecondLine))])]) : _vm._e(), _vm._v(" "), (_vm.showPendingMicrodepositsLabel) ? _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.fundingSources.length === 0) ? _c('div', {
    staticClass: "alert alert-info mt-lg",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v("Securely connect your bank account below to seamlessly invest and receive payments to your account.")])]) : _vm._e(), _vm._v(" "), (_vm.fundingSources.length > 0 && !_vm.showFundingTable) ? _c('div', {
    staticClass: "alert alert-info mt-lg",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.fundingSources.length > 0 && _vm.showFundingTable) ? _c('div', {
    staticClass: "accounts-title top-margin left-margin"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n              Accounts list\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFundingTable),
      expression: "showFundingTable"
    }],
    staticClass: "table-responsive top-margin desktop-table"
  }, [_c('table', {
    staticClass: "table table-striped bank-accounts table-fundings"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.fundingSources), function(funding, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(funding.bankName ? funding.bankName : '-----'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(funding.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatType(funding.type, 'investor')))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(funding.status === 'verified') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.accounts[_vm.activeAccountIndex].defaultFundingSourceId),
        expression: "user.accounts[activeAccountIndex].defaultFundingSourceId"
      }],
      attrs: {
        "type": "radio",
        "disabled": _vm.isReadOnly
      },
      domProps: {
        "value": funding.id,
        "checked": _vm._q(_vm.user.accounts[_vm.activeAccountIndex].defaultFundingSourceId, funding.id)
      },
      on: {
        "change": function($event) {
          _vm.showConfirmationModal({
            fundingSource: funding
          })
        },
        "__c": function($event) {
          _vm.user.accounts[_vm.activeAccountIndex].defaultFundingSourceId = funding.id
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(funding.type !== _vm.fundingSourceTypes.CHECK.name && funding.type !== _vm.fundingSourceTypes.WIRE_TRANSFER.name) ? _c('span', {
      staticClass: "label",
      class: funding.status === 'verified' ? 'label-success' : 'label-warning'
    }, [_vm._v("\n                      " + _vm._s(funding.status) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      staticClass: "text-red",
      style: ({
        pointerEvents: _vm.isReadOnly ? 'none' : null,
        opacity: _vm.isReadOnly ? 0.5 : 1
      }),
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeFundingSource(funding.id)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-trash"
    })]), _vm._v(" "), (funding.status !== 'verified') ? _c('button', {
      staticClass: "btn btn-details btn-outline btn-confirm-microdeposit",
      attrs: {
        "type": "button",
        "disabled": _vm.isReadOnly
      },
      on: {
        "click": function($event) {
          _vm.redirectToConfirmMicrodepositPage(funding.id)
        }
      }
    }, [_vm._v("Confirm Micro-deposit")]) : _vm._e()])])
  }))]), _vm._v(" "), (_vm.fundingSources.length > 1 && _vm.showFundingTable) ? _c('p', {
    staticClass: "left-margin top-margin"
  }, [_c('i', [_vm._v("Please note you cannot select an unverified bank account as your default.")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFundingTable),
      expression: "showFundingTable"
    }],
    staticClass: "mobile-card-view"
  }, [_c('div', {
    staticClass: "funding-cards-mobile"
  }, _vm._l((_vm.fundingSources), function(funding, index) {
    return _c('div', {
      key: index,
      staticClass: "funding-card-mobile"
    }, [_c('div', {
      staticClass: "funding-card-mobile-header"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "funding-card-mobile-title-section"
    }, [_c('div', {
      staticClass: "funding-card-mobile-title"
    }, [_vm._v(_vm._s(funding.bankName ? funding.bankName : '-----'))]), _vm._v(" "), (funding.type !== _vm.fundingSourceTypes.CHECK.name && funding.type !== _vm.fundingSourceTypes.WIRE_TRANSFER.name) ? _c('span', {
      staticClass: "label funding-card-mobile-status",
      class: funding.status === 'verified' ? 'label-success' : 'label-warning'
    }, [_vm._v("\n                      " + _vm._s(funding.status) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "funding-card-mobile-body"
    }, [_c('div', {
      staticClass: "funding-card-mobile-row"
    }, [_c('span', {
      staticClass: "funding-card-mobile-label"
    }, [_vm._v("Account name:")]), _vm._v(" "), _c('span', {
      staticClass: "funding-card-mobile-value"
    }, [_vm._v(_vm._s(funding.name))])]), _vm._v(" "), _c('div', {
      staticClass: "funding-card-mobile-row"
    }, [_c('span', {
      staticClass: "funding-card-mobile-label"
    }, [_vm._v("Type:")]), _vm._v(" "), _c('span', {
      staticClass: "funding-card-mobile-value"
    }, [_vm._v(_vm._s(_vm.formatType(funding.type, 'investor')))])]), _vm._v(" "), (funding.status === 'verified') ? _c('div', {
      staticClass: "funding-card-mobile-row funding-card-mobile-default"
    }, [_c('span', {
      staticClass: "funding-card-mobile-label"
    }, [_vm._v("Set as default:")]), _vm._v(" "), _c('div', {
      staticClass: "funding-card-mobile-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.user.accounts[_vm.activeAccountIndex].defaultFundingSourceId),
        expression: "user.accounts[activeAccountIndex].defaultFundingSourceId"
      }],
      staticClass: "funding-radio-input",
      attrs: {
        "type": "radio",
        "id": ("mobile-funding-" + (funding.id)),
        "disabled": _vm.isReadOnly
      },
      domProps: {
        "value": funding.id,
        "checked": _vm._q(_vm.user.accounts[_vm.activeAccountIndex].defaultFundingSourceId, funding.id)
      },
      on: {
        "change": function($event) {
          _vm.showConfirmationModal({
            fundingSource: funding
          })
        },
        "__c": function($event) {
          _vm.user.accounts[_vm.activeAccountIndex].defaultFundingSourceId = funding.id
        }
      }
    }), _vm._v(" "), _c('label', {
      class: {
        'funding-radio-label': true, 'is-default': _vm.user.accounts[_vm.activeAccountIndex].defaultFundingSourceId === funding.id
      },
      attrs: {
        "for": ("mobile-funding-" + (funding.id))
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.user.accounts[_vm.activeAccountIndex].defaultFundingSourceId === funding.id ? 'Default account' : 'Make default') + "\n                      ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "funding-card-mobile-actions"
    }, [(funding.status !== 'verified') ? _c('button', {
      staticClass: "btn btn-mobile-action btn-verify",
      attrs: {
        "type": "button",
        "disabled": _vm.isReadOnly
      },
      on: {
        "click": function($event) {
          _vm.redirectToConfirmMicrodepositPage(funding.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check-circle"
    }), _vm._v(" Confirm Micro-deposit\n                  ")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-mobile-action btn-delete",
      attrs: {
        "type": "button",
        "disabled": _vm.isReadOnly
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeFundingSource(funding.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete account\n                  ")])])])
  })), _vm._v(" "), (_vm.fundingSources.length > 1) ? _c('p', {
    staticClass: "mobile-note"
  }, [_c('i', [_vm._v("Please note you cannot select an unverified bank account as your default.")])]) : _vm._e()]), _vm._v(" "), (_vm.fundingSourcesTypeBankLength >= _vm.maxAmountFundingSources) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.user.accounts[_vm.activeAccountIndex].accountType !== 'INSTITUTION' && !_vm.disableInvestment) ? _c('button', {
    staticClass: "btn btn-default btn-lg x-space addButton top-margin",
    attrs: {
      "disabled": _vm.isReadOnly || (_vm.fundingSourcesTypeBankLength >= _vm.maxAmountFundingSources) || _vm.isStateRestricted(_vm.user.residentialAddress.state),
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.verifyPrimaryInvestor()
      }
    }
  }, [_vm._v("\n              Add a bank account\n          ")]) : _vm._e()], 1)], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Manage bank accounts\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("Please note you have pending micro-deposits for bank accounts below.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("Please note that you don't have linked bank accounts at the moment.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("Securely connect your bank account below to seamlessly invest and receive payments to your account.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bank name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Account name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Default")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "funding-card-mobile-icon"
  }, [_c('i', {
    staticClass: "fa fa-university"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 left-margin"
  }, [_c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v("The maximum number of online bank accounts is 3.")])])])
}]}

/***/ }),
/* 2125 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.defaultRateAndTermId),
      expression: "defaultRateAndTermId"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.defaultRateAndTermId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.handleSelectRateAndTerm($event)
      }]
    }
  }, _vm._l((_vm.yearRates), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "name": "rateAndTerm"
      },
      domProps: {
        "value": item.id
      }
    }, [_vm._v("\n      " + _vm._s(item.label) + "\n    ")])
  }))]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Transfer request")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-margin"
  }, [_c('div', {
    staticClass: "modal-body mt-lg"
  }, [(!_vm.transferNote.transactionId) ? _c('form', {
    staticClass: "mb-xl top-margin form-row",
    attrs: {
      "role": "form",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback searchbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.text),
      expression: "search.text"
    }],
    staticClass: "form-control",
    attrs: {
      "autofocus": "",
      "id": "searchText",
      "type": "text",
      "placeholder": "Search account number",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.search.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.searchAccount()
      }
    }
  }, [_c('em', {
    staticClass: "icon-magnifier pr-sm"
  }), _vm._v(" Search\n                  ")])])]) : _vm._e(), _vm._v(" "), (!_vm.search.account && _vm.search.hasSearched) ? _c('div', {
    staticClass: "panel-body"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.search.account || _vm.selectedAccount) ? _c('div', {
    staticClass: "top-margin"
  }, [_c('table', {
    staticClass: "table table-striped bank-accounts table-fundings"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [(_vm.selectedAccount) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.selectedAccount.accountId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedAccount.accountName))]), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.search.account && (!_vm.selectedAccount || _vm.search.account.id !== _vm.selectedAccount.id)) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.search.account.accountId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.search.account.accountName))]), _vm._v(" "), _c('td', [(!_vm.selectedAccount || _vm.search.account.id !== _vm.selectedAccount.id) ? _c('button', {
    staticClass: "btn btn-details btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectAccount(_vm.search.account)
      }
    }
  }, [_vm._v("Select account")]) : _c('span', {
    staticClass: "action-span green-text"
  }, [_c('i', {
    staticClass: "fa fa-check check"
  }), _vm._v("Selected\n                        ")])])]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Please append your comment below *")]), _vm._v(" "), _c('restricted-textarea', {
    attrs: {
      "input": _vm.comment,
      "limit": 255,
      "id": "comment",
      "placeholder": "",
      "required": true
    },
    on: {
      "inputUpdated": _vm.commentUpdated
    }
  }), _vm._v(" "), (!_vm.comment || _vm.transaction.comment === _vm.comment) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("You must enter or append a comment.")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit",
      "disabled": !!_vm.transferNote.transactionId && _vm.isCancelButtonDisabled()
    },
    on: {
      "click": function($event) {
        !_vm.transferNote.transactionId ? _vm.goToNoteDetail() : _vm.showTransferConfirmationModal()
      }
    }
  }, [_vm._v("Cancel request")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit",
      "disabled": !_vm.transferNote.transactionId || _vm.isButtonDisabled()
    },
    on: {
      "click": _vm.approveTransfer
    }
  }, [_vm._v("Approve transfer")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-approve buttons",
    attrs: {
      "type": "submit",
      "disabled": !!_vm.transferNote.transactionId || _vm.isButtonDisabled()
    },
    on: {
      "click": _vm.submitRequest
    }
  }, [_vm._v("Submit request")])])])])])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg not-found-alert",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("No results found.\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Account number")]), _vm._v(" "), _c('th', [_vm._v("Account name")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "action-span green-text"
  }, [_c('i', {
    staticClass: "fa fa-check check"
  }), _vm._v("Selected\n                        ")])])
}]}

/***/ }),
/* 2127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.isCommercialOverrideModalVisible) ? _c('commercial-address-override', {
    on: {
      "confirm": _vm.confirmCommercialOverride,
      "cancel": _vm.cancelCommercialOverride
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSuggestedAddressModalVisible) ? _c('address-suggestion') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn-back icon-back bottom-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Go back")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.disableSubmit) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [(_vm.$route.query.retry) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Please verify your information and submit it once more.")])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            User information\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.newUser.userType === 'INVESTOR' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.userType),
      expression: "newUser.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "InvestorOption",
      "id": "InvestorOption",
      "value": "INVESTOR"
    },
    domProps: {
      "checked": _vm._q(_vm.newUser.userType, "INVESTOR")
    },
    on: {
      "__c": function($event) {
        _vm.newUser.userType = "INVESTOR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "InvestorOption"
    }
  }, [_vm._v("Investor")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.newUser.userType === 'ADVISOR' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.userType),
      expression: "newUser.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "FinancialAdvisorOption",
      "id": "FinancialAdvisorOption",
      "value": "ADVISOR"
    },
    domProps: {
      "checked": _vm._q(_vm.newUser.userType, "ADVISOR")
    },
    on: {
      "click": function($event) {
        _vm.selectAdvisor()
      },
      "__c": function($event) {
        _vm.newUser.userType = "ADVISOR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "FinancialAdvisorOption"
    }
  }, [_vm._v("Financial Advisor ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.newUser.userType === 'MINOR' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.userType),
      expression: "newUser.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "MinorOption",
      "id": "MinorOption",
      "value": "MINOR"
    },
    domProps: {
      "checked": _vm._q(_vm.newUser.userType, "MINOR")
    },
    on: {
      "__c": function($event) {
        _vm.newUser.userType = "MINOR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "MinorOption"
    }
  }, [_vm._v("Minor")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.newUser.userType === 'ADMIN' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.userType),
      expression: "newUser.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "AdminOption",
      "id": "AdminOption",
      "value": "ADMIN"
    },
    domProps: {
      "checked": _vm._q(_vm.newUser.userType, "ADMIN")
    },
    on: {
      "click": function($event) {
        _vm.selectAdmin()
      },
      "__c": function($event) {
        _vm.newUser.userType = "ADMIN"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "AdminOption"
    }
  }, [_vm._v("Admin ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.userType),
      expression: "newUser.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "institutionalRepresentative",
      "id": "institutionalRepresentative",
      "value": "INSTITUTIONAL_REPRESENTATIVE"
    },
    domProps: {
      "checked": _vm._q(_vm.newUser.userType, "INSTITUTIONAL_REPRESENTATIVE")
    },
    on: {
      "__c": function($event) {
        _vm.newUser.userType = "INSTITUTIONAL_REPRESENTATIVE"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "institutionalRepresentative"
    }
  }, [_vm._v("Institutional Representative ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.newUser.userType === 'READ_ONLY' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.userType),
      expression: "newUser.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "readOnlyOption",
      "id": "readOnlyOption",
      "value": "READ_ONLY"
    },
    domProps: {
      "checked": _vm._q(_vm.newUser.userType, "READ_ONLY")
    },
    on: {
      "__c": function($event) {
        _vm.newUser.userType = "READ_ONLY"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "readOnlyOption"
    }
  }, [_vm._v("Read-only")])])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.firstName),
      expression: "newUser.firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('FirstName')
    },
    attrs: {
      "type": "text",
      "name": "FirstName",
      "id": "FirstName",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.newUser.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('FirstName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.lastName),
      expression: "newUser.lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('LastName')
    },
    attrs: {
      "type": "text",
      "name": "LastName",
      "id": "LastName",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.newUser.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('LastName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), (_vm.newUser.userType == 'ADVISOR') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.organizationName),
      expression: "newUser.organizationName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('CompanyName1')
    },
    attrs: {
      "type": "text",
      "name": "CompanyName1",
      "id": "CompanyName1",
      "placeholder": "Company name"
    },
    domProps: {
      "value": (_vm.newUser.organizationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.organizationName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('CompanyName1')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Company name 2")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.alternateCompanyName),
      expression: "newUser.alternateCompanyName"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('CompanyName2')
    },
    attrs: {
      "type": "text",
      "name": "CompanyName2",
      "id": "CompanyName2",
      "placeholder": "Company name"
    },
    domProps: {
      "value": (_vm.newUser.alternateCompanyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.alternateCompanyName = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.newUser.userType === 'ADMIN') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Company name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.organizationName),
      expression: "newUser.organizationName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "CompanyName",
      "id": "CompanyName",
      "value": "Calvert Impact Capital"
    },
    domProps: {
      "value": (_vm.newUser.organizationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.organizationName = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType === 'ADMIN' || _vm.newUser.userType === 'ADVISOR') ? _c('div', {
    class: {
      'col-md-12': true, 'col-md-6': _vm.newUser.userType === 'ADMIN'
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "availability-check-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('Email')
    },
    attrs: {
      "type": "text",
      "name": "Email",
      "id": "Email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.email = $event.target.value
      }, _vm.emailInput],
      "blur": _vm.checkEmailAvailability
    }
  }), _vm._v(" "), (_vm.emailAvailabilityStatus !== null) ? _c('div', {
    staticClass: "availability-indicator"
  }, [(_vm.emailAvailabilityStatus === 'checking') ? _c('span', {
    staticClass: "fa fa-spinner fa-spin text-info"
  }) : _vm._e(), _vm._v(" "), (_vm.emailAvailabilityStatus === 'available') ? _c('span', {
    staticClass: "fa fa-check text-success"
  }) : _vm._e(), _vm._v(" "), (_vm.emailAvailabilityStatus === 'unavailable') ? _c('span', {
    staticClass: "fa fa-times text-danger"
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.errors.has('Email')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('Email')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newUser.userType === 'ADVISOR'),
      expression: "newUser.userType==='ADVISOR'"
    }],
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("CRD number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.CRDnumber),
      expression: "newUser.CRDnumber"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('CRD')
    },
    attrs: {
      "type": "text",
      "name": "CRD",
      "id": "CRD",
      "placeholder": "CRD NUMBER"
    },
    domProps: {
      "value": (_vm.newUser.CRDnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.CRDnumber = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('CRD')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newUser.userType === 'INVESTOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY'),
      expression: "newUser.userType === 'INVESTOR' || newUser.userType === 'MINOR' || newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || newUser.userType === 'READ_ONLY'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "date-time-input"
    }
  }, [_vm._v("Date of birth")]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-group date birth-field-bottom"
  }, [_c('date-picker', {
    class: {
      'form-control': true, 'form-control-error': _vm.isBirthFieldInvalid
    },
    attrs: {
      "placeholder": "mm/dd/yyyy",
      "id": "date-time-input",
      "name": "date-time-input",
      "wrap": true,
      "config": _vm.dateBirthConfig
    },
    nativeOn: {
      "blur": function($event) {
        _vm.checkDateBirth(_vm.newUser.dateOfBirth)
      }
    },
    model: {
      value: (_vm.newUser.dateOfBirth),
      callback: function($$v) {
        _vm.newUser.dateOfBirth = $$v
      },
      expression: "newUser.dateOfBirth"
    }
  }), _vm._v(" "), _vm._m(7)], 1), _vm._v(" "), (_vm.isBirthFieldInvalid) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ssn"
    }
  }, [_vm._v("Social security number")]), _vm._v(" "), _c('div', {
    staticClass: "availability-check-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.socialSecurityNum),
      expression: "newUser.socialSecurityNum"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('999-99-9999'),
      expression: "'999-99-9999'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "ssn",
      "id": "ssn",
      "placeholder": "000-00-0000"
    },
    domProps: {
      "value": (_vm.newUser.socialSecurityNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.socialSecurityNum = $event.target.value
      }, _vm.ssnInput],
      "blur": _vm.checkSsnAvailability
    }
  }), _vm._v(" "), (_vm.ssnAvailabilityStatus !== null) ? _c('div', {
    staticClass: "availability-indicator"
  }, [(_vm.ssnAvailabilityStatus === 'checking') ? _c('span', {
    staticClass: "fa fa-spinner fa-spin text-info"
  }) : _vm._e(), _vm._v(" "), (_vm.ssnAvailabilityStatus === 'available') ? _c('span', {
    staticClass: "fa fa-check text-success"
  }) : _vm._e(), _vm._v(" "), (_vm.ssnAvailabilityStatus === 'unavailable') ? _c('span', {
    staticClass: "fa fa-times text-danger"
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.errors.has('ssn')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('ssn')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newUser.userType === 'INVESTOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY'),
      expression: "newUser.userType==='INVESTOR' || newUser.userType === 'MINOR' || newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || newUser.userType === 'READ_ONLY'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Primary email "), (_vm.emailRequired) ? _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "availability-check-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('PrimaryEmail')
    },
    attrs: {
      "type": "text",
      "name": "PrimaryEmail",
      "id": "PrimaryEmail",
      "placeholder": "Primary email"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.email = $event.target.value
      }, _vm.emailInput],
      "blur": _vm.checkEmailAvailability
    }
  }), _vm._v(" "), (_vm.emailAvailabilityStatus !== null) ? _c('div', {
    staticClass: "availability-indicator"
  }, [(_vm.emailAvailabilityStatus === 'checking') ? _c('span', {
    staticClass: "fa fa-spinner fa-spin text-info"
  }) : _vm._e(), _vm._v(" "), (_vm.emailAvailabilityStatus === 'available') ? _c('span', {
    staticClass: "fa fa-check text-success"
  }) : _vm._e(), _vm._v(" "), (_vm.emailAvailabilityStatus === 'unavailable') ? _c('span', {
    staticClass: "fa fa-times text-danger"
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.errors.has('PrimaryEmail')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('PrimaryEmail')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Secondary email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.secondaryEmail),
      expression: "newUser.secondaryEmail"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('SecondaryEmail')
    },
    attrs: {
      "type": "text",
      "name": "SecondaryEmail",
      "id": "SecondaryEmail",
      "placeholder": "Secondary Email"
    },
    domProps: {
      "value": (_vm.newUser.secondaryEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.secondaryEmail = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('SecondaryEmail')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('SecondaryEmail')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.primaryPhoneNum),
      expression: "newUser.primaryPhoneNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('primaryPhoneNum')
    },
    attrs: {
      "id": "primaryPhoneNum",
      "name": "primaryPhoneNum",
      "placeholder": "Phone number"
    },
    domProps: {
      "value": (_vm.newUser.primaryPhoneNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.primaryPhoneNum = $event.target.value
      }, _vm.onPhoneNumberChange]
    }
  }), _vm._v(" "), (_vm.errors.has('primaryPhoneNum')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ssn"
    }
  }, [_vm._v("Secondary phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.secondaryPhoneNum),
      expression: "newUser.secondaryPhoneNum"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "spn"
    },
    domProps: {
      "value": (_vm.newUser.secondaryPhoneNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.secondaryPhoneNum = $event.target.value
      }, _vm.onPhoneNumberChange]
    }
  })])])]), _vm._v(" "), (_vm.enableMfa) ? _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mfaPhonePreference),
      expression: "mfaPhonePreference"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mfaPhonePreference"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mfaPhonePreference = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-- Select --")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PRIMARY",
      "disabled": !_vm.hasPrimaryPhone
    }
  }, [_vm._v("\n                    Primary Phone\n                  ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SECONDARY",
      "disabled": !_vm.hasSecondaryPhone
    }
  }, [_vm._v("\n                    Secondary Phone\n                  ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NONE"
    }
  }, [_vm._v("None (Email only)")])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n                  Select which phone number should be used for SMS multi-factor authentication.\n                ")])])])]) : _vm._e(), _vm._v(" "), (_vm.showProvideLoginOption) ? _c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', {
    staticClass: "dark-grey-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provideInvestorLogin),
      expression: "provideInvestorLogin"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "provide-investor-login",
      "disabled": _vm.emailIsInvalid
    },
    domProps: {
      "checked": Array.isArray(_vm.provideInvestorLogin) ? _vm._i(_vm.provideInvestorLogin, "") > -1 : (_vm.provideInvestorLogin)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.provideInvestorLogin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.provideInvestorLogin = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.provideInvestorLogin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.provideInvestorLogin = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n              Provide investor log in\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', {
    staticClass: "dark-grey-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableMfa),
      expression: "enableMfa"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "enable-mfa",
      "disabled": !_vm.provideInvestorLogin
    },
    domProps: {
      "checked": Array.isArray(_vm.enableMfa) ? _vm._i(_vm.enableMfa, "") > -1 : (_vm.enableMfa)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.enableMfa,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.enableMfa = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.enableMfa = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enableMfa = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n              Enable MFA\n            ")])]), _vm._v(" "), (_vm.showLoginNotice) ? _c('div', {
    staticClass: "panel-body account-notice"
  }, [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType === 'INVESTOR' || _vm.newUser.userType === 'ADVISOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY') ? _c('div', [(_vm.newUser.userType == 'INVESTOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY') ? _c('div', {
    staticClass: "panel-title"
  }, [_vm._v(" Residential Address ")]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType == 'ADVISOR') ? _c('div', {
    staticClass: "panel-title"
  }, [_vm._v(" Business Address ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  })]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType === 'INVESTOR' || _vm.newUser.userType === 'ADVISOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('RestrictedTwoInputs', {
    attrs: {
      "instructionsLabel": "Make sure your address doesn't exceed 50 characters.",
      "id": "ResidentialAddress",
      "fieldLabel": _vm.streetAddressLabel,
      "primaryPlaceholder": "Street and number e.g. 123 Any Street",
      "secondaryPlaceholder": "(optional) Apartment, building, floor, etc.",
      "dual": true,
      "primaryInput": _vm.newUser.residentialAddress.streetAddress1,
      "secondaryInput": _vm.newUser.residentialAddress.streetAddress2
    },
    on: {
      "inputUpdated": _vm.residentialAddressUpdated
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType === 'INVESTOR' || _vm.newUser.userType === 'ADVISOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "zip-code"
    }
  }, [_vm._v("Zip code "), (!_vm.isInstitutionalRepresentative) ? _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.residentialAddress.zipCode),
      expression: "newUser.residentialAddress.zipCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && _vm.newUser.userType !== 'READ_ONLY'
      }),
      expression: "{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('Zipcode') || _vm.isZipCodeInvalid(_vm.newUser.residentialAddress.zipCode, _vm.newUser.residentialAddress.country)
    },
    attrs: {
      "type": "text",
      "name": "Zipcode",
      "id": "Zipcode",
      "placeholder": "Zip code"
    },
    domProps: {
      "value": (_vm.newUser.residentialAddress.zipCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.residentialAddress.zipCode = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('Zipcode') || _vm.isZipCodeInvalid(_vm.newUser.residentialAddress.zipCode, _vm.newUser.residentialAddress.country)) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City "), (!_vm.isInstitutionalRepresentative) ? _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.residentialAddress.city),
      expression: "newUser.residentialAddress.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && _vm.newUser.userType !== 'READ_ONLY'
      }),
      expression: "{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('City')
    },
    attrs: {
      "type": "text",
      "name": "City",
      "id": "City",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.newUser.residentialAddress.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.residentialAddress.city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('City')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("State "), (!_vm.isInstitutionalRepresentative && _vm.selectedUserType !== 'READ_ONLY') ? _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.residentialAddress.state),
      expression: "newUser.residentialAddress.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && _vm.newUser.userType !== 'READ_ONLY'
      }),
      expression: "{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('ResidentialState')
    },
    attrs: {
      "id": "ResidentialState",
      "name": "ResidentialState",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newUser.residentialAddress.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _vm._l((_vm.countryStates('residentialAddress')), function(s) {
    return _c('option', {
      domProps: {
        "value": s.abbreviation
      }
    }, [_vm._v(_vm._s(s.name))])
  })], 2), _vm._v(" "), (_vm.errors.has('ResidentialState')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("Country "), (!_vm.isInstitutionalRepresentative && _vm.selectedUserType !== 'READ_ONLY') ? _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.residentialAddress.country),
      expression: "newUser.residentialAddress.country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && _vm.newUser.userType !== 'READ_ONLY'
      }),
      expression: "{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('ResidentialCountry')
    },
    attrs: {
      "id": "ResidentialCountry",
      "name": "ResidentialCountry",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newUser.residentialAddress.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _vm._l((_vm.geoLocation.countries), function(c) {
    return _c('option', {
      domProps: {
        "value": c.abbreviation
      }
    }, [_vm._v(_vm._s(c.name))])
  })], 2), _vm._v(" "), (_vm.errors.has('ResidentialCountry')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType == 'INVESTOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType == 'ADVISOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY') ? _c('fieldset', {
    staticClass: "checkbox c-checkbox check-margin mt-xl mb-lg"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isResidentDefaultAddress),
      expression: "isResidentDefaultAddress"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "isResidentDefaultAddress"
    },
    domProps: {
      "checked": Array.isArray(_vm.isResidentDefaultAddress) ? _vm._i(_vm.isResidentDefaultAddress, "") > -1 : (_vm.isResidentDefaultAddress)
    },
    on: {
      "click": function($event) {
        _vm.submitDifferentMailingAddress()
      },
      "__c": function($event) {
        var $$a = _vm.isResidentDefaultAddress,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isResidentDefaultAddress = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isResidentDefaultAddress = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isResidentDefaultAddress = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("Different mailing address\n            ")])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "mailing-address mb-xl",
    attrs: {
      "hidden": !_vm.isResidentDefaultAddress
    }
  }, [(_vm.newUser.userType == 'INVESTOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType == 'ADVISOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY') ? _c('div', [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Mailing Address")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  })]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType === 'INVESTOR' || _vm.newUser.userType === 'ADVISOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 top-margin"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('RestrictedTwoInputs', {
    attrs: {
      "instructionsLabel": "Make sure your address doesn't exceed 50 characters.",
      "id": "MailinglAddress",
      "fieldLabel": _vm.streetAddressLabel,
      "primaryPlaceholder": "Street and number e.g. 123 Any Street",
      "secondaryPlaceholder": "(optional) Apartment, building, floor, etc.",
      "dual": true,
      "primaryInput": _vm.newUser.mailingAddress.streetAddress1,
      "secondaryInput": _vm.newUser.mailingAddress.streetAddress2,
      "isDisabled": !_vm.isResidentDefaultAddress
    },
    on: {
      "inputUpdated": _vm.mailingAddressUpdated
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType === 'INVESTOR' || _vm.newUser.userType === 'ADVISOR' || _vm.newUser.userType === 'MINOR' || _vm.newUser.userType === 'INSTITUTIONAL_REPRESENTATIVE' || _vm.newUser.userType === 'READ_ONLY') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.mailingAddress.zipCode),
      expression: "newUser.mailingAddress.zipCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && _vm.newUser.userType !== 'READ_ONLY'
      }),
      expression: "{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.isResidentDefaultAddress && (_vm.errors.has('MailingZipcode') || _vm.isZipCodeInvalid(_vm.newUser.mailingAddress.zipCode, _vm.newUser.mailingAddress.country))
    },
    attrs: {
      "type": "text",
      "name": "MailingZipcode",
      "id": "MailingZipcode",
      "placeholder": "Zip code",
      "disabled": !_vm.isResidentDefaultAddress
    },
    domProps: {
      "value": (_vm.newUser.mailingAddress.zipCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.mailingAddress.zipCode = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isResidentDefaultAddress && (_vm.errors.has('MailingZipcode') || _vm.isZipCodeInvalid(_vm.newUser.mailingAddress.zipCode, _vm.newUser.mailingAddress.country))) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.mailingAddress.city),
      expression: "newUser.mailingAddress.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && _vm.newUser.userType !== 'READ_ONLY'
      }),
      expression: "{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.isResidentDefaultAddress && _vm.errors.has('MailingCity')
    },
    attrs: {
      "type": "text",
      "name": "MailingCity",
      "id": "MailingCity",
      "placeholder": "City",
      "disabled": !_vm.isResidentDefaultAddress
    },
    domProps: {
      "value": (_vm.newUser.mailingAddress.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.mailingAddress.city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isResidentDefaultAddress && _vm.errors.has('MailingCity')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.mailingAddress.state),
      expression: "newUser.mailingAddress.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && _vm.newUser.userType !== 'READ_ONLY'
      }),
      expression: "{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
    }],
    class: {
      'form-control ': true, 'form-control-error': _vm.isResidentDefaultAddress && _vm.errors.has('MailingState'), 'disabled-state': !_vm.isResidentDefaultAddress
    },
    attrs: {
      "id": "MailingState",
      "name": "MailingState",
      "disabled": !_vm.isResidentDefaultAddress,
      "required": "",
      "disabled": !_vm.isResidentDefaultAddress
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newUser.mailingAddress.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _vm._l((_vm.countryStates('mailingAddress')), function(s) {
    return _c('option', {
      domProps: {
        "value": s.abbreviation
      }
    }, [_vm._v(_vm._s(s.name))])
  })], 2), _vm._v(" "), (_vm.isResidentDefaultAddress && _vm.errors.has('MailingState')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.mailingAddress.country),
      expression: "newUser.mailingAddress.country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && _vm.newUser.userType !== 'READ_ONLY'
      }),
      expression: "{required: newUser.userType !== 'INSTITUTIONAL_REPRESENTATIVE' && newUser.userType !== 'READ_ONLY'}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('MailingCountry')
    },
    attrs: {
      "id": "MailingCountry",
      "name": "MailingCountry",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newUser.mailingAddress.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _vm._l((_vm.geoLocation.countries), function(c) {
    return _c('option', {
      domProps: {
        "value": c.abbreviation
      }
    }, [_vm._v(_vm._s(c.name))])
  })], 2), _vm._v(" "), (_vm.errors.has('MailingCountry')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), (_vm.newUser.userType === 'INVESTOR' || _vm.newUser.userType === 'MINOR') ? _c('div', [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-container",
    class: {
      'has-error': _vm.isFileInvalid
    }
  }, [_c('div', {
    staticClass: "bottom-margin"
  }, [_c('input', {
    ref: "fileupload",
    staticClass: "form-control filestyle",
    staticStyle: {
      "position": "absolute",
      "clip": "rect(0px 0px 0px 0px)"
    },
    attrs: {
      "type": "file",
      "data-classbutton": "btn btn-default",
      "data-classinput": "form-control inline",
      "id": "filestyle-0",
      "tabindex": "-1",
      "accept": _vm.getAcceptedFileExtensions()
    },
    on: {
      "change": _vm.fileChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bootstrap-filestyle input-group"
  }, [_c('input', {
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "placeholder": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.selectedFile ? _vm.selectedFile.name : ''
    }
  }), _vm._v(" "), _vm._m(16)])]), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Your file must be in JPG, JPEG, PNG, TIF or PDF format and cannot exceed 10MB.")]), _vm._v(" "), (_vm.isFileInvalid) ? _c('span', {
    staticClass: "help-block m-b-none"
  }, [_vm._v("The file you selected is not valid. Please select a different file.")]) : _vm._e()]), _vm._v(" "), _vm._m(17), _vm._v(" "), (_vm.uploadedFiles.length > 0) ? _c('div', {
    staticClass: "space table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-files"
  }, [_vm._m(18), _vm._v(" "), _c('tbody', _vm._l((_vm.uploadedFiles), function(file, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(new Date())))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      staticClass: "text-red",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeDocument(index)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-trash"
    })])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "space"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.newUser.userType == 'INVESTOR' || _vm.newUser.userType === 'MINOR') ? _c('div', [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(20), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.paymentPreference),
      expression: "newUser.paymentPreference"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('paymentPreference')
    },
    attrs: {
      "name": "paymentPreference",
      "id": "paymentPreference",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newUser.paymentPreference = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select principal payment preference")]), _vm._v(" "), _vm._l((_vm.paymentPreferences), function(principal) {
    return _c('option', {
      key: principal.id,
      domProps: {
        "value": principal.name
      }
    }, [_vm._v(_vm._s(principal.text))])
  })], 2), _vm._v(" "), (_vm.errors.has('paymentPreference')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(21), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.interestPreference),
      expression: "newUser.interestPreference"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('interestPreference')
    },
    attrs: {
      "name": "interestPreference",
      "id": "interestPreference",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newUser.interestPreference = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select interest payment preference")]), _vm._v(" "), _vm._l((_vm.paymentPreferences), function(interest) {
    return _c('option', {
      key: interest.id,
      domProps: {
        "value": interest.name
      }
    }, [_vm._v(_vm._s(interest.text))])
  })], 2), _vm._v(" "), (_vm.errors.has('interestPreference')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitButton()
    },
    on: {
      "click": function($event) {
        _vm.validateAndSubmitUser()
      }
    }
  }, [_vm._v("Submit")])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-back icon-back top-margin bottom-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Go back")])])])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Create user\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon-exclamation pr-sm"
  }), _vm._v("There was an issue validating your personal information.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]), _c('small', [_vm._v(" Required fields")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("First name "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Last name "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Company name 1 "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Email "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "primaryPhoneNum"
    }
  }, [_vm._v("Primary phone number "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "mfaPhonePreference"
    }
  }, [_c('strong', [_vm._v("MFA Phone Preference")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("\n                Normally we do NOT provide minors with a log in.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "zip-code"
    }
  }, [_vm._v("Zip code "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("State "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("Country "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-title"
  }, [_c('div', [_vm._v("KYC documentation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "group-span-filestyle input-group-btn",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('label', {
    staticClass: "btn btn-default document-label",
    attrs: {
      "for": "filestyle-0"
    }
  }, [_c('span', {
    staticClass: "icon-span-filestyle fa fa-folder-open"
  }), _vm._v(" "), _c('span', {
    staticClass: "buttonText"
  }, [_vm._v("Choose file")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "panel-list mt-lg text-muted"
  }, [_c('li', [_vm._v("Ensure the document has not expired.")]), _vm._v(" "), _c('li', [_vm._v("The document should not look fuzzy or cropped.")]), _vm._v(" "), _c('li', [_vm._v("Make sure the name and address match the profile information.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("File name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Uploaded by")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-title space"
  }, [_c('div', [_vm._v("Payment preference")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("Principal maturity preference "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("Interest payment preference "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 2128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.purchasingNote || _vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('onboarding-wizard', {
    attrs: {
      "userStatus": _vm.userStatus
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "text-center form-title"
  }, [_vm._v("Purchase Community Investment Note")]), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group form-group-element"
  }, [_c('label', [_vm._v("Enter investment amount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.investmentAmount),
      expression: "investmentAmount"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control text-right input-md': true, 'form-control-error': _vm.isInvestmentAmountInvalid
    },
    attrs: {
      "autocomplete": "off",
      "name": "investmentAmount",
      "id": "investmentAmount",
      "required": ""
    },
    domProps: {
      "value": (_vm.investmentAmount)
    },
    on: {
      "change": _vm.removeNegative,
      "blur": function($event) {
        _vm.validateInvestmentAmount()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.investmentAmount = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isInvestmentAmountInvalid) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.investmentAmountError))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-element"
  }, [_c('label', [_vm._v("Select rate and term")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interestYearRateSelected),
      expression: "interestYearRateSelected"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "name": "account",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interestYearRateSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.interestYearRates), function(interest) {
    return _c('option', {
      domProps: {
        "value": interest.id
      }
    }, [_vm._v(_vm._s(interest.label))])
  })), _vm._v(" "), _c('div', {
    staticClass: "has-feedback",
    class: {
      'has-error': _vm.interestYearRateErrorMessage
    }
  }, [_c('strong', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock6"
    }
  }, [_vm._v(_vm._s(_vm.interestYearRateErrorMessage))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-element"
  }, [_c('label', [_vm._v("Select bank account")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fundingSourceSelected),
      expression: "fundingSourceSelected"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "name": "account",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fundingSourceSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.fundingSources), function(account) {
    return _c('option', {
      domProps: {
        "value": account.id
      }
    }, [_vm._v(_vm._s(account.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "has-feedback",
    class: {
      'has-error': _vm.fundingSourceErrorMessage
    }
  }, [_c('strong', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock6"
    }
  }, [_vm._v(_vm._s(_vm.fundingSourceErrorMessage))])])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dwollaTermsCheck),
      expression: "dwollaTermsCheck"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "agreeTerms"
    },
    domProps: {
      "checked": Array.isArray(_vm.dwollaTermsCheck) ? _vm._i(_vm.dwollaTermsCheck, "") > -1 : (_vm.dwollaTermsCheck)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.dwollaTermsCheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.dwollaTermsCheck = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.dwollaTermsCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.dwollaTermsCheck = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), _c('terms-of-conditions')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "has-feedback",
    class: {
      'has-error': _vm.prospectusAndDwollaTermsErrorMessage
    }
  }, [_c('strong', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock6"
    }
  }, [_vm._v(_vm._s(_vm.prospectusAndDwollaTermsErrorMessage))])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmitButtonDisabled()
    },
    on: {
      "click": function($event) {
        _vm.validateAndSubmitInvestment()
      }
    }
  }, [_vm._v("\n                  Submit\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  })])])])], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Manage investments\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Make an investment")])])
}]}

/***/ }),
/* 2129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel-subtitle bottom-margin"
  }, [_vm._v("\n    Payment preferences\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin top-margin"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentPreferenceSelected),
      expression: "paymentPreferenceSelected"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "paymentPreferenceSelected_Input",
      "name": "paymentPreferenceSelected_Input"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.paymentPreferenceSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.paymentPreferences.DONATE.name
    }
  }, [_vm._v("\n            " + _vm._s(_vm.paymentPreferences.DONATE.label) + "\n          ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.paymentPreferences.PAYOUT.name
    }
  }, [_vm._v("\n            " + _vm._s(_vm.paymentPreferences.PAYOUT.label) + "\n          ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.paymentPreferences.REINVEST.name
    }
  }, [_vm._v("\n            " + _vm._s(_vm.paymentPreferences.REINVEST.label) + "\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interestPreferenceSelected),
      expression: "interestPreferenceSelected"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "interestPreferenceSelected_Input",
      "name": "interestPreferenceSelected_Input"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interestPreferenceSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.paymentPreferences.DONATE.name
    }
  }, [_vm._v("\n            " + _vm._s(_vm.paymentPreferences.DONATE.label) + "\n          ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.paymentPreferences.PAYOUT.name
    }
  }, [_vm._v("\n            " + _vm._s(_vm.paymentPreferences.PAYOUT.label) + "\n          ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.paymentPreferences.REINVEST.name
    }
  }, [_vm._v("\n            " + _vm._s(_vm.paymentPreferences.REINVEST.label) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-subtitle bottom-margin"
  }, [_vm._v("\n    Note Restrictions\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox bottom-margin"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redemptionRestrictionSelected),
      expression: "redemptionRestrictionSelected"
    }],
    attrs: {
      "type": "checkbox",
      "id": "notesRestriction_Input"
    },
    domProps: {
      "checked": Array.isArray(_vm.redemptionRestrictionSelected) ? _vm._i(_vm.redemptionRestrictionSelected, null) > -1 : (_vm.redemptionRestrictionSelected)
    },
    on: {
      "change": _vm.handleNotesRestrictionChange,
      "__c": function($event) {
        var $$a = _vm.redemptionRestrictionSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.redemptionRestrictionSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.redemptionRestrictionSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.redemptionRestrictionSelected = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n           Enable Redemptions with Upcoming Transactions\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-subtitle bottom-margin"
  }, [_vm._v("\n    General Communication Preferences\n  ")]), _vm._v(" "), (_vm.communicationPreferences.EMAIL !== undefined) ? _c('div', {
    staticClass: "row bottom-margin top-margin"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    class: _vm.communicationPreferenceSelected === _vm.communicationPreferences.EMAIL.name ?
      'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.communicationPreferenceSelected),
      expression: "communicationPreferenceSelected"
    }],
    attrs: {
      "id": "communicationPreference_Email",
      "name": "communicationPreference_Email",
      "type": "radio"
    },
    domProps: {
      "value": _vm.communicationPreferences.EMAIL.name,
      "checked": _vm._q(_vm.communicationPreferenceSelected, _vm.communicationPreferences.EMAIL.name)
    },
    on: {
      "__c": function($event) {
        _vm.communicationPreferenceSelected = _vm.communicationPreferences.EMAIL.name
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "communicationPreference_Email"
    }
  }, [_vm._v(_vm._s(_vm.communicationPreferences.EMAIL.label))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    class: _vm.communicationPreferenceSelected === _vm.communicationPreferences.SNAIL_MAIL.name ?
      'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.communicationPreferenceSelected),
      expression: "communicationPreferenceSelected"
    }],
    attrs: {
      "id": "communicationPreference_SnailMail",
      "name": "communicationPreference_SnailMmail",
      "type": "radio"
    },
    domProps: {
      "value": _vm.communicationPreferences.SNAIL_MAIL.name,
      "checked": _vm._q(_vm.communicationPreferenceSelected, _vm.communicationPreferences.SNAIL_MAIL.name)
    },
    on: {
      "__c": function($event) {
        _vm.communicationPreferenceSelected = _vm.communicationPreferences.SNAIL_MAIL.name
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "communicationPreference_SnailMail"
    }
  }, [_vm._v(_vm._s(_vm.communicationPreferences.SNAIL_MAIL.label))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-subtitle bottom-margin"
  }, [_vm._v("\n    Specific Communication Preferences\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin top-margin"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "panel-subtitle"
  }, [_vm._v("\n        1099\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form1099Email),
      expression: "form1099Email"
    }],
    attrs: {
      "type": "checkbox",
      "id": "form1099_email",
      "name": "form1099_email"
    },
    domProps: {
      "checked": Array.isArray(_vm.form1099Email) ? _vm._i(_vm.form1099Email, null) > -1 : (_vm.form1099Email)
    },
    on: {
      "change": _vm.handleForm1099EmailChange,
      "__c": function($event) {
        var $$a = _vm.form1099Email,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.form1099Email = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form1099Email = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form1099Email = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n          Email\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form1099SnailMail),
      expression: "form1099SnailMail"
    }],
    attrs: {
      "type": "checkbox",
      "id": "form1099_snailmail",
      "name": "form1099_snailmail"
    },
    domProps: {
      "checked": Array.isArray(_vm.form1099SnailMail) ? _vm._i(_vm.form1099SnailMail, null) > -1 : (_vm.form1099SnailMail)
    },
    on: {
      "change": _vm.handleForm1099SnailMailChange,
      "__c": function($event) {
        var $$a = _vm.form1099SnailMail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.form1099SnailMail = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form1099SnailMail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form1099SnailMail = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n          Snail Mail\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "panel-subtitle"
  }, [_vm._v("\n        Impact Report\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.impactReportEmail),
      expression: "impactReportEmail"
    }],
    attrs: {
      "type": "checkbox",
      "id": "impactReport_email",
      "name": "impactReport_email"
    },
    domProps: {
      "checked": Array.isArray(_vm.impactReportEmail) ? _vm._i(_vm.impactReportEmail, null) > -1 : (_vm.impactReportEmail)
    },
    on: {
      "change": _vm.handleImpactReportEmailChange,
      "__c": function($event) {
        var $$a = _vm.impactReportEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.impactReportEmail = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.impactReportEmail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.impactReportEmail = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n          Email\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.impactReportSnailMail),
      expression: "impactReportSnailMail"
    }],
    attrs: {
      "type": "checkbox",
      "id": "impactReport_snailmail",
      "name": "impactReport_snailmail"
    },
    domProps: {
      "checked": Array.isArray(_vm.impactReportSnailMail) ? _vm._i(_vm.impactReportSnailMail, null) > -1 : (_vm.impactReportSnailMail)
    },
    on: {
      "change": _vm.handleImpactReportSnailMailChange,
      "__c": function($event) {
        var $$a = _vm.impactReportSnailMail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.impactReportSnailMail = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.impactReportSnailMail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.impactReportSnailMail = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n          Snail Mail\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-subtitle bottom-margin top-margin"
  }, [_vm._v("\n    Impact preferences\n  ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.displayedPreferences.length > 0 && _vm.nonDisplayedPreferences.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "checkbox c-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayedPreferences[_vm.indexOfGeneralPreference].isSelected),
      expression: "displayedPreferences[indexOfGeneralPreference].isSelected"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.displayedPreferences[_vm.indexOfGeneralPreference].id,
      "disabled": false
    },
    domProps: {
      "value": _vm.displayedPreferences[_vm.indexOfGeneralPreference].id,
      "checked": Array.isArray(_vm.displayedPreferences[_vm.indexOfGeneralPreference].isSelected) ? _vm._i(_vm.displayedPreferences[_vm.indexOfGeneralPreference].isSelected, _vm.displayedPreferences[_vm.indexOfGeneralPreference].id) > -1 : (_vm.displayedPreferences[_vm.indexOfGeneralPreference].isSelected)
    },
    on: {
      "change": _vm.onChangeSelectImpactPreference,
      "__c": function($event) {
        var $$a = _vm.displayedPreferences[_vm.indexOfGeneralPreference].isSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.displayedPreferences[_vm.indexOfGeneralPreference].id,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.displayedPreferences[_vm.indexOfGeneralPreference].isSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.displayedPreferences[_vm.indexOfGeneralPreference].isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.displayedPreferences[_vm.indexOfGeneralPreference].isSelected = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n          Where Calvert Impact Capital sees the most need and opportunity\n        ")])]), _vm._v(" "), _vm._l((_vm.displayedPreferences), function(preference, index) {
    return (!_vm.isGeneralPreference(index) && !_vm.isOtherPreference(index)) ? _c('div', {
      key: index,
      staticClass: "checkbox c-checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (preference.isSelected),
        expression: "preference.isSelected"
      }],
      attrs: {
        "type": "checkbox",
        "id": preference.id,
        "disabled": false
      },
      domProps: {
        "value": preference.id,
        "checked": Array.isArray(preference.isSelected) ? _vm._i(preference.isSelected, preference.id) > -1 : (preference.isSelected)
      },
      on: {
        "change": _vm.onChangeSelectImpactPreference,
        "__c": function($event) {
          var $$a = preference.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = preference.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (preference.isSelected = $$a.concat($$v))
            } else {
              $$i > -1 && (preference.isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            preference.isSelected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fa fa-check"
    }), _vm._v("\n          " + _vm._s(preference.preferenceText) + "\n        ")])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, _vm._l((_vm.nonDisplayedPreferences), function(preference, index) {
    return _c('div', {
      key: index,
      staticClass: "checkbox c-checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (preference.isSelected),
        expression: "preference.isSelected"
      }],
      attrs: {
        "type": "checkbox",
        "id": preference.id,
        "disabled": false
      },
      domProps: {
        "value": preference.id,
        "checked": Array.isArray(preference.isSelected) ? _vm._i(preference.isSelected, preference.id) > -1 : (preference.isSelected)
      },
      on: {
        "change": _vm.onChangeSelectImpactPreference,
        "__c": function($event) {
          var $$a = preference.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = preference.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (preference.isSelected = $$a.concat($$v))
            } else {
              $$i > -1 && (preference.isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            preference.isSelected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fa fa-check"
    }), _vm._v("\n          " + _vm._s(preference.preferenceText) + "\n        ")])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin bottom-margin"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('RestrictedSingleInput', {
    attrs: {
      "dual": true,
      "input": _vm.other,
      "limit": 50,
      "warningLimit": 29,
      "fieldLabel": "Other",
      "instructionsLabel": "Make sure your text doesn't exceed 50 characters.",
      "placeholderText": 'Enter your preference here...'
    },
    on: {
      "inputUpdated": _vm.selectOtherPreference
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg button-submit",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.showConfirmationModal
    }
  }, [_vm._v("Submit preferences")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "paymentPreferenceSelected_Input"
    }
  }, [_vm._v("\n          Principal maturity preference "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "interestPreferenceSelected_Input"
    }
  }, [_vm._v("\n          Interest payment preference "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin bottom-margin"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "panel-subtitle"
  }, [_vm._v("\n        Displayed\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "panel-subtitle"
  }, [_vm._v("\n        Non displayed\n      ")])])])
}]}

/***/ }),
/* 2130 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.isTransactionModalVisible) ? _c('transaction', {
    attrs: {
      "informationMessage": "Transactions older than 1 Jan 2013 are not shown"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isInformationModalVisible) ? _c('information') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('dismissable-alert', {
    attrs: {
      "title": "You've purchased a Community Investment Note!",
      "subtitle": "Your investment will take 3 to 4 business days to be processed. You will receive a notification when it's completed.",
      "closeAction": _vm.hidePurchaseCompletedAlert,
      "isShowing": _vm.showPurchaseCompleted
    }
  }), _vm._v(" "), (!_vm.disableInvestment && (_vm.userStatus && _vm.userStatus.status !== 'no_status') && !_vm.isInstitutionAccount) ? _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "button",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": function($event) {
        _vm.purchaseNote()
      }
    }
  }, [_vm._v("\n                  Make an investment\n            ")]) : _vm._e(), _vm._v(" "), (_vm.userStatus && _vm.userStatus.status !== 'new') ? _c('div', [_c('div', {
    staticClass: "current-balance"
  }, [_c('p', {
    staticClass: "msg text-muted"
  }, [_vm._v("Current account balance: "), _c('strong', {
    staticClass: "amountBalance"
  }, [_vm._v(_vm._s(_vm.currentAmountBalance))])])])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive top-margin desktop-table"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortByNoteId()
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Note number")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('noteId')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "note-sort-title large-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('currentBalance')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('currentBalance')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "note-sort-title large-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('originalBalance')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('originalBalance')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('interestRate')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Rate")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('interestRate')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('interestTerm')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Term")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('interestTerm')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('purchasedOn')
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('purchasedOn')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('openedOn')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Open date")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('openedOn')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('maturityDate')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Maturity date")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('maturityDate')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortByStatus()
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Status")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('status')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("View details")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderedNotes), function(note) {
    return _c('tr', {
      key: note.noteId
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(note.noteId))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.originalBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatRate(note.interestRate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatTerm(note.interestTerm)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.purchasedOn)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.openedOn)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.maturityDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(note.status == 'cancelled') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (note.status == 'failed') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (note.status == 'pending') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (note.status == 'open') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Open")]) : _vm._e(), _vm._v(" "), (note.status == 'closed') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Closed")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button",
        "disabled": _vm.isReadOnly
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(note)
        }
      }
    }, [_vm._v("View details")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-card-view"
  }, [_c('div', {
    staticClass: "notes-cards-mobile"
  }, _vm._l((_vm.orderedNotes), function(note) {
    return _c('div', {
      key: note.noteId,
      staticClass: "note-card-mobile"
    }, [_c('div', {
      staticClass: "note-card-mobile-header"
    }, [_c('div', {
      staticClass: "note-card-mobile-number"
    }, [_c('span', {
      staticClass: "note-label"
    }, [_vm._v("Note")]), _vm._v(" "), _c('span', {
      staticClass: "note-number"
    }, [_vm._v(_vm._s(note.noteId))])]), _vm._v(" "), _c('span', {
      staticClass: "label note-status-badge",
      class: {
        'label-danger': note.status === 'cancelled' || note.status === 'failed' || note.status === 'closed',
          'label-warning': note.status === 'pending',
          'label-success': note.status === 'open'
      }
    }, [_vm._v("\n                    " + _vm._s(note.status) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-mobile-body"
    }, [_c('div', {
      staticClass: "note-card-mobile-row highlight-row"
    }, [_c('span', {
      staticClass: "note-card-mobile-label"
    }, [_vm._v("Current principal:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-mobile-value amount-value"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-mobile-row"
    }, [_c('span', {
      staticClass: "note-card-mobile-label"
    }, [_vm._v("Original principal:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-mobile-value"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.originalBalance)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-mobile-row"
    }, [_c('span', {
      staticClass: "note-card-mobile-label"
    }, [_vm._v("Rate:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-mobile-value"
    }, [_vm._v(_vm._s(_vm.formatRate(note.interestRate)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-mobile-row"
    }, [_c('span', {
      staticClass: "note-card-mobile-label"
    }, [_vm._v("Term:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-mobile-value"
    }, [_vm._v(_vm._s(_vm.formatTerm(note.interestTerm)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-mobile-row"
    }, [_c('span', {
      staticClass: "note-card-mobile-label"
    }, [_vm._v("Purchase date:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-mobile-value"
    }, [_vm._v(_vm._s(_vm.formatDate(note.purchasedOn)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-mobile-row"
    }, [_c('span', {
      staticClass: "note-card-mobile-label"
    }, [_vm._v("Open date:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-mobile-value"
    }, [_vm._v(_vm._s(_vm.formatDate(note.openedOn)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-mobile-row"
    }, [_c('span', {
      staticClass: "note-card-mobile-label"
    }, [_vm._v("Maturity date:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-mobile-value"
    }, [_vm._v(_vm._s(_vm.formatDate(note.maturityDate)))])])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-mobile-action"
    }, [_c('button', {
      staticClass: "btn btn-mobile-details",
      attrs: {
        "type": "button",
        "disabled": _vm.isReadOnly
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(note)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" View details\n                  ")])])])
  }))])], 1)])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Manage Investments\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Notes list")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-container"
  }, [_c('span', [_vm._v("Current")]), _vm._v(" "), _c('span', [_vm._v("principal")]), _vm._v(" "), _c('span', [_vm._v("amount")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-container"
  }, [_c('span', [_vm._v("\n                          Original\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          principal\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          amount\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-container"
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Purchase date")])])
}]}

/***/ }),
/* 2131 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mt-4"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [(_vm.isInformationModalVisible) ? _c('information', [_c('template', {
    slot: "header"
  }, [_c('div', {
    staticClass: "alert alert-warning d-flex align-items-center justify-content-center text-center",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', [_c('strong', [_vm._v("Thanks for registering to invest in communities with us!\n                      For security purposes, additional information is required to verify your identity.")])])])]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-accept",
    on: {
      "click": _vm.beginKba
    }
  }, [_vm._v("Start questionnaire")])])])])], 2) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "card-title mb-3"
  }, [_vm._v("Identity Verification")]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.errorMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.successMessage) ? _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.successMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center justify-content-start mb-3"
  }, [_c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("About")]), _vm._v(" "), _c('div', {
    staticClass: "h5 friendly-timer"
  }, [_c('span', {
    staticClass: "badge badge-info"
  }, [_vm._v(_vm._s(_vm.formattedTime))])])])]), _vm._v(" "), _c('dismissable-alert', {
    staticClass: "mb-3",
    attrs: {
      "isShowing": true,
      "dismissible": false,
      "alertType": "success",
      "showIcon": true,
      "icon": "information",
      "title": "About these questions",
      "subtitle": "We do not store your questions or answers. They are provided by our verification partner from publicly available government records."
    }
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "text-center my-4"
  }, [_c('div', {
    staticClass: "spinner-border text-info",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small text-muted mt-2"
  }, [_vm._v("Loading questions…")])]) : _vm._e(), _vm._v(" "), (_vm.questions.length) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_vm._l((_vm.questions), function(q, qi) {
    return _c('div', {
      key: q.id,
      staticClass: "card mb-4 question-card shadow-sm",
      attrs: {
        "aria-labelledby": ("q-" + (q.id) + "-label")
      }
    }, [_c('div', {
      staticClass: "card-header d-flex justify-content-between align-items-center"
    }, [_c('strong', [_vm._v("Question " + _vm._s(qi + 1))]), _vm._v(" "), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v("Select one")])]), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [_c('div', {
      staticClass: "question-text mb-3",
      attrs: {
        "id": ("q-" + (q.id) + "-label")
      }
    }, [_vm._v(_vm._s(q.text))]), _vm._v(" "), _c('div', {
      staticClass: "answers"
    }, _vm._l((q.answers), function(ans) {
      return _c('div', {
        key: ans.id,
        staticClass: "answer-item mb-2 p-2 border rounded"
      }, [_c('div', {
        staticClass: "custom-control custom-radio"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selectedAnswers[q.id]),
          expression: "selectedAnswers[q.id]"
        }],
        staticClass: "custom-control-input",
        attrs: {
          "type": "radio",
          "name": ("q-" + (q.id)),
          "id": ("q-" + (q.id) + "-a-" + (ans.id)),
          "disabled": _vm.submitting || _vm.loading || _vm.expired
        },
        domProps: {
          "value": ans.id,
          "checked": _vm._q(_vm.selectedAnswers[q.id], ans.id)
        },
        on: {
          "__c": function($event) {
            _vm.$set(_vm.selectedAnswers, q.id, ans.id)
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "custom-control-label",
        attrs: {
          "for": ("q-" + (q.id) + "-a-" + (ans.id))
        }
      }, [_vm._v("\n                        " + _vm._s(ans.text) + "\n                      ")])])])
    }))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mt-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isComplete || _vm.submitting || _vm.expired
    }
  }, [_vm._v("\n                Submit Answers\n              ")]), _vm._v(" "), (_vm.expired) ? _c('span', {
    staticClass: "text-danger ml-3"
  }, [_vm._v("Session expired.")]) : _vm._e()])], 2) : _vm._e()], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 2132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "top": "130px"
    },
    attrs: {
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('div', {
    staticClass: "modal-close col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "modal-button",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title "
  }, [_vm._v("Search for existing investor, minor or advisor to add as new representative")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body mt-lg"
  }, [_c('form', {
    staticClass: "mb-xl top-margin form-row",
    attrs: {
      "role": "form",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback searchbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "autofocus": "",
      "id": "search",
      "type": "text",
      "placeholder": "Search by first name, last name, or user email",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSearchDisabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.searchInvestors()
      }
    }
  }, [_c('em', {
    staticClass: "icon-magnifier pr-sm"
  }), _vm._v(" Search")])])]), _vm._v(" "), (_vm.investors.length === 0 && _vm.hasSearched) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg not-found-alert",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("No results found.")])])]) : _vm._e(), _vm._v(" "), (_vm.representativeWasAdded) ? _c('div', {
    staticClass: "alert alert-success alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.representativeWasAdded = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check-circle-o"
  }), _vm._v(" " + _vm._s(_vm.lastRepresentativeAdded) + " was added successfully as representative.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.investors.length > 0) ? _c('div', {
    staticClass: "table-responsive top-margin"
  }, [_c('table', {
    staticClass: "table table-striped bank-accounts table-fundings"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("First name")]), _vm._v(" "), _c('th', [_vm._v("Last name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("User type")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.investors), function(investor) {
    return _c('tr', {
      key: investor.id
    }, [_c('td', [_vm._v(_vm._s(investor.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(investor.lastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(investor.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getUserTypeLabel(investor.userType)))]), _vm._v(" "), _c('td', [(!_vm.isAccountRepresentative(investor.id)) ? _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.addRepresentativeToAccount(investor)
        }
      }
    }, [_vm._v("Add to account")]) : _c('span', {
      staticClass: "action-span green-text"
    }, [_c('i', {
      staticClass: "fa fa-check check"
    }), _vm._v("Added")])])])
  }))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-done",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("Done")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 2133 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Fail Transaction request")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-margin",
    attrs: {
      "id": "content-wrapper"
    }
  }, [_vm._l((_vm.fields()), function(field, idx) {
    return _c('div', {
      key: idx,
      staticClass: "row top-margin"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('div', [_c('label', [_vm._v(_vm._s(field.text))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('div', [_c('p', {
      staticClass: "text-right"
    }, [_vm._v("\n                    " + _vm._s(_vm.getValue(field.accessor)) + "\n                  ")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin",
    attrs: {
      "id": "comment-section"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Please append your comment below *")]), _vm._v(" "), _c('restricted-textarea', {
    attrs: {
      "input": _vm.transaction.comment,
      "limit": 255,
      "id": "comment",
      "required": true,
      "placeholder": ""
    },
    on: {
      "inputUpdated": _vm.commentUpdated
    }
  }), _vm._v(" "), (_vm.hasCommentChanged) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("You must enter or append a comment.")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin",
    attrs: {
      "id": "button-section"
    }
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableCancel
    },
    on: {
      "click": _vm.handleCancelRequest
    }
  }, [_vm._v("\n                  Cancel request\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableApprove
    },
    on: {
      "click": _vm.approveFailTransaction
    }
  }, [_vm._v("\n                  Approve request\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-approve buttons",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmit
    },
    on: {
      "click": _vm.submitRequest
    }
  }, [_vm._v("\n                  Submit request\n                ")])])])], 2)])])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
}]}

/***/ }),
/* 2134 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('FirstName')
    },
    attrs: {
      "type": "text",
      "name": "FirstName",
      "id": "FirstName",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('FirstName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('LastName')
    },
    attrs: {
      "type": "text",
      "name": "LastName",
      "id": "LastName",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('LastName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.financialAccount.organizationName),
      expression: "financialAccount.organizationName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('CompanyName1')
    },
    attrs: {
      "type": "text",
      "name": "CompanyName1",
      "id": "CompanyName1",
      "placeholder": "Company name"
    },
    domProps: {
      "value": (_vm.financialAccount.organizationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.financialAccount.organizationName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('CompanyName1')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Company name 2")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.financialAccount.alternateCompanyName),
      expression: "financialAccount.alternateCompanyName"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('CompanyName2')
    },
    attrs: {
      "type": "text",
      "name": "CompanyName2",
      "id": "CompanyName2",
      "placeholder": "Company name"
    },
    domProps: {
      "value": (_vm.financialAccount.alternateCompanyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.financialAccount.alternateCompanyName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('Email')
    },
    attrs: {
      "type": "text",
      "name": "Email",
      "id": "Email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, _vm.emailUpdated]
    }
  }), _vm._v(" "), (_vm.errors.has('Email')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("CRD number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.financialAccount.CRDnumber),
      expression: "financialAccount.CRDnumber"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('CRD')
    },
    attrs: {
      "type": "text",
      "name": "CRD",
      "id": "CRD",
      "placeholder": "CRD NUMBER"
    },
    domProps: {
      "value": (_vm.financialAccount.CRDnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.financialAccount.CRDnumber = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('CRD')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryPhoneNum),
      expression: "primaryPhoneNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    class: {
      'form-control': true,
      'form-control-error': _vm.errors.has('primaryPhoneNum')
    },
    attrs: {
      "id": "primaryPhoneNum",
      "name": "primaryPhoneNum",
      "placeholder": "Phone number"
    },
    domProps: {
      "value": (_vm.primaryPhoneNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.primaryPhoneNum = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.isValidPrimaryPhoneNumber()) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "secondaryPhoneNum"
    }
  }, [_vm._v("Secondary phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondaryPhoneNum),
      expression: "secondaryPhoneNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        regex: /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/
      }),
      expression: "{ regex:/^\\([0-9]{3}\\) [0-9]{3}-[0-9]{4}$/ }"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('secondaryPhoneNum')
    },
    attrs: {
      "id": "secondaryPhoneNum",
      "name": "secondaryPhoneNum",
      "type": "text"
    },
    domProps: {
      "value": (_vm.secondaryPhoneNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.secondaryPhoneNum = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('secondaryPhoneNum')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Wrong phone number")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("First name "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Last name "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Company name 1 "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Email "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "primaryPhoneNum"
    }
  }, [_vm._v("Primary phone number "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 2135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible) ? _c('div', {
    staticClass: "alert alert-success alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hide
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "icon-check"
  }), _vm._v(" " + _vm._s(_vm.message) + " ")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2136 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-control restricted-textarea"
  }, [_c('label', {
    class: _vm.getColor(),
    attrs: {
      "data-limit": ((_vm.inputValue.length) + "/" + _vm.limit)
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: ("" + _vm.required)
      }),
      expression: "{required: `${required}`}"
    }],
    class: _vm.textColorClass,
    attrs: {
      "rows": "4",
      "placeholder": _vm.placeholder,
      "maxlength": _vm.limit,
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "focus": _vm.enableShowLimit,
      "blur": _vm.disableShowLimit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.showNotice) ? _c('div', [_c('p', {
    staticClass: "notice-message"
  }, [_vm._v("Comments should not be longer than " + _vm._s(_vm.limit) + " characters")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2137 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.documents.length === 0) ? _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.documents.length > 0) ? _c('div', {
    class: {
      'table-fixed-header--md': _vm.documents.length > 6,
        'table-responsive': true,
        'bottom-margin': true,
        'overflow-y-off': true,
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.documents), function(document) {
    return _c('tr', {
      key: document.Key
    }, [_c('td', {
      staticClass: "file file-name name-data",
      on: {
        "click": function($event) {
          _vm.openDocument(document)
        }
      }
    }, [_c('i', {
      staticClass: "icon fa fa-file-text-o"
    }), _c('a', {
      attrs: {
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(document.Key))])]), _vm._v(" "), _c('td', {
      staticClass: "file-updated-date text-left uploaded-data"
    }, [_vm._v("\n            " + _vm._s(_vm.formatDate(!!document.Head &&
      !!document.Head.Metadata &&
      !!document.Head.Metadata.uploaded_at ? document.Head.Metadata.uploaded_at : document.LastModified)) + "\n          ")])])
  }))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        No documents were found.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left name-head"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-left uploaded-head"
  }, [_vm._v("Uploaded on")])])])
}]}

/***/ }),
/* 2138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    attrs: {
      "align": "center"
    }
  }, [_c('ContactUsHeader'), _vm._v(" "), _c('div', {
    staticClass: "block-center mt-xl wd-xl"
  }, [_c('div', {
    staticClass: "panel panel-dark panel-flat"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "Your new password",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "form-icon icon-lock"
  })]), _vm._v(" "), _c('PasswordHint', {
    attrs: {
      "password": _vm.password
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirmation),
      expression: "passwordConfirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "passwordConfirmation",
      "type": "password",
      "placeholder": "Confirm your new password",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.passwordConfirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirmation = $event.target.value
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "form-icon icon-lock"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default btn-lg mt-xl",
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit
    }
  }, [_vm._v("Change password")]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.resetPasswordError
    }
  }, [_c('strong', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock6"
    }
  }, [_vm._v(_vm._s(_vm.resetPasswordError))])])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center pv"
  }, [_c('strong', [_vm._v("Change Password")])])
}]}

/***/ }),
/* 2139 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Redeem request\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-margin"
  }, [_c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.formatNegativeAmount(_vm.redeemNote.principalAmount)))])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.formatNegativeAmount(_vm.redeemNote.currentAccrintValue)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    class: _vm.redeemNote.redeemFull ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redeemNote.redeemFull),
      expression: "redeemNote.redeemFull"
    }],
    attrs: {
      "id": "ritema",
      "name": "ritem",
      "type": "radio",
      "disabled": !_vm.redeemNote.isNewRedemption
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.redeemNote.redeemFull, true)
    },
    on: {
      "change": function($event) {
        _vm.resetRadioValue()
      },
      "__c": function($event) {
        _vm.redeemNote.redeemFull = true
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ritema"
    }
  })])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    class: !_vm.redeemNote.redeemFull ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redeemNote.redeemFull),
      expression: "redeemNote.redeemFull"
    }],
    attrs: {
      "id": "ritemb",
      "name": "ritem",
      "type": "radio",
      "disabled": !_vm.redeemNote.isNewRedemption
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.redeemNote.redeemFull, false)
    },
    on: {
      "change": function($event) {
        _vm.resetRadioValue()
      },
      "__c": function($event) {
        _vm.redeemNote.redeemFull = false
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ritemb"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redeemNote.fundingSource),
      expression: "redeemNote.fundingSource"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "FundingSource",
      "id": "FundingSource",
      "placeholder": "Please select",
      "disabled": !_vm.redeemNote.isNewRedemption
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.redeemNote.fundingSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_vm._l((_vm.redeemNote.fundingSources), function(fs) {
    return _c('option', {
      key: fs.id,
      domProps: {
        "value": fs.id
      }
    }, [_vm._v(_vm._s(fs.name))])
  }), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.donateFundingSource.name
    }
  }, [_vm._v(_vm._s(_vm.donateFundingSource.text))])], 2)]), _vm._v(" "), (!this.redeemNote.fundingSource || !this.redeemNote.fundingSources || this.redeemNote.fundingSources.length === 0) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("There must be a valid bank account for the redemption.")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [(_vm.redeemNote.redeemFull) ? _c('p', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.formatNegativeAmount(_vm.getUnformattedValue(_vm.redeemNote.redeemAmount))))]) : _vm._e(), _vm._v(" "), (!_vm.redeemNote.redeemFull) ? _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.redeemNote.redeemAmount),
      expression: "redeemNote.redeemAmount"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "id": "redeemPartialAmount",
      "autocomplete": "off",
      "required": "",
      "disabled": !_vm.redeemNote.isNewRedemption
    },
    domProps: {
      "value": (_vm.redeemNote.redeemAmount)
    },
    on: {
      "change": _vm.removeNegative,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.redeemNote.redeemAmount = $event.target.value
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.checkRemainingPrincipalAmount()) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("Please change this redemption request to ensure the remaining principal on the note is $20 or more.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.redeemNote.serviceFee),
      expression: "redeemNote.serviceFee"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "id": "serviceFee",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.redeemNote.serviceFee)
    },
    on: {
      "change": _vm.removeNegative,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.redeemNote.serviceFee = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('p', {
    staticClass: "text-right total-amount"
  }, [_vm._v(_vm._s(_vm.getPrincipalToRepay()))])])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator2"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin mb-lg"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [(_vm.redeemNote.redeemFull) ? _c('p', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.formatNegativeAmount(_vm.redeemNote.currentAccrintValue)))]) : _vm._e(), _vm._v(" "), (!_vm.redeemNote.redeemFull) ? _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.redeemNote.interestToReedem),
      expression: "redeemNote.interestToReedem"
    }],
    class: {
      'form-control text-right': true, 'form-control-error': _vm.getUnformattedValue(_vm.redeemNote.interestToReedem) > _vm.getUnformattedValue(_vm.redeemNote.currentAccrintValue)
    },
    attrs: {
      "id": "interestAmount",
      "autocomplete": "off",
      "required": "",
      "disabled": !_vm.redeemNote.isNewRedemption
    },
    domProps: {
      "value": (_vm.redeemNote.interestToReedem)
    },
    on: {
      "change": _vm.removeNegative,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.redeemNote.interestToReedem = $event.target.value
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.getUnformattedValue(_vm.redeemNote.interestToReedem) > _vm.getUnformattedValue(_vm.redeemNote.currentAccrintValue)) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("The interest payment cannot be greater than the accrued interest")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator2"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('p', {
    staticClass: "text-right total-amount"
  }, [_vm._v(_vm._s(_vm.getTotalPaidOut()))])])])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redeemNote.redemptionCategoryId),
      expression: "redeemNote.redemptionCategoryId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "RedemptionCategory",
      "id": "RedemptionCategory",
      "placeholder": "Please select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.redeemNote.redemptionCategoryId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.redeemNote.redemptionCategories), function(rc) {
    return _c('option', {
      key: rc.id,
      domProps: {
        "value": rc.id
      }
    }, [_vm._v("\n                      " + _vm._s(rc.label) + "\n                    ")])
  }))])])]), _vm._v(" "), (_vm.displayRedemptionCategoryHelperText) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.redeemNote.redemptionCategoryHelperText),
      expression: "redeemNote.redemptionCategoryHelperText",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "redemptionCategoryHelperText",
      "autocomplete": "off",
      "placeholder": "Enter a redemption category...",
      "required": ""
    },
    domProps: {
      "value": (_vm.redeemNote.redemptionCategoryHelperText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.redeemNote.redemptionCategoryHelperText = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.redeemNote.redeemFull && this.totalPaidOut <= 0) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("Please ensure the total paid out is more than $0.")])]) : _vm._e(), _vm._v(" "), (_vm.displayPaidOutError(_vm.redeemNote.redeemFull)) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("Please change this redemption request to ensure the total paid out and Principal to repay is more than $0.")])]) : _vm._e(), _vm._v(" "), (!_vm.redeemNote.isNewRedemption && !this.noteHasSufficientFunds) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("There are insufficient funds on this note to pay these transactions. Please edit the redemption values before approving payment.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Please append your comment below *")]), _vm._v(" "), _c('restricted-textarea', {
    attrs: {
      "input": _vm.redeemNote.comment,
      "limit": 255,
      "id": "comment",
      "required": true,
      "placeholder": ""
    },
    on: {
      "inputUpdated": _vm.commentUpdated
    }
  }), _vm._v(" "), (!_vm.redeemNote.comment || _vm.initialComment === _vm.redeemNote.comment) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("You must enter or append a comment.")])]) : _vm._e()], 1)]), _vm._v(" "), (!_vm.disableApprove) ? _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(12)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit",
      "disabled": !_vm.redeemNote.isNewRedemption && _vm.isCancelButtonDisabled()
    },
    on: {
      "click": function($event) {
        _vm.redeemNote.isNewRedemption ? _vm.goBack() : _vm.showRedeemConfirmationModal()
      }
    }
  }, [_vm._v("Cancel request")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableApprove
    },
    on: {
      "click": _vm.approveRedemption
    }
  }, [_vm._v("Approve payment")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-approve buttons",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmit
    },
    on: {
      "click": _vm.submitRequest
    }
  }, [_vm._v("Submit request")])])])])])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Principal amount:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Interest due:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', [_c('span', [_vm._v("Full")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', [_c('span', [_vm._v("Partial")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Bank account *")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('label', [_vm._v("Principal to redeem: *")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('label', [_vm._v("Service fee:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('label', [_vm._v("Principal to repay:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('label', {
    staticClass: "mt-sm pt-sm"
  }, [_vm._v("Interest payment:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('label', [_vm._v("Total paid to investor:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Redemption Category *")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "alert alert-info tip-alert"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n                  All transactions must be entered by "), _c('strong', [_vm._v("4:55 p.m. ET")]), _vm._v(" to be processed today.\n                ")])])
}]}

/***/ }),
/* 2140 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.isSuggestedAddressModalVisible) ? _c('address-suggestion') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-heading"
  }, [(_vm.accountType === 'institution') ? _c('div', [_vm._v("Create account / Institution account")]) : _vm._e(), _vm._v(" "), (_vm.accountType === 'trust') ? _c('div', [_vm._v("Create account / Trust account")]) : _vm._e(), _vm._v(" "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-back icon-back bottom-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Go back")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.isLoading || _vm.userDetailLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [(_vm.accountType === 'institution') ? _c('div', [_vm._v("Institution information")]) : _vm._e(), _vm._v(" "), (_vm.accountType === 'trust') ? _c('div', [_vm._v("Trust information")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', [(_vm.accountType === 'institution') ? _c('label', [_vm._v("Institution name*")]) : _vm._e(), _vm._v(" "), (_vm.accountType === 'trust') ? _c('label', [_vm._v("Trust name*")]) : _vm._e()])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [(_vm.accountType === 'institution') ? _c('div', [_c('RestrictedSingleInput', {
    attrs: {
      "input": _vm.institutionName,
      "limit": 40,
      "placeholderText": 'Institution name'
    },
    on: {
      "inputUpdated": _vm.onInstitutionNameUpdate
    }
  }), _vm._v(" "), (_vm.institutionNameChanged && _vm.institutionName.trim().length === 0) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.accountType === 'trust') ? _c('div', [_c('RestrictedSingleInput', {
    attrs: {
      "input": _vm.trustName,
      "limit": 40,
      "placeholderText": 'Trust name'
    },
    on: {
      "inputUpdated": _vm.onTrustNameUpdate
    }
  }), _vm._v(" "), (_vm.trustNameChanged && _vm.trustName.trim().length === 0) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 left-margin"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taxId),
      expression: "taxId"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.accountType === 'institution' ? '99-9999999' : '999999999'),
      expression: "accountType === 'institution' ? '99-9999999' : '999999999'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('taxId') || _vm.isTaxIdInvalid(_vm.taxId)
    },
    attrs: {
      "name": "taxId",
      "id": "taxId",
      "type": "text",
      "placeholder": "Tax ID"
    },
    domProps: {
      "value": (_vm.taxId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taxId = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('taxId') || _vm.isTaxIdInvalid(_vm.taxId)) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', [(_vm.accountType === 'institution') ? _c('label', [_vm._v("Institution type*")]) : _vm._e(), _vm._v(" "), (_vm.accountType === 'trust') ? _c('label', [_vm._v("Trust type*")]) : _vm._e()])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [(_vm.accountType === 'institution') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.institutionTypeSelected),
      expression: "institutionTypeSelected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('institutionType')
    },
    attrs: {
      "name": "institutionType",
      "id": "institutionType",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.institutionTypeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Institution type")]), _vm._v(" "), _vm._l((_vm.institutionTypes), function(institutionType, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": institutionType.name
      }
    }, [_vm._v(_vm._s(institutionType.text))])
  })], 2), _vm._v(" "), (_vm.errors.has('institutionType')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.accountType === 'trust') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trustTypeSelected),
      expression: "trustTypeSelected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('trustType')
    },
    attrs: {
      "name": "trustType",
      "id": "trustType",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trustTypeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Trust type")]), _vm._v(" "), _vm._l((_vm.trustTypes), function(trustType, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": trustType.name
      }
    }, [_vm._v(_vm._s(trustType.text))])
  })], 2), _vm._v(" "), (_vm.errors.has('trustType')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 left-margin"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('phoneNumber') || _vm.isPhoneNumberInvalid(_vm.phoneNumber)
    },
    attrs: {
      "name": "phoneNumber",
      "id": "phoneNumber",
      "type": "text",
      "placeholder": "Phone number"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('phoneNumber') || _vm.isPhoneNumberInvalid(_vm.phoneNumber)) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), (_vm.accountType === 'institution') ? _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.adjacentEmails), function(email, index) {
    return (_vm.accountType === 'institution') ? _c('div', {
      key: index,
      staticClass: "row bottom-margin"
    }, [_c('div', {
      staticClass: "col-md-5"
    }, [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.adjacentEmails[index]),
        expression: "adjacentEmails[index]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('email'),
        expression: "'email'"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true, 'form-control-error': _vm.errors.has('institutionEmail' + index)
      },
      attrs: {
        "name": 'institutionEmail' + index,
        "id": 'institutionEmail' + index,
        "type": "email",
        "placeholder": "Email"
      },
      domProps: {
        "value": (_vm.adjacentEmails[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.adjacentEmails, index, $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errors.has('institutionEmail' + index)) ? _c('span', {
      staticClass: "error-feedback"
    }, [_vm._v("Invalid email format")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-5"
    }, [(index === 0) ? _c('button', {
      staticClass: "btn btn-info btn-md button-add-more",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.addEmailSubmit()
        }
      }
    }, [_vm._v("Add more")]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [(_vm.accountType === 'institution') ? _c('div', [_vm._v("Institution address")]) : _vm._e(), _vm._v(" "), (_vm.accountType === 'trust') ? _c('div', [_vm._v("Trust address")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('RestrictedTwoInputs', {
    attrs: {
      "instructionsLabel": "Make sure your address doesn't exceed 50 characters.",
      "id": "ResidentialAddress",
      "fieldLabel": "Street address*",
      "primaryPlaceholder": "Street and number e.g. 123 Any Street",
      "secondaryPlaceholder": "(optional) Building, floor, etc.",
      "dual": true,
      "primaryInput": _vm.residentialAddress.streetAddress1,
      "secondaryInput": _vm.residentialAddress.streetAddress2
    },
    on: {
      "inputUpdated": _vm.residentialAddressUpdated
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residentialAddress.zipCode),
      expression: "residentialAddress.zipCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('zipCode') || _vm.isZipCodeInvalid(_vm.residentialAddress.zipCode)
    },
    attrs: {
      "name": "zipCode",
      "id": "zipCode",
      "type": "text",
      "placeholder": "Zip code"
    },
    domProps: {
      "value": (_vm.residentialAddress.zipCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.residentialAddress.zipCode = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('zipCode') || _vm.isZipCodeInvalid(_vm.residentialAddress.zipCode)) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residentialAddress.city),
      expression: "residentialAddress.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('mainCity')
    },
    attrs: {
      "name": "mainCity",
      "id": "mainCity",
      "type": "text",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.residentialAddress.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.residentialAddress.city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('mainCity')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residentialAddress.state),
      expression: "residentialAddress.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('state')
    },
    attrs: {
      "name": "state",
      "id": "state",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.residentialAddress.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _vm._l((_vm.countryStates('residentialAddress')), function(s, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": s.abbreviation
      }
    }, [_vm._v(_vm._s(s.name))])
  })], 2), _vm._v(" "), (_vm.errors.has('state')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residentialAddress.country),
      expression: "residentialAddress.country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('Country')
    },
    attrs: {
      "name": "Country",
      "id": "Country",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.residentialAddress.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _vm._l((_vm.geoLocation.countries), function(c, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": c.abbreviation
      }
    }, [_vm._v(_vm._s(c.name))])
  })], 2), _vm._v(" "), (_vm.errors.has('country')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasDifferentMailingAddress),
      expression: "hasDifferentMailingAddress"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "hasDifferentMailingAddress"
    },
    domProps: {
      "checked": Array.isArray(_vm.hasDifferentMailingAddress) ? _vm._i(_vm.hasDifferentMailingAddress, "") > -1 : (_vm.hasDifferentMailingAddress)
    },
    on: {
      "click": function($event) {
        _vm.submitDifferentMailingAddress()
      },
      "__c": function($event) {
        var $$a = _vm.hasDifferentMailingAddress,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.hasDifferentMailingAddress = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.hasDifferentMailingAddress = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.hasDifferentMailingAddress = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("Different mailing address\n                ")])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('RestrictedTwoInputs', {
    attrs: {
      "instructionsLabel": "Make sure your address doesn't exceed 50 characters.",
      "id": "MailingAddress",
      "fieldLabel": "Street address*",
      "primaryPlaceholder": "Street and number e.g. 123 Any Street",
      "secondaryPlaceholder": "(optional) Building, floor, etc.",
      "dual": true,
      "primaryInput": _vm.mailingAddress.streetAddress1,
      "secondaryInput": _vm.mailingAddress.streetAddress2,
      "isDisabled": !_vm.hasDifferentMailingAddress
    },
    on: {
      "inputUpdated": _vm.mailingAddressUpdated
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailingAddress.zipCode),
      expression: "mailingAddress.zipCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'form-control-error': (_vm.hasDifferentMailingAddress && _vm.errors.has('mailingZipCode')) || _vm.isZipCodeInvalid(_vm.mailingAddress.zipCode)
    },
    attrs: {
      "disabled": !_vm.hasDifferentMailingAddress,
      "name": "mailingZipCode",
      "id": "mailingZipCode",
      "type": "text",
      "placeholder": "Zip code"
    },
    domProps: {
      "value": (_vm.mailingAddress.zipCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailingAddress.zipCode = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasDifferentMailingAddress && (_vm.errors.has('mailingZipCode') || _vm.isZipCodeInvalid(_vm.mailingAddress.zipCode))) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailingAddress.city),
      expression: "mailingAddress.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'form-control-error': _vm.hasDifferentMailingAddress && _vm.errors.has('mailingCity')
    },
    attrs: {
      "disabled": !_vm.hasDifferentMailingAddress,
      "name": "mailingCity",
      "id": "mailingCity",
      "type": "text",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.mailingAddress.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailingAddress.city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasDifferentMailingAddress && _vm.errors.has('mailingCity')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailingAddress.state),
      expression: "mailingAddress.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control ': true, 'form-control-error': _vm.hasDifferentMailingAddress && _vm.errors.has('mailingState'), 'disabled-state': !_vm.hasDifferentMailingAddress
    },
    attrs: {
      "disabled": !_vm.hasDifferentMailingAddress,
      "name": "mailingState",
      "id": "mailingState",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mailingAddress.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _vm._l((_vm.countryStates('mailingAddress')), function(s, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": s.abbreviation
      }
    }, [_vm._v(_vm._s(s.name))])
  })], 2), _vm._v(" "), (_vm.hasDifferentMailingAddress && _vm.errors.has('mailingState')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailingAddress.country),
      expression: "mailingAddress.country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('Country'), 'disabled-state': !_vm.hasDifferentMailingAddress
    },
    attrs: {
      "disabled": !_vm.hasDifferentMailingAddress,
      "name": "Country",
      "id": "Country",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mailingAddress.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _vm._l((_vm.geoLocation.countries), function(c, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": c.abbreviation
      }
    }, [_vm._v(_vm._s(c.name))])
  })], 2), _vm._v(" "), (_vm.errors.has('country')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [(_vm.accountType === 'institution') ? _c('div', [_vm._v("Documentation of authorized signers")]) : _vm._e(), _vm._v(" "), (_vm.accountType === 'trust') ? _c('div', [_vm._v("Trust document")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-container",
    class: {
      'has-error': _vm.isFileInvalid
    }
  }, [_c('div', {
    staticClass: "bottom-margin"
  }, [_c('input', {
    ref: "fileupload",
    staticClass: "form-control filestyle",
    staticStyle: {
      "position": "absolute",
      "clip": "rect(0px 0px 0px 0px)"
    },
    attrs: {
      "type": "file",
      "data-classbutton": "btn btn-default",
      "data-classinput": "form-control inline",
      "id": "filestyle-0",
      "tabindex": "-1",
      "accept": _vm.getAcceptedFileExtensions()
    },
    on: {
      "change": _vm.fileChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bootstrap-filestyle input-group"
  }, [_c('input', {
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "placeholder": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.selectedFile ? _vm.selectedFile.name : ''
    }
  }), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Your file must be in JPG, JPEG, PNG, TIF or PDF format and cannot exceed 10MB.")]), _vm._v(" "), (_vm.isFileInvalid) ? _c('span', {
    staticClass: "help-block m-b-none"
  }, [_vm._v("The file you selected is not valid. Please select a different file.")]) : _vm._e()]), _vm._v(" "), (_vm.uploadedFiles.length > 0) ? _c('div', {
    staticClass: "space table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-files"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.uploadedFiles), function(file, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(new Date())))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      staticClass: "text-red",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeDocument(index)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-trash"
    })])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "space"
  })]) : _vm._e(), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.principalPaymentSelected),
      expression: "principalPaymentSelected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('principalPayment')
    },
    attrs: {
      "name": "principalPayment",
      "id": "principalPayment",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.principalPaymentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select principal payment preference")]), _vm._v(" "), _vm._l((_vm.paymentPreference), function(principal, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": principal.name
      }
    }, [_vm._v(_vm._s(principal.text))])
  })], 2), _vm._v(" "), (_vm.errors.has('principalPayment')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 left-margin"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interestPaymentSelected),
      expression: "interestPaymentSelected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('interestPayment')
    },
    attrs: {
      "name": "interestPayment",
      "id": "interestPayment",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interestPaymentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select interest payment preference")]), _vm._v(" "), _vm._l((_vm.paymentPreference), function(interest, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": interest.name
      }
    }, [_vm._v(_vm._s(interest.text))])
  })], 2), _vm._v(" "), (_vm.errors.has('interestPayment')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-approve",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmitButtonDisabled(_vm.errors)
    },
    on: {
      "click": function($event) {
        _vm.submitRequest()
      }
    }
  }, [_vm._v("Submit")])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-back icon-back bottom-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Go back")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  })], 2)])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Tax ID*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Phone number*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', [_c('label', [_vm._v("Additional emails for reporting")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Zip code*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("City*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("State*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Country*")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-title"
  }, [_c('div', [_vm._v("Mailing address")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Zip code*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("City*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("State*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Country*")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "group-span-filestyle input-group-btn",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('label', {
    staticClass: "btn btn-default document-label",
    attrs: {
      "for": "filestyle-0"
    }
  }, [_c('span', {
    staticClass: "icon-span-filestyle fa fa-folder-open"
  }), _vm._v(" "), _c('span', {
    staticClass: "buttonText"
  }, [_vm._v("Choose file")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("File name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Uploaded by")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-title space"
  }, [_c('div', [_vm._v("Payment preference")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', [_c('label', [_vm._v("Principal maturity preference*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Interest payment preference*")])])])])
}]}

/***/ }),
/* 2141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('address-form', {
    key: 1,
    ref: "residentialComponent",
    attrs: {
      "title": _vm.firstTitle,
      "parentAddress": _vm.residentialAddress,
      "states": _vm.geoLocation.states,
      "canada-states": _vm.geoLocation.canadaStates,
      "countries": _vm.geoLocation.countries,
      "validate-washington": true,
      "is-admin": _vm.isAdmin,
      "selected-user-type": _vm.selectedUserType
    }
  }), _vm._v(" "), (_vm.showPOBoxInput) ? _c('fieldset', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasBeenAllowedPOBox),
      expression: "hasBeenAllowedPOBox"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "hasBeenAllowedPOBox"
    },
    domProps: {
      "checked": Array.isArray(_vm.hasBeenAllowedPOBox) ? _vm._i(_vm.hasBeenAllowedPOBox, "") > -1 : (_vm.hasBeenAllowedPOBox)
    },
    on: {
      "click": _vm.handleAllowPOBox,
      "__c": function($event) {
        var $$a = _vm.hasBeenAllowedPOBox,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.hasBeenAllowedPOBox = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.hasBeenAllowedPOBox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.hasBeenAllowedPOBox = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("Allow PO Box\n    ")])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "checkbox c-checkbox check-margin mb-lg"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isMailingAddressDifferent),
      expression: "isMailingAddressDifferent"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "isMailingAddressDifferent"
    },
    domProps: {
      "checked": Array.isArray(_vm.isMailingAddressDifferent) ? _vm._i(_vm.isMailingAddressDifferent, "") > -1 : (_vm.isMailingAddressDifferent)
    },
    on: {
      "click": _vm.updateMailingAddress,
      "__c": function($event) {
        var $$a = _vm.isMailingAddressDifferent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isMailingAddressDifferent = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isMailingAddressDifferent = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isMailingAddressDifferent = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("Different mailing address\n    ")])]), _vm._v(" "), _c('address-form', {
    ref: "mailingComponent",
    attrs: {
      "title": _vm.secondTitle,
      "parentAddress": _vm.mailingAddress,
      "states": _vm.geoLocation.states,
      "canada-states": _vm.geoLocation.canadaStates,
      "countries": _vm.geoLocation.countries,
      "disabled": !_vm.isMailingAddressDifferent,
      "is-admin": _vm.isAdmin,
      "selected-user-type": _vm.selectedUserType,
      "isMailing": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 subtitle"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._t("default")], 2)])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.notesTransactions.length === 0) ? _c('no-upcoming-transactions') : _c('div', _vm._l((_vm.notesTransactions), function(nt, index) {
    return _c('div', {
      key: index,
      staticClass: "panel panel-default"
    }, [_c('upcoming-transaction-data', {
      attrs: {
        "transaction-id": nt.transaction.transactionId,
        "header-message": _vm.headerMessage,
        "alert-message": _vm.getAlertMessage(nt),
        "maturity-date": nt.transaction.maturityDate,
        "note-id": nt.transaction.note.noteId,
        "payment-type": nt.transaction.type,
        "amount": nt.transaction.amount
      }
    }, [
      [(!_vm.actionProvided) ? _c('div', {
        staticClass: "alert alert-info",
        attrs: {
          "role": "alert"
        }
      }, [_c('p', [_c('em', {
        staticClass: "icon icon-info pr-sm"
      }), _vm._v(_vm._s(_vm.headerMessage) + "\n              "), _c('strong', [_vm._v(_vm._s(_vm.getAlertMessage(nt)))]), _vm._v(" on\n              " + _vm._s(_vm.formatDate(nt.transaction.maturityDate)) + ".\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Please note that you're able to change this payment using the\n              options below.\n            ")])]) : _c('div', {
        staticClass: "alert alert-success",
        attrs: {
          "role": "alert"
        }
      }, [_c('p', [_c('em', {
        staticClass: "icon-check pr-sm"
      }), _vm._v("You have chosen to\n              "), _c('strong', [_vm._v(_vm._s(_vm.getAlertMessage(nt)))]), _vm._v(" on\n              " + _vm._s(_vm.formatDate(nt.transaction.maturityDate)) + ".\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Please note that you're able to change this payment using the\n              options below.\n            ")])])]
    ], 2), _vm._v(" "), _c('div', {
      staticClass: "transaction-reinvest"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Select from options below")])]), _vm._v(" "), (_vm.isReinvestActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Rate and term")])]) : _vm._e(), _vm._v(" "), (_vm.isDonateActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Donation amount")])]) : _vm._e(), _vm._v(" "), (_vm.isCashoutActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Select bank account")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.action),
        expression: "nt.action"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "name": "action",
        "required": ""
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          nt.action = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.$emit('actionChanged', {
            action: nt.action,
            index: index,
            actionPreviousTaken: _vm.actionProvided,
          })
        }]
      }
    }, _vm._l((_vm.allowedActions), function(action, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": action
        }
      }, [_vm._v(_vm._s(action.text) + "\n              ")])
    }))]), _vm._v(" "), (_vm.isReinvestActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('CustomRatesAndTermsForInvestor', {
      attrs: {
        "nt": nt,
        "action-provided": _vm.actionProvided
      },
      on: {
        "setRateAndTerm": _vm.setRateAndTerm
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isDonateActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.amountForDonation),
        expression: "nt.amountForDonation"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "disabled": true,
        "required": ""
      },
      domProps: {
        "value": (nt.amountForDonation)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nt.amountForDonation = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.isCashoutActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.fundingSource),
        expression: "nt.fundingSource"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "name": "fundingSource",
        "required": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          nt.fundingSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_vm._l((_vm.fundingSources), function(fs, index) {
      return (fs.removed) ? _c('option', {
        key: index,
        attrs: {
          "disabled": "",
          "hidden": ""
        },
        domProps: {
          "value": fs
        }
      }, [_vm._v(_vm._s(fs.name))]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.fundingSources), function(fs, index) {
      return (!fs.removed) ? _c('option', {
        key: index,
        domProps: {
          "value": fs
        }
      }, [_vm._v(_vm._s(fs.name))]) : _vm._e()
    })], 2), _vm._v(" "), (_vm.shouldSubmitButtonBeDisabled(nt)) ? _c('span', {
      staticClass: "error-feedback"
    }, [_vm._v("Please choose a bank account above or add one on the\n              "), _c('router-link', {
      staticClass: "hyperlink",
      attrs: {
        "to": {
          name: 'AddFundingSource'
        },
        "title": "Add a bank account",
        "replace": ""
      }
    }, [_vm._v("bank account page")])], 1) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.isReinvestActionTaken(nt.action)) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "checkbox c-checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.termsOfConditionAcceptance),
        expression: "nt.termsOfConditionAcceptance"
      }],
      attrs: {
        "type": "checkbox",
        "value": ""
      },
      domProps: {
        "checked": Array.isArray(nt.termsOfConditionAcceptance) ? _vm._i(nt.termsOfConditionAcceptance, "") > -1 : (nt.termsOfConditionAcceptance)
      },
      on: {
        "__c": function($event) {
          var $$a = nt.termsOfConditionAcceptance,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (nt.termsOfConditionAcceptance = $$a.concat($$v))
            } else {
              $$i > -1 && (nt.termsOfConditionAcceptance = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            nt.termsOfConditionAcceptance = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fa fa-check"
    }), _vm._v(" "), _c('terms-of-conditions', {
      attrs: {
        "hide-state-disclosures": ""
      }
    })], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('button', {
      staticClass: "btn btn-default btn-lg",
      attrs: {
        "type": "submit",
        "disabled": _vm.submitsDisabled || _vm.shouldSubmitButtonBeDisabled(nt)
      },
      on: {
        "click": function($event) {
          _vm.$emit('submit', nt, _vm.rateAndTerm)
        }
      }
    }, [_vm._v("\n            Submit\n          ")])])])], 1)
  }))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "line-separator bottom-margin"
  })])
}]}

/***/ }),
/* 2143 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "restricted-input"
  }, [(_vm.fieldLabel) ? _c('label', [_vm._v(_vm._s(_vm.fieldLabel))]) : _vm._e(), _vm._v(" "), (_vm.instructionsLabel) ? _c('label', {
    staticClass: "instructions-label"
  }, [_vm._v(_vm._s(_vm.instructionsLabel))]) : _vm._e(), _vm._v(" "), _c('label', {
    class: _vm.getColor(),
    attrs: {
      "data-limit": ((_vm.inputValue.length) + "/" + _vm.limit)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "restricted-input form-control",
    class: {
      'input-with-label': _vm.showLimit
    },
    attrs: {
      "id": "primaryInput",
      "type": "text",
      "maxlength": _vm.limit,
      "placeholder": _vm.placeholderText,
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "focus": _vm.enableShowLimit,
      "blur": _vm.disableShowLimit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputValue.length === _vm.limit && _vm.showLimit),
      expression: "inputValue.length === limit && showLimit"
    }],
    staticClass: "red-text"
  }, [_vm._v(_vm._s(_vm.errorMessage))])])
},staticRenderFns: []}

/***/ }),
/* 2144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "password-hint"
  }, [_c('div', {
    staticClass: "hint-title"
  }, [_vm._v("Password must contain:")]), _vm._v(" "), _c('div', {
    staticClass: "hint-criteria"
  }, _vm._l((_vm.criteria), function(criterion) {
    return _c('div', {
      key: criterion.id,
      staticClass: "criterion",
      class: {
        'matched': criterion.matched
      }
    }, [_c('span', {
      staticClass: "criterion-icon"
    }, [_c('i', {
      class: criterion.matched ? 'icon-check' : 'icon-close'
    })]), _vm._v(" "), _c('span', {
      staticClass: "criterion-text"
    }, [_vm._v(_vm._s(criterion.text))])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 2145 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), _c('bank-account-changed-warning', {
    attrs: {
      "isVisible": _vm.isBankAccountChangedWarningVisible,
      "isAdminView": true
    },
    on: {
      "close": _vm.hideBankAccountChangedWarning,
      "goToUpcomingTransactions": _vm.handleGoToUpcomingTransactions
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      " + _vm._s(_vm.accountType) + " account\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })]), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.userDetailLoading ||
    _vm.accountUsersLoading ||
    _vm.isNotesSegmentLoading ||
    _vm.isFundingSourcesSegmentLoading ||
    _vm.preferencesSpinner ||
    _vm.isUpcomingTransactionsSegmentLoading ||
    _vm.isRepresentativesLoading ||
    _vm.beneficiariesSpinner) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Account information")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('RestrictedSingleInput', {
    attrs: {
      "input": _vm.newAccountName,
      "limit": 40
    },
    on: {
      "inputUpdated": _vm.onNewAccountNameUpdate
    }
  }), _vm._v(" "), (_vm.newAccountName.trim().length === 0) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.formatDate(_vm.account.createdAt)) + " ")])])])]), _vm._v(" "), (_vm.account.investorSince) ? _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.account.investorSince) ? _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.investorSince) + " ")])])])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.legacyUsername) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "disabled": _vm.disableSubmitButton()
    },
    on: {
      "click": function($event) {
        _vm.showUpdateAccountConfirmationModal()
      }
    }
  }, [_vm._v("\n                      Submit account information\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.accountId) + " ")])])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [(_vm.account.status == 'active') ? _c('p', {
    staticClass: "label label-success capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.status == 'pending') ? _c('p', {
    staticClass: "label label-warning capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.status == 'inactive') ? _c('p', {
    staticClass: "label label-danger capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.hasUserComments) ? _c('p', {
    staticClass: "label label-danger capitalize-text"
  }, [_vm._v(" Comments ")]) : _vm._e()])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.legacyCustomerNumber) + " ")])])])])])])])])]), _vm._v(" "), (_vm.accountRepresentatives !== undefined && _vm.account.primaryInvestorId) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountRepresentatives', {
    attrs: {
      "accountId": _vm.accountId,
      "accountName": _vm.accountName,
      "accountType": _vm.accountType,
      "representatives": _vm.accountRepresentatives,
      "primaryInvestorId": _vm.account.primaryInvestorId
    },
    on: {
      "representativesLoadingStarted": _vm.setRepresentativesSpinnerOn,
      "representativesLoadingSucceed": _vm.setRepresentativesSpinnerOff,
      "representativesLoadingFailed": _vm.setRepresentativesSpinnerOff,
      "representativesUpdated": _vm.loadAccountInformation
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.beneficiaries !== undefined) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountBeneficiaries', {
    attrs: {
      "beneficiaries": _vm.beneficiaries,
      "accountId": _vm.accountId
    },
    on: {
      "beneficiaryLoadingStarted": _vm.setBeneficiariesSpinnerOn,
      "beneficiaryLoadingSucceed": _vm.setBeneficiariesSpinnerOff,
      "beneficiaryLoadingFailed": _vm.setBeneficiariesSpinnerOff,
      "beneficiariesUpdated": _vm.loadAccountInformation
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountNotes', {
    attrs: {
      "accountId": _vm.accountId,
      "displayAlertForUpcomingTransactionsWithAction": _vm.shouldUpcomingTransactionsWithActionsBeDisplayed,
      "displayAlertForUpcomingTransactionsWithNoAction": _vm.shouldUpcomingTransactionsWithNoActionsBeDisplayed,
      "disable-investment": _vm.user.disableInvestment
    },
    on: {
      "goToUpcomingTransactionsSegment": function($event) {
        _vm.goToSegment('upcoming-transactions-segment')
      },
      "notesLoadingFailed": _vm.setNotesSpinnerOff,
      "notesLoadingStarted": _vm.setNotesSpinnerOn,
      "notesLoadingSucceed": _vm.setNotesSpinnerOff,
      "redirectToNoteDetailsView": _vm.goToViewDetail,
      "redirectToPurchaseInvestmentNoteView": _vm.goToPurchaseInvestmentNote
    }
  })], 1)]), _vm._v(" "), (_vm.account.defaultFundingSourceId !== undefined) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "funding-sources-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountFundingSources', {
    attrs: {
      "accountId": _vm.accountId,
      "defaultFundingSourceId": _vm.userAccount.defaultFundingSourceId,
      "account": _vm.account
    },
    on: {
      "fundingSourcesLoadingFailed": _vm.setFundingSourceSpinnerOff,
      "fundingSourcesLoadingStarted": _vm.setFundingSourceSpinnerOn,
      "fundingSourcesLoadingSucceed": _vm.setFundingSourceSpinnerOff,
      "defaultFundingSourceUpdated": _vm.handleDefaultFundingSourceUpdated,
      "restart": _vm.loadAccountUsers,
      "showBankAccountChangedWarning": _vm.showBankAccountChangedWarning
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AdminAccountDocuments')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "preferences-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Preferences\n          ")]), _vm._v(" "), _c('SuccessAlert', {
    attrs: {
      "isVisible": _vm.isPreferencesSuccessMessageVisible,
      "message": _vm.preferencesSuccessMessage
    },
    on: {
      "hideSuccessAlert": _vm.hidePreferencesSuccessMessage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.account.communicationPreference !== undefined) ? _c('AccountPreferences', {
    attrs: {
      "accountId": _vm.accountId,
      "communicationPreference": _vm.account.communicationPreference,
      "interestPreference": _vm.account.interestPreference,
      "paymentPreference": _vm.account.paymentPreference,
      "communication1099Preference": _vm.account.communication1099Preference,
      "communicationImpactReportPreference": _vm.account.communicationImpactReportPreference,
      "user": _vm.user,
      "redemptionRestriction": _vm.account.redemptionRestriction
    },
    on: {
      "impactPreferencesLoadingFailed": _vm.setPreferencesSpinnerOff,
      "impactPreferencesLoadingStarted": _vm.setPreferencesSpinnerOn,
      "impactPreferencesLoadingSucceed": _vm.setPreferencesSpinnerOff,
      "updateImpactPreferencesFailed": _vm.setPreferencesSpinnerOff,
      "updateImpactPreferencesStarted": _vm.setPreferencesSpinnerOn,
      "updateImpactPreferencesSucceed": _vm.displayImpactPreferenceSuccessfulNotification
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "upcoming-transactions-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('UpcomingTransactions', {
    ref: "upcomingTransactions",
    attrs: {
      "accountId": _vm.accountId,
      "defaultFundingSourceId": _vm.userAccount.defaultFundingSourceId,
      "investorAccountIdentifier": _vm.userAccount.accountId
    },
    on: {
      "goToFundingSourcesSegment": function($event) {
        _vm.goToSegment('funding-sources-segment')
      },
      "hideAlertForUpcomingTransactions": _vm.hideUpcomingTransactionsAlerts,
      "showAlertForUpcomingTransactionsWithAction": _vm.displayUpcomingTransactionsWithActionAlert,
      "showAlertForUpcomingTransactionsWithNoAction": _vm.displayUpcomingTransactionsWithNoActionAlert,
      "upcomingTransactionsLoadingFailed": _vm.setUpcomingTransactionsSpinnerOff,
      "upcomingTransactionsLoadingStarted": _vm.setUpcomingTransactionsSpinnerOn,
      "upcomingTransactionsLoadingSucceed": _vm.setUpcomingTransactionsSpinnerOff
    }
  })], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Account name:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Date created:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Investor since:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Legacy username:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("ID:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Status:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Legacy customer number:")])])])])
}]}

/***/ }),
/* 2146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), _c('div', [_c('fieldset', [_vm._m(0), _vm._v(" "), (_vm.preferences.length > 0) ? _c('div', {
    staticClass: "col-sm-6"
  }, _vm._l((_vm.middleIndex), function(index) {
    return _c('div', {
      key: index - 1,
      staticClass: "checkbox c-checkbox"
    }, [(_vm.isGeneralPreference(index - 1)) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.preferences[index - 1].isSelected),
        expression: "preferences[index - 1].isSelected"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.preferences[index - 1].id,
        "disabled": _vm.isReadOnly
      },
      domProps: {
        "value": _vm.preferences[index - 1].id,
        "checked": Array.isArray(_vm.preferences[index - 1].isSelected) ? _vm._i(_vm.preferences[index - 1].isSelected, _vm.preferences[index - 1].id) > -1 : (_vm.preferences[index - 1].isSelected)
      },
      on: {
        "change": _vm.onChangeSelectImpactPreference,
        "__c": function($event) {
          var $$a = _vm.preferences[index - 1].isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = _vm.preferences[index - 1].id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.preferences[index - 1].isSelected = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.preferences[index - 1].isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.preferences[index - 1].isSelected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fa fa-check"
    }), _vm._v("\n            Where Calvert Impact Capital sees the most need and opportunity\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.isGeneralPreference(index - 1) && !_vm.isOtherPreference(index - 1)) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.preferences[index - 1].isSelected),
        expression: "preferences[index - 1].isSelected"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.preferences[index - 1].id,
        "disabled": _vm.isReadOnly
      },
      domProps: {
        "value": _vm.preferences[index - 1].id,
        "checked": Array.isArray(_vm.preferences[index - 1].isSelected) ? _vm._i(_vm.preferences[index - 1].isSelected, _vm.preferences[index - 1].id) > -1 : (_vm.preferences[index - 1].isSelected)
      },
      on: {
        "change": _vm.onChangeSelectImpactPreference,
        "__c": function($event) {
          var $$a = _vm.preferences[index - 1].isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = _vm.preferences[index - 1].id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.preferences[index - 1].isSelected = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.preferences[index - 1].isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.preferences[index - 1].isSelected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fa fa-check"
    }), _vm._v("\n            " + _vm._s(_vm.preferences[index - 1].preferenceText) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.isGeneralPreference(index - 1) && !_vm.isOtherPreference(index - 1)) ? _c('a', {
      staticClass: "checkbox-link",
      attrs: {
        "href": _vm.preferences[index - 1].url,
        "target": "_blank",
        "rel": "noopener",
        "aria-describedby": "new-window",
        "title": "Read more..."
      }
    }, [_c('em', {
      staticClass: "fa fa-external-link",
      attrs: {
        "aria-hidden": ""
      }
    })]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.preferences.length > 0) ? _c('div', {
    staticClass: "col-sm-6"
  }, _vm._l(((_vm.preferences.length - _vm.middleIndex)), function(index) {
    return _c('div', {
      key: index + _vm.middleIndex - 1,
      staticClass: "checkbox c-checkbox"
    }, [(_vm.isGeneralPreference(index + _vm.middleIndex - 1)) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.preferences[index - 1].isSelected),
        expression: "preferences[index - 1].isSelected"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.preferences[index - 1].id,
        "disabled": _vm.isReadOnly
      },
      domProps: {
        "value": _vm.preferences[index - 1].id,
        "checked": Array.isArray(_vm.preferences[index - 1].isSelected) ? _vm._i(_vm.preferences[index - 1].isSelected, _vm.preferences[index - 1].id) > -1 : (_vm.preferences[index - 1].isSelected)
      },
      on: {
        "change": _vm.onChangeSelectImpactPreference,
        "__c": function($event) {
          var $$a = _vm.preferences[index - 1].isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = _vm.preferences[index - 1].id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.preferences[index - 1].isSelected = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.preferences[index - 1].isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.preferences[index - 1].isSelected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fa fa-check"
    }), _vm._v("\n            Where Calvert Impact Capital sees the most need and opportunity\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.isGeneralPreference(index + _vm.middleIndex - 1) && !_vm.isOtherPreference(index + _vm.middleIndex - 1)) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.preferences[(index + _vm.middleIndex) - 1].isSelected),
        expression: "preferences[(index + middleIndex) - 1].isSelected"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.preferences[(index + _vm.middleIndex) - 1].id,
        "disabled": _vm.isReadOnly
      },
      domProps: {
        "value": _vm.preferences[(index + _vm.middleIndex) - 1].id,
        "checked": Array.isArray(_vm.preferences[(index + _vm.middleIndex) - 1].isSelected) ? _vm._i(_vm.preferences[(index + _vm.middleIndex) - 1].isSelected, _vm.preferences[(index + _vm.middleIndex) - 1].id) > -1 : (_vm.preferences[(index + _vm.middleIndex) - 1].isSelected)
      },
      on: {
        "change": _vm.onChangeSelectImpactPreference,
        "__c": function($event) {
          var $$a = _vm.preferences[(index + _vm.middleIndex) - 1].isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = _vm.preferences[(index + _vm.middleIndex) - 1].id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.preferences[(index + _vm.middleIndex) - 1].isSelected = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.preferences[(index + _vm.middleIndex) - 1].isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.preferences[(index + _vm.middleIndex) - 1].isSelected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fa fa-check"
    }), _vm._v("\n            " + _vm._s(_vm.preferences[(index + _vm.middleIndex) - 1].preferenceText) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.isGeneralPreference(index + _vm.middleIndex - 1) && !_vm.isOtherPreference(index + _vm.middleIndex - 1)) ? _c('a', {
      staticClass: "checkbox-link",
      attrs: {
        "href": _vm.preferences[index + _vm.middleIndex - 1].url,
        "target": "_blank",
        "rel": "noopener",
        "aria-describedby": "new-window",
        "title": "Read more..."
      }
    }, [_c('em', {
      staticClass: "fa fa-external-link",
      attrs: {
        "aria-hidden": ""
      }
    })]) : _vm._e()])
  })) : _vm._e()]), _vm._v(" "), _c('fieldset', {
    staticClass: "extra-option"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('RestrictedSingleInput', {
    attrs: {
      "dual": true,
      "input": _vm.other,
      "limit": 50,
      "warningLimit": 29,
      "fieldLabel": "Other",
      "instructionsLabel": "Make sure your text doesn't exceed 50 characters.",
      "placeholderText": 'Enter your preference here...',
      "isDisabled": _vm.isReadOnly
    },
    on: {
      "inputUpdated": _vm.selectOtherPreference
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": _vm.showConfirmationModal
    }
  }, [_vm._v("Submit")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "hidden": ""
    }
  }, [_c('span', {
    attrs: {
      "id": "new-window"
    }
  }, [_vm._v("Read more about it. This link opens in a new window.")])])
}]}

/***/ }),
/* 2147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "no-transactions"
  }, [_vm._v("\n      No transactions at the moment.\n    ")]), _vm._v(" "), _c('br'), _c('br'), _c('br')])])
}]}

/***/ }),
/* 2148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('FirstName')
    },
    attrs: {
      "type": "text",
      "name": "FirstName",
      "id": "FirstName",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('FirstName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('LastName')
    },
    attrs: {
      "type": "text",
      "name": "LastName",
      "id": "LastName",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('LastName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "date-time-input"
    }
  }, [_vm._v("Date of birth "), (!_vm.looseValidation) ? _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group input-group date birth-field-bottom"
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.looseValidation
      }),
      expression: "{required: !looseValidation}"
    }],
    class: {
      'form-control': true, 'form-control-error': !_vm.looseValidation && _vm.isBirthFieldInvalid
    },
    attrs: {
      "placeholder": "mm/dd/yyyy",
      "id": "date-time-input",
      "name": "date-time-input",
      "wrap": true,
      "config": _vm.dateBirthConfig
    },
    nativeOn: {
      "blur": function($event) {
        _vm.checkDateBirth(_vm.dateOfBirth)
      }
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), (!_vm.looseValidation && _vm.isBirthFieldInvalid) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e(), _vm._v(" "), (!_vm.looseValidation && !this.isDateBirthValid(_vm.dateOfBirth)) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("You must be 18 years or older in order to invest with us.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ssn"
    }
  }, [_vm._v("Social security number "), (!_vm.looseValidation) ? _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "availability-check-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialSecurityNum),
      expression: "socialSecurityNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.looseValidation,
        regex: /(^[0-9]{3}\-[0-9]{2}\-[0-9]{4}$)|(x{3}\-x{2}(\-[0-9]{4})?)/
      }),
      expression: "{required: !looseValidation, regex: /(^[0-9]{3}\\-[0-9]{2}\\-[0-9]{4}$)|(x{3}\\-x{2}(\\-[0-9]{4})?)/}"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('***-**-9999'),
      expression: "'***-**-9999'"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('ssn')
    },
    attrs: {
      "type": "text",
      "name": "ssn",
      "id": "ssn",
      "placeholder": "000-00-0000",
      "onfocus": "this.value=''"
    },
    domProps: {
      "value": (_vm.socialSecurityNum)
    },
    on: {
      "click": function($event) {
        _vm.socialSecurityNum = ''
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.socialSecurityNum = $event.target.value
      }, _vm.ssnInput],
      "blur": _vm.checkSsnAvailability
    }
  }), _vm._v(" "), (_vm.ssnAvailabilityStatus !== null) ? _c('div', {
    staticClass: "availability-indicator"
  }, [(_vm.ssnAvailabilityStatus === 'checking') ? _c('span', {
    staticClass: "fa fa-spinner fa-spin text-info"
  }) : _vm._e(), _vm._v(" "), (_vm.ssnAvailabilityStatus === 'available') ? _c('span', {
    staticClass: "fa fa-check text-success"
  }) : _vm._e(), _vm._v(" "), (_vm.ssnAvailabilityStatus === 'unavailable') ? _c('span', {
    staticClass: "fa fa-times text-danger"
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.errors.has('ssn')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('ssn')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Primary email"), (_vm.emailRequired) ? _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "availability-check-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('PrimaryEmail')
    },
    attrs: {
      "type": "text",
      "name": "PrimaryEmail",
      "id": "PrimaryEmail",
      "placeholder": "Primary email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, _vm.emailUpdated],
      "blur": _vm.checkEmailAvailability
    }
  }), _vm._v(" "), (_vm.emailAvailabilityStatus !== null) ? _c('div', {
    staticClass: "availability-indicator"
  }, [(_vm.emailAvailabilityStatus === 'checking') ? _c('span', {
    staticClass: "fa fa-spinner fa-spin text-info"
  }) : _vm._e(), _vm._v(" "), (_vm.emailAvailabilityStatus === 'available') ? _c('span', {
    staticClass: "fa fa-check text-success"
  }) : _vm._e(), _vm._v(" "), (_vm.emailAvailabilityStatus === 'unavailable') ? _c('span', {
    staticClass: "fa fa-times text-danger"
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.errors.has('PrimaryEmail')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('PrimaryEmail')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Secondary email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondaryEmail),
      expression: "secondaryEmail"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('SecondaryEmail')
    },
    attrs: {
      "type": "text",
      "name": "SecondaryEmail",
      "id": "SecondaryEmail",
      "placeholder": "Secondary Email"
    },
    domProps: {
      "value": (_vm.secondaryEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.secondaryEmail = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('SecondaryEmail')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first('SecondaryEmail')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryPhoneNum),
      expression: "primaryPhoneNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /(^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$)|([0-9]{10})/
      }),
      expression: "{ required: true, regex: /(^\\([0-9]{3}\\) [0-9]{3}-[0-9]{4}$)|([0-9]{10})/ }"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('primaryPhoneNum')
    },
    attrs: {
      "id": "primaryPhoneNum",
      "name": "primaryPhoneNum",
      "placeholder": "Phone number"
    },
    domProps: {
      "value": (_vm.primaryPhoneNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.primaryPhoneNum = $event.target.value
      }, _vm.onPhoneNumberChange]
    }
  }), _vm._v(" "), (_vm.errors.has('primaryPhoneNum')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "secondaryPhoneNum"
    }
  }, [_vm._v("Secondary phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondaryPhoneNum),
      expression: "secondaryPhoneNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        regex: /(^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$)|([0-9]{10})/
      }),
      expression: "{ regex:/(^\\([0-9]{3}\\) [0-9]{3}-[0-9]{4}$)|([0-9]{10})/ }"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('secondaryPhoneNum')
    },
    attrs: {
      "id": "secondaryPhoneNum",
      "name": "secondaryPhoneNum",
      "type": "text"
    },
    domProps: {
      "value": (_vm.secondaryPhoneNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.secondaryPhoneNum = $event.target.value
      }, _vm.onPhoneNumberChange]
    }
  }), _vm._v(" "), (_vm.errors.has('secondaryPhoneNum')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Wrong phone number")]) : _vm._e()])])]), _vm._v(" "), (_vm.enableMfa) ? _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mfaPhonePreference),
      expression: "mfaPhonePreference"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mfaPhonePreference"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mfaPhonePreference = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-- Select --")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PRIMARY",
      "disabled": !_vm.hasPrimaryPhone
    }
  }, [_vm._v("\n            Primary Phone\n          ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SECONDARY",
      "disabled": !_vm.hasSecondaryPhone
    }
  }, [_vm._v("\n            Secondary Phone\n          ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NONE"
    }
  }, [_vm._v("None (Email only)")])]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("\n          Select which phone number should be used for SMS multi-factor authentication.\n        ")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("First name "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Last name "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "primaryPhoneNum"
    }
  }, [_vm._v("Primary phone number "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "mfaPhonePreference"
    }
  }, [_c('strong', [_vm._v("MFA Phone Preference")])])
}]}

/***/ }),
/* 2149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Additional emails")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('SuccessAlert', {
    attrs: {
      "isVisible": _vm.isSuccessMessageDisplayed,
      "message": _vm.successMessage
    },
    on: {
      "hideSuccessAlert": _vm.hideSuccessMessage
    }
  }), _vm._v(" "), (_vm.emails.length === 0 && !_vm.shouldFormForNewEmailBeDisplayed) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.emails.length > 0 || _vm.shouldFormForNewEmailBeDisplayed) ? _c('div', {
    class: {
      'table-fixed-header--md cols-4': _vm.emails.length > 6, 'table-responsive': true, 'bottom-margin': true
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(_vm.shouldFormForNewEmailBeDisplayed) ? _c('tr', {
    class: {
      'new-email-form-shrunk': !_vm.errors.has('newEmail') && _vm.isEmailUnique(),
        'new-email-form-expanded': _vm.errors.has('newEmail') || !_vm.isEmailUnique(),
    },
    attrs: {
      "id": "newEmailRow"
    }
  }, [_c('td', {
    staticClass: "text-left column-email"
  }, [_c('div', {
    staticClass: "row margin-0"
  }, [_c('div', {
    staticClass: "row margin-0"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        email: true
      }),
      expression: "{ required: true, email: true }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('newEmail') || !_vm.isEmailUnique()
    },
    attrs: {
      "name": "newEmail",
      "id": "newEmail",
      "type": "email",
      "required": "",
      "placeholder": "e.g., john.doe@yourinstitution.com"
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row margin-0"
  }, [(_vm.errors.has('newEmail')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row margin-0"
  }, [(!_vm.isEmailUnique()) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Email cannot be a duplicate")]) : _vm._e()])])]), _vm._v(" "), _c('td', {
    staticClass: "text-left column-actions"
  }, [_c('div', {
    staticClass: "row margin-0"
  }, [_c('div', {
    staticClass: "col-lg-4 padding-0"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button--add buttons",
    attrs: {
      "type": "button",
      "disabled": _vm.errors.has('newEmail') || !_vm.newEmail || !_vm.isEmailUnique()
    },
    on: {
      "click": _vm.addNewEmail
    }
  }, [_vm._v("\n                  Add\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 text-center padding-0"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button--discard buttons",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideFormForNewEmail
    }
  }, [_vm._v("\n                  Discard\n                ")])])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.emails), function(emailObj, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-left column-email"
    }, [_vm._v(_vm._s(emailObj.email))]), _vm._v(" "), _c('td', {
      staticClass: "text-left column-actions"
    }, [_c('button', {
      staticClass: "btn btn-trash",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.showQuestionModalForDeletionOfEmail(emailObj.email)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-trash fa-2x delete-icon"
    })])])])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin bottom-margin"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.displayFormForNewEmail
    }
  }, [_vm._v("\n        Add additional email\n      ")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        No additional emails were found.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left column-email"
  }, [_vm._v("Email address")]), _vm._v(" "), _c('th', {
    staticClass: "text-left column-actions"
  }, [_vm._v("Actions")])])])
}]}

/***/ }),
/* 2150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.handleCancel($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title text-center"
  }, [_vm._v("Select Phone Number for MFA Texts")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "mb-lg"
  }, [_vm._v("\n          Please select the cell phone number that can receive texts for MFA codes, or edit an existing number to your\n          cell.\n        ")]), _vm._v(" "), _c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.error))])]), _vm._v(" "), _c('div', {
    staticClass: "phone-selector mb-lg"
  }, [_c('label', {
    staticClass: "phone-option",
    class: {
      'selected': _vm.selectedPhone === 'PRIMARY',
        'editing': _vm.editingPrimary
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPhone),
      expression: "selectedPhone"
    }],
    attrs: {
      "type": "radio",
      "name": "phonePreference",
      "value": "PRIMARY",
      "disabled": !_vm.hasValidPrimaryPhone && !_vm.editingPrimary
    },
    domProps: {
      "checked": _vm._q(_vm.selectedPhone, "PRIMARY")
    },
    on: {
      "__c": function($event) {
        _vm.selectedPhone = "PRIMARY"
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "phone-content"
  }, [_c('div', {
    staticClass: "phone-header"
  }, [_c('strong', [_vm._v("Primary Phone")]), _vm._v(" "), (!_vm.editingPrimary) ? _c('button', {
    staticClass: "btn btn-sm btn-link edit-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.startEditingPrimary($event)
      }
    }
  }, [_vm._v("\n                  Edit\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.editingPrimary) ? _c('div', {
    staticClass: "phone-input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editPrimaryPhone),
      expression: "editPrimaryPhone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    staticClass: "form-control phone-input-inline",
    attrs: {
      "id": "editPrimaryPhone",
      "type": "text",
      "placeholder": "(555) 123-4567"
    },
    domProps: {
      "value": (_vm.editPrimaryPhone)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "blur": _vm.stopEditingPrimary,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editPrimaryPhone = $event.target.value
      }
    }
  })]) : _c('div', {
    staticClass: "phone-display-value"
  }, [(_vm.displayPrimaryPhone || _vm.hasExistingPrimaryPhone) ? _c('small', [_vm._v("\n                  " + _vm._s(_vm.displayPrimaryPhone || _vm.formatPhoneForDisplay(_vm.user.primaryPhoneNum)) + "\n                ")]) : _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("(Not set)")])])])]), _vm._v(" "), _c('label', {
    staticClass: "phone-option",
    class: {
      'selected': _vm.selectedPhone === 'SECONDARY',
        'editing': _vm.editingSecondary
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPhone),
      expression: "selectedPhone"
    }],
    attrs: {
      "type": "radio",
      "name": "phonePreference",
      "value": "SECONDARY",
      "disabled": !_vm.hasValidSecondaryPhone && !_vm.editingSecondary
    },
    domProps: {
      "checked": _vm._q(_vm.selectedPhone, "SECONDARY")
    },
    on: {
      "__c": function($event) {
        _vm.selectedPhone = "SECONDARY"
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "phone-content"
  }, [_c('div', {
    staticClass: "phone-header"
  }, [_c('strong', [_vm._v("Secondary Phone")]), _vm._v(" "), (!_vm.editingSecondary) ? _c('button', {
    staticClass: "btn btn-sm btn-link edit-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.startEditingSecondary($event)
      }
    }
  }, [_vm._v("\n                  Edit\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.editingSecondary) ? _c('div', {
    staticClass: "phone-input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editSecondaryPhone),
      expression: "editSecondaryPhone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    staticClass: "form-control phone-input-inline",
    attrs: {
      "id": "editSecondaryPhone",
      "type": "text",
      "placeholder": "(555) 123-4567"
    },
    domProps: {
      "value": (_vm.editSecondaryPhone)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "blur": _vm.stopEditingSecondary,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editSecondaryPhone = $event.target.value
      }
    }
  })]) : _c('div', {
    staticClass: "phone-display-value"
  }, [(_vm.displaySecondaryPhone || _vm.hasExistingSecondaryPhone) ? _c('small', [_vm._v("\n                  " + _vm._s(_vm.displaySecondaryPhone || _vm.formatPhoneForDisplay(_vm.user.secondaryPhoneNum)) + "\n                ")]) : _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("(Not set)")])])])])]), _vm._v(" "), (!_vm.hasValidPrimaryPhone && !_vm.hasValidSecondaryPhone && !_vm.editingPrimary && !_vm.editingSecondary) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("\n          You need at least one phone number for SMS MFA. Please add a phone number above.\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer modal-buttons"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleEmailOnly
    }
  }, [_vm._v("I only want to receive login codes through email")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button",
      "disabled": _vm.saving || !_vm.canSave
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saving ? 'Saving...' : 'Save') + "\n        ")])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-lg"
  }, [_c('strong', [_vm._v("To keep your account secure, multi-factor authentication through text message is now\n            available.")]), _vm._v(" Standard text message rates from your carrier might apply.\n        ")])
}]}

/***/ }),
/* 2151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.INVESTOR)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "InvestorOption",
      "id": "InvestorOption",
      "value": "INVESTOR",
      "disabled": _vm.isFinanciaAdvisorOrAdmin()
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "INVESTOR")
    },
    on: {
      "__c": function($event) {
        _vm.user.userType = "INVESTOR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "InvestorOption"
    }
  }, [_vm._v("Investor")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.FINANCIAL_ADVISOR)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "FinancialAdvisorOption",
      "id": "FinancialAdvisorOption",
      "disabled": "",
      "value": "ADVISOR"
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "ADVISOR")
    },
    on: {
      "click": function($event) {
        _vm.selectAdvisor()
      },
      "__c": function($event) {
        _vm.user.userType = "ADVISOR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "FinancialAdvisorOption"
    }
  }, [_vm._v("Financial Advisor ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.MINOR)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "MinorOption",
      "id": "MinorOption",
      "value": "MINOR",
      "disabled": _vm.isFinanciaAdvisorOrAdmin()
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "MINOR")
    },
    on: {
      "__c": function($event) {
        _vm.user.userType = "MINOR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "MinorOption"
    }
  }, [_vm._v("Minor")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.ADMIN)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "AdminOption",
      "id": "AdminOption",
      "disabled": "",
      "value": "ADMIN"
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "ADMIN")
    },
    on: {
      "__c": function($event) {
        _vm.user.userType = "ADMIN"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "AdminOption"
    }
  }, [_vm._v("Admin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.INSTITUTIONAL_REPRESENTATIVE)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "InstitutionalRepresentativeOption",
      "id": "InstitutionalRepresentativeOption",
      "disabled": "",
      "value": "INSTITUTIONAL_REPRESENTATIVE"
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "INSTITUTIONAL_REPRESENTATIVE")
    },
    on: {
      "__c": function($event) {
        _vm.user.userType = "INSTITUTIONAL_REPRESENTATIVE"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "InstitutionalRepresentativeOption"
    }
  }, [_vm._v("Institutional Representative")])])])])])
},staticRenderFns: []}

/***/ }),
/* 2152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "restricted-input"
  }, [_c('label', [_vm._v(_vm._s(_vm.fieldLabel))]), _vm._v(" "), _c('label', {
    staticClass: "instructions-label"
  }, [_vm._v(_vm._s(_vm.instructionsLabel))]), _vm._v(" "), _c('label', {
    class: _vm.getColor('primary'),
    attrs: {
      "data-limit": (_vm.charactersUsed + "/" + _vm.limit)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryInputMessage),
      expression: "primaryInputMessage"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.isFirstInputRequired
      }),
      expression: "{required: isFirstInputRequired}"
    }],
    class: {
      'restricted-input form-control': true, 'form-control-error': _vm.errors.has('primaryInput')
    },
    attrs: {
      "id": "primaryInput",
      "name": "primaryInput",
      "type": "text",
      "maxlength": _vm.primaryInputLimit,
      "placeholder": _vm.primaryPlaceholder,
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": (_vm.primaryInputMessage)
    },
    on: {
      "focus": function($event) {
        _vm.enableShowLimit('primary')
      },
      "blur": function($event) {
        _vm.disableShowLimit('primary')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.primaryInputMessage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    class: _vm.getColor('secondary'),
    attrs: {
      "data-limit": (_vm.charactersUsed + "/" + _vm.limit)
    }
  }, [(_vm.dual) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondaryInputMessage),
      expression: "secondaryInputMessage"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.isSecondInputRequired
      }),
      expression: "{required: isSecondInputRequired}"
    }],
    class: {
      'restricted-input form-control': true, 'form-control-error': _vm.errors.has('secondaryInput')
    },
    attrs: {
      "id": "secondaryInput",
      "name": "secondaryInput",
      "type": "text",
      "maxlength": _vm.secondaryInputLimit,
      "placeholder": _vm.secondaryPlaceholder,
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": (_vm.secondaryInputMessage)
    },
    on: {
      "focus": function($event) {
        _vm.enableShowLimit('secondary')
      },
      "blur": function($event) {
        _vm.disableShowLimit('secondary')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.secondaryInputMessage = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('primaryInput') || _vm.errors.has('secondaryInput')),
      expression: "errors.has('primaryInput') || errors.has('secondaryInput')"
    }],
    staticClass: "red-text"
  }, [_vm._v("Required")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.charactersUsed === _vm.limit && (_vm.showLimitOnPrimary || _vm.showLimitOnSecondary)),
      expression: "charactersUsed === limit && (showLimitOnPrimary || showLimitOnSecondary)"
    }],
    staticClass: "red-text"
  }, [_vm._v(_vm._s(_vm.errorMessage))])])
},staticRenderFns: []}

/***/ }),
/* 2153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.disableSubmitDetailTransaction) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._v("\n        Transaction " + _vm._s(_vm.transaction.transactionId) + "\n      ")]), _vm._v(" "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-back icon-back bottom-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Go back")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-heading top-margin"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n              Transaction " + _vm._s(this.transaction.transactionId) + "       " + _vm._s(_vm.formatType(this.transaction.type, 'admin')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.account.accountName))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.formatTerm(_vm.note.interestTerm)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.user.fullName))])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.note.interestRate.toFixed(2).toString()) + _vm._s(_vm.note.interestRate ? '%' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.formatAmount(_vm.transaction.amount)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.user.primaryPhoneNum))])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.transaction.createdAt)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(this.transaction.transactionId))])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.transaction.updatedAt)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.formatType(_vm.transaction.type)))])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.transaction.dwollaTransferId))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.note.noteId))])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', {
    staticClass: "danger"
  }, [_vm._v(_vm._s(_vm.transaction.status))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', [_c('p', {
    staticClass: "danger"
  }, [_vm._v(_vm._s(_vm.transaction.failureReason))])])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Action comment:")]), _vm._v(" "), _c('restricted-textarea', {
    attrs: {
      "input": _vm.transaction.comment || '',
      "limit": 255,
      "id": "comment",
      "placeholder": "Please input a comment to mark a transaction as Lost."
    },
    on: {
      "inputUpdated": _vm.commentUpdated
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 m-top-10"
  }, [(!this.transaction.comment) ? _c('p', [_vm._v("Please add a comment if you decide to mark a transaction as Lost or you have processed it manually")]) : _vm._e(), _vm._v(" "), (_vm.transaction.comment && !_vm.transaction.lost && _vm.transaction.comment === _vm.previousLostComment) ? _c('p', [_c('i', [_vm._v("Please append a comment before marking this transaction as lost.")])]) : _vm._e(), _vm._v(" "), (_vm.transaction.comment && _vm.transaction.lost && _vm.transaction.comment === _vm.previousLostComment) ? _c('p', [_c('i', [_vm._v("Please append a comment before marking this transaction as unlost.")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitDetailTransaction || !_vm.transaction.comment
    },
    on: {
      "click": _vm.submitSaveLostComment
    }
  }, [_vm._v("Save")])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  }), _vm._v(" "), (!_vm.shouldUserNotBeAllowedToRetry()) ? _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(15)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-retry mr-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.shouldUserNotBeAllowedToRetry()
    },
    on: {
      "click": _vm.submitRetryTransaction
    }
  }, [_vm._v("Retry")]), _vm._v(" "), (!_vm.transaction.lost) ? _c('button', {
    staticClass: "btn btn-info btn-lg button-lost mr-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitDetailTransaction || !_vm.transaction.comment ||
        _vm.transaction.comment === _vm.previousLostComment
    },
    on: {
      "click": _vm.showLostConfirmationModal
    }
  }, [_vm._v("Lost\n            ")]) : _vm._e(), _vm._v(" "), (_vm.transaction.lost) ? _c('button', {
    staticClass: "btn btn-info btn-lg button-lost mr-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitDetailTransaction || !_vm.transaction.comment || _vm.transaction.comment === _vm.previousLostComment
    },
    on: {
      "click": _vm.showLostConfirmationModal
    }
  }, [_vm._v("Unlost")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-processed mr-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitDetailTransaction || _vm.transaction.lost
    },
    on: {
      "click": _vm.openModalToAskForProcessing
    }
  }, [_vm._v("Processed manually")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.lostSuccess) ? _c('div', {
    staticClass: "alert lost-comment alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                 " + _vm._s(_vm.successMessage) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.lostCommentSuccess) ? _c('div', {
    staticClass: "alert lost-comment alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                 Comment succesfully saved.\n              ")]) : _vm._e()])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Account name:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Term:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Name:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Rate:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Email:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Telephone number:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Transaction date:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Id:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Last updated date:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Transaction type:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Dwolla transaction:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Note number:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Status:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', [_c('label', [_vm._v("Transaction failure reason:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "alert alert-info tip-alert"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n                All transactions must be entered by "), _c('strong', [_vm._v("4:55 p.m. ET")]), _vm._v(" to be processed today.\n              ")])])
}]}

/***/ }),
/* 2154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isVisible) ? _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeModal($event)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.amount),
      expression: "formData.amount"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "id": "amount",
      "type": "text",
      "placeholder": "Enter amount",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.amount = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.amount) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.amount))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.noteId),
      expression: "formData.noteId"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "id": "noteId",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.formData.noteId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select a note")]), _vm._v(" "), _vm._l((_vm.availableNoteIds), function(noteOption, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": noteOption.noteId
      }
    }, [_vm._v("\n                  " + _vm._s(noteOption.label) + "\n                ")])
  })], 2), _vm._v(" "), (_vm.errors.noteId) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.noteId))]) : _vm._e(), _vm._v(" "), (_vm.availableNoteIds.length === 0) ? _c('span', {
    staticClass: "help-block text-warning"
  }, [_c('em', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" No notes available. Please ensure you have transactions with action taken that will reinvest.\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedFundingSourceIndex),
      expression: "selectedFundingSourceIndex"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "id": "fundingSourceType",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedFundingSourceIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select funding source type")]), _vm._v(" "), _vm._l((_vm.fundingSources), function(fundingSource, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v("\n                  " + _vm._s(fundingSource.name) + "\n                ")])
  })], 2), _vm._v(" "), (_vm.errors.fundingSourceType) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.errors.fundingSourceType))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeModal($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": !_vm.isFormValid || _vm.submitting
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("\n            " + _vm._s(_vm.submitting ? 'Submitting...' : 'Submit') + "\n          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.isVisible) ? _c('div', {
    staticClass: "modal-backdrop fade in"
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "modal-title"
  }, [_c('em', {
    staticClass: "fa fa-plus-circle text-blue"
  }), _vm._v(" Add Additional Reinvestment\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "amount"
    }
  }, [_vm._v("Amount "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "noteId"
    }
  }, [_vm._v("Note ID "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "fundingSourceType"
    }
  }, [_vm._v("Funding Source Type "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 2155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('em', {
    staticClass: "sa-icon sa-info icon-info mb-xl"
  }), _vm._v(" "), _vm._t("header"), _vm._v(" "), _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n          " + _vm._s(_vm.message) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_vm._t("body", [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-accept",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("OK")])])])])], 2)], 2)])])
},staticRenderFns: []}

/***/ }),
/* 2156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isCheckWireModalVisible) ? _c('CheckWire', {
    attrs: {
      "closeAction": _vm.modalToAddNewFundingSourceHasBeenClosed
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [(!_vm.showDwollaComponent) ? _c('div', [_c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Bank accounts")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin button-row"
  }, [_c('div', {
    staticClass: "col-lg-2 button-col"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg top-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openModalToAddNewFundingSource
    }
  }, [_vm._v("\n            Add check or Wire/ACH\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 button-col"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg addButton top-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addAccount()
      }
    }
  }, [_vm._v("\n            Add a bank account\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  })]), _vm._v(" "), (_vm.fundingSources.length === 0) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.fundingSources.length > 0 || _vm.showFundingTable) ? _c('div', {
    class: {
      'table-fixed-header--md cols-4': _vm.fundingSources.length > 6, 'table-responsive': true, 'bottom-margin': true, 'desktop-table': true
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.fundingSources), function(fundingSource, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(fundingSource.bankName ? fundingSource.bankName : '-----'))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(fundingSource.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(_vm.formatType(fundingSource.type, 'investor')))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      class: {
        'radio-item': true, 'radio-item-unselected': fundingSource.id.toString() !== _vm.currentDefaultFundingSourceId
      }
    }, [(fundingSource.status === 'verified') ? _c('input', {
      attrs: {
        "type": "radio",
        "id": fundingSource.id,
        "for": fundingSource.id
      },
      domProps: {
        "value": fundingSource.id.toString()
      },
      on: {
        "click": function($event) {
          _vm.showDefaultFundingSourceConfirmationModal(fundingSource)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('label', {
      attrs: {
        "for": fundingSource.id
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [(fundingSource.type !== _vm.fundingSourceTypes.CHECK.name && fundingSource.type !== _vm.fundingSourceTypes.WIRE_TRANSFER.name) ? _c('span', {
      staticClass: "label",
      class: fundingSource.status === 'verified' ? 'label-success' : 'label-warning'
    }, [_vm._v("\n                  " + _vm._s(fundingSource.status) + "\n                ")]) : _vm._e()])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.fundingSources.length > 0) ? _c('div', {
    staticClass: "mobile-card-view"
  }, [_c('div', {
    staticClass: "funding-cards"
  }, _vm._l((_vm.fundingSources), function(fundingSource, index) {
    return _c('div', {
      key: index,
      staticClass: "funding-card"
    }, [_c('div', {
      staticClass: "funding-card-header"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "funding-card-title"
    }, [_vm._v("\n                " + _vm._s(fundingSource.bankName ? fundingSource.bankName : '-----') + "\n              ")]), _vm._v(" "), (fundingSource.type !== _vm.fundingSourceTypes.CHECK.name && fundingSource.type !== _vm.fundingSourceTypes.WIRE_TRANSFER.name) ? _c('span', {
      staticClass: "label funding-card-status",
      class: fundingSource.status === 'verified' ? 'label-success' : 'label-warning'
    }, [_vm._v("\n                " + _vm._s(fundingSource.status) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "funding-card-body"
    }, [_c('div', {
      staticClass: "funding-card-row"
    }, [_c('span', {
      staticClass: "funding-card-label"
    }, [_vm._v("Account name:")]), _vm._v(" "), _c('span', {
      staticClass: "funding-card-value"
    }, [_vm._v(_vm._s(fundingSource.name))])]), _vm._v(" "), _c('div', {
      staticClass: "funding-card-row"
    }, [_c('span', {
      staticClass: "funding-card-label"
    }, [_vm._v("Type:")]), _vm._v(" "), _c('span', {
      staticClass: "funding-card-value"
    }, [_vm._v(_vm._s(_vm.formatType(fundingSource.type, 'investor')))])]), _vm._v(" "), (fundingSource.status === 'verified') ? _c('div', {
      staticClass: "funding-card-row funding-card-default"
    }, [_c('span', {
      staticClass: "funding-card-label"
    }, [_vm._v("Set as default:")]), _vm._v(" "), _c('div', {
      staticClass: "funding-card-radio"
    }, [_c('div', {
      class: {
        'radio-item-mobile': true, 'radio-item-selected': fundingSource.id.toString() === _vm.currentDefaultFundingSourceId
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": ("mobile-" + (fundingSource.id))
      },
      domProps: {
        "value": fundingSource.id.toString(),
        "checked": fundingSource.id.toString() === _vm.currentDefaultFundingSourceId
      },
      on: {
        "click": function($event) {
          _vm.showDefaultFundingSourceConfirmationModal(fundingSource)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("mobile-" + (fundingSource.id))
      }
    }, [_vm._v("\n                      " + _vm._s(fundingSource.id.toString() === _vm.currentDefaultFundingSourceId ? 'Default account' : 'Make default') + "\n                    ")])])])]) : _vm._e()])])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.showDwollaComponent) ? _c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "false",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('div', {
    staticClass: "modal-close col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "modal-button",
    on: {
      "click": _vm.closeDwollaModal
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("Add bank account")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body mt-lg"
  }, [_c('dwolla-funding-source-create', {
    attrs: {
      "customerId": _vm.account.dwollaCustomerId || _vm.currentDwollaCustomerIdFromStore,
      "initiateMicroDeposits": ""
    }
  })], 1), _vm._v(" "), (_vm.showDwollaAcknowledgeButton) ? _c('div', {
    staticClass: "modal-buttons"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.acknowledgeDwollaMessage
    }
  }, [_vm._v("Ok")])])])]) : _vm._e()])]) : _vm._e()])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n            No bank accounts were found.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bank name")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Account name")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Default")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Status")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "funding-card-icon"
  }, [_c('i', {
    staticClass: "fa fa-university"
  })])
}]}

/***/ }),
/* 2157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('div', {
    staticClass: "modal-close col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "modal-button",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title "
  }, [_vm._v("Transactions")]), _vm._v(" "), (_vm.showInformationMessage) ? _c('div', {
    staticClass: "panel-body account-notice"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    attrs: {
      "id": "transaction-message"
    }
  }, [_vm._v(_vm._s(_vm.informationMessage))])])]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "modal-subtitle"
  }, [_vm._v("\n            Note number: " + _vm._s(_vm.noteId) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "transaction-table-scroll-wrap"
  }, [_c('div', {
    ref: "tableScroll",
    staticClass: "table-responsive bottom-margin",
    on: {
      "scroll": _vm.onTableScroll
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Transaction type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.transactions), function(t, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(t.createdAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(t.amount)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatType(t.type, 'investor', t.fundingSourceId)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.isFailTransaction(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (_vm.isCancelTransaction(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (_vm.isPurchaseFailedTransaction(t)) ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (_vm.isPurchaseFailedTransactionWithSelectedErrorsCode(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (t.status == 'PENDING') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v(_vm._s(_vm.formatStatus(t.status)))]) : _vm._e(), _vm._v(" "), (t.status == 'PROCESSED') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v(_vm._s(_vm.formatStatus(t.status)))]) : _vm._e()])])
  }))])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showScrollRightHint),
      expression: "showScrollRightHint"
    }],
    staticClass: "transaction-scroll-right-btn",
    attrs: {
      "type": "button",
      "aria-label": "Scroll table all the way to the right"
    },
    on: {
      "click": _vm.scrollTableToEnd
    }
  }, [_c('em', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 2158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('dismissable-alert', {
    attrs: {
      "isShowing": _vm.isShowingReinvestmentNotice,
      "title": "Please take note!",
      "subtitle": "Transactions reinvested at the same rate/term on the same day will be reinvested together into one Note.",
      "notice": " Transactions that do not amount to $20 or greater when combined will be repaid to the default destination.",
      "alertType": "warning",
      "showIcon": true,
      "icon": "calendar-payment",
      "dismissible": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title top-margin bottom-margin"
  }, [_vm._v("Upcoming transactions")]), _vm._v(" "), (_vm.isExtraReinvestmentsEnabled) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._m(0), _vm._v(" "), (!_vm.hasAdditionalReinvestments) ? _c('div', [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.hasAdditionalReinvestments) ? _c('div', {
    staticClass: "table-responsive top-margin"
  }, [_c('table', {
    staticClass: "table table-striped additional-reinvestments-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.additionalReinvestments), function(ar, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(Number(ar.amount))))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(ar.reinvestDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(ar.fundingSourceType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(ar.status === 'PENDING') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (ar.status === 'FUNDS_TRANSFERRED') ? _c('span', {
      staticClass: "label label-info"
    }, [_vm._v("Funds Transferred")]) : _vm._e(), _vm._v(" "), (ar.status === 'PROCESSED') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Processed")]) : _vm._e(), _vm._v(" "), (ar.status === 'CANCELLED') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (ar.status === 'FAILED') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(ar.status === 'PENDING') ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "type": "button",
        "disabled": _vm.cancellingReinvestmentId === ar.id
      },
      on: {
        "click": function($event) {
          _vm.confirmCancelReinvestment(ar)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.cancellingReinvestmentId === ar.id ? 'Cancelling...' : 'Cancel') + "\n                  ")]) : _vm._e(), _vm._v(" "), (ar.status === 'FUNDS_TRANSFERRED') ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("\n                    Transfer in progress\n                  ")]) : _vm._e()])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openAddAdditionalReinvestmentModal
    }
  }, [_c('em', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Additional Reinvestment\n            ")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._m(3), _vm._v(" "), (!_vm.isThereAnyUpcomingTransactionWithNoAction()) ? _c('div', [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.isThereAnyUpcomingTransactionWithNoAction()) ? _c('div', _vm._l((_vm.notesTransactionsWithNoAction), function(nt, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "panel panel-default",
      attrs: {
        "id": "panelDemo1"
      }
    }, [_c('div', {
      staticClass: "panel-heading top-margin"
    }, [_c('div', {
      staticClass: "panel-title"
    }, [_vm._v("\n                  Transaction " + _vm._s(nt.transaction.transactionId) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "row notification"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "alert alert-info",
      attrs: {
        "role": "alert"
      }
    }, [_c('p', [_c('em', {
      staticClass: "icon icon-info pr-sm"
    }), _vm._v(_vm._s(_vm.getHeaderMessage()) + " "), _c('strong', [_vm._v(_vm._s(_vm.getAlertMessage(nt)))]), _vm._v("\n                      on " + _vm._s(_vm.formatDate(nt.transaction.maturityDate)) + ".")]), _vm._v(" "), _c('p', [_vm._v("Please note that you're able to change this payment using the options below.")])])])]), _vm._v(" "), _c('div', {
      staticClass: "row transation-info"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "row first-row"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm.formatDate(nt.transaction.maturityDate)))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(6, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v(_vm._s(nt.transaction.note.noteId))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "row first-row"
    }, [_vm._m(7, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm.getTypeOfPayment(nt.transaction.type)))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(8, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm.formatAmount(nt.transaction.amount)))])])])])]), _vm._v(" "), _vm._m(9, true), _vm._v(" "), _c('div', {
      staticClass: "transation-reinvest"
    }, [_c('div', {
      staticClass: "row"
    }, [_vm._m(10, true), _vm._v(" "), (_vm.isReinvestActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Rate and term")])]) : _vm._e(), _vm._v(" "), (_vm.isDonateActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Donation amount")])]) : _vm._e(), _vm._v(" "), (_vm.isCashoutActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Select bank account")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.action),
        expression: "nt.action"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "name": "action",
        "required": ""
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          nt.action = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.actionChanged(nt.action, index, false)
        }]
      }
    }, _vm._l((_vm.getActionsAllowedForThisTransaction()), function(action, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": action
        }
      }, [_vm._v(_vm._s(action.text) + " ")])
    }))]), _vm._v(" "), (_vm.isReinvestActionTaken(nt.action)) ? _c('div', [_c('CustomRateAndTerm', {
      attrs: {
        "manageRateAndTermGroupsId": nt.transaction.manageRateAndTermGroupsId,
        "mainContainer": 'left-padding',
        "term": nt.term,
        "rate": nt.rate,
        "nt": nt,
        "rateLimit": _vm.investmentsRestrictions.rateLimit
      },
      on: {
        "rateAndTermIsInvalid": function($event) {
          _vm.setRateAndTermAsInvalid(index, 'no-action')
        },
        "rateAndTermIsValid": function($event) {
          _vm.setRateAndTermAsValid(index, 'no-action')
        },
        "rateChanged": function($event) {
          _vm.setRate($event, index, 'no-action')
        },
        "termChanged": function($event) {
          _vm.setTerm($event, index, 'no-action')
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isDonateActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.amountForDonation),
        expression: "nt.amountForDonation"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "disabled": true,
        "required": ""
      },
      domProps: {
        "value": (nt.amountForDonation)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nt.amountForDonation = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.isCashoutActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.fundingSource),
        expression: "nt.fundingSource"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "name": "fundingSource",
        "required": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          nt.fundingSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_vm._l((_vm.fundingSources), function(fs, index) {
      return (fs.removed) ? _c('option', {
        key: index,
        attrs: {
          "disabled": "",
          "hidden": ""
        },
        domProps: {
          "value": fs
        }
      }, [_vm._v(_vm._s(fs.name))]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.fundingSources), function(fs, index) {
      return (!fs.removed) ? _c('option', {
        key: index,
        domProps: {
          "value": fs
        }
      }, [_vm._v(_vm._s(fs.name))]) : _vm._e()
    })], 2), _vm._v(" "), (_vm.shouldSubmitButtonBeDisabled(index, 'no-action')) ? _c('span', {
      staticClass: "error-feedback"
    }, [_vm._v("\n                      Please choose a bank account above or add one using the "), _c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.goToFundingSourcesSegment($event)
        }
      }
    }, [_vm._v("bank account section")])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('button', {
      staticClass: "btn btn-default btn-lg",
      attrs: {
        "type": "submit",
        "disabled": _vm.submitsDisabled || _vm.shouldSubmitButtonBeDisabled(index, 'no-action')
      },
      on: {
        "click": function($event) {
          _vm.submitUpcomingTransaction(nt)
        }
      }
    }, [_vm._v("Submit")])])])])])
  })) : _vm._e(), _vm._v(" "), _vm._m(11), _vm._v(" "), (!_vm.isThereAnyUpcomingTransactionWithAction()) ? _c('div', [_vm._m(12)]) : _vm._e(), _vm._v(" "), (_vm.isThereAnyUpcomingTransactionWithAction()) ? _c('div', _vm._l((_vm.notesTransactionsWithAction), function(nt, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "panel panel-default",
      attrs: {
        "id": "panelDemo1"
      }
    }, [_c('div', {
      staticClass: "panel-heading top-margin"
    }, [_c('div', {
      staticClass: "panel-title"
    }, [_vm._v("\n                  Transaction " + _vm._s(nt.transaction.transactionId) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "row notification"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "alert alert-success",
      attrs: {
        "role": "alert"
      }
    }, [_c('p', [_c('em', {
      staticClass: "icon-check pr-sm"
    }), _vm._v("You have chosen to "), _c('strong', [_vm._v(_vm._s(_vm.getAlertMessage(nt)))]), _vm._v("\n                      on " + _vm._s(_vm.formatDate(nt.transaction.maturityDate)) + ".")]), _vm._v(" "), _c('p', [_vm._v("Please note that you're able to change this payment using the options below.")])])])]), _vm._v(" "), _c('div', {
      staticClass: "row transation-info"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "row first-row"
    }, [_vm._m(13, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm.formatDate(nt.transaction.maturityDate)))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(14, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v(_vm._s(nt.transaction.note.noteId))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "row first-row"
    }, [_vm._m(15, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm.getTypeOfPayment(nt.transaction.type)))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(16, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm.formatAmount(nt.transaction.amount)))])])])])]), _vm._v(" "), _vm._m(17, true), _vm._v(" "), _c('div', {
      staticClass: "transation-reinvest"
    }, [_c('div', {
      staticClass: "row"
    }, [_vm._m(18, true), _vm._v(" "), (_vm.isReinvestActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Rate and term")])]) : _vm._e(), _vm._v(" "), (_vm.isDonateActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Donation amount")])]) : _vm._e(), _vm._v(" "), (_vm.isCashoutActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Select bank account")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.action),
        expression: "nt.action"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "name": "action",
        "required": ""
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          nt.action = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.actionChanged(nt.action, index, true)
        }]
      }
    }, _vm._l((_vm.getActionsAllowedForThisTransaction()), function(action, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": action
        }
      }, [_vm._v(_vm._s(action.text))])
    }))]), _vm._v(" "), (_vm.isReinvestActionTaken(nt.action)) ? _c('div', [_c('CustomRateAndTerm', {
      attrs: {
        "manageRateAndTermGroupsId": nt.transaction.manageRateAndTermGroupsId,
        "mainContainer": 'left-padding',
        "term": nt.term,
        "rate": nt.rate,
        "nt": nt,
        "rateLimit": _vm.investmentsRestrictions.rateLimit
      },
      on: {
        "rateAndTermIsInvalid": function($event) {
          _vm.setRateAndTermAsInvalid(index, 'action')
        },
        "rateAndTermIsValid": function($event) {
          _vm.setRateAndTermAsValid(index, 'action')
        },
        "rateChanged": function($event) {
          _vm.setRate($event, index, 'action')
        },
        "termChanged": function($event) {
          _vm.setTerm($event, index, 'action')
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isDonateActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.amountForDonation),
        expression: "nt.amountForDonation"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "disabled": true,
        "required": ""
      },
      domProps: {
        "value": (nt.amountForDonation)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nt.amountForDonation = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.isCashoutActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.fundingSource),
        expression: "nt.fundingSource"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "name": "fundingSource",
        "required": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          nt.fundingSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_vm._l((_vm.fundingSources), function(fs, index) {
      return (fs.removed) ? _c('option', {
        key: index,
        attrs: {
          "disabled": "",
          "hidden": ""
        },
        domProps: {
          "value": fs
        }
      }, [_vm._v(_vm._s(fs.name))]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.fundingSources), function(fs, index) {
      return (!fs.removed) ? _c('option', {
        key: index,
        domProps: {
          "value": fs
        }
      }, [_vm._v(_vm._s(fs.name))]) : _vm._e()
    })], 2), _vm._v(" "), (_vm.shouldSubmitButtonBeDisabled(index, 'action')) ? _c('span', {
      staticClass: "error-feedback"
    }, [_vm._v("\n                      Please choose a bank account above or add one using the "), _c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.goToFundingSourcesSegment($event)
        }
      }
    }, [_vm._v("bank account section")])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('button', {
      staticClass: "btn btn-default btn-lg",
      attrs: {
        "type": "submit",
        "disabled": _vm.submitsDisabled || _vm.shouldSubmitButtonBeDisabled(index, 'action')
      },
      on: {
        "click": function($event) {
          _vm.submitUpcomingTransaction(nt)
        }
      }
    }, [_vm._v("Submit")])])])])])
  })) : _vm._e()])])], 1), _vm._v(" "), _c('AddAdditionalReinvestment', {
    attrs: {
      "isVisible": _vm.showAdditionalReinvestmentModal,
      "availableNoteIds": _vm.getAvailableNoteIds(),
      "fundingSources": _vm.availableFundingSources
    },
    on: {
      "close": _vm.closeAddAdditionalReinvestmentModal,
      "save": _vm.saveAdditionalReinvestment
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 subtitle"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('em', {
    staticClass: "fa fa-exchange text-blue"
  }), _vm._v("Additional reinvestments")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "no-transactions"
  }, [_vm._v("\n                No additional reinvestments at the moment.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-right"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Reinvestment Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Funding Source")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 subtitle"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('em', {
    staticClass: "fa fa-exchange text-blue"
  }), _vm._v("Transactions you need to provide direction on")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "no-transactions"
  }, [_vm._v("\n                No transactions at the moment.\n              ")]), _vm._v(" "), _c('br'), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Transaction date:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Note number:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Payment type:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "line-separator top-margin"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "value"
  }, [_vm._v("Select from options below")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 subtitle"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('em', {
    staticClass: "fa fa-exchange text-gray"
  }), _vm._v("Transactions you've provided direction on")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "no-transactions"
  }, [_vm._v("\n                No transactions at the moment.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Transaction date:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Note number:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Payment type:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "line-separator top-margin"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "value"
  }, [_vm._v("Select from options below")])])
}]}

/***/ }),
/* 2159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), _c('bank-account-changed-warning', {
    attrs: {
      "isVisible": _vm.isBankAccountChangedWarningVisible,
      "isAdminView": true
    },
    on: {
      "close": _vm.hideBankAccountChangedWarning,
      "goToUpcomingTransactions": _vm.handleGoToUpcomingTransactions
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isUnlinkRepresentativesLoading || _vm.userDetailLoading || _vm.accountUsersLoading || _vm.isNotesSegmentLoading || _vm.isFundingSourcesSegmentLoading || _vm.preferencesSpinner || _vm.isUpcomingTransactionsSegmentLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Account information")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.accountName) + " ")])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.formatDate(_vm.account.createdAt)) + " ")])])])]), _vm._v(" "), (_vm.account.investorSince) ? _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.account.investorSince) ? _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.investorSince) + " ")])])])]) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.legacyUsername) + " ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.accountId) + " ")])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [(_vm.account.status == 'active') ? _c('p', {
    staticClass: "label label-success capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.status == 'pending') ? _c('p', {
    staticClass: "label label-warning capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.status == 'inactive') ? _c('p', {
    staticClass: "label label-danger capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.hasUserComments) ? _c('p', {
    staticClass: "label label-danger capitalize-text"
  }, [_vm._v(" Comments ")]) : _vm._e()])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.legacyCustomerNumber) + " ")])])])])])])])])]), _vm._v(" "), (_vm.accountRepresentatives !== undefined) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountRepresentatives', {
    attrs: {
      "accountId": _vm.accountId,
      "representatives": _vm.accountRepresentatives,
      "primaryInvestorId": _vm.account.primaryInvestorId,
      "accountName": _vm.accountName,
      "accountType": _vm.accountType
    },
    on: {
      "representativesLoadingStarted": _vm.setRepresentativesSpinnerOn,
      "representativesLoadingSucceed": _vm.setRepresentativesSpinnerOff,
      "representativesLoadingFailed": _vm.setRepresentativesSpinnerOff,
      "representativesUpdated": _vm.loadAccountInformation
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.beneficiaries !== undefined) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountBeneficiaries', {
    attrs: {
      "beneficiaries": _vm.beneficiaries,
      "accountId": _vm.accountId
    },
    on: {
      "beneficiaryLoadingStarted": _vm.setBeneficiariesSpinnerOn,
      "beneficiaryLoadingSucceed": _vm.setBeneficiariesSpinnerOff,
      "beneficiaryLoadingFailed": _vm.setBeneficiariesSpinnerOff,
      "beneficiariesUpdated": _vm.loadAccountInformation
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountNotes', {
    attrs: {
      "accountId": _vm.accountId,
      "displayAlertForUpcomingTransactionsWithAction": _vm.shouldUpcomingTransactionsWithActionsBeDisplayed,
      "displayAlertForUpcomingTransactionsWithNoAction": _vm.shouldUpcomingTransactionsWithNoActionsBeDisplayed,
      "disable-investment": _vm.user.disableInvestment
    },
    on: {
      "goToUpcomingTransactionsSegment": function($event) {
        _vm.goToSegment('upcoming-transactions-segment')
      },
      "notesLoadingFailed": _vm.setNotesSpinnerOff,
      "notesLoadingStarted": _vm.setNotesSpinnerOn,
      "notesLoadingSucceed": _vm.setNotesSpinnerOff,
      "redirectToNoteDetailsView": _vm.goToViewDetail,
      "redirectToPurchaseInvestmentNoteView": _vm.goToPurchaseInvestmentNote
    }
  })], 1)]), _vm._v(" "), (_vm.account.defaultFundingSourceId !== undefined) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "funding-sources-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountFundingSources', {
    attrs: {
      "accountId": _vm.accountId,
      "defaultFundingSourceId": _vm.userAccount.defaultFundingSourceId,
      "account": _vm.account
    },
    on: {
      "fundingSourcesLoadingFailed": _vm.setFundingSourceSpinnerOff,
      "fundingSourcesLoadingStarted": _vm.setFundingSourceSpinnerOn,
      "fundingSourcesLoadingSucceed": _vm.setFundingSourceSpinnerOff,
      "defaultFundingSourceUpdated": _vm.handleDefaultFundingSourceUpdated,
      "showBankAccountChangedWarning": _vm.showBankAccountChangedWarning
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AdminAccountDocuments')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "preferences-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Preferences\n          ")]), _vm._v(" "), _c('SuccessAlert', {
    attrs: {
      "isVisible": _vm.isPreferencesSuccessMessageVisible,
      "message": _vm.preferencesSuccessMessage
    },
    on: {
      "hideSuccessAlert": _vm.hidePreferencesSuccessMessage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.account.communicationPreference !== undefined) ? _c('AccountPreferences', {
    attrs: {
      "accountId": _vm.accountId,
      "interestPreference": _vm.account.interestPreference,
      "redemptionRestriction": _vm.account.redemptionRestriction,
      "communicationPreference": _vm.account.communicationPreference,
      "communication1099Preference": _vm.account.communication1099Preference,
      "communicationImpactReportPreference": _vm.account.communicationImpactReportPreference,
      "paymentPreference": _vm.account.paymentPreference,
      "user": _vm.user
    },
    on: {
      "impactPreferencesLoadingFailed": _vm.setPreferencesSpinnerOff,
      "impactPreferencesLoadingStarted": _vm.setPreferencesSpinnerOn,
      "impactPreferencesLoadingSucceed": _vm.setPreferencesSpinnerOff,
      "updateImpactPreferencesFailed": _vm.setPreferencesSpinnerOff,
      "updateImpactPreferencesStarted": _vm.setPreferencesSpinnerOn,
      "updateImpactPreferencesSucceed": _vm.displayImpactPreferenceSuccessfulNotification
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "upcoming-transactions-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('UpcomingTransactions', {
    ref: "upcomingTransactions",
    attrs: {
      "accountId": _vm.accountId,
      "defaultFundingSourceId": _vm.userAccount.defaultFundingSourceId,
      "investorAccountIdentifier": _vm.userAccount.accountId
    },
    on: {
      "goToFundingSourcesSegment": function($event) {
        _vm.goToSegment('funding-sources-segment')
      },
      "hideAlertForUpcomingTransactions": _vm.hideUpcomingTransactionsAlerts,
      "showAlertForUpcomingTransactionsWithAction": _vm.displayUpcomingTransactionsWithActionAlert,
      "showAlertForUpcomingTransactionsWithNoAction": _vm.displayUpcomingTransactionsWithNoActionAlert,
      "upcomingTransactionsLoadingFailed": _vm.setUpcomingTransactionsSpinnerOff,
      "upcomingTransactionsLoadingStarted": _vm.setUpcomingTransactionsSpinnerOn,
      "upcomingTransactionsLoadingSucceed": _vm.setUpcomingTransactionsSpinnerOff
    }
  })], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Individual account\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Name:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Date created:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Investor since:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Legacy username:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("ID:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Status:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Legacy customer number:")])])])])
}]}

/***/ }),
/* 2160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isInformationModalVisible) ? _c('information') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.isEmptyAnnouncement() && _vm.hasBeenCreatedAccount) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.announcementHTMLWithSafeLinks)
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading || _vm.hasBeenRedirected) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.isThereAnyUpcomingTransaction) ? _c('div', {
    staticClass: "alert alert-info mb-lg",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Click "), _c('router-link', {
    attrs: {
      "to": {
        name: 'UpcomingTransactionsForInvestor'
      },
      "title": "Upcoming Transactions",
      "replace": ""
    }
  }, [_vm._v("here")]), _vm._v(" to see the transactions you need to provide direction on.")], 1)]) : _vm._e(), _vm._v(" "), (!_vm.hasBeenCreatedAccount) ? _c('div', {
    staticClass: "welcome text-center"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "welcome-options"
  }, [_c('button', {
    staticClass: "card card-create",
    attrs: {
      "role": "link"
    },
    on: {
      "click": _vm.goToAccountCreation
    }
  }, [_c('em', {
    staticClass: "icon-user-follow card-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Create a new account")]), _vm._v(" "), _c('p', [_vm._v("Let's create an account with just three easy steps.")])])])]) : _vm._e(), _vm._v(" "), _c('dismissable-alert', {
    attrs: {
      "title": "You've purchased a Community Investment Note!",
      "subtitle": "Your investment will take 3 to 4 business days to be processed. You will receive a notification when it's completed.",
      "closeAction": _vm.hidePurchaseCompletedAlert,
      "isShowing": _vm.showPurchaseCompleted
    }
  }), _vm._v(" "), (_vm.hasBeenCreatedAccount) ? _c('div', [_c('div', {
    staticClass: "row-space-around"
  }, [_c('div', {
    staticClass: "current-balance"
  }, [_c('p', {
    staticClass: "msg text-muted panel-title mt-lg mb-lg"
  }, [_vm._v("Current account balance: "), _c('strong', {
    staticClass: "amountBalance"
  }, [_vm._v(_vm._s(_vm.currentAmountBalance))])])]), _vm._v(" "), (!_vm.disableInvestment && (_vm.userStatus && _vm.userStatus.status === 'verified') && !_vm.isInstitutionAccount && !_vm.isReadOnly) ? _c('button', {
    staticClass: "btn btn-default btn-lg m-vertical btn-full-mobile",
    attrs: {
      "type": "submit",
      "data-toggle": "tooltip",
      "data-placement": "top"
    },
    on: {
      "click": _vm.goToNotePurchase
    }
  }, [_vm._v("\n                  Make an investment\n              ")]) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticClass: "panel-title mt-lg mb-lg"
  }, [_vm._v("Here are your last 45 days of transactions:")]), _vm._v(" "), (_vm.transactions.length > 0) ? _c('div', {
    staticClass: "transactions-container"
  }, [_c('div', {
    staticClass: "transactions-table-desktop",
    class: {
      'table-fixed-header--md cols-5': _vm.transactions.length > 8, 'condensed': _vm.isThereAnyUpcomingTransaction
    }
  }, [_c('table', {
    staticClass: "table table-striped bank-accounts"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.transactions), function(t, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center",
      class: {
        'td-blocked': _vm.shouldDisplayBlock
      }
    }, [_vm._v(_vm._s(_vm.formatDate(t.createdAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      class: {
        'td-blocked': _vm.shouldDisplayBlock
      }
    }, [_vm._v(_vm._s(_vm.formatType(t.type, 'investor', t.fundingSourceId)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      class: {
        'td-blocked': _vm.shouldDisplayBlock
      }
    }, [_vm._v(_vm._s(t.note.noteId))]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      class: {
        'td-blocked': _vm.shouldDisplayBlock
      }
    }, [_vm._v(_vm._s(_vm.formatAmount(t.amount)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      class: {
        'td-blocked': _vm.shouldDisplayBlock
      }
    }, [(_vm.isFailTransaction(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (_vm.isCancelTransaction(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (_vm.isPurchaseFailedTransaction(t)) ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (_vm.isPurchaseFailedTransactionWithSelectedErrorsCode(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (t.status == 'PENDING') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v(_vm._s(_vm.formatStatus(t.status)))]) : _vm._e(), _vm._v(" "), (t.status == 'PROCESSED') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v(_vm._s(_vm.formatStatus(t.status)))]) : _vm._e()])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "transactions-cards-mobile"
  }, _vm._l((_vm.transactions), function(t, index) {
    return _c('div', {
      key: index,
      staticClass: "transaction-card"
    }, [_c('div', {
      staticClass: "transaction-card-header"
    }, [_c('div', {
      staticClass: "transaction-card-date"
    }, [_vm._v(_vm._s(_vm.formatDate(t.createdAt)))]), _vm._v(" "), (_vm.isFailTransaction(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (_vm.isCancelTransaction(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (_vm.isPurchaseFailedTransaction(t)) ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (_vm.isPurchaseFailedTransactionWithSelectedErrorsCode(t)) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (t.status == 'PENDING') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v(_vm._s(_vm.formatStatus(t.status)))]) : _vm._e(), _vm._v(" "), (t.status == 'PROCESSED') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v(_vm._s(_vm.formatStatus(t.status)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "transaction-card-body"
    }, [_c('div', {
      staticClass: "transaction-card-row"
    }, [_c('span', {
      staticClass: "transaction-card-label"
    }, [_vm._v("Transaction type:")]), _vm._v(" "), _c('span', {
      staticClass: "transaction-card-value"
    }, [_vm._v(_vm._s(_vm.formatType(t.type, 'investor', t.fundingSourceId)))])]), _vm._v(" "), _c('div', {
      staticClass: "transaction-card-row"
    }, [_c('span', {
      staticClass: "transaction-card-label"
    }, [_vm._v("Note number:")]), _vm._v(" "), _c('span', {
      staticClass: "transaction-card-value"
    }, [_vm._v(_vm._s(t.note.noteId))])]), _vm._v(" "), _c('div', {
      staticClass: "transaction-card-row transaction-card-amount"
    }, [_c('span', {
      staticClass: "transaction-card-label"
    }, [_vm._v("Amount:")]), _vm._v(" "), _c('span', {
      staticClass: "transaction-card-value"
    }, [_vm._v(_vm._s(_vm.formatAmount(t.amount)))])])])])
  }))]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (_vm.hasBeenCreatedAccount) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "updates-content"
  }, _vm._l((Object.values(_vm.summaryPageDocuments).filter(Boolean)), function(d, index) {
    return _c('button', {
      key: ("Card" + index),
      staticClass: "card card-update card-update-content",
      attrs: {
        "role": "link"
      },
      on: {
        "click": function($event) {
          _vm.openDocument(d)
        }
      }
    }, [_c('img', {
      staticClass: "card-icon",
      attrs: {
        "src": _vm.getIconUrl(d.icon, d.iconName),
        "alt": "icon",
        "height": "100"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(d.tag))])])
  }))]) : _vm._e()])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Account summary\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon icon-info pr-sm"
  }), _vm._v("Please note that you have upcoming transactions")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "welcome-header"
  }, [_c('h2', {
    staticClass: "welcome-title"
  }, [_vm._v("Thanks for registering!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "welcome-paragraph"
  }, [_c('strong', [_vm._v("Welcome to Calvert Impact Capital's investment platform.")]), _c('br'), _vm._v("We invite you to "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener",
      "aria-describedby": "new-window-0",
      "href": "https://www.calvertimpactcapital.org/about"
    }
  }, [_vm._v("learn about our work "), _c('em', {
    staticClass: "fa fa fa-external-link"
  })]), _vm._v(". And when you're ready, proceed to create a new account.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Transaction type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Note number")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "updates-header"
  }, [_c('h3', {
    staticClass: "panel-title mt-lg mb-lg"
  }, [_vm._v("Investor updates")]), _vm._v(" "), _c('h3', {
    staticClass: "panel-title mt-lg mb-lg latest-updates"
  }, [_c('a', {
    staticClass: "btn-right icon-right bottom-margin",
    attrs: {
      "href": "http://www.calvertimpactcapital.org/blog",
      "target": "_blank"
    }
  }, [_vm._v("\n                  See Latest Calvert Impact Capital Updates\n                ")])])])
}]}

/***/ }),
/* 2161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn-back icon-back bottom-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("\n      Go back\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.yearsRatesLoading || _vm.userDetailLoading || _vm.isSubmitting) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Purchase Community Investment Note\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.investmentAmount),
      expression: "investmentAmount"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control text-right input-md': true, 'form-control-error': _vm.isInvestmentAmountInvalid
    },
    attrs: {
      "autocomplete": "off",
      "name": "investmentAmount",
      "id": "investmentAmount"
    },
    domProps: {
      "value": (_vm.investmentAmount)
    },
    on: {
      "change": _vm.removeNegative,
      "blur": function($event) {
        _vm.validateInvestmentAmount()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.investmentAmount = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isInvestmentAmountInvalid) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.investmentAmountError))]) : _vm._e()])]), _vm._v(" "), _c('div', [_c('CustomRateAndTerm', {
    attrs: {
      "isCurrentRateAndTerm": true,
      "mainContainer": '',
      "rateLimit": _vm.investmentsRestrictions.rateLimit,
      "showDefaultValue": true,
      "predefinedRatesTerms": _vm.interestYearRates
    },
    on: {
      "rateAndTermIsInvalid": _vm.rateAndTermIsInvalid,
      "rateAndTermIsValid": _vm.rateAndTermIsValid,
      "rateChanged": _vm.rateChanged,
      "termChanged": _vm.termChanged
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fundingSourceSelected),
      expression: "fundingSourceSelected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control input-md': true, 'form-control-error': _vm.errors.has('fundingSource')
    },
    attrs: {
      "name": "fundingSource",
      "id": "fundingSource",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fundingSourceSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select bank account")]), _vm._v(" "), _vm._l((_vm.fundingSources), function(fundingSource, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": fundingSource.type
      }
    }, [_vm._v(_vm._s(fundingSource.name))])
  })], 2), _vm._v(" "), (_vm.errors.has('fundingSource')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group date"
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control input-md': true, 'form-control-error': _vm.isDateFundedInvalid
    },
    attrs: {
      "id": "dateFunded",
      "placeholder": "MM/DD/YYYY",
      "config": _vm.dateConfig,
      "name": "dateFunded",
      "wrap": true,
      "autocomplete": "off"
    },
    on: {
      "dp-change": _vm.validateDateFunded
    },
    model: {
      value: (_vm.dateFunded),
      callback: function($$v) {
        _vm.dateFunded = $$v
      },
      expression: "dateFunded"
    }
  }), _vm._v(" "), _vm._m(3)], 1), _vm._v(" "), (_vm.isDateFundedInvalid) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.dateFundedError))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), (_vm.fundingSourceSelected === 'brokerage') ? _c('div', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.distributorFee),
      expression: "distributorFee"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "id": "distributorFee",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.distributorFee)
    },
    on: {
      "change": _vm.removeNegative,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.distributorFee = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.brokerageFee),
      expression: "brokerageFee"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "id": "brokerageFee",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.brokerageFee)
    },
    on: {
      "change": _vm.removeNegative,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.brokerageFee = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), (_vm.fundingSourceSelected === 'brokerage') ? _c('div', [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cusip),
      expression: "cusip"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('*********'),
      expression: "'*********'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'form-control-error': _vm.isCusipInvalid
    },
    attrs: {
      "type": "text",
      "name": "cusip",
      "id": "cusip"
    },
    domProps: {
      "value": (_vm.cusip)
    },
    on: {
      "blur": function($event) {
        _vm.validateCusip()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cusip = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isCusipInvalid) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Please input 9 characters in order to proceed.")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-approve",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmitButtonDisabled()
    },
    on: {
      "click": function($event) {
        _vm.submitRequest()
      }
    }
  }, [_vm._v("\n                Submit request\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-back icon-back bottom-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("\n            Go back\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  })])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Purchase Community Investment Note\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Enter investment amount "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Select rate and term "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Select bank account "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Date funded "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Distributor fee*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Brokerage fee*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("CUSIP*")])])])
}]}

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Home\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "welcome text-center"
  }, [_c('header', {
    staticClass: "welcome-header"
  }, [_c('h3', {
    staticClass: "welcome-title"
  }, [_vm._v("Welcome to your financial advisor portal "), _c('br'), _vm._v("at Calvert Impact Capital")])]), _vm._v(" "), _c('p', {
    staticClass: "welcome-paragraph"
  }, [_vm._v("\n               We invite you to learn "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener",
      "aria-describedby": "new-window-0",
      "href": "https://www.calvertimpactcapital.org/about"
    }
  }, [_vm._v("about our work "), _c('em', {
    staticClass: "fa fa fa-external-link"
  })]), _vm._v(".\n               "), _c('br'), _vm._v("Or proceed to manage your clients' accounts.\n            ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row tutorial-row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "tutorial"
  }, [_c('header', {
    staticClass: "tutorial-header"
  }, [_c('h3', {
    staticClass: "tutorial-title"
  }, [_vm._v("How to access your client's accounts")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "tutorial-step"
  }, [_c('div', {
    staticClass: "image-holder"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(485),
      "alt": "step-1"
    }
  })]), _vm._v(" "), _c('ol', [_c('li', [_c('strong', [_vm._v("Click on your name at the top right of the page.")]), _vm._v(" "), _c('p', [_vm._v("A dropdown with links to your account and your clients' accounts will be shown.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tutorial-step"
  }, [_c('div', {
    staticClass: "image-holder"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(486),
      "alt": "step-2"
    }
  })]), _vm._v(" "), _c('ol', {
    attrs: {
      "start": "2",
      "id": "step-2"
    }
  }, [_c('li', [_c('strong', [_vm._v("Once you see the dropdown, click on one of your clients' accounts.")]), _vm._v(" "), _c('p', [_vm._v("Switch between client accounts from the dropdown.")])])])])])])])])])
}]}

/***/ }),
/* 2163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-heading"
  }, [_vm._v("Feedback")]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.hasProvidedFeedback) ? _c('dismissable-alert', {
    attrs: {
      "title": _vm.previousFeedbackMessage,
      "closeAction": _vm.hidePreviousFeedbackMessage,
      "isShowing": _vm.showPreviousFeedbackMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('dismissable-alert', {
    attrs: {
      "title": "Thank you! Your feedback has been submitted.",
      "closeAction": _vm.hideSubmittedAlert,
      "isShowing": _vm.feedbackWasSubmitted
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "feedback-survey"
  }, [_c('h3', {
    staticClass: "survey-title"
  }, [_vm._v("\n          Thank you for taking a moment to provide feedback\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "survey-question"
  }, [_c('p', {
    staticClass: "question-text"
  }, [_vm._v("\n            How satisfied are you with your investment in the Community\n            Investment Note?\n          ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "score-scale",
    attrs: {
      "role": "radiogroup",
      "aria-label": "Satisfaction score from 0 to 10"
    }
  }, _vm._l((_vm.scoreOptions), function(value) {
    return _c('button', {
      key: ("score-" + value),
      staticClass: "score-option",
      class: {
        'score-option-selected': _vm.score === value
      },
      attrs: {
        "type": "button",
        "role": "radio",
        "aria-checked": _vm.score === value ? 'true' : 'false',
        "aria-label": ("Score " + value)
      },
      on: {
        "click": function($event) {
          _vm.selectScore(value)
        }
      }
    }, [_c('span', {
      staticClass: "score-label"
    }, [_vm._v(_vm._s(value))]), _vm._v(" "), _c('span', {
      staticClass: "score-circle"
    })])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "survey-question"
  }, [_c('p', {
    staticClass: "question-text"
  }, [_vm._v("\n            What is the primary reason for your score? How could we improve\n            your experience?\n          ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    staticClass: "form-control reason-input",
    attrs: {
      "rows": "4",
      "maxlength": "2000",
      "placeholder": "Enter text"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("\n        Submit feedback\n      ")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scale-legend"
  }, [_c('span', [_vm._v("0 = Not at all")]), _vm._v(" "), _c('span', [_vm._v("10 = Very satisfied")])])
}]}

/***/ }),
/* 2164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isSuggestedAddressModalVisible) ? _c('address-suggestion') : _vm._e(), _vm._v(" "), _c('bank-account-changed-warning', {
    attrs: {
      "isVisible": _vm.isBankAccountChangedWarningVisible,
      "isAdminView": true
    },
    on: {
      "close": _vm.hideBankAccountChangedWarning,
      "goToUpcomingTransactions": _vm.handleGoToUpcomingTransactions
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.userDetailLoading ||
    _vm.accountUsersLoading ||
    _vm.isNotesSegmentLoading ||
    _vm.isFundingSourcesSegmentLoading ||
    _vm.isUpcomingTransactionsSegmentLoading ||
    _vm.preferencesSpinner ||
    _vm.isRepresentativesLoading ||
    _vm.beneficiariesSpinner) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Account information")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('RestrictedSingleInput', {
    attrs: {
      "input": _vm.organization.name,
      "limit": 40
    },
    on: {
      "inputUpdated": _vm.onTrustNameUpdate
    }
  }), _vm._v(" "), (_vm.organization && _vm.organization.name && _vm.organization.name.trim().length === 0) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.accountId) + " ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row space zero-margin-x"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.formatDate(_vm.account.createdAt)) + " ")])])])]), _vm._v(" "), (_vm.account.investorSince) ? _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.account.investorSince) ? _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.investorSince) + " ")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [(_vm.account.status == 'active') ? _c('p', {
    staticClass: "label label-success capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.status == 'pending') ? _c('p', {
    staticClass: "label label-warning capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.status == 'inactive') ? _c('p', {
    staticClass: "label label-danger capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.hasUserComments) ? _c('p', {
    staticClass: "label label-danger capitalize-text"
  }, [_vm._v(" Comments ")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {}, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.type),
      expression: "organization.type"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('trustType')
    },
    attrs: {
      "name": "trustType",
      "id": "trustType",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.organization.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.trustTypes), function(trustType, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": trustType.name
      }
    }, [_vm._v("\n                        " + _vm._s(trustType.text) + "\n                      ")])
  })), _vm._v(" "), (_vm.errors.has('trustType')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.taxId),
      expression: "organization.taxId"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('***-**-9999'),
      expression: "'***-**-9999'"
    }],
    class: {
      'form-control': true,
      'form-control-error': _vm.errors.has('taxId') || !this.isTaxIdValid()
    },
    attrs: {
      "name": "taxId",
      "id": "taxId"
    },
    domProps: {
      "value": (_vm.organization.taxId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organization.taxId = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('taxId') || !this.isTaxIdValid()) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.phoneNumber),
      expression: "organization.phoneNumber"
    }],
    class: {
      'form-control': true,
      'form-control-error': _vm.errors.has('phone') || !_vm.isPhoneNumberValid()
    },
    attrs: {
      "name": "phone",
      "id": "phone"
    },
    domProps: {
      "value": (_vm.organization.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organization.phoneNumber = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('phone') || !_vm.isPhoneNumberValid()) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.legacyUsername) + " ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.legacyCustomerNumber) + " ")])])])])])]), _vm._v(" "), (_vm.organization.mainAddress && _vm.organization.mailingAddress) ? _c('Addresses', {
    key: 1,
    ref: "addresses",
    attrs: {
      "firstTitle": 'Trust Address',
      "residentialAddress": _vm.organization.mainAddress,
      "secondTitle": 'Mailing Address',
      "mailingAddress": _vm.organization.mailingAddress,
      "is-admin": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "disabled": _vm.shouldSubmitButtonBeDisabled()
    },
    on: {
      "click": function($event) {
        _vm.validateAndSubmitAccount()
      }
    }
  }, [_vm._v("\n                    Submit account information\n                ")])])])], 1)])]), _vm._v(" "), (_vm.accountRepresentatives !== undefined && _vm.account.primaryInvestorId) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountRepresentatives', {
    attrs: {
      "accountId": _vm.accountId,
      "accountName": _vm.accountName,
      "accountType": _vm.getAccountType(),
      "representatives": _vm.accountRepresentatives,
      "primaryInvestorId": _vm.account.primaryInvestorId
    },
    on: {
      "representativesLoadingStarted": _vm.setRepresentativesSpinnerOn,
      "representativesLoadingSucceed": _vm.setRepresentativesSpinnerOff,
      "representativesLoadingFailed": _vm.setRepresentativesSpinnerOff,
      "representativesUpdated": _vm.loadAccountInformation
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.beneficiaries !== undefined) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountBeneficiaries', {
    attrs: {
      "beneficiaries": _vm.beneficiaries,
      "accountId": _vm.accountId
    },
    on: {
      "beneficiaryLoadingStarted": _vm.setBeneficiariesSpinnerOn,
      "beneficiaryLoadingSucceed": _vm.setBeneficiariesSpinnerOff,
      "beneficiaryLoadingFailed": _vm.setBeneficiariesSpinnerOff,
      "beneficiariesUpdated": _vm.loadAccountInformation
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountNotes', {
    attrs: {
      "accountId": _vm.accountId,
      "displayAlertForUpcomingTransactionsWithAction": _vm.shouldUpcomingTransactionsWithActionsBeDisplayed,
      "displayAlertForUpcomingTransactionsWithNoAction": _vm.shouldUpcomingTransactionsWithNoActionsBeDisplayed,
      "disable-investment": _vm.user.disableInvestment || _vm.organization.disableInvestment
    },
    on: {
      "goToUpcomingTransactionsSegment": function($event) {
        _vm.goToSegment('upcoming-transactions-segment')
      },
      "notesLoadingFailed": _vm.setNotesSpinnerOff,
      "notesLoadingStarted": _vm.setNotesSpinnerOn,
      "notesLoadingSucceed": _vm.setNotesSpinnerOff,
      "redirectToNoteDetailsView": _vm.goToViewDetail,
      "redirectToPurchaseInvestmentNoteView": _vm.goToPurchaseInvestmentNote
    }
  })], 1)]), _vm._v(" "), (_vm.account.defaultFundingSourceId !== undefined) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "funding-sources-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountFundingSources', {
    attrs: {
      "accountId": _vm.accountId,
      "defaultFundingSourceId": _vm.userAccount.defaultFundingSourceId,
      "account": _vm.account
    },
    on: {
      "fundingSourcesLoadingFailed": _vm.setFundingSourceSpinnerOff,
      "fundingSourcesLoadingStarted": _vm.setFundingSourceSpinnerOn,
      "fundingSourcesLoadingSucceed": _vm.setFundingSourceSpinnerOff,
      "defaultFundingSourceUpdated": _vm.handleDefaultFundingSourceUpdated,
      "restart": _vm.loadAccountUsers,
      "showBankAccountChangedWarning": _vm.showBankAccountChangedWarning
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AdminAccountDocuments')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "preferences-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Preferences\n          ")]), _vm._v(" "), _c('SuccessAlert', {
    attrs: {
      "isVisible": _vm.isPreferencesSuccessMessageVisible,
      "message": _vm.preferencesSuccessMessage
    },
    on: {
      "hideSuccessAlert": _vm.hidePreferencesSuccessMessage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.account.communicationPreference !== undefined) ? _c('AccountPreferences', {
    attrs: {
      "accountId": _vm.accountId,
      "interestPreference": _vm.account.interestPreference,
      "communicationPreference": _vm.account.communicationPreference,
      "communication1099Preference": _vm.account.communication1099Preference,
      "communicationImpactReportPreference": _vm.account.communicationImpactReportPreference,
      "paymentPreference": _vm.account.paymentPreference,
      "redemptionRestriction": _vm.account.redemptionRestriction,
      "user": _vm.user
    },
    on: {
      "impactPreferencesLoadingFailed": _vm.setPreferencesSpinnerOff,
      "impactPreferencesLoadingStarted": _vm.setPreferencesSpinnerOn,
      "impactPreferencesLoadingSucceed": _vm.setPreferencesSpinnerOff,
      "updateImpactPreferencesFailed": _vm.setPreferencesSpinnerOff,
      "updateImpactPreferencesStarted": _vm.setPreferencesSpinnerOn,
      "updateImpactPreferencesSucceed": _vm.displayImpactPreferenceSuccessfulNotification
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "upcoming-transactions-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('UpcomingTransactions', {
    ref: "upcomingTransactions",
    attrs: {
      "accountId": _vm.accountId,
      "defaultFundingSourceId": _vm.userAccount.defaultFundingSourceId,
      "investorAccountIdentifier": _vm.userAccount.accountId
    },
    on: {
      "goToFundingSourcesSegment": function($event) {
        _vm.goToSegment('funding-sources-segment')
      },
      "hideAlertForUpcomingTransactions": _vm.hideUpcomingTransactionsAlerts,
      "showAlertForUpcomingTransactionsWithAction": _vm.displayUpcomingTransactionsWithActionAlert,
      "showAlertForUpcomingTransactionsWithNoAction": _vm.displayUpcomingTransactionsWithNoActionAlert,
      "upcomingTransactionsLoadingFailed": _vm.setUpcomingTransactionsSpinnerOff,
      "upcomingTransactionsLoadingStarted": _vm.setUpcomingTransactionsSpinnerOn,
      "upcomingTransactionsLoadingSucceed": _vm.setUpcomingTransactionsSpinnerOff
    }
  })], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Trust account\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Trust name *")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("ID:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v("Date created:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Investor since:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Status:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Trust type *")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Tax ID *")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Phone number *")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Legacy username:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Legacy customer number:")])])])])
}]}

/***/ }),
/* 2165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    attrs: {
      "data-animation": "pop"
    }
  }, [_c('em', {
    staticClass: "sa-icon sa-error fa fa-warning"
  }), _vm._v(" "), _c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("There is a problem")]), _vm._v(" "), _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n        Commercial addresses are not allowed as an investor's residential\n        addresses.\n      ")]), _vm._v(" "), _c('fieldset', {
    staticClass: "checkbox c-checkbox override-row"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allowed),
      expression: "allowed"
    }],
    attrs: {
      "type": "checkbox",
      "name": "allowCommercialAddress"
    },
    domProps: {
      "checked": Array.isArray(_vm.allowed) ? _vm._i(_vm.allowed, null) > -1 : (_vm.allowed)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.allowed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allowed = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.allowed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allowed = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n          Allow commercial address as residential\n        ")])]), _vm._v(" "), (_vm.allowed) ? _c('fieldset', {
    staticClass: "form-group override-row"
  }, [_c('label', {
    attrs: {
      "for": "commercialOverrideComment"
    }
  }, [_vm._v("\n          Override verified by\n          "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n            (who approved this and how it was verified, e.g. Google Maps)\n          ")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "commercialOverrideComment",
      "rows": "2",
      "placeholder": "e.g. Verified via Google Maps by Jane Admin"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg btn-accept",
    attrs: {
      "disabled": !_vm.canSave
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("\n              Save with override\n            ")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 2166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    attrs: {
      "id": "app"
    }
  }, [(_vm.checkRoute() && _vm.shouldRoutesBeDisplayed) ? _c('topnavbar', {
    on: {
      "force-update": _vm.forceUpdate,
      "toggle-drawer": _vm.toggleDrawer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.checkRoute() && !_vm.irAdmin && _vm.shouldRoutesBeDisplayed) ? _c('sidebar', {
    ref: "sidebar",
    attrs: {
      "drawer-open": _vm.isDrawerOpen
    },
    on: {
      "drawer-closed": _vm.handleDrawerClosed
    }
  }) : _vm._e(), _vm._v(" "), (_vm.checkRoute() && _vm.irAdmin && _vm.shouldRoutesBeDisplayed) ? _c('iradminsidebar') : _vm._e(), _vm._v(" "), (_vm.shouldRoutesBeDisplayed) ? _c('router-view', {
    ref: "accountSummary"
  }) : _vm._e(), _vm._v(" "), (_vm.maintenance) ? _c('maintenance') : _vm._e(), _vm._v(" "), _c('mfa-phone-preference-dialog', {
    attrs: {
      "visible": _vm.showPhonePreferenceDialog,
      "user": _vm.currentUser
    },
    on: {
      "saved": _vm.handlePhonePreferenceSaved,
      "cancel": _vm.handlePhonePreferenceCancel
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel-heading top-margin"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Transaction " + _vm._s(_vm.transactionId))])]), _vm._v(" "), _c('div', {
    staticClass: "row notification"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row transation-info"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row first-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.maturityDate)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.noteId))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row first-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.getPaymentType))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.formatAmount(_vm.amount)))])])])])]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Transaction date:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Note number:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Payment type:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "line-separator top-margin"
  })])])
}]}

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "block-center mt-xl wd-xl"
  }, [_c('div', {
    staticClass: "panel panel-dark panel-flat"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('svg', {
    attrs: {
      "width": "151",
      "height": "144",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill-rule": "nonzero",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 122h79v10H7c-3 0-5-3-5-5V7c0-3 2-5 5-5h138c3 0 5 2 5 5v78h-9V11H11v111z",
      "fill": "#E2E2E2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 39v-9h138v9H7zm14-14v-9h9v9h-9zm18 0v-9h9v9h-9z",
      "fill": "#E2E2E2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 120h79v10H5c-3 0-5-2-5-5V5c0-3 2-5 5-5h138c3 0 5 2 5 5v78h-9V9H9v111z",
      "fill": "#00788D"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5 37v-9h138v9H5zm14-14v-9h9v9h-9zm18 0v-9h9v9h-9z",
      "fill": "#00788D"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M133.9321616 86.51651217h-16.336519v5.44550635h16.336519v-5.44550635zm-10.8910127 35.39579123h5.4455064v-16.336519h-5.4455064v16.336519zm21.8500942-18.0110122l3.8799233-3.8799233c-1.1707838-1.4022179-2.4504778-2.6819119-3.8526957-3.8526957l-3.8799233 3.8799233c-4.1794261-3.3489865-9.5024086-5.3638238-15.2882591-5.3638238-13.545697 0-24.49116478 10.9726953-24.49116478 24.5047786 0 13.5320833 10.94546778 24.5047785 24.49116478 24.5047785 13.5456971 0 24.5183924-10.9726952 24.5183924-24.5047785 0-5.7858505-2.0148374-11.0952192-5.3774376-15.2882591zm-19.127341 34.3475313c-10.523441 0-19.05927223-8.5358312-19.05927223-19.0592722 0-10.523441 8.53583123-19.0592723 19.05927223-19.0592723 10.523441 0 19.0592722 8.5358313 19.0592722 19.0592723s-8.5358312 19.0592722-19.0592722 19.0592722z",
      "fill": "#E2E2E2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M131.9321616 84.51651217h-16.336519v5.44550635h16.336519v-5.44550635zm-10.8910127 35.39579123h5.4455064v-16.336519h-5.4455064v16.336519zm21.8500942-18.0110122l3.8799233-3.8799233c-1.1707838-1.4022179-2.4504778-2.6819119-3.8526957-3.8526957l-3.8799233 3.8799233c-4.1794261-3.3489865-9.5024086-5.3638238-15.2882591-5.3638238-13.545697 0-24.49116478 10.9726953-24.49116478 24.5047786 0 13.5320833 10.94546778 24.5047785 24.49116478 24.5047785 13.5456971 0 24.5183924-10.9726952 24.5183924-24.5047785 0-5.7858505-2.0148374-11.0952192-5.3774376-15.2882591zm-19.127341 34.3475313c-10.523441 0-19.05927223-8.5358312-19.05927223-19.0592722 0-10.523441 8.53583123-19.0592723 19.05927223-19.0592723 10.523441 0 19.0592722 8.5358313 19.0592722 19.0592723s-8.5358312 19.0592722-19.0592722 19.0592722z",
      "fill": "#8C1D1D"
    }
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v(_vm._s(_vm.errorDescription))]), _vm._v(" "), (_vm.resetPassword) ? _c('div', [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg mt-lg",
    on: {
      "click": _vm.goToResetPassword
    }
  }, [_vm._v("Reset password")])]) : _vm._e(), _vm._v(" "), (_vm.emailConfirmation) ? _c('div', [_vm._m(2), _vm._v(" "), (!_vm.sentEmailConfirmation) ? _c('div', [_c('button', {
    staticClass: "btn btn-default btn-lg mt-lg",
    on: {
      "click": _vm.resendEmailVerification
    }
  }, [_vm._v("Confirm email")])]) : _vm._e(), _vm._v(" "), (_vm.sentEmailConfirmation) ? _c('div', [_vm._m(3), _vm._v(" "), _c('p', [_vm._v("Email sent. Please check your email.")])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _vm._m(4)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading text-center"
  }, [_c('img', {
    staticClass: "block-center",
    attrs: {
      "src": __webpack_require__(229),
      "alt": "Image",
      "width": "180"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The reset password link you were trying to enter is not available anymore. "), _c('br'), _vm._v("Please, try again.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The email confirmation link you were trying to enter is not available anymore. "), _c('br'), _vm._v("Please, try again.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/#/login"
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg mt-lg"
  }, [_vm._v("Go to login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mt-lg"
  }, [_vm._v("If you need more help, please contact Calvert Impact Capital at "), _c('a', {
    attrs: {
      "href": "mailto:info@calvertimpact.org"
    }
  }, [_vm._v("info@calvertimpact.org")]), _vm._v(" or call us at 800-248-0337.")])
}]}

/***/ }),
/* 2169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isCheckWireModalVisible) ? _c('checkwire', {
    attrs: {
      "closeAction": _vm.loadFundingSourceAfterModalSave
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.userDetailLoading || _vm.accountUsersLoading || _vm.noteLoading || _vm.fundingLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("\n          " + _vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName) + " - " + _vm._s(_vm.getAccountType()) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-value"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.account.accountId) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "info-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-value"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.formatDate(_vm.account.createdAt)) + " ")])])]), _vm._v(" "), (_vm.account.investorSince) ? _c('div', {
    staticClass: "info-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "info-value"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.account.investorSince) + " ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "info-value"
  }, [_c('div', {
    staticClass: "space-between"
  }, [(_vm.account.status == 'active') ? _c('p', {
    staticClass: "label label-success capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.status == 'pending') ? _c('p', {
    staticClass: "label label-warning capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.status == 'inactive') ? _c('p', {
    staticClass: "label label-danger capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.hasUserComments) ? _c('p', {
    staticClass: "label label-danger capitalize-text"
  }, [_vm._v(" Comments ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-subtitle top-margin"
  }, [_vm._v("\n            Authorized account holders and representatives\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "representatives-section"
  }, [_c('p', {
    staticClass: "label-names"
  }, [_vm._v("Name:")]), _vm._v(" "), _c('div', {
    staticClass: "representatives-list"
  }, _vm._l((_vm.accountRepresentatives), function(representative, index) {
    return _c('p', {
      key: index
    }, [_vm._v("\n                  " + _vm._s(representative.fullName) + "\n                ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Note list\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg btn-full-mobile top-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goToPurchaseInvestmentNote()
      }
    }
  }, [_vm._v("\n            Make an investment\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "balance-section"
  }, [_c('span', {
    staticClass: "panel-subtitle"
  }, [_vm._v("Current account balance: "), _c('strong', {
    staticClass: "amountBalance"
  }, [_vm._v(_vm._s(_vm.formatAmount(_vm.currentAmountBalance)))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-subtitle top-margin bottom-margin"
  }, [_vm._v("\n              Notes list\n          ")]), _vm._v(" "), (_vm.notes.length === 0) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                 No notes found.\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.notes.length > 0) ? _c('div', {
    staticClass: "notes-container"
  }, [_c('div', {
    staticClass: "notes-table-desktop",
    class: {
      'table-fixed-header--md cols-9': _vm.notes.length > 6
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.notes), function(note, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(note.noteId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatTerm(note.interestTerm)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatRate(note.interestRate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.purchasedOn)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.openedOn)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.maturityDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(note.status == 'cancelled') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (note.status == 'failed') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (note.status == 'closed') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Closed")]) : _vm._e(), _vm._v(" "), (note.status == 'pending') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (note.status == 'open') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Open")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(note)
        }
      }
    }, [_vm._v("View details")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "notes-cards-mobile"
  }, _vm._l((_vm.notes), function(note, index) {
    return _c('div', {
      key: index,
      staticClass: "note-card"
    }, [_c('div', {
      staticClass: "note-card-header"
    }, [_c('div', {
      staticClass: "note-card-title"
    }, [_vm._v("Note #" + _vm._s(note.noteId))]), _vm._v(" "), (note.status == 'cancelled') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (note.status == 'failed') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (note.status == 'closed') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Closed")]) : _vm._e(), _vm._v(" "), (note.status == 'pending') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (note.status == 'open') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Open")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "note-card-body"
    }, [_c('div', {
      staticClass: "note-card-row"
    }, [_c('span', {
      staticClass: "note-card-label"
    }, [_vm._v("Term:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-value"
    }, [_vm._v(_vm._s(_vm.formatTerm(note.interestTerm)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-row"
    }, [_c('span', {
      staticClass: "note-card-label"
    }, [_vm._v("Rate:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-value"
    }, [_vm._v(_vm._s(_vm.formatRate(note.interestRate)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-row"
    }, [_c('span', {
      staticClass: "note-card-label"
    }, [_vm._v("Principal amount:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-value"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-row"
    }, [_c('span', {
      staticClass: "note-card-label"
    }, [_vm._v("Purchase date:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-value"
    }, [_vm._v(_vm._s(_vm.formatDate(note.purchasedOn)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-row"
    }, [_c('span', {
      staticClass: "note-card-label"
    }, [_vm._v("Open date:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-value"
    }, [_vm._v(_vm._s(_vm.formatDate(note.openedOn)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-row"
    }, [_c('span', {
      staticClass: "note-card-label"
    }, [_vm._v("Maturity date:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-value"
    }, [_vm._v(_vm._s(_vm.formatDate(note.maturityDate)))])])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-footer"
    }, [_c('button', {
      staticClass: "btn btn-details btn-outline btn-block",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(note)
        }
      }
    }, [_vm._v("View details")])])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("\n            Bank account\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "action-button-container"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg btn-full-mobile",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.openCheckWireModal()
      }
    }
  }, [_vm._v("Add check or wire transfer")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-subtitle top-margin bottom-margin"
  }, [_vm._v("\n          Account list\n          ")]), _vm._v(" "), (_vm.fundingSources.length === 0) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                 No bank accounts were found.\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.fundingSources.length > 0) ? _c('div', {
    staticClass: "funding-container"
  }, [_c('div', {
    staticClass: "funding-table-desktop",
    class: {
      'table-fixed-header--sm cols-5': _vm.fundingSources.length > 3
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.fundingSources), function(funding, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(funding.bankName ? funding.bankName : '-----'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(funding.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatType(funding.type, 'investor')))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(funding.status === 'verified') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.userAccount.defaultFundingSourceId),
        expression: "userAccount.defaultFundingSourceId"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": funding.id,
        "checked": _vm._q(_vm.userAccount.defaultFundingSourceId, funding.id)
      },
      on: {
        "change": function($event) {
          _vm.showDefaultFundingSourceConfirmationModal({
            fundingSource: funding
          })
        },
        "__c": function($event) {
          _vm.userAccount.defaultFundingSourceId = funding.id
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(funding.type !== 'check' && funding.type !== 'wire-transfer') ? _c('span', {
      staticClass: "label",
      class: funding.status === 'verified' ? 'label-success' : 'label-warning'
    }, [_vm._v("\n                        " + _vm._s(funding.status) + "\n                      ")]) : _vm._e()])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "funding-cards-mobile"
  }, _vm._l((_vm.fundingSources), function(funding, index) {
    return _c('div', {
      key: index,
      staticClass: "funding-card"
    }, [_c('div', {
      staticClass: "funding-card-header"
    }, [_c('div', {
      staticClass: "funding-card-title"
    }, [_vm._v(_vm._s(funding.name))]), _vm._v(" "), (funding.type !== 'check' && funding.type !== 'wire-transfer') ? _c('span', {
      staticClass: "label",
      class: funding.status === 'verified' ? 'label-success' : 'label-warning'
    }, [_vm._v("\n                    " + _vm._s(funding.status) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "funding-card-body"
    }, [_c('div', {
      staticClass: "funding-card-row"
    }, [_c('span', {
      staticClass: "funding-card-label"
    }, [_vm._v("Bank name:")]), _vm._v(" "), _c('span', {
      staticClass: "funding-card-value"
    }, [_vm._v(_vm._s(funding.bankName ? funding.bankName : '-----'))])]), _vm._v(" "), _c('div', {
      staticClass: "funding-card-row"
    }, [_c('span', {
      staticClass: "funding-card-label"
    }, [_vm._v("Type:")]), _vm._v(" "), _c('span', {
      staticClass: "funding-card-value"
    }, [_vm._v(_vm._s(_vm.formatType(funding.type, 'investor')))])]), _vm._v(" "), (funding.status === 'verified') ? _c('div', {
      staticClass: "funding-card-row"
    }, [_c('span', {
      staticClass: "funding-card-label"
    }, [_vm._v("Default:")]), _vm._v(" "), _c('span', {
      staticClass: "funding-card-value"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.userAccount.defaultFundingSourceId),
        expression: "userAccount.defaultFundingSourceId"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": funding.id,
        "checked": _vm._q(_vm.userAccount.defaultFundingSourceId, funding.id)
      },
      on: {
        "change": function($event) {
          _vm.showDefaultFundingSourceConfirmationModal({
            fundingSource: funding
          })
        },
        "__c": function($event) {
          _vm.userAccount.defaultFundingSourceId = funding.id
        }
      }
    })])]) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("\n            Account preference\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "preferences-container"
  }, [_c('div', {
    staticClass: "preference-item"
  }, [_c('div', {
    class: _vm.account.paymentPreference === 'reinvest' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.paymentPreference),
      expression: "account.paymentPreference"
    }],
    attrs: {
      "id": "ritema",
      "name": "ritem",
      "type": "radio"
    },
    domProps: {
      "value": 'reinvest',
      "checked": _vm._q(_vm.account.paymentPreference, 'reinvest')
    },
    on: {
      "change": function($event) {
        _vm.showConfirmationModal('reinvest')
      },
      "__c": function($event) {
        _vm.account.paymentPreference = 'reinvest'
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ritema"
    }
  }, [_vm._v(_vm._s(_vm.formatPaymentPreference('reinvest')))])])]), _vm._v(" "), _c('div', {
    staticClass: "preference-item"
  }, [_c('div', {
    class: _vm.account.paymentPreference === 'payout' ? 'radio-item radio-item-repay' : 'radio-item radio-item-repay radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.paymentPreference),
      expression: "account.paymentPreference"
    }],
    attrs: {
      "id": "ritemb",
      "name": "ritem",
      "type": "radio"
    },
    domProps: {
      "value": 'payout',
      "checked": _vm._q(_vm.account.paymentPreference, 'payout')
    },
    on: {
      "change": function($event) {
        _vm.showConfirmationModal('payout')
      },
      "__c": function($event) {
        _vm.account.paymentPreference = 'payout'
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ritemb"
    }
  }, [_vm._v(_vm._s(_vm.formatPaymentPreference('payout')))])])]), _vm._v(" "), _c('div', {
    staticClass: "preference-item"
  }, [_c('div', {
    class: _vm.account.paymentPreference === 'donate' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.paymentPreference),
      expression: "account.paymentPreference"
    }],
    attrs: {
      "id": "ritemc",
      "name": "ritem",
      "type": "radio"
    },
    domProps: {
      "value": 'donate',
      "checked": _vm._q(_vm.account.paymentPreference, 'donate')
    },
    on: {
      "change": function($event) {
        _vm.showConfirmationModal('donate')
      },
      "__c": function($event) {
        _vm.account.paymentPreference = 'donate'
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ritemc"
    }
  }, [_vm._v(_vm._s(_vm.formatPaymentPreference('donate')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  })])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Account\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-label"
  }, [_c('label', [_vm._v("Id:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-label"
  }, [_c('label', [_vm._v("Date created:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-label"
  }, [_c('label', [_vm._v("Investor since:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-label"
  }, [_c('label', [_vm._v("Status:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Note number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Term")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Rate")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Principal amount")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Purchase date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Open date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Maturity date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("View details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bank name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Account name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Default")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")])])])
}]}

/***/ }),
/* 2170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "top": "130px"
    },
    attrs: {
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('div', {
    staticClass: "modal-close col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "modal-button",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("\n          Search for existing user with accounts to merge\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body mt-lg"
  }, [_c('form', {
    staticClass: "mb-xl top-margin form-row",
    attrs: {
      "role": "form",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback searchbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "autofocus": "",
      "id": "search",
      "type": "text",
      "placeholder": "Search by first name, last name, or user email",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSearchDisabled || _vm.isSearching
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.searchUsers()
      }
    }
  }, [(!_vm.isSearching) ? _c('span', [_c('em', {
    staticClass: "icon-magnifier pr-sm"
  }), _vm._v(" Search\n               ")]) : _c('span', [_c('em', {
    staticClass: "fa fa-spinner fa-spin pr-sm"
  }), _vm._v(" Searching...\n               ")])])])]), _vm._v(" "), (_vm.users.length === 0 && _vm.hasSearched && !_vm.isSearching) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg not-found-alert",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("No users with accounts found.\n           ")])])]) : _vm._e(), _vm._v(" "), (_vm.users.length > 0) ? _c('div', {
    staticClass: "table-responsive top-margin"
  }, [_c('table', {
    staticClass: "table table-striped bank-accounts table-fundings"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("First name")]), _vm._v(" "), _c('th', [_vm._v("Last name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("User type")]), _vm._v(" "), _c('th', [_vm._v("Account(s)")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', {
      key: user.id
    }, [_c('td', [_vm._v(_vm._s(user.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.lastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getUserTypeLabel(user.userType)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.accounts.length))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-warning btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.confirmMergeUser(user)
        }
      }
    }, [_vm._v("\n                    Merge with this user\n                  ")])])])
  }))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-done",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("\n              Cancel\n            ")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 2171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "transaction-sort-title small-container",
    on: {
      "click": _vm.handleSortStrategy
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle()
  })])])
},staticRenderFns: []}

/***/ }),
/* 2172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    attrs: {
      "align": "center"
    }
  }, [_c('ContactUsHeader'), _vm._v(" "), (_vm.hasBeenDisabledSignUp === 'ON') ? _c('h4', {
    staticClass: "text-center"
  }, [_vm._m(0)]) : _c('h4', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Register to create a new investment account below")])]), _vm._v(" "), _c('div', {
    staticClass: "block-center mt-sm wd-xl"
  }, [(_vm.hasBeenDisabledSignUp === 'ON') ? _c('p', {
    staticClass: "pt-sm text-center"
  }, [_vm._v("\n            If you are an existing investor,\n              "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("log in here")]), _vm._v(" or email\n              "), _c('a', {
    attrs: {
      "href": "mailto:info@calvertimpact.org"
    }
  }, [_vm._v("info@calvertimpact.org")]), _vm._v(" for online access.\n          ")], 1) : _vm._e(), _vm._v(" "), (_vm.hasBeenDisabledSignUp === 'OFF') ? _c('div', {
    staticClass: "panel panel-dark panel-flat"
  }, [_c('p', {
    staticClass: "pt-sm text-center"
  }, [_vm._v("\n            If you are an existing investor that has not logged in online before,\n              "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("log in here")]), _vm._v(" or email\n              "), _c('a', {
    attrs: {
      "href": "mailto:info@calvertimpact.org"
    }
  }, [_vm._v("info@calvertimpact.org")]), _vm._v(" for online access.\n          ")], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateAndSubmitRegistration($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.emailError
    }
  }, [_c('label', {
    staticClass: "text-muted",
    attrs: {
      "for": "signupInputEmail1"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.computedEmail),
      expression: "computedEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "signupInputEmail1",
      "type": "email",
      "placeholder": "Enter email",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.computedEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.computedEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "form-icon icon-envelope"
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock2"
    }
  }, [_vm._v(_vm._s(_vm.emailError))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.stateError
    }
  }, [_c('label', {
    staticClass: "text-muted",
    attrs: {
      "for": "state"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "state",
      "placeholder": "Please select",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Please select")]), _vm._v(" "), _vm._l((_vm.filteredStates), function(s) {
    return _c('option', {
      key: s.abbreviation,
      domProps: {
        "value": s.abbreviation
      }
    }, [_vm._v(_vm._s(s.name))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock3"
    }
  }, [_vm._v(_vm._s(_vm.stateError))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.passwordErrors.length > 0
    }
  }, [_c('label', {
    staticClass: "text-muted",
    attrs: {
      "for": "signupInputPassword1"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "signupInputPassword1",
      "type": "password",
      "placeholder": "Password",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "form-icon icon-lock"
  })]), _vm._v(" "), _c('PasswordHint', {
    attrs: {
      "password": _vm.password
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.passConfirmationError
    }
  }, [_c('label', {
    staticClass: "text-muted",
    attrs: {
      "for": "signupInputPassword1"
    }
  }, [_vm._v("Confirm password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirmation),
      expression: "passwordConfirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "signupInputPasswordConfirmation",
      "type": "password",
      "placeholder": "Confirm password",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.passwordConfirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirmation = $event.target.value
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "form-icon icon-lock"
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock5"
    }
  }, [_vm._v(_vm._s(_vm.passConfirmationError))])]), _vm._v(" "), _c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.sitekey
    },
    on: {
      "verify": _vm.onVerify
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default btn-lg mt-lg",
    attrs: {
      "type": "submit",
      "disabled": !_vm.recaptchaIsVerified
    }
  }, [_vm._v("Create account")]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.registrationError
    }
  }, [_c('strong', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock6"
    }
  }, [_vm._v(_vm._s(_vm.registrationError))])])], 1)])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_vm._v("Account creation is currently disabled. Please try again later.\n    "), _c('br'), _vm._v(" If you have questions, contact our support at "), _c('a', {
    attrs: {
      "href": "mailto:info@calvertimpact.org"
    }
  }, [_vm._v("info@calvertimpact.org")]), _vm._v(" or 800.248.0337.")])
}]}

/***/ }),
/* 2173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    class: _vm.containerClass,
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "p-hidden-accessible"
  }, [_c('input', {
    ref: "focusInput",
    attrs: {
      "type": "text",
      "role": "listbox",
      "id": _vm.inputId,
      "readonly": "",
      "disabled": _vm.disabled,
      "tabindex": _vm.tabindex,
      "aria-haspopup": "listbox",
      "aria-expanded": _vm.overlayVisible,
      "aria-labelledby": _vm.ariaLabelledBy
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keydown": _vm.onKeyDown
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-multiselect-label-container"
  }, [_c('div', {
    class: _vm.labelClass
  }, [_vm._t("value", [(_vm.display === 'comma') ? [_vm._v("\n                    " + _vm._s(_vm.label || 'empty') + "\n                ")] : (_vm.display === 'chip') ? [_vm._l((_vm.value), function(item) {
    return _c('div', {
      key: _vm.getLabelByValue(item),
      staticClass: "p-multiselect-token"
    }, [_c('span', {
      staticClass: "p-multiselect-token-label"
    }, [_vm._v(_vm._s(_vm.getLabelByValue(item)))]), _vm._v(" "), (!_vm.disabled) ? _c('span', {
      staticClass: "p-multiselect-token-icon pi pi-times-circle",
      on: {
        "click": function($event) {
          _vm.removeChip(item)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (!_vm.value || _vm.value.length === 0) ? [_vm._v(_vm._s(_vm.placeholder || 'empty'))] : _vm._e()] : _vm._e()], {
    value: _vm.value,
    placeholder: _vm.placeholder
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "p-multiselect-trigger"
  }, [_vm._t("indicator", [_c('span', {
    staticClass: "p-multiselect-trigger-icon pi pi-chevron-down"
  })])], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "p-connected-overlay"
    },
    on: {
      "enter": _vm.onOverlayEnter,
      "leave": _vm.onOverlayLeave
    }
  }, [(_vm.overlayVisible) ? _c('div', {
    ref: "overlay",
    staticClass: "p-multiselect-panel p-component"
  }, [((_vm.showToggleAll && _vm.selectionLimit == null) || _vm.filter) ? _c('div', {
    staticClass: "p-multiselect-header"
  }, [(_vm.showToggleAll && _vm.selectionLimit == null) ? _c('div', {
    staticClass: "p-checkbox p-component",
    attrs: {
      "role": "checkbox",
      "aria-checked": _vm.allSelected
    },
    on: {
      "click": _vm.onToggleAll
    }
  }, [_c('div', {
    staticClass: "p-hidden-accessible"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "readonly": ""
    },
    on: {
      "focus": _vm.onHeaderCheckboxFocus,
      "blur": _vm.onHeaderCheckboxBlur
    }
  })]), _vm._v(" "), _c('div', {
    class: ['p-checkbox-box', {
      'p-highlight': _vm.allSelected,
      'p-focus': _vm.headerCheckboxFocused
    }],
    attrs: {
      "role": "checkbox",
      "aria-checked": _vm.allSelected
    }
  }, [_c('span', {
    class: ['p-checkbox-icon', {
      'pi pi-check': _vm.allSelected
    }]
  })])]) : _vm._e(), _vm._v(" "), (_vm.filter) ? _c('div', {
    staticClass: "p-multiselect-filter-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterValue),
      expression: "filterValue"
    }],
    ref: "filterInput",
    staticClass: "p-multiselect-filter p-inputtext p-component",
    attrs: {
      "type": "text",
      "autoComplete": "on",
      "placeholder": _vm.filterPlaceholder
    },
    domProps: {
      "value": (_vm.filterValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterValue = $event.target.value
      }, _vm.onFilterChange]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "p-multiselect-filter-icon pi pi-search"
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    staticClass: "p-multiselect-close p-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCloseClick
    }
  }, [_c('span', {
    staticClass: "p-multiselect-close-icon pi pi-times"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "itemsWrapper",
    staticClass: "p-multiselect-items-wrapper",
    style: ({
      'max-height': _vm.scrollHeight
    })
  }, [_c('ul', {
    staticClass: "p-multiselect-items p-component",
    attrs: {
      "role": "listbox",
      "aria-multiselectable": "true"
    }
  }, [_vm._l((_vm.visibleOptions), function(option, i) {
    return _c('li', {
      directives: [{
        name: "ripple",
        rawName: "v-ripple"
      }],
      key: _vm.getOptionRenderKey(option),
      class: ['p-multiselect-item', {
        'p-highlight': _vm.isSelected(option),
        'p-disabled': _vm.isOptionDisabled(option)
      }],
      attrs: {
        "role": "option",
        "aria-selected": _vm.isSelected(option),
        "aria-label": _vm.getOptionLabel(option),
        "tabindex": _vm.tabindex || '0'
      },
      on: {
        "click": function($event) {
          _vm.onOptionSelect($event, option)
        },
        "keydown": function($event) {
          _vm.onOptionKeyDown($event, option)
        }
      }
    }, [_c('div', {
      staticClass: "p-checkbox p-component"
    }, [_c('div', {
      class: ['p-checkbox-box', {
        'p-highlight': _vm.isSelected(option)
      }]
    }, [_c('span', {
      class: ['p-checkbox-icon', {
        'pi pi-check': _vm.isSelected(option)
      }]
    })])]), _vm._v(" "), _vm._t("option", [_c('span', [_vm._v(_vm._s(_vm.getOptionLabel(option)))])], {
      option: option,
      index: i
    })], 2)
  }), _vm._v(" "), (_vm.filterValue && (!_vm.visibleOptions || (_vm.visibleOptions && _vm.visibleOptions.length === 0))) ? _c('li', {
    staticClass: "p-multiselect-empty-message"
  }, [_vm._v(_vm._s(_vm.emptyFilterMessage))]) : _vm._e()], 2)])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.isAccountCreationModalVisible) ? _c('accountCreation') : _vm._e(), _vm._v(" "), (_vm.isSuggestedAddressModalVisible) ? _c('address-suggestion') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper content-wrapper-banner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel b text-white banner-width title-panel"
  }, [_c('div', {
    staticClass: "panel-body bg-cover clearfix"
  }, [_c('div', {
    staticClass: "media mt0"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "media-body media-middle"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('p', {
    staticClass: "information-title"
  }, [_vm._v("Personal Information")]), _vm._v(" "), _c('h3', {
    staticClass: "media-heading m0"
  }, [_vm._v(_vm._s(_vm.userProfile.firstName) + " " + _vm._s(_vm.userProfile.lastName))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper content-wrapper-container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Basic information\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("First name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfile.firstName),
      expression: "userProfile.firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('FirstName')
    },
    attrs: {
      "type": "text",
      "name": "FirstName",
      "id": "FirstName",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.userProfile.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userProfile.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('FirstName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Last name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfile.lastName),
      expression: "userProfile.lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('LastName')
    },
    attrs: {
      "type": "text",
      "name": "LastName",
      "id": "LastName",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.userProfile.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userProfile.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('LastName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Email*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfile.email),
      expression: "userProfile.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('Email')
    },
    attrs: {
      "type": "text",
      "name": "Email",
      "id": "Email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.userProfile.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userProfile.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('Email')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "primaryPhoneNum"
    }
  }, [_vm._v("Primary phone number*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfile.primaryPhoneNum),
      expression: "userProfile.primaryPhoneNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('primaryPhoneNum')
    },
    attrs: {
      "id": "primaryPhoneNum",
      "name": "primaryPhoneNum",
      "placeholder": "Phone number"
    },
    domProps: {
      "value": (_vm.userProfile.primaryPhoneNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userProfile.primaryPhoneNum = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('primaryPhoneNum')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ssn"
    }
  }, [_vm._v("Secondary phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userProfile.secondaryPhoneNum),
      expression: "userProfile.secondaryPhoneNum"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "spn"
    },
    domProps: {
      "value": (_vm.userProfile.secondaryPhoneNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userProfile.secondaryPhoneNum = $event.target.value
      }
    }
  })])])]), _vm._v(" "), (_vm.userProfile.residentialAddress.state) ? _c('addresses-form', {
    key: 1,
    ref: "addresses",
    attrs: {
      "firstTitle": 'Residential Address',
      "residentialAddress": _vm.userProfile.residentialAddress,
      "secondTitle": 'Mailing Address',
      "mailingAddress": _vm.userProfile.mailingAddress
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitButton()
    },
    on: {
      "click": function($event) {
        _vm.validateAndSubmitUser()
      }
    }
  }, [_vm._v("Submit")])])])], 1)])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Personal information\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-thumbnail img-circle thumb45",
    attrs: {
      "src": __webpack_require__(123),
      "alt": "Image"
    }
  })])])
}]}

/***/ }),
/* 2175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "top": "100px"
    },
    attrs: {
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('div', {
    staticClass: "modal-close col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "modal-button",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title "
  }, [_vm._v("Interest adjustment - " + _vm._s(_vm.noteId))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body mt-lg"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons mt-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-adjust",
    attrs: {
      "type": "button",
      "disabled": _vm.isSubmitDisabled
    },
    on: {
      "click": function($event) {
        _vm.submitAction()
      }
    }
  }, [_vm._v("Submit adjustments")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 2176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShowing) ? _c('div', {
    staticClass: "alert alert-dismissible",
    class: ("alert-" + _vm.alertType),
    attrs: {
      "role": "alert"
    }
  }, [(_vm.dismissible) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeAction
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-container"
  }, [(_vm.showIcon) ? _c('img', {
    class: {
      'alert-with-notice': _vm.notice
    },
    attrs: {
      "src": _vm.getAlertImageUrl(),
      "alt": "payment",
      "width": "50",
      "height": "50"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-container"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _c('p', {
    staticClass: "notice"
  }, [_vm._v(_vm._s(_vm.notice))])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 2177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.clazz,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path) {
    return _c('path', _vm._b({}, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon) {
    return _c('polygon', _vm._b({}, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v("\b\n    "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.icon.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),
/* 2178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _vm._m(1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Account Suspended\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('p', [_vm._v("\n            Your account has been suspended. Please contact the Calvert Impact Capital for more details at "), _c('a', {
    attrs: {
      "href": "mailto:info@calvertimpact.org"
    }
  }, [_vm._v("info@calvertimpact.org")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "tel:+18002480337"
    }
  }, [_vm._v("800.248.0337")])])])])
}]}

/***/ }),
/* 2179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('em', {
    staticClass: "sa-icon sa-info icon-exclamation"
  }), _vm._v(" "), _c('h2', {
    staticClass: "modal-title "
  }, [_vm._v("Suggested address")]), _vm._v(" "), _c('p', {
    staticClass: "modal-subtitle"
  }, [_vm._v("We’ve found the following address given the details you provided:")]), _vm._v(" "), _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v(" " + _vm._s(_vm.suggestedAddress.streetAddress1)), _c('br'), _vm._v(" "), (_vm.suggestedAddress.streetAddress2) ? _c('span', [_vm._v(_vm._s(_vm.suggestedAddress.streetAddress2) + " "), _c('br')]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.suggestedAddress.city) + ", " + _vm._s(_vm.suggestedAddress.state) + " " + _vm._s(_vm.suggestedAddress.zipCode) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_vm._t("body", [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('p', [_vm._v("Would you like to accept or edit the address?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("Go back to edit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.acceptSuggestion()
      }
    }
  }, [_vm._v("Accept suggestion")])])])])], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 2180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('em', {
    staticClass: "sa-icon sa-error fa fa-warning"
  }), _vm._v(" "), _c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("There is a problem")]), _vm._v(" "), _vm._l((_vm.reducedErrors), function(error) {
    return _c('p', {
      staticClass: "modal-paragraph"
    }, [_vm._v("\n          " + _vm._s(error) + "\n        ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_vm._t("body", [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-accept",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("OK")])])])])], 2)], 2)])])
},staticRenderFns: []}

/***/ }),
/* 2181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('div', {
    staticClass: "spinner-container"
  }, [_c('spinner', {
    staticClass: "spinner-secction"
  })], 1) : _c('tabs', [_c('tab', {
    attrs: {
      "name": "Reports",
      "selected": true
    }
  }, [_c('DocumentView', {
    attrs: {
      "documents": _vm.reports,
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Monthly Statements"
    }
  }, [_c('DocumentView', {
    attrs: {
      "documents": _vm.monthlys,
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Tax Documents"
    }
  }, [_c('DocumentView', {
    attrs: {
      "documents": _vm.taxes,
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Transaction Notices"
    }
  }, [_c('DocumentView', {
    attrs: {
      "documents": _vm.transactionNotices,
      "user": _vm.user
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Note list")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.isBulkRedemptionVisible) ? _c('bulk-redemption', {
    attrs: {
      "accountId": _vm.accountId
    },
    on: {
      "close": _vm.closeBulkRedemption,
      "completed": _vm.onBulkRedemptionCompleted
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isBulkTransferVisible) ? _c('bulk-transfer', {
    attrs: {
      "accountId": _vm.accountId
    },
    on: {
      "close": _vm.closeBulkTransfer,
      "completed": _vm.onBulkTransferCompleted
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg top-margin",
    attrs: {
      "type": "button",
      "disabled": _vm.disableInvestment
    },
    on: {
      "click": function($event) {
        _vm.goToPurchaseInvestmentNote()
      }
    }
  }, [_vm._v("\n        Make an investment\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg top-margin ml-sm",
    attrs: {
      "type": "button",
      "disabled": !_vm.hasOpenNotes,
      "title": "Redeem every open note on this account in one request"
    },
    on: {
      "click": function($event) {
        _vm.openBulkRedemption()
      }
    }
  }, [_vm._v("\n        Redeem/approve all open notes\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-outline btn-lg top-margin ml-sm",
    attrs: {
      "type": "button",
      "disabled": !_vm.hasTransferableNotes,
      "title": "Transfer every note on this account to another account in one request"
    },
    on: {
      "click": function($event) {
        _vm.openBulkTransfer()
      }
    }
  }, [_vm._v("\n        Transfer all notes\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 text-right account-balance-column"
  }, [_c('br', {
    staticClass: "panel-subtitle"
  }), _vm._v(" Current account balance: "), _c('strong', {
    staticClass: "amountBalance"
  }, [_vm._v(_vm._s(_vm.formatAmount(_vm.currentAmountBalance)))])])]), _vm._v(" "), (_vm.notes.length === 0) ? _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row mt-lg mb-lg"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [(_vm.notes.length > 0) ? _c('div', {
    class: {
      'table-fixed-header--md table-fixed-column cols-11': _vm.notes.length > 6, 'table-responsive': true, 'bottom-margin': true
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-col"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotesById('noteId')
      }
    }
  }, [_c('span', [_vm._v("Note number")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('noteId')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('originalBalance')
      }
    }
  }, [_c('span', [_vm._v("Original amount")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('originalBalance')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('currentBalance')
      }
    }
  }, [_c('span', [_vm._v("Current amount")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('currentBalance')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('interestRate')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Rate")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('interestRate')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('interestTerm')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Term")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('interestTerm')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('purchasedOn')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Purchase date")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('purchasedOn')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('openedOn')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Open date")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('openedOn')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('maturityDate')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Maturity date")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('maturityDate')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortByStatus()
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Status")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('status')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title large-container",
    on: {
      "click": function($event) {
        _vm.sortNotesById('legacyNoteID')
      }
    }
  }, [_c('span', [_vm._v("Legacy note number")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('legacyNoteID')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("View details")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderedNotes), function(note, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center sticky-col"
    }, [_vm._v(_vm._s(note.noteId))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.originalBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatRate(note.interestRate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatTerm(note.interestTerm)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.purchasedOn)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.openedOn)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.maturityDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(note.status == 'cancelled') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (note.status == 'failed') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (note.status == 'closed') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Closed")]) : _vm._e(), _vm._v(" "), (note.status == 'pending') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (note.status == 'open') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Open")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(note.legacyNoteID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(note)
        }
      }
    }, [_vm._v("View details")])])])
  }))])]) : _vm._e()])]), _vm._v(" "), (_vm.displayAlertForUpcomingTransactionsWithAction) ? _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Click "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.gotToUpcomingTransactionsSegment($event)
      }
    }
  }, [_vm._v("here")]), _vm._v(" to review the actions received for the transactions.")])])])]) : _vm._e(), _vm._v(" "), (_vm.displayAlertForUpcomingTransactionsWithNoAction) ? _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v("Click "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.gotToUpcomingTransactionsSegment($event)
      }
    }
  }, [_vm._v("here")]), _vm._v(" to see the transactions that require action.")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        No notes were found.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("Please note this account has upcoming transactions that have received action.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("Please note this account has upcoming transactions that require action.")])
}]}

/***/ }),
/* 2183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper main-container"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "search-area"
  }, [_c('form', {
    staticClass: "mb-xl top-margin form-row",
    attrs: {
      "role": "form",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback searchbox"
  }, [_c('div', {
    staticClass: "dropdown",
    class: _vm.isSearchOpen ? 'dropdown-open' : 'dropdown-closed',
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.toggleIsSearchOpen,
      "blur": function($event) {
        _vm.isSearchOpen = false
      }
    }
  }, [(!_vm.isSearchOpen) ? _c('h4', {
    staticClass: "current-search-by"
  }, [_vm._v(_vm._s(_vm.currentSearchByDisplay)), _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('h4', {
    staticClass: "current-search-by",
    attrs: {
      "id": "filter-by"
    }
  }, [_vm._v("Filter by")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-content"
  }, _vm._l((_vm.searchTypes), function(searchType) {
    return _c('li', {
      key: searchType.name,
      staticClass: "search-option",
      on: {
        "click": function($event) {
          _vm.updatedSearchingBy(searchType)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check",
      class: _vm.currentSearchByDisplay !== searchType.displayName ? 'transparent-text' : '',
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                    " + _vm._s(searchType.displayName) + "\n                  ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "search-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "searchInput",
    staticClass: "form-control",
    attrs: {
      "id": "search",
      "type": "text",
      "placeholder": "Enter your search here...",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "focus": _vm.onSearchFocus,
      "blur": _vm.onSearchBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasSearched || _vm.search) ? _c('p', {
    attrs: {
      "id": "clear-icon"
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_vm._v("X")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitSearch
    },
    on: {
      "click": _vm.searchInvestors
    }
  }, [_c('em', {
    staticClass: "icon-magnifier pr-sm"
  }), _vm._v(" Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.goToCreateUser()
      }
    }
  }, [_c('em', {
    staticClass: "icon-user-follow pr-sm"
  }), _vm._v(" Create new user")])])]), _vm._v(" "), _c('recent-records', {
    attrs: {
      "visible": _vm.isSearchFocused
    }
  })], 1), _vm._v(" "), (_vm.isSearchLoading) ? _c('spinner', {
    staticClass: "table-spinner"
  }) : _c('div', {
    staticClass: "panel-heading"
  }, [(_vm.areResultsEmpty && !_vm.isSearchLoading) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg",
    attrs: {
      "role": "alert"
    }
  }, [_c('section', {
    staticClass: "search-message--no-result"
  }, [_c('i', {
    staticClass: "fa fa-window-close-o"
  }), _vm._v(" "), _c('h4', [_vm._v("No results found for \"" + _vm._s(_vm.searchMessage) + "\"")]), _vm._v(" "), _c('p', [_vm._v("Make sure your text is spelled correctly or try with a different keyword.")])])])]) : (!_vm.hasSearched && !_vm.isSearchLoading) ? _c('div', [_c('section', {
    staticClass: "search-message--empty"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('h4', [_vm._v("You can search by:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Name / email - using investor's name, account name or email")]), _vm._v(" "), _c('li', [_vm._v("Advisor firm - using company name 1 or company name 2")]), _vm._v(" "), _c('li', [_vm._v("Note number or CUSIP")]), _vm._v(" "), _c('li', [_vm._v("Account number")])])])]) : _c('div', [(_vm.results) ? _c('div', {
    staticClass: "table-responsive top-margin"
  }, [(_vm.searchingBy === 'ACCOUNT_NUMBER') ? _c('search-by-account-results', {
    attrs: {
      "results": _vm.results,
      "searchMessage": _vm.searchMessage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchingBy === 'NAME_EMAIL' || _vm.searchingBy === 'ADVISOR_FIRM') ? _c('search-by-name-or-email-results', {
    attrs: {
      "results": _vm.results,
      "searchMessage": _vm.searchMessage,
      "show-company-names": _vm.searchingBy === 'ADVISOR_FIRM'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchingBy === 'NOTE_NUMBER' || _vm.searchingBy === 'CUSIP') ? _c('search-by-note-number-or-cusip-results', {
    attrs: {
      "results": _vm.results,
      "searchMessage": _vm.searchMessage
    }
  }) : _vm._e()], 1) : _vm._e()])])], 1)])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
}]}

/***/ }),
/* 2184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-heading"
  }, [_vm._v("Payment preferences")]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('dismissable-alert', {
    attrs: {
      "title": "Your preferences have been updated. This update does not change upcoming transactions within 45 days.",
      "closeAction": _vm.hidePaymentPreferenceUpdated,
      "isShowing": _vm.paymentPreferenceWasUpdated
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "payment-preferences"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "preferences-container"
  }, [_c('div', {
    staticClass: "principal-preferences preferences"
  }, [_c('h3', {
    staticClass: "preference-type-title"
  }, [_vm._v("Principal maturity")]), _vm._v(" "), _vm._l((_vm.availablePreferences), function(preference) {
    return _c('div', {
      key: preference.id
    }, [_c('div', {
      class: {
        'radio-item': true,
        'radio-item-unselected':
        preference.name !== _vm.paymentPreference,
      },
      style: ({
        pointerEvents: _vm.isReadOnly ? 'none' : null,
        opacity: _vm.isReadOnly ? 0.6 : 1
      }),
      on: {
        "click": function($event) {
          _vm.setPrincipalPreference(preference.name)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": true
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "preference-text"
    }), _vm._v(_vm._s(preference.text) + "\n                    "), _c('label')])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "interest-preferences preferences"
  }, [_c('h3', {
    staticClass: "preference-type-title"
  }, [_vm._v("Interest payment")]), _vm._v(" "), _vm._l((_vm.availablePreferences), function(preference) {
    return _c('div', {
      key: preference.id
    }, [_c('div', {
      class: {
        'radio-item': true,
        'radio-item-unselected':
        preference.name !== _vm.interestPreference,
      },
      style: ({
        pointerEvents: _vm.isReadOnly ? 'none' : null,
        opacity: _vm.isReadOnly ? 0.6 : 1
      }),
      on: {
        "click": function($event) {
          _vm.setInterestPreference(preference.name)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": true
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "preference-text"
    }), _vm._v(_vm._s(preference.text) + "\n                    "), _c('label')])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": function($event) {
        _vm.updatePaymentPreferences()
      }
    }
  }, [_vm._v("\n        Submit\n      ")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "separator mt-xl mb-lg"
  }, [_c('p', {
    staticClass: "description"
  }, [_vm._v("\n                Change your payment preferences by selecting between the\n                options we provide below.\n              ")])])
}]}

/***/ }),
/* 2185 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n    " + _vm._s(_vm.resultsLength) + " results found for \""), _c('b', [_vm._v(_vm._s(_vm.searchMessage.toUpperCase()))]), _vm._v("\"\n  ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped bank-accounts table-fundings",
    attrs: {
      "id": "results"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.hasNotes) ? _vm._l((_vm.notes), function(note, index) {
    return _c('tr', {
      key: (index + "-note-" + (note.noteId))
    }, [_c('td', [_vm._v(_vm._s(note.noteId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(note.cusip))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.account.accountId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.account.accountName))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToAccountDetail(_vm.account)
        }
      }
    }, [_vm._v("Account details")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToNoteDetails(note)
        }
      }
    }, [_vm._v("Note details")])])])
  }) : [_c('tr', [_c('td', [_vm._v("---")]), _vm._v(" "), _c('td', [_vm._v("---")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.account.accountId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.account.accountName))]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-details btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goToAccountDetail(_vm.account)
      }
    }
  }, [_vm._v("Account details")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-details btn-outline",
    attrs: {
      "disabled": "",
      "type": "button"
    }
  }, [_vm._v("Note details")])])])]], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Note number")]), _vm._v(" "), _c('th', [_vm._v("CUSIP number")]), _vm._v(" "), _c('th', [_vm._v("Account number")]), _vm._v(" "), _c('th', [_vm._v("Account name")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 2186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible && _vm.records.length),
      expression: "visible && records.length"
    }],
    staticClass: "recent-records"
  }, [_c('h5', {
    staticClass: "recent-records-title"
  }, [_vm._v("Recently viewed")]), _vm._v(" "), _c('ul', {
    staticClass: "recent-records-list"
  }, _vm._l((_vm.records), function(record) {
    return _c('li', {
      key: ((record.type) + "-" + (record.id)),
      staticClass: "recent-records-row",
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.goTo(record)
        }
      }
    }, [_c('span', {
      staticClass: "recent-records-type"
    }, [_vm._v(_vm._s(_vm.typeLabel(record.type)))]), _vm._v(" "), _c('span', {
      staticClass: "recent-records-label"
    }, [_vm._v(_vm._s(_vm.displayLabel(record)))]), _vm._v(" "), _c('span', {
      staticClass: "recent-records-time"
    }, [_vm._v(_vm._s(_vm.formatViewedAt(record.viewedAt)))])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('center', {
    staticClass: "page"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(230),
      "alt": "Maintenance",
      "width": "300"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title extra-space"
  }, [_vm._v("We'll be back soon!")]), _vm._v(" "), _c('p', {
    staticClass: "text extra-space"
  }, [_vm._v("We're currently undergoing maintenance, the site will be online shortly.")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("If you need more help, please contact Calvert Impact Capital at")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('a', {
    staticClass: "hyperlink",
    attrs: {
      "href": "mailto:info@calvertimpact.org"
    }
  }, [_vm._v("info@calvertimpact.org")]), _vm._v(" or call us at\n      "), _c('a', {
    staticClass: "hyperlink",
    attrs: {
      "href": "tel:8002480337"
    }
  }, [_vm._v("800-248-0337")]), _vm._v(".\n    ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar topnavbar",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand"
  }, [_c('div', {
    staticClass: "brand-logo"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": __webpack_require__(229),
      "alt": "Calvert Impact Capital",
      "width": "120"
    }
  })])])])])
}]}

/***/ }),
/* 2188 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('nav', {
    attrs: {
      "aria-label": "breadcrumb"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.breadcrumbsData), function(route, index) {
    return _c('li', {
      key: index,
      staticClass: "breadcrumb-item",
      class: {
        active: route.selected
      }
    }, [(!route.selected) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.onClick(route)
        }
      }
    }, [_vm._v(_vm._s(route.title))]) : _vm._e(), _vm._v("\n             " + _vm._s(route.selected ? route.title : null) + "\n          ")])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 2189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Documents")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('DocumentTabView')], 1)])
},staticRenderFns: []}

/***/ }),
/* 2190 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('onboarding-wizard', {
    attrs: {
      "userStatus": _vm.userStatus
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [(!_vm.uploadSucceeded && _vm.needsDocumentation && _vm.documentationReason) ? _c('div', [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDocumentationReason()))])])]) : _vm._e(), _vm._v(" "), (_vm.uploadFailed) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v("Make sure that your documentation is in a valid format and is no more than 10 MB.")])]) : _vm._e(), _vm._v(" "), (_vm.uploadSucceeded) ? _c('div', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.documentationInReview) ? _c('div', [_vm._m(4)]) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "mt-lg"
  }, [_vm._v("In order to complete verifying your personal information, we need you to upload a copy of one of the following documents:")]), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "radio c-radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentType),
      expression: "documentType"
    }],
    attrs: {
      "type": "radio",
      "name": "documentType",
      "value": "license"
    },
    domProps: {
      "checked": _vm._q(_vm.documentType, "license")
    },
    on: {
      "__c": function($event) {
        _vm.documentType = "license"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-circle"
  }), _vm._v("Driver's license")])]), _vm._v(" "), _c('div', {
    staticClass: "radio c-radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentType),
      expression: "documentType"
    }],
    attrs: {
      "type": "radio",
      "name": "documentType",
      "value": "passport"
    },
    domProps: {
      "checked": _vm._q(_vm.documentType, "passport")
    },
    on: {
      "__c": function($event) {
        _vm.documentType = "passport"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-circle"
  }), _vm._v("Passport")])]), _vm._v(" "), _c('div', {
    staticClass: "radio c-radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentType),
      expression: "documentType"
    }],
    attrs: {
      "type": "radio",
      "name": "documentType",
      "value": "idCard"
    },
    domProps: {
      "checked": _vm._q(_vm.documentType, "idCard")
    },
    on: {
      "__c": function($event) {
        _vm.documentType = "idCard"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-circle"
  }), _vm._v("ID card")])]), _vm._v(" "), _c('div', {
    staticClass: "radio c-radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentType),
      expression: "documentType"
    }],
    attrs: {
      "type": "radio",
      "name": "documentType",
      "value": "other"
    },
    domProps: {
      "checked": _vm._q(_vm.documentType, "other")
    },
    on: {
      "__c": function($event) {
        _vm.documentType = "other"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-circle"
  }), _vm._v("Other")])])]), _vm._v(" "), (_vm.selectedFile) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel discoverer",
    attrs: {
      "data-filter-group": "image"
    }
  }, [_c('div', {
    staticClass: "panel-body text-center"
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-dark"
  }, [_vm._v(_vm._s(_vm.selectedFile.name))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix m0 text-muted"
  }, [_c('small', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s((_vm.selectedFile.size / 1024).toFixed(2).toString() + "KB"))])])])])])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-inline",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group mt-lg",
    class: {
      'has-error': _vm.isFileInvalid
    }
  }, [_c('input', {
    staticClass: "form-control filestyle",
    staticStyle: {
      "position": "absolute",
      "clip": "rect(0px 0px 0px 0px)"
    },
    attrs: {
      "type": "file",
      "data-classbutton": "btn btn-default",
      "data-classinput": "form-control inline",
      "id": "filestyle-0",
      "tabindex": "-1",
      "accept": _vm.getAcceptedFileExtensions()
    },
    on: {
      "change": _vm.fileChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bootstrap-filestyle input-group"
  }, [_c('input', {
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "placeholder": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.selectedFile ? _vm.selectedFile.name : ''
    }
  }), _vm._v(" "), _vm._m(8)]), _vm._v(" "), (_vm.isFileInvalid) ? _c('span', {
    staticClass: "help-block m-b-none"
  }, [_vm._v("The file you selected is not valid. Please select a different file.")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Your file must be in " + _vm._s(_vm.supportedFileExtensions) + " format and cannot exceed 10MB.")])]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit()
    },
    on: {
      "click": _vm.handleUpload
    }
  }, [_vm._v("Submit")])])])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n       Upload Documentation\n       "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "fa fa-warning pr-sm"
  }), _vm._v("Verification of your documents failed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "fa fa-warning pr-sm"
  }), _vm._v("There was a problem uploading your documentation. Please try again.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_c('h4', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("We've received your documentation")]), _vm._v(" "), _c('p', [_vm._v("Please allow up to 48 hours while we verify it.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_c('h4', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("Your documentation is being verified.")]), _vm._v(" "), _c('p', [_vm._v("Please allow up to 48 hours while we verify it.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Additional documentation required")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix discover"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "text-muted mr-sm",
    attrs: {
      "href": "#",
      "title": "Download"
    }
  }, [_c('em', {
    staticClass: "fa fa-download fa-fw"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "file-icon ph-lg",
    attrs: {
      "href": "#"
    }
  }, [_c('em', {
    staticClass: "fa fa-5x fa-file-image-o text-green"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "group-span-filestyle input-group-btn",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('label', {
    staticClass: "btn btn-default",
    attrs: {
      "for": "filestyle-0"
    }
  }, [_c('span', {
    staticClass: "icon-span-filestyle fa fa-folder-open"
  }), _vm._v(" "), _c('span', {
    staticClass: "buttonText"
  }, [_vm._v("Choose file")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "panel-list mt-lg mb-xl text-muted"
  }, [_c('li', {
    staticClass: "help-block"
  }, [_vm._v("Ensure that your document has not expired.")]), _vm._v(" "), _c('li', {
    staticClass: "help-block"
  }, [_vm._v("The document should not look fuzzy or cropped.")]), _vm._v(" "), _c('li', {
    staticClass: "help-block"
  }, [_vm._v("Make sure the name and address match your investor profile information.")])])
}]}

/***/ }),
/* 2191 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isSuggestedAddressModalVisible) ? _c('address-suggestion') : _vm._e(), _vm._v(" "), _c('bank-account-changed-warning', {
    attrs: {
      "isVisible": _vm.isBankAccountChangedWarningVisible,
      "isAdminView": true
    },
    on: {
      "close": _vm.hideBankAccountChangedWarning,
      "goToUpcomingTransactions": _vm.handleGoToUpcomingTransactions
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.userDetailLoading ||
    _vm.accountUsersLoading ||
    _vm.isNotesSegmentLoading ||
    _vm.isFundingSourcesSegmentLoading ||
    _vm.preferencesSpinner ||
    _vm.isUpcomingTransactionsSegmentLoading ||
    _vm.isAdditionalEmailsLoading ||
    _vm.isRepresentativesLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Account information")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('RestrictedSingleInput', {
    attrs: {
      "input": _vm.organization.name,
      "limit": 40
    },
    on: {
      "inputUpdated": _vm.onInstitutionNameUpdate
    }
  }), _vm._v(" "), (_vm.organization && _vm.organization.name && _vm.organization.name.trim().length === 0) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.accountId) + " ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row space zero-margin-x"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.formatDate(_vm.account.createdAt)) + " ")])])])]), _vm._v(" "), (_vm.account.investorSince) ? _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.account.investorSince) ? _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.investorSince) + " ")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [(_vm.account.status == 'active') ? _c('p', {
    staticClass: "label label-success capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.status == 'pending') ? _c('p', {
    staticClass: "label label-warning capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.status == 'inactive') ? _c('p', {
    staticClass: "label label-danger capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.hasUserComments) ? _c('p', {
    staticClass: "label label-danger capitalize-text"
  }, [_vm._v(" Comments ")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {}, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.type),
      expression: "organization.type"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('institutionType')
    },
    attrs: {
      "name": "institutionType",
      "id": "institutionType",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.organization.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.institutionTypes), function(institutionType, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": institutionType.name
      }
    }, [_vm._v("\n                        " + _vm._s(institutionType.text) + "\n                      ")])
  })), _vm._v(" "), (_vm.errors.has('institutionType')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.taxId),
      expression: "organization.taxId"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('99-9999999'),
      expression: "'99-9999999'"
    }],
    class: {
      'form-control': true,
      'form-control-error': _vm.errors.has('taxId') || !_vm.isTaxIdValid()
    },
    attrs: {
      "name": "taxId",
      "id": "taxId"
    },
    domProps: {
      "value": (_vm.organization.taxId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organization.taxId = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('taxId') || !_vm.isTaxIdValid()) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.organization.phoneNumber),
      expression: "organization.phoneNumber"
    }],
    class: {
      'form-control': true,
      'form-control-error': _vm.errors.has('phone') || !_vm.isPhoneNumberValid()
    },
    attrs: {
      "name": "phone",
      "id": "phone"
    },
    domProps: {
      "value": (_vm.organization.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organization.phoneNumber = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('phone') || !_vm.isPhoneNumberValid()) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.legacyUsername) + " ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(_vm.account.legacyCustomerNumber) + " ")])])])])])]), _vm._v(" "), (_vm.organization.mainAddress && _vm.organization.mailingAddress) ? _c('Addresses', {
    key: 1,
    ref: "addresses",
    attrs: {
      "firstTitle": 'Institution Address',
      "residentialAddress": _vm.organization.mainAddress,
      "secondTitle": 'Mailing Address',
      "mailingAddress": _vm.organization.mailingAddress,
      "is-admin": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "disabled": _vm.shouldSubmitButtonBeDisabled()
    },
    on: {
      "click": function($event) {
        _vm.validateAndSubmitAccount()
      }
    }
  }, [_vm._v("\n                  Submit account information\n                ")])])])], 1)])]), _vm._v(" "), (_vm.accountRepresentatives !== undefined) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountEmails', {
    attrs: {
      "accountId": _vm.accountId,
      "emails": _vm.accountEmails
    },
    on: {
      "additionalEmailsAddingFailed": _vm.setAdditionalEmailSpinnerOff,
      "additionalEmailsAddingStarted": _vm.setAdditionalEmailSpinnerOn,
      "additionalEmailsAddingSucceed": _vm.setAdditionalEmailSpinnerOff,
      "additionalEmailsDeletingFailed": _vm.setAdditionalEmailSpinnerOff,
      "additionalEmailsDeletingStarted": _vm.setAdditionalEmailSpinnerOn,
      "additionalEmailsDeletingSucceed": _vm.setAdditionalEmailSpinnerOff
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.accountRepresentatives !== undefined && _vm.account.primaryInvestorId) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountRepresentatives', {
    attrs: {
      "accountId": _vm.accountId,
      "accountName": _vm.accountName,
      "accountType": _vm.getAccountType(),
      "representatives": _vm.accountRepresentatives,
      "primaryInvestorId": _vm.account.primaryInvestorId
    },
    on: {
      "representativesLoadingStarted": _vm.setRepresentativesSpinnerOn,
      "representativesLoadingSucceed": _vm.setRepresentativesSpinnerOff,
      "representativesLoadingFailed": _vm.setRepresentativesSpinnerOff,
      "representativesUpdated": _vm.loadAccountInformation
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountNotes', {
    attrs: {
      "accountId": _vm.accountId,
      "displayAlertForUpcomingTransactionsWithAction": _vm.shouldUpcomingTransactionsWithActionsBeDisplayed,
      "displayAlertForUpcomingTransactionsWithNoAction": _vm.shouldUpcomingTransactionsWithNoActionsBeDisplayed,
      "disable-investment": _vm.user.disableInvestment || _vm.organization.disableInvestment
    },
    on: {
      "goToUpcomingTransactionsSegment": function($event) {
        _vm.goToSegment('upcoming-transactions-segment')
      },
      "notesLoadingFailed": _vm.setNotesSpinnerOff,
      "notesLoadingStarted": _vm.setNotesSpinnerOn,
      "notesLoadingSucceed": _vm.setNotesSpinnerOff,
      "redirectToNoteDetailsView": _vm.goToViewDetail,
      "redirectToPurchaseInvestmentNoteView": _vm.goToPurchaseInvestmentNote
    }
  })], 1)]), _vm._v(" "), (_vm.account.defaultFundingSourceId !== undefined) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "funding-sources-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AccountFundingSources', {
    attrs: {
      "accountId": _vm.accountId,
      "defaultFundingSourceId": _vm.userAccount.defaultFundingSourceId,
      "account": _vm.account
    },
    on: {
      "fundingSourcesLoadingFailed": _vm.setFundingSourceSpinnerOff,
      "fundingSourcesLoadingStarted": _vm.setFundingSourceSpinnerOn,
      "fundingSourcesLoadingSucceed": _vm.setFundingSourceSpinnerOff,
      "defaultFundingSourceUpdated": _vm.handleDefaultFundingSourceUpdated,
      "restart": _vm.loadAccountUsers,
      "showBankAccountChangedWarning": _vm.showBankAccountChangedWarning
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('AdminAccountDocuments')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "preferences-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Preferences\n          ")]), _vm._v(" "), _c('SuccessAlert', {
    attrs: {
      "isVisible": _vm.isPreferencesSuccessMessageVisible,
      "message": _vm.preferencesSuccessMessage
    },
    on: {
      "hideSuccessAlert": _vm.hidePreferencesSuccessMessage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.account.communicationPreference !== undefined) ? _c('AccountPreferences', {
    attrs: {
      "accountId": _vm.accountId,
      "interestPreference": _vm.account.interestPreference,
      "communicationPreference": _vm.account.communicationPreference,
      "communication1099Preference": _vm.account.communication1099Preference,
      "communicationImpactReportPreference": _vm.account.communicationImpactReportPreference,
      "paymentPreference": _vm.account.paymentPreference,
      "redemptionRestriction": _vm.account.redemptionRestriction,
      "user": _vm.user
    },
    on: {
      "impactPreferencesLoadingFailed": _vm.setPreferencesSpinnerOff,
      "impactPreferencesLoadingStarted": _vm.setPreferencesSpinnerOn,
      "impactPreferencesLoadingSucceed": _vm.setPreferencesSpinnerOff,
      "updateImpactPreferencesFailed": _vm.setPreferencesSpinnerOff,
      "updateImpactPreferencesStarted": _vm.setPreferencesSpinnerOn,
      "updateImpactPreferencesSucceed": _vm.displayImpactPreferenceSuccessfulNotification
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "upcoming-transactions-segment"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('UpcomingTransactions', {
    ref: "upcomingTransactions",
    attrs: {
      "accountId": _vm.accountId,
      "defaultFundingSourceId": _vm.userAccount.defaultFundingSourceId,
      "investorAccountIdentifier": _vm.userAccount.accountId
    },
    on: {
      "goToFundingSourcesSegment": function($event) {
        _vm.goToSegment('funding-sources-segment')
      },
      "hideAlertForUpcomingTransactions": _vm.hideUpcomingTransactionsAlerts,
      "showAlertForUpcomingTransactionsWithAction": _vm.displayUpcomingTransactionsWithActionAlert,
      "showAlertForUpcomingTransactionsWithNoAction": _vm.displayUpcomingTransactionsWithNoActionAlert,
      "upcomingTransactionsLoadingFailed": _vm.setUpcomingTransactionsSpinnerOff,
      "upcomingTransactionsLoadingStarted": _vm.setUpcomingTransactionsSpinnerOn,
      "upcomingTransactionsLoadingSucceed": _vm.setUpcomingTransactionsSpinnerOff
    }
  })], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Institution account\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Institution name *")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("ID")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v("Date Created:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Investor since:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Status:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Institution type *")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Tax ID *")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Phone number *")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Legacy Username:")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row space zero-margin-x"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', [_c('label', [_vm._v("Legacy Customer Number:")])])])])
}]}

/***/ }),
/* 2192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.isEditing ? 'Edit Additional Investment' : 'Add Funds to My Reinvestments'))]), _vm._v(" "), _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n        " + _vm._s(_vm.isEditing ? 'Update your additional investment details below.' : 'Select a note and enter the amount you want to add to your reinvestments.') + "\n      ")]), _vm._v(" "), (!_vm.isEditing) ? _c('div', {
    staticClass: "modal-info-box"
  }, [_c('p', {
    staticClass: "info-text"
  }, [_c('em', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n          You can add additional funds to your reinvestments between "), _c('strong', [_vm._v("45 and 3 days")]), _vm._v(" before the reinvestment date.\n          Only notes within this window are shown below.\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select note")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedNote),
      expression: "selectedNote"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "name": "note",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedNote = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select note")]), _vm._v(" "), _vm._l((_vm.availableNotes), function(note, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": note
      }
    }, [_vm._v("\n              Note " + _vm._s(note.noteId) + " - Reinvests " + _vm._s(_vm.formatDate(note.maturityDate)) + "\n            ")])
  })], 2), _vm._v(" "), (!_vm.selectedNote) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("\n            Please select a note\n          ")]) : _vm._e()]), _vm._v(" "), (_vm.selectedNote) ? _c('div', [(_vm.fundingSources && _vm.fundingSources.length > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select bank account")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedFundingSource),
      expression: "selectedFundingSource"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "name": "fundingSource",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedFundingSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select bank account")]), _vm._v(" "), _vm._l((_vm.fundingSources), function(fs, index) {
    return _c('option', {
      key: index,
      attrs: {
        "disabled": fs.removed
      },
      domProps: {
        "value": fs
      }
    }, [_vm._v("\n                " + _vm._s(fs.name) + "\n              ")])
  })], 2), _vm._v(" "), (!_vm.selectedFundingSource) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("\n              Please select a bank account\n            ")]) : _vm._e()]) : _c('div', {
    staticClass: "alert alert-warning no-bank-account-alert"
  }, [_c('p', {
    staticClass: "no-bank-text"
  }, [_vm._v("\n              You must connect a bank account to make ACH transfers.\n              "), _c('router-link', {
    staticClass: "bank-link",
    attrs: {
      "to": {
        name: 'AddFundingSource'
      }
    }
  }, [_vm._v("\n                Add a bank account\n              ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Amount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "placeholder": "$0.00",
      "required": ""
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.amountError) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("\n              " + _vm._s(_vm.amountError) + "\n            ")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), (_vm.selectedNote) ? _c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button",
      "disabled": !_vm.isFormValid || _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.submitAddMoney()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.loading ? 'Submitting...' : (_vm.isEditing ? 'Update Investment' : 'Add Money')) + "\n            ")]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "topnavbar-wrapper"
  }, [_c('nav', {
    staticClass: "navbar topnavbar",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "hamburger-menu",
    attrs: {
      "aria-label": "Toggle menu"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('span', {
    staticClass: "hamburger-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "hamburger-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "hamburger-icon"
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "nav-wrapper"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "dropdown dropdown-list"
  }, [_c('a', {
    staticClass: "dropdown-list--account",
    attrs: {
      "href": "#",
      "id": "user-block-toggle",
      "data-toggle": "dropdown",
      "aria-expanded": "true"
    }
  }, [_c('div', {
    staticClass: "dropdown-list--account__info"
  }, [(_vm.activeAccount) ? _c('strong', [_vm._v(_vm._s(_vm.activeAccount.accountName))]) : _vm._e(), _vm._v(" "), (_vm.activeAccount) ? _c('span', {
    staticClass: "user-block-role"
  }, [_vm._v(_vm._s(_vm.getAccountDescription(_vm.activeAccount.accountType)))]) : _vm._e(), _vm._v(" "), (!_vm.irAdmin && _vm.investorSince) ? _c('span', {
    staticClass: "user-block-investor-since"
  }, [_vm._v("Investor since " + _vm._s(_vm.investorSince))]) : _vm._e()]), _vm._v(" "), _c('b', {
    staticClass: "dropdown-list--account__icon icon-arrow-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu animated flipInX"
  }, [_c('li', [_c('div', {
    staticClass: "list-group"
  }, [_c('div', {
    staticClass: "list-group-item list-group-item--current"
  }, [_c('div', {
    staticClass: "media-box"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [(_vm.activeAccount) ? _c('img', {
    staticClass: "img-thumbnail img-circle",
    attrs: {
      "src": _vm.getAccountImgUrl(_vm.activeAccount.accountType),
      "alt": "Avatar",
      "width": "60",
      "height": "60"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "media-box-body clearfix"
  }, [(_vm.activeAccount) ? _c('p', {
    staticClass: "m0"
  }, [_vm._v(_vm._s(_vm.activeAccount.accountName))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "m0 text-muted"
  }, [(_vm.activeAccount) ? _c('small', [_vm._v(_vm._s(_vm.getAccountDescription(_vm.activeAccount.accountType)))]) : _vm._e()])]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), (!_vm.irAdmin && _vm.user.id !== undefined) ? _c('li', {
    staticClass: "action-widget",
    class: {
      disabled: !_vm.hasBeenCreatedAccount
    },
    attrs: {
      "id": "go-to-account-details"
    }
  }, [_c('router-link', {
    staticClass: "action-link",
    attrs: {
      "to": {
        name: 'InvestorAccountDetails',
        params: {
          id: _vm.activeAccountId
        }
      },
      "title": "Account details"
    }
  }, [_c('em', {
    staticClass: "fa fa-cogs"
  }), _vm._v(" "), (_vm.shouldGoBackButtonBeDisplayed) ? _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Client's account")]) : _vm._e(), _vm._v(" "), (!_vm.shouldGoBackButtonBeDisplayed) ? _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Account details")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.isFinancialAdvisor && _vm.activeAccount.primaryInvestorId !== _vm.user.id) ? _c('li', {
    staticClass: "action-widget",
    attrs: {
      "id": "go-to-profile widget"
    }
  }, [_c('router-link', {
    staticClass: "action-link",
    attrs: {
      "to": {
        name: 'EditUserProfileByAdvisor',
        params: {
          userId: _vm.activeAccount.primaryInvestorId
        }
      },
      "title": "Profile information"
    }
  }, [_c('em', {
    staticClass: "icon-user"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Client's profile")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.irAdmin && _vm.user.id !== undefined) ? _c('li', {
    staticClass: "action-widget",
    class: {
      disabled: !_vm.hasBeenCreatedAccount
    },
    attrs: {
      "id": "go-to-profile widget"
    }
  }, [_c('router-link', {
    staticClass: "action-link",
    attrs: {
      "to": {
        name: 'EditUserProfile'
      },
      "title": "Profile information"
    }
  }, [_c('em', {
    staticClass: "icon-user"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Personal information")])])], 1) : _vm._e(), _vm._v(" "), (_vm.shouldGoBackButtonBeDisplayed) ? _c('li', {
    staticClass: "action-widget list-go-back"
  }, [_c('router-link', {
    staticClass: "list-group-item",
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('div', {
    on: {
      "click": _vm.activateAdvisorAccount
    }
  }, [_c('img', {
    staticClass: "img-thumbnail img-circle",
    attrs: {
      "src": _vm.financialAdvisorAvatar,
      "alt": "Avatar",
      "width": "60",
      "height": "60"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Go back to your financial advisor account")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.user.id !== undefined) ? _c('li', [(_vm.sortedAccounts.length > 1) ? _c('div', {
    staticClass: "list-group list-group--title"
  }, [(!_vm.isFinancialAdvisor) ? _c('h5', {
    staticClass: "text-muted"
  }, [_vm._v("Switch account")]) : _c('h5', {
    staticClass: "text-muted"
  }, [_vm._v("Your clients' accounts")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedAccounts), function(nt, index) {
    return _c('div', {
      key: index,
      staticClass: "list-group"
    }, [(nt.id !== _vm.activeAccount.id && nt.accountType !== _vm.accountTypes.ADVISOR.name) ? _c('router-link', {
      staticClass: "list-group-item",
      attrs: {
        "to": {
          name: 'AccountSummary'
        }
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.activateAccount(nt)
        }
      }
    }, [_c('a', {
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "media-box"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_c('img', {
      staticClass: "img-thumbnail img-circle",
      attrs: {
        "src": _vm.getAccountImgUrl(nt.accountType),
        "alt": "Avatar",
        "width": "60",
        "height": "60"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "media-box-body clearfix"
    }, [_c('p', {
      staticClass: "m0"
    }, [_vm._v(_vm._s(nt.accountName))]), _vm._v(" "), _c('p', {
      staticClass: "m0 text-muted"
    }, [_c('small', [_vm._v(_vm._s(_vm.getAccountDescription(nt.accountType)))])])])])])])]) : _vm._e()], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "list-group"
  }, [_c('a', {
    staticClass: "list-group-item list-group-item--logout",
    on: {
      "click": _vm.callLogOut
    }
  }, [_vm._m(3)])])])])])])]), _vm._v(" "), _vm._m(4)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-brand"
  }, [_c('div', {
    staticClass: "brand-logo"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": __webpack_require__(229),
      "alt": "Calvert Impact Capital",
      "width": "120"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown dropdown-list hide"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('em', {
    staticClass: "icon-bell"
  }), _vm._v(" "), _c('div', {
    staticClass: "label label-danger"
  }, [_vm._v("11")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu animated flipInX"
  }, [_c('li', [_c('div', {
    staticClass: "list-group"
  }, [_c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "media-box"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('em', {
    staticClass: "fa fa-twitter fa-2x text-info"
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-box-body clearfix"
  }, [_c('p', {
    staticClass: "m0"
  }, [_vm._v("New followers")]), _vm._v(" "), _c('p', {
    staticClass: "m0 text-muted"
  }, [_c('small', [_vm._v("1 new follower")])])])])]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "media-box"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('em', {
    staticClass: "fa fa-envelope fa-2x text-warning"
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-box-body clearfix"
  }, [_c('p', {
    staticClass: "m0"
  }, [_vm._v("New e-mails")]), _vm._v(" "), _c('p', {
    staticClass: "m0 text-muted"
  }, [_c('small', [_vm._v("You have 10 new emails")])])])])]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "media-box"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('em', {
    staticClass: "fa fa-tasks fa-2x text-success"
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-box-body clearfix"
  }, [_c('p', {
    staticClass: "m0"
  }, [_vm._v("Pending Tasks")]), _vm._v(" "), _c('p', {
    staticClass: "m0 text-muted"
  }, [_c('small', [_vm._v("11 pending task")])])])])]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#"
    }
  }, [_c('small', [_vm._v("More notifications")]), _vm._v(" "), _c('span', {
    staticClass: "label label-danger pull-right"
  }, [_vm._v("14")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "current-check"
  }, [_c('em', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-box"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('em', {
    staticClass: "icon-logout fa-2x text-info"
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-box-body clearfix"
  }, [_c('p', {
    staticClass: "m0"
  }, [_vm._v("Log out")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "navbar-form",
    attrs: {
      "role": "search",
      "action": "search.html"
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Type and hit enter ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fa fa-times form-control-feedback",
    attrs: {
      "data-search-dismiss": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "hidden btn btn-default",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])
}]}

/***/ }),
/* 2194 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-heading"
  }, [(_vm.accountType === 'joint') ? _c('div', [_vm._v("Create account / Joint")]) : _vm._e(), _vm._v(" "), (_vm.accountType === 'utma-ugma') ? _c('div', [_vm._v("Create account / UTMA / UGMA")]) : _vm._e(), _vm._v(" "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-back icon-back bottom-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Go back")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [(_vm.accountType === 'joint') ? _c('div', [_vm._v("Joint account information")]) : _vm._e(), _vm._v(" "), (_vm.accountType === 'utma-ugma') ? _c('div', [_vm._v("UTMA / UGMA information")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', [_c('RestrictedSingleInput', {
    attrs: {
      "input": _vm.accountName,
      "limit": 40,
      "placeholderText": 'Account name'
    },
    on: {
      "inputUpdated": _vm.onAccountNameUpdate
    }
  }), _vm._v(" "), (_vm.accountNameChanged && _vm.accountName.trim().length === 0) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.principalPaymentSelected),
      expression: "principalPaymentSelected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('principalPayment')
    },
    attrs: {
      "name": "principalPayment",
      "id": "principalPayment",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.principalPaymentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select principal payment preference")]), _vm._v(" "), _vm._l((_vm.paymentPreference), function(principal) {
    return _c('option', {
      domProps: {
        "value": principal.name
      }
    }, [_vm._v(_vm._s(principal.text))])
  })], 2), _vm._v(" "), (_vm.errors.has('principalPayment')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 left-margin"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interestPaymentSelected),
      expression: "interestPaymentSelected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('interestPayment')
    },
    attrs: {
      "name": "interestPayment",
      "id": "interestPayment",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interestPaymentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select interest payment preference")]), _vm._v(" "), _vm._l((_vm.paymentPreference), function(interest) {
    return _c('option', {
      domProps: {
        "value": interest.name
      }
    }, [_vm._v(_vm._s(interest.text))])
  })], 2), _vm._v(" "), (_vm.errors.has('interestPayment')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-approve",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmitButtonDisabled()
    },
    on: {
      "click": function($event) {
        _vm.submitRequest()
      }
    }
  }, [_vm._v("Submit")])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-back icon-back bottom-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Go back")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  })])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', [_c('label', [_vm._v("Account name*")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', [_c('label', [_vm._v("Principal maturity preference*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Interest payment preference*")])])])])
}]}

/***/ }),
/* 2195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-close col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "modal-button",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title "
  }, [_vm._v("Add payment method")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body mt-lg"
  }, [_vm._t("body", [_c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n                Please select check or wire/ACH as an option:\n            ")]), _vm._v(" "), _c('fieldset', {
    staticClass: "row pt-lg"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: _vm.fundingSourceType === _vm.fundingSourceTypes.CHECK.name ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fundingSourceType),
      expression: "fundingSourceType"
    }],
    attrs: {
      "id": "checkOption",
      "name": "checkOption",
      "type": "radio"
    },
    domProps: {
      "value": _vm.fundingSourceTypes.CHECK.name,
      "checked": _vm._q(_vm.fundingSourceType, _vm.fundingSourceTypes.CHECK.name)
    },
    on: {
      "__c": function($event) {
        _vm.fundingSourceType = _vm.fundingSourceTypes.CHECK.name
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkOption"
    }
  }, [_vm._v(_vm._s(_vm.fundingSourceTypes.CHECK.label))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: _vm.fundingSourceType === _vm.fundingSourceTypes.WIRE_TRANSFER.name ? 'radio-item' : 'radio-item radio-item-unselected right-margin'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fundingSourceType),
      expression: "fundingSourceType"
    }],
    attrs: {
      "id": "wireTransferOption",
      "name": "wireTransferOption",
      "type": "radio"
    },
    domProps: {
      "value": _vm.fundingSourceTypes.WIRE_TRANSFER.name,
      "checked": _vm._q(_vm.fundingSourceType, _vm.fundingSourceTypes.WIRE_TRANSFER.name)
    },
    on: {
      "__c": function($event) {
        _vm.fundingSourceType = _vm.fundingSourceTypes.WIRE_TRANSFER.name
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "wireTransferOption"
    }
  }, [_vm._v(_vm._s(_vm.fundingSourceTypes.WIRE_TRANSFER.label))])])])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_vm._t("body", [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-save",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.saveModal()
      }
    }
  }, [_vm._v("Save")])])])])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-info pr-sm"
  }, [_c('p', [_vm._v(_vm._s(_vm.content))])])
},staticRenderFns: []}

/***/ }),
/* 2197 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "aside sidebar-wrapper",
    class: {
      'drawer-open': _vm.isDrawerOpen
    }
  }, [_c('div', {
    staticClass: "aside-inner"
  }, [_c('button', {
    staticClass: "drawer-close-btn",
    attrs: {
      "aria-label": "Close menu"
    },
    on: {
      "click": _vm.closeDrawer
    }
  }, [_c('em', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('nav', {
    staticClass: "sidebar",
    attrs: {
      "data-sidebar-anyclick-close": ""
    }
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "has-user-block"
  }, [_c('div', {
    staticClass: "collapse in",
    attrs: {
      "id": "user-block"
    }
  }, [_c('div', {
    staticClass: "item user-block"
  }, [_c('div', {
    staticClass: "user-block-picture"
  }, [_c('div', {
    staticClass: "user-block-status"
  }, [(_vm.activeAccount) ? _c('img', {
    staticClass: "img-thumbnail img-circle",
    attrs: {
      "src": _vm.getAccountImgUrl(_vm.activeAccount.accountType),
      "alt": "Avatar",
      "width": "60",
      "height": "60"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "user-block-info"
  }, [(_vm.activeAccount) ? _c('span', {
    staticClass: "user-block-name",
    attrs: {
      "id": "account-name"
    }
  }, [_vm._v(_vm._s(_vm.activeAccount.accountName))]) : _vm._e(), _vm._v(" "), (_vm.activeAccount) ? _c('span', {
    staticClass: "user-block-role"
  }, [_vm._v(_vm._s(_vm.getAccountDescription(_vm.activeAccount.accountType)))]) : _vm._e(), _vm._v(" "), (_vm.isAccountStatusAsPending() && !_vm.isFinancialAdvisor) ? _c('span', {
    staticClass: "status label label-warning"
  }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (_vm.isAccountStatusAsActive() && !_vm.isFinancialAdvisor) ? _c('span', {
    staticClass: "status label label-info"
  }, [_vm._v("Active")]) : _vm._e()])])])]), _vm._v(" "), (_vm.isFinancialAdvisor) ? _c('li', {
    class: {
      active: _vm.$route.name === 'Home'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      },
      "title": "Home"
    }
  }, [_c('em', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Home")])])], 1) : _vm._e(), _vm._v(" "), (_vm.activeAccount.accountType !== _vm.accountTypes.ADVISOR.name) ? _c('li', {
    class: {
      active: _vm.$route.name === 'AccountSummary', disabled: _vm.disableSubmit
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'AccountSummary'
      },
      "title": "Account summary"
    }
  }, [_c('em', {
    staticClass: "icon-book-open"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Account summary")])])], 1) : _vm._e(), _vm._v(" "), (_vm.activeAccount.accountType !== _vm.accountTypes.ADVISOR.name && !_vm.isReadOnly) ? _c('li', {
    class: {
      active: _vm.$route.name === 'Notes', disabled: _vm.disableSubmit
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Notes'
      },
      "title": "Investments",
      "replace": ""
    }
  }, [_c('em', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Investments")])])], 1) : _vm._e(), _vm._v(" "), (_vm.activeAccount.accountType !== _vm.accountTypes.ADVISOR.name && !_vm.isReadOnly) ? _c('li', {
    class: {
      active: _vm.$route.name === 'UpcomingTransactionsForInvestor', disabled: _vm.disableSubmit
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'UpcomingTransactionsForInvestor'
      },
      "title": "Upcoming transactions",
      "replace": ""
    }
  }, [_c('em', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Upcoming transactions")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isInstitutionAccount && _vm.activeAccount.accountType !== _vm.accountTypes.ADVISOR.name) ? _c('li', {
    class: {
      active: _vm.$route.name === 'AddFundingSource', disabled: _vm.disableSubmit
    }
  }, [_c('router-link', {
    class: {
      'with-notification': !_vm.hasFundingSources
    },
    attrs: {
      "to": {
        name: 'AddFundingSource'
      },
      "title": "Bank accounts"
    }
  }, [_c('em', {
    staticClass: "fa fa-university"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Bank accounts")]), _vm._v(" "), (_vm.hasFundingSources === false && _vm.userProfile.accountType !== 'INSTITUTION') ? _c('notification-icon', {
    attrs: {
      "content": _vm.notificationMessage
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeAccount.accountType !== _vm.accountTypes.ADVISOR.name) ? _c('li', {
    class: {
      active: _vm.isPreferencesViewActive, disabled: _vm.disableSubmit, 'accordion-list-background': _vm.preferencesAccordionOpen
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.togglePreferencesAccordion()
      }
    }
  }, [_c('em', {
    staticClass: "fa fa-globe"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Preferences")])]), _vm._v(" "), (_vm.displayedPreferences.length > 0) ? _c('ul', {
    staticClass: "nav accordion-submenu"
  }, _vm._l((_vm.displayedPreferences), function(preference, index) {
    return _c('li', {
      key: ("preference-" + index),
      staticClass: "accordion-list-background",
      class: {
        active: _vm.$route.name === preference.route, disabled: _vm.disableSubmit
      }
    }, [_c('router-link', {
      staticClass: "with-notification",
      attrs: {
        "to": {
          name: preference.route
        },
        "title": preference.title
      }
    }, [_c('span', {
      staticClass: "accordion-list-item-text",
      attrs: {
        "data-localize": "sidebar.nav.WIDGETS"
      }
    }, [_vm._v(_vm._s(preference.title))]), _vm._v(" "), (_vm.displayNotificationIcon(preference)) ? _c('notification-icon', {
      attrs: {
        "content": _vm.notificationMessage
      }
    }) : _vm._e()], 1)], 1)
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      active: _vm.$route.name === 'AccountDocuments', disabled: _vm.disableSubmit, 'accordion-list-background': _vm.documentsAccordionOpen
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.toggleDocumentsAccordion()
      }
    }
  }, [_c('em', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Documents")])]), _vm._v(" "), (_vm.documentOptions.length > 0) ? _c('ul', {
    staticClass: "nav accordion-submenu"
  }, _vm._l((_vm.documentOptions), function(document, index) {
    return _c('li', {
      key: ("document-" + index),
      staticClass: "accordion-list-background",
      class: {
        active: _vm.$route.name === document.value, disabled: _vm.disableSubmit
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'AccountDocuments',
          query: {
            type: document.value
          }
        },
        "title": document.text
      }
    }, [_c('span', {
      staticClass: "accordion-list-item-text",
      attrs: {
        "data-localize": "sidebar.nav.WIDGETS"
      }
    }, [_vm._v(_vm._s(document.text))])])], 1)
  })) : _vm._e()]), _vm._v(" "), (_vm.activeAccount.accountType !== _vm.accountTypes.ADVISOR.name) ? _c('li', {
    class: {
      active: _vm.$route.name === 'FeedbackSurvey', disabled: _vm.disableSubmit
    }
  }, [_c('router-link', {
    class: {
      'with-notification': _vm.showFeedbackIndicator
    },
    attrs: {
      "to": {
        name: 'FeedbackSurvey'
      },
      "title": "Feedback"
    }
  }, [_c('em', {
    staticClass: "fa fa-comment-o"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Feedback")]), _vm._v(" "), (_vm.showFeedbackIndicator) ? _c('notification-icon', {
    attrs: {
      "content": 'We\'d love to hear your feedback.'
    }
  }) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12",
    attrs: {
      "id": "contact-message-container"
    }
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert",
      "id": "contact-message"
    }
  }, [_c('p', [_vm._v("Contact us with any questions:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:info@calvertimpact.org",
      "target": "_blank"
    }
  }, [_vm._v("info@calvertimpact.org")])])])
}]}

/***/ }),
/* 2198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-close col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "modal-button",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("Comments for note " + _vm._s(_vm.transaction.transactionId))])]), _vm._v(" "), _c('div', {
    staticClass: "mt-lg"
  }, [_vm._t("body", [_c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("Please append your comment below*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "transactionComment",
      "rows": "4",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "mt-lg"
  }, [_vm._t("body", [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-save-comment",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.saveComment()
      }
    }
  }, [_vm._v("Save comment")])])])])], 2)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-heading"
  }, [_vm._v("Communication preferences")]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('dismissable-alert', {
    attrs: {
      "title": "Communication preference updated!",
      "closeAction": _vm.hideCommunicationUpdatedAlert,
      "isShowing": _vm.communicationUpdated
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Choose your communication preferences")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg top-margin bottom-margin",
    attrs: {
      "type": "button",
      "disabled": _vm.isReadOnly || _vm.allEmail
    },
    on: {
      "click": _vm.setAllToEmail
    }
  }, [_vm._v("\n        Set All Delivery Methods to Email\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive bottom-margin"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("Transaction Notices & Options Forms")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "radio c-radio"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "transactions",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm.transactionsEmail
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setExclusivePreference('TRANSACTIONS', 'EMAIL')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-circle"
  })])])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "radio c-radio"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "transactions",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm.transactionsPostal
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setExclusivePreference('TRANSACTIONS', 'SNAIL-MAIL')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-circle"
  })])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("Impact Report (annual each fall)")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "radio c-radio"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "impactReport",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm.impactReportEmail
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setExclusivePreference('IMPACT_REPORT', 'EMAIL')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-circle"
  })])])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "radio c-radio"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "impactReport",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm.impactReportPostal
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setExclusivePreference('IMPACT_REPORT', 'SNAIL-MAIL')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-circle"
  })])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_vm._v("\n                1099 Tax Form (annual each January, can select both email & postal)\n              ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "checkbox c-checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm.form1099Email
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggle1099('EMAIL')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  })])])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "checkbox c-checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isReadOnly
    },
    domProps: {
      "checked": _vm.form1099Postal
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggle1099('SNAIL-MAIL')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  })])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_vm._v("\n        All of the above, as well as Monthly Statements and other Reports are always\n        available in your Documents section online.\n      ")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Document")]), _vm._v(" "), _c('th', {
    staticClass: "text-center delivery-col"
  }, [_vm._v("Email")]), _vm._v(" "), _c('th', {
    staticClass: "text-center delivery-col"
  }, [_vm._v("Postal Mail")])])])
}]}

/***/ }),
/* 2200 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.isInformationModalVisible) ? _c('information') : _vm._e(), _vm._v(" "), (_vm.loading || _vm.initializingState) ? _c('spinner') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('dismissable-alert', {
    attrs: {
      "isShowing": _vm.isShowingReinvestmentNotice,
      "title": "Please take note!",
      "subtitle": "Transactions reinvested at the same rate/term on the same day will be reinvested together into one Note.",
      "notice": " Transactions that do not amount to $20 or greater when combined will be repaid to the default destination.",
      "alertType": "warning",
      "showIcon": true,
      "icon": "calendar-payment",
      "dismissible": false
    }
  }), _vm._v(" "), (_vm.isExtraReinvestmentsEnabled && _vm.scheduledAdditionalInvestments.length > 0) ? _c('div', {
    staticClass: "scheduled-investments-section"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "section-description"
  }, [_vm._v("\n              These additional deposits are scheduled to be combined with your reinvestments.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "scheduled-investments-list"
  }, _vm._l((_vm.scheduledAdditionalInvestments), function(investment) {
    return _c('div', {
      key: investment.id,
      staticClass: "scheduled-investment-item"
    }, [_c('div', {
      staticClass: "investment-info"
    }, [_c('span', {
      staticClass: "investment-notes"
    }, [_c('strong', [_vm._v(_vm._s(investment.noteId))])]), _vm._v(" "), _c('span', {
      staticClass: "investment-amount"
    }, [_vm._v("\n                    " + _vm._s(_vm.formatAmount(Number(investment.amount))) + "\n                  ")]), _vm._v(" "), _c('span', {
      staticClass: "investment-date"
    }, [_vm._v("\n                    Reinvests on " + _vm._s(_vm.formatDate(investment.reinvestDate)) + "\n                  ")]), _vm._v(" "), _c('span', {
      staticClass: "investment-status"
    }, [(investment.status === 'PENDING') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (investment.status === 'FUNDS_TRANSFERRED') ? _c('span', {
      staticClass: "label label-info"
    }, [_vm._v("Funds Transferred")]) : _vm._e(), _vm._v(" "), (investment.status === 'PROCESSED') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Processed")]) : _vm._e(), _vm._v(" "), (investment.status === 'CANCELLED') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (investment.status === 'FAILED') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e()])]), _vm._v(" "), (investment.status === 'FUNDS_TRANSFERRED') ? _c('div', {
      staticClass: "investment-actions"
    }, [_vm._m(2, true)]) : _vm._e(), _vm._v(" "), (investment.status === 'PENDING') ? _c('div', {
      staticClass: "investment-actions"
    }, [_c('button', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editAdditionalInvestment(investment)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Edit\n                  ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.confirmCancelAdditionalInvestment(investment)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-times"
    }), _vm._v(" Cancel\n                  ")])]) : _vm._e()])
  }))]) : _vm._e(), _vm._v(" "), (_vm.isExtraReinvestmentsEnabled && _vm.hasUpcomingTransactions) ? _c('div', {
    staticClass: "add-funds-section"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleAddFundsToReinvestments
    }
  }, [_vm._v("\n                  Add funds to my reinvestments\n                ")])])])]) : _vm._e(), _vm._v(" "), _c('upcoming-transactions', {
    attrs: {
      "notes-transactions": _vm.notesTransactionsWithNoAction,
      "allowed-actions": _vm.actionsAllowedForThisTransaction,
      "funding-sources": _vm.fundingSources,
      "submits-disabled": _vm.submitsDisabled,
      "year-rates": _vm.yearRates,
      "action-provided": false
    },
    on: {
      "actionChanged": _vm.actionChanged,
      "submit": _vm.submitUpcomingTransaction
    }
  }, [_c('em', {
    staticClass: "fa fa-exchange text-blue"
  }), _vm._v("Transactions you need to\n            provide direction on\n          ")]), _vm._v(" "), _c('upcoming-transactions', {
    attrs: {
      "notes-transactions": _vm.notesTransactionsWithAction,
      "allowed-actions": _vm.actionsAllowedForThisTransaction,
      "funding-sources": _vm.fundingSources,
      "submits-disabled": _vm.submitsDisabled,
      "year-rates": _vm.yearRates,
      "action-provided": ""
    },
    on: {
      "actionChanged": _vm.actionChanged,
      "submit": _vm.submitUpcomingTransaction
    }
  }, [_c('em', {
    staticClass: "fa fa-exchange text-gray"
  }), _vm._v("Transactions you've\n            provided direction on\n          ")])], 1)])]), _vm._v(" "), (_vm.showAddMoneyModal) ? _c('add-money-modal', {
    attrs: {
      "funding-sources": _vm.availableFundingSources,
      "available-notes": _vm.availableNotesForReinvestment,
      "loading": _vm.addMoneyLoading,
      "editing-investment": _vm.editingInvestment
    },
    on: {
      "close": _vm.closeAddMoneyModal,
      "submit": _vm.submitAddMoney
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCancelConfirmModal) ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-100px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("Cancel Additional Investment")]), _vm._v(" "), _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n            Are you sure you want to cancel this additional investment of "), _c('strong', [_vm._v(_vm._s(_vm.cancellingInvestment ? _vm.formatAmount(Number(_vm.cancellingInvestment.amount)) : ''))]), _vm._v(" for note "), _c('strong', [_vm._v(_vm._s(_vm.cancellingInvestment ? _vm.cancellingInvestment.noteId : ''))]), _vm._v("?\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "modal-paragraph text-muted"
  }, [_vm._v("\n            This action cannot be undone.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg",
    attrs: {
      "type": "button",
      "disabled": _vm.cancellingLoading
    },
    on: {
      "click": _vm.closeCancelConfirmModal
    }
  }, [_vm._v("\n                  Keep Investment\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "type": "button",
      "disabled": _vm.cancellingLoading
    },
    on: {
      "click": _vm.cancelAdditionalInvestment
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.cancellingLoading ? 'Cancelling...' : 'Yes, Cancel It') + "\n                ")])])])])])])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Upcoming transactions\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "section-title"
  }, [_c('em', {
    staticClass: "fa fa-plus-circle text-success"
  }), _vm._v(" Scheduled Additional Investments\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "text-muted"
  }, [_c('em', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Transfer in progress")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "add-funds-explainer"
  }, [_c('p', {
    staticClass: "explainer-text"
  }, [_c('strong', [_vm._v("Add funds to your reinvestments:")]), _vm._v(" Maturing notes or interest payments that are scheduled to reinvest can receive additional funds to reinvest alongside them. This allows you to increase your investment amount when your existing notes mature or have interest transact. You can add funds between 45 and 3 days before the reinvestment date.\n                  ")])])])])
}]}

/***/ }),
/* 2201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n    " + _vm._s(_vm.resultsLengthText) + " found for \"\n    "), _c('b', [_vm._v(_vm._s(_vm.searchMessage.toUpperCase()))]), _vm._v("\"\n  ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped bank-accounts table-fundings",
    attrs: {
      "id": "results"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedNotes), function(note, index) {
    return _c('tr', {
      key: (index + "-note-" + (note.noteId))
    }, [_c('td', [_vm._v(_vm._s(note.noteId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(note.cusip))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(note.account.accountId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(note.account.accountName))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToAccountDetail(note)
        }
      }
    }, [_vm._v("Account details")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToNoteDetails(note)
        }
      }
    }, [_vm._v("Note details")])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Note number")]), _vm._v(" "), _c('th', [_vm._v("CUSIP number")]), _vm._v(" "), _c('th', [_vm._v("Account number")]), _vm._v(" "), _c('th', [_vm._v("Account name")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}

/***/ }),
/* 2202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terms-of-conditions"
  }, [_vm._v("\n  I have read, understand, and accept Calvert Impact Capital's\n  "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://calvertimpact.org/terms-of-use"
    }
  }, [_vm._v("\n    Terms of Use\n  ")]), _vm._v(",\n  "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.calvertimpactcapital.org/privacy#privacy"
    }
  }, [_vm._v("\n    Privacy Policy\n  ")]), _vm._v(", and\n  "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.calvertimpactcapital.org/prospectus"
    }
  }, [_vm._v("\n    Community Investment Note Prospectus\n  ")]), _vm._v(", and our payment partner Dwolla's\n  "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.dwolla.com/legal/tos/?whitelabel"
    }
  }, [_vm._v("\n    Terms of Service\n  ")]), _vm._v(" and\n  "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.dwolla.com/legal/privacy?whitelabel"
    }
  }, [_vm._v("\n  Privacy Policy\n  ")]), _vm._v(".\n  "), _c('br'), _c('br'), _vm._v("\n  I further agree that any interest check I receive for an amount less than $20.00\n  that remains uncashed 365 days after issuance will be donated to Calvert Impact Capital\n  and I will receive a donation receipt for that amount.\n  I will be notified of the uncashed check three times prior to the donation.\n  "), _c('br'), _c('br'), _vm._v(" "), (!_vm.hideStateDisclosures) ? [_vm._m(0), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n    For Tennessee Residents Only: I also acknowledge that I have 1. a gross\n    annual income of at least $70,000 and a net worth of at least $70,000, or\n    a net worth of at least $250,000, and 2. that I am not investing more than\n    10% of my personal net worth (excluding my primary residence, home\n    furnishings, and automobiles).\n    "), _c('br'), _c('br'), _vm._v("\n    For Washington State Residents Only: I also acknowledge that I am not\n    investing more than 10% of my personal net worth, or joint net worth with\n    my spouse or spousal equivalent, in Community Investment Notes. For this\n    purpose, my net worth excludes the value of my primary residence and its\n    furnishing, automobiles, and loans associated with them.\n  ")] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('u', [_vm._v("For Pennsylvania Residents")]), _vm._v(": Please note your right of refusal\n      within two days of investing as described in the prospectus on\n      "), _c('u', [_vm._v("page iv")]), _vm._v(".\n    ")])
}]}

/***/ }),
/* 2203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Add Funds request")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-margin"
  }, [_c('div', {
    staticClass: "modal-body mt-lg"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.investmentAmount),
      expression: "investmentAmount"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control text-right input-md': true, 'form-control-error': _vm.isInvestmentAmountInvalid
    },
    attrs: {
      "autocomplete": "off",
      "name": "investmentAmount",
      "id": "investmentAmount"
    },
    domProps: {
      "value": (_vm.investmentAmount)
    },
    on: {
      "change": _vm.removeNegative,
      "blur": function($event) {
        _vm.validateInvestmentAmount()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.investmentAmount = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isInvestmentAmountInvalid) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.investmentAmountError))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Please append your comment below *")]), _vm._v(" "), _c('restricted-textarea', {
    attrs: {
      "input": _vm.comment,
      "limit": 255,
      "id": "comment",
      "placeholder": "",
      "required": true
    },
    on: {
      "inputUpdated": _vm.commentUpdated
    }
  }), _vm._v(" "), (!_vm.comment || _vm.information.comment === _vm.comment) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("You must enter or append a comment.")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit",
      "disabled": !_vm.information.isNewRequest && _vm.isCancelButtonDisabled()
    },
    on: {
      "click": function($event) {
        _vm.information.isNewRequest ? _vm.goToNoteDetail() : _vm.showCancelConfirmationModal()
      }
    }
  }, [_vm._v("Cancel request")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit",
      "disabled": _vm.information.isNewRequest || _vm.isButtonDisabled()
    },
    on: {
      "click": _vm.submitApproveAddFunds
    }
  }, [_vm._v("Approve Add Funds")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-approve buttons",
    attrs: {
      "type": "submit",
      "disabled": !_vm.information.isNewRequest || _vm.isButtonDisabled()
    },
    on: {
      "click": _vm.submitRequest
    }
  }, [_vm._v("Submit request")])])])])])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Enter investment amount "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])])])
}]}

/***/ }),
/* 2204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.isCommercialOverrideModalVisible) ? _c('commercial-address-override', {
    on: {
      "confirm": _vm.confirmCommercialOverride,
      "cancel": _vm.cancelCommercialOverride
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAccountCreationModalVisible) ? _c('accountCreation') : _vm._e(), _vm._v(" "), (_vm.isSuggestedAddressModalVisible) ? _c('address-suggestion') : _vm._e(), _vm._v(" "), (_vm.isMergePartialUserModalVisible) ? _c('merge-partial-user', {
    attrs: {
      "closeAction": _vm.closeMergePartialUserModal,
      "partialUserId": _vm.user.id
    },
    on: {
      "userMergeRequested": _vm.handleUserMerge
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [(_vm.$route.query.retry) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Please verify your information and submit it once more.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            User information\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.INVESTOR)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "InvestorOption",
      "id": "InvestorOption",
      "value": "INVESTOR",
      "disabled": _vm.isFinancialAdvisorOrAdmin()
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "INVESTOR")
    },
    on: {
      "__c": function($event) {
        _vm.user.userType = "INVESTOR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "InvestorOption"
    }
  }, [_vm._v("Investor")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.FINANCIAL_ADVISOR)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "FinancialAdvisorOption",
      "id": "FinancialAdvisorOption",
      "disabled": "",
      "value": "ADVISOR"
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "ADVISOR")
    },
    on: {
      "click": function($event) {
        _vm.selectAdvisor()
      },
      "__c": function($event) {
        _vm.user.userType = "ADVISOR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "FinancialAdvisorOption"
    }
  }, [_vm._v("Financial Advisor ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.MINOR)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "MinorOption",
      "id": "MinorOption",
      "value": "MINOR",
      "disabled": _vm.isFinancialAdvisorAdminOrInstitutional()
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "MINOR")
    },
    on: {
      "__c": function($event) {
        _vm.user.userType = "MINOR"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "MinorOption"
    }
  }, [_vm._v("Minor")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.ADMIN)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "AdminOption",
      "id": "AdminOption",
      "disabled": "",
      "value": "ADMIN"
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "ADMIN")
    },
    on: {
      "__c": function($event) {
        _vm.user.userType = "ADMIN"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "AdminOption"
    }
  }, [_vm._v("Admin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.INSTITUTIONAL_REPRESENTATIVE)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "InstitutionalRepresentativeOption",
      "id": "InstitutionalRepresentativeOption",
      "value": "INSTITUTIONAL_REPRESENTATIVE"
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "INSTITUTIONAL_REPRESENTATIVE")
    },
    on: {
      "__c": function($event) {
        _vm.user.userType = "INSTITUTIONAL_REPRESENTATIVE"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "InstitutionalRepresentativeOption"
    }
  }, [_vm._v("Institutional Representative")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    class: _vm.getStyleClassForUserTypeRadioButton(_vm.userTypes.READ_ONLY)
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userType),
      expression: "user.userType"
    }],
    attrs: {
      "type": "radio",
      "name": "ReadOnlyOption",
      "id": "ReadOnlyOption",
      "value": "READ_ONLY"
    },
    domProps: {
      "checked": _vm._q(_vm.user.userType, "READ_ONLY")
    },
    on: {
      "__c": function($event) {
        _vm.user.userType = "READ_ONLY"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ReadOnlyOption"
    }
  }, [_vm._v("Read-only")])])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.userCommentCategories,
      "showToggleAll": false,
      "placeholder": "Select relevant categories",
      "optionLabel": "name"
    },
    model: {
      value: (_vm.userCommentCategory),
      callback: function($$v) {
        _vm.userCommentCategory = $$v
      },
      expression: "userCommentCategory"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Please append your comment below.")]), _vm._v(" "), (_vm.savingComment) ? _c('span', {
    staticClass: "auto-save-notice-label auto-save-notice-saving-color"
  }, [_vm._v("[ Saving... ]")]) : _vm._e(), _vm._v(" "), (_vm.commentSaved) ? _c('span', {
    staticClass: "auto-save-notice-label auto-save-notice-saved-color"
  }, [_vm._v("[ Saved ]")]) : _vm._e(), _vm._v(" "), (_vm.commentSaveError) ? _c('span', {
    staticClass: "auto-save-notice-label auto-save-notice-error-color"
  }, [_vm._v("[ Not Saved ]")]) : _vm._e(), _vm._v(" "), _c('restricted-textarea', {
    attrs: {
      "limit": 255,
      "input": _vm.userCommentInput,
      "id": "comment",
      "required": false,
      "showNotice": false,
      "showLimit": true,
      "textColorClass": 'vinous-text',
      "placeholder": ""
    },
    on: {
      "inputUpdated": _vm.commentUpdated
    }
  })], 1)]), _vm._v(" "), _c('basic-information', {
    ref: "basicInformation",
    attrs: {
      "looseValidation": true,
      "basicInformation": _vm.user,
      "enableMfa": _vm.enableMfa
    },
    on: {
      "emailUpdated": _vm.handleEmailChange
    }
  }), _vm._v(" "), (_vm.showProvideLoginOption) ? _c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', {
    staticClass: "dark-grey-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provideInvestorLogin),
      expression: "provideInvestorLogin"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "provide-investor-login",
      "disabled": !_vm.emailIsValid
    },
    domProps: {
      "checked": _vm.shouldBeCheckedByDefault,
      "checked": Array.isArray(_vm.provideInvestorLogin) ? _vm._i(_vm.provideInvestorLogin, "") > -1 : (_vm.provideInvestorLogin)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.provideInvestorLogin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.provideInvestorLogin = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.provideInvestorLogin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.provideInvestorLogin = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n            Provide investor log in\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.showProvideLoginOption) ? _c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', {
    staticClass: "dark-grey-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableMfa),
      expression: "enableMfa"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "enable-mfa",
      "disabled": !_vm.provideInvestorLogin
    },
    domProps: {
      "checked": _vm.shouldBeCheckedByDefault,
      "checked": Array.isArray(_vm.enableMfa) ? _vm._i(_vm.enableMfa, "") > -1 : (_vm.enableMfa)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.enableMfa,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.enableMfa = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.enableMfa = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enableMfa = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n            Enable MFA\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.showLoginNotice) ? _c('div', {
    staticClass: "panel-body account-notice"
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.user.residentialAddress && _vm.user.mailingAddress) ? _c('addresses-form', {
    key: 1,
    ref: "addresses",
    attrs: {
      "firstTitle": 'Residential Address',
      "residentialAddress": _vm.user.residentialAddress,
      "secondTitle": 'Mailing Address',
      "mailingAddress": _vm.user.mailingAddress,
      "is-admin": true,
      "selected-user-type": _vm.user.userType,
      "shouldShowAllowPOBoxInput": true,
      "userHasBeenAllowedPOBox": _vm.userHasBeenAllowedPOBox
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitButton()
    },
    on: {
      "click": function($event) {
        _vm.validateAndSubmitUser()
      }
    }
  }, [_vm._v("Submit")])])]), _vm._v(" "), _c('dismissable-alert', {
    attrs: {
      "title": "You've changed the default account",
      "subtitle": "",
      "closeAction": _vm.hideDefaultAccountAlert,
      "isShowing": _vm.showDefaultAccountChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Accounts\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.user.accounts && _vm.user.accounts.length === 0) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                 No accounts found.\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.user.accounts && _vm.user.accounts.length > 0) ? _c('div', {
    staticClass: "table-responsive bottom-margin",
    class: {
      'table-fixed-header--sm cols-5': _vm.user.accounts.length > 3 || _vm.fetchingSummaryReports
    }
  }, [(_vm.fetchingSummaryReports) ? _c('spinner', {
    staticClass: "table-spinner"
  }) : _vm._e(), _vm._v(" "), (!_vm.fetchingSummaryReports) ? _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.user.accounts), function(account) {
    return _c('tr', {
      key: account.id
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(account.accountName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(account.accountType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatAmount(account.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      class: {
        'radio-item': true, 'radio-item-unselected': account.id !== _vm.user.defaultAccountId
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": account.id,
        "for": account.id
      },
      domProps: {
        "value": account.id
      },
      on: {
        "click": function($event) {
          _vm.changeDefaultAccount(account)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "lbl-defaultAccount",
      attrs: {
        "for": account.id
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-center last-column-data"
    }, [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(account)
        }
      }
    }, [_vm._v("View details")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.generateSummaryReport(account)
        }
      }
    }, [_vm._v("Summary Report")])])])
  }))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 top-margin"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg btn-new",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.openAccountCreationModal()
      }
    }
  }, [_vm._v("Create new")]), _vm._v(" "), (_vm.user.accounts && _vm.user.accounts.length === 0 && _vm.user.userType !== _vm.userTypes.INSTITUTIONAL_REPRESENTATIVE.name && _vm.user.userType !== _vm.userTypes.READ_ONLY.name) ? _c('button', {
    staticClass: "btn btn-warning btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.mergePartialUser()
      }
    }
  }, [_vm._v("Merge partial user")]) : _vm._e()])]), _vm._v(" "), (_vm.showRecentActivity) ? _c('div', {
    staticClass: "line-separator top-margin"
  }) : _vm._e(), _vm._v(" "), (_vm.showRecentActivity) ? _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Recent activity\n          ")]) : _vm._e(), _vm._v(" "), (_vm.showRecentActivity) ? _c('div', {
    staticClass: "line-separator"
  }) : _vm._e(), _vm._v(" "), (_vm.showRecentActivity) ? _c('div', {
    staticClass: "bottom-margin"
  }, [(!_vm.user.lastLogins || _vm.user.lastLogins.length === 0) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                No login activity found.\n              ")])]) : _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.user.lastLogins), function(login) {
    return _c('tr', {
      key: login.id
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatLoginTimestamp(login.loggedInAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(login.device || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(login.ipAddress || '—'))])])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.showRecentActivity) ? _c('div', {
    staticClass: "line-separator top-margin"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Investor feedback\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-margin"
  }, [(_vm.fetchingFeedback) ? _c('spinner', {
    staticClass: "table-spinner"
  }) : _vm._e(), _vm._v(" "), (!_vm.fetchingFeedback && _vm.userFeedback.length === 0) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                No feedback submitted.\n              ")])]) : _vm._e(), _vm._v(" "), (!_vm.fetchingFeedback && _vm.userFeedback.length > 0) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.userFeedback), function(feedback) {
    return _c('tr', {
      key: feedback.id
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatFeedbackDate(feedback.createdAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatFeedbackScore(feedback.score)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center feedback-comments"
    }, [_vm._v(_vm._s(feedback.reason || '—'))])])
  }))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon-exclamation pr-sm"
  }), _vm._v("There was an issue validating your personal information.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Comment Category")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info alert-dismissible mt-lg",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("\n              Normally we do NOT provide minors with a log in.\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Account name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Type of account")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Account Balance")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Default Account")]), _vm._v(" "), _c('th', {
    staticClass: "text-center last-column-title"
  }, [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Last login")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Device")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("IP address")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Score")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Comments")])])])
}]}

/***/ }),
/* 2205 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Impact preferences\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('SuccessAlert', {
    attrs: {
      "isVisible": _vm.isSuccessMessageVisible,
      "message": _vm.successMessage
    },
    on: {
      "hideSuccessAlert": _vm.hideSuccessMessage
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mb-lg"
  }, [(_vm.activeAccountId !== null) ? _c('preferences', {
    attrs: {
      "account-id": _vm.activeAccountId,
      "primaryInvestor": _vm.user
    },
    on: {
      "saved": _vm.onPreferencesSaved,
      "loaded": _vm.onPreferencesLoaded
    }
  }) : _vm._e()], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "panel-title mt-xl mb-lg"
  }, [_c('p', [_vm._v("You can target your account balance to one or more portfolio sectors and\n          initiatives below. We use this to inform our portfolio deployment and impact in line with investor interests. This is optional, and does not change the risk or any\n          characteristics of your investments. Please refer to the\n          "), _c('strong', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.calvertimpactcapital.org/prospectus"
    }
  }, [_vm._v("prospectus")])]), _vm._v(" for more information.")])])
}]}

/***/ }),
/* 2206 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.showAdjustmentModal) ? _c('interest-adjustment', {
    attrs: {
      "noteId": _vm.note.noteId,
      "isSubmitDisabled": _vm.isSubmitDisabled,
      "submitAction": _vm.submitAdjustment,
      "cancelAction": _vm.cleanAdjustmentInformation
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('p', [_c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")]), _c('small', [_vm._v(" Required fields")])]), _vm._v(" "), _c('div', {
    staticClass: "title-holder"
  }, [_c('h1', [_vm._v("Add new INT-ADJ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "adjustment-label"
  }, [_vm._v("Adjustment amount"), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', {
    staticClass: "dollar-sign-holder form-control",
    class: {
      'form-control-error': _vm.errors.has('interest-amount')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fixedAdjustmentAmount),
      expression: "fixedAdjustmentAmount"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "currency",
    attrs: {
      "name": "interest-amount",
      "type": "number",
      "value": "2",
      "placeholder": "0.00",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.fixedAdjustmentAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fixedAdjustmentAmount = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('interest-amount') || _vm.adjustmentAmount == 0) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("The adjustment amount cannot be zero. Please enter a different amount.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "adjustment-label"
  }, [_vm._v("Date"), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group date"
  }, [_c('date-picker', {
    attrs: {
      "disabled": "",
      "value": _vm.adjustmentDate,
      "config": _vm.dateConfig
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "fa fa-calendar"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row row-margin"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "adjustment-label"
  }, [_vm._v("Comment"), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-control",
    class: {
      'form-control-error': _vm.errors.has('interest-comment')
    },
    attrs: {
      "rows": "4",
      "id": "comment",
      "name": "interest-comment",
      "placeholder": "Enter your comments here"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('interest-comment')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("The comment field cannot be empty. Please enter a comment.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row row-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "title-holder"
  }, [_c('h1', [_vm._v("Resulting current INT-PAID")])]), _vm._v(" "), _c('label', {
    staticClass: "adjustment-label"
  }, [_vm._v("Interest paid amount")]), _vm._v(" "), _c('span', {
    staticClass: "dollar-sign-holder form-control",
    attrs: {
      "disabled": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interestPaid),
      expression: "interestPaid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        min_value: 0
      }),
      expression: "{min_value: 0}"
    }],
    staticClass: "currency",
    attrs: {
      "name": "interest-paid",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.interestPaid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.interestPaid = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.interestPaid < 0.005) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("This interest payment would be zero or negative once rounded to two decimal places. Please change the adjustment so that the interest payment will be at least $0.01 once rounded to two decimal places.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "title-holder"
  }, [_c('h1', [_vm._v("Resulting current interest accrued")])]), _vm._v(" "), _c('label', {
    staticClass: "adjustment-label"
  }, [_vm._v("Interest accrued amount")]), _vm._v(" "), _c('span', {
    staticClass: "dollar-sign-holder form-control",
    attrs: {
      "disabled": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interestAccrued),
      expression: "interestAccrued"
    }],
    staticClass: "currency",
    attrs: {
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.interestAccrued)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.interestAccrued = $event.target.value
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.isInformationModalVisible) ? _c('information') : _vm._e(), _vm._v(" "), (_vm.isVisibleEditCommentModal) ? _c('edit-transaction-comment', {
    attrs: {
      "closeAction": _vm.closeEditCommentModal,
      "transaction": _vm.transaction,
      "loadNoteDetail": _vm.loadNoteDetail
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n          Note details\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-margin"
  }, [_c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.note.noteId))])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.formatAmount(_vm.note.currentBalance)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.formatTerm(_vm.note.interestTerm)))])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.note.openedOn)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.formatRate(_vm.note.interestRate)))])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.note.maturityDate)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.formatAmount(_vm.note.originalBalance)))])])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [(_vm.note.status == 'closed') ? _c('p', {
    staticClass: "label label-danger"
  }, [_vm._v("Closed")]) : _vm._e(), _vm._v(" "), (_vm.note.status == 'cancelled') ? _c('p', {
    staticClass: "label label-danger"
  }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (_vm.note.status == 'pending') ? _c('p', {
    staticClass: "label label-warning"
  }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (_vm.note.status == 'open') ? _c('p', {
    staticClass: "label label-success"
  }, [_vm._v("Open")]) : _vm._e()])])]), _vm._v(" "), (_vm.note.cusip) ? _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 left-margin"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.note.cusip))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-10 top-margin bottom-margin"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-note-action",
    attrs: {
      "type": "submit",
      "disabled": _vm.isRedeemDisabled
    },
    on: {
      "click": function($event) {
        _vm.goToRedeem()
      }
    }
  }, [_vm._v("Redeem")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-note-action",
    attrs: {
      "disabled": _vm.isTransferDisabled
    },
    on: {
      "click": function($event) {
        _vm.goToTransfer()
      }
    }
  }, [_vm._v("Transfer")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-note-action",
    attrs: {
      "disabled": _vm.isAddFundsDisabled
    },
    on: {
      "click": function($event) {
        _vm.goToAddFunds()
      }
    }
  }, [_vm._v("Add funds")])])]), _vm._v(" "), (_vm.adjustmentWasSuccessfull) ? _c('div', {
    staticClass: "alert alert-success alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.adjustmentWasSuccessfull = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-check-circle-o"
  }), _vm._v(" The interest adjustment was saved successfully.\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-subtitle bottom-margin"
  }, [_vm._v("\n            Transaction list\n        ")]), _vm._v(" "), (_vm.note.transactions.length === 0) ? _c('div', [_vm._m(10)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive bottom-margin",
    class: {
      'table-fixed-header--md cols-7': _vm.note.transactions.length > 6
    }
  }, [_c('table', {
    staticClass: "table table-striped table-transaction"
  }, [_c('thead', [_c('tr', [_c('sortable-th', {
    attrs: {
      "sort-property": _vm.sortProperty,
      "sort-toggle": _vm.sortToggle,
      "property": "transactionId",
      "label": "Id"
    },
    on: {
      "handleSortStrategy": _vm.sortTransactionsStrategy
    }
  }), _vm._v(" "), _c('sortable-th', {
    attrs: {
      "sort-property": _vm.sortProperty,
      "sort-toggle": _vm.sortToggle,
      "property": "type",
      "label": "Transaction type"
    },
    on: {
      "handleSortStrategy": _vm.sortTransactionsStrategy
    }
  }), _vm._v(" "), _c('sortable-th', {
    attrs: {
      "sort-property": _vm.sortProperty,
      "sort-toggle": _vm.sortToggle,
      "property": "amount",
      "label": "Amount"
    },
    on: {
      "handleSortStrategy": _vm.sortTransactionsStrategy
    }
  }), _vm._v(" "), _c('sortable-th', {
    attrs: {
      "sort-property": _vm.sortProperty,
      "sort-toggle": _vm.sortToggle,
      "property": "createdAt",
      "label": "Date"
    },
    on: {
      "handleSortStrategy": _vm.sortTransactionsStrategy
    }
  }), _vm._v(" "), _c('sortable-th', {
    attrs: {
      "sort-property": _vm.sortProperty,
      "sort-toggle": _vm.sortToggle,
      "property": "updatedAt",
      "label": "Last updated date"
    },
    on: {
      "handleSortStrategy": _vm.sortTransactionsStrategy
    }
  }), _vm._v(" "), _c('sortable-th', {
    attrs: {
      "sort-property": _vm.sortProperty,
      "sort-toggle": _vm.sortToggle,
      "property": "status",
      "label": "Status"
    },
    on: {
      "handleSortStrategy": _vm.sortTransactionsStrategy
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Actions")])], 1)]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderedTransactions), function(transaction) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!(transaction.type === 'ACCR-INT' && _vm.note.status === 'closed')),
        expression: "!(transaction.type === 'ACCR-INT' && note.status === 'closed')"
      }],
      key: transaction.id
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(transaction.transactionId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatType(transaction.type, 'admin', transaction.fundingSourceId)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "aligned-amounts-container"
    }, [_c('span', {
      staticClass: "whole"
    }, [_vm._v(_vm._s(_vm.getWholeAmount(transaction.amount)))]), _vm._v(" "), _c('span', [_vm._v(".")]), _vm._v(" "), _c('span', {
      staticClass: "decimal"
    }, [_vm._v(_vm._s(_vm.getDecimals(transaction.amount)))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(transaction.createdAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(transaction.updatedAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(transaction.status == 'CANCELLED') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (transaction.status == 'FAILED') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (transaction.status == 'PENDING') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (transaction.status == 'PRE-PENDING') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pre-pending")]) : _vm._e(), _vm._v(" "), (transaction.status == 'PROCESSED') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Processed")]) : _vm._e(), _vm._v(" "), (transaction.status == 'BATCHED') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Batched")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(transaction.comment) ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.top",
        value: (transaction.comment),
        expression: "transaction.comment",
        modifiers: {
          "top": true
        }
      }],
      staticClass: "transaction-comment"
    }, [_vm._v(_vm._s(transaction.comment))]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-details edit-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.openEditCommentModal(transaction)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.canViewRedeemDetail(transaction)) ? _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail()
        }
      }
    }, [_vm._v("View details")]) : _vm._e(), _vm._v(" "), (_vm.canViewTransferDetail(transaction)) ? _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewTransferDetail()
        }
      }
    }, [_vm._v("View details")]) : _vm._e(), _vm._v(" "), (_vm.canViewAddFundsDetail(transaction)) ? _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToAddFunds()
        }
      }
    }, [_vm._v("View details")]) : _vm._e(), _vm._v(" "), (_vm.canRerunInterestAccrual(transaction)) ? _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button",
        "disabled": _vm.note.status === 'closed'
      },
      on: {
        "click": function($event) {
          _vm.isRerunInterestAccrualDisabled ? (_vm.handleRerunInterestAccrualDisabledShowModal()) : (_vm.handleRerunInterestAccrual(_vm.note.id))
        }
      }
    }, [_vm._v("Re-run interest accrual")]) : _vm._e(), _vm._v(" "), (_vm.canTransactionBeFailed(transaction)) ? _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.failTransaction(transaction.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.markAsFailedMessage(transaction)))]) : _vm._e()])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-2 top-margin bottom-margin"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-redeem",
    attrs: {
      "type": "button",
      "disabled": !_vm.isAdjustmentPossible
    },
    on: {
      "click": function($event) {
        _vm.showAdjustmentModal = true
      }
    }
  }, [_vm._v("Interest adjustment")])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  })])])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Id:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Current amount:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Term:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Open Date:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Rate:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Maturity:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Original amount:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Status:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 left-margin"
  }, [_c('div', [_c('label', [_vm._v("CUSIP:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_c('em', {
    staticClass: "icon-info"
  }), _vm._v(" No transactions found.")])])
}]}

/***/ }),
/* 2207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Retry Payment")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-margin"
  }, [_c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.transactionId))])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("$ " + _vm._s(_vm.transactionAmount))])])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedFundingSource),
      expression: "selectedFundingSource"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fundingSource",
      "id": "FundingSource",
      "placeholder": "Please select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedFundingSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_vm._l((_vm.fundingSources), function(fundingSource) {
    return _c('option', {
      key: fundingSource.id,
      domProps: {
        "value": fundingSource.id
      }
    }, [_vm._v("\n                      " + _vm._s(fundingSource.name) + "\n                    ")])
  }), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.donateFundingSource.name
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.donateFundingSource.text) + "\n                    ")])], 2)]), _vm._v(" "), (this.fundingSources.length === 0) ? _c('p', {
    staticClass: "top-margin",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', [_vm._v("There must be a valid bank account for the retry.")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Please append your comment below *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "comment",
      "id": "comment",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('comment')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("You must enter or append a comment.")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-white buttons",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n                  Cancel\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-approve buttons",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmitDisabled
    },
    on: {
      "click": _vm.submitRequest
    }
  }, [_vm._v("\n                  Submit\n                ")])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Transaction ID:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Transaction Amount:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Bank account *")])])])])
}]}

/***/ }),
/* 2208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('em', {
    staticClass: "sa-icon sa-success icon-check"
  }), _vm._v(" "), _c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("Great!")]), _vm._v(" "), _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n          " + _vm._s(_vm.message) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_vm._t("body", [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-accept",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("OK")])])])])], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 2209 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n    Accounts\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.accounts && _vm.accounts.length === 0) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n          No accounts found.\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.accounts && _vm.accounts.length > 0) ? _c('div', {
    staticClass: "table-responsive bottom-margin",
    class: {
      'table-fixed-header--sm cols-5': _vm.accounts.length > 3 || _vm.fetchingSummaryReports
    }
  }, [(_vm.fetchingSummaryReports) ? _c('spinner', {
    staticClass: "table-spinner"
  }) : _vm._e(), _vm._v(" "), (!_vm.fetchingSummaryReports) ? _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.accounts), function(account) {
    return _c('tr', {
      key: account.id
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(account.accountName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(account.accountType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatAmount(account.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      class: {
        'radio-item': true, 'radio-item-unselected': account.id !== _vm.defaultAccountId
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": account.id,
        "for": account.id
      },
      domProps: {
        "value": account.id
      },
      on: {
        "click": function($event) {
          _vm.changeDefaultAccount(account)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "lbl-defaultAccount",
      attrs: {
        "for": account.id
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "text-center last-column-data"
    }, [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(account)
        }
      }
    }, [_vm._v("View details")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.generateSummaryReport(account)
        }
      }
    }, [_vm._v("Summary Report")])])])
  }))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 top-margin"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg btn-new",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.openAccountCreationModal()
      }
    }
  }, [_vm._v("Create new")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Account name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Type of account")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Account Balance")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Default Account")]), _vm._v(" "), _c('th', {
    staticClass: "text-center last-column-title"
  }, [_vm._v("Actions")])])])
}]}

/***/ }),
/* 2210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.isAccountCreationModalVisible) ? _c('accountCreation') : _vm._e(), _vm._v(" "), (_vm.isSuggestedAddressModalVisible) ? _c('address-suggestion') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [(_vm.$route.query.retry) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Please verify your information and submit it once more.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            User information\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (!_vm.isLoading) ? _c('userTypeSelection-form', {
    ref: "basicFinancialInformation",
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('multiselect', {
    attrs: {
      "options": _vm.userCommentCategories,
      "showToggleAll": false,
      "placeholder": "Select relevant categories",
      "optionLabel": "name"
    },
    model: {
      value: (_vm.userCommentCategory),
      callback: function($$v) {
        _vm.userCommentCategory = $$v
      },
      expression: "userCommentCategory"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Please append your comment below")]), _vm._v(" "), (_vm.savingComment) ? _c('span', {
    staticClass: "auto-save-notice-label auto-save-notice-saving-color"
  }, [_vm._v("[ Saving... ]")]) : _vm._e(), _vm._v(" "), (_vm.commentSaved) ? _c('span', {
    staticClass: "auto-save-notice-label auto-save-notice-saved-color"
  }, [_vm._v("[ Saved ]")]) : _vm._e(), _vm._v(" "), (_vm.commentSaveError) ? _c('span', {
    staticClass: "auto-save-notice-label auto-save-notice-error-color"
  }, [_vm._v("[ Not Saved ]")]) : _vm._e(), _vm._v(" "), _c('restricted-textarea', {
    staticClass: "restricted-textarea",
    attrs: {
      "limit": 255,
      "input": _vm.userCommentInput,
      "id": "comment",
      "required": false,
      "showNotice": false,
      "showLimit": true,
      "textColorClass": 'vinous-text',
      "placeholder": ""
    },
    on: {
      "inputUpdated": _vm.commentUpdated
    }
  })], 1)]), _vm._v(" "), (!_vm.isLoading) ? _c('basicFinancial-information', {
    ref: "basicFinancialInformation",
    attrs: {
      "basicFinancialInformation": _vm.user
    },
    on: {
      "validated": _vm.basicInformationValidated,
      "emailUpdated": _vm.handleEmailChange
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', {
    staticClass: "dark-grey-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provideInvestorLogin),
      expression: "provideInvestorLogin"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "provide-investor-login",
      "disabled": !_vm.emailIsValid
    },
    domProps: {
      "checked": _vm.shouldBeCheckedByDefault,
      "checked": Array.isArray(_vm.provideInvestorLogin) ? _vm._i(_vm.provideInvestorLogin, "") > -1 : (_vm.provideInvestorLogin)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.provideInvestorLogin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.provideInvestorLogin = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.provideInvestorLogin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.provideInvestorLogin = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n            Provide investor log in\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', {
    staticClass: "dark-grey-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enableMfa),
      expression: "enableMfa"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "enable-mfa",
      "disabled": !_vm.provideInvestorLogin
    },
    domProps: {
      "checked": Array.isArray(_vm.enableMfa) ? _vm._i(_vm.enableMfa, "") > -1 : (_vm.enableMfa)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.enableMfa,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.enableMfa = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.enableMfa = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.enableMfa = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("\n            Enable MFA\n          ")])]), _vm._v(" "), (_vm.user.residentialAddress && _vm.user.mailingAddress) ? _c('addresses-form', {
    key: 1,
    ref: "addresses",
    attrs: {
      "firstTitle": 'Business address',
      "residentialAddress": _vm.user.residentialAddress,
      "secondTitle": 'Mailing address',
      "mailingAddress": _vm.user.mailingAddress,
      "is-admin": true
    },
    on: {
      "validated": _vm.addressesValidated
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin bottom-margin"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitButton()
    },
    on: {
      "click": function($event) {
        _vm.validateAndSubmitUser()
      }
    }
  }, [_vm._v("Submit")])])]), _vm._v(" "), _c('dismissable-alert', {
    attrs: {
      "title": "You've changed the default account",
      "subtitle": "",
      "closeAction": _vm.hideDefaultAccountAlert,
      "isShowing": _vm.showDefaultAccountChanged
    }
  }), _vm._v(" "), (_vm.user !== undefined) ? _c('AccountsList', {
    attrs: {
      "userType": _vm.user.userType,
      "defaultAccountId": _vm.user.defaultAccountId,
      "accounts": _vm.user.accounts
    },
    on: {
      "confirmedChangeDefaultAccount": _vm.changedDefaultAccountId
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      All users\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon-exclamation pr-sm"
  }), _vm._v("There was an issue validating your personal information.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Comment Category")])])])])
}]}

/***/ }),
/* 2211 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper main-container"
  }, [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isSubmitSettingsLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Announcement")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', [_c('vue-editor', {
    attrs: {
      "editorToolbar": _vm.customEditorToolbar
    },
    model: {
      value: (_vm.announcementHTML),
      callback: function($$v) {
        _vm.announcementHTML = $$v
      },
      expression: "announcementHTML"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "ml",
    domProps: {
      "innerHTML": _vm._s(_vm.announcementHTMLWithSafeLinks)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg mt",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.handleSubmitSettings
    }
  }, [_vm._v("Submit")])])])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Settings\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
}]}

/***/ }),
/* 2212 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper background-white",
    attrs: {
      "align": "center"
    }
  }, [(_vm.isSuccessModalVisible) ? _c('success') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-center mt-xl wd-xl"
  }, [_c('div', {
    staticClass: "panel panel-dark panel-flat"
  }, [(_vm.needsMfa) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "text-center pv"
  }, [_vm._v("Multi-factor Authentication")]), _vm._v(" "), _c('p', {
    staticClass: "text-center pv"
  }, [_vm._v("Please enter the code sent to your email.")]), _vm._v(" "), _c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.otherErrors))])]), _vm._v(" "), _c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateMfaAndSubmitLogin()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mfaCode),
      expression: "mfaCode"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mfaCode",
      "type": "text",
      "placeholder": "Enter the code",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.mfaCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mfaCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default btn-lg mt-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.submittedMfa
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('p', {
    staticClass: "pt-lg text-center border-top mt-xl"
  }, [_vm._v("\n          Back to "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.backToLogin
    }
  }, [_vm._v("login")])])]) : _vm._e(), _vm._v(" "), (!_vm.needsMfa) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("Log in to your account below | "), _c('a', {
    staticClass: "text-muted cursor-pointer",
    on: {
      "click": function($event) {
        _vm.handleRedirection()
      }
    }
  }, [_vm._v("First time user?")])]), _vm._v(" "), _c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.otherErrors))])]), _vm._v(" "), (_vm.isUserIdle) ? _c('p', [_c('strong', {
    staticClass: "text-red"
  }, [_vm._v("You have been logged out of your account due to inactivity.")])]) : _vm._e(), _vm._v(" "), (_vm.fromPasswordResetEmail) ? _c('p', [_c('strong', {
    staticClass: "text-success"
  }, [_vm._v("Your password has been reset successfully.")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateAndSubmitLogin()
      }
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.emailError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control shadow",
    attrs: {
      "id": "signupInputEmail1",
      "type": "email",
      "placeholder": "Enter Email",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock2"
    }
  }, [_vm._v(_vm._s(_vm.emailError))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.passwordError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control shadow",
    attrs: {
      "id": "signupInputPassword1",
      "type": "password",
      "placeholder": "Enter Password",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock4"
    }
  }, [_vm._v(_vm._s(_vm.passwordError))])]), _vm._v(" "), _c('div', {
    staticClass: "direction-row"
  }, [_c('div', [_c('a', {
    staticClass: "text-muted cursor-pointer",
    on: {
      "click": function($event) {
        _vm.handleRedirection('reset-password')
      }
    }
  }, [_vm._v("Forgot your password?")])]), _vm._v(" "), _c('div', {
    staticClass: "direction-row"
  }, [_c('a', {
    staticClass: "text-muted no-underline mr-1 cursor-pointer",
    on: {
      "click": function($event) {
        _vm.handleRememberMe()
      }
    }
  }, [_vm._v("\n                Remember Me\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    staticClass: "checkbox-shadow cursor-pointer",
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "rememberMe"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, "") > -1 : (_vm.rememberMe)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-pill btn-default btn-lg mt-lg pull-left mb-0",
    attrs: {
      "type": "submit",
      "disabled": _vm.submittedForm
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.loginError
    }
  }, [_c('strong', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock6"
    }
  }, [_vm._v(_vm._s(_vm.loginError))])])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('em', {
    staticClass: "icon-lock"
  }), _vm._v("\n            Log In\n          ")])
}]}

/***/ }),
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./bg.jpg": 1225,
	"./bg3.jpg": 1226,
	"./icon-calendar-payment.svg": 481,
	"./icon-impact-report.svg": 482,
	"./icon-maintenance.svg": 230,
	"./icon-prospectus.png": 1227,
	"./icon-quarterly-report.svg": 483,
	"./icon-tax-document.svg": 484,
	"./tutorial_1.png": 485,
	"./tutorial_2.png": 486,
	"./user/img-profile-UGMA.svg": 487,
	"./user/img-profile-advisor.svg": 161,
	"./user/img-profile-default-admin.svg": 231,
	"./user/img-profile-default.svg": 123,
	"./user/img-profile-institution.svg": 488,
	"./user/img-profile-joint.svg": 489,
	"./user/img-profile-trust.svg": 490
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2217;

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icon-calendar-payment.svg": 481,
	"./icon-impact-report.svg": 482,
	"./icon-maintenance.svg": 230,
	"./icon-quarterly-report.svg": 483,
	"./icon-tax-document.svg": 484
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2218;

/***/ }),
/* 2219 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2220 */,
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/glyphicons-halflings-regular.8988968.svg";

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Simple-Line-Icons.2fe2efe.svg";

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.f4769f9.eot";

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.fa27723.woff";

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.448c34a.woff2";

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Simple-Line-Icons.f33df36.eot";

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Simple-Line-Icons.d228596.ttf";

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Simple-Line-Icons.78f07e2.woff";

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Simple-Line-Icons.0cb0b9c.woff2";

/***/ })
],[574]);


// WEBPACK FOOTER //
// static/js/app.9900a6ae097bb8cc4c2d.js